export const EN_TRANSLATION = 0;
export const ES_TRANSLATION = 1;
export const DE_TRANSLATION = 2;

export type LangFields = [string, string, string];

export const TRANSLATIONS = {
    Pocket: {
        TabLive: ["Live", "En vivo", "Live"],
        TabJobs: ["Jobs", "Tareas", "Aufträge"],
        TabInbox: ["Inbox", "Bandeja", "Eingang"],
        TabMore: ["More", "Más", "Mehr"],
        SearchPlaceholder: ["Search people, jobs, places", "Busca personas, tareas, lugares", "Suche Personen, Aufträge, Orte"],
        SearchPlaceholderLocation: ["Search people and places", "Busca personas y lugares", "Suche Personen und Orte"],
        Cancel: ["Cancel", "Cancelar", "Abbrechen"],
        Close: ["Close", "Cerrar", "Schließen"],
        Back: ["Back", "Atrás", "Zurück"],
        LiveDot: ["Live", "En vivo", "Live"],
        OutOfTotal: ["{0} of {1} out", "{0} de {1} en la calle", "{0} von {1} unterwegs"],
        JobsDoneOfTotal: ["{0} of {1} jobs done", "{0} de {1} tareas hechas", "{0} von {1} Aufträgen erledigt"],
        NobodyOutYet: ["Nobody is out yet", "Todavía no ha salido nadie", "Noch ist niemand unterwegs"],
        RunningLate: ["{0} running late", "{0} con retraso", "{0} verspätet"],
        UnassignedCount: ["{0} unassigned", "{0} sin asignar", "{0} nicht zugewiesen"],
        NoJobsToday: ["No jobs today", "Hoy no hay tareas", "Heute keine Aufträge"],
        NeedsYou: ["Needs you", "Requiere tu atención", "Braucht dich"],
        Everyone: ["Everyone", "Todos", "Alle"],
        NeedTrackingOff: ["Tracking off", "Seguimiento desactivado", "Tracking aus"],
        NeedLocationOff: ["Location services off", "Ubicación desactivada", "Standortdienste aus"],
        NeedLoggedOut: ["Logged out of the app", "Sesión cerrada en la app", "In der App abgemeldet"],
        NeedNoLocation: ["No location for {0}", "Sin ubicación desde hace {0}", "Seit {0} kein Standort"],
        NeedJobsLeft: ["{0} jobs still open today", "{0} tareas aún abiertas hoy", "Heute noch {0} offene Aufträge"],
        NeedJobsLeftOne: ["1 job still open today", "1 tarea aún abierta hoy", "Heute noch 1 offener Auftrag"],
        NeedUnassigned: ["{0} jobs not assigned", "{0} tareas sin asignar", "{0} Aufträge nicht zugewiesen"],
        NeedUnassignedOne: ["1 job not assigned", "1 tarea sin asignar", "1 Auftrag nicht zugewiesen"],
        Call: ["Call", "Llamar", "Anrufen"],
        Message: ["Message", "Mensaje", "Nachricht"],
        ShowOnMap: ["Map", "Mapa", "Karte"],
        Today: ["Today", "Hoy", "Heute"],
        DoneOfTotal: ["{0} of {1} done", "{0} de {1} hechas", "{0} von {1} erledigt"],
        DoneEarlier: ["{0} done earlier", "{0} hechas antes", "{0} vorher erledigt"],
        Phone: ["Phone", "Teléfono", "Telefon"],
        Battery: ["Battery", "Batería", "Akku"],
        App: ["App", "App", "App"],
        LastSignal: ["Last signal", "Última señal", "Letztes Signal"],
        AgoShort: ["{0} ago", "hace {0}", "vor {0}"],
        JustNow: ["Just now", "Ahora mismo", "Gerade eben"],
        OnSite: ["On site", "En el sitio", "Vor Ort"],
        OnTheWay: ["On the way", "En camino", "Unterwegs"],
        Late: ["Late", "Tarde", "Verspätet"],
        Details: ["Details", "Detalles", "Details"],
        Proof: ["Proof", "Prueba", "Nachweis"],
        History: ["History", "Historial", "Verlauf"],
        Assigned: ["Assigned", "Asignada a", "Zugewiesen"],
        NobodyYet: ["Nobody yet", "Nadie todavía", "Noch niemand"],
        When: ["When", "Cuándo", "Wann"],
        AnyTime: ["Any time", "Cualquier hora", "Jederzeit"],
        OnSiteMinutes: ["{0} min", "{0} min", "{0} Min."],
        Priority: ["Priority", "Prioridad", "Priorität"],
        PriorityLow: ["Low", "Baja", "Niedrig"],
        PriorityNormal: ["Normal", "Normal", "Normal"],
        PriorityHigh: ["High", "Alta", "Hoch"],
        Customer: ["Customer", "Cliente", "Kunde"],
        Contact: ["Contact", "Contacto", "Kontakt"],
        Notes: ["Notes", "Notas", "Notizen"],
        Navigate: ["Navigate", "Cómo llegar", "Navigation"],
        Assign: ["Assign", "Asignar", "Zuweisen"],
        Reassign: ["Reassign", "Reasignar", "Neu zuweisen"],
        Status: ["Status", "Estado", "Status"],
        StopOfTotal: ["Stop {0} of {1}", "Parada {0} de {1}", "Stopp {0} von {1}"],
        NotAssigned: ["Not assigned", "Sin asignar", "Nicht zugewiesen"],
        StatusUnassigned: ["Unassigned", "Sin asignar", "Nicht zugewiesen"],
        StatusScheduled: ["Scheduled", "Programada", "Geplant"],
        StatusStarted: ["Started", "Empezada", "Gestartet"],
        StatusInProgress: ["In progress", "En curso", "In Arbeit"],
        StatusDone: ["Done", "Hecha", "Erledigt"],
        StatusIssue: ["Issue", "Problema", "Problem"],
        StatusRejected: ["Rejected", "Rechazada", "Abgelehnt"],
        CheckedIn: ["Checked in", "Llegada", "Eingecheckt"],
        CheckedOut: ["Checked out", "Salida", "Ausgecheckt"],
        ManualCheck: ["by hand", "a mano", "von Hand"],
        GpsCheck: ["GPS", "GPS", "GPS"],
        Photos: ["Photos", "Fotos", "Fotos"],
        Signature: ["Signature", "Firma", "Unterschrift"],
        Forms: ["Forms", "Formularios", "Formulare"],
        NoProofYet: ["No photos, signature or forms yet.", "Aún no hay fotos, firma ni formularios.", "Noch keine Fotos, Unterschrift oder Formulare."],
        HistCreated: ["Created", "Creada", "Erstellt"],
        HistAssigned: ["Assigned to {0}", "Asignada a {0}", "{0} zugewiesen"],
        HistUnassigned: ["Unassigned", "Sin asignar", "Zuweisung entfernt"],
        NoHistory: ["No history yet.", "Aún no hay historial.", "Noch kein Verlauf."],
        ChangeStatus: ["Change status", "Cambiar estado", "Status ändern"],
        StatusConfirm: ["Mark as {0}?", "¿Marcar como {0}?", "Als „{0}“ markieren?"],
        StatusConfirmHint: ["The change applies right away, also on the customer’s ETA page.", "El cambio se aplica al momento, también en la página ETA del cliente.", "Die Änderung gilt sofort, auch auf der ETA-Seite für den Kunden."],
        Apply: ["Apply", "Aplicar", "Übernehmen"],
        StatusChanged: ["Marked as {0}", "Marcada como {0}", "Als „{0}“ markiert"],
        ReassignTitle: ["Assign to", "Asignar a", "Zuweisen an"],
        Suggested: ["Suggested", "Sugerencias", "Vorschläge"],
        EveryoneElse: ["Everyone else", "Todos los demás", "Alle anderen"],
        DetourMin: ["+{0} min detour", "+{0} min de desvío", "+{0} Min. Umweg"],
        LeaveUnassigned: ["Leave unassigned", "Dejar sin asignar", "Nicht zuweisen"],
        AssignedTo: ["Assigned to {0}", "Asignada a {0}", "{0} zugewiesen"],
        AssignTo: ["Assign to {0}", "Asignar a {0}", "{0} zuweisen"],
        SomethingWentWrong: ["That didn’t work. Check the connection and try again.", "No ha funcionado. Revisa la conexión e inténtalo de nuevo.", "Das hat nicht geklappt. Prüfe die Verbindung und versuch es noch mal."],
        JobsSummary: ["{0} jobs · {1} done", "{0} tareas · {1} hechas", "{0} Aufträge · {1} erledigt"],
        Unassigned: ["Unassigned", "Sin asignar", "Nicht zugewiesen"],
        DoneCount: ["{0} done", "{0} hechas", "{0} erledigt"],
        Messages: ["Messages", "Mensajes", "Nachrichten"],
        NoResults: ["Nothing found for “{0}”", "No se encontró nada para «{0}»", "Nichts gefunden für „{0}“"],
        SearchHintLocation: ["Search a name, an address or a place.", "Busca un nombre, una dirección o un lugar.", "Suche nach einem Namen, einer Adresse oder einem Ort."],
        SearchHint: ["Search a name, a job title, an address or a place.", "Busca un nombre, una tarea, una dirección o un lugar.", "Suche nach einem Namen, Auftrag, einer Adresse oder einem Ort."],
        SectionPeople: ["People", "Personas", "Personen"],
        SectionJobs: ["Jobs", "Tareas", "Aufträge"],
        SectionPlaces: ["Places", "Lugares", "Orte"],
        SectionAddresses: ["Addresses", "Direcciones", "Adressen"],
        OnComputer: ["On the computer", "En la computadora", "Am Computer"],
        OnComputerHint: ["Location history, planning, statistics and settings are in the desktop version for now.", "El historial de ubicaciones, la planificación, las estadísticas y la configuración están por ahora en la versión de escritorio.", "Standortverlauf, Planung, Statistiken und Einstellungen gibt es vorerst in der Desktop-Version."],
        UseDesktopVersion: ["Use the desktop version", "Usar la versión de escritorio", "Desktop-Version nutzen"],
        UseDesktopVersionHint: ["All features, laid out for a big screen. To switch back, open the menu and tap your name.", "Todas las funciones, pensadas para pantallas grandes. Para volver, abre el menú y toca tu nombre.", "Alle Funktionen, gemacht für große Bildschirme. Zurück kommst du über das Menü: Tipp dort auf deinen Namen."],
        Reports: ["Reports", "Informes", "Berichte"],
        ReportsHint: ["Jobs, mileage, timesheets and more", "Tareas, kilometraje, horas y más", "Aufträge, Fahrten, Stundenzettel und mehr"],
        ReportsHintLocation: ["Mileage, timesheets, check-ins and more", "Kilometraje, horas, check-ins y más", "Fahrten, Stundenzettel, Check-ins und mehr"],
        RepRecent: ["Recent files", "Archivos recientes", "Letzte Dateien"],
        RepNoFiles: ["No files yet.", "Aún no hay archivos.", "Noch keine Dateien."],
        RepScheduled: ["On a schedule", "Programados", "Geplant"],
        RepNew: ["New report", "Nuevo informe", "Neuer Bericht"],
        RepComputerOnly: ["On the computer: GPX tracks, time allocation, place and member exports, and choosing columns.", "En la computadora: recorridos GPX, reparto del tiempo, exportar lugares y miembros, y elegir columnas.", "Am Computer: GPX-Tracks, Zeitaufteilung, Orte- und Mitglieder-Export und die Spaltenauswahl."],
        RepWho: ["Who", "Quién", "Wer"],
        RepWhen: ["When", "Cuándo", "Wann"],
        RepFile: ["File", "Archivo", "Datei"],
        RepForm: ["Form", "Formulario", "Formular"],
        RepEveryone: ["Everyone", "Todos", "Alle"],
        RepATeam: ["A team", "Un equipo", "Ein Team"],
        RepAPerson: ["A person", "Una persona", "Eine Person"],
        RepChooseForm: ["Choose a form", "Elige un formulario", "Wähl ein Formular"],
        RepChooseTeam: ["Choose a team", "Elige un equipo", "Wähl ein Team"],
        RepToday: ["Today", "Hoy", "Heute"],
        RepYesterday: ["Yesterday", "Ayer", "Gestern"],
        RepThisWeek: ["This week", "Esta semana", "Diese Woche"],
        RepLastWeek: ["Last week", "La semana pasada", "Letzte Woche"],
        RepThisMonth: ["This month", "Este mes", "Diesen Monat"],
        RepLastMonth: ["Last month", "El mes pasado", "Letzten Monat"],
        RepPickDates: ["Pick dates", "Elegir fechas", "Daten wählen"],
        RepPickDay: ["Pick a day", "Elegir un día", "Tag wählen"],
        RepMaxDays: ["Up to {0} days", "Hasta {0} días", "Bis zu {0} Tage"],
        RepRepeatDaily: ["Every weekday morning, to my Inbox", "Cada mañana de lunes a viernes, en mi bandeja", "Jeden Werktag morgens in meinen Posteingang"],
        RepRepeatWeekly: ["Every Monday, to my Inbox", "Cada lunes, en mi bandeja", "Jeden Montag in meinen Posteingang"],
        RepGetFile: ["Get the file", "Obtener el archivo", "Datei erstellen"],
        RepPreparing: ["Preparing… usually under a minute. You can leave this screen.", "Preparando… suele tardar menos de un minuto. Puedes salir de esta pantalla.", "Wird erstellt … meist in unter einer Minute. Du kannst die Seite verlassen."],
        RepReady: ["{0} is ready", "{0} está listo", "{0} ist fertig"],
        RepFailed: ["That report didn’t work. Try again in a moment.", "Ese informe no ha funcionado. Inténtalo de nuevo en un momento.", "Der Bericht hat nicht geklappt. Versuch es gleich noch mal."],
        RepShare: ["Share", "Compartir", "Teilen"],
        RepScheduledFile: ["Scheduled", "Programado", "Geplant"],
        RepEveryDay: ["Every day", "Cada día", "Jeden Tag"],
        RepEveryWeek: ["Every week", "Cada semana", "Jede Woche"],
        RepEveryTwoWeeks: ["Every 2 weeks", "Cada 2 semanas", "Alle 2 Wochen"],
        RepToYou: ["To you", "Para ti", "An dich"],
        RepToPeople: ["To {0} people", "Para {0} personas", "An {0} Personen"],
        RepToPerson: ["To {0}", "Para {0}", "An {0}"],
        RepPaused: ["Schedule paused", "Programación en pausa", "Zeitplan pausiert"],
        RepResumed: ["Schedule on again", "Programación activada", "Zeitplan wieder aktiv"],
        RepScheduleSaved: ["Saved. The next one comes to your Inbox.", "Guardado. El próximo llega a tu bandeja.", "Gespeichert. Der nächste kommt in deinen Posteingang."],
        CopyLink: ["Copy link for my computer", "Copiar enlace para mi computadora", "Link für meinen Computer kopieren"],
        LinkCopied: ["Link copied", "Enlace copiado", "Link kopiert"],
        AccountOnHold: ["Your account is on hold", "Tu cuenta está en pausa", "Dein Konto ist pausiert"],
        BillingOnComputer: ["Plans, licenses and invoices are in the web dashboard on a computer.", "Los planes, las licencias y las facturas están en el panel web, en la computadora.", "Pläne, Lizenzen und Rechnungen findest du im Web-Dashboard am Computer."],
        CsCheckEmail: ["Check your email", "Revisa tu correo", "Schau in deine E-Mails"],
        CsCodeSentTo: ["We sent a 6-digit code to {0}.", "Te enviamos un código de 6 dígitos a {0}.", "Wir haben dir einen 6-stelligen Code an {0} geschickt."],
        CsCodeLabel: ["Code from the email", "Código del correo", "Code aus der E-Mail"],
        CsOpenGmail: ["Open Gmail", "Abrir Gmail", "Gmail öffnen"],
        CsResendIn: ["New code in {0} s", "Nuevo código en {0} s", "Neuer Code in {0} s"],
        CsResend: ["Send a new code", "Enviar un código nuevo", "Neuen Code senden"],
        CsCodeResent: ["New code sent to {0}", "Nuevo código enviado a {0}", "Neuer Code an {0} geschickt"],
        CsWrongEmail: ["Wrong address? Log out", "¿Correo equivocado? Cierra sesión", "Falsche Adresse? Abmelden"],
        CsWhereTitle: ["Where’s your business?", "¿Dónde está tu negocio?", "Wo ist dein Betrieb?"],
        CsWhereSub: ["Its name or address. It sets your map and time zone.", "Su nombre o dirección. Con eso ajustamos tu mapa y tu zona horaria.", "Name oder Adresse. Danach richten sich Karte und Zeitzone."],
        CsSearchPlaceholder: ["Business name or address", "Nombre del negocio o dirección", "Name des Betriebs oder Adresse"],
        CsHere: ["Use where I am now", "Usar donde estoy ahora", "Meinen aktuellen Standort nehmen"],
        CsHereHint: ["Your phone asks first", "Tu teléfono te pregunta antes", "Dein Handy fragt vorher"],
        CsLocating: ["Finding you…", "Buscando tu ubicación…", "Standort wird gesucht…"],
        CsNothingFound: ["Nothing found. Try the street address.", "No encontramos nada. Prueba con la dirección.", "Nichts gefunden. Versuch es mit der Adresse."],
        CsIsThisIt: ["Is this your business?", "¿Es este tu negocio?", "Ist das dein Betrieb?"],
        CsYesThatsUs: ["Yes, that’s us", "Sí, somos nosotros", "Ja, das sind wir"],
        CsSearchAgain: ["Search again", "Buscar de nuevo", "Neu suchen"],
        CsNameNeeded: ["Give your company a name", "Ponle nombre a tu empresa", "Gib deiner Firma einen Namen"],
        CsTeamTitle: ["About your team", "Sobre tu equipo", "Über dein Team"],
        CsCreate: ["Create {0}", "Crear {0}", "{0} anlegen"],
        CsTrialNote: ["30 days free · no card needed", "30 días gratis · sin tarjeta", "30 Tage kostenlos · ohne Karte"],
        CsCreated: ["{0} is on the map", "{0} ya está en el mapa", "{0} ist auf der Karte"],
        CsCreatedHint: ["Your company, its place and the time zone are set. Next: the people who work in the field.", "Tu empresa, su lugar y la zona horaria están listos. Ahora: las personas que trabajan en campo.", "Firma, Ort und Zeitzone stehen. Jetzt kommen die Leute, die draußen arbeiten."],
        CsInviteCrew: ["Invite your crew", "Invita a tu equipo", "Lade dein Team ein"],
        CsLater: ["I’ll do this later", "Lo haré más tarde", "Mach ich später"],
        InvWho: ["Who works in the field?", "¿Quién trabaja en campo?", "Wer arbeitet draußen?"],
        InvWhoSub: ["Add them here, then send each one the link. You see who has joined.", "Agrégalos aquí y envía a cada uno el enlace. Verás quién se ha unido.", "Füg sie hier hinzu und schick jedem den Link. Du siehst, wer schon dabei ist."],
        InvContacts: ["Pick from your contacts", "Elegir de tus contactos", "Aus deinen Kontakten wählen"],
        InvContactsHint: ["Send each one a link by WhatsApp or a message", "Envía a cada uno un enlace por WhatsApp o mensaje", "Schick jedem einen Link per WhatsApp oder Nachricht"],
        InvByName: ["Add people by name", "Agregar personas por nombre", "Leute mit Namen hinzufügen"],
        InvByNameHint: ["Then send each one the link", "Luego envía a cada uno el enlace", "Dann schickst du jedem den Link"],
        InvGroup: ["One link for a group chat", "Un enlace para un chat de grupo", "Ein Link für einen Gruppenchat"],
        InvGroupHint: ["Everyone who joins shows up by name", "Quien se une aparece con su nombre", "Jeder, der beitritt, erscheint mit Namen"],
        InvQr: ["Show a QR code", "Mostrar un código QR", "QR-Code zeigen"],
        InvQrHint: ["For people standing next to you", "Para quien está a tu lado", "Für Leute direkt neben dir"],
        InvOwn: ["Add my own phone", "Agregar mi propio teléfono", "Mein eigenes Handy hinzufügen"],
        InvOwnHint: ["If you work in the field too", "Si tú también trabajas en campo", "Wenn du selbst auch draußen arbeitest"],
        InvOwnSteps: ["Install the app on this phone and log in with the same account as here.", "Instala la app en este teléfono e inicia sesión con la misma cuenta que aquí.", "Installier die App auf diesem Handy und melde dich mit demselben Konto an wie hier."],
        InvSendTitle: ["Send invites", "Enviar invitaciones", "Einladungen senden"],
        InvSendHint: ["Send opens WhatsApp with the message ready, or your phone’s share menu. You can change the text there.", "Enviar abre WhatsApp con el mensaje listo, o el menú de compartir. Puedes cambiar el texto allí.", "Senden öffnet WhatsApp mit fertiger Nachricht oder das Teilen-Menü. Den Text kannst du dort noch ändern."],
        InvSend: ["Send", "Enviar", "Senden"],
        InvSent: ["Sent", "Enviado", "Gesendet"],
        InvRetry: ["Try again", "Reintentar", "Nochmal"],
        InvRoleWorker: ["Field worker", "Trabajador de campo", "Außendienst"],
        InvRoleDispatcher: ["Dispatcher", "Despacho", "Disposition"],
        InvWhatTheyGet: ["What {0} gets", "Lo que recibe {0}", "Das bekommt {0}"],
        InvPersonalText: ["Hi {0}, it’s {1} from {2}. We use Hellotracks for our jobs and routes. Join our team: {3} (code {4})", "Hola {0}, soy {1} de {2}. Usamos Hellotracks para nuestras tareas y rutas. Únete a nuestro equipo: {3} (código {4})", "Hallo {0}, hier ist {1} von {2}. Wir nutzen Hellotracks für unsere Aufträge und Routen. Komm in unser Team: {3} (Code {4})"],
        InvClaimHint: ["When they join with the code, they pick their own name from your list.", "Al unirse con el código, eligen su nombre de tu lista.", "Wenn sie mit dem Code beitreten, wählen sie ihren Namen aus deiner Liste."],
        InvAddName: ["Name", "Nombre", "Name"],
        InvAddPhone: ["Mobile number (optional)", "Celular (opcional)", "Handynummer (optional)"],
        InvAdd: ["Add", "Agregar", "Hinzufügen"],
        InvAddedNobody: ["Add the people who work in the field, one by one.", "Agrega a las personas que trabajan en campo, una a una.", "Füg die Leute, die draußen arbeiten, einzeln hinzu."],
        InvQrTitle: ["QR code", "Código QR", "QR-Code"],
        InvQrScan: ["Ask them to point their phone’s camera here. It opens the app, or the store if it isn’t installed yet.", "Pídeles que apunten aquí con la cámara del teléfono. Abre la app, o la tienda si aún no la tienen.", "Lass sie die Handykamera hierauf richten. Das öffnet die App oder den Store, falls sie noch fehlt."],
        InvQrAfter: ["They pick their name from your list, or add it, when they join.", "Al unirse, eligen su nombre de tu lista o lo agregan.", "Beim Beitreten wählen sie ihren Namen aus deiner Liste oder tragen ihn ein."],
        InvResend: ["Resend", "Reenviar", "Nochmal senden"],
        InvHelp: ["Help", "Ayuda", "Hilfe"],
        InvSeeOnMap: ["See on map", "Ver en el mapa", "Auf der Karte"],
        InvDone: ["Done", "Listo", "Fertig"],
        HandoffTitle: ["This page needs a bigger screen", "Esta página necesita una pantalla más grande", "Diese Seite braucht einen größeren Bildschirm"],
        HandoffHint: ["Open it on your computer. Everything else works here.", "Ábrela en tu computadora. Todo lo demás funciona aquí.", "Öffne sie am Computer. Alles andere funktioniert hier."],
        DispatchOnlyTitle: ["Jobs and routes come with Dispatch", "Las tareas y las rutas vienen con Dispatch", "Aufträge und Routen gibt es mit Dispatch"],
        DispatchOnlyHint: ["Your plan covers live tracking, places and location history. Dispatch adds jobs, routes, route optimization and live arrival times for your customers. Plans are in the web dashboard on a computer.", "Tu plan incluye el seguimiento en vivo, los lugares y el historial de ubicaciones. Dispatch agrega tareas, rutas, optimización de rutas y horas de llegada en vivo para tus clientes. Los planes están en el panel web, en la computadora.", "Dein Plan umfasst Live-Ortung, Orte und den Standortverlauf. Mit Dispatch kommen Aufträge, Routen, Routenoptimierung und Live-Ankunftszeiten für deine Kunden dazu. Die Pläne findest du im Web-Dashboard am Computer."],
        GoToLive: ["Go to Live", "Ir a En vivo", "Zu Live"],
        HelpCenter: ["Help center", "Centro de ayuda", "Hilfe-Center"],
        SignOut: ["Log out", "Cerrar sesión", "Abmelden"],
        Account: ["Account", "Cuenta", "Konto"],
        Unknown: ["Unknown", "Desconocido", "Unbekannt"],
        People: ["People", "Personas", "Personen"],
        NeedYouCount: ["{0} need you", "{0} requieren atención", "{0} brauchen dich"],
        ScopeAll: ["All · {0}", "Todos · {0}", "Alle · {0}"],
        ScopeNeeds: ["Needs you · {0}", "Atención · {0}", "Braucht dich · {0}"],
        ScopeInvited: ["Invited · {0}", "Invitados · {0}", "Eingeladen · {0}"],
        NothingNeedsYou: ["Nothing needs you. Every phone is set up.", "Nada requiere tu atención. Todos los teléfonos están listos.", "Nichts braucht dich. Alle Handys sind eingerichtet."],
        NobodyInvited: ["No open invites.", "No hay invitaciones pendientes.", "Keine offenen Einladungen."],
        InvitePeople: ["Invite people", "Invitar personas", "Leute einladen"],
        InviteShareTitle: ["Join {0} on Hellotracks", "Únete a {0} en Hellotracks", "Komm zu {0} auf Hellotracks"],
        InviteShareText: [
            "Join {0} on Hellotracks. Install the app, tap “I have an invite code” and enter {1}.",
            "Únete a {0} en Hellotracks. Instala la app, toca «Tengo un código de invitación» e ingresa {1}.",
            "Komm zu {0} auf Hellotracks. Installier die App, tipp auf „Ich habe einen Einladungscode“ und gib {1} ein.",
        ],
        InviteLinkCopied: ["Invite copied. Paste it into WhatsApp, a text or an email.", "Invitación copiada. Pégala en WhatsApp, un SMS o un correo.", "Einladung kopiert. Füg sie in WhatsApp, eine SMS oder eine E-Mail ein."],
        InviteShared: ["Invite shared", "Invitación compartida", "Einladung geteilt"],
        CopyInviteHint: ["Copy this and send it by WhatsApp, text or email.", "Cópialo y envíalo por WhatsApp, SMS o correo.", "Kopier das und schick es per WhatsApp, SMS oder E-Mail."],
        InviteCodeIs: ["Invite code {0}", "Código de invitación {0}", "Einladungscode {0}"],
        SendFixStepsTo: ["Send fix steps to {0}", "Enviar pasos a {0}", "Anleitung an {0} senden"],
        ResendInvites: ["Resend {0} invites", "Reenviar {0} invitaciones", "{0} Einladungen erneut senden"],
        ResendInviteTo: ["Resend the invite to {0}", "Reenviar la invitación a {0}", "Einladung erneut an {0} senden"],
        InvitesResent: ["Invites sent again", "Invitaciones reenviadas", "Einladungen erneut gesendet"],
        Work: ["Work", "Trabajo", "Arbeit"],
        Role: ["Role", "Rol", "Rolle"],
        Teams: ["Teams", "Equipos", "Teams"],
        NoTeam: ["No team", "Sin equipo", "Kein Team"],
        PhoneSetupLink: ["Phone setup and profile", "Configuración del teléfono y perfil", "Handy-Einrichtung und Profil"],
        SetupTitle: ["Get your team on the map", "Pon a tu equipo en el mapa", "Bring dein Team auf die Karte"],
        SetupLead: ["{0} is ready. Most teams are on the map in under five minutes.", "{0} está listo. La mayoría de los equipos aparecen en el mapa en menos de cinco minutos.", "{0} ist startklar. Die meisten Teams sind in unter fünf Minuten auf der Karte."],
        StepInviteTitle: ["Invite your team", "Invita a tu equipo", "Lade dein Team ein"],
        StepInviteHint: ["Send one link by WhatsApp, text or email. They install the app and show up here.", "Envía un enlace por WhatsApp, SMS o correo. Instalan la app y aparecen aquí.", "Schick einen Link per WhatsApp, SMS oder E-Mail. Sie installieren die App und erscheinen hier."],
        ShareInviteLink: ["Share invite link", "Compartir enlace de invitación", "Einladungslink teilen"],
        StepPhoneTitle: ["Track this phone too", "Registra también este teléfono", "Auch dieses Handy tracken"],
        StepPhoneHint: ["If you work in the field yourself, install the app on this phone and log in with the same code.", "Si tú también trabajas en la calle, instala la app en este teléfono e inicia sesión con el mismo código.", "Wenn du selbst draußen arbeitest, installier die App auf diesem Handy und melde dich mit demselben Code an."],
        GetTheApp: ["Get the app", "Descargar la app", "App holen"],
        WhoIsJoining: ["Who’s joining", "Quién se está uniendo", "Wer dazukommt"],
        JoinInvited: ["Invite sent {0}", "Invitación enviada {0}", "Einladung gesendet {0}"],
        JoinSignedIn: ["Logged in · waiting for a first location", "Sesión iniciada · esperando la primera ubicación", "Angemeldet · wartet auf den ersten Standort"],
        JoinOnMap: ["On the map", "En el mapa", "Auf der Karte"],
        NobodyJoinedYet: ["Nobody yet. Share the link and people appear here as they join.", "Nadie todavía. Comparte el enlace y la gente aparecerá aquí al unirse.", "Noch niemand. Teil den Link, dann erscheinen die Leute hier, sobald sie beitreten."],
        ContinueToMap: ["Continue to the map", "Ir al mapa", "Weiter zur Karte"],
        OnTheMapToast: ["{0} is on the map", "{0} está en el mapa", "{0} ist auf der Karte"],
        InviteYourTeam: ["Invite your team", "Invita a tu equipo", "Lade dein Team ein"],
        InviteRowHint: ["Nobody has joined yet", "Todavía no se ha unido nadie", "Noch ist niemand beigetreten"],
        ByPerson: ["By person", "Por persona", "Nach Person"],
        AllJobs: ["All jobs", "Todas", "Alle Aufträge"],
        FilterAll: ["All", "Todas", "Alle"],
        FilterOpen: ["Open", "Abiertas", "Offen"],
        FilterLate: ["Late", "Con retraso", "Verspätet"],
        FilterDone: ["Done", "Hechas", "Erledigt"],
        Select: ["Select", "Seleccionar", "Auswählen"],
        SelectJobs: ["Select jobs", "Seleccionar tareas", "Aufträge auswählen"],
        SelectedCount: ["{0} selected", "{0} seleccionadas", "{0} ausgewählt"],
        MoveTo: ["Move to…", "Mover a…", "Verschieben…"],
        MoveJobs: ["Move {0} jobs", "Mover {0} tareas", "{0} Aufträge verschieben"],
        MoveOneJob: ["Move 1 job", "Mover 1 tarea", "1 Auftrag verschieben"],
        MoveJobsTo: ["Move {0} to {1}", "Mover {0} a {1}", "{0} zu {1} verschieben"],
        KeepPerson: ["Keep the person", "Mantener la persona", "Person behalten"],
        KeepDay: ["Same day", "Mismo día", "Gleicher Tag"],
        Tomorrow: ["Tomorrow", "Mañana", "Morgen"],
        PickDate: ["Pick a date", "Elegir fecha", "Datum wählen"],
        Unassign: ["Unassign", "Quitar asignación", "Zuweisung entfernen"],
        NearFirstJob: ["Near the first job", "Cerca de la primera tarea", "In der Nähe des ersten Auftrags"],
        MovedJobs: ["Moved {0} jobs", "{0} tareas movidas", "{0} Aufträge verschoben"],
        MovedOneJob: ["Moved 1 job", "1 tarea movida", "1 Auftrag verschoben"],
        MovedBack: ["Moved back", "Devueltas", "Zurückverschoben"],
        Undo: ["Undo", "Deshacer", "Rückgängig"],
        RouteOf: ["{0}’s route", "Ruta de {0}", "Route von {0}"],
        SaveOrder: ["Save order", "Guardar orden", "Reihenfolge speichern"],
        OrderSaved: ["Order saved", "Orden guardado", "Reihenfolge gespeichert"],
        RouteFailed: ["The route couldn’t be optimized", "No se pudo optimizar la ruta", "Die Route konnte nicht optimiert werden"],
        MoveUp: ["Move up", "Subir", "Nach oben"],
        MoveDown: ["Move down", "Bajar", "Nach unten"],
        OrderHint: ["Done stops stay where they are. The person gets the new order on their phone.", "Las paradas hechas se quedan donde están. La persona recibe el nuevo orden en su teléfono.", "Erledigte Stopps bleiben, wo sie sind. Die Person bekommt die neue Reihenfolge aufs Handy."],
        EditOrder: ["Edit order", "Editar orden", "Reihenfolge ändern"],
        NoArchivedJobs: ["No archived jobs on this day", "No hay tareas archivadas este día", "An diesem Tag gibt es keine archivierten Aufträge"],
        NoJobsOnDay: ["No jobs on this day", "No hay tareas este día", "An diesem Tag gibt es keine Aufträge"],
        NStops: ["{0} stops", "{0} paradas", "{0} Stopps"],
        OneStop: ["1 stop", "1 parada", "1 Stopp"],
        StopsLeft: ["{0} stops left", "Quedan {0} paradas", "Noch {0} Stopps"],
        OneStopLeft: ["1 stop left", "Queda 1 parada", "Noch 1 Stopp"],
        DoneBy: ["Done by {0}", "Termina hacia las {0}", "Fertig gegen {0}"],
        DrivingTime: ["{0} driving", "{0} de manejo", "{0} Fahrzeit"],
        AllStopsDone: ["All stops done", "Todas las paradas hechas", "Alle Stopps erledigt"],
        WorkingOutRoute: ["Working out the route…", "Calculando la ruta…", "Route wird berechnet …"],
        StopOfRoute: ["Stop {0} of {1} on {2}’s route", "Parada {0} de {1} en la ruta de {2}", "Stopp {0} von {1} auf der Route von {2}"],
        Create: ["Create", "Crear", "Erstellen"],
        CreateJobHint: ["Where, what, who and when", "Dónde, qué, quién y cuándo", "Wo, was, wer und wann"],
        Route: ["Route", "Ruta", "Route"],
        CreateRouteHint: ["Several stops for one person", "Varias paradas para una persona", "Mehrere Stopps für eine Person"],
        Place: ["Place", "Lugar", "Ort"],
        CreatePlaceHint: ["Save a spot you visit often", "Guarda un sitio que visitan a menudo", "Speichere einen Ort, den ihr oft besucht"],
        ComputerOnlyCreate: ["Zones, teams and imports are in the desktop version.", "Las zonas, los equipos y las importaciones están en la versión de escritorio.", "Zonen, Teams und Importe gibt es in der Desktop-Version."],
        NewJob: ["New job", "Nueva tarea", "Neuer Auftrag"],
        NewRoute: ["New route", "Nueva ruta", "Neue Route"],
        NewPlace: ["New place", "Nuevo lugar", "Neuer Ort"],
        Where: ["Where", "Dónde", "Wo"],
        What: ["What", "Qué", "Was"],
        Who: ["Who", "Quién", "Wer"],
        WhereSearch: ["Address or place", "Dirección o lugar", "Adresse oder Ort"],
        WhereIAmNow: ["Where I am now", "Donde estoy ahora", "Wo ich gerade bin"],
        WhereIAmNowHint: ["Uses this phone’s location", "Usa la ubicación de este teléfono", "Nutzt den Standort dieses Handys"],
        LocationRefused: ["This phone didn’t share its location. Allow it in the browser settings, or type the address.", "Este teléfono no compartió su ubicación. Permítelo en la configuración del navegador o escribe la dirección.", "Dieses Handy hat seinen Standort nicht geteilt. Erlaub es in den Browser-Einstellungen oder gib die Adresse ein."],
        Change: ["Change", "Cambiar", "Ändern"],
        EarlierJobsHere: ["{0} earlier jobs here", "{0} tareas anteriores aquí", "{0} frühere Aufträge hier"],
        EarlierJobHere: ["1 earlier job here", "1 tarea anterior aquí", "1 früherer Auftrag hier"],
        TitlePlaceholder: ["Title, e.g. Boiler service", "Título, p. ej. Revisión de caldera", "Titel, z. B. Heizungswartung"],
        UsualHere: ["Usual here", "Lo habitual aquí", "Üblich hier"],
        UsualVisit: ["Usual visit here: {0} min", "Visita habitual aquí: {0} min", "Übliche Dauer hier: {0} Min."],
        OnSiteFor: ["On site", "En el sitio", "Vor Ort"],
        TimeWindow: ["Time window", "Ventana horaria", "Zeitfenster"],
        From: ["From", "Desde", "Von"],
        Until: ["Until", "Hasta", "Bis"],
        ArrivesAbout: ["+{0} min · arrives about {1}", "+{0} min · llega cerca de las {1}", "+{0} Min. · kommt gegen {1}"],
        CreateJob: ["Create job", "Crear tarea", "Auftrag erstellen"],
        JobCreated: ["Job created", "Tarea creada", "Auftrag erstellt"],
        Open: ["Open", "Abrir", "Öffnen"],
        PickPerson: ["Pick a person", "Elige una persona", "Wähl eine Person"],
        Stops: ["Stops", "Paradas", "Stopps"],
        AddStop: ["Add a stop", "Agregar parada", "Stopp hinzufügen"],
        StopTitle: ["Stop {0}", "Parada {0}", "Stopp {0}"],
        Remove: ["Remove", "Quitar", "Entfernen"],
        RoutePlan: ["{0} driving · finishes about {1}", "{0} manejando · termina cerca de las {1}", "{0} Fahrt · fertig gegen {1}"],
        OptimizeOrder: ["Optimize order", "Optimizar orden", "Reihenfolge optimieren"],
        CreateNJobs: ["Create {0} jobs", "Crear {0} tareas", "{0} Aufträge erstellen"],
        CreateOneJob: ["Create 1 job", "Crear 1 tarea", "1 Auftrag erstellen"],
        RouteCreated: ["{0} jobs added to {1}’s route", "{0} tareas agregadas a la ruta de {1}", "{0} Aufträge zur Route von {1} hinzugefügt"],
        PlaceName: ["Name", "Nombre", "Name"],
        Radius: ["Radius", "Radio", "Radius"],
        RadiusHint: ["Arrivals inside this circle count as a visit.", "Las llegadas dentro de este círculo cuentan como visita.", "Ankünfte in diesem Kreis zählen als Besuch."],
        CreatePlace: ["Create place", "Crear lugar", "Ort erstellen"],
        PlaceCreated: ["Place created", "Lugar creado", "Ort erstellt"],
        ShareEta: ["Share ETA", "Compartir ETA", "ETA teilen"],
        EtaShareTitle: ["Live arrival time", "Hora de llegada en vivo", "Live-Ankunftszeit"],
        EtaShareText: ["Follow your technician’s arrival live:", "Sigue en vivo la llegada de tu técnico:", "Verfolge live, wann dein Techniker ankommt:"],
        EtaShared: ["ETA link shared", "Enlace ETA compartido", "ETA-Link geteilt"],
        EtaCopied: ["ETA link copied", "Enlace ETA copiado", "ETA-Link kopiert"],
        EtaReady: ["The live ETA page is ready", "La página ETA en vivo está lista", "Die Live-ETA-Seite ist bereit"],
        CopyLinkHint: ["Copy this link and send it.", "Copia este enlace y envíalo.", "Kopier diesen Link und schick ihn weiter."],
        NoOpenJob: ["No open job to share", "No hay ninguna tarea abierta", "Kein offener Auftrag zum Teilen"],
        RemoveFromRouteConfirm: ["Remove this job from its recurring route?", "¿Quitar esta tarea de su ruta recurrente?", "Diesen Auftrag aus seiner wiederkehrenden Route entfernen?"],
        RemovedFromRoute: ["Removed from the route", "Quitada de la ruta", "Aus der Route entfernt"],
        Address: ["Address", "Dirección", "Adresse"],
        AddNotes: ["Add notes for the job", "Agregar notas para la tarea", "Notizen zum Auftrag hinzufügen"],
        FindingBestFit: ["Finding who fits best…", "Buscando quién encaja mejor…", "Suche, wer am besten passt …"],
        FitFirstJob: ["Best for the first job", "Mejor para la primera tarea", "Am besten für den ersten Auftrag"],
        LacksSkill: ["{0} lacks a required skill: {1}", "A {0} le falta una habilidad requerida: {1}", "{0} fehlt ein benötigter Skill: {1}"],
    },
    Search: {
        Placeholder: ['Find on map', 'Encontrar en el mapa', 'Auf der Karte finden'],
        PlaceholderLong: [
            'Search members, jobs, places, zones…',
            'Busca miembros, tareas, lugares, zonas…',
            'Suche Mitglieder, Aufträge, Orte, Zonen…',
        ],
        PlaceholderLongLocation: [
            'Search members, places, zones…',
            'Busca miembros, lugares, zonas…',
            'Suche Mitglieder, Orte, Zonen…',
        ],
        SectionMembers: ['Members', 'Miembros', 'Mitglieder'],
        SectionJobs: ['Jobs', 'Tareas', 'Aufträge'],
        SectionPlaces: ['Places', 'Lugares', 'Orte'],
        SectionZones: ['Zones', 'Zonas', 'Zonen'],
        SectionTeams: ['Teams', 'Equipos', 'Teams'],
        SectionAddresses: ['Addresses', 'Direcciones', 'Adressen'],
        Recent: ['Recent', 'Recientes', 'Zuletzt verwendet'],
        Suggestions: ['Try searching for', 'Prueba a buscar', 'Suche zum Beispiel nach'],
        NoResults: ['No results for "{0}"', 'Sin resultados para "{0}"', 'Keine Ergebnisse für "{0}"'],
        NoResultsHint: [
            'Try fewer characters, or search a phone number, address or order number.',
            'Prueba con menos caracteres, o busca un teléfono, dirección o número de orden.',
            'Versuche es mit weniger Zeichen oder suche nach Telefonnummer, Adresse oder Auftragsnummer.',
        ],
        JobsOtherDates: ['Jobs on other dates', 'Tareas en otras fechas', 'Aufträge an anderen Tagen'],
        AllKinds: ['All', 'Todo', 'Alle'],
        ShowMore: ['Show {0} more', 'Mostrar {0} más', '{0} weitere anzeigen'],
        HighlightedOnMap: [
            "{0} highlighted on the map",
            "{0} resaltados en el mapa",
            "{0} auf der Karte hervorgehoben",
        ],
        ClearHighlight: ["Clear", "Quitar", "Aufheben"],
        ShowAllOnMap: ['Show all {0} on map', 'Mostrar los {0} en el mapa', 'Alle {0} auf der Karte zeigen'],
        Coordinates: ['Coordinates', 'Coordenadas', 'Koordinaten'],
        Matched: ['matched {0}', 'coincide en {0}', 'Treffer in {0}'],
        ResultCount: ['{0} results', '{0} resultados', '{0} Ergebnisse'],

        ActionShowOnMap: ['Show on map', 'Mostrar en el mapa', 'Auf der Karte zeigen'],
        ActionZoomTo: ['Zoom to', 'Acercar', 'Heranzoomen'],
        ActionSelectOnMap: ['Select on map', 'Seleccionar en el mapa', 'Auf der Karte auswählen'],
        ActionAddToBoard: ['Add to board', 'Agregar al tablero', 'Zum Board hinzufügen'],
        ActionCreatePlaceHere: ['Create place here', 'Crear lugar aquí', 'Ort hier erstellen'],
        ActionCreateJobHere: ['Create job here', 'Crear tarea aquí', 'Auftrag hier erstellen'],
        ActionCopyId: ['Copy ID', 'Copiar ID', 'ID kopieren'],
        ActionCopyOrderId: ['Copy order number', 'Copiar número de orden', 'Auftragsnummer kopieren'],
        ActionCopyAddress: ['Copy address', 'Copiar dirección', 'Adresse kopieren'],
        ActionCopyCoordinates: ['Copy coordinates', 'Copiar coordenadas', 'Koordinaten kopieren'],
        ActionOpenTeam: ['Open teams', 'Abrir equipos', 'Teams öffnen'],
        Copied: ['Copied to clipboard', 'Copiado al portapapeles', 'In die Zwischenablage kopiert'],

        HintNavigate: ['navigate', 'navegar', 'navigieren'],
        HintSelect: ['open', 'abrir', 'öffnen'],
        HintActions: ['actions', 'acciones', 'Aktionen'],
        HintFilter: ['filter', 'filtrar', 'filtern'],

        FieldUsername: ['username', 'nombre de usuario', 'Nutzername'],
        FieldAddress: ['address', 'dirección', 'Adresse'],
        FieldCity: ['city', 'ciudad', 'Stadt'],
        FieldPhone: ['phone', 'teléfono', 'Telefon'],
        FieldEmail: ['email', 'correo', 'E-Mail'],
        FieldNotes: ['notes', 'notas', 'Notizen'],
        FieldOrderId: ['order number', 'número de orden', 'Auftragsnummer'],
        FieldIdentifier: ['ID', 'ID', 'ID'],
        FieldContact: ['contact', 'contacto', 'Kontakt'],
        FieldAssignee: ['assignee', 'asignado', 'zugewiesen an'],
        FieldCustomField: ['custom field', 'campo personalizado', 'zusätzliches Feld'],
        FieldSkills: ['skills', 'habilidades', 'Skills'],
        FieldStatus: ['status', 'estado', 'Status'],
        FieldTeam: ['team', 'equipo', 'Team'],
    },
    Map: {
        Members: ['Members', 'Miembros', 'Mitglieder'],
        Tracks: ['Trips', 'Viajes', 'Fahrten'],
        Clean: ['Clean', 'Limpio', 'Reduziert'],
        Darkmap: ['Dark map', 'Oscuro', 'Dunkel'],
        Filter: ['Filter', 'Filtrar', 'Filter'],
        Heatmap: ['Heat map', 'Mapa de calor', 'Heatmap'],
        History: ['History', 'Historial', 'Verlauf'],
        IconSize: ['Icon size', 'Tamaño del marcador', 'Größe'],
        Layers: ['Layers', 'Capas', 'Ebenen'],
        Live: ['Live', 'En vivo', 'Live'],
        LiveMap: ['Live', 'En vivo', 'Live'],
        Logout: ['Log out', 'Cerrar sesión', 'Abmelden'],
        Places: ['Places', 'Lugares', 'Orte'],
        Roadmap: ['Road map', 'Mapa vial', 'Straßenkarte'],
        Satellite: ['Satellite', 'Satélite', 'Satellit'],
        Traffic: ['Traffic', 'Tráfico', 'Verkehr'],
        Zones: ['Zones', 'Zonas', 'Zonen'],
        Jobs: ['Jobs', 'Tareas', 'Aufträge'],
        DayRoutes: ["Routes", "Rutas", "Routen"],
        RulerTool: ["Measure distance (M)", "Medir distancia (M)", "Entfernung messen (M)"],
        RulerHintStart: [
            "Click the map to start measuring",
            "Haz clic en el mapa para empezar a medir",
            "Klick auf die Karte, um mit dem Messen anzufangen",
        ],
        RulerHintNext: [
            "Click to add points · double-click to finish",
            "Haz clic para agregar puntos · doble clic para terminar",
            "Klick für weitere Punkte · Doppelklick zum Beenden",
        ],
        RulerTotal: ["{0} total", "{0} en total", "{0} gesamt"],
        RulerClear: ["Clear", "Borrar", "Löschen"],
        RulerByRoad: ["By road", "Por carretera", "Fahrstrecke"],
        RulerStraight: ["{0} straight", "{0} en línea recta", "{0} Luftlinie"],
        RulerRoadResult: ["{0} by road · {1}", "{0} por carretera · {1}", "{0} Fahrstrecke · {1}"],
        RulerNoRoad: ["No road route found", "No hay ruta por carretera", "Keine Route über Straßen gefunden"],
        RulerRoadTooMany: [
            "By road works with up to 25 points",
            "Por carretera funciona con hasta 25 puntos",
            "Fahrstrecke geht mit bis zu 25 Punkten",
        ],
        PointTool: ["Point tool", "Herramienta de punto", "Punktwerkzeug"],
        PointToolDesc: [
            "Click the map to create a place or job, or to see the address.",
            "Haz clic en el mapa para crear un lugar o una tarea, o para ver la dirección.",
            "Klicke auf die Karte, um einen Ort oder Auftrag zu erstellen oder eine Adresse anzusehen.",
        ],
        SelectTool: [
            "Select tool",
            "Herramienta de selección",
            "Auswahlwerkzeug",
        ],
        SelectToolDesc: [
            "Click and drag to select jobs.",
            "Haz clic y arrastra para seleccionar tareas.",
            "Klicke und ziehe, um Aufträge auszuwählen.",
        ],
        Waypoints: [
            "Waypoints",
            "Puntos de ruta",
            "Wegpunkte",
        ],
        TranslucentVsSolidBackground: [
            "Translucent or solid background",
            "Fondo translúcido o sólido",
            "Durchscheinender oder deckender Hintergrund",
        ],
        PanelTitle: ["Map", "Mapa", "Karte"],
        GroupMapStyle: ["Map style", "Estilo del mapa", "Kartenstil"],
        GroupPeople: ["People", "Personas", "Personen"],
        GroupWork: ["Work", "Trabajo", "Arbeit"],
        GroupHistory: ["History", "Historial", "Verlauf"],
        GroupContext: ["Surroundings", "Entorno", "Umgebung"],
        AllPeople: ["Everyone", "Todo el equipo", "Alle"],
        StatusLabels: ["Status labels", "Etiquetas de estado", "Statusanzeigen"],
        LastHours: ["Last 4 hours", "Últimas 4 horas", "Letzte 4 Stunden"],
        PlannedRoutes: ["Planned routes", "Rutas planificadas", "Geplante Routen"],
        CleanMap: ["Clean map", "Mapa limpio", "Reduzierte Karte"],
        CleanMapDesc: [
            "Calmer base map with fewer street names and icons",
            "Mapa base más tranquilo, con menos nombres de calles e iconos",
            "Ruhigere Grundkarte mit weniger Straßennamen und Symbolen",
        ],
        Display: ["Display", "Visualización", "Darstellung"],
        OnlyOn: ["Only on {0}", "Solo en {0}", "Nur in {0}"],
        NotOnThisPage: ["Not on this page", "No en esta página", "Nicht auf dieser Seite"],
        NeedsDispatchPlan: ["Needs a plan with Dispatch", "Requiere un plan con Dispatch", "Braucht einen Tarif mit Dispatch"],
        SelectPersonFirst: ["Select a person first", "Selecciona primero a una persona", "Wähl zuerst eine Person aus"],
        ShowingSelected: ["Showing who you selected", "Muestra a quien seleccionaste", "Zeigt, wen du ausgewählt hast"],
        SavedForPage: ["Saved for {0}", "Guardado para {0}", "Gespeichert für {0}"],
        SavedForOtherPages: ["Saved for the other pages", "Guardado para las demás páginas", "Gespeichert für die übrigen Seiten"],
        AlwaysOnHere: ["Always shown on this page", "Siempre visible en esta página", "Auf dieser Seite immer sichtbar"],
        ResetLayers: ["Reset layers", "Restablecer capas", "Ebenen zurücksetzen"],
        NotShown: ["{0} not shown", "{0} sin mostrar", "{0} nicht angezeigt"],
        Legend: ["Legend", "Leyenda", "Legende"],
        GpsPointsExplained: [
            "Green = standing · white → magenta = slow → fast",
            "Verde = parado · blanco → magenta = lento → rápido",
            "Grün = steht · weiß → magenta = langsam → schnell",
        ],
        LegendPerson: ["Person", "Persona", "Person"],
        LegendLess: ["Less", "Menos", "Weniger"],
        LegendMore: ["More", "Más", "Mehr"],
        PlayDay: ["Play the day", "Reproducir el día", "Tag abspielen"],
        StopPlayback: ["Stop", "Detener", "Stoppen"],
        PlaybackSpeed: ["Speed", "Velocidad", "Tempo"],
        DockAllSettings: ["All settings", "Toda la configuración", "Alle Einstellungen"],
        DockCollapse: ["Make smaller", "Reducir", "Verkleinern"],
        DockExpand: ["Show layers", "Mostrar capas", "Ebenen zeigen"],
        DockBack: ["Back", "Volver", "Zurück"],
        CardDetails: ["Details", "Detalles", "Details"],
        CardStatus: ["Now", "Ahora", "Jetzt"],
        CardPhone: ["Phone", "Teléfono", "Handy"],
        CardJobsToday: ["Jobs today", "Tareas de hoy", "Aufträge heute"],
        CardDoneOf: ["{0} of {1} done", "{0} de {1} listas", "{0} von {1} erledigt"],
        CardNextJob: ["Next job", "Próxima tarea", "Nächster Auftrag"],
        CardTrip: ["Trip", "Viaje", "Fahrt"],
        CardTime: ["Time", "Hora", "Zeit"],
        CardTopSpeed: ["Top speed", "Velocidad máxima", "Höchstgeschwindigkeit"],
        CardStayed: ["Stayed", "Estuvo", "Aufenthalt"],
        CardJobsLeft: ["Jobs left", "Tareas pendientes", "Offene Aufträge"],
        CardOfTotal: ["{0} of {1}", "{0} de {1}", "{0} von {1}"],
        CardPlannedStart: ["Planned start", "Inicio previsto", "Geplanter Start"],
        CardPlannedFinish: ["Planned finish", "Fin previsto", "Geplantes Ende"],
        CardDriving: ["Driving", "Manejo", "Fahrzeit"],
        CardHereNow: ["Here now", "Aquí ahora", "Gerade hier"],
        CardNobodyHere: ["Nobody right now", "Nadie ahora mismo", "Gerade niemand"],
        CardMore: ["+{0} more", "+{0} más", "+{0} weitere"],
        CardZone: ["Zone", "Zona", "Zone"],
        DefaultMaps: ["Standard", "Estándar", "Standard"],
        CardJobsHere: ["{0} jobs here", "{0} tareas aquí", "{0} Aufträge hier"],
        CardSpreadHint: ["Click the pin to see each one", "Haz clic en el pin para verlas por separado", "Klick auf den Pin, um sie einzeln zu sehen"],
    },
    Eta: {
        EtaPage: ["ETA page", "Página ETA", "ETA-Seite"],
        PageNotFound: ["ETA page not found.", "Página ETA no encontrada.", "ETA-Seite nicht gefunden."],
        LoadingArrivalDetails: ["Loading your arrival details...", "Cargando los detalles de llegada...", "Ankunftsdetails werden geladen..."],
        EstimatedArrival: ["Estimated arrival", "Llegada estimada", "Geschätzte Ankunft"],
        ArrivalStatus: ["Arrival status", "Estado de llegada", "Ankunftsstatus"],
        ArrivalTimePending: ["Arrival time pending", "Hora de llegada pendiente", "Ankunftszeit ausstehend"],
        StatusScheduled: ["Scheduled", "Programado", "Geplant"],
        StatusAssigned: ["Assigned", "Asignado", "Zugewiesen"],
        StatusEnRoute: ["On the way", "En camino", "Unterwegs"],
        StatusApproaching: ["Approaching", "Acercándose", "Nähert sich"],
        StatusArrived: ["Arrived", "Llegó", "Angekommen"],
        StatusCompleted: ["Completed", "Completado", "Abgeschlossen"],
        StatusCancelled: ["Canceled", "Cancelado", "Storniert"],
        StatusExpired: ["Expired", "Expirado", "Abgelaufen"],
        StatusRevoked: ["Revoked", "Revocado", "Widerrufen"],
        StatusUnavailable: ["Unavailable", "No disponible", "Nicht verfügbar"],
        DetailScheduled: [
            "Your appointment with {0} is confirmed.",
            "Su cita con {0} está confirmada.",
            "Ihr Termin mit {0} ist bestätigt.",
        ],
        DetailAssigned: [
            "You're all set - someone from {0} is assigned to your visit.",
            "Todo listo: alguien de {0} está asignado a su visita.",
            "Alles bereit: Jemand von {0} ist Ihrem Besuch zugewiesen.",
        ],
        DetailEnRoute: [
            "Someone from {0} is on the way to you.",
            "Alguien de {0} está en camino.",
            "Jemand von {0} ist auf dem Weg zu Ihnen.",
        ],
        DetailApproaching: [
            "Almost there - they're nearby.",
            "Ya casi llega: está cerca.",
            "Fast da: Die Person ist in der Nähe.",
        ],
        DetailArrived: [
            "Someone from {0} has arrived.",
            "Alguien de {0} ha llegado.",
            "Jemand von {0} ist angekommen.",
        ],
        DetailCompleted: [
            "All done - your visit is complete.",
            "Todo listo: su visita está completa.",
            "Alles erledigt: Ihr Besuch ist abgeschlossen.",
        ],
        DetailCancelled: [
            "This appointment is no longer active.",
            "Esta cita ya no está activa.",
            "Dieser Termin ist nicht mehr aktiv.",
        ],
        DetailExpired: [
            "This tracking page has expired.",
            "Esta página de seguimiento ha expirado.",
            "Diese Tracking-Seite ist abgelaufen.",
        ],
        DetailRevoked: [
            "This tracking page is no longer available.",
            "Esta página de seguimiento ya no está disponible.",
            "Diese Tracking-Seite ist nicht mehr verfügbar.",
        ],
        DetailUnavailable: [
            "Arrival details are currently unavailable.",
            "Los detalles de llegada no están disponibles ahora.",
            "Ankunftsdetails sind derzeit nicht verfügbar.",
        ],
        ConfidenceLive: [
            "Updating live from their current location",
            "Actualizando en vivo desde su ubicación actual",
            "Live-Aktualisierung vom aktuellen Standort",
        ],
        ConfidenceTripActive: [
            "Updating as they head your way",
            "Actualizando mientras va hacia usted",
            "Aktualisiert sich auf dem Weg zu Ihnen",
        ],
        ConfidenceStaleLocation: [
            "Based on their last known location - may change",
            "Basado en su última ubicación conocida; puede cambiar",
            "Basierend auf dem letzten bekannten Standort; kann sich ändern",
        ],
        ConfidenceArrived: ["Arrival confirmed", "Llegada confirmada", "Ankunft bestätigt"],
        ConfidenceCompleted: ["Your visit is complete", "Su visita está completa", "Ihr Besuch ist abgeschlossen"],
        ConfidenceCancelled: ["Your appointment was canceled", "Su cita fue cancelada", "Ihr Termin wurde storniert"],
        ConfidenceScheduled: [
            "Based on your scheduled appointment time",
            "Basado en la hora programada de su cita",
            "Basierend auf Ihrem geplanten Termin",
        ],
        ConfidencePendingSchedule: [
            "No arrival window has been shared yet",
            "Aún no se ha compartido una ventana de llegada",
            "Es wurde noch kein Ankunftszeitfenster geteilt",
        ],
        Service: ["Service", "Servicio", "Service"],
        ServiceVisit: ["Service visit", "Visita de servicio", "Servicetermin"],
        Appointment: ["Appointment", "Cita", "Termin"],
        Readiness: ["Readiness", "Preparación", "Bereitschaft"],
        WhoIsComing: ["Who's coming", "Quién viene", "Wer kommt"],
        ToBeAssigned: ["To be assigned", "Por asignar", "Noch nicht zugewiesen"],
        AssignedWorkerPrivate: ["Assigned", "Asignado", "Zugewiesen"],
        AssignedToYourVisit: ["Assigned to your visit", "Asignado a su visita", "Ihrem Besuch zugewiesen"],
        FollowUpRequested: ["Follow-up requested", "Seguimiento solicitado", "Rückmeldung angefordert"],
        ReadyConfirmed: ["Ready confirmed", "Preparación confirmada", "Bereitschaft bestätigt"],
        InstructionsAdded: ["Instructions added", "Instrucciones agregadas", "Anweisungen hinzugefügt"],
        Waiting: ["Waiting", "En espera", "Wartet"],
        ConfirmedAt: ["Confirmed {0}", "Confirmado {0}", "Bestätigt {0}"],
        RequestedAt: ["Requested {0}", "Solicitado {0}", "Angefordert {0}"],
        AccessInstructionsAvailableToDispatch: [
            "Access instructions are available to dispatch",
            "Las instrucciones de acceso están disponibles para despacho",
            "Zugangshinweise sind für die Disposition verfügbar",
        ],
        ConfirmReadinessOrAddInstructionsBelow: [
            "Confirm readiness or add instructions below",
            "Confirme la preparación o agregue instrucciones abajo",
            "Bereitschaft bestätigen oder unten Hinweise hinzufügen",
        ],
        ReadyForArrival: ["Ready for arrival?", "¿Listo para la llegada?", "Bereit für die Ankunft?"],
        ReadyForArrivalDetail: [
            "Let the team know the site or recipient is ready.",
            "Informe al equipo que el sitio o destinatario está listo.",
            "Teilen Sie dem Team mit, dass der Einsatzort oder Empfänger bereit ist.",
        ],
        ReadinessConfirmedMessage: ["Readiness confirmed.", "Preparación confirmada.", "Bereitschaft bestätigt."],
        ReadyConfirmedButton: ["Ready confirmed", "Preparación confirmada", "Bereitschaft bestätigt"],
        ImReady: ["I'm ready", "Estoy listo", "Ich bin bereit"],
        AccessInstructions: ["Access instructions", "Instrucciones de acceso", "Zugangshinweise"],
        AccessInstructionsDetail: [
            "Gate code, parking, loading dock, or reception notes.",
            "Código de puerta, estacionamiento, muelle de carga o recepción.",
            "Torcode, Parkplatz, Laderampe oder Empfangshinweise.",
        ],
        AddAccessInstructions: ["Add access instructions", "Agregar instrucciones de acceso", "Zugangshinweise hinzufügen"],
        AccessInstructionsSaved: ["Access instructions saved.", "Instrucciones de acceso guardadas.", "Zugangshinweise gespeichert."],
        AccessInstructionsVisibleDetail: [
            "Dispatch and the assigned worker can see these instructions.",
            "El despacho y el trabajador asignado pueden ver estas instrucciones.",
            "Die Disposition und der zugewiesene Mitarbeiter können diese Hinweise sehen.",
        ],
        SaveInstructions: ["Save instructions", "Guardar instrucciones", "Hinweise speichern"],
        UpdateInstructions: ["Update instructions", "Actualizar instrucciones", "Hinweise aktualisieren"],
        RequestReschedule: ["Request reschedule", "Solicitar reprogramación", "Neuen Termin anfragen"],
        RequestRescheduleDetail: [
            "Ask dispatch to follow up if this window no longer works.",
            "Pida a despacho que haga seguimiento si este horario ya no le funciona.",
            "Bitten Sie die Disposition um Rückmeldung, falls dieses Zeitfenster nicht mehr passt.",
        ],
        ReschedulePlaceholder: ["What time works better?", "¿Qué hora le conviene más?", "Welche Zeit passt besser?"],
        RescheduleRequestSent: ["Reschedule request sent.", "Solicitud de reprogramación enviada.", "Terminänderung angefragt."],
        RescheduleRequestVisibleDetail: [
            "Sent {0}. Dispatch has been notified and can follow up.",
            "Enviado {0}. Despacho fue notificado y puede hacer seguimiento.",
            "Gesendet {0}. Die Disposition wurde benachrichtigt und kann sich melden.",
        ],
        UpdateRescheduleRequest: ["Update request", "Actualizar solicitud", "Anfrage aktualisieren"],
        RecipientFooterHelp: [
            "Need to reach the company? Reply via the message, email, portal, or booking channel where you received this link.",
            "¿Necesita contactar a la empresa? Responda por el mensaje, correo, portal o canal de reserva donde recibió este enlace.",
            "Möchten Sie das Unternehmen erreichen? Antworten Sie über die Nachricht, E-Mail, das Portal oder den Buchungskanal, über den Sie diesen Link erhalten haben.",
        ],
        MapLocationMayBeDelayed: ["location may be delayed", "la ubicación puede estar retrasada", "Standort kann verzögert sein"],
        MapLive: ["live", "en vivo", "live"],
        ErrorExpiredTitle: ["This tracking link has expired", "Este enlace de seguimiento ha expirado", "Dieser Tracking-Link ist abgelaufen"],
        ErrorRevokedTitle: [
            "This tracking link is no longer active",
            "Este enlace de seguimiento ya no está activo",
            "Dieser Tracking-Link ist nicht mehr aktiv",
        ],
        ErrorUnavailableTitle: ["Tracking page unavailable", "Página de seguimiento no disponible", "Tracking-Seite nicht verfügbar"],
        ErrorExpiredMessage: [
            "If your appointment is still coming up, contact the company that sent this link for an updated one.",
            "Si su cita aún está pendiente, comuníquese con la empresa que envió este enlace para recibir uno actualizado.",
            "Falls Ihr Termin noch bevorsteht, bitten Sie das Unternehmen, das Ihnen diesen Link gesendet hat, um einen neuen Link.",
        ],
        ErrorRevokedMessage: [
            "The sender turned this link off. For arrival details, please reach out to the company directly.",
            "El remitente desactivó este enlace. Para detalles de llegada, comuníquese directamente con la empresa.",
            "Der Absender hat diesen Link deaktiviert. Für Ankunftsdetails kontaktieren Sie bitte direkt das Unternehmen.",
        ],
        ErrorUnavailableMessage: [
            "We couldn't find this tracking page. Double-check the link, or contact the company that sent it.",
            "No pudimos encontrar esta página de seguimiento. Revise el enlace o comuníquese con la empresa que lo envió.",
            "Wir konnten diese Tracking-Seite nicht finden. Prüfen Sie den Link oder kontaktieren Sie das Unternehmen, das ihn gesendet hat.",
        ],
        PoweredByHellotracks: ["Powered by Hellotracks", "Con tecnología de Hellotracks", "Bereitgestellt von Hellotracks"],
        ManualCreateDescription: [
            "Create a live arrival page the recipient can open without logging in — no app or account needed.",
            "Crea una página de llegada en vivo que el destinatario pueda abrir sin iniciar sesión — sin app ni cuenta.",
            "Erstelle eine Live-Ankunftsseite, die der Empfänger ohne Anmeldung öffnen kann – ohne App oder Konto.",
        ],
        ManualShareCaption: [
            "You'll copy the link and share it yourself — by email, SMS, or your own system.",
            "Copiarás el enlace y lo compartirás tú mismo — por correo, SMS o tu propio sistema.",
            "Du kopierst den Link und teilst ihn selbst – per E-Mail, SMS oder über dein eigenes System.",
        ],
        AutoEmailTip: [
            "Tip: Hellotracks can email this page to the job's contact automatically when the worker is on the way.",
            "Consejo: Hellotracks puede enviar esta página por correo al contacto de la tarea automáticamente cuando el trabajador esté en camino.",
            "Tipp: Hellotracks kann diese Seite automatisch per E-Mail an den Auftragskontakt senden, wenn der Mitarbeiter unterwegs ist.",
        ],
        AutoEmailScheduledToXAboutYMin: [
            "Nothing to do here — Hellotracks emails a live arrival link to {0} about {1} min before arrival and creates the page automatically when the email is sent.",
            "No necesitas hacer nada — Hellotracks envía un enlace de llegada en vivo a {0} unos {1} min antes de la llegada y crea la página automáticamente al enviar el correo.",
            "Du musst nichts tun – Hellotracks sendet etwa {1} Min. vor der Ankunft einen Live-Ankunftslink per E-Mail an {0} und erstellt die Seite dabei automatisch.",
        ],
        AutoEmailScheduledToX: [
            "Nothing to do here — Hellotracks emails a live arrival link to {0} before arrival and creates the page automatically when the email is sent.",
            "No necesitas hacer nada — Hellotracks envía un enlace de llegada en vivo a {0} antes de la llegada y crea la página automáticamente al enviar el correo.",
            "Du musst nichts tun – Hellotracks sendet vor der Ankunft einen Live-Ankunftslink per E-Mail an {0} und erstellt die Seite dabei automatisch.",
        ],
        CreateEtaPage: ["Create ETA page", "Crear página ETA", "ETA-Seite erstellen"],
        CreatePageNow: ["Create page now", "Crear página ahora", "Seite jetzt erstellen"],
        CreateEarlyCaption: [
            "Create it earlier if you want to preview the page or share the link yourself.",
            "Créala antes si quieres previsualizar la página o compartir el enlace tú mismo.",
            "Erstelle sie früher, wenn du die Seite ansehen oder den Link selbst teilen möchtest.",
        ],
        RecipientLink: ["Recipient link", "Enlace del destinatario", "Empfängerlink"],
        Preview: ["Preview", "Vista previa", "Vorschau"],
        Refresh: ["Refresh", "Actualizar", "Aktualisieren"],
        Revoke: ["Revoke", "Revocar", "Widerrufen"],
        RecipientActivity: ["Recipient activity", "Actividad del destinatario", "Empfängeraktivität"],
        Viewed: ["Viewed", "Visto", "Angesehen"],
        Ready: ["Ready", "Listo", "Bereit"],
        AccessNotes: ["Access notes", "Notas de acceso", "Zugangshinweise"],
        RescheduleRequested: ["Reschedule requested", "Reprogramación solicitada", "Terminänderung angefragt"],
        LatestEvents: ["Latest events", "Últimos eventos", "Neueste Ereignisse"],
        WillEmailToXAboutYMin: [
            "The ETA email sends this ETA page to {0} about {1} min before arrival.",
            "El correo de ETA envía esta página ETA a {0} unos {1} min antes de la llegada.",
            "Die ETA-E-Mail schickt diese ETA-Seite etwa {1} Min. vor der Ankunft an {0}.",
        ],
        WillEmailToX: [
            "The ETA email sends this ETA page to {0} before arrival.",
            "El correo de ETA envía esta página ETA a {0} antes de la llegada.",
            "Die ETA-E-Mail schickt diese ETA-Seite vor der Ankunft an {0}.",
        ],
        AutoEmailsOff: [
            "ETA emails are off, so copy the link and send it yourself.",
            "Los correos de ETA están desactivados, así que copia el enlace y envíalo tú mismo.",
            "ETA-E-Mails sind aus, also kopier den Link und schick ihn selbst.",
        ],
        NoContactEmailShareYourself: [
            "No ETA email can go out: this job has no contact email. Copy the link and send it yourself.",
            "No puede salir ningún correo de ETA: esta tarea no tiene correo de contacto. Copia el enlace y envíalo tú mismo.",
            "Es kann keine ETA-E-Mail rausgehen: Dieser Auftrag hat keine Kontakt-E-Mail. Kopier den Link und schick ihn selbst.",
        ],
        NoEmailScheduled: [
            "No ETA email is planned for this job, so copy the link and send it yourself.",
            "No hay ningún correo de ETA previsto para esta tarea, así que copia el enlace y envíalo tú mismo.",
            "Für diesen Auftrag ist keine ETA-E-Mail geplant, also kopier den Link und schick ihn selbst.",
        ],
        JobContactFallback: [
            "the job's contact",
            "la persona de contacto",
            "den Auftragskontakt",
        ],
        EtaPageLinkMissingFromEmailTemplate: [
            "Your ETA email doesn't include the ETA page link. Turn on “Include ETA page link” in the email settings, or copy the link and send it yourself.",
            "Tu correo de ETA no incluye el enlace a la página ETA. Activa “Incluir enlace a la página ETA” en la configuración de correo, o copia el enlace y envíalo tú mismo.",
            "Deine ETA-E-Mail enthält den Link zur ETA-Seite nicht. Schalte „Link zur ETA-Seite einfügen“ in den E-Mail-Einstellungen ein oder kopier den Link und schick ihn selbst.",
        ],
        EtaPageEmailSentWithLinkToXAtY: [
            "The ETA email sent this ETA page to {0} at {1}.",
            "El correo de ETA envió esta página ETA a {0} a las {1}.",
            "Die ETA-E-Mail hat diese ETA-Seite um {1} an {0} geschickt.",
        ],
        EtaPageEmailSentWithoutLinkToXAtY: [
            "The ETA email went to {0} at {1}, but without the ETA page link.",
            "El correo de ETA llegó a {0} a las {1}, pero sin el enlace a la página ETA.",
            "Die ETA-E-Mail ging um {1} an {0}, aber ohne den Link zur ETA-Seite.",
        ],
        EtaPageNoContactEmail: [
            "ETA emails are on, but this job has no contact email. Add one above, or create the ETA page and send the link yourself.",
            "Los correos de ETA están activados, pero esta tarea no tiene correo de contacto. Agrega uno arriba, o crea la página ETA y envía el enlace tú mismo.",
            "ETA-E-Mails sind an, aber dieser Auftrag hat keine Kontakt-E-Mail. Füg oben eine hinzu oder erstell die ETA-Seite und schick den Link selbst.",
        ],
        EtaPageEditEmailSettings: [
            "Edit email settings",
            "Editar configuración de correo",
            "E-Mail-Einstellungen bearbeiten",
        ],
        RevokeEtaPageTitle: ["Revoke ETA page?", "¿Revocar página ETA?", "ETA-Seite widerrufen?"],
        RevokeEtaPageDescription: [
            "The recipient link stops working immediately. This can't be undone.",
            "El enlace del destinatario dejará de funcionar de inmediato. Esto no se puede deshacer.",
            "Der Empfängerlink funktioniert sofort nicht mehr. Dies kann nicht rückgängig gemacht werden.",
        ],
        RecipientVisibility: ["What the recipient sees", "Lo que ve el destinatario", "Was der Empfänger sieht"],
        ShowWorkerName: ["Worker name", "Nombre del trabajador", "Mitarbeitername"],
        ShowWorkerNameCaption: [
            "Shows who is assigned.",
            "Muestra quién está asignado.",
            "Zeigt, wer zugewiesen ist.",
        ],
        ShowLiveMap: ["Live map", "Mapa en vivo", "Live-Karte"],
        ShowLiveMapCaption: [
            "Shows live location during the active visit.",
            "Muestra la ubicación en vivo durante la visita activa.",
            "Zeigt den Live-Standort während des aktiven Termins.",
        ],
        EventCreated: ["created", "creado", "erstellt"],
        EventViewed: ["viewed", "visto", "angesehen"],
        EventReadyConfirmed: ["ready confirmed", "preparación confirmada", "Bereitschaft bestätigt"],
        EventAccessNotesAdded: ["access notes added", "notas de acceso agregadas", "Zugangshinweise hinzugefügt"],
        EventRescheduleRequested: ["reschedule requested", "reprogramación solicitada", "Terminänderung angefragt"],
        EventEtaRecalculated: ["ETA recalculated", "ETA recalculada", "ETA neu berechnet"],
        EventVisibilityChanged: ["visibility changed", "visibilidad cambiada", "Sichtbarkeit geändert"],
        EventJobStatusChanged: ["job status changed", "estado de tarea cambiado", "Auftragsstatus geändert"],
        EventCompleted: ["completed", "completado", "abgeschlossen"],
        EventExpired: ["expired", "expirado", "abgelaufen"],
        EventRevoked: ["revoked", "revocado", "widerrufen"],
    },
    General: {
        NotFound: ["Not found", "No encontrado", "Nicht gefunden"],
        GotIt: ["Got it", "Entendido", "Verstanden"],
        DownloadStarted: ["Download started", "Descarga iniciada", "Download gestartet"],
        ShowTags: [
            "Show tags",
            "Mostrar etiquetas",
            "Tags anzeigen"
        ],
        GroupByTeam: [
            "Group by team",
            "Agrupar por equipo",
            "Nach Team gruppieren"
        ],
        NotYetScheduled: ["Not yet scheduled", "No programado todavía", "Noch nicht geplant"],
        ShowTimeSlider: ["Show time slider", "Mostrar línea de tiempo", "Zeitleiste einblenden"],
        HideTimeSlider: ["Hide time slider", "Ocultar línea de tiempo", "Zeitleiste ausblenden"],
        Average: ["Average", "Promedio", "Durchschnitt"],
        AllDay: ["All day", "Todo el día", "Ganzer Tag"],
        Morning: ["Morning", "Mañana", "Morgen"],
        Afternoon: ["Afternoon", "Tarde", "Nachmittag"],
        Evening: ["Evening", "Noche", "Abend"],
        Night: ["Night", "Madrugada", "Nacht"],
        EditLocation: ["Edit location", "Editar dirección", "Adresse bearbeiten"],
        NoResults: ["No results", "Sin resultados", "Keine Ergebnisse"],
        System: ["System", "Sistema", "System"],
        Pin: ["Pin", "Fijar", "Anheften"],
        Unpin: ["Unpin", "Desfijar", "Lösen"],
        Pinned: ["Pinned", "Fijados", "Angeheftet"],
        XAway: ["{0} away", "está a {0}", "{0} entfernt"],
        TimeToReach: ["Time to reach", "Tiempo de viaje", "Fahrzeit"],
        Find: ["Find", "Encontrar", "Finden"],
        EditAddress: ["Edit address", "Editar dirección", "Adresse ändern"],
        Rename: ["Rename", "Renombrar", "Umbenennen"],
        Range: ['Range', 'Rango', "Bereich"],
        XDays: ["{0} days", "{0} días", "{0} Tage"],
        XHours: ["{0} hours", "{0} horas", "{0} Stunden"],
        XMinutes: ["{0} minutes", "{0} minutos", "{0} Minuten"],
        Accept: ['Accept', 'Aceptar', 'Akzeptieren'],
        Action: ['Action', 'Acción', 'Aktion',],
        ActionCannotBeUndone: [
            'This action <strong>cannot be undone</strong>, and will permanently delete data.',
            'Esta acción <strong>no se puede deshacer</strong> y eliminará datos permanentemente.',
            'Diese Aktion kann <strong>nicht rückgängig gemacht</strong> werden und löscht Daten dauerhaft.',
        ],
        Add: ['Add', 'Agregar', 'Hinzufügen'],
        Address: ['Address', 'Dirección', 'Adresse'],
        Admin: ['Administrator', 'Administrador', 'Administrator'],
        AdministratorsDesc: [
            'Administrators have the same permissions as operators. They can also add, manage and remove members. ',
            'Los administradores tienen los mismos permisos que los operadores. Además, pueden agregar, administrar y eliminar miembros.',
            'Administratoren haben alle Rechte von Disponenten. Zusätzlich können sie Mitglieder hinzufügen, verwalten und entfernen.',
        ],
        AssignedTo: ['Assigned to', 'Asignado a', 'Zugewiesen an'],
        MovedTo: ["Moved to", "Cambiado a", "Verschoben auf"],
        At: ['at', 'en', 'in'],
        Between: ['between', 'entre', 'zwischen'],
        SaveTemplate: ['Save template', 'Guardar plantilla', 'Vorlage speichern'],
        CloseTemplate: ["Close template", "Cerrar plantilla", "Vorlage schließen"],
        SaveCustomFieldsForJobsDesc: [
            "Save custom fields as a template to apply automatically to new jobs",
            "Guardar campos personalizados como plantilla para aplicar automáticamente en nuevas tareas",
            "Benutzerdefinierte Felder als Vorlage speichern, um sie automatisch auf zukünftige Aufträge anzuwenden"
        ],
        SaveCustomFieldsForPlacesDesc: [
            "Save custom fields as a template to apply automatically to future places",
            "Guardar campos personalizados como plantilla para aplicarlos automáticamente a lugares futuros",
            "Benutzerdefinierte Felder als Vorlage speichern, um sie automatisch auf zukünftige Orte anzuwenden"
        ],
        LinkedFormsForPlacesDesc: [
            "Linked forms are accessible in the place view in the mobile app. Create and manage forms under Insights > Forms.",
            "Los formularios vinculados son accesibles en la vista del lugar en la aplicación móvil. Crea y administra formularios en Insights > Formularios.",
            "Verknüpfte Formulare findest du in der mobilen App in der Ortsansicht. Erstelle und verwalte Formulare unter Insights > Formulare.",
        ],
        SaveFormsForPlacesDesc: [
            "Save these linked forms as the default for all new places",
            "Guardar estos formularios vinculados como predeterminados para todos los nuevos lugares",
            "Diese verknüpften Formulare als Standard für alle neuen Orte speichern"
        ],
        SaveVoizReportsForPlacesDesc: [
            "Save these linked Voiz reports as the default for all new places",
            "Guardar estos informes Voiz vinculados como predeterminados para todos los nuevos lugares",
            "Diese verknüpften Voiz-Berichte als Standard für alle neuen Orte speichern"
        ],
        Cancel: ['Cancel', 'Cancelar', 'Abbrechen'],
        Change: ['Change', 'Cambiar', "Ändern"],
        City: ['City', 'Ciudad', 'Stadt'],
        CloseWithoutSaving: ['Close without saving', 'Cerrar sin guardar', 'Schließen ohne Speichern'],
        ConnectedToWorkspace: [
            'Connected to workspace',
            'Conectado al espacio de trabajo',
            'Verbunden mit Workspace',
        ],
        Confirm: ['Confirm', 'Confirmar', 'Bestätigen'],
        Contact: ['Contact', 'Contacto', 'Kontakt'],
        Copied: ['Copied', 'Copiado', 'Kopiert'],
        Copy: ['Copy', 'Copiar', 'Kopieren'],
        Assignee: ['Assignee', 'Asignado', 'Zugewiesen an'],
        CopyAssignee: ['Copy assignee', 'Copiar asignado', 'Zuweisung kopieren'],
        CopyDate: ['Copy date', 'Copiar fecha', 'Datum kopieren'],
        Country: ['Country', 'País', 'Land'],
        Credentials: ['Credentials', 'Credenciales', 'Anmeldedaten'],
        Date: ['Date', 'Fecha', 'Datum'],
        Quality: ['Quality', 'Calidad', 'Qualität'],
        Delete: ['Delete', 'Borrar', 'Löschen'],
        Duration: ['Duration', 'Duración', 'Dauer'],
        Minutes: ['Minutes', 'Minutos', 'Minuten'],
        Edit: ['Edit', 'Editar', 'Bearbeiten'],
        Email: ['Email', 'Correo electrónico', 'E-Mail'],
        Empty: ['Empty', 'Vacío', 'Leer'],
        Filter: ['Filter', 'Filtrar', 'Filter'],
        Friday: ['Friday', 'Viernes', 'Freitag'],
        General: ['General', 'General', 'Allgemein'],
        Geocode: ['Geolocate', 'Geolocalizar', 'Geolokalisieren'],
        ImageUpload: ['Upload image', 'Subir imagen', 'Bild hochladen'],
        FileToUpload: ['File to upload', 'Archivo a subir', 'Datei zum Hochladen'],
        IncorrectPassword: ['Incorrect password', 'Contraseña incorrecta', 'Falsches Passwort'],
        InvalidUsernameOrPassword: [
            "Invalid username or password",
            "Nombre de usuario o contraseña inválidos",
            "Nutzername oder Passwort ungültig",
        ],
        InvalidImageError: ['File not accepted', 'Archivo no aceptado', 'Datei nicht akzeptiert'],
        Job: ['Job', 'Tarea', 'Auftrag'],
        Language: ['Language', 'Idioma', 'Sprache'],
        Loading: ['Loading...', 'Cargando...', 'Wird geladen...'],
        Ready: ['Ready', 'Listo', 'Bereit'],
        Locate: ['Locate', 'Localizar', 'Orten'],
        LocationServicesOff: ['Location services off', 'Servicios de ubicación desactivados', 'Standortdienste aus'],
        LoggedOut: ['Logged out', 'Sesión cerrada', 'Abgemeldet'],
        Member: ['Member', 'Miembro', 'Mitglied'],
        Members: ['Members', 'Miembros', 'Mitglieder'],
        More: ['More', 'Más', 'Mehr'],
        XMore: ['{0} more', '{0} más', '{0} mehr'],
        Monday: ['Monday', 'Lunes', 'Montag'],
        Name: ['Name', 'Nombre', 'Name'],
        Never: ['Never', 'Nunca', 'Niemals'],
        No: ['No', 'No', 'Nein'],
        None: ['None', 'Ninguna', 'Keine'],
        Maybe: ['Maybe', 'Tal vez', 'Vielleicht'],
        OK: ['OK', 'OK', 'OK'],
        OffDuty: ['Off duty', 'Tiempo fuera de servicio', 'Außerhalb der Dienstzeit'],
        OnTheWay: ['On the way', 'En camino', 'Unterwegs'],
        OneDay: ['1 day', '1 día', '1 Tag'],
        OneMonth: ['1 month', '1 mes', '1 Monat'],
        Open: ['Open', 'Abrir', 'Öffnen'],
        Operator: ['Operator', 'Operador', 'Disponent'],
        OperatorsDesc: [
            'Operators can access both the web dashboard and the mobile app. They can create, manage and dispatch jobs.',
            'Los operadores tienen acceso al panel web y a la aplicación móvil. Pueden crear, administrar y asignar tareas.',
            'Disponenten haben Zugang zum Web-Dashboard und zur mobilen App. Sie können Aufträge erstellen, verwalten und zuweisen.',
        ],
        Overnight: ['Overnight', 'Horario nocturno', 'Nachtschicht'],
        Password: ['Password', 'Contraseña', 'Passwort'],
        Phone: ['Phone', 'Teléfono', 'Telefon'],
        Place: ['Place', 'Lugar', 'Ort'],
        PleaseEnterAValidEmailAddress: [
            'Please enter a valid email address.',
            'Ingresa una dirección de correo electrónico válida.',
            'Bitte eine gültige E-Mail-Adresse eingeben.',
        ],
        PostalCode: ['ZIP code', 'Código postal', 'Postleitzahl'],
        ReallyCloseUnsaved: [
            'You have unsaved changes',
            'Tienes cambios sin guardar',
            'Es gibt nicht gespeicherte Änderungen',
        ],
        ResetPasswordLink: [
            'Send link to reset password',
            'Enviar enlace para restablecer la contraseña',
            'Link zum Zurücksetzen des Passworts senden',
        ],
        ChangeUsername: [
            'Change username',
            'Cambiar nombre de usuario',
            'Nutzernamen ändern',
        ],
        UsernameAlreadyTaken: [
            'Username is already taken.',
            'El nombre de usuario ya está en uso.',
            'Der Nutzername ist bereits vergeben.',
        ],
        UsernameChanged: [
            'Username changed.',
            'Nombre de usuario cambiado.',
            'Nutzername geändert.',
        ],
        LinkExpiredTitle: ['This link has expired or was already used.', 'Este enlace ha caducado o ya se usó.', 'Dieser Link ist abgelaufen oder wurde schon benutzt.'],
        LinkExpiredHint: ['Links from emails work once and expire after a while. Get a new one by email.', 'Los enlaces de los correos sirven una vez y caducan pasado un tiempo. Pide uno nuevo por correo.', 'Links aus E-Mails funktionieren nur einmal und laufen nach einer Weile ab. Lass dir einen neuen schicken.'],
        SendNewLink: ['Send me a new link', 'Enviarme un enlace nuevo', 'Neuen Link schicken'],
        PasswordRecoveryLinkExpired: [
            'This activation link was opened again or has expired. Please use the newest tab or request a new link.',
            'Este enlace de activación se abrió de nuevo o ha expirado. Usa la pestaña más reciente o solicita un nuevo enlace.',
            'Dieser Aktivierungslink wurde erneut geöffnet oder ist abgelaufen. Bitte verwende den neuesten Tab oder fordere einen neuen Link an.',
        ],
        Role: ['Role', 'Rol', 'Rolle'],
        Saturday: ['Saturday', 'Sábado', 'Samstag'],
        Save: ['Save', 'Guardar', 'Speichern'],
        SaveAsJobTemplate: ['Save as job template', 'Guardar como plantilla de tarea', 'Als Vorlage speichern'],
        SelectPlaceOrAddresOnMap: [
            'Select place or address on map',
            'Selecciona el lugar o dirección en el mapa',
            'Ort oder Adresse auf der Karte auswählen',
        ],
        SetAsDefault: ['Set as default', 'Fijar por defecto', 'Als Standard festlegen'],
        Settings: ['Settings', 'Configuración', 'Einstellungen'],
        Signature: ['Signature', 'Firma', 'Unterschrift'],
        SignatureName: ['Signature name', 'Nombre del firmante', 'Name des Unterzeichners'],
        SignatureDate: ['Signature date', 'Fecha de la firma', 'Datum der Unterschrift'],
        GeneralSettings: ['General settings', 'Configuración general', 'Allgemeine Einstellungen'],
        State: ['State', 'Estado', 'Bundesland'],
        Stationary: ['Stationary', 'Parado', 'Stillstehend'],
        LiveStatusAt: ['At', 'En', 'Bei'],
        LiveStatusAtJob: ['At job', 'En tarea', 'Bei Auftrag'],
        LiveStatusPausing: ['Pausing', 'En pausa', 'Pausiert'],
        LiveStatusLastSeen: ['Last seen {0} ago', 'Visto hace {0}', 'Zuletzt gesehen vor {0}'],
        LiveStatusAgo: ['{0} ago', 'hace {0}', 'vor {0}'],
        XIssues: ['{0} issues', '{0} problemas', '{0} Probleme'],
        Status: ['Status', 'Estado', 'Status'],
        StatusChange: [
            'Status change will be applied immediately',
            'El cambio de estado se aplicará inmediatamente',
            'Die Statusänderung wird sofort angewendet',
        ],
        Sunday: ['Sunday', 'Domingo', 'Sonntag'],
        Team: ['Team', 'Equipo', 'Team'],
        Teams: ['Teams', 'Equipos', 'Teams'],
        TeamsForPlacesDesc: [
            "Restrict this place's visibility to specific teams. Only members of assigned teams will see this place in their mobile app.",
            "Restringe la visibilidad de este lugar a equipos específicos. Solo los miembros de los equipos asignados verán este lugar en su aplicación móvil.",
            "Beschränke die Sichtbarkeit dieses Ortes auf bestimmte Teams. Nur Mitglieder der zugewiesenen Teams sehen diesen Ort in ihrer mobilen App.",
        ],
        Thursday: ['Thursday', 'Jueves', 'Donnerstag'],
        TimeZone: ['Time zone', 'Huso horario', 'Zeitzone'],
        LanguageAndRegion: ['Language & region', 'Idioma y región', 'Sprache & Region'],
        Formats: ['Formats', 'Formatos', 'Formate'],
        Title: ['Title', 'Título', 'Titel'],
        EnterTitle: ["Enter title", "Ingresar título", "Titel eingeben"],
        To: ['To', 'Hasta', 'Nach'],
        Total: ['Total', 'Total', 'Gesamt'],
        TrackingOff: ['Tracking off', 'Seguimiento apagado', 'Tracking aus'],
        Tuesday: ['Tuesday', 'Martes', 'Dienstag'],
        UnitDistance: ['Measure of length', 'Formato de distancia', 'Längenmaß'],
        UnitKilometer: ['Kilometer', 'Kilómetros', 'Kilometer'],
        UnitMiles: ['Miles', 'Millas', 'Meilen'],
        UnitTime12: ['12 hours (AM/PM)', '12 horas (AM/PM)', '12 Stunden (AM/PM)'],
        UnitTime24: ['24 hours', '24 horas', '24 Stunden'],
        UnitTime: ['Time format', 'Formato de hora', 'Uhrzeitformat'],
        Url: ['URL', 'URL', 'URL'],
        Username: ['Username', 'Nombre de usuario', 'Nutzername'],
        VerifyEmail: ['Verify email', 'Verificar correo electrónico', 'E-Mail bestätigen'],
        VerifyPhone: ['Verify phone number', 'Verificar número de teléfono', 'Telefonnummer bestätigen'],
        Wednesday: ['Wednesday', 'Miércoles', 'Mittwoch'],
        WeekdayFr: ['Fr', 'Vi', 'Fr'],
        WeekdayMo: ['Mo', 'Lu', 'Mo'],
        WeekdaySa: ['Sa', 'Sa', 'Sa'],
        WeekdaySu: ['Su', 'Do', 'So'],
        WeekdayTh: ['Th', 'Jue', 'Do'],
        WeekdayTu: ['Tu', 'Ma', 'Di'],
        WeekdayWe: ['We', 'Mi', 'Mi'],
        MonthJan: ['Jan', 'Ene', 'Jan'],
        MonthFeb: ['Feb', 'Feb', 'Feb'],
        MonthMar: ['Mar', 'Mar', 'Mär'],
        MonthApr: ['Apr', 'Abr', 'Apr'],
        MonthMay: ['May', 'May', 'Mai'],
        MonthJun: ['Jun', 'Jun', 'Jun'],
        MonthJul: ['Jul', 'Jul', 'Jul'],
        MonthAug: ['Aug', 'Ago', 'Aug'],
        MonthSep: ['Sep', 'Sep', 'Sep'],
        MonthOct: ['Oct', 'Oct', 'Okt'],
        MonthNov: ['Nov', 'Nov', 'Nov'],
        MonthDec: ['Dec', 'Dic', 'Dez'],
        WorkersDesc: [
            'Workers only have access to the mobile app to see their jobs.',
            'Los trabajadores solo tienen acceso a la aplicación móvil para ver sus tareas.',
            'Mitarbeiter haben nur Zugang über die Hellotracks-App und sehen dort ihre zugewiesenen Aufträge.',
        ],
        XMonths: ['{0} months', '{0} meses', '{0} Monate'],
        Xmin: ['{0} min', '{0} min', '{0} min'],
        Yes: ['Yes', 'Sí', 'Ja'],
        YourWebsite: ['Your website', 'Tu página web', 'Deine Website'],
        Required: ['Required', 'Requerido', 'Erforderlich'],
        Optional: ['Optional', 'Opcional', 'Optional'],
        Create: ['Create', 'Crear', 'Erstellen'],
        PleaseCompleteAllFields: [
            'Please complete all required fields',
            'Completa todos los campos obligatorios',
            'Bitte alle Pflichtfelder ausfüllen',
        ],
        NoChangesToSave: [
            'No changes to save',
            'No hay cambios para guardar',
            'Keine Änderungen zu speichern',
        ],
        InfoAboutTemplates: [
            'Info about templates',
            'Información sobre plantillas',
            'Informationen zu Vorlagen',
        ],
        StartImporting: [
            'Start importing',
            'Comenzar importación',
            'Import starten',
        ],
        Message: ['Message', 'Mensaje', 'Nachricht'],
        MessageSentTo: [
            'Message sent to {0}',
            'Mensaje enviado a {0}',
            'Nachricht an {0} gesendet',
        ],
        LinkedForms: ['Linked forms', 'Formularios vinculados', 'Verknüpfte Formulare'],
        Created: ['Created', 'Creado', 'Erstellt'],
        Assigned: ['Assigned', 'Asignado', 'Zugewiesen'],
        Saved: ['Saved', 'Guardado', 'Gespeichert'],
        Archived: ['Archived', 'Archivado', 'Archiviert'],
        RecentlyUpdated: ['Recent', 'Recientes', 'Aktuell'],
        AssignedDate: ["Assigned date", "Fecha asignada", "Zugewiesenes Datum"],
        NoAssignedDate: ["No date", "Sin fecha", "Kein Datum"],
        ReduceFilters: [
            "Reduce filters",
            "Reducir los filtros",
            "Filter reduzieren",
        ],
        LastSaved: [
            "Last saved",
            "Último guardado",
            "Zuletzt gespeichert",
        ],
        SomethingWentWrong: ['Something went wrong!', '¡Algo salió mal!', 'Etwas ist schiefgelaufen!'],
        Done: ['Done', 'Listo', 'Fertig'],
        Description: ['Description', 'Descripción', 'Beschreibung'],
        Every: ['Every', 'Todos los', 'Jeden'],
        Days: ['Days', 'Días', 'Tage'],
        Clear: ['Clear', 'Limpiar', 'Leeren'],
        ClearAll: ['Clear all', 'Limpiar todo', 'Alle löschen'],
        AssignOnSpecificDays: [
            'Additionally assign on specific days',
            'Asignar además en días específicos',
            'Zusätzlich an bestimmten Tagen zuweisen'
        ],
        ChooseDateRange: [
            'Choose date range',
            'Seleccionar rango de fechas',
            'Datumsbereich auswählen'
        ],
        Until: ['Until', 'Hasta', 'Bis'],
        From: ['From', 'Desde', 'Von'],
        End: ['End', 'Fin', 'Ende'],
        Or: ['or', 'o', 'oder'],
        Exit: ['Exit', 'Salir', 'Beenden'],
        Expand: ["Expand", "Maximizar", "Maximieren"],
        Calculate: ['Calculate', 'Calcular', 'Berechnen'],
        Optimized: ['Optimized', 'Optimizado', 'Optimiert'],
        SuccessAssignTo: [
            "successfully assigned to",
            "asignado con éxito a",
            "erfolgreich zugewiesen an",
        ],
        RemoveFromBoard: [
            "Remove from board",
            "Quitar del tablero",
            "Vom Board entfernen",
        ],
        AssignOnceNow: ['Assign once now', 'Asignar ahora (una vez)', 'Einmalig zuweisen'],
        RecurringlyAssignTo: [
            "Recurringly assign to",
            "Asignar recurrentemente a",
            "Wiederkehrend zuweisen",
        ],
        ShowAll: ['Show all', 'Ver todo', 'Alle anzeigen'],
        ShowLess: ['Show less', 'Ver menos', 'Weniger anzeigen'],
        ShowAllCount: ['Show all {0}', 'Ver los {0}', 'Alle {0} anzeigen'],
        SelectedDay: ['Selected day', 'Día seleccionado', 'Ausgewählter Tag'],
        CreatedByX: [
            "Created by {0}",
            "Creado por {0}",
            "Erstellt von {0}",
        ],
        By: [
            "by {0}",
            "por {0}",
            "von {0}",
        ],
        AssignedByX: [
            "Assigned by {0}",
            "Asignado por {0}",
            "Zugewiesen von {0}",
        ],
        Time: ['Time', 'Hora', 'Zeit'],
        Issue: ['Issue', 'Problema', 'Problem'],
        Started: ['Started', 'Empezado', 'Gestartet'],
        Rejected: ['Rejected', 'Rechazada', 'Abgelehnt'],
        CheckIn: ['Check-in', 'Check-in', 'Check-in'],
        CheckOut: ['Check-out', 'Check-out', 'Check-out'],
        Success: ['Success', 'Éxito', 'Erfolg'],
        EnterAddressOrGeocode: [
            "Enter street address or geolocate",
            "Ingresa dirección o geolocaliza",
            "Adresse eingeben oder geolokalisieren",
        ],
        TimeWindow: [
            'Time window',
            'Ventana horaria',
            'Zeitfenster',
        ],
        BackToPage: [
            'Back to {0}',
            'Volver a {0}',
            'Zurück zu {0}',
        ],
        TimeWindowDesc: [
            "An optional time window for the job site's availability. Visible to field workers. Also helps with routing and auto-dispatching.",
            "Una ventana horaria opcional para la disponibilidad del sitio de la tarea. Visible para los trabajadores de campo. También ayuda con las rutas y la asignación automática.",
            "Ein optionales Zeitfenster, in dem der Einsatzort verfügbar ist. Sichtbar für Außendienstmitarbeiter. Hilft auch bei Routenplanung und automatischer Disposition.",
        ],
        NotSet: [
            'not set',
            'no establecido',
            'nicht gesetzt',
        ],
        NoUploadedImages: [
            "No uploaded images",
            "No hay imágenes cargadas",
            "Keine Bilder hochgeladen",
        ],
        NoUploadedImagesDesc: [
            "Here you'll find all uploaded images from your field staff for the selected day. Your field staff can upload images to assigned jobs from their Hellotracks mobile app.",
            "Aquí encontrarás todas las imágenes cargadas por tu equipo de campo para el día seleccionado. Tu equipo de campo puede cargar imágenes para tareas asignadas desde su aplicación móvil de Hellotracks.",
            "Hier findest du alle hochgeladenen Bilder deiner Mitarbeiter für den ausgewählten Tag. Dein Außendienst kann Bilder zu den zugewiesenen Aufträgen über die Hellotracks-App hochladen.",
        ],
        NoSignature: [
            "No signature",
            "Sin firma",
            "Keine Unterschrift",
        ],
        AssignTo: [
            'Assign to',
            'Asignar a',
            'Zuweisen',
        ],
        Assign: [
            'Assign',
            'Asignar',
            'Zuweisen',
        ],
        Reassign: [
            "Reassign",
            "Reasignar",
            "Neu zuweisen",
        ],
        Send: [
            'Send',
            'Enviar',
            'Senden',
        ],
        AttachLocation: [
            "Attach location",
            "Adjuntar ubicación",
            "Standort anhängen",
        ],
        Billing: [
            "Billing",
            "Facturación",
            "Zahlungsdaten",
        ],
        SignOut: [
            "Log out",
            "Cerrar sesión",
            "Abmelden",
        ],
        ViewProfile: [
            "View profile",
            "Ver perfil",
            "Profil ansehen",
        ],
        RoleAdministrator: [
            "Administrator",
            "Administrador",
            "Administrator",
        ],
        RoleOperator: [
            "Operator",
            "Operador",
            "Disponent",
        ],
        RoleWorker: [
            "Worker",
            "Trabajador",
            "Mitarbeiter",
        ],
        CompanyAccount: [
            "Company account",
            "Cuenta de empresa",
            "Firmenkonto",
        ],
        EditX: ['Edit {0}', 'Editar {0}', '{0} bearbeiten'],
        ToggleMenu: [
            "Toggle menu",
            "Alternar menú",
            "Menü ein-/ausblenden",
        ],
        NavMenuOperations: [
            "Operations",
            "Operaciones",
            "Operations",
        ],
        NavMenuAnalyze: [
            'Analyze',
            'Análisis',
            'Analysieren',
        ],
        NavMenuManage: [
            'Manage',
            'Administrar',
            'Verwalten',
        ],
        MemberRouting: [
            "Member routing",
            "Ruta de miembro",
            "Routing",
        ],
        NavLocationGeneralDesc: [
            "Click the map to place the new job, or search for an address or place.",
            "Haz clic en el mapa para colocar la nueva tarea, o busca y elige por dirección o lugar.",
            "Klicke auf die Karte, um den neuen Auftrag zu platzieren, oder suche und wähle eine Adresse oder einen Ort.",
        ],
        NavLocationPlaceDesc: [
            "Click the map to create the new place, or search for an address.",
            "Haz clic en el mapa para crear el nuevo lugar, o busca y elige por dirección.",
            "Klicke auf die Karte, um den neuen Ort zu erstellen, oder suche und wähle eine Adresse.",
        ],
        Next: ["Next", "Siguiente", "Weiter"],
        FindAddress: [
            'Find address',
            'Buscar dirección',
            'Adresse finden',
        ],
        AddressOrPlace: [
            "Address or place",
            "Dirección o lugar",
            "Adresse oder Ort",
        ],
        NavLocationPlaceHelp: [
            "Drag from center to move the place. Drag from sides to change the radius.",
            "Arrastra desde el centro para mover el lugar. Arrastra desde los lados para cambiar el radio.",
            "Ziehe vom Zentrum aus, um den Ort zu bewegen. Ziehe von den Seiten, um den Radius zu ändern.",
        ],
        NavDrawNewZoneDesc: [
            "Click the map to create a new zone. Click the last point to finish.",
            "Haz clic en el mapa para crear una nueva zona, haz clic en el último punto para terminar.",
            "Klicke auf die Karte, um eine neue Zone zu erstellen. Klicke auf den letzten Punkt, um abzuschließen.",
        ],
        NavDrawEditZoneXDesc: [
            "Editing region for {0}",
            "Editando región de {0}",
            "Region bearbeiten für {0}",
        ],
        NavDrawQuickRouteDesc: [
            "Click points on the map to create a quick route of several jobs. Click the last point again to finish. Each point creates a new job.",
            "Haz clic en puntos del mapa para crear una ruta rápida de varias tareas. Haz clic de nuevo en el último punto para terminar. Cada punto crea una nueva tarea.",
            "Klicke auf der Karte Punkte an, um eine schnelle Route aus mehreren Aufträgen zu erstellen. Klicke erneut auf den letzten Punkt, um abzuschließen. Jeder Punkt erstellt einen neuen Auftrag.",
        ],
        Color: [
            "Color",
            "Color",
            "Farbe",
        ],
        ProgressStatus: [
            "Progress status",
            "Estado del progreso",
            "Fortschritt",
        ],
        Type: ['Type', 'Tipo', 'Typ'],
        Size: ['Size', 'Tamaño', 'Größe'],
        Priority: ['Priority', 'Prioridad', 'Priorität'],
        PriorityCaption: [
            "Priority indicates urgency to operators and workers, and is relevant for route optimization, ensuring higher priority jobs are scheduled first.",
            "La prioridad indica urgencia a los operadores y trabajadores, y es relevante para la optimización de rutas, asegurando que las tareas de mayor prioridad se programen primero.",
            "Priorität zeigt Dringlichkeit für Disponenten und Mitarbeiter an und ist relevant für die Routenoptimierung, um sicherzustellen, dass Aufträge mit höherer Priorität zuerst geplant werden."
        ],
        Apply: ['Apply', 'Aplicar', 'Übernehmen'],
        GeolocatingStartedInBackground: [
            "Geolocating started in the background.",
            "Comenzó la geolocalización en segundo plano.",
            "Geolokalisierung wurde im Hintergrund gestartet.",
        ],
        Radius: [
            'Radius',
            'Radio',
            'Radius',
        ],
        Sort: [
            "Sort",
            "Ordenar",
            "Sortieren",
        ],
        Stop: [
            "Stop",
            "Parada",
            "Stopp",
        ],
        Stops: [
            "Stops",
            "Paradas",
            "Stopps",
        ],
        SelectAssignee: [
            "Select assignee",
            "Seleccionar asignado",
            "Zuständige Person auswählen",
        ],
        CreateJobRoute: [
            'Create job route',
            'Crear ruta con tareas',
            'Auftragsroute erstellen',
        ],
        Places: ['Places', 'Lugares', 'Orte'],
        Dates: [
            'Dates',
            'Fechas',
            'Datum',
        ],
        FromXToX: [
            "From {0} to {1}",
            "Desde {0} hasta {1}",
            "Von {0} bis {1}",
        ],
        ByMembers: [
            "By members",
            "Por miembros",
            "Nach Mitgliedern",
        ],
        ByPlaces: [
            "By places",
            "Por lugares",
            "Nach Orten",
        ],
        Format: [
            "Format",
            "Formato",
            "Format",
        ],
        Back: [
            "Back",
            "Regresar",
            "Zurück",
        ],
        Download: [
            'Download',
            'Descargar',
            'Download',
        ],
        Start: [
            'Start',
            'Comenzar',
            'Starten',
        ],
        Remove: ['Remove', 'Quitar', 'Entfernen'],
        LocationServicesOn: ['Location services on', 'Servicios de ubicación activados', 'Standortdienste ein'],
        Mode: [
            'Mode',
            'Modo',
            'Modus',
        ],
        BatterySaveOn: [
            "Battery save mode is ON",
            "El modo de ahorro de batería está encendido",
            "Batteriesparmodus EIN",
        ],
        BatterySaveOnDesc: [
            "Battery save mode reduces location accuracy and update frequency, which may prevent proper route recording.",
            "El modo de ahorro de batería reduce la precisión de la ubicación y la frecuencia de actualización, lo que puede impedir un registro adecuado de la ruta.",
            "Der Batteriesparmodus verringert die Standortgenauigkeit und die Aktualisierungsfrequenz, was die ordnungsgemäße Aufzeichnung der Route verhindern kann.",
        ],
        BatterySaveOff: [
            "Battery save mode is OFF",
            "El modo de ahorro de batería está apagado",
            "Batteriesparmodus AUS",
        ],
        TrackRecordingOff: [
            "Trip recording is OFF",
            "La grabación de viajes está desactivada",
            "Fahrtenaufzeichnung ist AUS",
        ],
        TrackRecordingOn: [
            "Trip recording is ON",
            "La grabación de viajes está activada",
            "Fahrtenaufzeichnung ist EIN",
        ],
        GpsStationaryOff: [
            "Locating is OFF while stationary",
            "La localización está apagada mientras está parado",
            "Ortung ist im Stillstand AUS",
        ],
        GpsStationaryOn: [
            "Locating is ON while stationary",
            "La localización está encendida mientras está parado",
            "Ortung ist im Stillstand EIN",
        ],
        OpenProfile: [
            "Open profile",
            "Abrir perfil",
            "Profil öffnen",
        ],
        OpenDispatch: [
            "Open Dispatch",
            "Abrir despacho",
            "Disposition öffnen",
        ],
        OpenLocationHistory: [
            "Open location history",
            "Abrir historial de ubicaciones",
            "Standortverlauf öffnen",
        ],
        AddToBoard: [
            "Add to board",
            "Agregar al tablero",
            "Zum Board hinzufügen",
        ],
        Board: ["Board", "Tablero", "Board"],
        CurrentlyActive: [
            "Currently active",
            "Actualmente activo",
            "Aktuell aktiv",
        ],
        InService: [
            "In service",
            "En servicio",
            "Im Dienst",
        ],
        CurrentlyInService: [
            "Currently in service",
            "Actualmente en servicio",
            "Aktuell im Dienst",
        ],
        Select: [
            'Select',
            'Seleccionar',
            'Auswählen',
        ],
        Unselect: [
            "Unselect",
            "Deseleccionar",
            "Abwählen",
        ],
        Integrations: [
            'API & Integrations',
            'API & Integraciones',
            'API & Integrationen',
        ],
        Timesheet: [
            'Timesheet',
            'Hoja de tiempo',
            'Zeiterfassung',
        ],
        Dashboard: [
            "Dashboard",
            "Panel",
            "Dashboard",
        ],
        Zones: [
            "Zones",
            "Zonas",
            "Zonen",
        ],
        Reports: [
            'Reports',
            'Informes',
            'Berichte',
        ],
        Timeline: [
            'Timeline',
            'Línea de tiempo',
            'Timeline',
        ],
        TripsAndStops: ["Trips and stops", "Viajes y paradas", "Fahrten und Stopps"],
        Dispatch: ['Dispatch', 'Despacho', 'Disposition'],
        AllJobs: [
            'List of all jobs',
            'Lista de todas las tareas',
            'Liste aller Aufträge',
        ],
        SearchMember: [
            'Search member',
            'Buscar miembro',
            'Mitglied suchen',
        ],
        NoEmail: ['Without email', 'Sin correo electrónico', 'Ohne E-Mail'],
        UsernameTooShort: [
            "A username needs at least 6 characters",
            "El nombre de usuario debe tener al menos 6 caracteres",
            "Ein Nutzername braucht mindestens 6 Zeichen",
        ],
        UsernameCharacters: [
            "A username can only use letters a–z, digits and _ @ . - +",
            "El nombre de usuario solo admite letras a–z, números y _ @ . - +",
            "Im Nutzernamen sind nur Buchstaben a–z, Ziffern und _ @ . - + erlaubt",
        ],
        XNotified: [
            "{0} notified",
            "{0} notificado",
            "{0} benachrichtigt",
        ],
        SuccessfullyLoadedTo: [
            "successfully loaded to",
            "cargado con éxito a",
            "erfolgreich geladen für",
        ],
        NewJobForXonX: [
            "New job for {0} on {1}",
            "Nueva tarea para {0} en {1}",
            "Neuer Auftrag für {0} am {1}",
        ],
        EditRegion: [
            "Edit region",
            "Editar región",
            "Region bearbeiten",
        ],
        DoneEditingRegion: [
            "Done editing",
            "Hecho",
            "Fertig",
        ],
        AssignToTeams: [
            'Assign to team',
            'Asignar a un equipo',
            'Einem Team zuweisen',
        ],
        AssignToMembers: [
            'Assign to member',
            'Asignar a un miembro',
            'Einem Mitglied zuweisen',
        ],
        RecentSubmissions: [
            'Recent submissions',
            'Envíos recientes',
            'Aktuelle Einsendungen',
        ],
        Questions: [
            'Questions',
            'Preguntas',
            'Fragen',
        ],
        IncorrectCode: [
            "Incorrect code",
            "Código incorrecto",
            "Falscher Code",
        ],
        WelcomeBack: [
            "Welcome back",
            "Bienvenido de nuevo",
            "Willkommen zurück",
        ],
        LogIntoHellotracks: [
            "Log in to the Hellotracks web dashboard",
            "Iniciar sesión en el panel web de Hellotracks",
            "Im Web-Dashboard anmelden",
        ],
        RequestPasswordReset: [
            "Request password reset",
            "Recupera tu contraseña",
            "Passwort zurücksetzen",
        ],
        RequestPasswordResetLink: [
            "Request a password reset link",
            "Solicitar un enlace para restablecer tu contraseña",
            "Link zum Zurücksetzen des Passworts anfordern",
        ],
        UsernameOrEmail: [
            "Username or email",
            "Nombre de usuario o correo",
            "Nutzername oder E-Mail",
        ],
        YourPassword: [
            "your password",
            "tu contraseña",
            "dein Passwort",
        ],
        Login: [
            "Log in",
            "Iniciar sesión",
            "Anmelden",
        ],
        ForgotPassword: [
            'Forgot password?',
            '¿Olvidaste tu contraseña?',
            'Passwort vergessen?',
        ],
        BackToLogin: [
            "Back to login",
            "Volver al inicio de sesión",
            "Zurück zur Anmeldung",
        ],
        Signup: [
            'Sign up',
            'Registrarse',
            'Registrieren',
        ],
        DontHaveAnAccountYet: [
            "Don't have an account yet?",
            '¿No tienes cuenta aún?',
            'Noch kein Konto angelegt?',
        ],
        CompanySettings: [
            'Company settings',
            'Configuración de la empresa',
            'Unternehmenseinstellungen',
        ],
        UseMobileVersion: ["Use the mobile version", "Usar la versión móvil", "Mobile Version nutzen"],
        MySettings: [
            "My settings",
            "Mi configuración",
            "Meine Einstellungen",
        ],
        LowPriority: [
            "Low priority",
            "Prioridad baja",
            "Niedrige Priorität",
        ],
        NormalPriority: [
            "Normal priority",
            "Prioridad normal",
            "Normale Priorität",
        ],
        HighPriority: [
            "High priority",
            "Prioridad alta",
            "Hohe Priorität",
        ],
        LoggedIn: ["Logged in", "Sesión iniciada", "Angemeldet"],
        ActiveSwitchOn: [
            "Active (Switch is ON)",
            "Activo (Interruptor encendido)",
            "Aktiv (Schalter ist EIN)",
        ],
        ServiceSwithOff: [
            "Not in service (Switch is OFF)",
            "Fuera de servicio (Interruptor apagado)",
            "Nicht im Dienst (Schalter ist AUS)",
        ],
        LocationPermissionGranted: [
            "Location permission granted",
            "Permiso de ubicación otorgado",
            "Standorterlaubnis erteilt",
        ],
        LocationPermissionDenied: [
            "Location permission denied",
            "Permiso de ubicación denegado",
            "Standorterlaubnis verweigert",
        ],
        BackgroundLocationOn: [
            "Background location allowed",
            "Ubicación en segundo plano permitida",
            "Hintergrund-Standort erlaubt",
        ],
        BackgroundLocationOff: [
            "Background location off",
            "Ubicación en segundo plano desactivada",
            "Hintergrund-Standort aus",
        ],
        BackgroundLocationOffDesc: [
            "The app can only access location while open on screen, so trips are not recorded. On the phone, set location access for Hellotracks to \"Always\" (iPhone: Settings → Privacy & Security → Location Services) or \"Allow all the time\" (Android: Settings → Apps → Hellotracks → Permissions → Location).",
            "La app solo puede acceder a la ubicación mientras está abierta en pantalla, por lo que no se registran los viajes. En el teléfono, configura el acceso a la ubicación de Hellotracks en \"Siempre\" (iPhone: Configuración → Privacidad y seguridad → Localización) o \"Permitir siempre\" (Android: Configuración → Aplicaciones → Hellotracks → Permisos → Ubicación).",
            "Die App kann nur auf den Standort zugreifen, während sie geöffnet ist – Fahrten werden daher nicht aufgezeichnet. Stelle den Standortzugriff für Hellotracks am Telefon auf \"Immer\" (iPhone: Einstellungen → Datenschutz & Sicherheit → Ortungsdienste) bzw. \"Immer zulassen\" (Android: Einstellungen → Apps → Hellotracks → Berechtigungen → Standort).",
        ],
        Messages: [
            'Messages',
            'Mensajes',
            'Nachrichten',
        ],
        Here: ["Here", "Aquí", "Hier"],
        Uploads: ["Uploads", "Cargas", "Uploads"],
        Photos: ["Photos", "Fotos", "Fotos"],
        UploadedImages: ["Uploaded images", "Imágenes cargadas", "Hochgeladene Bilder"],
        PhotoTaken: ["Taken", "Tomada", "Aufgenommen"],
        PhotoUploaded: ["Uploaded", "Subida", "Hochgeladen"],
        JobsAssigned: ["Jobs assigned", "Tareas asignadas", "Aufträge zugewiesen"],
        Continue: [
            'Continue',
            'Continuar',
            'Weiter',
        ],
        Today: ["Today", "Hoy", "Heute"],
        LastLocation: ["Last location", "Última ubicación", "Letzter Standort"],
        OnDuty: [
            "On duty",
            "De servicio",
            "Im Dienst",
        ],
        Jobs: [
            "Jobs",
            "Tareas",
            "Aufträge",
        ],
        Tracks: [
            "Trips",
            "Viajes",
            "Fahrten",
        ],
        Invited: ["Invited", "Invitado", "Eingeladen"],
        FilterByTeam: ["Filter by team", "Filtrar por equipo", "Nach Team filtern"],
        Recurring: ["Recurring", "Recurrente", "Wiederkehrend"],
        Daily: ["Daily", "Diario", "Täglich"],
        Weekly: ["Weekly", "Semanal", "Wöchentlich"],
        Notifying: ["Notifying", "Notificación", "Benachrichtigung"],
        ReallyDelete: ["Delete this?", "¿Eliminar esto?", "Wirklich löschen?"],
        Active: ["Active", "Activo", "Aktiv"],
        Paused: ["Paused", "Pausado", "Pausiert"],
        Close: ['Close', 'Cerrar', 'Schließen'],
        Cancelled: ["Canceled", "Cancelado", "Abgebrochen"],
        EnterInitials: ["Enter initials", "Ingresar iniciales", "Initialen eingeben"],
        Max6Chars: ["max 6 chars", "máx. 6 caracteres", "max. 6 Zeichen"],
        OrCreateWithText: ["or create with text", "o crear con texto", "oder mit Text erstellen"],
        StopBetweenTracks: ["Stationary", "Inmóvil", "Stillstand"],
        StopIdling: ["Stationary", "Inmóvil", "Stillstand"],
        StopAtPlace: ["At place", "En el lugar", "an einem Ort"],
        ShowStopsAtPlaces: ["Show stops at places", "Mostrar paradas en lugares", "Stopps an Orten anzeigen"],
        ShowStopsAtJobs: ["Show stops at jobs", "Mostrar paradas en tareas", "Stopps bei Aufträgen anzeigen"],
        ShowStopsIdling: ["Show stationary stops", "Mostrar paradas inmóviles", "Stopps im Stillstand anzeigen"],
        ArrivedAtPlace: ["Arrived at place", "Llegó al lugar", "Ort erreicht"],
        LeftPlace: ["Left place", "Salió del lugar", "Ort verlassen"],
        TimeSlider: ["Time slider", "Deslizador de tiempo", "Zeitschieberegler"],
        StopAtJob: ["At job", "En tarea", "bei Auftrag"],
        Snooze: ["Snooze", "Silenciar", "Pausieren"],
        SnoozeNotifications: [
            "Snooze notifications",
            "Silenciar notificaciones",
            "Benachrichtigungen pausieren"
        ],
        FrequentLiveNotificationsDesc: [
            "To avoid distraction, live notifications are temporarily silenced.",
            "Para evitar distracción, las notificaciones en vivo están temporalmente en silencio.",
            "Um Ablenkung zu vermeiden, sind die Live-Benachrichtigungen vorübergehend stummgeschaltet.",
        ],
        EnterPasswordConfirm: [
            "Enter your password to confirm",
            "Ingresa tu contraseña para confirmar",
            "Gib zur Bestätigung dein Passwort ein",
        ],
        ConfirmToProceed: [
            "Confirm to proceed",
            "Confirmar para proceder",
            "Bestätigen, um fortzufahren",
        ],
        EditTeamName: [
            "Edit team name",
            "Editar el nombre del equipo",
            "Teamname bearbeiten",
        ],
        TeamRoutingSettings: [
            "Team routing",
            "Enrutamiento del equipo",
            "Team-Routing",
        ],
        DeleteTeam: [
            "Delete team",
            "Borrar equipo",
            "Team löschen",
        ],
        NewEntry: [
            "New entry",
            "Nuevo registro",
            "Neuer Eintrag",
        ],
        Info: [
            "Info",
            "Información",
            "Info",
        ],
        Actions: [
            'Actions',
            'Acciones',
            'Aktionen',
        ],
        Location: ['Location', 'Ubicación', 'Standort'],
        LocationHistory: ['Location history', "Historial de ubicaciones", "Standortverlauf"],
        ProvidedByHTAndX: [
            "Provided by <a href='{0}' target='_blank' rel='noopener noreferrer'>Hellotracks</a> and {1}",
            "Proporcionado por <a href='{0}' target='_blank' rel='noopener noreferrer'>Hellotracks</a> y {1}",
            "Zur Verfügung gestellt von <a href='{0}' target='_blank' rel='noopener noreferrer'>Hellotracks</a> und {1}",
        ],
        JobNotFound: [
            "Job not found",
            "Tarea no encontrada",
            "Auftrag nicht gefunden",
        ],
        ShowPrintableVersion: [
            "Show printable and sharable version",
            "Mostrar versión para imprimir o compartir",
            "Version zum Ausdrucken oder Teilen anzeigen"
        ],
        OpenDetails: [
            'Open details',
            'Abrir detalles',
            'Details öffnen',
        ],
        Distance: [
            'Distance',
            'Distancia',
            'Distanz',
        ],
        Speed: [
            'Speed',
            'Velocidad',
            'Geschwindigkeit',
        ],
        GPS: [
            'GPS',
            'GPS',
            'GPS',
        ],
        CreateURLToShareThisTrack: [
            'Create URL to share this trip',
            'Crear URL para compartir este viaje',
            'URL erstellen, um diese Fahrt zu teilen',
        ],
        ReallyDeleteThisTrack: [
            'Really delete this trip permanently?',
            '¿Seguro que quieres borrar este viaje definitivamente?',
            'Fahrt wirklich dauerhaft löschen?',
        ],
        Track: [
            "Trip",
            "Viaje",
            "Fahrt",
        ],
        ManualTrip: ["Manual trip", "Viaje manual", "Manuelle Fahrt"],
        TrackInfo: [
            "Trip info",
            "Información del viaje",
            "Fahrt-Info",
        ],
        DownloadAsGPXFile: [
            'Download as GPX file',
            'Descargar como archivo GPX',
            'Download als GPX-Datei',
        ],
        Share: [
            'Share',
            'Compartir',
            'Teilen',
        ],
        TrackNotFound: [
            "Trip not found",
            "Viaje no encontrado",
            "Fahrt nicht gefunden",
        ],
        OpenLink: [
            "Open link",
            "Abrir enlace",
            "Link öffnen",
        ],
        DownloadAppDescription: [
            "Everyone you want to see on the map needs to download and install the Hellotracks mobile app.",
            "Todos los usuarios que deseas ver en el mapa deben descargar e instalar la aplicación móvil de Hellotracks.",
            "Um alle Benutzer auf der Karte zu sehen, müssen diese die mobile Hellotracks-App herunterladen und installieren.",
        ],
        DesktopAppAvailable: [
            "Desktop app available",
            "Aplicación de escritorio disponible",
            "Desktop-App verfügbar",
        ],
        DesktopAppDescription: [
            "Enjoy a faster, more integrated experience with our native desktop app for {0}.",
            "Disfruta de una experiencia más rápida e integrada con nuestra aplicación de escritorio nativa para {0}.",
            "Genieße eine schnellere, besser integrierte Erfahrung mit unserer nativen Desktop-App für {0}.",
        ],
        DesktopApp: [
            "Desktop app",
            "Aplicación de escritorio",
            "Desktop-App",
        ],
        DesktopAppBenefits: [
            "Experience Hellotracks with a dedicated workspace free from browser distractions, plus enhanced multi-window and multi-monitor support for your {0} system.",
            "Experimenta Hellotracks con un espacio de trabajo dedicado sin distracciones del navegador, además de soporte mejorado para múltiples ventanas y monitores en tu sistema {0}.",
            "Erlebe Hellotracks mit einem dedizierten Arbeitsbereich ohne Browser-Ablenkungen, plus verbesserter Unterstützung für mehrere Fenster und Monitore auf deinem {0}-System.",
        ],
        DontShowAgain: [
            "Don't show again",
            "No mostrar de nuevo",
            "Nicht mehr anzeigen",
        ],
        DownloadForPlatform: [
            "Download for {0}",
            "Descargar para {0}",
            "Download für {0}",
        ],
        ConfigureShortForm: [
            "Form",
            "Formulario",
            "Formular",
        ],
        UserIsAlreadyRegistered: [
            'User already exists.',
            'El usuario ya ha sido registrado.',
            'Der Benutzer ist bereits registriert.',
        ],
        MileageHistory: [
            "Mileage history",
            "Historial de kilometraje",
            "Kilometerverlauf"
        ],
        MileageHistoryDesc: [
            "The mileage history gives you a quick overview of recent driven distances. Each square is a day, darker means more mileage on that day.",
            "El historial de kilometraje brinda una vista rápida de las distancias recorridas recientemente. Cada cuadrado representa un día, cuanto más oscuro, más kilometraje en ese día.",
            "Der Kilometerverlauf gibt einen schnellen Überblick über die kürzlich gefahrenen Strecken. Jedes Quadrat stellt einen Tag dar, dunklere Farben bedeuten mehr Kilometer an diesem Tag.",
        ],
        Import: ["Import", "Importar", "Importieren"],
        Export: ["Export", "Exportar", "Exportieren"],
        DayRoutes: ["Day routes", "Rutas del día", "Tagesrouten"],
        NameIsRequired: [
            "Name is required",
            'El nombre es obligatorio',
            "Name ist erforderlich",
        ],
        EmailIsRequired: [
            "Email is required",
            'El correo electrónico es obligatorio',
            "E-Mail ist erforderlich",
        ],
        InvalidEmail: [
            "Invalid email",
            "Correo electrónico no válido",
            "Ungültige E-Mail-Adresse",
        ],
        Row: [
            'Row',
            'Fila',
            'Zeile',
        ],
        SucceedImport: [
            "Import successful",
            "Importación exitosa",
            "Import erfolgreich",
        ],
        ImportInProgress: [
            "The import is running in the background. Large files may take a while to complete.",
            "La importación se está ejecutando en segundo plano. Los archivos grandes pueden tardar en completarse.",
            "Der Import läuft im Hintergrund. Große Dateien können einige Zeit bis zum Abschluss benötigen."
        ],
        ImportProgress: [
            "Importing rows: {0} of {1}",
            "Importando filas: {0} de {1}",
            "Zeilen werden importiert: {0} von {1}",
        ],
        GeocodingProgress: [
            "Geocoding addresses: {0} of {1}",
            "Geocodificando direcciones: {0} de {1}",
            "Adressen werden geocodiert: {0} von {1}",
        ],
        ImportPreparing: [
            "Preparing import…",
            "Preparando la importación…",
            "Import wird vorbereitet…",
        ],
        ImportStalled: [
            "The import has not made progress for a while. It may have been interrupted — we will keep checking.",
            "La importación no ha avanzado durante un tiempo. Es posible que se haya interrumpido; seguiremos comprobándolo.",
            "Der Import ist seit einiger Zeit nicht vorangekommen. Möglicherweise wurde er unterbrochen – wir prüfen weiter.",
        ],
        DownloadFailedRows: [
            "Download failed rows",
            "Descargar filas fallidas",
            "Fehlgeschlagene Zeilen herunterladen",
        ],
        ImportSummaryNewEntries: [
            "new entries added",
            "entradas nuevas agregadas",
            "neue Einträge hinzugefügt",
        ],
        ImportSummaryUpdated: [
            "Updated",
            "Actualizadas",
            "Aktualisiert",
        ],
        ImportSummaryAlreadyExisted: [
            "Already existed",
            "Ya existían",
            "Bereits vorhanden",
        ],
        ImportSummaryErrors: [
            "Errors",
            "Errores",
            "Fehler",
        ],
        ImportSummaryNothingNew: [
            "All {0} rows already existed — nothing new was added.",
            "Las {0} filas ya existían: no se agregó nada nuevo.",
            "Alle {0} Zeilen waren bereits vorhanden – es wurde nichts Neues hinzugefügt.",
        ],
        ImportSummaryRowsProcessed: [
            "{0} rows processed",
            "{0} filas procesadas",
            "{0} Zeilen verarbeitet",
        ],
        ImportSummaryErrorsTruncated: [
            "The report lists the first {0} errors.",
            "El informe muestra los primeros {0} errores.",
            "Der Bericht enthält die ersten {0} Fehler.",
        ],
        ErrorLabel: [
            "Error",
            "Error",
            "Fehler",
        ],
        LargeImportPreviewHint: [
            "Preview of the first {0} of {1} rows.",
            "Vista previa de las primeras {0} de {1} filas.",
            "Vorschau der ersten {0} von {1} Zeilen.",
        ],
        UnrecognizedColumnsNote: [
            "Columns marked with * don't match a known field and will be imported as custom fields.",
            "Las columnas marcadas con * no coinciden con ningún campo conocido y se importarán como campos personalizados.",
            "Mit * markierte Spalten entsprechen keinem bekannten Feld und werden als benutzerdefinierte Felder importiert.",
        ],
        ImportFailed: [
            "The import failed. No completion was reported.",
            "La importación falló. No se informó su finalización.",
            "Der Import ist fehlgeschlagen. Es wurde kein Abschluss gemeldet.",
        ],
        ImportStatusUnavailable: [
            "The import status is temporarily unavailable. The server may still be processing it.",
            "El estado de la importación no está disponible temporalmente. Es posible que el servidor aún la esté procesando.",
            "Der Importstatus ist vorübergehend nicht verfügbar. Der Server verarbeitet den Import möglicherweise noch.",
        ],
        LargeImportFileDesc: [
            "{1} contains {0} rows and will be uploaded directly for background processing.",
            "{1} contiene {0} filas y se cargará directamente para su procesamiento en segundo plano.",
            "{1} enthält {0} Zeilen und wird direkt zur Verarbeitung im Hintergrund hochgeladen.",
        ],
        PasswordRecovery: [
            'Password recovery',
            'Recuperación de contraseña',
            'Passwort wiederherstellen',
        ],
        NewPassword: [
            'New password',
            'Nueva contraseña',
            'Neues Passwort',
        ],
        NewPasswordsDoNotMatch: [
            'Passwords do not match',
            'Las contraseñas no coinciden.',
            'Passwörter stimmen nicht überein.',
        ],
        NoLocation: [
            "No location set",
            "No se ha establecido la ubicación",
            "Kein Standort festgelegt",
        ],
        NoPermission: [
            'No permission',
            'Sin permiso',
            'Keine Berechtigung',
        ],
        EnterEmail: ["Enter email", "Ingresar correo electrónico", "E-Mail eingeben"],
        EnterPassword: ["Enter password", "Ingresar contraseña", "Passwort eingeben"],
        EnterUsername: ["Enter username", "Ingresar nombre de usuario", "Nutzername eingeben"],
        Unlinked: [
            "None",
            "Ninguna",
            "Keine",
        ],
        ActionWillSaveChanges: [
            "This action will additionally save changes to the current job.",
            "Esta acción guardará adicionalmente los cambios en la tarea actual.",
            "Diese Aktion wird zusätzlich Änderungen am aktuellen Auftrag speichern.",
        ],
        AddToTable: [
            "Add to table",
            "Agregar a la tabla",
            "Zur Tabelle hinzufügen",
        ],
        RemoveFromTable: [
            "Remove from table",
            "Quitar de la tabla",
            "Von Tabelle entfernen",
        ],
        ReallyDeleteSelectedTracks: [
            "Permanently delete the selected trips?",
            "¿Borrar permanentemente los viajes seleccionados?",
            "Ausgewählte Fahrten wirklich dauerhaft löschen?",
        ],
        Reason: [
            "Reason",
            "Motivo",
            "Begründung",
        ],
        Customize: [
            "Customize",
            "Personalizar",
            "Anpassen",
        ],
        Welcome: [
            "Welcome to Hellotracks",
            "Bienvenido a Hellotracks",
            "Willkommen bei Hellotracks",
        ],
        LoginToContinue: [
            "Log in with your account to continue",
            "Inicia sesión con tu cuenta para continuar",
            "Melde dich mit deinem Konto an, um fortzufahren",
        ],
        Unassigned: ['Unassigned', 'Sin asignar', 'Nicht zugewiesen'],
        Update: [
            "Update",
            "Actualizar",
            "Aktualisieren",
        ],
        WelcomeToHellotracksBusiness: [
            'Welcome to Hellotracks Business',
            '¡Bienvenido a Hellotracks Business!',
            'Willkommen bei Hellotracks Business',
        ],
        NowYouAreReadyToInstall: [
            'Now you are ready to install the Hellotracks app on your device and log in.',
            'Ahora puedes instalar la app de Hellotracks en tu dispositivo e iniciar sesión.',
            'Jetzt kannst du die Hellotracks-App auf deinem Gerät installieren und dich anmelden.',
        ],
        GetApp: [
            'Get app',
            'Ir a la página de instalación',
            'Zur Download-Seite',
        ],
        GoToLiveDashboard: [
            'Go to live dashboard',
            'Ir al panel en vivo',
            'Zum Live-Dashboard gehen',
        ],
        NoName: [
            "[no name]",
            "[sin nombre]",
            "[kein Name]",
        ],
        TryBusiness: [
            "Try Business",
            "Prueba la versión Business",
            "Business ausprobieren"
        ],
        TryBusinessDesc: [
            "Discover the power of the Hellotracks Business platform! If you're currently using our free plan without realizing the full potential, you can easily upgrade to a business account and unlock unrestricted access to all our advanced features. Try it free for 30 days and experience the difference!",
            "¡Descubre el poder de la plataforma Hellotracks Business! Si actualmente estás utilizando nuestro plan gratuito sin darte cuenta de todo su potencial, puedes actualizar fácilmente a una cuenta Business y desbloquear acceso ilimitado a todas nuestras funciones avanzadas. ¡Pruébalo gratis durante 30 días y experimenta la diferencia!",
            "Entdecke die Leistungsfähigkeit der Hellotracks Business-Plattform! Wenn du derzeit unseren kostenlosen Plan nutzt, ohne das volle Potenzial zu erkennen, kannst du problemlos auf ein Business-Konto upgraden und uneingeschränkten Zugriff auf alle unsere fortschrittlichen Funktionen erhalten. Probiere es 30 Tage lang kostenlos aus und erlebe den Unterschied!"
        ],
        ResendInvitation: [
            "Resend invitation",
            "Reenviar invitación",
            "Einladung erneut senden",
        ],
        TooManyRows: [
            "Too many rows",
            "Demasiadas filas",
            "Zu viele Zeilen",
        ],
        FieldIsRequired: [
            "This field is required",
            "Este campo es requerido",
            "Dieses Feld ist erforderlich",
        ],
        Submit: [
            "Submit",
            "Enviar",
            "Senden",
        ],
        CheckInternetConnection: [
            "Please check your internet connection and try again.",
            "Revisa tu conexión a internet e inténtalo de nuevo.",
            "Bitte Internetverbindung überprüfen und später nochmals versuchen.",
        ],
        Duplicate: [
            "Duplicate",
            "Duplicar",
            "Duplizieren",
        ],
        Purpose: [
            "Purpose",
            "Propósito",
            "Zweck"
        ],
        Comment: [
            "Comment",
            "Comentario",
            "Kommentar",
        ],
        Cells: [
            "Cells",
            "Celdas",
            "Zellen",
        ],
        HideAllPanels: [
            "Hide all panels to have a better view of the map.",
            "Oculta todos los paneles para tener una mejor vista del mapa.",
            "Verstecke alle Bedienfelder, um eine bessere Sicht auf die Karte zu haben."
        ],
        SingleSignOn: [
            "Single Sign-On (SSO)",
            "Single Sign-On (SSO)",
            "Single Sign-On (SSO)",
        ],
        ManualCheck: [
            "Manual",
            "Manual",
            "Manuell"
        ],
        EmailAsUsername: [
            "Email as username",
            "Correo electrónico como nombre de usuario",
            "E-Mail als Nutzername"
        ],
        SetIndividualUsername: [
            "Set individual username",
            "Establecer nombre de usuario individual",
            "Individuellen Nutzernamen festlegen"
        ],
        PasswordTooCommon: [
            "Password is too common and not secure",
            "La contraseña es demasiado común y no es segura",
            "Das Passwort ist zu gängig und nicht sicher",
        ],
        LastXDays: ['{0}d', '{0} días', '{0} Tage'],
        LastXMonths: ['{0}mo', '{0} mes.', '{0} Mon.'],
        Custom: ["Custom", "Personalizado", "Benutzerdef."],
        PinMenu: [
            "Pin menu",
            "Fijar menú",
            "Menü anheften"
        ],
        UnpinMenu: [
            "Unpin menu",
            "Desfijar menú",
            "Menü lösen",
        ],
        Conditional: [
            "Conditional",
            "Condicional",
            "Bedingung",
        ],
        Show: [
            "Show",
            "Mostrar",
            "Anzeigen",
        ],
        PDFUpload: ['Upload PDF', 'Subir PDF', 'PDF hochladen'],
        OnlyAllowedForBusiness: [
            "This is enabled only for Business",
            "Esto está habilitado solo para Business",
            "Dies ist nur für Business aktiviert",
        ],
        ConfirmPinToProceed: [
            "Do you wish to proceed? Please confirm by entering the following pin code.",
            "¿Deseas continuar? Por favor, confirma ingresando el código pin siguiente.",
            "Möchtest du fortfahren? Bitte bestätige, indem du die folgende PIN eingibst."
        ],
        NothingPinnedYet: [
            "Nothing pinned yet",
            "Nada fijado aún",
            "Noch nichts angeheftet",
        ],
        ViaX: [
            "via {0}",
            "a través de {0}",
            "über {0}",
        ],
        ViaTemplateX: [
            "via template “{0}”",
            "a través de la plantilla “{0}”",
            "über Vorlage „{0}“",
        ],
        ViaRecurringRouteX: [
            "via recurring route “{0}”",
            "a través de la ruta recurrente “{0}”",
            "über wiederkehrende Route „{0}“",
        ],
        EnterName: [
            "Enter name",
            "Ingresar nombre",
            "Name eingeben"
        ],
        AcceptAll: [
            "Accept all",
            "Aceptar todos",
            "Alle akzeptieren",
        ],
        Table: ["Table", "Tabla", "Tabelle"],
        List: ["List", "Lista", "Liste"],
        Week: ["Week", "Semana", "Woche"],
        Calendar: ["Calendar", "Calendario", "Kalender"],
        YouCanDragMe: [
            "You can drag me",
            "Puedes arrastrarme",
            "Du kannst mich verschieben",
        ]
    },
    Settings: {
        TimezoneMismatchDesc: [
            "Browser timezone doesn't match your user's saved timezone.",
            "La zona horaria del navegador no coincide con la zona horaria guardada de tu usuario.",
            "Die Zeitzone des Browsers stimmt nicht mit der gespeicherten Zeitzone deines Benutzers überein.",
        ],
        TimezoneMismatchUseBrowser: [
            "Update to browser timezone",
            "Actualizar a la zona horaria del navegador",
            "Auf die Zeitzone des Browsers aktualisieren",
        ],
        TimezoneMismatchKeepUser: [
            "Keep user's saved timezone",
            "Mantener la zona horaria guardada del usuario",
            "Die gespeicherte Zeitzone des Benutzers beibehalten",
        ],
        TimeFormatMismatchDesc: [
            "Browser time format doesn't match your user's language",
            "El formato de hora del navegador no coincide con el idioma de tu usuario",
            "Das Zeitformat des Browsers stimmt nicht mit der Sprache deines Benutzers überein",
        ],
        TimeFormatMismatchUseBrowser: [
            "Update to browser time format",
            "Actualizar al formato de hora del navegador",
            "Auf das Zeitformat des Browsers aktualisieren",
        ],
        TimeFormatMismatchKeepUser: [
            "Keep existing time format",
            "Mantener el formato de hora actual",
            "Das vorhandene Zeitformat beibehalten",
        ],
        DistanceFormatMismatchDesc: [
            "Browser distance format doesn't match your user's language",
            "El formato de distancia del navegador no coincide con el idioma de tu usuario",
            "Das Distanzformat des Browsers stimmt nicht mit der Sprache deines Benutzers überein",
        ],
        DistanceFormatMismatchUseBrowser: [
            "Update to browser distance format",
            "Actualizar al formato de distancia del navegador",
            "Auf das Distanzformat des Browsers aktualisieren",
        ],
        DistanceFormatMismatchKeepUser: [
            "Keep existing distance format",
            "Mantener el formato de distancia actual",
            "Das vorhandene Distanzformat beibehalten",
        ],
        LanguageMismatchDesc: [
            "Browser language doesn't match your user's language",
            "El idioma del navegador no coincide con el idioma de tu usuario",
            "Die Sprache des Browsers stimmt nicht mit der Sprache deines Benutzers überein",
        ],
        LanguageMismatchUseBrowser: [
            "Update to browser language",
            "Actualizar al idioma del navegador",
            "Auf die Sprache des Browsers aktualisieren",
        ],
        LanguageMismatchKeepUser: [
            "Keep user's language",
            "Mantener el idioma del usuario",
            "Die Sprache des Benutzers beibehalten",
        ],
    },
    Menu: {
        LiveMapDesc: [
            "Your whole team in real-time",
            "Todo tu equipo en tiempo real",
            "Das gesamte Team in Echtzeit",
        ],
        TracksDesc: [
            "All driven routes in one list",
            "Todas las rutas recorridas en una lista",
            "Alle gefahrenen Routen in einer Liste",
        ],
        AllJobsDesc: [
            "Manage all your jobs in one table",
            "Gestiona todas tus tareas en una tabla",
            "Verwalte alle Aufträge in einer Tabelle",
        ],
        DispatchDesc: [
            "Schedule and assign jobs",
            "Programar y asignar tareas",
            "Aufträge planen und zuweisen",
        ],
        FormsAndDataInputDesc: [
            "Retrieve data from your team in the field",
            "Recupera datos de tu equipo en el campo",
            "Daten von deinem Team vor Ort abrufen",
        ],
        HeatmapDesc: [
            "Visualize movement over a longer time period",
            "Visualiza el movimiento durante un periodo de tiempo más largo",
            "Bewegung über eine längere Zeitspanne visualisieren",
        ],
        UploadsDesc: [
            "View uploaded pictures from jobs",
            "Ver fotos subidas de tareas",
            "Hochgeladene Bilder von Aufträgen anzeigen",
        ],
        TeamDesc: [
            "Manage and organize your team",
            "Gestiona y organiza tu equipo",
            "Verwalte und organisiere dein Team",
        ],
        PlacesDesc: [
            "Create and manage geofences: Places and Zones",
            "Crea y gestiona geocercas: lugares y zonas",
            "Erstelle und verwalte Geofences: Orte und Zonen",
        ],
        AlertsDesc: [
            "Get notifications and alerts for important events",
            "Recibe notificaciones y alertas para eventos importantes",
            "Erhalte Benachrichtigungen und Warnungen für wichtige Ereignisse",
        ],
        DashboardDesc: [
            "Get an overview of your team's activities",
            "Obtén una visión general de las actividades de tu equipo",
            "Erhalte einen Überblick über die Aktivitäten deines Teams",
        ],
        ReportsDesc: [
            "Generate reports and analyze your team's data",
            "Genera informes y analiza los datos de tu equipo",
            "Erstelle Berichte und analysiere die Daten deines Teams",
        ],
        TimesheetDesc: [
            "Monitor clock-ins and clock-outs of mobile staff",
            "Controla los registros de entrada y salida del personal móvil",
            "Ein- und Ausstempelzeiten von mobilen Mitarbeitern überwachen",
        ],
        SettingsDesc: [
            "Configure your account settings",
            "Ajusta la configuración de tu cuenta",
            "Kontoeinstellungen konfigurieren",
        ],
        HelpCenterDesc: [
            "Get support and assistance",
            "Obtén soporte y ayuda",
            "Unterstützung und Hilfe erhalten",
        ],
    },
    Help: {
        Help: ['Help', 'Ayuda', 'Hilfe'],
        Title: ['Help center', 'Centro de ayuda', 'Hilfe-Center'],
        Url: [
            "https://help-docs.hellotracks.com",
            "https://help-docs-spanish.hellotracks.com",
            "https://help-docs-german.hellotracks.com",
        ],
        Beacon: [
            "3a9a0701-e62a-4f9d-ac93-19c4293119de",
            "e8dada15-8df3-4e83-8b1f-38a12d80afc5",
            "76c51b20-1ad4-4aa4-a7e5-ef5988eba4b2",
        ],
    },
    Dispatch: {
        NoRoute: ["no route", "sin ruta", "keine Route"],
        RouteOutOfDateHintShort: [
            "The route we have was calculated for a different set of jobs. Selecting this member refreshes it.",
            "La ruta que tenemos se calculó para otro conjunto de tareas. Al seleccionar a este miembro se actualiza.",
            "Die vorhandene Route wurde für andere Aufträge berechnet. Beim Auswählen des Mitglieds wird sie erneuert.",
        ],
        Projected: ["projected", "previsto", "voraussichtlich"],
        // "late" belongs to Routing.BehindPlan, which measures against the route's
        // own ETA. This one measures against the customer's window — a different
        // reference, and the two sit next to each other in the route panel.
        JobPastWindow: ["{0} past window", "{0} tras la ventana", "{0} nach Zeitfenster"],
        JobSince: ["since {0}", "desde {0}", "seit {0}"],
        JobMore: ["+{0} more", "+{0} más", "+{0} weitere"],
        LaneDone: ["{0} done", "{0} hechas", "{0} fertig"],
        LaneIssue: ["{0} issue", "{0} problema", "{0} Problem"],
        LaneIssues: ["{0} issues", "{0} problemas", "{0} Probleme"],
        LaneLeft: ["{0} left", "{0} restantes", "{0} offen"],
        LaneOnSite: ["on site", "en el lugar", "vor Ort"],
        // the ruler's presets: which hours the lanes show
        LaneAroundNow: ["Around now", "Ahora", "Jetzt"],
        LaneWorkingHours: ["Working hours", "Horario laboral", "Arbeitszeit"],
        LaneWholeDay: ["Whole day", "Todo el día", "Ganzer Tag"],
        LaneWindowDrag: [
            "Drag to move. Pull the edges to see more or fewer hours.",
            "Arrastra para mover. Tira de los bordes para ver más o menos horas.",
            "Zieh, um zu verschieben. Zieh an den Rändern für mehr oder weniger Stunden.",
        ],
        LaneWindowOutside: [
            "Work outside these hours is counted at the ends of each lane.",
            "El trabajo fuera de estas horas se cuenta en los extremos de cada carril.",
            "Arbeit außerhalb dieser Stunden wird an den Enden jeder Zeile gezählt.",
        ],
        LaneWindowFollows: [
            "Moves along with the clock until you drag it.",
            "Avanza con el reloj hasta que lo arrastres.",
            "Wandert mit der Uhr mit, bis du es verschiebst.",
        ],
        LaneWindowAria: [
            "Hours shown in the lanes. Arrow keys move, plus and minus zoom, Home shows the whole day.",
            "Horas mostradas en los carriles. Las flechas mueven, más y menos acercan, Inicio muestra todo el día.",
            "In den Zeilen gezeigte Stunden. Pfeiltasten verschieben, Plus und Minus zoomen, Pos1 zeigt den ganzen Tag.",
        ],
        LaneHours: ["{0} hours", "{0} horas", "{0} Stunden"],
        RouteNotLoadedHint: [
            "No route for this day has been loaded yet.",
            "Aún no se ha cargado ninguna ruta para este día.",
            "Für diesen Tag wurde noch keine Route geladen.",
        ],
        EndsNextDay: [
            "Finishes after {0} jobs, the following day",
            "Termina tras {0} tareas, al día siguiente",
            "Fertig nach {0} Aufträgen, am Folgetag",
        ],
        // Name the hour, not the frame. "Falls outside the shown time range"
        // describes our rendering, so it reads as a limitation of the tool;
        // "5 jobs after 8 PM" is a fact about the member's day.
        JobsAfterTime: ["{0} jobs after {1}", "{0} tareas después de {1}", "{0} Aufträge nach {1}"],
        JobAfterTime: ["1 job after {0}", "1 tarea después de {0}", "1 Auftrag nach {0}"],
        JobsBeforeTime: ["{0} jobs before {1}", "{0} tareas antes de {1}", "{0} Aufträge vor {1}"],
        JobBeforeTime: ["1 job before {0}", "1 tarea antes de {0}", "1 Auftrag vor {0}"],
        RouteNotCalculated: [
            "No route calculated for this day, so job times are unknown.",
            "No hay ruta calculada para este día, así que se desconocen los horarios.",
            "Für diesen Tag ist keine Route berechnet, daher sind die Zeiten unbekannt.",
        ],
        EndsAt: ["Finishes after {0} jobs", "Termina tras {0} tareas", "Fertig nach {0} Aufträgen"],
        EndsAfterShift: [
            "Finishes after {0} jobs — past the end of the shift",
            "Termina tras {0} tareas — después del fin de turno",
            "Fertig nach {0} Aufträgen — nach Schichtende",
        ],
        JobsDescription: [
            "Jobs are tasks or assignments that can be dispatched to team members, typically involving activities at specific locations such as deliveries, service visits, or inspections. Jobs can include details like instructions, deadlines, and associated forms, helping teams efficiently manage, track, and report their field activities.",
            "Las tareas son actividades o asignaciones que pueden enviarse a los miembros del equipo, generalmente implican acciones en lugares específicos como entregas, visitas de servicio o inspecciones. Las tareas pueden incluir detalles como instrucciones, fechas límite y formularios asociados, lo que permite al equipo gestionar, seguir e informar eficientemente sobre sus actividades en campo.",
            "Aufträge sind Aufgaben oder Einsätze, die an Teammitglieder disponiert werden können und typischerweise Tätigkeiten an bestimmten Orten umfassen, wie Lieferungen, Servicebesuche oder Inspektionen. Aufträge können Details wie Anweisungen, Fristen und verknüpfte Formulare enthalten, wodurch Teams ihre Außeneinsätze effizient verwalten, verfolgen und dokumentieren können.",
        ],
        ShowAvatarsOnly: ["Show avatars only", "Mostrar solo avatares", "Nur Avatare zeigen"],
        ShowFullList: ["Show the full list", "Mostrar la lista completa", "Ganze Liste zeigen"],
        StopLate: ["{0} late", "{0} tarde", "{0} zu spät"],
        StopReschedule: ["Reschedule?", "¿Reprogramar?", "Neuer Termin?"],
        FindAssignee: ["Find assignee", "Buscar asignado", "Zuweisung aussuchen"],
        SuggestedAssigneeX: ["Suggested: {0}", "Sugerencia: {0}", "Vorschlag: {0}"],
        ImportJobs: ["Import jobs", "Importar tareas", "Aufträge importieren"],
        All: ["All", "Todas", "Alle"],
        AllJobs: ["All jobs", "Todas las tareas", "Alle Aufträge"],
        SwitchActiveArchived: ["Active/Archived jobs", "Tareas activas/archivadas", "Aktive/archivierte Aufträge"],
        SwitchedToArchivedJobs: [
            "Switched to archived jobs",
            "Cambiado a tareas archivadas",
            "Zu archivierten Aufträgen gewechselt",
        ],
        SwitchedToActiveJobs: [
            "Switched to active jobs",
            "Cambiado a tareas activas",
            "Zu aktiven Aufträgen gewechselt",
        ],
        PinJob: ["Pin job", "Fijar tarea", "Auftrag anheften"],
        Unpin: ["Unpin", "Desfijar", "Lösen"],
        AllUnassigned: [
            "All",
            "Todas",
            "Alle"
        ],
        Calculate: [
            '<strong>Calculate:</strong><p>Calculate route times and distances.</p>',
            '<strong>Calcular:</strong><p>Calcular tiempos de ruta y distancias.</p>',
            '<strong>Berechnen:</strong><p>Routenzeiten und Entfernungen berechnen.</p>',
        ],
        EditXJobs: ['Edit {0} jobs', 'Editar {0} tareas', '{0} Aufträge bearbeiten'],
        ExportOneJob: ["Export 1 job", "Exportar 1 tarea", "1 Auftrag exportieren"],
        ExportXJobs: ["Export {0} jobs", "Exportar {0} tareas", "{0} Aufträge exportieren"],
        ExportOneImage: ["Export 1 image", "Exportar 1 imagen", "1 Bild exportieren"],
        ExportXImages: ["Export {0} images", "Exportar {0} imágenes", "{0} Bilder exportieren"],
        More: ['See more options', 'Ver más opciones', 'Mehr Optionen sehen'],
        InsertNewJob: [
            "Insert new job",
            "Insertar nueva tarea",
            "Neuen Auftrag einfügen"
        ],
        Groups: [
            "Groups",
            "Grupos",
            "Gruppen",
        ],
        JobGroup: [
            "Job group",
            "Grupo de tareas",
            "Auftragsgruppe",
        ],
        JobGroups: [
            "Job groups",
            "Grupos de tareas",
            "Auftragsgruppen",
        ],
        NewJobGroup: [
            "New job group",
            "Nuevo grupo de tareas",
            "Neue Auftragsgruppe",
        ],
        EditJobGroup: [
            "Edit job group",
            "Editar grupo de tareas",
            "Auftragsgruppe bearbeiten",
        ],
        JobGroupTitlePlaceholder: [
            "Group title",
            "Título del grupo",
            "Gruppentitel",
        ],
        JobGroupReference: [
            "Reference",
            "Referencia",
            "Referenz",
        ],
        JobGroupReferencePlaceholder: [
            "e.g. case number",
            "p. ej. número de caso",
            "z. B. Fallnummer",
        ],
        JobGroupNotesPlaceholder: [
            "Internal notes for this group",
            "Notas internas para este grupo",
            "Interne Notizen für diese Gruppe",
        ],
        JobGroupCompleted: [
            "Completed",
            "Completado",
            "Abgeschlossen",
        ],
        JobGroupJobs: [
            "Jobs",
            "Tareas",
            "Aufträge",
        ],
        JobGroupJobTitlePlaceholder: [
            "Job title",
            "Título de la tarea",
            "Auftragstitel",
        ],
        JobGroupAddJob: [
            "Add job",
            "Agregar tarea",
            "Auftrag hinzufügen",
        ],
        JobGroupOneJobToLink: [
            "1 job to link",
            "1 tarea para vincular",
            "1 Auftrag zum Verknüpfen",
        ],
        JobGroupXJobsToLink: [
            "{0} jobs to link",
            "{0} tareas para vincular",
            "{0} Aufträge zum Verknüpfen",
        ],
        JobGroupLinkedJobs: [
            "Linked jobs",
            "Tareas vinculadas",
            "Verknüpfte Aufträge",
        ],
        JobGroupNoLinkedJobs: [
            "No linked jobs yet.",
            "Todavía no hay tareas vinculadas.",
            "Noch keine verknüpften Aufträge.",
        ],
        JobGroupSelectTitle: [
            "Select job group",
            "Seleccionar grupo de tareas",
            "Auftragsgruppe auswählen",
        ],
        JobGroupSearchPlaceholder: [
            "Search by title or reference",
            "Buscar por título o referencia",
            "Nach Titel oder Referenz suchen",
        ],
        JobGroupNoMatching: [
            "No matching job groups",
            "No hay grupos de tareas coincidentes",
            "Keine passenden Auftragsgruppen",
        ],
        JobGroupNoMatchingShort: [
            "No matching groups",
            "No hay grupos coincidentes",
            "Keine passenden Gruppen",
        ],
        JobGroupNoGroupsYet: [
            "No job groups yet",
            "Todavía no hay grupos de tareas",
            "Noch keine Auftragsgruppen",
        ],
        JobGroupTryDifferentSearch: [
            "Try a different title or reference.",
            "Prueba con otro título o referencia.",
            "Versuche einen anderen Titel oder eine andere Referenz.",
        ],
        JobGroupTryDifferentSearchTerm: [
            "Try a different search term.",
            "Prueba con otro término de búsqueda.",
            "Versuche einen anderen Suchbegriff.",
        ],
        JobGroupCreateEmptyState: [
            "Create a job group to manage related jobs from one place.",
            "Crea un grupo de tareas para gestionar tareas relacionadas desde un solo lugar.",
            "Erstelle eine Auftragsgruppe, um zusammengehörige Aufträge an einem Ort zu verwalten.",
        ],
        JobGroupCreateBeforeLinking: [
            "Create a job group first to link jobs.",
            "Crea primero un grupo de tareas para vincular tareas.",
            "Erstelle zuerst eine Auftragsgruppe, um Aufträge zu verknüpfen.",
        ],
        JobGroupUpdated: [
            "Updated {0}",
            "Actualizado {0}",
            "Aktualisiert {0}",
        ],
        JobGroupOneJob: [
            "1 job",
            "1 tarea",
            "1 Auftrag",
        ],
        JobGroupXJobs: [
            "{0} jobs",
            "{0} tareas",
            "{0} Aufträge",
        ],
        JobGroupDeleteTitle: [
            "Delete job group",
            "Eliminar grupo de tareas",
            "Auftragsgruppe löschen",
        ],
        JobGroupDeleteDescription: [
            "Delete this job group and unlink all related jobs?",
            "¿Eliminar este grupo de tareas y desvincular todas las tareas relacionadas?",
            "Diese Auftragsgruppe löschen und alle zugehörigen Aufträge trennen?",
        ],
        JobGroupSaveChanges: [
            "Save changes",
            "Guardar cambios",
            "Änderungen speichern",
        ],
        JobGroupCreateGroup: [
            "Create group",
            "Crear grupo",
            "Gruppe erstellen",
        ],
        JobGroupNewGroup: [
            "New group",
            "Nuevo grupo",
            "Neue Gruppe",
        ],
        JobGroupLinkToGroup: [
            "Link to group",
            "Vincular al grupo",
            "Mit Gruppe verknüpfen",
        ],
        JobGroupUnlink: [
            "Unlink",
            "Desvincular",
            "Verknüpfung entfernen",
        ],
        NextDay: ['Next day', 'Día siguiente', 'Nächster Tag'],
        PreviousDay: ['Previous day', 'Día anterior', 'Vorheriger Tag'],
        ReallyDeleteSelectedJobs: [
            'Delete the selected jobs?',
            '¿Borrar las tareas seleccionadas?',
            'Ausgewählte Aufträge wirklich löschen?',
        ],
        UnassignedJobs: ['Unassigned jobs', 'Tareas no asignadas', 'Nicht zugewiesene Aufträge'],
        Description: [
            "You can create new jobs and assign them to users to create day routes. Use our route optimization tool to reduce mileage and improve efficiency.",
            "Puedes crear nuevas tareas y asignárselas a los usuarios para crear rutas diarias. También puedes utilizar nuestra herramienta de optimización de rutas para reducir la cantidad de kilómetros recorridos y mejorar la eficiencia.",
            "Du kannst neue Aufträge erstellen und sie Benutzern zuweisen, um Tagesrouten zu erstellen. Außerdem kannst du unser Routenoptimierungstool nutzen, um die Kilometerzahl zu reduzieren und die Effizienz zu verbessern.",
        ],
        RecurringReasonsTitle: [
            "Recurring reasons for issues in the field",
            "Motivos recurrentes de problemas",
            "Wiederkehrende Gründe für Probleme vor Ort",
        ],
        RecurringReasonsDescription: [
            "Pick recurring issues that field workers can choose from when they mark a job as Issue",
            "Selecciona problemas recurrentes en el campo que pueden ser seleccionados por los trabajadores de campo al marcar una tarea como Problema",
            "Wähle hier Standard-Probleme, die wiederkehrend auftreten. Diese können von Mitarbeitern vor Ort ausgewählt werden, wenn ein Auftrag als »Problem« markiert wird",
        ],
        InputFormDescription: [
            "Set up a completion form which can be filled out by your staff in the field.",
            "Configura un formulario de finalización que pueda completar tu personal en el campo.",
            "Richte hier ein Formular für Auftragsabschluss ein, das von den Mitarbeitern vor Ort ausgefüllt werden kann.",
        ],
        CustomizeInputForm: [
            "Customize the standard completion form",
            "Personalizar el formulario de finalización estándar",
            "Standard-Formular für Auftragsabschluss anpassen",
        ],
        JobCompletion: [
            'Job completion confirmation / Proof of delivery',
            'Confirmación de finalización de la tarea / Prueba de entrega',
            'Bestätigung abgeschlossener Aufträge / Liefernachweis',
        ],
        EmailOnCompletion: [
            'Email on completion',
            'Correo al completar',
            'E-Mail bei Abschluss',
        ],
        EmailOnIssue: [
            'Email on issue',
            'Correo al reportar problema',
            'E-Mail bei Problem',
        ],
        EmailSubject: [
            "Email subject",
            "Asunto del correo",
            "E-Mail-Betreff",
        ],
        EmailSubjectDescription: [
            "Job completion confirmation",
            "Confirmación de finalización de la tarea",
            "Bestätigung des Auftragsabschlusses",
        ],
        EmailBody: [
            "Email body",
            "Cuerpo del correo",
            "Nachrichtentext",
        ],
        EmailBodyDescription: [
            "This is a notice to let you know that the job below was completed successfully. Click the link below to see the details.",
            "Este es un aviso para informarle que la tarea a continuación se completó correctamente. Haga clic en el siguiente enlace para ver los detalles.",
            "Dies ist eine Benachrichtigung, um Sie darüber zu informieren, dass der unten aufgeführte Auftrag erfolgreich abgeschlossen wurde. Klicken Sie auf den Link unten, um die Details zu sehen.",
        ],
        RecurringReasonsExamples: [
            "e.g. Customer didn't order, No time to deliver...",
            "p. ej. El cliente no lo ordenó, Sin tiempo para entregar...",
            "z. B. Kunde hat nicht bestellt, Keine Zeit zur Lieferung...",
        ],
        WorkerChangesStatusOfJobToX: [
            "Worker updates status of job to {0}",
            "El trabajador actualiza el estado de la tarea a {0}",
            "Der Mitarbeiter aktualisiert den Status des Auftrags auf {0}",
        ],
        Pinned: [
            "Pinned",
            "Fijadas",
            "Angeheftet",
        ],
        PinnedJobs: [
            "Pinned jobs",
            "Tareas fijadas",
            "Angeheftete Aufträge"
        ],
        ScheduledArrival: [
            "Scheduled arrival",
            "Llegada programada",
            "Geplante Ankunft"
        ],
        ScheduledDeparture: [
            "Scheduled departure",
            "Salida programada",
            "Geplante Abfahrt"
        ],
    },
    EmptyStates: {
        TimesheetEmptyDescription: [
            "Your team can clock in and out with the Hellotracks mobile app by turning the Active switch on/off. Here you can find a summary of your team's clock-in and clock-out times.",
            'Tu equipo puede registrar la entrada y la salida con la app móvil de Hellotracks activando o desactivando el interruptor Activo. Aquí encontrarás un resumen de las horas de entrada y salida de tu equipo.',
            'Dein Team kann sich mit der Hellotracks-App ein- und ausstempeln, indem es den Aktiv-Schalter ein- oder ausschaltet. Hier findest du eine Übersicht der Ein- und Ausstempelzeiten deines Teams.',
        ],
        TimesheetEmptyTitle: [
            'No entries found for this day',
            'No se encontraron entradas para este día',
            'Keine Einträge für diesen Tag gefunden',
        ],
        TracksEmptyDescription: [
            'Invite your team to activate tracking in the Hellotracks mobile app to see all driven routes here.',
            'Invita a tu equipo a activar el seguimiento en la aplicación móvil Hellotracks para ver todas las rutas recorridas aquí.',
            'Lade dein Team ein, Tracking in der mobilen Hellotracks-App zu aktivieren, um alle gefahrenen Routen hier zu sehen.',
        ],
        TracksEmptyTitle: [
            'No driven routes or events for this user within the selected day and timeframe.',
            'No hay rutas recorridas o eventos para este usuario dentro del día y período de tiempo seleccionado.',
            'Keine gefahrenen Routen oder Ereignisse für diesen Nutzer innerhalb des ausgewählten Tages und Zeitrahmens',
        ],
        ZonesEmptyDescription: [
            'Zones are polygonal areas. Use them to visualize areas on the map, set up geofencing alerts and dispatch jobs.',
            'Las zonas son áreas poligonales. Úsalas para visualizar áreas en el mapa, configurar alertas de geocerca y asignar tareas.',
            'Zonen sind polygonale Regionen. Nutze sie, um Regionen auf der Karte zu visualisieren, Geofencing-Warnungen einzurichten und Aufträge zu verteilen.',
        ],
        ZonesEmptyTitle: ['No zones created yet', 'Todavía no se han creado zonas', 'Noch keine Zonen erstellt'],
        MemberTracksEmptyTitle: [
            'No driven routes or stops found within the selected timeframe.',
            'No se encontraron rutas recorridas ni paradas en el período seleccionado.',
            'Keine gefahrenen Strecken oder Stopps innerhalb des ausgewählten Zeitrahmens gefunden'
        ],
    },
    ProfileModal: {
        AppLogin: ['App login', 'Sesiones en la app', 'App-Anmeldungen'],
        AppRunningInBackground: ['App running in background', 'App en segundo plano', 'App läuft im Hintergrund'],
        AppRunningInForeground: ['App is running in foreground', 'App en primer plano', 'App läuft im Vordergrund'],
        AppSuspended: [
            'App is suspended (compromises accuracy of trip recognition)',
            'App suspendida (afecta el registro de viajes)',
            'App wurde suspendiert (beeinflusst Fahrten-Aufzeichnung)',
        ],
        AppVersion: ['App version', 'Versión de la app', 'App-Version'],
        BatteryLevel: ['Battery level', 'Nivel de batería', 'Akkustand'],
        Conversation: ['Chat', 'Chat', 'Chat'],
        Device: ['Device', 'Dispositivo', 'Gerät'],
        EditProfile: ['Edit profile', 'Editar perfil', 'Profil bearbeiten'],
        General: ['General', 'General', 'Allgemein'],
        Integrations: ['Integrations', 'Integraciones', 'Integrationen'],
        MostRecentLocation: ['Most recent location', 'Ubicación más reciente', 'Letzter Standort'],
        Profile: ['Profile', 'Perfil', 'Profil'],
        Communication: ["Communication", "Comunicación", "Kommunikation"],
        Routing: ['Routing', 'Enrutamiento', 'Routing'],
        Worker: ['Worker', 'Trabajador', 'Mitarbeiter'],
        WorkingHours: ['Working hours', 'Horas laborales', 'Arbeitszeiten'],
        ResetPasswordLinkSent: ['Reset password link sent', 'Enlace enviado', 'Link wurde zugesendet'],
        EmailVerificationCodeSentToX: ['Email verification code sent to {0}.', 'Código de verificación de correo electrónico enviado a {0}.', 'E-Mail-Bestätigungscode wurde an {0} gesendet.'],
        NoValidEmailAddressX: ['Invalid email address: {0}.', 'Dirección de correo electrónico no válida: {0}.', 'Keine gültige E-Mail-Adresse: {0}.'],
        EnterVerificationCode: ['Enter verification code', 'Ingresa el código de verificación', 'Bestätigungscode eingeben'],
        PhoneSuccessfullyVerified: ['Phone number successfully verified.', 'Número de teléfono verificado con éxito.', 'Telefonnummer erfolgreich bestätigt.'],
        PhoneVerificationCodeSentToX: ['Phone verification code sent to {0}.', 'Código de verificación enviado a {0}.', 'Der Bestätigungscode wurde an {0} gesendet.'],
        NoValidPhoneNumberX: ['Invalid phone number: {0}.', 'Número de teléfono inválido: {0}.', 'Keine gültige Telefonnummer: {0}.'],
        DeviceGraphsOverview: [
            "Here you'll find graphs providing a comprehensive overview of the user's device battery history, overall status history, idling behavior, and online connectivity.",
            "Aquí encontrarás gráficos que ofrecen una visión completa del historial de batería del dispositivo del usuario, el historial general de estado, el comportamiento en reposo y la conectividad en línea.",
            "Hier findest du Diagramme, die einen umfassenden Überblick über den Batterieverlauf des Geräts, den allgemeinen Statusverlauf, das Leerlaufverhalten und die Online-Konnektivität des Nutzers geben."
        ],
        DeviceGraphs: ["Graphs", "Gráficos", "Diagramme"],
        GraphBattery: ["Battery", "Batería", "Akku"],
        GraphCharging: ["charging", "cargando", "lädt"],
        GraphLocationAge: ["Since last location", "Desde la última ubicación", "Seit letzter Ortung"],
        GraphLoggedIn: ["Logged in", "Sesión iniciada", "Angemeldet"],
        GraphInService: ["In service", "En servicio", "Im Dienst"],
        GraphLocating: ["Locating", "Ubicando", "Ortung aktiv"],
        GraphAppOpen: ["App open", "App abierta", "App geöffnet"],
        GraphOnline: ["Online", "En línea", "Online"],
        GraphNoData: ["no reports", "sin datos", "keine Meldungen"],
        GraphNoReports: [
            "The phone sent no reports in this time.",
            "El teléfono no envió datos en este período.",
            "Das Handy hat in dieser Zeit nichts gemeldet.",
        ],
    },
    Job: {
        GroupJob: ['Job', 'Tarea', 'Auftrag'],
        GroupAssignment: ['Assignment', 'Asignación', 'Zuweisung'],
        GroupDetails: ['Details', 'Detalles', 'Details'],
        GroupContactLogistics: ['Contact & logistics', 'Contacto y logística', 'Kontakt & Logistik'],
        SubmittedForms: ['Submitted forms', 'Formularios enviados', 'Eingereichte Formulare'],
        Address: ['Address', 'Dirección', 'Adresse'],
        Advanced: ['Advanced', 'Avanzado', 'Erweitert'],
        CarryOverNextDayIfUnfinished: [
            'Carry over next day if unfinished',
            'Continuar al día siguiente hasta finalizar',
            'Auf Folgetag übertragen, falls unerledigt',
        ],
        RememberCarryOverSetting: [
            "Remember the carry over setting for future jobs.",
            "Recordar la configuración de continuar al día siguiente para tareas futuras.",
            "Die Übertragungseinstellung für zukünftige Aufträge speichern."
        ],
        Contact: ['Contact', 'Contacto', 'Kontakt'],
        ContactName: ['Contact name', 'Nombre de contacto', 'Kontakt-Name'],
        ContactPhone: ['Contact phone', 'Teléfono de contacto', 'Kontakt-Telefon'],
        ContactEmail: ['Contact email', 'Correo electrónico de contacto', 'Kontakt-E-Mail'],
        Date: ['Date', 'Fecha', 'Datum'],
        DispatchJobCompletion: [
            'Job completion confirmation / Proof of delivery',
            'Confirmación de finalización de la tarea / Prueba de entrega',
            'Bestätigung abgeschlossener Aufträge / Liefernachweis',
        ],
        DispatchJobCompletionSend: [
            'Send email to customer on job completion',
            'Enviar correo al cliente al finalizar la tarea',
            'E-Mail an Kunden senden, wenn ein Auftrag abgeschlossen ist',
        ],
        DispatchJobCompletionEditInCompanyX: [
            "Can be edited in {0} > {1}",
            "Se puede editar en {0} > {1}",
            "Kann unter {0} > {1} bearbeitet werden",
        ],
        EmailPreview: [
            "Email preview",
            "Vista previa del correo electrónico",
            "E-Mail-Vorschau",
        ],
        Email: ['Email', 'Correo electrónico', 'E-Mail'],
        EnterEmail: ['Enter email', 'Ingresar correo electrónico', 'E-Mail eingeben'],
        FormsLinkedForm: ['Linked form', 'Formulario vinculado', 'Verknüpftes Formular'],
        FormsLinkedForms: ['Linked forms', 'Formularios vinculados', 'Verknüpfte Formulare'],
        High: ['High', 'Alta', 'Hoch'],
        JobInfo: ['Job info', 'Información', 'Auftragsinfo'],
        JobTypeDropoff: ['Drop-off', 'Entregar', 'Zuliefern'],
        JobTypePickup: ['Pickup', 'Recoger', 'Abholen'],
        JobTypeWork: ['Work', 'Trabajo', 'Arbeit'],
        Latitude: ['Latitude', 'Latitud', 'Breitengrad'],
        LinkedZone: ['Linked zone', 'Zona vinculada', 'Verknüpfte Zone'],
        LinkedZones: ['Linked zones', 'Zonas vinculadas', 'Verknüpfte Zonen'],
        Longitude: ['Longitude', 'Longitud', 'Längengrad'],
        Low: ['Low', 'Baja', 'Niedrig'],
        NewJob: ['New job', 'Nueva tarea', 'Neuer Auftrag'],
        Normal: ['Normal', 'Normal', 'Normal'],
        Notes: ['Notes', 'Notas', 'Notizen'],
        NumberOfItemsToDropoff: [
            "Number of items to drop off",
            "Número de artículos para dejar",
            "Anzahl der abzuliefernden Objekte"
        ],
        NumberOfItemsToPickup: [
            "Number of items to pick up",
            "Número de artículos para recoger",
            "Anzahl der abzuholenden Objekte"
        ],
        Dropoff: ['Drop-off', 'Entregar', 'Abladen'],
        Pickup: ['Pickup', 'Recoger', 'Aufladen'],
        OnCompleting: ['on completing', 'al completar', 'bei Abschluss'],
        OnIssue: ['on issue', 'al reportar problema', 'bei Problem'],
        OnSiteCaption: [
            'How long you expect the worker to stay on site',
            'Cuánto tiempo esperas que el trabajador permanezca en el lugar',
            'Wie lange der Mitarbeiter voraussichtlich vor Ort bleibt',
        ],
        RememberOnSiteSetting: [
            "Remember the duration setting for future jobs",
            "Recordar la configuración de duración para tareas futuras",
            "Die Dauer-Einstellung für zukünftige Aufträge speichern"
        ],
        OnSiteTime: ['On site', 'Tiempo en sitio', 'Vor Ort'],
        OrderId: ['Order #', '# de orden', 'Auftrags-Nr.'],
        OrderIdCaption: [
            "The order number can be used to identify a job and likely represents your internal service number for this job.",
            "El número de orden se puede utilizar para identificar una tarea y probablemente representa tu número de servicio interno para esta tarea.",
            "Die Auftragsnummer kann verwendet werden, um einen Auftrag zu identifizieren und stellt wahrscheinlich die interne Servicenummer für diesen Auftrag dar."
        ],
        PickupAndDelivery: ['Pickup & delivery', 'Recolección y entrega', 'Auf- und Abladen'],
        Priority: ['Priority', 'Prioridad', 'Priorität'],
        ReallyDeleteThisJob: [
            'Do you want to delete this job?',
            '¿Quieres borrar esta tarea?',
            'Willst du diesen Auftrag löschen?',
        ],
        ReallyDeleteThisTemplate: [
            'Do you want to delete this template?',
            '¿Quieres borrar esta plantilla?',
            'Willst du diese Vorlage löschen?',
        ],
        SetAsDefault: ['Set as default', 'Fijar por defecto', 'Als Standard festlegen'],
        StaffInput: ['Responses', 'Respuestas', 'Antworten'],
        StatusHistory: ['Status history', 'Historial', 'Statusverlauf'],
        Type: ['Type', 'Tipo', 'Typ'],
        UploadedImages: ['Uploaded images', 'Imágenes adjuntas', 'Angehängte Fotos'],
        minutes: ['minutes', 'minutos', 'Minuten'],
        ManageJobTypeDesc: [
            'You can create or remove custom job types here',
            'Aquí puedes crear o eliminar los tipos de tarea personalizados',
            'Du kannst hier benutzerdefinierte Auftragstypen erstellen oder entfernen.',
        ],
        JobType: [
            'Custom job type',
            'Tipo de tarea personalizado',
            'Benutzerdefinierter Auftragstyp',
        ],
        JobTypeDeleteDesc: [
            'Removing a custom job type also removes it from all existing jobs that use it.',
            'Al eliminar un tipo de tarea, también se quitará de todas las tareas existentes que lo usan.',
            'Wenn du diesen Auftragstyp entfernst, wird er auch von allen bestehenden Aufträgen mit diesem Typ entfernt.',
        ],
        CarryOver: [
            'Carry over',
            'Continuar',
            'Übertragen',
        ],
        NoCarryOver: [
            'No carry over',
            'No continuar',
            'Nicht übertragen',
        ],
        CarryOverQuestion: [
            'Carry over?',
            '¿Continuar?',
            'Übertragen?',
        ],
        ChooseCarryOver: [
            "Choose when to carry over unfinished jobs to the next day",
            "Elige cuándo trasladar tareas no terminadas al día siguiente",
            "Wähle, wann nicht abgeschlossene Aufträge auf den nächsten Tag übertragen werden sollen",
        ],
        CarryOverIfNotDoneOrIssue: [
            "Carry over if not Done or Issue",
            "Trasladar si no está Terminado o Problema",
            "Übertragen, wenn nicht Erledigt oder Problem",
        ],
        JobFinishedIfMarkedAsEither: [
            "Job is considered finished if marked as either",
            "La tarea se considera terminada si está marcada como cualquiera",
            "Auftrag gilt als abgeschlossen, wenn er als eines von beiden markiert ist",
        ],
        CarryOverIfNotDone: [
            "Carry over if not Done",
            "Trasladar si no está Terminado",
            "Übertragen, wenn nicht Erledigt",
        ],
        JobFinishedOnlyIfDone: [
            "Job is considered finished only if marked as Done",
            "La tarea se considera terminada solo si está marcada como Terminada",
            "Auftrag gilt nur als abgeschlossen, wenn er als Erledigt markiert ist",
        ],
        ImportJobs: [
            'Import jobs',
            'Importar tareas',
            'Aufträge importieren',
        ],
        ImportJobsTitle: [
            'Import jobs from a CSV or Excel file',
            'Importar tareas desde un archivo CSV o Excel',
            'Aufträge aus CSV- oder Excel-Datei importieren',
        ],
        ImportJobsInfo: [
            '<p>Please structure your Excel/CSV file correctly, i.e. headers must be correct, and data formatting should be consistent.</p><p>You can download this <strong>template</strong>: <a href="{0}" target="_blank" download>CSV template</a>, <a href="{1}" download>Excel template</a>.</p><ul><li>Do not rename header fields</li><li>You may remove columns</li><li>Leave cells empty if they don\'t apply</li><li>If you use the CSV format, make sure the file is encoded in UTF-8</li></ul>',
            '<p>Por favor aseg&uacute;rate de que tu archivo Excel/CSV tiene encabezados correctos y datos consistentes.</p><p>Puedes descargar una plantilla de ejemplo aqu&iacute;: <a href="{0}" target="_blank" download>plantilla de CSV</a>, <a href="{1}" download>plantilla de Excel</a>.</p><ul><li>No modifiques encabezados</li><li>Puedes remover columnas</li><li>Deja campos vac&iacute;os si no aplican</li><li>Aseg&uacute;rate de que el formato del CSV est&aacute; en UTF-8</li></ul>',
            '<p>Die Struktur der Excel-/CSV-Datei muss korrekt sein, d. h. die Kopfzeile muss dem richtigen Format entsprechen.</p><p>Du kannst diese <strong>Vorlage</strong> herunterladen: <a href="{0}" target="_blank" download>CSV-Vorlage</a>, <a href="{1}" download>Excel-Vorlage</a>.</p><ul><li>Die Felder der Kopfzeile nicht &auml;ndern</li><li>Spalten entfernen ist erlaubt</li><li>Du kannst Felder leer lassen</li><li>Wenn du das CSV-Format verwendest, stelle sicher, dass die Datei UTF-8-codiert ist.</li></ul>'
        ],
        XJobs: ['{0} jobs', '{0} tareas', '{0} Aufträge'],
        OneJob: ['1 job', '1 tarea', '1 Auftrag'],
        TodaysJobs: ["Today", 'Hoy', 'Heute'],
        FilterByTitleAddressOrder: [
            "Filter jobs by title, address, order number, ID",
            "Filtrar tareas por título, dirección, número de orden, ID",
            "Aufträge nach Titel, Adresse, Auftragsnummer, ID filtern",
        ],
        DropJobAndArrange: [
            "Drop jobs between Start and End and arrange order to create a route",
            "Puedes soltar tareas entre Comienzo y Final y organizar el orden para crear una ruta",
            "Zieh Aufträge zwischen Start und Ende und ordne sie, um eine Route zu erstellen",
        ],
        ZoomToJobs: [
            "Zoom to jobs",
            "Zoom a tareas",
            "Zu Aufträgen zoomen",
        ],
        DraggablePanel: [
            "Draggable panel",
            "Panel arrastrable",
            "Verschiebbares Panel",
        ],
        LinkedZonesDesc: [
            "Linked zones are displayed on the assigned worker's Hellotracks mobile app. You'll receive check-ins of assigned workers if they enter the zone.",
            "Las zonas vinculadas se muestran en la aplicación móvil Hellotracks del trabajador asignado. Recibirás check-ins de los trabajadores asignados cuando entren en la zona.",
            "Verknüpfte Zonen werden in der Hellotracks-Mobil-App des zugewiesenen Mitarbeiters angezeigt. Check-ins von zugewiesenen Mitarbeitern erscheinen, wenn sie die Zone betreten.",
        ],
        LinkedFormsDesc: [
            "Linked forms are accessible in the job view in the mobile app. Create and manage forms under Insights > Forms.",
            "Los formularios vinculados son accesibles en la vista de la tarea en la aplicación móvil. Crea y administra formularios en Insights > Formularios.",
            "Verknüpfte Formulare sind in der Auftragsansicht in der mobilen App zugänglich. Erstelle und verwalte Formulare unter Insights > Formulare.",
        ],
        ManualJobCheckin: [
            'Manual check-in',
            'Check-in manual',
            'Manueller Check-in',
        ],
        ManualJobCheckout: [
            'Manual check-out',
            'Check-out manual',
            'Manueller Check-out',
        ],
        EditJobTypes: [
            "Edit job types",
            "Editar tipos de tarea",
            "Auftragstypen bearbeiten",
        ],
        EnterJobTitle: [
            "Enter job title",
            "Ingresa el título de la tarea",
            "Auftragstitel eingeben",
        ],
        ArchivedJobsDesc: [
            "Archived jobs are not visible to field staff and are not available to dispatch. You can restore or delete archived jobs.",
            "Las tareas archivadas no son visibles para el personal de campo y no están disponibles para el despacho. Puedes restaurar o eliminar las tareas archivadas.",
            "Archivierte Aufträge sind für Mitarbeiter vor Ort nicht sichtbar und stehen nicht zur Disposition. Du kannst archivierte Aufträge wiederherstellen oder löschen.",
        ],
        SearchJobAndAssign: [
            "Search for job and assign",
            "Buscar tarea y asignar",
            "Auftrag suchen und zuweisen",
        ],
        NarrowTimeframe: [
            "Consider narrowing the timeframe to ensure all relevant jobs are included in the list.",
            "Considera reducir el plazo para asegurarte de que se incluyan todas las tareas relevantes en la lista.",
            "Erwäge, den Zeitrahmen einzugrenzen, um sicherzustellen, dass alle relevanten Aufträge in der Liste enthalten sind.",
        ],
        XSelectedJobs: [
            "{0} selected jobs",
            "{0} tareas seleccionadas",
            "{0} ausgewählte Aufträge",
        ],
        OneSelectedJob: [
            "1 selected job",
            "1 tarea seleccionada",
            "1 ausgewählter Auftrag",
        ],
        Requirements: [
            "Requirements",
            "Requisitos",
            "Anforderungen"
        ],
        SkillsRequired: [
            "Skills required",
            "Habilidades requeridas",
            "Erforderliche Skills"
        ],
        SkillsRequiredDesc: [
            "A listing of the skills necessary to complete this job, which are taken into account during route solving to meet routing requirements. This includes specific technical knowledge, certifications, and experience with essential tools and equipment.",
            "Una lista de las habilidades necesarias para completar esta tarea, que se tienen en cuenta durante la resolución de rutas para cumplir con los requisitos de enrutamiento. Esto incluye conocimientos técnicos específicos, certificaciones y experiencia con herramientas y equipos esenciales.",
            "Eine Auflistung der Skills, die für die Erledigung dieses Auftrags erforderlich sind und bei der Routenplanung berücksichtigt werden, um die Routing-Anforderungen zu erfüllen. Dies umfasst spezifische technische Kenntnisse, Zertifizierungen und Erfahrung mit wesentlichen Werkzeugen und Ausrüstungen."
        ],
        DateAndTime: [
            "Date and time",
            "Fecha y hora",
            "Datum und Zeit",
        ],
        Expanded: ["Expanded", "Desplegado", "Ausgeklappt"],
        Compact: ["Compact", "Compacto", "Kompakt"],
        Comments: [
            "Comments",
            "Comentarios",
            "Kommentare",
        ],
        AddComment: [
            "Add comment",
            "Agregar comentario",
            "Kommentar hinzufügen",
        ],
        EnterComment: [
            "Enter comment",
            "Ingresar comentario",
            "Kommentar eingeben",
        ],
        Labels: [
            "Labels",
            "Etiquetas",
            "Labels"
        ],
        SearchJobs: [
            "Search jobs",
            "Buscar tareas",
            "Aufträge suchen",
        ],
        EditSearch: [
            "Edit search",
            "Editar búsqueda",
            "Suche bearbeiten",
        ],
        ClearSearch: [
            "Clear search",
            "Limpiar búsqueda",
            "Suche leeren",
        ],
        InSelectedRange: [
            "In selected range",
            "En rango seleccionado",
            "Im ausgewählten Zeitraum",
        ],
        InAllDates: [
            "In all dates",
            "En todas las fechas",
            "An allen Tagen",
        ],
        SearchingAllDates: [
            'Searching all dates: "{0}"',
            'Buscando en todas las fechas: "{0}"',
            'Suche an allen Tagen: „{0}“',
        ],
        SearchingSelectedRange: [
            'Searching selected range: "{0}"',
            'Buscando en rango seleccionado: "{0}"',
            'Suche im ausgewählten Zeitraum: „{0}"',
        ],
        Searching: [
            "Searching...",
            "Buscando...",
            "Suche...",
        ],
        XMatches: [
            "{0} matches",
            "{0} coincidencias",
            "{0} Treffer",
        ],
        ShowingFirstXMatches: [
            "Showing first {0} matches. Refine search to narrow results.",
            "Mostrando las primeras {0} coincidencias. Refina la búsqueda para acotar resultados.",
            "Zeige die ersten {0} Treffer. Verfeinere die Suche, um die Ergebnisse einzugrenzen.",
        ],
    },
    JobStatuses: {
        Accepted: ['Started', 'Empezado', 'Gestartet'],
        Issue: ['Issue', 'Problema', 'Problem'],
        InProgress: ['In progress', 'En progreso', 'In Bearbeitung'],
        Scheduled: ['Scheduled', 'Programada', 'Geplant'],
        Done: ['Done', 'Completa', 'Erledigt'],
        Unassigned: ['Unassigned', 'Sin asignar', 'Nicht zugewiesen'],
        Rejected: ["Rejected", "Rechazado", "Abgelehnt"],
    },
    WorkingHours: {
        WeeklyScheduleTitle: [
            'Weekly schedule',
            'Horario semanal',
            'Wochenplan',
        ],
        WeeklyScheduleDesc: [
            'Default schedule applied each week unless overridden for a specific date.',
            'Horario predeterminado aplicado cada semana a menos que se anule para una fecha específica.',
            'Standardplan, der jede Woche gilt, sofern nicht für ein bestimmtes Datum überschrieben.',
        ],
        CopyTime: ['Copy time to all', 'Copiar horas a todos', 'Zeiten zu allen kopieren'],
        DateOverridesTitle: [
            'Date-based shifts (next 14 days)',
            'Turnos por fecha (próximos 14 días)',
            'Datumsspezifische Schichten (nächste 14 Tage)',
        ],
        DateOverridesDesc: [
            'Override the weekly template for specific dates. Individual date overrides take precedence.',
            'Anula la plantilla semanal para fechas específicas. Las anulaciones individuales tienen prioridad.',
            'Überschreibt die Wochenvorlage für bestimmte Tage. Individuelle Tages-Overrides haben Vorrang.',
        ],
        DateOverridesUseOverride: [
            'Use date override',
            'Usar anulación por fecha',
            'Datums-Override verwenden',
        ],
        DateOverridesOffDay: [
            'Off day',
            'Día libre',
            'Freier Tag',
        ],
        DateOverridesClear: [
            'Clear all date overrides',
            'Eliminar todas las anulaciones por fecha',
            'Alle Datums-Overrides entfernen',
        ],
        DefaultWorkingHoursNoTeam: [
            'Default working hours (no team)',
            'Horario de trabajo (sin equipo)',
            'Standard-Arbeitszeiten (kein Team)',
        ],
        IndividualAvailability: ['Working hours', 'Horas laborales', 'Arbeitszeiten'],
        IndividualRouteStartEndLocation: [
            'Individual (overrules team setting)',
            'Individual (anula la configuración del equipo)',
            'Individuell (überschreibt Team-Einstellung)',
        ],
        TeamAvailability: ['Team working hours', 'Horario de trabajo del equipo', 'Team-Arbeitszeiten'],
        UseIndividualAvailabilityForX: [
            "Use individual working hours for {0} (overrules the team's working hours)",
            'Usar horario de trabajo individual para {0} (anula el horario de trabajo del equipo)',
            'Individuelle Arbeitszeit für {0} verwenden (überschreibt die Team-Arbeitszeit)',
        ],
    },
    Routing: {
        QuickRouteDesc: [
            "Create multiple jobs quickly via the Route tool",
            "Crea múltiples tareas rápidamente a través de la herramienta de ruta",
            "Erstelle schnell mehrere Aufträge über das Routenwerkzeug"
        ],
        Start: ["Route start", "Comienzo de la ruta", "Start der Tagesroute"],
        End: ["Route end", "Final de la ruta", "Ende der Tagesroute"],
        Route: ['Route', 'Ruta', 'Route'],
        RouteCalculationIssue: [
            "Route calculation issue",
            "Problema de cálculo de ruta",
            "Problem bei der Routenberechnung",
        ],
        ActualArrival: ['Actual arrival (check-in)', 'Llegada real (check-in)', 'Tatsächliche Ankunft (Check-in)'],
        ActualDeparture: ['Actual departure (check-out)', 'Salida real (check-out)', 'Tatsächliche Abfahrt (Check-out)'],
        BetterOrder: ['Better order', 'Mejor orden', 'Bessere Reihenfolge'],
        YourOrder: ['Your order', 'Tu orden', 'Deine Reihenfolge'],
        DayBarStopXYZW: ['{0} · {1}–{2} · {3} on site', '{0} · {1}–{2} · {3} en el sitio', '{0} · {1}–{2} · {3} vor Ort'],
        DayBarBetweenX: ['{0} to the next stop', '{0} hasta la siguiente parada', '{0} bis zum nächsten Stopp'],
        BetterOrderTooltip: [
            'The order with the least driving that keeps time windows, working hours and skills',
            'El orden con menos manejo que respeta ventanas horarias, horario laboral y habilidades',
            'Die Reihenfolge mit der wenigsten Fahrzeit, die Zeitfenster, Arbeitszeit und Skills einhält',
        ],
        BetterOrderEndsAt: ['A better order ends at {0}, {1} sooner', 'Con un orden mejor termina a las {0}, {1} antes', 'Mit besserer Reihenfolge fertig um {0}, {1} früher'],
        BetterOrderFitsShift: ['A better order ends within the shift, at {0}', 'Con un orden mejor termina dentro del turno, a las {0}', 'Mit besserer Reihenfolge fertig in der Schicht, um {0}'],
        BetterOrderCheckFailed: ["Couldn't check the order right now", 'No se pudo revisar el orden ahora', 'Reihenfolge konnte gerade nicht geprüft werden'],
        BetterOrderSolverFailed: ["Couldn't work out a better order", 'No se pudo calcular un orden mejor', 'Bessere Reihenfolge konnte nicht berechnet werden'],
        ButOneStopDoesntFit: [", but 1 stop doesn't fit the hours or its window", ', pero 1 parada no cabe en el horario o en su ventana', ', aber 1 Stopp passt nicht in die Arbeitszeit oder sein Zeitfenster'],
        ButStopsDontFit: [", but {0} stops don't fit the hours or their window", ', pero {0} paradas no caben en el horario o en su ventana', ', aber {0} Stopps passen nicht in die Arbeitszeit oder ihr Zeitfenster'],
        ButOneMoreLate: [', but 1 more stop is late', ', pero 1 parada más llega tarde', ', aber 1 Stopp mehr ist zu spät'],
        ButMoreLate: [', but {0} more stops are late', ', pero {0} paradas más llegan tarde', ', aber {0} Stopps mehr sind zu spät'],
        TryAgain: ['Try again', 'Reintentar', 'Nochmal versuchen'],
        StopNoAddressOff: ['{0} has no address and is left out of the driving', '{0} no tiene dirección y no cuenta en el manejo', '{0} hat keine Adresse und zählt nicht zur Fahrt'],
        StopsNoAddressOff: ['{0} stops have no address and are left out of the driving', '{0} paradas no tienen dirección y no cuentan en el manejo', '{0} Stopps haben keine Adresse und zählen nicht zur Fahrt'],
        StopNoAddressBlocks: ["{0} has no address, so the route can't be worked out", '{0} no tiene dirección, así que no se puede calcular la ruta', '{0} hat keine Adresse, deshalb lässt sich die Route nicht berechnen'],
        StopsNoAddressBlocks: ["{0} stops have no address, so the route can't be worked out", '{0} paradas no tienen dirección, así que no se puede calcular la ruta', '{0} Stopps haben keine Adresse, deshalb lässt sich die Route nicht berechnen'],
        StopNumber: ['Stop {0}', 'Parada {0}', 'Stopp {0}'],
        ShowStop: ['Show', 'Mostrar', 'Anzeigen'],
        RouteStartNotSet: ['At the first stop · not set', 'En la primera parada · sin definir', 'Beim ersten Stopp · nicht festgelegt'],
        RouteEndNotSet: ['At the last stop · not set', 'En la última parada · sin definir', 'Beim letzten Stopp · nicht festgelegt'],
        AtFirstStop: ['At the first stop', 'En la primera parada', 'Beim ersten Stopp'],
        AtLastStop: ['At the last stop', 'En la última parada', 'Beim letzten Stopp'],
        FromFirstStop: ['{0} from the first stop', 'A {0} de la primera parada', '{0} vom ersten Stopp'],
        FromLastStop: ['{0} from the last stop', 'A {0} de la última parada', '{0} vom letzten Stopp'],
        SetLocation: ['Set', 'Definir', 'Festlegen'],
        ChangeLocation: ['Change', 'Cambiar', 'Ändern'],
        RouteStartsFar: ['The route starts {0} from the first stop', 'La ruta empieza a {0} de la primera parada', 'Die Route beginnt {0} vom ersten Stopp entfernt'],
        RouteEndsFar: ['The route ends {0} from the last stop', 'La ruta termina a {0} de la última parada', 'Die Route endet {0} vom letzten Stopp entfernt'],
        RouteFailedShortNoRoute: ['No drivable route to every stop', 'No hay ruta en auto hasta todas las paradas', 'Nicht jeder Stopp ist mit dem Auto erreichbar'],
        RouteFailedShortNoRegion: ["The route's start or end is outside the regions we can route", 'El inicio o el final de la ruta está fuera de las regiones que podemos calcular', 'Start oder Ende der Route liegt außerhalb der Regionen, die wir berechnen können'],
        RouteFailedShortTooMany: ['Too many stops to route at once', 'Demasiadas paradas para calcular de una vez', 'Zu viele Stopps für eine Route'],
        RouteFailedShortSanity: ['The stop locations look wrong', 'Las ubicaciones de las paradas parecen incorrectas', 'Die Orte der Stopps sehen falsch aus'],
        RouteFailedShortNow: ["The route couldn't be worked out just now", 'No se pudo calcular la ruta ahora', 'Route konnte gerade nicht berechnet werden'],
        BetterOrderSooner: ['A better order ends {0} sooner', 'Con un orden mejor termina {0} antes', 'Mit besserer Reihenfolge {0} früher fertig'],
        BetterOrderHighFirst: ['Better order · High priority first', 'Mejor orden · Prioridad alta primero', 'Bessere Reihenfolge · Hohe Priorität zuerst'],
        BetterOrderLowLast: ['Better order · Low priority last', 'Mejor orden · Prioridad baja al final', 'Bessere Reihenfolge · Niedrige Priorität zuletzt'],
        BetterOrderOnTime: [
            'A better order reaches more customers in their window',
            'Un orden mejor llega a más clientes dentro de su horario',
            'Eine bessere Reihenfolge erreicht mehr Kunden in ihrem Zeitfenster',
        ],
        AlreadyBestOrder: ['This order is already the best one', 'Este orden ya es el mejor', 'Diese Reihenfolge ist schon die beste'],
        HintTitle: ['Optimize now runs by itself', 'Optimizar ahora funciona solo', 'Optimieren läuft jetzt von selbst'],
        HintBody: [
            'Every route is checked in the background. A better order keeps time windows, working hours, skills and vehicle capacity, and started stops stay where they are.',
            'Cada ruta se revisa en segundo plano. Un orden mejor respeta ventanas horarias, horario laboral, habilidades y capacidad del vehículo, y las paradas empezadas se quedan donde están.',
            'Jede Route wird im Hintergrund geprüft. Eine bessere Reihenfolge hält Zeitfenster, Arbeitszeit, Skills und Fahrzeugkapazität ein, und begonnene Stopps bleiben, wo sie sind.',
        ],
        HintLine: ["Shows up only when it's worth it", 'Aparece solo cuando vale la pena', 'Erscheint nur, wenn es sich lohnt'],
        HintLineWhere: ['here', 'aquí', 'hier'],
        HintBar: ['Your day next to the better one', 'Tu día junto al mejor', 'Dein Tag neben dem besseren'],
        HintBarWhere: ['above', 'arriba', 'darüber'],
        HintPreview: ['You decide: preview, use or keep yours', 'Tú decides: ver, usar o mantener el tuyo', 'Du entscheidest: ansehen, übernehmen oder behalten'],
        PreviewOrder: ['Preview', 'Vista previa', 'Vorschau'],
        UndoOrder: ['Undo', 'Deshacer', 'Rückgängig'],
        ReplayOnMap: ['Replay on map', 'Repetir en el mapa', 'Auf der Karte abspielen'],
        OrderBefore: ['Before', 'Antes', 'Vorher'],
        OrderAfter: ['After', 'Después', 'Nachher'],
        OrderEarlier: ['one place earlier', 'un puesto antes', 'einen Platz früher'],
        OrderEarlierMany: ['{0} places earlier', '{0} puestos antes', '{0} Plätze früher'],
        OrderLater: ['one place later', 'un puesto después', 'einen Platz später'],
        OrderLaterMany: ['{0} places later', '{0} puestos después', '{0} Plätze später'],
        OrderUnchanged: ['unchanged', 'sin cambios', 'unverändert'],
        OrderMoreMoved: ['{0} more stops move', '{0} paradas más cambian de lugar', '{0} weitere Stopps werden verschoben'],
        OrderReversed: ['Same {0} stops, driven the other way round', 'Las mismas {0} paradas, recorridas al revés', 'Dieselben {0} Stopps, in umgekehrter Reihenfolge'],
        OrderReversedHint: ['Stop {0} comes first, stop 1 last', 'La parada {0} va primero y la 1, al final', 'Stopp {0} kommt zuerst, Stopp 1 zuletzt'],
        OrderMovedOfTotal: ['{0} of {1} stops change places', '{0} de {1} paradas cambian de lugar', '{0} von {1} Stopps werden verschoben'],
        OrderRestKept: ['The rest keep their order', 'El resto mantiene su orden', 'Die übrigen behalten ihre Reihenfolge'],
        UseThisOrder: ['Use this order', 'Usar este orden', 'Diese Reihenfolge übernehmen'],
        KeepCurrentOrder: ['Keep mine', 'Mantener el actual', 'Aktuelle behalten'],
        NewOrderSaved: ['New order saved', 'Nuevo orden guardado', 'Neue Reihenfolge gespeichert'],
        WasNumber: ['was {0}', 'era {0}', 'vorher {0}'],
        DoneByInstead: ['Done by {0} instead of {1}', 'Termina a las {0} en vez de a las {1}', 'Fertig um {0} statt {1}'],
        DrivingInstead: ['Driving {0} instead of {1}', 'Manejo {0} en vez de {1}', 'Fahrzeit {0} statt {1}'],
        WindowsAllKept: ['Every time window kept', 'Se respetan todas las ventanas horarias', 'Alle Zeitfenster eingehalten'],
        LateInstead: ['{0} late for their window instead of {1}', '{0} fuera de su ventana en vez de {1}', '{0} außerhalb ihres Zeitfensters statt {1}'],
        LateSame: ['{0} late for their window, same as your order', '{0} fuera de su ventana, igual que en tu orden', '{0} außerhalb ihres Zeitfensters, wie in deiner Reihenfolge'],
        UnfitStops: [
            '{0} stops don’t fit the working hours or their window and go last',
            '{0} paradas no caben en el horario o en su ventana y van al final',
            '{0} Stopps passen nicht in die Arbeitszeit oder ihr Zeitfenster und kommen ans Ende',
        ],
        ExpectedArrival: ['Expected arrival, from the latest check-in or check-out', 'Llegada prevista, según el último check-in o check-out', 'Voraussichtliche Ankunft, nach dem letzten Check-in oder Check-out'],
        ExpectedDeparture: ['Expected departure, from the latest check-in or check-out', 'Salida prevista, según el último check-in o check-out', 'Voraussichtliche Abfahrt, nach dem letzten Check-in oder Check-out'],
        DayBehindPlan: ['Running {0} behind plan', 'Va con {0} de retraso', '{0} hinter dem Plan'],
        DayAheadOfPlan: ['Running {0} ahead of plan', 'Va con {0} de adelanto', '{0} vor dem Plan'],
        DayOnPlan: ['On plan', 'Según lo previsto', 'Im Plan'],
        DayDoneBy: ['done by {0}', 'termina hacia las {0}', 'fertig gegen {0}'],
        DayEndsAt: ['Ends {0}', 'Termina a las {0}', 'Endet um {0}'],
        DayDone: ['Done', 'Terminado', 'Fertig'],
        DayNoWorkingHours: ['no working hours set', 'sin horario laboral', 'keine Arbeitszeit hinterlegt'],
        PastShiftEnd: ['{0} past shift end', '{0} después del fin del turno', '{0} nach Schichtende'],
        DayNoWorkingHoursOnX: ['no working hours on {0}', 'sin horario laboral el {0}', 'keine Arbeitszeit am {0}'],
        SetHoursForToday: ['Set hours for today', 'Fijar horario para hoy', 'Arbeitszeit für heute festlegen'],
        SetHoursForThisDay: ['Set hours for this day', 'Fijar horario para este día', 'Arbeitszeit für diesen Tag festlegen'],
        ExtendHoursToX: ['Extend to {0}', 'Extender hasta las {0}', 'Bis {0} verlängern'],
        HoursThisDay: ['Hours', 'Horario', 'Arbeitszeit'],
        OnlyThisDay: ['Only this day. The weekly hours stay as they are.', 'Solo este día. El horario semanal no cambia.', 'Nur an diesem Tag. Die Wochenarbeitszeit bleibt, wie sie ist.'],
        WorksTodayXYZ: ['{0} works today {1} – {2}', '{0} trabaja hoy de {1} a {2}', '{0} arbeitet heute von {1} bis {2}'],
        WorksOnXYZW: ['{0} works {1} – {2} on {3}', '{0} trabaja el {3} de {1} a {2}', '{0} arbeitet am {3} von {1} bis {2}'],
        OutsideHoursOfX: [", outside {0}'s hours", ', fuera del horario de {0}', ', außerhalb der Arbeitszeit von {0}'],
        ButOneStopNeedsSkillX: [", but 1 stop needs a skill {0} doesn't have", ', pero 1 parada necesita una habilidad que {0} no tiene', ', aber 1 Stopp braucht einen Skill, den {0} nicht hat'],
        ButStopsNeedSkillsXY: [", but {0} stops need skills {1} doesn't have", ', pero {0} paradas necesitan habilidades que {1} no tiene', ', aber {0} Stopps brauchen Skills, die {1} nicht hat'],
        ButOneStopOverCapacity: [', but 1 stop is more than the vehicle takes', ', pero 1 parada supera la capacidad del vehículo', ', aber 1 Stopp passt nicht mehr ins Fahrzeug'],
        ButStopsOverCapacityX: [', but {0} stops are more than the vehicle takes', ', pero {0} paradas superan la capacidad del vehículo', ', aber {0} Stopps passen nicht mehr ins Fahrzeug'],
        ButOneStopMissesWindow: [', but 1 stop misses its window', ', pero 1 parada no llega a su ventana horaria', ', aber 1 Stopp verpasst sein Zeitfenster'],
        ButStopsMissWindowsX: [', but {0} stops miss their windows', ', pero {0} paradas no llegan a su ventana horaria', ', aber {0} Stopps verpassen ihr Zeitfenster'],
        StopOutsideHoursX: ["outside {0}'s hours", 'fuera del horario de {0}', 'außerhalb der Arbeitszeit von {0}'],
        StopNeedsSkillX: ["needs a skill {0} doesn't have", 'necesita una habilidad que {0} no tiene', 'braucht einen Skill, den {0} nicht hat'],
        StopOverCapacity: ['more than the vehicle takes', 'supera la capacidad del vehículo', 'passt nicht mehr ins Fahrzeug'],
        StopMissesWindowX: ['misses its {0} window', 'no llega a su ventana horaria de {0}', 'verpasst sein Zeitfenster {0}'],
        StopMissesWindow: ['misses its window', 'no llega a su ventana horaria', 'verpasst sein Zeitfenster'],
        WindowOutsideHoursXYZ: ["its {0} window is outside {1}'s hours ({2})", 'su ventana horaria de {0} queda fuera del horario de {1} ({2})', 'sein Zeitfenster {0} liegt außerhalb der Arbeitszeit von {1} ({2})'],
        StopAfterHours: ['after hours', 'fuera de horario', 'nach Schichtende'],
        StopSkillMissing: ['skill missing', 'falta habilidad', 'Skill fehlt'],
        StopOverCapacityShort: ['over capacity', 'excede capacidad', 'über Kapazität'],
        StopNoAddress: ['no address', 'sin dirección', 'keine Adresse'],
        UnassignStop: ['Unassign', 'Quitar asignación', 'Zuweisung entfernen'],
        ShiftEndsAt: ['Shift ends {0}', 'Fin del turno {0}', 'Schichtende {0}'],
        DayFinishedLate: ['Done, {0} later than planned', 'Terminado, {0} más tarde de lo previsto', 'Fertig, {0} später als geplant'],
        DayFinishedEarly: ['Done, {0} earlier than planned', 'Terminado, {0} antes de lo previsto', 'Fertig, {0} früher als geplant'],
        DayFinishedOnPlan: ['Done as planned', 'Terminado según lo previsto', 'Fertig wie geplant'],
        ArrivesAfterWindow: ['Predicted to arrive after the time window', 'Se prevé que llegue después de la ventana horaria', 'Voraussichtliche Ankunft nach dem Zeitfenster'],
        EndLocation: ['End location', 'Ubicación final', 'Endpunkt'],
        IndividualRouteStartEndLocation: [
            'Individual (overrules team setting)',
            'Individual (anula la configuración del equipo)',
            'Individuell (überschreibt Team-Einstellung)',
        ],
        OnSiteTime: ['On site', 'Tiempo en sitio', 'Vor Ort'],
        WaitingTime: [
            "Waiting",
            "Espera",
            "Wartezeit",
        ],
        Lunch: ['Lunch', 'Almuerzo', 'Mittagspause'],
        LunchXY: ['Lunch {0}–{1}', 'Almuerzo {0}–{1}', 'Mittagspause {0}–{1}'],
        LunchBreakAfterStopX: ['Lunch break, after stop {0}', 'Pausa de almuerzo, después de la parada {0}', 'Mittagspause, nach Stopp {0}'],
        Routing: ['Routing', 'Enrutamiento', 'Routing'],
        RoutingDesc: [
            'Select the route start and end locations for your teams. This only applies to users who do not have their own route start and end locations set.',
            'Selecciona las ubicaciones de inicio y fin de ruta para tus equipos. Recuerda que solo aplica a los usuarios que no tienen configuradas ubicaciones de inicio / fin de ruta individuales.',
            'Wähle die Start- und Endorte für die Route pro Team aus. Beachte, dass dies nur für Nutzer gilt, für die keine individuellen Start-/Endpositionen für Routen festgelegt sind.',
        ],
        RoutingNothingSet: [
            "The route's first job will be the start location, and the route's last job will be the end location of the route.",
            'La primera tarea será la ubicación de inicio y la última tarea será la ubicación final de la ruta.',
            'Der erste Auftrag der Route ist der Startort, und der letzte Auftrag der Route ist der Endort der Route.',
        ],
        RoutingNothingSetDesc: [
            "No individual start and end locations are set for this user, and there are no start/end locations set for this user's team.",
            'No hay ubicaciones de inicio y fin de ruta establecidas para este usuario y no hay ubicaciones de inicio / fin establecidas para el equipo de este usuario.',
            'Für diesen Nutzer sind keine individuellen Start- und Endpositionen festgelegt, und für das Team dieses Nutzers sind keine Start-/Endpositionen festgelegt.',
        ],
        RoutingRouteStartTime: ['Route start time', 'Hora de inicio de ruta', 'Routenstart-Zeit'],
        RoutingSettings: ['Routing settings', 'Configuración de rutas', 'Routing-Einstellungen'],
        RoutingTeamUsed: [
            "The start and end locations of the user's team will be applied.",
            'Se aplicará la ubicación inicial y final del equipo del usuario.',
            'Der Start- und Endort des Teams wird angewendet.',
        ],
        RoutingTitle: [
            'Start and end locations for directions and route optimization',
            'Ubicaciones de inicio y fin para direcciones y optimización de rutas',
            'Start- und Endorte für die Routenberechnung und -optimierung',
        ],
        RoutingTravelMode: ['Travel mode', 'Modo de viaje', 'Reisemodus'],
        RoutingUseFixedHours: [
            'Use fixed route start time',
            'Usar hora fija de inicio de ruta',
            'Verwende fixe Routenstart-Zeit',
        ],
        RoutingUseWorkingHours: ['Use working hours', 'Usar horario de trabajo', 'Verwende Arbeitszeiten'],
        StartEndRouteLocation: ['Start/end route location', 'Ubicación inicio/final', 'Start-/Endpunkt der Route'],
        StartLocation: ['Start location', 'Ubicación de inicio', 'Startpunkt'],
        TeamRouting: ['Team routing', 'Enrutamiento del equipo', 'Team-Routing'],
        Travelling: ['Traveling', 'Viaje', 'Fahrt'],
        XStartsRouteAt: ['{0} starts route at', '{0} comienza la ruta a las', '{0} startet Route um'],
        RouteCalculationFailed: [
            "Route calculation was not successful. Probably a job location is not set or not accessible by road. Also check start and end location in routing settings.",
            "El cálculo de la ruta no fue exitoso. Probablemente una ubicación de tarea no está establecida o no se puede acceder por carretera. También verifica la ubicación de inicio y finalización en la configuración de enrutamiento.",
            "Die Routenberechnung war nicht erfolgreich. Wahrscheinlich ist ein Auftragsort nicht festgelegt oder nicht per Straße erreichbar. Überprüfe auch den Start- und Endstandort in den Routing-Einstellungen.",
        ],
        RouteCalculationFailedNoJobs: [
            "No jobs are assigned, so no route is needed.",
            "No hay tareas asignadas, por lo que no se necesita una ruta.",
            "Es sind keine Aufträge zugewiesen, daher ist keine Route erforderlich.",
        ],
        RouteCalculationFailedThrottled: [
            "Route calculation was throttled due to too many requests. Please retry in a moment.",
            "El cálculo de ruta fue limitado por demasiadas solicitudes. Inténtalo de nuevo en un momento.",
            "Die Routenberechnung wurde wegen zu vieler Anfragen gedrosselt. Bitte versuche es in Kürze erneut.",
        ],
        RouteCalculationFailedNoRoute: [
            "No drivable route was found. Check whether all job/start/end locations are reachable by road.",
            "No se encontró una ruta transitable. Verifica que todas las ubicaciones de tarea/inicio/fin sean accesibles por carretera.",
            "Es wurde keine befahrbare Route gefunden. Prüfe, ob alle Auftrags-/Start-/Endorte über Straßen erreichbar sind.",
        ],
        RouteCalculationFailedNoRegion: [
            "Route could not be calculated because waypoints are outside the supported routing regions.",
            "No se pudo calcular la ruta porque los puntos están fuera de las regiones de enrutamiento compatibles.",
            "Die Route konnte nicht berechnet werden, weil Wegpunkte außerhalb der unterstützten Routing-Regionen liegen.",
        ],
        RouteCalculationFailedTooManyWaypoints: [
            "Route could not be calculated because there are too many waypoints.",
            "No se pudo calcular la ruta porque hay demasiados puntos intermedios.",
            "Die Route konnte nicht berechnet werden, weil zu viele Wegpunkte vorhanden sind.",
        ],
        RouteCalculationFailedProviderException: [
            "Route calculation failed due to a temporary routing provider error. Please retry.",
            "El cálculo de ruta falló debido a un error temporal del proveedor de rutas. Inténtalo de nuevo.",
            "Die Routenberechnung ist wegen eines temporären Fehlers beim Routing-Anbieter fehlgeschlagen. Bitte erneut versuchen.",
        ],
        RouteCalculationFailedSanityRejected: [
            "Route was rejected because the distances look implausible. Check job coordinates and route start/end settings.",
            "La ruta fue rechazada porque las distancias parecen inverosímiles. Verifica las coordenadas de las tareas y la configuración de inicio/fin de ruta.",
            "Die Route wurde verworfen, weil die Distanzen unplausibel sind. Prüfe die Auftragskoordinaten und Start-/Endeinstellungen der Route.",
        ],
        NewRoute: [
            "New route",
            "Nueva ruta",
            "Neue Route",
        ],
        SendRouteNotificationToX: [
            "Send route change notification to {0}",
            "Enviar notificación de cambio de ruta a {0}",
            "Benachrichtigung über Routenänderung senden an {0}",
        ],
        RouteSimulationStarted: [
            "Route simulation started",
            "Simulación de ruta iniciada",
            "Routensimulation gestartet"
        ],
        RouteSimulationFinished: [
            "Route simulation finished",
            "Simulación de ruta finalizada",
            "Routensimulation abgeschlossen"
        ],
        SimulateRoute: ['Simulate the route (2 min)', 'Simular la ruta (2 min)', 'Route simulieren (2 Min.)'],
        StopSimulation: ['Stop simulation', 'Terminar simulación', 'Simulation stoppen'],
        SimulationOffDutyDesc: [
            'Route simulation does not work while off duty.',
            'La simulación de ruta no funciona mientras está fuera del horario de trabajo.',
            'Die Routensimulation funktioniert nicht, wenn der Nutzer außer Dienst ist.',
        ],
        VehicleCapacityDesc: [
            "This count is relevant for effective route optimization and auto-assignment. Make sure the vehicle's capacity for carrying these items is correctly set in the routing settings.",
            "Este conteo es relevante para la optimización efectiva de la ruta y la asignación automática. Asegúrate de que la capacidad del vehículo para llevar estos artículos esté correctamente definida en la configuración de rutas.",
            "Diese Anzahl ist relevant für eine effektive Routenoptimierung und automatische Zuweisung. Stelle sicher, dass die Kapazität des Fahrzeugs für den Transport dieser Gegenstände korrekt in den Routing-Einstellungen festgelegt ist."
        ],
        LoadCapacityDesc: [
            "Enter the maximum load capacity: specify the number of items this vehicle can carry. This information is crucial for optimizing routes and auto-assigning jobs, taking into account the pick-up and drop-off requirements of each task.",
            "Ingresa la capacidad máxima de carga: especifica la cantidad de artículos que este vehículo puede llevar. Esta información es crucial para optimizar rutas y asignar tareas automáticamente, teniendo en cuenta los requisitos de recogida y entrega de cada tarea.",
            "Gib die maximale Ladekapazität ein: Gib die Anzahl der Gegenstände an, die dieses Fahrzeug transportieren kann. Diese Informationen sind entscheidend für die Optimierung von Routen und die automatische Zuweisung von Aufträgen, unter Berücksichtigung der Abhol- und Lieferanforderungen jedes Auftrags."
        ],
        TravelModeDesc: [
            "Choose the type of vehicle used by this user. This choice is important to create the most efficient routes and provide accurate routing time estimates.",
            "Elige el tipo de vehículo utilizado por este usuario. Esta elección es importante para crear las rutas más eficientes y proporcionar estimaciones de tiempo de ruta precisas.",
            "Wähle die Art des Fahrzeugs, das von diesem Nutzer verwendet wird. Diese Wahl ist wichtig, um die effizientesten Routen zu erstellen und genaue Zeitabschätzungen für die Routenplanung zu liefern."
        ],
        SeeFullRoute: [
            "See full route on map",
            "Ver ruta completa en el mapa",
            "Vollständige Route in der Karte anzeigen",
        ],
        Skills: [
            "Skills",
            "Habilidades",
            "Skills",
        ],
        SkillsCaption: [
            "Enter the skills for this member to ensure accurate job routing based on required competencies.",
            "Ingresa las habilidades de este miembro para asegurar una asignación precisa de tareas basada en las competencias requeridas.",
            "Gib die Skills dieses Mitglieds ein, um eine genaue Zuweisung von Aufträgen basierend auf den erforderlichen Kompetenzen zu gewährleisten.",
        ],
        Expertise: [
            "Expertise",
            "Experiencia",
            "Fachkenntnisse"
        ],
        ExpertiseInfo: [
            "Helps the system auto-assign the best workers.",
            "Ayuda al sistema a asignar automáticamente a los mejores trabajadores.",
            "Hilft dem System, automatisch die besten Mitarbeiter zuzuweisen."
        ],
        ExpertiseCaption: [
            "Enter all relevant skills and expertise of this worker. Include what they are proficient in, tasks they can handle, and any specialties they have. Also, note any limitations—what they don’t do or areas they don’t cover. This helps assign the right jobs to the right people efficiently.",
            "Ingresa todas las habilidades y experiencia relevantes de este trabajador. Incluye en qué es competente, las tareas que puede manejar y cualquier especialidad que tenga. También señala cualquier limitación: lo que no hace o las áreas que no cubre. Esto ayuda a asignar las tareas correctas a las personas adecuadas de manera eficiente.",
            "Gib alle relevanten Skills und Fachkenntnisse dieses Mitarbeiters ein. Füge hinzu, worin er versiert ist, welche Aufgaben er bewältigen kann und welche Spezialisierungen er hat. Notiere auch alle Einschränkungen – was er nicht macht oder welche Bereiche er nicht abdeckt. Dies hilft, die richtigen Aufträge den richtigen Personen effizient zuzuweisen."
        ],
        SkillsPlaceholder: [
            "Electrical repairs, HVAC maintenance, basic plumbing",
            "Reparaciones eléctricas, mantenimiento de aire acondicionado, plomería básica",
            "Elektroreparaturen, Wartung von Heizung und Klima, einfache Sanitärarbeiten",
        ],
        ExpertisePlaceholder: [
            "- Expertise: Troubleshooting industrial HVAC systems, installing electrical wiring in residential buildings\n- Limitations: No experience with commercial refrigeration, does not handle gas line work\n- Operating Area: Los Angeles County, CA\n- Unavailable For: Weekend emergency calls, long-distance service requests",
            "- Experiencia: Diagnóstico de sistemas HVAC industriales, instalación de cableado eléctrico en edificios residenciales\n- Limitaciones: Sin experiencia en refrigeración comercial, no maneja trabajos de tuberías de gas\n- Área de operación: Ciudad de México y zona metropolitana\n- No disponible para: Llamadas de emergencia los fines de semana, solicitudes de servicio de larga distancia",
            "- Fachkenntnisse: Fehlerdiagnose bei industriellen HVAC-Systemen, Installation elektrischer Verkabelung in Wohngebäuden\n- Einschränkungen: Keine Erfahrung mit gewerblicher Kühlung, arbeitet nicht mit Gasleitungen\n- Einsatzgebiet: München und Umland\n- Nicht verfügbar für: Notdienste am Wochenende, Aufträge mit langer Anfahrt"
        ],
        MultiRouteOptimizationDescription: [
            "Multi-Route Optimization assigns up to 1000 jobs to multiple workers, considering constraints such as <strong>time windows</strong>, <strong>capacity</strong>, and <strong>skills</strong>.",
            "La optimización de múltiples rutas asigna hasta 1000 tareas a varios trabajadores, considerando restricciones como <strong>ventanas de tiempo</strong>, <strong>capacidad</strong> y <strong>habilidades</strong>.",
            "Die Multi-Routen-Optimierung weist bis zu 1000 Aufträge verschiedenen Mitarbeitern zu, unter Berücksichtigung von Einschränkungen wie <strong>Zeitfenstern</strong>, <strong>Kapazität</strong> und <strong>Skills</strong>."
        ],
        MultiRouteAlignment: [
            "It ensures that each route aligns with individual schedules and capabilities.",
            "Garantiza que cada ruta se alinee con los horarios y capacidades individuales.",
            "Es stellt sicher, dass jede Route mit den individuellen Zeitplänen und Fähigkeiten übereinstimmt."
        ],
        CreatingJobRoute: [
            "Creating a job route automatically generates a job for each stop. You can easily edit and customize each job after creation. Each job is assigned to the selected assignee and date.",
            "Crear una ruta de tareas generará automáticamente una tarea para cada parada. Puedes editar y personalizar cada tarea fácilmente después de su creación. Cada tarea se asignará a la persona y la fecha seleccionadas.",
            "Das Erstellen einer Auftragsroute generiert automatisch einen Auftrag für jeden Stopp. Du kannst jeden Auftrag nach der Erstellung leicht bearbeiten und anpassen. Er wird dem ausgewählten Zuständigen und Datum zugewiesen.",
        ],
    },
    Vehicles: {
        Vehicle: ['Vehicle', 'Vehículo', 'Fahrzeug'],
        VehicleCapacity: ['Vehicle capacity', 'Capacidad del vehículo', 'Kapazität des Fahrzeugs'],
        Vehicles: ['Vehicles', 'Vehículos', 'Fahrzeuge'],
    },
    TravelModes: {
        Bicycle: ['Bicycle', 'Bicicleta', 'Fahrrad'],
        Car: ['Car', 'Auto', 'Auto'],
        Motorcycle: ['Motorcycle', 'Motocicleta', 'Motorrad'],
        Pedestrian: ['Pedestrian', 'A pie', 'Fußgänger'],
        Truck: ['Truck', 'Camión', 'LKW'],
        Van: ['Van', 'Camioneta', 'Van'],
    },
    TeamManagement: {
        OverwriteProfileImageDesc: ["Current profile images will be replaced with initials. This action cannot be undone.", "Las imágenes de perfil actuales se reemplazarán con iniciales. Esta acción no se puede deshacer.", "Aktuelle Profilbilder werden durch Initialen ersetzt. Diese Aktion kann nicht rückgängig gemacht werden."],
        CreateNewInviteCode: [
            'Create new invite code',
            'Crear nuevo código de invitación',
            'Neuen Einladungscode erstellen',
        ],
        InviteCode: ['Invite code', 'Código de invitación', 'Einladungscode'],
        ManageInviteCodesDesc: [
            'Share the invite code with all your mobile team members with your messaging app of choice. On mobile, clicking the link will automatically forward to the Hellotracks app in iOS App Store or Android Play Store.',
            'Comparte el código de invitación con todos los miembros de tu equipo. En el dispositivo móvil, al hacer clic en el enlace, se redireccionará automáticamente a la aplicación Hellotracks en la App Store de iOS o Play Store de Android.',
            'Teile den Einladungscode mit allen Teammitgliedern mit der Messaging-App deiner Wahl. Auf dem Smartphone führt der Link automatisch zur Hellotracks-App im iOS App Store oder Android Play Store.',
        ],
        NewTeam: ['New team', 'Nuevo equipo', 'Neues Team'],
        NoActiveInviteCode: ['No active invite code', 'Sin código de invitación activo', 'Kein aktiver Einladungscode'],
        TeamName: ['Team name', 'Nombre del equipo', 'Teamname'],
        ThisInviteCodesExpiresInXDays: [
            'This invite code expires automatically in {0} days.',
            'Este código de invitación vence automáticamente en {0} días.',
            'Dieser Einladungscode läuft automatisch in {0} Tagen aus.',
        ],
        AddMemberToX: ['Add member to {0}', 'Agregar miembro a {0}', 'Mitglied zu {0} hinzufügen'],
        ImportMembers: ['Import members', 'Importar miembros', 'Mitglieder importieren'],
        DeleteTeamDesc: ['Do you want to delete this team?', '¿Quieres borrar este equipo?', 'Dieses Team wirklich löschen?'],
        RemoveXFromTeam: ['Remove {0} from this team', 'Quitar {0} del equipo', '{0} von diesem Team entfernen'],
        RemoveXFromY: ['Do you want to remove {0} from {1}?', '¿Quieres quitar {0} de {1}?', '{0} von {1} entfernen?'],
        NoTeamAssigned: [
            "No team assigned",
            "Sin equipo asignado",
            "Kein Team zugewiesen",
        ],
    },
    TripLists: {
        TripPurposeAndComment: [
            "Purpose and comment",
            "Propósito y comentario",
            "Zweck und Kommentar"
        ],
        TripPurposeList: [
            "Trip purpose list",
            "Lista de propósitos de viaje",
            "Fahrtzwecke",
        ],
        TripPurposeListCaption: [
            "This is a preset list of trip purposes. Workers have the option to assign a purpose to each trip from this list.",
            "Esta es una lista predefinida de propósitos de viaje. Los trabajadores tienen la opción de asignar un propósito a cada viaje de esta lista.",
            "Eine feste Auswahl an Fahrtzwecken. Mitarbeiter wählen daraus für jede Fahrt einen Zweck.",
        ],
        TripCommentList: [
            "Trip comment list",
            "Lista de comentarios de viaje",
            "Fahrtkommentare",
        ],
        TripCommentListCaption: [
            "This is a preset list of trip comments. Workers have the option to assign a comment to each trip from this list.",
            "Esta es una lista predefinida de comentarios de viaje. Los trabajadores tienen la opción de asignar un comentario a cada viaje de esta lista.",
            "Eine feste Auswahl an Kommentaren. Mitarbeiter wählen daraus für jede Fahrt einen Kommentar.",
        ],
    },
    CustomFields: {
        CustomFields: ['Custom fields', 'Campos personalizados', 'Zusätzliche Felder'],
        CustomFieldsDesc: [
            'Define custom key-value fields that are visible to workers in the mobile app. Use these for any job- or place-specific data like reference numbers, notes, or instructions.',
            'Define campos personalizados de clave-valor que son visibles para los trabajadores en la aplicación móvil. Úsalos para datos específicos como números de referencia, notas o instrucciones.',
            'Definiere benutzerdefinierte Schlüssel-Wert-Felder, die für Mitarbeiter in der mobilen App sichtbar sind. Verwende diese für auftrags- oder ortsspezifische Daten wie Referenznummern, Notizen oder Anweisungen.',
        ],
        EnterValue: ['Enter value', 'Ingresar valor', 'Wert eingeben'],
        FieldName: ['Field name', 'Nombre del campo', 'Feldname'],
        AddCustomField: [
            'Add custom field',
            'Agregar campo personalizado',
            'Zusätzliches Feld hinzufügen',
        ],
        DuplicatedFieldError: [
            'Fields must be unique.',
            'Los campos deben ser únicos.',
            'Die Felder müssen eindeutig sein.',
        ]
    },
    Grid: {
        // ag-grid's own texts (column filters), passed as localeText
        filterOoo: ["Filter...", "Filtrar...", "Filtern..."],
        contains: ["Contains", "Contiene", "Enthält"],
        notContains: ["Does not contain", "No contiene", "Enthält nicht"],
        equals: ["Equals", "Es igual a", "Ist gleich"],
        notEqual: ["Does not equal", "No es igual a", "Ist nicht gleich"],
        startsWith: ["Begins with", "Empieza con", "Beginnt mit"],
        endsWith: ["Ends with", "Termina con", "Endet mit"],
        blank: ["Blank", "Vacío", "Leer"],
        notBlank: ["Not blank", "No vacío", "Nicht leer"],
        lessThan: ["Less than", "Menor que", "Kleiner als"],
        greaterThan: ["Greater than", "Mayor que", "Größer als"],
        lessThanOrEqual: ["Less than or equal to", "Menor o igual que", "Kleiner oder gleich"],
        greaterThanOrEqual: ["Greater than or equal to", "Mayor o igual que", "Größer oder gleich"],
        inRange: ["Between", "Entre", "Zwischen"],
        before: ["Before", "Antes de", "Vor"],
        after: ["After", "Después de", "Nach"],
        andCondition: ["AND", "Y", "UND"],
        orCondition: ["OR", "O", "ODER"],
        applyFilter: ["Apply", "Aplicar", "Anwenden"],
        resetFilter: ["Reset", "Restablecer", "Zurücksetzen"],
        clearFilter: ["Clear", "Borrar", "Löschen"],
        cancelFilter: ["Cancel", "Cancelar", "Abbrechen"],
        noRowsToShow: ["No rows to show", "No hay filas para mostrar", "Keine Zeilen"],
        loadingOoo: ["Loading...", "Cargando...", "Wird geladen..."],
    },
    Company: {
        RecapTitle: ["Daily replay videos", "Videos diarios de replay", "Tägliche Replay-Videos"],
        RecapDesc: [
            "Every day, a cinematic 3D replay video of each selected member's workday is rendered and sent to the recipients below.",
            "Cada día se crea un video de replay en 3D con la jornada de cada miembro seleccionado y se envía a los destinatarios de abajo.",
            "Jeden Tag wird für jedes ausgewählte Mitglied ein 3D-Replay-Video seines Arbeitstags erstellt und an die Empfänger unten geschickt.",
        ],
        RecapEnable: ["Enable daily replay videos", "Activar videos diarios de replay", "Tägliche Replay-Videos aktivieren"],
        RecapSendAt: ["Send at (company local time)", "Enviar a las (hora local de la empresa)", "Senden um (Ortszeit des Unternehmens)"],
        RecapPreviousDay: ["previous day", "día anterior", "Vortag"],
        RecapMembersCaption: ["Leave empty to include all members with tracking.", "Déjalo vacío para incluir a todos los miembros con seguimiento.", "Leer lassen, um alle Mitglieder mit Tracking einzuschließen."],
        RecapAllMembers: ["All members", "Todos los miembros", "Alle Mitglieder"],
        RecapDigest: ["Morning digest email", "Correo de resumen por la mañana", "Zusammenfassung am Morgen per E-Mail"],
        RecapDigestCaption: [
            "One summary email with all replays of the day — press Enter after each address.",
            "Un correo con todos los replays del día. Presiona Enter después de cada dirección.",
            "Eine E-Mail mit allen Replays des Tages. Drück nach jeder Adresse Enter.",
        ],
        RecapPush: ["Also send each member their own video as push notification", "Enviar también a cada miembro su propio video como notificación push", "Jedem Mitglied sein eigenes Video zusätzlich als Push-Benachrichtigung senden"],
        CheckIns: [
            "Auto check-ins at places and jobs",
            "Check-ins automáticos en lugares y tareas",
            "Automatisches Ein- und Auschecken an Orten und bei Aufträgen",
        ],
        ZoneCheckIns: [
            "Check-ins at zones",
            "Check-ins en zonas",
            "Ein- und Auschecken in Zonen",
        ],
        CheckInArea: [
            'Area size for check-ins at jobs',
            'Tamaño del área para check-ins en tareas',
            'Größe für Check-ins bei Aufträgen'
        ],
        CheckInDelayMessage: [
            "Check-ins shorter than the configured delay are ignored in reports, and check-in alerts are only sent once the delay has passed.",
            "Los check-ins más cortos que el retraso configurado se ignoran en los informes, y las alertas de check-in solo se envían una vez transcurrido el retraso.",
            "Check-ins, die kürzer sind als die konfigurierte Verzögerung, werden in Berichten ignoriert. Check-in-Alarme werden erst nach Ablauf der Verzögerung gesendet."
        ],
        CheckInBigRadius: ['Big geofence (~300m/1000ft)', 'Geocerca grande (300m)', 'Große Geofence (300m)'],
        CheckInDelay: ['Delay', 'Retraso', 'Verzögerung'],
        CheckInShortRadius: ['Small geofence (~100m/330ft)', 'Geocerca pequeña (100m)', 'Kleine Geofence (100m)'],
        Company: ['Company', 'Empresa', 'Unternehmen'],
        CompanyName: ['Company name', 'Nombre de la empresa', 'Name des Unternehmens'],
        EnterCompanyName: ["Enter company name", "Ingresar nombre de la empresa", "Name des Unternehmens eingeben"],
        CompanySettings: ['Settings', 'Configuración', 'Unternehmenseinstellungen'],
        QuickSetup: ["Quick setup", "Configuración rápida", "Schnelleinrichtung"],
        CompanySetupShortDesc: [
            'Your address becomes your first place on the map, so arrivals and departures are tracked automatically. You can change it anytime.',
            'Tu dirección será tu primer lugar en el mapa, así las llegadas y salidas se registran automáticamente. Puedes cambiarla cuando quieras.',
            'Deine Adresse wird dein erster Ort auf der Karte, damit Ankünfte und Abfahrten automatisch erfasst werden. Du kannst sie jederzeit ändern.',
        ],
        CreateCompany: ['Open my map', 'Abrir mi mapa', 'Meine Karte öffnen'],
        CompanySetupTitle: ['Your company location', 'La dirección de la empresa', 'Adresse des Unternehmens'],
        SearchForYourCompany: ["Search for your company", "Busca tu empresa", "Suche nach deinem Unternehmen"],
        DeleteTracksOlderThan: ['Delete trips older than', 'Borrar viajes de más de', 'Fahrten löschen, die älter sind als'],
        EnableAutoCheckin: [
            'Enable auto check-ins at places and jobs. With check-ins you get notified on arrivals and departures at your places and jobs.',
            'Permitir check-ins automáticos en lugares y tareas. Con los check-ins se te notifica sobre las llegadas y salidas de tus lugares y tareas.',
            'Aktiviere automatische Check-ins an Orten und bei Aufträgen. Mit Check-ins wirst du benachrichtigt, wenn jemand an deinen Orten und Aufträgen ankommt oder wieder geht.',
        ],
        EnableZoneCheckin: [
            "Enable automatic check-ins at zones. If enabled, you will receive notifications upon entering and exiting the regions of your zones.",
            "Habilitar check-ins automáticos en zonas. Si está activado, recibirás notificaciones al entrar y salir de las regiones de tus zonas.",
            "Automatische Check-ins in Zonen aktivieren. Wenn aktiviert, erhältst du Benachrichtigungen beim Betreten und Verlassen der Regionen deiner Zonen."
        ],
        JobGroups: [
            'Job groups',
            'Grupos de tareas',
            'Auftragsgruppen',
        ],
        JobGroupsDesc: [
            'Use job groups to bundle related jobs, keep multi-stop work organized, and move or assign them together.',
            'Usa grupos de tareas para reunir tareas relacionadas, organizar trabajos con varias paradas y moverlas o asignarlas juntas.',
            'Nutze Auftragsgruppen, um zusammengehörige Aufträge zu bündeln, Arbeiten mit mehreren Stopps übersichtlich zu halten und sie gemeinsam zu verschieben oder zuzuweisen.',
        ],
        Notifications: ['Notifications', 'Notificaciones', 'Benachrichtigungen'],
        OvernightJobs: ['Overnight jobs', 'Tareas durante la noche', 'Aufträge über Nacht'],
        OvernightJobsDesc: [
            "Hold worker's assigned jobs overnight until working hours end.",
            'Mantener las tareas asignadas durante la noche hasta que termine el horario laboral del trabajador.',
            'Die zugewiesenen Aufträge über Nacht halten, bis die Arbeitszeiten des Mitarbeiters enden.',
        ],
        EnableJobGroups: [
            'Enable job groups in Dispatch',
            'Habilitar grupos de tareas en Despacho',
            'Auftragsgruppen in der Disposition aktivieren',
        ],
        SendEmailOnNewMessage: [
            'Send email notification on new messages',
            'Enviar notificación por correo al recibir nuevos mensajes',
            'E-Mail-Benachrichtigung bei neuen Nachrichten senden',
        ],
        SnoozeNotificationsDesc: [
            'Hide live pop-up notifications for everyone in this company on web. Personal snooze still applies in addition.',
            'Oculta las notificaciones emergentes en vivo para todos en esta empresa en la web. El silencio personal sigue aplicándose además.',
            'Blendet Live-Popup-Benachrichtigungen im Web für alle in dieser Firma aus. Die persönliche Stummschaltung gilt zusätzlich.',
        ],
        StatusLabelList: ['Status list', 'Lista de estados', 'Statusliste'],
        StatusLabelSection: [
            'Predefined statuses workers can pick from, e.g. Available, Busy, On Leave',
            'Estados predefinidos para que los miembros elijan, p. ej. Disponible, Ocupado, Ausente',
            'Vordefinierte Status, aus denen Mitarbeiter wählen können, z. B. Verfügbar, Beschäftigt, Abwesend',
        ],
        TabPermissions: [
            'Permissions',
            'Permisos',
            'Berechtigungen',
        ],
        TabGeneral: [
            'General',
            'General',
            'Allgemein',
        ],
        LanguageAndFormats: [
            'Language & formats',
            'Idioma y formatos',
            'Sprache & Formate',
        ],
        TabLocationTracking: [
            'Location & tracking',
            'Ubicación y seguimiento',
            'Standort & Tracking',
        ],
        RoleAdministrators: [
            'Administrators',
            'Administradores',
            'Administratoren',
        ],
        RoleOperators: [
            'Operators',
            'Operadores',
            'Disponenten',
        ],
        RoleWorkers: [
            'Workers',
            'Trabajadores',
            'Mitarbeiter',
        ],
        AdminsRoleDesc: [
            'Administrators have every permission, including adding and removing members. They can use the web dashboard and the mobile app, are never visible to operators or workers, and see every member\'s location, other administrators included.',
            'Los administradores tienen todos los permisos, incluido agregar y eliminar miembros. Pueden usar el panel web y la app móvil, nunca son visibles para operadores ni trabajadores, y ven la ubicación de todos los miembros, incluidos otros administradores.',
            'Administratoren haben alle Berechtigungen, auch Mitglieder hinzuzufügen und zu entfernen. Sie können Web-Dashboard und App nutzen, sind für Disponenten und Mitarbeiter nie sichtbar und sehen den Standort aller Mitglieder, auch anderer Administratoren.',
        ],
        OperatorsRoleDesc: [
            'Operators use the web dashboard to watch live location and dispatch jobs.',
            'Los operadores usan el panel web para ver la ubicación en vivo y asignar tareas.',
            'Disponenten nutzen das Web-Dashboard, um Live-Standorte zu sehen und Aufträge zu disponieren.',
        ],
        WorkersRoleDesc: [
            'Workers use the mobile app only. They see their own jobs, their own trips and, if allowed below, their team.',
            'Los trabajadores usan solo la app móvil. Ven sus propias tareas, sus propios viajes y, si se permite abajo, su equipo.',
            'Mitarbeiter nutzen nur die App. Sie sehen ihre eigenen Aufträge, ihre eigenen Fahrten und, wenn unten erlaubt, ihr Team.',
        ],
        GroupOnTheMap: [
            'On the map',
            'En el mapa',
            'Auf der Karte',
        ],
        GroupTracking: [
            'Tracking',
            'Seguimiento',
            'Tracking',
        ],
        GroupTrips: [
            'Trips',
            'Viajes',
            'Fahrten',
        ],
        GroupJobs: [
            'Jobs',
            'Tareas',
            'Aufträge',
        ],
        GroupPlacesZones: [
            'Places and zones',
            'Lugares y zonas',
            'Orte und Zonen',
        ],
        GroupMessages: [
            'Messages',
            'Mensajes',
            'Nachrichten',
        ],
        WorkerSeeTeam: [
            'See members of the same team',
            'Ver a los miembros del mismo equipo',
            'Mitglieder des eigenen Teams sehen',
        ],
        WorkerSeeTeamHelp: [
            'Other teams and administrators stay hidden',
            'Otros equipos y los administradores quedan ocultos',
            'Andere Teams und Administratoren bleiben verborgen',
        ],
        WorkerTrackingOff: [
            'Deactivate tracking',
            'Desactivar el seguimiento',
            'Tracking deaktivieren',
        ],
        WorkerTrackingOffHelp: [
            'A worker can pause sharing their own location',
            'Un trabajador puede pausar el envío de su ubicación',
            'Ein Mitarbeiter kann das Teilen seines Standorts pausieren',
        ],
        WorkerBatterySave: [
            'Battery save mode',
            'Modo de ahorro de batería',
            'Energiesparmodus',
        ],
        WorkerBatterySaveHelp: [
            'Lowers location accuracy while on',
            'Reduce la precisión de la ubicación mientras está activo',
            'Verringert die Standortgenauigkeit, solange er aktiv ist',
        ],
        WorkerTrackWorkingHours: [
            'Track only during working hours',
            'Seguir solo en horario laboral',
            'Nur während der Arbeitszeit tracken',
        ],
        WorkerTrackWorkingHoursHelp: [
            'Individual or team hours, whichever is set',
            'Horario individual o del equipo, el que esté definido',
            'Individuelle oder Team-Arbeitszeit, je nachdem, was gesetzt ist',
        ],
        WorkerEditWorkingHours: [
            'Edit own working hours',
            'Editar su propio horario laboral',
            'Eigene Arbeitszeiten bearbeiten',
        ],
        WorkerAddTrips: [
            'Add and edit trips',
            'Agregar y editar viajes',
            'Fahrten hinzufügen und bearbeiten',
        ],
        WorkerAddTripsHelp: [
            'Manual trips count toward mileage',
            'Los viajes manuales cuentan para el kilometraje',
            'Manuelle Fahrten zählen zu den gefahrenen Kilometern',
        ],
        WorkerTripsApproval: [
            'Added or edited trips need approval',
            'Los viajes agregados o editados necesitan aprobación',
            'Hinzugefügte oder bearbeitete Fahrten müssen genehmigt werden',
        ],
        WorkerTripsApprovalHelp: [
            'They show as Pending review until an operator approves',
            'Aparecen como Pendiente de revisión hasta que un operador los apruebe',
            'Sie erscheinen als „Prüfung ausstehend“, bis ein Disponent sie genehmigt',
        ],
        WorkerJobCalendar: [
            'Job calendar',
            'Calendario de tareas',
            'Auftragskalender',
        ],
        WorkerJobCalendarHelp: [
            'Days ahead, not only today\'s route',
            'Los próximos días, no solo la ruta de hoy',
            'Kommende Tage, nicht nur die heutige Route',
        ],
        WorkerCreateJobs: [
            'Create own jobs',
            'Crear sus propias tareas',
            'Eigene Aufträge anlegen',
        ],
        WorkerCreateJobsHelp: [
            'They appear on their route and in Dispatch',
            'Aparecen en su ruta y en Despacho',
            'Sie erscheinen auf der Route und in der Disposition',
        ],
        WorkerMoveJobDate: [
            'Move a job to another day',
            'Mover una tarea a otro día',
            'Einen Auftrag auf einen anderen Tag verschieben',
        ],
        WorkerRelocateJob: [
            'Change a job\'s location',
            'Cambiar la ubicación de una tarea',
            'Den Standort eines Auftrags ändern',
        ],
        WorkerOptimizeRoute: [
            'Optimize own route',
            'Optimizar su propia ruta',
            'Eigene Route optimieren',
        ],
        WorkerRejectJob: [
            'Reject a job',
            'Rechazar una tarea',
            'Einen Auftrag ablehnen',
        ],
        WorkerRejectJobHelp: [
            'With auto-reassign, a rejected job goes to the nearest worker',
            'Con reasignación automática, una tarea rechazada pasa al trabajador más cercano',
            'Mit automatischer Neuzuweisung geht ein abgelehnter Auftrag an den nächsten Mitarbeiter',
        ],
        RejectNever: [
            'Never',
            'Nunca',
            'Nie',
        ],
        RejectAllowed: [
            'Allowed',
            'Permitido',
            'Erlaubt',
        ],
        RejectAutoReassign: [
            'Auto-reassign',
            'Reasignar auto.',
            'Autom. neu zuweisen',
        ],
        WorkerCreatePlaces: [
            'Create and edit places',
            'Crear y editar lugares',
            'Orte anlegen und bearbeiten',
        ],
        WorkerPlacesVisible: [
            'Places visible in the app',
            'Lugares visibles en la app',
            'Sichtbare Orte in der App',
        ],
        WorkerZonesVisible: [
            'Zones visible in the app',
            'Zonas visibles en la app',
            'Sichtbare Zonen in der App',
        ],
        ChoiceSameTeam: [
            'Same team',
            'Mismo equipo',
            'Eigenes Team',
        ],
        ChoiceAssigned: [
            'Assigned',
            'Asignadas',
            'Zugewiesene',
        ],
        ChoiceAll: [
            'All',
            'Todas',
            'Alle',
        ],
        WorkerMessageTeam: [
            'Message members of the same team',
            'Enviar mensajes a los miembros del mismo equipo',
            'Mitgliedern des eigenen Teams schreiben',
        ],
        WorkerMessageTeamHelp: [
            'Operators and administrators can always be messaged',
            'A operadores y administradores siempre se les puede escribir',
            'Disponenten und Administratoren können immer angeschrieben werden',
        ],
        GroupForms: [
            'Forms',
            'Formularios',
            'Formulare',
        ],
        WorkerWebForms: [
            'Fill in forms on the web',
            'Completar formularios en la web',
            'Formulare im Web ausfüllen',
        ],
        WorkerWebFormsHelp: [
            'Workers sign in at {0} and see only your forms, nothing else',
            'Los trabajadores entran en {0} y solo ven tus formularios, nada más',
            'Mitarbeiter melden sich unter {0} an und sehen nur eure Formulare, sonst nichts',
        ],
        OperatorSeeOtherTeams: [
            'See workers of other teams',
            'Ver a los trabajadores de otros equipos',
            'Mitarbeiter anderer Teams sehen',
        ],
        OperatorSeeAdmins: [
            'See administrators and assign them jobs',
            'Ver a los administradores y asignarles tareas',
            'Administratoren sehen und ihnen Aufträge zuweisen',
        ],
        OperatorVisible: [
            'Visible on the map and can receive jobs',
            'Visible en el mapa y puede recibir tareas',
            'Auf der Karte sichtbar und kann Aufträge erhalten',
        ],
        OperatorVisibleHelp: [
            'Treated like a worker in Dispatch',
            'Se trata como un trabajador en Despacho',
            'Wird in der Disposition wie ein Mitarbeiter behandelt',
        ],
        OperatorJobVisibility: [
            'Jobs visible in Dispatch',
            'Tareas visibles en Despacho',
            'Sichtbare Aufträge in der Disposition',
        ],
        JobsTeamOrUnassigned: [
            'Team or unassigned',
            'Del equipo o sin equipo',
            'Team oder ohne Team',
        ],
        JobsTeamOnly: [
            'Team only',
            'Solo del equipo',
            'Nur Team',
        ],
        OperatorDeleteJobs: [
            'Delete jobs',
            'Eliminar tareas',
            'Aufträge löschen',
        ],
        NoCompanyAcc: [
            "No company account",
            "Sin cuenta de empresa",
            "Kein Firmenkonto",
        ],
        TrackingAndLocation: [
            "Location data",
            "Datos de ubicación",
            "Standortdaten",
        ],
        AdvancedMobileSettings: [
            "Advanced mobile app settings",
            "Configuración avanzada para la aplicación móvil",
            "Erweiterte Einstellungen für die Mobil-App",
        ],
        Profile: [
            "Company profile",
            "Perfil de la empresa",
            "Unternehmensprofil",
        ],
        SelectZones: [
            "Select zones",
            "Seleccionar zonas",
            "Zonen auswählen",
        ],
        RestrictLocationLabel: [
            "Limit location data to specific zones",
            "Limitar datos de ubicación a zonas específicas",
            "Standortdaten auf bestimmte Zonen beschränken"
        ],
        RestrictLocationDesc: [
            "Note: Location data will not be registered outside the selected zones. Only choose this option if you want tracking to be confined to a specific area for everyone.",
            "Nota: Los datos de ubicación no se registrarán fuera de las zonas seleccionadas. Elige esta opción solo si deseas que el seguimiento se limite a un área específica para todos.",
            "Hinweis: Standortdaten werden außerhalb der ausgewählten Zonen nicht registriert. Wähle diese Option nur, wenn du möchtest, dass das Tracking für alle auf einen bestimmten Bereich beschränkt ist.",
        ],
        JobData: [
            "Job data",
            "Datos de tareas",
            "Auftragsdaten"
        ],
        AutoArchiveJobsDesc: [
            "Stale jobs are archived after their last activity, so only active jobs stay in view. Archived jobs can still be reassigned when needed.",
            "Las tareas obsoletas se archivan después de su última actividad, así solo quedan a la vista las tareas activas. Las tareas archivadas se pueden reasignar cuando sea necesario.",
            "Veraltete Aufträge werden nach ihrer letzten Aktivität archiviert, sodass nur aktive Aufträge sichtbar bleiben. Archivierte Aufträge können bei Bedarf neu zugewiesen werden."
        ],
        AutoArchiveJobs: [
            "Automatically archive stale jobs after",
            "Archivar automáticamente tareas obsoletas después de",
            "Automatisches Archivieren von veralteten Aufträgen nach"
        ],
        AutoDeleteJobsDesc: [
            "Archived jobs are permanently deleted after the chosen time. This keeps your workspace tidy and protects privacy.",
            "Las tareas archivadas se eliminan definitivamente después del tiempo elegido. Así tu espacio de trabajo se mantiene ordenado y se protege la privacidad.",
            "Archivierte Aufträge werden nach der gewählten Zeit endgültig gelöscht. Das hält deinen Arbeitsbereich übersichtlich und schützt die Privatsphäre."
        ],
        AutoDeleteJobs: [
            "Automatically delete archived jobs after",
            "Eliminar automáticamente tareas archivadas después de",
            "Automatisches Löschen von archivierten Aufträgen nach"
        ]
    },
    Attachments: {
        Attachment: ['Attachment', 'Adjunto', 'Anhang'],
        Attachments: ['Attachments', 'Adjuntos', 'Anhänge'],
        AttachmentsDesc: [
            'You can add attachments as URLs such as Google Forms, PDFs or images. Workers in the field have access to these attachments.',
            'Puedes agregar archivos adjuntos como URL, p. ej. Google Forms, PDF o imágenes. Los trabajadores en el campo tendrán acceso a estos archivos.',
            'Du kannst Anhänge als URLs hinzufügen, z. B. Google Forms, PDFs oder Bilder. Mitarbeiter vor Ort haben Zugriff auf diese Anhänge.',
        ],
        SaveTemplate: [
            "Use these attachments for new jobs",
            "Usar estos adjuntos en las tareas nuevas",
            "Diese Anhänge für neue Aufträge verwenden",
        ],
        ClearTemplate: [
            "Start new jobs without attachments",
            "Crear las tareas nuevas sin adjuntos",
            "Neue Aufträge ohne Anhänge anlegen",
        ],
    },
    ShortForm: {
        ShortFormDesc: [
            'Workers can fill out a form when completing a job and upload images and a signature. You can choose between a standard completion form shared by multiple jobs or an individual completion form for this job.',
            'Los trabajadores pueden completar un formulario al finalizar una tarea, cargar imágenes y una firma. Puedes elegir entre un formulario de finalización estándar compartido por varias tareas o un formulario de finalización individual para esta tarea.',
            'Mitarbeiter können nach Abschluss eines Auftrags ein Formular ausfüllen, Bilder und eine Unterschrift hochladen. Du kannst zwischen einem Standard-Formular für Auftragsabschluss, das von mehreren Aufträgen geteilt wird, und einem individuellen Formular für diesen Auftrag wählen.',
        ],
        ShortFormTitle: [
            'Form on job completion',
            'Formulario al finalizar la tarea',
            'Formular für Auftragsabschluss',
        ],
        UseIndividualForm: [
            'Use individual form',
            'Usar formulario individual',
            'Individuelles Formular verwenden',
        ],
        UseStandardForm: [
            'Use standard form',
            'Usar formulario estándar',
            'Standard-Formular verwenden',
        ],
        SwitchBackStandardFormDesc: [
            'Switching back to the standard completion form erases the current individual form.',
            'Al volver al formulario de finalización estándar, se eliminará el formulario individual actual.',
            'Beim Zurückwechseln zum Standard-Formular für Auftragsabschluss wird das aktuelle individuelle Formular gelöscht.',
        ],
        StandardForm: [
            'Standard form',
            'Formulario estándar',
            'Standard-Formular',
        ],
        ConfigurationOfIndividualForm: [
            'Configure form for this job',
            'Configurar formulario para esta tarea',
            'Formular für diesen Auftrag konfigurieren',
        ]
    },
    Archive: {
        Archive: ['Archive', 'Archivar', 'Archivieren'],
        ArchiveDescription: [
            'Do you want to archive the selected jobs? Archived jobs will disappear from the list but you can always easily restore them afterwards.',
            '¿Quieres archivar las tareas seleccionadas? Las tareas archivadas desaparecen de la lista, pero puedes restablecerlas en cualquier momento.',
            'Ausgewählte Aufträge archivieren? Archivierte Aufträge werden in der Tabelle ausgeblendet, können aber jederzeit wiederhergestellt werden.',
        ],
        ArchiveXJobs: ['Archive {0} jobs', 'Archivar {0} tareas', '{0} Aufträge archivieren'],
        Archived: ['Archived', 'Archivado', 'Archiviert'],
        Restore: ['Restore', 'Restablecer', 'Wiederherstellen'],
        RestoreDescription: [
            'Restore selected jobs?',
            '¿Restablecer las tareas seleccionadas?',
            'Ausgewählte Aufträge wiederherstellen?'
        ],
    },
    Clone: {
        Clone: ['Clone', 'Duplicar', 'Klonen'],
        CloneJob: ['Clone job', 'Duplicar tarea', 'Auftrag klonen'],
        CloningCreatesADuplicateOfThisJob: [
            'Cloning creates a duplicate of this job',
            'Duplicar crea una copia de esta tarea',
            'Ein Duplikat dieses Auftrags erstellen',
        ],
    },
    JobTemplates: {
        JobTemplateDesc: [
            'This is a job template. New jobs can apply this template with prefilled fields. Leave fields empty if they should not be applied.',
            'Esta es una plantilla de tarea. Las nuevas tareas pueden usar esta plantilla con campos predeterminados. Deja los campos vacíos si no aplican.',
            'Dies ist eine Auftragsvorlage. Neue Aufträge können diese Vorlage mit vorausgefüllten Feldern anwenden. Felder können leer gelassen werden, wenn sie nicht angewendet werden sollen.',
        ],
        JobTemplates: ['Templates', 'Plantillas', 'Vorlagen'],
        JobTemplatesDesc: [
            'Job templates make it easy to create jobs with prefilled values. You can create job templates by saving an existing job as a job template.',
            'Las plantillas de tareas facilitan la creación de tareas con valores predeterminados. Puedes crear plantillas de tareas cuando guardas una tarea existente como plantilla.',
            'Vorlagen erleichtern das Erstellen von Aufträgen mit vorausgefüllten Werten. Vorlagen können erstellt werden, indem ein vorhandener Auftrag als Vorlage abgespeichert wird.',
        ],
        JobTemplateCreateDesc: [
            "Create new job from this template",
            "Crear nueva tarea con esta plantilla",
            "Neuen Auftrag aus dieser Vorlage erstellen",
        ],
        CreateNewJobFromTemplate: [
            "Create new job from template",
            "Crear nueva tarea con plantilla",
            "Neuen Auftrag aus Vorlage erstellen",
        ],
        StartFromSearch: ["Search an address, place, template or recent job", "Busca una dirección, lugar, plantilla o tarea reciente", "Adresse, Ort, Vorlage oder letzten Auftrag suchen"],
        BlankJob: ["Blank job", "Tarea en blanco", "Leerer Auftrag"],
        BlankJobHint: ["Point on the map next", "Después lo marcas en el mapa", "Danach markierst du ihn auf der Karte"],
        RecentJobs: ["Recent jobs", "Tareas recientes", "Letzte Aufträge"],
        Again: ["Again", "Otra vez", "Nochmal"],
        UsedXTimes: ["used {0}×", "usada {0}×", "{0}× genutzt"],
        MadeXTimes: ["{0}× in 30 days", "{0}× en 30 días", "{0}× in 30 Tagen"],
        LastXForY: ["last {0}, {1}", "última {0}, {1}", "zuletzt {0}, {1}"],
        LastX: ["last {0}", "última {0}", "zuletzt {0}"],
        ForX: ["for {0}", "para {0}", "für {0}"],
        NothingFound: ["Nothing matches. Enter starts a blank job to point on the map.", "No hay coincidencias. Con Enter empiezas una tarea en blanco y la marcas en el mapa.", "Nichts gefunden. Mit Enter startest du einen leeren Auftrag und markierst ihn auf der Karte."],
        Untitled: ["Untitled", "Sin título", "Ohne Titel"],
        IdenticalX: ["{0} identical templates", "{0} plantillas idénticas", "{0} gleiche Vorlagen"],
        UnassignedJobs: ["Unassigned jobs", "Tareas sin asignar", "Nicht zugewiesene Aufträge"],
        Assign: ["Assign", "Asignar", "Zuweisen"],
        DistanceFromXY: ["{0} from {1}", "a {0} de {1}", "{0} von {1}"],
    },
    LocationField: {
        Field: ["Field", "Campo", "Feld"],
        Legend: ["Legend", "Leyenda", "Legende"],
        LegendOut: ["Out, first to last move", "Fuera, del primer al último movimiento", "Unterwegs, erste bis letzte Bewegung"],
        LegendNow: ["Now", "Ahora", "Jetzt"],
        Everyone: ["Everyone", "Todos", "Alle"],
        AllTeams: ["All teams", "Todos los equipos", "Alle Teams"],
        NoTeam: ["No team", "Sin equipo", "Ohne Team"],
        OutOfXFromY: ["{0} of {1} people were out, from {2}.", "{0} de {1} personas estuvieron en ruta, desde las {2}.", "{0} von {1} Personen waren unterwegs, ab {2}."],
        OutOfXTodayFromY: ["{0} of {1} people are out today, since {2}.", "{0} de {1} personas están en ruta hoy, desde las {2}.", "{0} von {1} Personen sind heute unterwegs, seit {2}."],
        DrivenX: ["{0} driven", "{0} recorridos", "{0} gefahren"],
        NobodyOut: ["Nobody was out on this day.", "Nadie estuvo en ruta este día.", "An diesem Tag war niemand unterwegs."],
        NobodyOutYet: ["Nobody is out yet today.", "Todavía nadie está en ruta hoy.", "Heute ist noch niemand unterwegs."],
        ShowYesterday: ["Show yesterday", "Ver ayer", "Gestern zeigen"],
        OneWithGaps: ["1 with gaps", "1 con huecos", "1 mit Lücken"],
        WithGapsX: ["{0} with gaps", "{0} con huecos", "{0} mit Lücken"],
        OneTripToReview: ["1 trip to review", "1 viaje por revisar", "1 Fahrt zu prüfen"],
        TripsToReviewX: ["{0} trips to review", "{0} viajes por revisar", "{0} Fahrten zu prüfen"],
        OneStartedLate: ["1 started late", "1 empezó tarde", "1 hat spät angefangen"],
        StartedLateX: ["{0} started late", "{0} empezaron tarde", "{0} haben spät angefangen"],
        LateStart: ["late start", "inicio tarde", "später Start"],
        NotOutX: ["{0} not out", "{0} sin actividad", "{0} nicht unterwegs"],
        Office: ["office", "oficina", "Büro"],
        NeverSignedIn: ["invited, never logged in", "invitado, nunca inició sesión", "eingeladen, nie angemeldet"],
        TrackingOff: ["tracking off", "seguimiento desactivado", "Tracking aus"],
        NoTripsOrStops: ["no trips or stops", "sin viajes ni paradas", "keine Fahrten oder Stopps"],
        OutSoFarXFromY: ["{0} people out so far, from {1}.", "{0} personas en ruta hasta ahora, desde las {1}.", "Bisher {0} Personen unterwegs, ab {1}."],
        MoreToCheckX: ["{0} more people to check.", "Quedan {0} personas por revisar.", "Noch {0} Personen zu prüfen."],
        LoadNextX: ["Load the next {0}", "Cargar las siguientes {0}", "Die nächsten {0} laden"],
        NoLocationToday: ["no location today", "sin ubicación hoy", "heute kein Standort"],
        ShowXMore: ["Show {0} more", "Mostrar {0} más", "{0} weitere anzeigen"],
        LoadingXOfY: ["Loading {0} of {1} days…", "Cargando {0} de {1} días…", "{0} von {1} Tagen werden geladen…"],
        OneDayNotLoaded: ["1 day didn't load.", "1 día no se cargó.", "1 Tag wurde nicht geladen."],
        DaysNotLoadedX: ["{0} days didn't load.", "{0} días no se cargaron.", "{0} Tage wurden nicht geladen."],
        TryAgain: ["Try again", "Volver a intentar", "Nochmal versuchen"],
        PickPeopleForTrips: ["Pick people above to list their trips.", "Elige personas arriba para ver sus viajes.", "Wähl oben Personen aus, um ihre Fahrten zu sehen."],
        PickPersonForDay: ["Pick a person in Field to open their day.", "Elige una persona en Campo para ver su día.", "Wähl eine Person im Feld, um ihren Tag zu öffnen."],
        BackToField: ["‹ Field", "‹ Campo", "‹ Feld"],
        HoverLineX: ["{0} – {1} · {2} · {3} on site · {4} driving", "{0} – {1} · {2} · {3} en el sitio · {4} de manejo", "{0} – {1} · {2} · {3} vor Ort · {4} Fahrzeit"],
    },
    LocationDay: {
        Day: ["Day", "Día", "Tag"],
        Trips: ["Trips", "Viajes", "Fahrten"],
        Team: ["Team", "Equipo", "Team"],
        OutFromXToY: ["Out from {0} to {1}.", "En ruta de {0} a {1}.", "Unterwegs von {0} bis {1}."],
        OutSinceX: ["Out since {0}.", "En ruta desde las {0}.", "Unterwegs seit {0}."],
        OneJob: ["1 job", "1 tarea", "1 Auftrag"],
        JobsX: ["{0} jobs", "{0} tareas", "{0} Aufträge"],
        OneStop: ["1 stop", "1 parada", "1 Stopp"],
        StopsX: ["{0} stops", "{0} paradas", "{0} Stopps"],
        OnSiteX: ["{0} on site", "{0} en el sitio", "{0} vor Ort"],
        DistanceInXDriving: ["{0} in {1} driving", "{0} en {1} de manejo", "{0} in {1} Fahrzeit"],
        NoLocationForX: ["No location for {0}.", "Sin ubicación durante {0}.", "{0} ohne Standort."],
        NothingThisDay: ["No trips or stops on this day.", "No hay viajes ni paradas este día.", "Keine Fahrten oder Stopps an diesem Tag."],
        AtJob: ["At a job", "En una tarea", "Bei einem Auftrag"],
        AtPlace: ["At a place", "En un lugar", "An einem Ort"],
        Stopped: ["Stopped", "Parado", "Stillstand"],
        Driving: ["Driving", "Manejando", "Fahrt"],
        NoLocation: ["No location", "Sin ubicación", "Kein Standort"],
        TrackingOff: ["Tracking off", "Seguimiento desactivado", "Tracking aus"],
        WorkingHours: ["Working hours", "Horario laboral", "Arbeitszeit"],
        StopWithoutPlace: ["Stop without a place", "Parada sin lugar", "Stopp ohne Ort"],
        GpsGaps: ["GPS gaps, part of the distance is estimated", "Huecos de GPS, parte de la distancia es estimada", "GPS-Lücken, ein Teil der Strecke ist geschätzt"],
        ManualCheckIn: ["Manual check-in", "Check-in manual", "Manueller Check-in"],
        OpenJob: ["Open job", "Abrir tarea", "Auftrag öffnen"],
        OpenPlace: ["Open place", "Abrir lugar", "Ort öffnen"],
        NoLocationForXRow: ["No location for {0}", "Sin ubicación durante {0}", "{0} ohne Standort"],
        TrackingOffForXRow: ["Tracking off for {0}", "Seguimiento desactivado durante {0}", "Tracking {0} lang aus"],
        GapNoLocationBody: ["Tracking stayed on, but the phone sent no location.", "El seguimiento siguió activo, pero el teléfono no envió ubicación.", "Das Tracking blieb an, aber das Handy hat keinen Standort gesendet."],
        GapTrackingOffBody: ["Tracking was switched off.", "Se desactivó el seguimiento.", "Das Tracking wurde ausgeschaltet."],
        LastSeenAtX: ["Last seen at {0}.", "Visto por última vez en {0}.", "Zuletzt gesehen bei {0}."],
        TrackingSwitchedOn: ["Tracking switched on", "Seguimiento activado", "Tracking eingeschaltet"],
        TrackingSwitchedOff: ["Tracking switched off", "Seguimiento desactivado", "Tracking ausgeschaltet"],
        SinceX: ["since {0}", "desde las {0}", "seit {0}"],
        UntilX: ["until {0}", "hasta las {0}", "bis {0}"],
        TopSpeed: ["Top speed", "Velocidad máxima", "Höchstgeschwindigkeit"],
        AverageSpeed: ["Average", "Promedio", "Durchschnitt"],
        Details: ["Details", "Detalles", "Details"],
        CheckPhone: ["Check the phone", "Revisar el teléfono", "Handy prüfen"],
        NoteGapX: ["{0} without location.", "{0} sin ubicación.", "{0} ohne Standort."],
        NoteGapInHoursX: ["{0} without location during working hours.", "{0} sin ubicación en horario laboral.", "{0} ohne Standort während der Arbeitszeit."],
        NoteTrackingOffX: ["Tracking was off for {0}.", "El seguimiento estuvo desactivado {0}.", "Das Tracking war {0} lang aus."],
        NoteOneManualCheckIn: ["1 manual check-in; the other stops were recorded by GPS.", "1 check-in manual; las demás paradas se registraron por GPS.", "1 manueller Check-in, die anderen Stopps kamen per GPS."],
        NoteManualCheckInsX: ["{0} manual check-ins; the other stops were recorded by GPS.", "{0} check-ins manuales; las demás paradas se registraron por GPS.", "{0} manuelle Check-ins, die anderen Stopps kamen per GPS."],
        NoteOnePoorDrive: ["1 drive with GPS gaps; its distance is partly estimated.", "1 trayecto con huecos de GPS; su distancia es en parte estimada.", "1 Fahrt mit GPS-Lücken, ihre Strecke ist teils geschätzt."],
        NotePoorDrivesX: ["{0} drives with GPS gaps; their distance is partly estimated.", "{0} trayectos con huecos de GPS; su distancia es en parte estimada.", "{0} Fahrten mit GPS-Lücken, ihre Strecke ist teils geschätzt."],
        NoteOneManualTrip: ["1 trip entered by hand.", "1 viaje ingresado a mano.", "1 Fahrt von Hand eingetragen."],
        NoteManualTripsX: ["{0} trips entered by hand.", "{0} viajes ingresados a mano.", "{0} Fahrten von Hand eingetragen."],
        NoteOnePending: ["1 trip is waiting for review.", "1 viaje está pendiente de revisión.", "1 Fahrt wartet auf Prüfung."],
        NotePendingX: ["{0} trips are waiting for review.", "{0} viajes están pendientes de revisión.", "{0} Fahrten warten auf Prüfung."],
        Person: ["Person", "Persona", "Person"],
        Distance: ["Distance", "Distancia", "Strecke"],
        DrivingTime: ["Driving", "Manejo", "Fahrzeit"],
        OnSite: ["On site", "En el sitio", "Vor Ort"],
        FirstMove: ["First move", "Primer movimiento", "Erste Bewegung"],
        Note: ["Note", "Nota", "Hinweis"],
        TeamNoLocationX: ["{0} no location", "{0} sin ubicación", "{0} ohne Standort"],
        TeamTrackingOffX: ["tracking off {0}", "seguimiento desactivado {0}", "Tracking {0} aus"],
        TeamPendingX: ["{0} to review", "{0} por revisar", "{0} zu prüfen"],
        TeamNoData: ["no trips or stops", "sin viajes ni paradas", "keine Fahrten oder Stopps"],
        TeamHint: ["Click a person to open their day.", "Haz clic en una persona para ver su día.", "Klick auf eine Person, um ihren Tag zu öffnen."],
        OneTrip: ["1 trip", "1 viaje", "1 Fahrt"],
        TripsX: ["{0} trips", "{0} viajes", "{0} Fahrten"],
        DrivingX: ["{0} driving", "{0} de manejo", "{0} Fahrzeit"],
        PendingX: ["{0} waiting for review", "{0} pendientes de revisión", "{0} warten auf Prüfung"],
        ReplayDay: ["3D replay of the day", "Repetición 3D del día", "3D-Wiedergabe des Tages"],
        Loading: ["Loading the day…", "Cargando el día…", "Tag wird geladen…"],
        Travel: ["Travel", "Trayecto", "Unterwegs"],
        TravelNoTrip: ["Travel, no trip recorded", "Trayecto sin viaje registrado", "Unterwegs, keine Fahrt aufgezeichnet"],
        TravelStraightX: ["{0} straight line · no trip recorded", "{0} en línea recta · sin viaje registrado", "{0} Luftlinie · keine Fahrt aufgezeichnet"],
        LateExitXYZ: ["The phone reported leaving {0} only at {1}, on arrival at {2}.", "El teléfono avisó de la salida de {0} recién a las {1}, al llegar a {2}.", "Das Handy hat das Verlassen von {0} erst um {1} gemeldet, schon bei {2}."],
        TravelRoadXY: ["{0} by road · about {1} driving · no trip recorded", "{0} por carretera · unos {1} en auto · sin viaje registrado", "{0} auf der Straße · etwa {1} Fahrzeit · keine Fahrt aufgezeichnet"],
        TooFastRoadXY: ["The drive takes about {0}, but the manual check-out and check-in are only {1} apart.", "El trayecto toma unos {0}, pero entre el check-out y el check-in manuales hay solo {1}.", "Die Fahrt dauert etwa {0}, aber zwischen manuellem Check-out und Check-in liegen nur {1}."],
        TooFast: ["Too fast for the distance between the manual check-out and check-in.", "Demasiado rápido para la distancia entre el check-out y el check-in manuales.", "Zu schnell für die Strecke zwischen manuellem Check-out und Check-in."],
        ManualCheckInX: ["Manual check-in · {0}", "Check-in manual · {0}", "Manueller Check-in · {0}"],
        ManualCheckInFarX: ["Manual check-in {0} away", "Check-in manual a {0}", "Manueller Check-in {0} entfernt"],
        OneForm: ["1 form", "1 formulario", "1 Formular"],
        FormsX: ["{0} forms", "{0} formularios", "{0} Formulare"],
        NoteOneFarCheckInX: ["1 manual check-in was made more than {0} from its job.", "1 check-in manual se hizo a más de {0} de su tarea.", "1 manueller Check-in war mehr als {0} vom Auftrag entfernt."],
        NoteFarCheckInsXY: ["{0} manual check-ins were made more than {1} from their job.", "{0} check-ins manuales se hicieron a más de {1} de su tarea.", "{0} manuelle Check-ins waren mehr als {1} vom Auftrag entfernt."],
        NoteOneTooFast: ["1 move between jobs was too fast for the distance.", "1 trayecto entre tareas fue demasiado rápido para la distancia.", "1 Weg zwischen Aufträgen war zu schnell für die Strecke."],
        Stops: ["Stops", "Paradas", "Stopps"],
        CheckIn: ["Check-in", "Check-in", "Check-in"],
        Gps: ["GPS", "GPS", "GPS"],
        Manual: ["Manual", "Manual", "Manuell"],
        ManualX: ["Manual · {0}", "Manual · {0}", "Manuell · {0}"],
        NoStops: ["No stops in this time.", "No hay paradas en este periodo.", "Keine Stopps in diesem Zeitraum."],
        NoTrips: ["No trips in this time.", "No hay viajes en este periodo.", "Keine Fahrten in diesem Zeitraum."],
        NoTripsOrStops: ["No trips or stops in this time.", "No hay viajes ni paradas en este periodo.", "Keine Fahrten oder Stopps in diesem Zeitraum."],
        TripsAndStops: ["All", "Todo", "Alle"],
        AtJobsX: ["{0} at jobs", "{0} en tareas", "{0} bei Aufträgen"],
        OneFarCheckIn: ["1 manual check-in far from its job", "1 check-in manual lejos de su tarea", "1 manueller Check-in weit vom Auftrag"],
        FarCheckInsX: ["{0} manual check-ins far from their job", "{0} check-ins manuales lejos de su tarea", "{0} manuelle Check-ins weit vom Auftrag"],
        NoteTooFastX: ["{0} moves between jobs were too fast for the distance.", "{0} trayectos entre tareas fueron demasiado rápidos para la distancia.", "{0} Wege zwischen Aufträgen waren zu schnell für die Strecke."],
    },
    CreateMenu: {
        Job: ["Job", "Tarea", "Auftrag"],
        Route: ["Route", "Ruta", "Route"],
        Place: ["Place", "Lugar", "Ort"],
        Zone: ["Zone", "Zona", "Zone"],
        Member: ["Member", "Miembro", "Mitglied"],
        Import: ["Import", "Importar", "Importieren"],
        ImportJobs: ["Jobs", "Tareas", "Aufträge"],
        ImportPlaces: ["Places", "Lugares", "Orte"],
        ImportZones: ["Zones", "Zonas", "Zonen"],
        ImportMembers: ["Members", "Miembros", "Mitglieder"],
        ImportRecurringRoutes: ["Recurring routes", "Rutas recurrentes", "Wiederkehrende Routen"],
    },
    NewRoute: {
        JobsAddedX: ["{0} jobs added", "{0} tareas agregadas", "{0} Aufträge hinzugefügt"],
        JobsAddedForXY: ["{0} jobs added to the route of {1}", "{0} tareas agregadas a la ruta de {1}", "{0} Aufträge zur Route von {1} hinzugefügt"],
        AddStop: ["Add a stop: address or place", "Agrega una parada: dirección o lugar", "Stopp hinzufügen: Adresse oder Ort"],
        AddStopHint: ["Paste several lines to add them all, or click the map", "Pega varias líneas para agregarlas todas, o haz clic en el mapa", "Füge mehrere Zeilen ein, um alle hinzuzufügen, oder klick auf die Karte"],
        PickSomeone: ["Pick someone to see times and optimize", "Elige a alguien para ver horarios y optimizar", "Wähl jemanden aus, um Zeiten zu sehen und zu optimieren"],
        AlreadyHasXJobsY: ["{0} already has {1} jobs {2}", "{0} ya tiene {1} tareas {2}", "{0} hat {2} schon {1} Aufträge"],
        AlreadyHasOneJobY: ["{0} already has 1 job {1}", "{0} ya tiene 1 tarea {1}", "{0} hat {1} schon 1 Auftrag"],
        DayToday: ["today", "hoy", "heute"],
        DayTomorrow: ["tomorrow", "mañana", "morgen"],
        DayOnX: ["on {0}", "el {0}", "am {0}"],
        JobsXToYOnRoute: ["Jobs {0}–{1} already on the route", "Tareas {0}–{1} ya en la ruta", "Aufträge {0}–{1} schon auf der Route"],
        StopsXNewY: ["{0} stops, {1} new", "{0} paradas, {1} nuevas", "{0} Stopps, {1} neu"],
        ClearNewStops: ["Clear new stops", "Quitar las paradas nuevas", "Neue Stopps entfernen"],
        NeedsSpot: ["not found, click its spot on the map", "no encontrada, haz clic en su punto del mapa", "nicht gefunden, klick auf die Stelle in der Karte"],
        DoesNotFit: ["does not fit the hours", "no cabe en el horario", "passt nicht in die Arbeitszeit"],
        LeaveUnassigned: ["Leave unassigned", "Dejar sin asignar", "Nicht zuweisen"],
        LeftUnassignedX: ["Left unassigned: {0}", "Sin asignar: {0}", "Nicht zugewiesen: {0}"],
        PutBack: ["Put back", "Volver a agregar", "Wieder einplanen"],
        StopsX: ["{0} stops", "{0} paradas", "{0} Stopps"],
        DrivingX: ["{0} driving", "{0} de manejo", "{0} Fahrt"],
        DoneByX: ["done by {0}", "termina a las {0}", "fertig um {0}"],
        ShiftEndsX: ["shift ends {0}", "el turno acaba a las {0}", "Schicht endet um {0}"],
        OptimizeOrder: ["Optimize order", "Optimizar orden", "Reihenfolge optimieren"],
        SavesXMin: ["saves {0} min", "ahorra {0} min", "spart {0} Min."],
        AlreadyBest: ["This order is already the fastest", "Este orden ya es el más rápido", "Diese Reihenfolge ist schon die schnellste"],
        UseThisOrder: ["Use this order", "Usar este orden", "Diese Reihenfolge nehmen"],
        KeepMyOrder: ["Keep my order", "Mantener mi orden", "Meine Reihenfolge behalten"],
        CreateXJobs: ["Create {0} jobs", "Crear {0} tareas", "{0} Aufträge erstellen"],
        CreateOneJob: ["Create 1 job", "Crear 1 tarea", "1 Auftrag erstellen"],
        CreateJobs: ["Create jobs", "Crear tareas", "Aufträge erstellen"],
        TellX: ["Tell {0}", "Avisar a {0}", "{0} benachrichtigen"],
        Undo: ["Undo", "Deshacer", "Rückgängig"],
        MoveUp: ["Move up", "Subir", "Nach oben"],
        MoveDown: ["Move down", "Bajar", "Nach unten"],
        Remove: ["Remove", "Quitar", "Entfernen"],
        NoRoute: ["No route found for these stops", "No se encontró una ruta para estas paradas", "Für diese Stopps wurde keine Route gefunden"],
    },
    NewJob: {
        Where: ["Where", "Dónde", "Wo"],
        What: ["What", "Qué", "Was"],
        Who: ["Who", "Quién", "Wer"],
        When: ["When", "Cuándo", "Wann"],
        SearchWhere: ["Address or place", "Dirección o lugar", "Adresse oder Ort"],
        OrClickMap: ["or click the spot on the map", "o haz clic en el punto del mapa", "oder klick auf die Stelle in der Karte"],
        Change: ["Change", "Cambiar", "Ändern"],
        KeepX: ["Keep {0}", "Mantener {0}", "{0} behalten"],
        WhatPlaceholder: ["Enter a title…", "Escribe un título…", "Titel eingeben…"],
        SomeoneElse: ["Someone else…", "Otra persona…", "Jemand anderes…"],
        PlusMin: ["+{0} min", "+{0} min", "+{0} Min."],
        Off: ["off", "libre", "frei"],
        Tomorrow: ["Tomorrow", "Mañana", "Morgen"],
        OtherDay: ["Other day", "Otro día", "Anderer Tag"],
        MinOnSite: ["min on site", "min en el sitio", "Min. vor Ort"],
        TimeWindow: ["Time window", "Ventana horaria", "Zeitfenster"],
        AfterX: ["after {0}", "después de {0}", "nach {0}"],
        FirstStop: ["first stop", "primera parada", "erster Stopp"],
        AboutX: ["about {0}", "hacia las {0}", "gegen {0}"],
        XIsOff: ["{0} is off that day", "{0} no trabaja ese día", "{0} hat an dem Tag frei"],
        UsualVisitX: ["Usual visit here: {0} min", "Visita habitual aquí: {0} min", "Übliche Dauer hier: {0} Min."],
        EarlierJobsX: ["{0} earlier jobs here", "{0} tareas anteriores aquí", "{0} frühere Aufträge hier"],
        EarlierJobHere: ["1 earlier job here", "1 tarea anterior aquí", "1 früherer Auftrag hier"],
        UsedHere: ["Used here:", "Usados aquí:", "Hier verwendet:"],
        StillOpenXY: ["Not done yet at this address: {0}, {1}.", "Aún sin terminar en esta dirección: {0}, {1}.", "Noch nicht erledigt an dieser Adresse: {0}, {1}."],
        OpenIt: ["Open it", "Abrirla", "Öffnen"],
        ShowIt: ["Show", "Mostrar", "Anzeigen"],
        TitleCopy: ["Copy of a job", "Copia de una tarea", "Kopie eines Auftrags"],
        TitleFromTemplate: ["New job from a template", "Tarea nueva desde una plantilla", "Neuer Auftrag aus einer Vorlage"],
        CopyOf: ["Copy of", "Copia de", "Kopie von"],
        FromTemplate: ["Template", "Plantilla", "Vorlage"],
        NotDoneYet: ["not done yet", "aún sin terminar", "noch nicht erledigt"],
        AddressJobsX: ["{0} earlier jobs at this address.", "{0} tareas anteriores en esta dirección.", "{0} frühere Aufträge an dieser Adresse."],
        SaveAsPlace: ["Save as place", "Guardar como lugar", "Als Ort speichern"],
        MoreDetails: ["More details", "Más detalles", "Mehr Details"],
        CreateJob: ["Create job", "Crear tarea", "Auftrag erstellen"],
    },
    NewPlace: {
        Name: ["Name", "Nombre", "Name"],
        NamePlaceholder: ["Name the place…", "Ponle nombre al lugar…", "Gib dem Ort einen Namen…"],
        Radius: ["Radius", "Radio", "Radius"],
        MostUsedRadiusX: ["most of your places use {0} m", "la mayoría de tus lugares usan {0} m", "die meisten deiner Orte haben {0} m"],
        SeenBy: ["Seen by", "Visible para", "Sichtbar für"],
        Everyone: ["Everyone", "Todos", "Alle"],
        NearbyXY: ["{0} is {1} m away.", "{0} está a {1} m.", "{0} ist {1} m entfernt."],
        NoTeam: ["No team picked: workers won't see this place or check in at it.", "Sin equipo: los trabajadores no verán este lugar ni harán check-in en él.", "Kein Team gewählt: Mitarbeiter sehen diesen Ort nicht und checken dort nicht ein."],
        LinkJobsX: ["Link the {0} open jobs here to this place", "Vincular las {0} tareas abiertas aquí a este lugar", "Die {0} offenen Aufträge hier mit diesem Ort verknüpfen"],
        LinkJobOne: ["Link the open job here to this place", "Vincular la tarea abierta aquí a este lugar", "Den offenen Auftrag hier mit diesem Ort verknüpfen"],
        CreatePlace: ["Create place", "Crear lugar", "Ort erstellen"],
        CreateAnyway: ["Create anyway", "Crear igualmente", "Trotzdem erstellen"],
        YouCouldAdd: ["Places you could add", "Lugares que podrías agregar", "Orte, die du anlegen könntest"],
        JobsHereX: ["{0} jobs in 90 days", "{0} tareas en 90 días", "{0} Aufträge in 90 Tagen"],
        CouldAddX: ["{0} places you could add", "{0} lugares que podrías agregar", "{0} Orte, die du anlegen könntest"],
        CouldAddOne: ["1 place you could add", "1 lugar que podrías agregar", "1 Ort, den du anlegen könntest"],
        CouldAddWhy: ["addresses with jobs but no place", "direcciones con tareas pero sin lugar", "Adressen mit Aufträgen, aber ohne Ort"],
        Show: ["Show", "Mostrar", "Anzeigen"],
        Hide: ["Hide", "Ocultar", "Ausblenden"],
        Add: ["Add", "Agregar", "Anlegen"],
    },
    NewZone: {
        DrawHint: ["Or click the map to draw it, a corner per click; the first corner closes it.", "O haz clic en el mapa para dibujarla, una esquina por clic; la primera la cierra.", "Oder klick auf die Karte, um sie zu zeichnen: eine Ecke pro Klick, die erste schließt sie."],
        DrawnByHand: ["Drawn on the map", "Dibujada en el mapa", "Auf der Karte gezeichnet"],
        AreaPlaceholder: ["Neighborhood, district, city or postcode", "Barrio, distrito, ciudad o código postal", "Viertel, Stadtteil, Stadt oder Postleitzahl"],
        AreaHint: ["Press Enter to search more places", "Presiona Enter para buscar más lugares", "Drück Enter, um weitere Orte zu suchen"],
        NoAreas: ["No area with a border found. Try another name or draw it.", "No encontramos un área con límites. Prueba otro nombre o dibújala.", "Kein Gebiet mit Grenze gefunden. Versuch einen anderen Namen oder zeichne es."],
        Searching: ["Searching…", "Buscando…", "Suche…"],
        Detail: ["Detail", "Detalle", "Detail"],
        Simple: ["Simple", "Simple", "Einfach"],
        Normal: ["Normal", "Normal", "Normal"],
        Exact: ["Exact", "Exacto", "Genau"],
        CornersX: ["{0} corners", "{0} esquinas", "{0} Ecken"],
        BordersBy: ["Borders © {0}", "Límites © {0}", "Grenzen © {0}"],
        OsmContributors: ["OpenStreetMap contributors", "colaboradores de OpenStreetMap", "OpenStreetMap-Mitwirkende"],
        PostcodesBy: ["Postcodes © {0}", "Códigos postales © {0}", "Postleitzahlen © {0}"],
        KindCity: ["City", "Ciudad", "Stadt"],
        KindTown: ["Town", "Pueblo", "Kleinstadt"],
        KindVillage: ["Village", "Aldea", "Dorf"],
        KindSuburb: ["Suburb", "Barrio", "Stadtteil"],
        KindNeighbourhood: ["Neighborhood", "Vecindario", "Viertel"],
        KindDistrict: ["District", "Distrito", "Bezirk"],
        KindCounty: ["County", "Condado", "Landkreis"],
        KindMunicipality: ["Municipality", "Municipio", "Gemeinde"],
        KindParish: ["Parish", "Parroquia", "Gemeinde"],
        KindCouncil: ["Council area", "Área municipal", "Gemeindegebiet"],
        KindRegency: ["Regency", "Regencia", "Regierungsbezirk"],
        KindLga: ["Local government area", "Área de gobierno local", "Kommunalbezirk"],
        KindProvince: ["Province", "Provincia", "Provinz"],
        KindPostcode: ["Postcode", "Código postal", "Postleitzahl"],
        KindState: ["State", "Estado", "Bundesland"],
        KindArea: ["Area", "Área", "Gebiet"],
        StartOver: ["Start over", "Empezar de nuevo", "Neu anfangen"],
        CoversX: ["covers {0} places", "abarca {0} lugares", "umfasst {0} Orte"],
        CoversOne: ["covers 1 place", "abarca 1 lugar", "umfasst 1 Ort"],
        DragCorners: ["drag the corners to adjust", "arrastra las esquinas para ajustar", "zieh an den Ecken zum Anpassen"],
        NamePlaceholder: ["Name the zone…", "Ponle nombre a la zona…", "Gib der Zone einen Namen…"],
        For: ["For", "Para", "Für"],
        Someone: ["Someone…", "Alguien…", "Jemand…"],
        CreateZone: ["Create zone", "Crear zona", "Zone erstellen"],
    },
    AreYouSure: {
        AreYouSureToRemoveX: ['Remove {0}?', '¿Quitar {0}?', '{0} wirklich entfernen?'],
    },
    Members: {
        AllLocationDataWillBeRemovedForThisUser: [
            'All location data will be removed for this user.',
            'Se eliminarán todos los datos de ubicación de este usuario.',
            'Alle Standortdaten werden für diesen Nutzer entfernt.',
        ],
        DeleteMember: ['Delete member', 'Borrar miembro', 'Mitglied löschen'],
        DeleteMemberConfirmPassword: [
            'Please enter your password to confirm the deletion.',
            'Ingresa tu contraseña para confirmar la eliminación.',
            'Bitte gib dein Passwort ein, um das Löschen zu bestätigen.',
        ],
        SelectMember: ['Select member', 'Seleccionar miembro', 'Mitglied auswählen'],
        SelectMembers: ['Select members', 'Seleccionar miembros', 'Mitglieder auswählen'],
        ImportMembers: [
            'Import members',
            'Importar miembros',
            'Mitglieder importieren',
        ],
        ImportMembersInfo: [
            '<p>You can import members from a CSV or Excel file. Make sure to include the headers: <strong>Name, Email, Phone, Role</strong>.</p><p><strong>Phone</strong> and <strong>Role</strong> are optional. <strong>Role</strong> defaults to <strong>Worker</strong>. Alternatively you can set it to <strong>Administrator</strong> or <strong>Operator</strong>. Email will become the username.',
            '<p>Puedes importar miembros desde un archivo CSV o Excel. Asegúrate de incluir el siguiente encabezado: <strong>Name, Email, Phone, Role</strong>.</p><p><strong>Phone</strong> y <strong>Role</strong> son opcionales. <strong>Role</strong> se establece de forma predeterminada en <strong>Worker</strong>. Alternativamente, puedes configurarlo en <strong>Administrator</strong> u <strong>Operator</strong>. El correo electrónico será el nombre de usuario.',
            '<p>Du kannst Mitglieder aus einer CSV- oder Excel-Datei importieren. Achte auf diese Kopfzeile: <strong>Name, Email, Phone, Role</strong>.</p><p><strong>Phone</strong> und <strong>Role</strong> sind optional. <strong>Role</strong> ist standardmäßig <strong>Worker</strong>. Alternativ kannst du die Rolle auf <strong>Administrator</strong> oder <strong>Operator</strong> festlegen. Die E-Mail-Adresse wird zum Nutzernamen.',
        ],
        ImportMembersTitle: [
            'Import members from Excel or CSV',
            'Importar miembros desde un archivo CSV o Excel',
            'Mitglieder aus einer Excel- oder CSV-Datei importieren',
        ],
        NewMember: [
            "New member",
            "Nuevo miembro",
            "Neues Mitglied",
        ],
        AllMembers: [
            "All members",
            "Todos los miembros",
            "Alle Mitglieder",
        ],
        ShowAllOnMap: [
            "Show all on map",
            "Mostrar todos en el mapa",
            "Alle auf der Karte anzeigen",
        ]
    },
    Sequences: {
        Sequences: ["Recurring routes", "Rutas recurrentes", "Wiederkehrende Routen"],
        SequencesDesc: [
            'Recurring routes represent a saved list of jobs that can be assigned to a member at any time or recurringly. You can save a member\'s day route directly and you can edit the list of jobs by drag and drop.',
            'Las rutas recurrentes representan una lista de tareas guardadas que se pueden asignar a un miembro en cualquier momento o de forma recurrente. Puedes guardar la ruta diaria de un miembro directamente y puedes editar la lista de tareas arrastrando y soltando.',
            'Wiederkehrende Routen stellen eine gespeicherte Liste von Aufträgen dar, die einem Mitglied jederzeit oder wiederholt zugewiesen werden können. Du kannst die Tagesroute eines Mitglieds direkt speichern und die Liste der Aufträge per Drag & Drop bearbeiten.'
        ],
        SaveSequenceAs: [
            'Save route in recurring routes',
            'Guardar ruta en rutas recurrentes',
            'Route in wiederkehrende Routen speichern',
        ],
        SequenceName: [
            'Route name',
            'Nombre de ruta',
            'Routenname',
        ],
        LoadSequence: [
            'Load recurring route',
            'Cargar ruta recurrente',
            'Wiederkehrende Route laden',
        ],
        LoadSequenceForX: [
            'Load route for {0}',
            'Cargar ruta para {0}',
            'Route für {0} laden',
        ],
        Completed: [
            'Completed',
            'Completada',
            'Abgeschlossen',
        ],
        XOfYCompleted: [
            '{0}/{1} completed',
            '{0}/{1} completadas',
            '{0}/{1} erledigt',
        ],
        RecentLoads: [
            'Recent loads',
            'Cargas recientes',
            'Kürzlich geladen',
        ],
        NewEmptySequence: [
            'New empty recurring route',
            'Nueva ruta recurrente vacía',
            'Neue leere wiederkehrende Route',
        ],
        ImportSequenceJobs: [
            'Update recurring route jobs',
            'Actualizar tareas de rutas recurrentes',
            'Aufträge in wiederkehrenden Routen aktualisieren',
        ],
        ImportSequenceJobsTitle: [
            'Update recurring route jobs from CSV or Excel file',
            'Actualizar tareas de rutas recurrentes desde un archivo CSV o Excel',
            'Aufträge in wiederkehrenden Routen aus CSV- oder Excel-Datei aktualisieren',
        ],
        ImportSequenceJobsInfo: [
            '<p>Upload a CSV/Excel file to update jobs saved inside active recurring routes. Rows are matched by exact <strong>Title</strong>. This does not create or update scheduled dispatch jobs.</p><ul><li><strong>Title</strong> is required and must be unique across active recurring routes</li><li>Use <strong>New Title</strong> to rename a saved route job</li><li>Supported update columns: Order, Notes, Priority, Type, On Site (minutes), Time Window</li><li>Leave cells empty to keep existing values</li></ul>',
            '<p>Sube un archivo CSV/Excel para actualizar tareas guardadas dentro de rutas recurrentes activas. Las filas se identifican por el <strong>Título</strong> exacto. Esto no crea ni actualiza tareas programadas en Despacho.</p><ul><li><strong>Título</strong> es obligatorio y debe ser único en las rutas recurrentes activas</li><li>Usa <strong>Nuevo título</strong> para renombrar una tarea guardada en la ruta</li><li>Columnas admitidas: Orden, Notas, Prioridad, Tipo, En sitio (minutos), Ventana horaria</li><li>Deja celdas vacías para mantener los valores existentes</li></ul>',
            '<p>Lade eine CSV/Excel-Datei hoch, um Aufträge in aktiven wiederkehrenden Routen zu aktualisieren. Zeilen werden über den exakten <strong>Titel</strong> zugeordnet. Geplante Aufträge in der Disposition werden nicht erstellt oder aktualisiert.</p><ul><li><strong>Titel</strong> ist erforderlich und muss in aktiven wiederkehrenden Routen eindeutig sein</li><li>Verwende <strong>Neuer Titel</strong>, um einen gespeicherten Routenauftrag umzubenennen</li><li>Unterstützte Spalten: Reihenfolge, Notizen, Priorität, Typ, Vor Ort (Minuten), Zeitfenster</li><li>Leere Zellen behalten vorhandene Werte bei</li></ul>',
        ],
        SelectOwnersForX: [
            'Restrict access to selected owners for {0}',
            'Restringir el acceso para {0} a los propietarios seleccionados',
            'Zugriff auf ausgewählte Besitzer beschränken für {0}',
        ],
        SelectOwnersDesc: [
            'Only owners have access to this route',
            'Solo los propietarios tienen acceso a esta ruta',
            'Nur Besitzer haben Zugriff auf diese Route',
        ],
        AssignSequenceX: [
            'Recurringly assign {0}',
            'Asignar recurrentemente {0}',
            '{0} wiederkehrend zuweisen',
        ],
        SaveAsSequence: [
            "Save as recurring route",
            "Guardar como ruta recurrente",
            "Als wiederkehrende Route speichern",
        ],
        DeleteSequenceQuestion: [
            'Delete route?',
            '¿Eliminar ruta?',
            'Route löschen?',
        ],
        DeleteSequence: [
            'Delete route',
            'Eliminar ruta',
            'Route löschen',
        ],
        RenameSequence: [
            'Rename route',
            'Renombrar ruta',
            'Routenname ändern',
        ],
        Restricted: [
            "Restricted",
            "Restringido",
            "Beschränkt"
        ],
        VisibleForAllOperators: [
            "Visible for all operators",
            "Visible para todos los operadores",
            "Für alle Disponenten sichtbar"
        ],
        RemoveFromSequence: [
            "Remove this job from the route",
            "Quitar esta tarea de la ruta",
            "Auftrag aus Route entfernen",
        ],
        AlwaysSchedule: [
            "Schedule ahead",
            "Programar con antelación",
            "Tage im Voraus planen"
        ],
        ScheduleDaysAhead: [
            "Schedule days ahead.",
            "Programar días por adelantado.",
            "Tage im Voraus planen."
        ],
        ScheduleDaysAheadDesc: [
            "The recurring route will be applied automatically {0} days in advance.",
            "La ruta recurrente se aplicará automáticamente con {0} días de antelación.",
            "Die wiederkehrende Route wird automatisch {0} Tage im Voraus angewendet."
        ],
        CurrentDay: [
            "Current day only",
            "Solo el día actual",
            "Nur aktueller Tag"
        ],
        OneDayAhead: [
            "Current day + 1 day ahead",
            "Día actual + 1 día adelante",
            "Aktueller Tag + 1 Tag im Voraus"
        ],
        XDaysAhead: [
            "Current day + {0} days ahead",
            "Día actual + {0} días adelante",
            "Aktueller Tag + {0} Tage im Voraus"
        ],
        EnsureSequenceAssigned: [
            "Apply manually now",
            "Aplicar manualmente ahora",
            "Jetzt manuell anwenden"
        ],
        ApplyRecurringSequencesDesc: [
            "Apply this recurring route for today and the next {0} days. Future jobs from this route will be cleaned up first (does not modify unrelated jobs).",
            "Aplicar la ruta recurrente para hoy y los próximos {0} días. Las tareas futuras de esta ruta se eliminarán primero (no modificará otras tareas).",
            "Die wiederkehrende Route für heute und die nächsten {0} Tage anwenden. Zukünftige Aufträge aus dieser Route werden zuerst gelöscht (andere Aufträge bleiben unverändert)."
        ]
    },
    RecurringRoutes: {
        Tab: ["Recurring routes", "Rutas recurrentes", "Wiederkehrende Routen"],
        New: ["New", "Nueva", "Neu"],
        Search: ["Search", "Buscar", "Suchen"],
        ActiveX: ["Active {0}", "Activas {0}", "Aktiv {0}"],
        PausedX: ["Paused {0}", "En pausa {0}", "Pausiert {0}"],
        EndedX: ["Ended {0}", "Terminadas {0}", "Beendet {0}"],
        SortByDate: ["Sort: next date", "Orden: próxima fecha", "Sortierung: nächster Termin"],
        SortByName: ["Sort: name", "Orden: nombre", "Sortierung: Name"],
        ListFooter: ["Jobs appear by themselves before each date.", "Las tareas aparecen solas antes de cada fecha.", "Aufträge erscheinen vor jedem Termin von selbst."],
        EmptyTitle: ["Routes that repeat", "Rutas que se repiten", "Routen, die sich wiederholen"],
        EmptyText: ["Save a list of stops once and choose how often and who does it. Hellotracks creates the jobs ahead of time, so they appear in the mobile app by themselves.", "Guarda una lista de paradas una vez y elige cada cuánto y quién la hace. Hellotracks crea las tareas con anticipación, así aparecen solas en la app móvil.", "Speichere eine Liste von Stopps einmal und wähle, wie oft und wer sie fährt. Hellotracks legt die Aufträge im Voraus an, so erscheinen sie von selbst in der mobilen App."],
        ExampleWeekly: ["Every week", "Cada semana", "Jede Woche"],
        ExampleWeeklyText: ["Office cleaning, Tue and Thu", "Limpieza de oficinas, mar y jue", "Büroreinigung, Di und Do"],
        ExampleMonthly: ["Every month", "Cada mes", "Jeden Monat"],
        ExampleMonthlyText: ["Grease traps, second Monday", "Trampas de grasa, segundo lunes", "Fettabscheider, zweiter Montag"],
        ExamplePerDay: ["A person per day", "Una persona por día", "Eine Person pro Tag"],
        ExamplePerDayText: ["Deliveries, one person Mon/Wed/Fri, another Tue/Thu", "Entregas, una persona lun/mié/vie, otra mar/jue", "Lieferungen, eine Person Mo/Mi/Fr, eine andere Di/Do"],
        RepeatAPastDay: ["Repeat a past day…", "Repetir un día pasado…", "Einen vergangenen Tag wiederholen…"],
        StartEmpty: ["Start empty", "Empezar vacía", "Leer beginnen"],
        PickADay: ["Whose day, and which one?", "¿El día de quién y cuál?", "Wessen Tag und welcher?"],
        NoJobsThatDay: ["{0} has no jobs on that day.", "{0} no tiene tareas ese día.", "{0} hat an dem Tag keine Aufträge."],
        Back: ["Recurring routes", "Rutas recurrentes", "Wiederkehrende Routen"],
        Schedule: ["Schedule", "Programación", "Zeitplan"],
        Who: ["Who", "Quién", "Wer"],
        JobsAppear: ["Jobs appear", "Las tareas aparecen", "Aufträge erscheinen"],
        PlannedDay: ["Planned day", "Día planificado", "Geplanter Tag"],
        Upcoming: ["Upcoming", "Próximas fechas", "Nächste Termine"],
        Stops: ["Stops", "Paradas", "Stopps"],
        History: ["History", "Historial", "Verlauf"],
        PastDates: ["Past dates", "Fechas pasadas", "Vergangene Termine"],
        Name: ["Name", "Nombre", "Name"],
        Repeat: ["Repeat", "Repetir", "Wiederholen"],
        On: ["On", "Los días", "An"],
        OnThe: ["On the", "El", "Am"],
        From: ["From", "Desde", "Ab"],
        Until: ["Until", "Hasta", "Bis"],
        Pause: ["Pause", "Pausa", "Pause"],
        Person: ["Person", "Persona", "Person"],
        Ahead: ["Ahead", "Anticipación", "Vorlauf"],
        StartsAt: ["Starts at", "Empieza a las", "Beginnt um"],
        EveryWeek: ["Every week", "Cada semana", "Jede Woche"],
        EveryNWeeks: ["Every {0} weeks", "Cada {0} semanas", "Alle {0} Wochen"],
        EveryMonthOnDayX: ["Every month on day {0}", "Cada mes el día {0}", "Jeden Monat am {0}."],
        EveryMonthOnTheXY: ["Every month on the {0} {1}", "Cada mes el {0} {1}", "Jeden Monat am {0} {1}"],
        OnlyPickedDates: ["Only on dates I pick", "Solo en las fechas que elija", "Nur an Tagen, die ich wähle"],
        Nth1: ["first", "primer", "ersten"],
        Nth2: ["second", "segundo", "zweiten"],
        Nth3: ["third", "tercer", "dritten"],
        Nth4: ["fourth", "cuarto", "vierten"],
        NthLast: ["last", "último", "letzten"],
        Never: ["Never", "Nunca", "Nie"],
        ADate: ["A date", "Una fecha", "Ein Datum"],
        NoPause: ["None", "Ninguna", "Keine"],
        AddPause: ["Add a pause", "Agregar una pausa", "Pause hinzufügen"],
        Resume: ["Resume", "Reanudar", "Fortsetzen"],
        PauseRangeXY: ["{0} to {1}", "{0} a {1}", "{0} bis {1}"],
        UntilFurtherNotice: ["until further notice", "hasta nuevo aviso", "bis auf Weiteres"],
        PickedDatesX: ["{0} dates picked", "{0} fechas elegidas", "{0} Tage gewählt"],
        AddDate: ["Add a date", "Agregar una fecha", "Datum hinzufügen"],
        SamePerson: ["One person", "Una persona", "Eine Person"],
        PersonPerDay: ["Per day", "Por día", "Pro Tag"],
        Unassigned: ["Unassigned", "Sin asignar", "Nicht zugewiesen"],
        DoesntRun: ["Doesn't run", "No se repite", "Findet nicht statt"],
        ChoosePerson: ["Choose a person", "Elige una persona", "Person wählen"],
        NeedsAPerson: ["needs a person", "necesita una persona", "braucht eine Person"],
        NoStopsNoJobs: ["no stops, no jobs", "sin paradas, sin tareas", "keine Stopps, keine Aufträge"],
        UnassignedHint: ["Jobs are made without a person and appear under Unassigned for that day.", "Las tareas se crean sin persona y aparecen en Sin asignar ese día.", "Aufträge werden ohne Person angelegt und erscheinen an dem Tag unter Nicht zugewiesen."],
        SameDay: ["The same day", "El mismo día", "Am selben Tag"],
        OneDayAhead: ["1 day ahead", "1 día antes", "1 Tag vorher"],
        NDaysAhead: ["{0} days ahead", "{0} días antes", "{0} Tage vorher"],
        InAppAndBoard: ["in the mobile app and on the board", "en la app móvil y en el tablero", "in der mobilen App und auf der Disposition"],
        OnBoardOnly: ["on the board only, in the mobile app once someone is assigned", "solo en el tablero, en la app móvil cuando se asigna a alguien", "nur auf der Disposition, in der mobilen App erst, wenn jemand zugewiesen ist"],
        JobsCreatedX: ["{0} jobs created", "{0} tareas creadas", "{0} Aufträge angelegt"],
        JobsCreatedOne: ["1 job created", "1 tarea creada", "1 Auftrag angelegt"],
        XOfYDone: ["{0} of {1} done", "{0} de {1} hechas", "{0} von {1} erledigt"],
        AppearOnX: ["Appear on {0}", "Aparecen el {0}", "Erscheinen am {0}"],
        AppearToday: ["Appear today", "Aparecen hoy", "Erscheinen heute"],
        Skipped: ["Skipped", "Omitida", "Ausgelassen"],
        Skip: ["Skip", "Omitir", "Auslassen"],
        Undo: ["Undo", "Deshacer", "Rückgängig"],
        Paused: ["Paused", "En pausa", "Pausiert"],
        PausedUntilX: ["until {0}", "hasta el {0}", "bis {0}"],
        Ended: ["Ended", "Terminada", "Beendet"],
        EndedOnX: ["on {0}", "el {0}", "am {0}"],
        Today: ["Today", "Hoy", "Heute"],
        InNDays: ["in {0} days", "en {0} días", "in {0} Tagen"],
        InOneDay: ["tomorrow", "mañana", "morgen"],
        NoUpcoming: ["No dates in the next year.", "Sin fechas en el próximo año.", "Keine Termine im nächsten Jahr."],
        SentenceWeeklyX: ["Every week on {0}", "Cada semana los {0}", "Jede Woche am {0}"],
        SentenceEveryNX: ["Every {0} weeks on {1}", "Cada {0} semanas los {1}", "Alle {0} Wochen am {1}"],
        SentenceWeekdays: ["Weekdays", "Días hábiles", "Werktags"],
        SentenceEveryDay: ["Every day", "Todos los días", "Jeden Tag"],
        SentenceDatesX: ["On {0} picked dates", "En {0} fechas elegidas", "An {0} gewählten Tagen"],
        SentenceDatesOne: ["On 1 picked date", "En 1 fecha elegida", "An 1 gewählten Tag"],
        SentencePlusDatesXY: ["{0} and {1} picked dates", "{0} y en {1} fechas elegidas", "{0} und an {1} gewählten Tagen"],
        SentencePlusDateOneX: ["{0} and 1 picked date", "{0} y en 1 fecha elegida", "{0} und an 1 gewählten Tag"],
        SentenceNoDays: ["No days chosen yet", "Aún sin días elegidos", "Noch keine Tage gewählt"],
        ForX: ["for {0}", "para {0}", "für {0}"],
        ForPerDay: ["a person per day", "una persona por día", "eine Person pro Tag"],
        ForUnassigned: ["unassigned", "sin asignar", "nicht zugewiesen"],
        NoPersonYet: ["no person yet", "sin persona aún", "noch ohne Person"],
        PerDayWhoX: ["{0}", "{0}", "{0}"],
        StopsX: ["{0} stops", "{0} paradas", "{0} Stopps"],
        StopsOne: ["1 stop", "1 parada", "1 Stopp"],
        OnlyTownX: ["{0} is only a town, so the stop sits in its middle", "{0} es solo una localidad, así que la parada queda en su centro", "{0} ist nur eine Gemeinde, der Stopp liegt in ihrer Mitte"],
        PinExactSpot: ["Pin the exact spot", "Marca el punto exacto", "Genaue Stelle setzen"],
        PinAfterSave: ["pin the exact spot once the route is saved", "marca el punto exacto cuando la ruta esté guardada", "setz die genaue Stelle, sobald die Route gespeichert ist"],
        FromX: ["From {0}", "Desde el {0}", "Ab {0}"],
        UntilX: ["until {0}", "hasta el {0}", "bis {0}"],
        EndedOnDayX: ["ended {0}", "terminó el {0}", "beendet am {0}"],
        LastDateX: ["last date {0}", "última fecha el {0}", "letzter Termin am {0}"],
        NoEnd: ["no end", "sin fin", "ohne Ende"],
        JobsAppearX: ["jobs appear {0}", "las tareas aparecen {0}", "Aufträge erscheinen {0}"],
        OverlapXYZ: ["{0} also has {1} on {2}. Both routes are added to the day, in order of their start time.", "{0} también tiene {1} los {2}. Ambas rutas se agregan al día, en orden de su hora de inicio.", "{0} hat {2} auch {1}. Beide Routen kommen in den Tag, in der Reihenfolge ihrer Startzeit."],
        SharesStopsXYZ: ["Shares {0} of {1} stops with {2} on the same day. Is one a copy of the other?", "Comparte {0} de {1} paradas con {2} el mismo día. ¿Una es copia de la otra?", "Teilt {0} von {1} Stopps mit {2} am selben Tag. Ist eine eine Kopie der anderen?"],
        PlannedSummaryXYZ: ["Ends {0} · {1} driving · {2} on site", "Termina {0} · {1} manejando · {2} en sitio", "Endet {0} · {1} Fahrt · {2} vor Ort"],
        PlannedHint: ["Planned times are a guide. Once the jobs exist, the day route gives the live ETAs.", "Los horarios planificados son una guía. Cuando existen las tareas, la ruta del día da las horas estimadas reales.", "Die geplanten Zeiten sind ein Anhaltspunkt. Sobald die Aufträge existieren, liefert die Tagesroute die echten Ankunftszeiten."],
        PlannedNeedsDays: ["Choose the days the route runs to see the planned day.", "Elige los días en que se realiza la ruta para ver el día planificado.", "Wähle die Tage der Route, um den geplanten Tag zu sehen."],
        PlannedNeedsPerson: ["Choose a person to see the planned day.", "Elige una persona para ver el día planificado.", "Wähle eine Person, um den geplanten Tag zu sehen."],
        PlannedWorking: ["Working out the planned day…", "Calculando el día planificado…", "Geplanter Tag wird berechnet…"],
        PlannedFailed: ["The planned day couldn't be worked out.", "No se pudo calcular el día planificado.", "Der geplante Tag konnte nicht berechnet werden."],
        FromWorkingHours: ["from the person's working hours", "según el horario de la persona", "aus den Arbeitszeiten der Person"],
        FromWorkingHoursOfXOnY: ["from the working hours of {0} on {1}", "según el horario de {0} el {1}", "aus den Arbeitszeiten von {0} am {1}"],
        UseWorkingHours: ["Use working hours", "Usar horario laboral", "Arbeitszeiten verwenden"],
        PlannedArrival: ["planned arrival", "llegada planificada", "geplante Ankunft"],
        OnSiteX: ["{0} on site", "{0} en sitio", "{0} vor Ort"],
        EditStops: ["Edit stops", "Editar paradas", "Stopps bearbeiten"],
        DoneEditing: ["Done", "Listo", "Fertig"],
        SkipADate: ["Skip a date", "Omitir una fecha", "Einen Tag auslassen"],
        UpdateTitle: ["Update jobs already created?", "¿Actualizar las tareas ya creadas?", "Bereits angelegte Aufträge aktualisieren?"],
        UpdateTextX: ["{0} dates already have jobs from this route.", "{0} fechas ya tienen tareas de esta ruta.", "{0} Termine haben schon Aufträge aus dieser Route."],
        UpdateTextOne: ["1 date already has jobs from this route.", "1 fecha ya tiene tareas de esta ruta.", "1 Termin hat schon Aufträge aus dieser Route."],
        NotStartedX: ["{0} not started", "{0} sin empezar", "{0} nicht begonnen"],
        StartedXY: ["{0} started or done, {1} not started", "{0} empezadas o hechas, {1} sin empezar", "{0} begonnen oder erledigt, {1} nicht begonnen"],
        ChangeX: ["{0} change", "{0} cambian", "{0} ändern sich"],
        RemovedX: ["{0} removed", "{0} se quitan", "{0} werden entfernt"],
        MovesToX: ["go to {0}", "pasan a {0}", "gehen an {0}"],
        UpdateNote: ["Done and started jobs are never changed. Changes for today reach the phone right away.", "Las tareas hechas o empezadas nunca cambian. Los cambios de hoy llegan al teléfono enseguida.", "Erledigte und begonnene Aufträge ändern sich nie. Änderungen für heute kommen sofort aufs Telefon."],
        KeepExistingJobs: ["Keep existing jobs", "Mantener las tareas existentes", "Bestehende Aufträge behalten"],
        UpdateNJobs: ["Update {0} jobs", "Actualizar {0} tareas", "{0} Aufträge aktualisieren"],
        UpdateOneJob: ["Update 1 job", "Actualizar 1 tarea", "1 Auftrag aktualisieren"],
        UpdatedX: ["{0} jobs updated", "{0} tareas actualizadas", "{0} Aufträge aktualisiert"],
        UpdatedOne: ["1 job updated", "1 tarea actualizada", "1 Auftrag aktualisiert"],
        SkipTitleX: ["Remove the jobs on {0}?", "¿Quitar las tareas del {0}?", "Aufträge am {0} entfernen?"],
        SkipTextX: ["You skipped {0}, but its jobs were already created.", "Omitiste el {0}, pero sus tareas ya se crearon.", "Du hast den {0} ausgelassen, aber seine Aufträge sind schon angelegt."],
        SkipNote: ["Only this date is affected. Started and done jobs always stay.", "Solo afecta a esta fecha. Las tareas empezadas o hechas siempre se quedan.", "Nur dieser Termin ist betroffen. Begonnene und erledigte Aufträge bleiben immer."],
        KeepTheJobs: ["Keep the jobs", "Mantener las tareas", "Aufträge behalten"],
        RemoveNJobs: ["Remove {0} jobs", "Quitar {0} tareas", "{0} Aufträge entfernen"],
        RemoveOneJob: ["Remove 1 job", "Quitar 1 tarea", "1 Auftrag entfernen"],
        RemovedXJobs: ["{0} jobs removed", "{0} tareas quitadas", "{0} Aufträge entfernt"],
        RemovedOneJob: ["1 job removed", "1 tarea quitada", "1 Auftrag entfernt"],
        LogCreated: ["created the route", "creó la ruta", "hat die Route angelegt"],
        LogRenamedX: ["renamed it to {0}", "la renombró a {0}", "hat sie in {0} umbenannt"],
        LogDeleted: ["deleted the route", "eliminó la ruta", "hat die Route gelöscht"],
        LogStopsXY: ["changed the stops ({0} → {1})", "cambió las paradas ({0} → {1})", "hat die Stopps geändert ({0} → {1})"],
        LogSchedule: ["changed the schedule", "cambió la programación", "hat den Zeitplan geändert"],
        LogWho: ["changed who does it", "cambió quién la hace", "hat geändert, wer sie fährt"],
        LogPausedX: ["paused it {0}", "la pausó {0}", "hat sie pausiert {0}"],
        LogResumed: ["resumed it", "la reanudó", "hat sie fortgesetzt"],
        LogSkippedX: ["skipped {0}", "omitió {0}", "hat {0} ausgelassen"],
        LogUnskippedX: ["brought back {0}", "recuperó {0}", "hat {0} zurückgeholt"],
        LogDaysAheadX: ["made jobs appear {0}", "hizo que las tareas aparezcan {0}", "lässt Aufträge {0} erscheinen"],
        LogStartTime: ["changed the start time", "cambió la hora de inicio", "hat die Startzeit geändert"],
        LogStopEditedX: ["edited the stop {0}", "editó la parada {0}", "hat den Stopp {0} bearbeitet"],
        LogJobsUpdatedXY: ["updated {0} jobs on {1} dates", "actualizó {0} tareas en {1} fechas", "hat {0} Aufträge an {1} Terminen aktualisiert"],
        LogJobsUpdatedOneDayX: ["updated {0} jobs on 1 date", "actualizó {0} tareas en 1 fecha", "hat {0} Aufträge an 1 Termin aktualisiert"],
        Someone: ["Someone", "Alguien", "Jemand"],
        NoHistory: ["Changes to this route show here.", "Los cambios de esta ruta aparecen aquí.", "Änderungen an dieser Route erscheinen hier."],
        Date: ["Date", "Fecha", "Datum"],
        Done: ["Done", "Hechas", "Erledigt"],
        RepeatThisDay: ["Repeat this day…", "Repetir este día…", "Diesen Tag wiederholen…"],
        NameXY: ["{0} · {1}", "{0} · {1}", "{0} · {1}"],
        NewRecurringRoute: ["New recurring route", "Nueva ruta recurrente", "Neue wiederkehrende Route"],
        FromDayOfX: ["From {0}'s day on {1}", "Del día de {0}, {1}", "Aus dem Tag von {0}, {1}"],
        SaveRecurringRoute: ["Save recurring route", "Guardar ruta recurrente", "Wiederkehrende Route speichern"],
        SaveChanges: ["Save changes", "Guardar cambios", "Änderungen speichern"],
        Cancel: ["Cancel", "Cancelar", "Abbrechen"],
        TodaysJobsStay: ["Today's jobs stay as they are. The stops keep today's order.", "Las tareas de hoy quedan como están. Las paradas mantienen el orden de hoy.", "Die heutigen Aufträge bleiben, wie sie sind. Die Stopps behalten die heutige Reihenfolge."],
        SavedX: ["{0} saved", "{0} guardada", "{0} gespeichert"],
        SavedText: ["Jobs appear by themselves before each date.", "Las tareas aparecen solas antes de cada fecha.", "Aufträge erscheinen vor jedem Termin von selbst."],
        FirstDates: ["First dates", "Primeras fechas", "Erste Termine"],
        CreateRecurringRoute: ["Recurring route", "Ruta recurrente", "Wiederkehrende Route"],
        PartOf: ["Part of", "Parte de", "Teil von"],
        OpenRoute: ["Open route", "Abrir ruta", "Route öffnen"],
        Column: ["Recurring route", "Ruta recurrente", "Wiederkehrende Route"],
        NoRouteYet: ["No stops yet. Add them below, or repeat a day from the board.", "Aún sin paradas. Agrégalas abajo o repite un día desde el tablero.", "Noch keine Stopps. Füg sie unten hinzu oder wiederhole einen Tag aus der Disposition."],
        NoStopsYetEdit: ["No stops yet. Add them with Edit stops above, or repeat a day from the board.", "Aún sin paradas. Agrégalas con Editar paradas arriba o repite un día desde el tablero.", "Noch keine Stopps. Füg sie oben mit Stopps bearbeiten hinzu oder wiederhole einen Tag aus der Disposition."],
        Rename: ["Rename", "Renombrar", "Umbenennen"],
        Delete: ["Delete", "Eliminar", "Löschen"],
        Close: ["Close", "Cerrar", "Schließen"],
        Restrict: ["Who can see it", "Quién puede verla", "Wer sie sehen kann"],
    },
    Billing: {
        LicensesHistory: ["Daily license history", "Historial de licencias diarias", "Täglicher Lizenzverlauf"],
        Payment: ['Billing', 'Facturación', 'Abrechnung'],
        Setup: ['Setup', 'Configuración', 'Setup'],
        SetupPaymentMethodNow: ['Set up payment method now', 'Ingresar método de pago', 'Bezahlmethode wählen'],
        YouWillBeChargedFirstInvoiceDue: ['You will be charged when your first invoice is due!', '¡El cobro se realizará cuando venza tu primera factura!', 'Die Abbuchung erfolgt, sobald deine erste Rechnung fällig ist!'],
        PaymentMethod: ['Payment method', 'Método de pago', 'Zahlungsmethode'],
        Licenses: ['Licenses', 'Licencias', 'Lizenzen'],
        TrialingUntil: ['Trial until {0}', 'Prueba hasta el {0}', 'Testphase bis {0}'],
        Active: ['Active', 'Activo', 'Aktiv'],
        PastDue: ['Past due', 'Vencida', 'Überfällig'],
        CanceledAtX: ['Canceled on {0}', 'Cancelado el {0}', 'Gekündigt am {0}'],
        Unpaid: ['Unpaid', 'Sin pagar', 'Nicht bezahlt'],
        Paused: ['Paused — add a payment method to activate', 'En pausa — agrega un método de pago para activar', 'Pausiert — füge eine Zahlungsmethode hinzu, um zu aktivieren'],
        TeamMember: ['Team member', 'Miembro del equipo', 'Teammitglied'],
        DelinquentMessage: ['Please update your payment information to continue using the service.', 'Actualiza la información de pago para continuar usando el servicio.', 'Bitte aktualisiere die Zahlungsinformationen, um den Dienst weiterhin nutzen zu können.'],
        UpcomingInvoice: ['Upcoming invoice', 'Próxima factura', 'Nächste Rechnung'],
        Period: ['Period', 'Periodo', 'Zeitraum'],
        ApplicationStatus: ['Application status', 'Estado', 'Anwendungsstatus'],
        ActiveSinceX: ['Active since {0}', 'Activo desde {0}', 'Aktiv seit {0}'],
        PaymentMethodMissing: ['Payment method missing.', 'Falta el método de pago.', 'Zahlungsmethode fehlt.'],
        TrialExpiredDesc: ['Your 30-day free trial with Hellotracks Business has expired. Please enter your payment method in order to continue using the service. Contact us at support@hellotracks.com if you have any questions. We thank you for your business.', 'Tu prueba gratuita de 30 días con Hellotracks Business ha expirado. Por favor ingresa un método de pago para continuar utilizando el servicio. Contáctanos a support@hellotracks.com si tienes alguna duda. Gracias por tu confianza.', 'Deine kostenlose 30-Tage-Testphase mit Hellotracks Business ist abgelaufen. Bitte gib eine Zahlungsmethode ein, wenn du den Dienst weiterhin nutzen willst. Bei Fragen kontaktiere uns unter support@hellotracks.com.'],
        Inactive: ['Inactive', 'Inactivo', 'Inaktiv'],
        BilledThroughReseller: ['Your plan is billed through your reseller. To change it, contact them.', 'Tu plan se factura a través de tu distribuidor. Para cambiarlo, habla con ellos.', 'Dein Plan läuft über deinen Reseller. Für Änderungen melde dich direkt dort.'],
        ActivateAccountNow: ['Activate account now', 'Activar cuenta ahora', 'Konto jetzt aktivieren'],
        Questions: ['Questions?', '¿Preguntas?', 'Fragen?'],
        Deactivate: ['Deactivate', 'Desactivar', 'Deaktivieren'],
        DeactivateCompanyAccount: ['Deactivate company account', 'Desactivar cuenta de la empresa', 'Unternehmenskonto deaktivieren'],
        DeactivateDesc: ['If you deactivate the company account, your subscription will be canceled immediately and you and your team won\'t be able to access the service. Deactivate company account?', 'Si desactivas la cuenta de la empresa, tu suscripción se cancelará de inmediato y ni tú ni tu equipo podrán acceder al servicio. ¿Desactivar cuenta?', 'Wenn du das Unternehmenskonto deaktivierst, wird dein Abonnement sofort gekündigt und weder du noch dein Team können den Dienst nutzen. Unternehmenskonto wirklich deaktivieren?'],
        CompanyAccountDeactivatedConfirmation: ['Your account has been successfully deactivated.', 'Tu cuenta ha sido desactivada.', 'Das Konto wurde erfolgreich deaktiviert.'],
        AccountIsActivated: ['Your account has been activated', 'Tu cuenta ha sido activada', 'Dein Konto wurde aktiviert'],
        Reactivate: ['Reactivate account', 'Reactivar cuenta', "Konto reaktivieren"],
        ReactivateDesc: ['This account has been deactivated. You can reactivate the account.', 'Esta cuenta ha sido desactivada. Puedes reactivar la cuenta.', 'Dieses Konto wurde deaktiviert. Du kannst das Konto reaktivieren.'],
        BillingStatus: [
            "Billing status",
            "Estado de facturación",
            "Abrechnungsstatus",
        ],
        Gain5Min: [
            "Get 5 minutes of access",
            "Obtener 5 minutos de acceso",
            "5 Minuten Zugriff bekommen",
        ],
        Gain5MinTooltip: [
            "This lets you manage your account.",
            "Esto te permite gestionar tu cuenta.",
            "Das ermöglicht es dir, dein Konto zu verwalten."
        ],
        AddPaymentMethod: [
            "Add payment method",
            "Agregar método de pago",
            "Zahlungsmethode hinzufügen",
        ],
        Expires: [
            "Expires",
            "Expira",
            "Ablaufdatum"
        ],
        Amount: [
            "Amount",
            "Monto",
            "Betrag",
        ],
        PaymentAttempt: [
            "Payment attempt",
            "Intento de pago",
            "Zahlungsversuch",
        ],
        ShowPastInvoices: [
            "Show past invoices",
            "Mostrar facturas anteriores",
            "Ältere Rechnungen anzeigen",
        ],
        PastInvoices: [
            "Past invoices",
            "Facturas anteriores",
            "Ältere Rechnungen",
        ],
        Default: [
            "Default",
            "Principal",
            "Standard",
        ],
        ReminderMessage: [
            "To continue enjoying our services without interruption, please update your payment details soon.",
            "Para seguir disfrutando de nuestros servicios sin interrupciones, actualiza los detalles de pago pronto.",
            "Um unseren Service weiterhin ohne Unterbrechung zu genießen, aktualisiere bitte bald die Zahlungsdetails.",
        ],
        PaymentOverdue: [
            "Payment overdue",
            "Pago vencido",
            "Zahlung überfällig",
        ],
        DelinquencyBannerAdmin: [
            "{0} overdue since {1}. Please update your payment method.",
            "{0} pendiente desde el {1}. Actualiza tu método de pago.",
            "{0} überfällig seit {1}. Bitte aktualisiere deine Zahlungsmethode.",
        ],
        DelinquencyBannerMember: [
            "This account has an outstanding payment. Please notify your administrator.",
            "Esta cuenta tiene un pago pendiente. Avisa a tu administrador.",
            "Dieses Konto hat eine ausstehende Zahlung. Bitte informiere deinen Administrator.",
        ],
        DelinquencyModalMessage: [
            "Your payment of {0} has been outstanding since {1}. All automatic charge attempts have failed. Please update your payment method to keep your account active.",
            "Tu pago de {0} está pendiente desde el {1}. Todos los intentos de cobro automático han fallado. Actualiza tu método de pago para mantener tu cuenta activa.",
            "Deine Zahlung von {0} ist seit dem {1} ausstehend. Alle automatischen Abbuchungsversuche sind fehlgeschlagen. Bitte aktualisiere deine Zahlungsmethode, damit dein Konto aktiv bleibt.",
        ],
        DelinquencySuspensionWarning: [
            "Without payment, dashboard access will be suspended on {0}.",
            "Sin el pago, el acceso al panel web se suspenderá el {0}.",
            "Ohne Zahlung wird der Zugriff auf das Web-Dashboard am {0} gesperrt.",
        ],
        UpdatePaymentMethod: [
            "Update payment method",
            "Actualizar método de pago",
            "Zahlungsmethode aktualisieren",
        ],
        YouHaveXLeftUntilTrialPeriodEnds: [
            "You have {0} left until your trial ends.",
            "{0} hasta que finalice el período de prueba.",
            "{0} bis zum Ende der Testphase."
        ],
        DeactivateWarning: [
            'If you deactivate the business account, everybody loses access to the web and mobile platforms.',
            'Si desactivas la cuenta empresarial, todos pierden el acceso a la web y las plataformas móviles.',
            'Wenn du das Business-Konto deaktivierst, verliert jeder den Zugriff auf das Web und die mobilen Plattformen.',
        ],
    },
    Questionnaire: {
        Title: ["Why are you leaving?", "¿Por qué te vas?", "Warum möchtest du gehen?"],
        Desc: [
            "Pick the main reason. For most reasons we can still help.",
            "Elige el motivo principal. En la mayoría de los casos todavía podemos ayudarte.",
            "Wähle den Hauptgrund. Bei den meisten Gründen können wir noch helfen.",
        ],
        ReasonDifficult: ["Hard to use", "Difícil de usar", "Schwer zu bedienen"],
        ReasonTeamAdoption: ["My team didn't keep using it", "Mi equipo no lo siguió usando", "Mein Team hat es nicht weiter genutzt"],
        ReasonPrice: ["Too expensive", "Demasiado caro", "Zu teuer"],
        ReasonFeature: ["Missing a feature", "Falta una función", "Eine Funktion fehlt"],
        ReasonAlternative: ["Switching to another tool", "Me cambio a otra herramienta", "Wir wechseln zu einem anderen Tool"],
        ReasonNoLongerNeeded: ["We don't need it anymore", "Ya no lo necesitamos", "Wir brauchen es nicht mehr"],
        ReasonSupport: ["Support let us down", "El soporte no estuvo a la altura", "Der Support hat uns enttäuscht"],
        ReasonOther: ["Something else", "Otro motivo", "Etwas anderes"],
        AskDifficult: ["What was hard?", "¿Qué fue difícil?", "Was war schwierig?"],
        PickTeamSetup: ["Getting my team set up", "Configurar a mi equipo", "Mein Team einzurichten"],
        PickPhoneApp: ["The phone app", "La app del celular", "Die Handy-App"],
        PickDashboard: ["The web dashboard", "La plataforma web", "Die Weboberfläche"],
        PickDispatching: ["Dispatching jobs", "Despachar tareas", "Aufträge disponieren"],
        PickReports: ["Reports and history", "Informes e historial", "Berichte und Verlauf"],
        PickSomethingElse: ["Something else", "Otra cosa", "Etwas anderes"],
        AskWhatHappened: ["What happened?", "¿Qué pasó?", "Was ist passiert?"],
        PickTrackingOff: ["Tracking got turned off on the phones", "Se desactivó el seguimiento en los celulares", "Die Ortung wurde auf den Handys ausgeschaltet"],
        PickNoLogin: ["People didn't log in", "La gente no inició sesión", "Die Leute haben sich nicht angemeldet"],
        PickWrongLocations: ["Locations were wrong or missing", "Las ubicaciones eran incorrectas o faltaban", "Standorte waren falsch oder fehlten"],
        AskPrice: ["Which fits best?", "¿Qué describe mejor tu caso?", "Was trifft am ehesten zu?"],
        PickOverBudget: ["Over our budget", "Supera nuestro presupuesto", "Über unserem Budget"],
        PickNotWorthIt: ["Not worth the price for us", "No vale el precio para nosotros", "Für uns den Preis nicht wert"],
        PickPerUser: ["Paying per person doesn't suit us", "Pagar por persona no nos conviene", "Bezahlen pro Person passt nicht zu uns"],
        PickCheaperOption: ["We found a cheaper option", "Encontramos una opción más barata", "Wir haben etwas Günstigeres gefunden"],
        AskBudget: ["What budget would work for you?", "¿Qué presupuesto te funcionaría?", "Welches Budget würde für dich passen?"],
        PerPersonMonth: ["per person a month", "por persona al mes", "pro Person und Monat"],
        TotalMonth: ["in total a month", "en total al mes", "insgesamt pro Monat"],
        AskCheaperTool: ["Which cheaper option are you looking at?", "¿Qué opción más barata estás considerando?", "Welche günstigere Lösung schaust du dir an?"],
        AskFeature: ["Which feature do you need?", "¿Qué función necesitas?", "Welche Funktion brauchst du?"],
        PickIntegration: ["A link to our CRM or accounting", "Conexión con nuestro CRM o contabilidad", "Anbindung an unser CRM oder die Buchhaltung"],
        PickCalendar: ["Google Calendar or Microsoft 365", "Google Calendar o Microsoft 365", "Google Kalender oder Microsoft 365"],
        PickMessages: ["SMS or WhatsApp messages", "Mensajes por SMS o WhatsApp", "SMS- oder WhatsApp-Nachrichten"],
        PickForms: ["Custom forms or workflows", "Formularios o flujos a medida", "Eigene Formulare oder Abläufe"],
        PickExports: ["Reports or exports", "Informes o exportaciones", "Berichte oder Exporte"],
        AskFeatureWhat: ["What should it do?", "¿Qué debería hacer?", "Was soll sie können?"],
        AskTool: ["Which tool are you switching to?", "¿A qué herramienta te cambias?", "Zu welchem Tool wechselst du?"],
        AskWhyTool: ["What made you choose it?", "¿Por qué la elegiste?", "Warum hast du dich dafür entschieden?"],
        PickLowerPrice: ["Lower price", "Precio más bajo", "Günstigerer Preis"],
        PickAFeature: ["A feature we need", "Una función que necesitamos", "Eine Funktion, die wir brauchen"],
        PickEasier: ["Easier for our team", "Más fácil para nuestro equipo", "Einfacher für unser Team"],
        PickWorksWith: ["Works with tools we already use", "Funciona con herramientas que ya usamos", "Passt zu Tools, die wir schon nutzen"],
        PickBuiltOwn: ["We built our own", "Hicimos la nuestra", "Wir haben selbst etwas gebaut"],
        AskNoLongerNeeded: ["Is this for good?", "¿Es definitivo?", "Ist das endgültig?"],
        PickForNow: ["Only for now, we'll need it again", "Solo por ahora, lo volveremos a necesitar", "Nur vorerst, wir brauchen es wieder"],
        PickForGood: ["For good", "Sí, es definitivo", "Ja, endgültig"],
        AskOther: ["Tell us the reason", "Cuéntanos el motivo", "Nenn uns den Grund"],
        WordsPlaceholder: ["A few words help us a lot", "Unas pocas palabras nos ayudan mucho", "Ein paar Worte helfen uns sehr"],
        MissingPick: ["Pick at least one.", "Elige al menos una opción.", "Wähle mindestens eine Option."],
        MissingWords: ["Tell us in a few words.", "Cuéntanos en pocas palabras.", "Sag es uns in ein paar Worten."],
        MissingTool: ["Tell us which tool you're switching to.", "Dinos a qué herramienta te cambias.", "Sag uns, zu welchem Tool du wechselst."],
        MissingBudget: ["Tell us a budget so we can make you an offer.", "Dinos un presupuesto para hacerte una oferta.", "Nenn uns ein Budget, damit wir dir ein Angebot machen können."],
        HelpTrainingTitle: ["Free training, 30 minutes", "Capacitación gratis de 30 minutos", "Kostenlose Schulung, 30 Minuten"],
        HelpTrainingDesc: [
            "We set it up together with you and your team, on your own account.",
            "Lo configuramos junto contigo y tu equipo, en tu propia cuenta.",
            "Wir richten es gemeinsam mit dir und deinem Team ein, in deinem eigenen Konto.",
        ],
        HelpTrainingTeamDesc: [
            "We help you get tracking running for the whole team, phone by phone.",
            "Te ayudamos a que el seguimiento funcione para todo tu equipo, celular por celular.",
            "Wir helfen dir, die Ortung für das ganze Team zum Laufen zu bringen, Handy für Handy.",
        ],
        PickATime: ["Pick a time", "Elegir un horario", "Termin wählen"],
        HelpVideos: ["Or watch how it works", "O mira cómo funciona", "Oder sieh dir an, wie es geht"],
        HelpOfferTitle: ["Let us make you an offer", "Déjanos hacerte una oferta", "Lass uns dir ein Angebot machen"],
        HelpOfferDesc: [
            "Send us your budget. We reply by email within one business day, and your account stays active.",
            "Envíanos tu presupuesto. Te respondemos por correo en un día hábil y tu cuenta sigue activa.",
            "Schick uns dein Budget. Wir antworten innerhalb eines Werktags per E-Mail, und dein Konto bleibt aktiv.",
        ],
        SendBudget: ["Send my budget", "Enviar mi presupuesto", "Budget senden"],
        HelpFeatureTitle: ["Good news: it may be on its way", "Buenas noticias: puede que ya esté en camino", "Gute Nachricht: Vielleicht ist sie schon unterwegs"],
        HelpFeatureDesc: [
            "Several features are close to ready. We check yours and reply by email within one business day. Your account stays active.",
            "Varias funciones están casi listas. Revisamos la tuya y te respondemos por correo en un día hábil. Tu cuenta sigue activa.",
            "Einige Funktionen sind fast fertig. Wir prüfen deine und antworten innerhalb eines Werktags per E-Mail. Dein Konto bleibt aktiv.",
        ],
        AskUsToCheck: ["Ask us to check", "Pídenos revisarlo", "Prüfen lassen"],
        HelpCallTitle: ["Sorry we let you down", "Lamentamos haberte fallado", "Tut uns leid, dass wir dich enttäuscht haben"],
        HelpCallDesc: [
            "Pick a time to talk. We'll already know what happened.",
            "Elige un horario para hablar. Ya sabremos lo que pasó.",
            "Wähle einen Termin für ein Gespräch. Wir wissen dann schon, was passiert ist.",
        ],
        ContactOk: ["You may contact me about this", "Pueden contactarme sobre esto", "Ihr dürft mich dazu kontaktieren"],
        KeepAccount: ["Keep my account", "Conservar mi cuenta", "Konto behalten"],
        ContinueDeactivating: ["Continue deactivating", "Continuar con la desactivación", "Weiter deaktivieren"],
        ChangeReason: ["Change reason", "Cambiar motivo", "Grund ändern"],
        DoneOfferTitle: ["We got your budget", "Recibimos tu presupuesto", "Wir haben dein Budget erhalten"],
        DoneFeatureTitle: ["We'll check and reply", "Lo revisamos y te respondemos", "Wir prüfen es und melden uns"],
        DoneReplyDesc: [
            "Our team replies by email within one business day. Your account stays active.",
            "Nuestro equipo te responde por correo en un día hábil. Tu cuenta sigue activa.",
            "Unser Team antwortet innerhalb eines Werktags per E-Mail. Dein Konto bleibt aktiv.",
        ],
        DoneBookedTitle: ["Talk to you soon", "Hablamos pronto", "Bis bald"],
        DoneBookedDesc: [
            "The invite is on its way to your email. Your account stays as it is.",
            "La invitación va camino a tu correo. Tu cuenta queda como está.",
            "Die Einladung ist per E-Mail unterwegs. Dein Konto bleibt, wie es ist.",
        ],
    },
    Demo: {
        IndustryFieldService: ["Field service", "Servicio de campo", "Außendienst"],
        IndustryDelivery: ["Delivery", "Entrega", "Lieferung"],
        IndustryMaintenance: ["Maintenance", "Mantenimiento", "Wartung"],
        IndustryHealthcareVisits: ["Healthcare visits", "Visitas médicas", "Medizinische Hausbesuche"],
        IndustrySalesVisits: ["Sales visits", "Visitas de ventas", "Vertriebsbesuche"],
        IndustryLogistics: ["Logistics", "Logística", "Logistik"],
        WorkflowSameDayDispatch: ["Same-day dispatch", "Despacho el mismo día", "Disposition am selben Tag"],
        WorkflowPlannedDailyRoutes: ["Planned daily routes", "Rutas diarias planificadas", "Geplante Tagesrouten"],
        WorkflowUrgentServiceCalls: ["Urgent service calls", "Llamadas de servicio urgentes", "Dringende Serviceeinsätze"],
        WorkflowPickupAndDelivery: ["Pickup and delivery", "Recogida y entrega", "Abholung und Lieferung"],
        WorkflowRecurringCustomerVisits: ["Recurring customer visits", "Visitas recurrentes a clientes", "Wiederkehrende Kundenbesuche"],
        BuildStepProvisionCompany: ["Setting up your company", "Creando tu empresa", "Dein Unternehmen wird eingerichtet"],
        BuildStepHireWorkers: ["Hiring demo workers", "Creando trabajadores de demo", "Demo-Mitarbeiter werden erstellt"],
        BuildStepGenerateJobsRoutes: ["Generating jobs & routes", "Generando tareas y rutas", "Aufträge und Routen werden erstellt"],
        BuildStepStartGps: ["Starting live GPS movement", "Iniciando movimiento GPS en vivo", "Live-GPS-Bewegung wird gestartet"],
        ErrorLoadSession: ["Could not load the demo session.", "No se pudo cargar la sesión demo.", "Die Demo-Sitzung konnte nicht geladen werden."],
        ErrorSetupFailed: ["Demo setup failed.", "La configuración de la demo falló.", "Die Demo-Einrichtung ist fehlgeschlagen."],
        ErrorExpired: ["This demo session expired before it was ready.", "Esta sesión demo expiró antes de estar lista.", "Diese Demo-Sitzung ist abgelaufen, bevor sie bereit war."],
        ErrorLocationRequired: ["Enter the city or region for the demo.", "Ingresa la ciudad o región para la demo.", "Gib die Stadt oder Region für die Demo ein."],
        ErrorSecurityCheckRequired: ["Complete the security check to start the demo.", "Completa la verificación de seguridad para iniciar la demo.", "Schließe die Sicherheitsprüfung ab, um die Demo zu starten."],
        ErrorCreateSession: ["Could not create the demo.", "No se pudo crear la demo.", "Die Demo konnte nicht erstellt werden."],
        Eyebrow: ["Live product demo", "Demo del producto en vivo", "Live-Produktdemo"],
        Title: ["Build your live Hellotracks demo", "Crea tu demo en vivo de Hellotracks", "Erstelle deine Live-Demo von Hellotracks"],
        Description: [
            "Answer three quick questions and we'll spin up a temporary team with real workers, dispatch activity, and live GPS movement.",
            "Responde tres preguntas rápidas y crearemos un equipo temporal con trabajadores reales, actividad de despacho y movimiento GPS en vivo.",
            "Beantworte drei kurze Fragen und wir erstellen ein temporäres Team mit echten Mitarbeitern, Disposition und Live-GPS-Bewegung.",
        ],
        TeamQuestion: ["What does your team do?", "¿Qué hace tu equipo?", "Was macht dein Team?"],
        WorkflowQuestion: ["How do they work?", "¿Cómo trabajan?", "Wie arbeitet das Team?"],
        LocationQuestion: ["City or region", "Ciudad o región", "Stadt oder Region"],
        LocationPlaceholder: ["San Francisco, CA", "San Francisco, CA", "San Francisco, CA"],
        StartLiveDemo: ["Start live demo", "Iniciar demo en vivo", "Live-Demo starten"],
        ExpirationNote: [
            "No signup required · Demo sessions expire automatically after 30 minutes",
            "No requiere registro · Las sesiones demo expiran automáticamente después de 30 minutos",
            "Keine Registrierung erforderlich · Demo-Sitzungen laufen automatisch nach 30 Minuten ab",
        ],
        BuildingTitle: ["Building your demo", "Creando tu demo", "Deine Demo wird erstellt"],
        BuildingDescription: [
            "Setting up a demo team for {0}{1}. This usually takes under a minute — you'll be logged in automatically.",
            "Estamos creando un equipo demo para {0}{1}. Normalmente tarda menos de un minuto — iniciarás sesión automáticamente.",
            "Ein Demo-Team für {0}{1} wird eingerichtet. Das dauert normalerweise weniger als eine Minute — du wirst automatisch angemeldet.",
        ],
        BuildingLocationSuffix: [" in {0}", " en {0}", " in {0}"],
        BuildingPatientNote: [
            "Live GPS takes a few extra seconds to come online. Hang tight, you're almost in.",
            "El GPS en vivo tarda unos segundos más en activarse. Un momento, ya casi estás dentro.",
            "Live-GPS braucht ein paar Sekunden länger, bis es läuft. Einen Moment, du bist gleich drin.",
        ],
        BuildingSlowDescription: [
            "This is taking longer than usual. Create your free account now, or keep waiting and you'll be logged in once the demo is ready.",
            "Esto está tardando más de lo normal. Crea tu cuenta gratis ahora, o espera y entrarás automáticamente cuando la demo esté lista.",
            "Das dauert länger als sonst. Erstelle jetzt dein kostenloses Konto oder warte noch – sobald die Demo bereit ist, wirst du automatisch angemeldet.",
        ],
        FailedSignupNote: [
            "You can still try Hellotracks with your own team. Your account is free.",
            "Aún puedes probar Hellotracks con tu propio equipo. Tu cuenta es gratis.",
            "Du kannst Hellotracks trotzdem mit deinem eigenen Team ausprobieren. Dein Konto ist kostenlos.",
        ],
        CreateYourFreeAccount: ["Create your free account", "Crea tu cuenta gratis", "Kostenloses Konto erstellen"],
        WorkspaceLabel: ["Demo workspace", "Espacio demo", "Demo-Arbeitsbereich"],
        TimeRemaining: ["{0} remaining", "Quedan {0}", "{0} verbleibend"],
        Expired: ["Expired", "Expirada", "Abgelaufen"],
        Feedback: ["Feedback", "Comentarios", "Feedback"],
        Restart: ["Restart", "Reiniciar", "Neu starten"],
        Exit: ["Exit", "Salir", "Beenden"],
        CreateOwnWorkspace: [
            "Create your own workspace",
            "Crea tu propio espacio de trabajo",
            "Eigenen Arbeitsbereich erstellen",
        ],
        ConversionTitle: [
            "Want to try this with your own team?",
            "¿Quieres probar esto con tu propio equipo?",
            "Möchtest du das mit deinem eigenen Team ausprobieren?",
        ],
        ConversionDescription: [
            "Create a free workspace and explore Hellotracks with your own dispatchers, workers, jobs, and routes.",
            "Crea un espacio de trabajo gratuito y explora Hellotracks con tus propios operadores, trabajadores, tareas y rutas.",
            "Erstelle einen kostenlosen Arbeitsbereich und teste Hellotracks mit deinen eigenen Disponenten, Mitarbeitern, Aufträgen und Routen.",
        ],
        ConversionExpiredTitle: [
            "Your demo workspace expired.",
            "Tu espacio demo ha expirado.",
            "Dein Demo-Arbeitsbereich ist abgelaufen.",
        ],
        ConversionExpiredDescription: [
            "Create a free workspace to keep exploring with your own data.",
            "Crea un espacio de trabajo gratuito para seguir explorando con tus propios datos.",
            "Erstelle einen kostenlosen Arbeitsbereich, um mit deinen eigenen Daten weiterzumachen.",
        ],
        StartFreeTrial: ["Start free trial", "Iniciar prueba gratis", "Kostenlose Testversion starten"],
        ContinueDemo: ["Continue demo", "Continuar demo", "Demo fortsetzen"],
        RestartDemo: ["Restart demo", "Reiniciar demo", "Demo neu starten"],
        CreateFreeWorkspace: ["Create free workspace", "Crear espacio gratuito", "Kostenlosen Arbeitsbereich erstellen"],
        FeedbackTitle: ["How was the live demo?", "¿Qué te pareció la demo en vivo?", "Wie war die Live-Demo?"],
        FeedbackDescription: [
            "Your feedback helps us improve the temporary demo workspace.",
            "Tus comentarios nos ayudan a mejorar el espacio demo temporal.",
            "Dein Feedback hilft uns, den temporären Demo-Arbeitsbereich zu verbessern.",
        ],
        FeedbackUseful: ["Useful", "Útil", "Nützlich"],
        FeedbackSomewhat: ["Somewhat", "Algo útil", "Teilweise"],
        FeedbackNotUseful: ["Not useful", "No útil", "Nicht nützlich"],
        FeedbackPlaceholder: [
            "What would you want to see next?",
            "¿Qué te gustaría ver después?",
            "Was möchtest du als Nächstes sehen?",
        ],
        FeedbackSendFailed: ["Could not send feedback.", "No se pudieron enviar los comentarios.", "Feedback konnte nicht gesendet werden."],
        FeedbackSkip: ["Skip", "Omitir", "Überspringen"],
        FeedbackClose: ["Close", "Cerrar", "Schließen"],
        FeedbackSend: ["Send feedback", "Enviar comentarios", "Feedback senden"],
    },
    Alerts: {
        CreateAlert: ['Create alert', 'Crear alerta', 'Alarm erstellen'],
        Alert: ["Alert", "Alerta", "Alarm"],
        AlertActiveOn: ["This alert is active on", "Esta alerta está activada", "Dieser Alarm ist aktiv"],
        AlertAndAddContition: ["and (add condition)", "y (condición adicional)", "und (zus. Bedingung)"],
        AlertAnywhere: ["anywhere", "donde sea", "irgendwo"],
        AlertAtPlace: ["at place", "en un lugar", "an einem Ort"],
        AlertChecksIn: ["checks in", "hace check-in", "checkt ein"],
        AlertTitlePlaceholder: [
            "Give this alert a name",
            "Asigna un nombre a esta alerta",
            "Gib diesem Alarm einen Namen",
        ],
        AlertChecksOut: ["checks out", "hace check-out", "checkt aus"],
        AlertDeleteQuest: [
            "Delete this alert configuration?",
            "¿Borrar esta configuración de alerta?",
            "Diese Alarm-Konfiguration entfernen?",
        ],
        AlertDoesntCheckIn: [
            "doesn't check in before the alert time ends",
            "no hace check-in antes de que termine la hora de alerta",
            "checkt nicht ein, bevor die Alarmzeit endet",
        ],
        AlertDoesntCheckOut: [
            "doesn't check out before the alert time ends",
            "no hace check-out antes de que termine la hora de alerta",
            "checkt nicht aus, bevor die Alarmzeit endet",
        ],
        AlertEntersZone: ["Enters zone", "Entra en zona", "Eintritt in Zone"],
        AlertEntersDangerZone: ["Enters danger zone", "Entra en zona peligrosa", "Eintritt in Gefahrenzone"],
        AlertDangerZoneDesc: [
            "Danger zone alerts notify the member directly via a message when they enter the zone.",
            "Las alertas de zona peligrosa notifican al miembro directamente mediante un mensaje cuando entra en la zona.",
            "Gefahrenzonen-Alarme benachrichtigen das Mitglied direkt per Nachricht, wenn es die Zone betritt.",
        ],
        AlertDangerZoneMessage: [
            "Member message",
            "Mensaje para miembro",
            "Nachricht an Mitglied",
        ],
        AlertDangerZoneMessagePlaceholder: [
            "{title}: {member} entered danger zone {zone} at {time}",
            "{title}: {member} entró en la zona peligrosa {zone} a las {time}",
            "{title}: {member} hat die Gefahrenzone {zone} um {time} betreten",
        ],
        AlertDangerZoneMessageCaption: [
            "Leave empty to use the default message. Supported placeholders: {title}, {member}, {zone}, {time}, {company}.",
            "Deja vacío para usar el mensaje predeterminado. Marcadores admitidos: {title}, {member}, {zone}, {time}, {company}.",
            "Leer lassen, um die Standardnachricht zu verwenden. Unterstützte Platzhalter: {title}, {member}, {zone}, {time}, {company}.",
        ],
        AlertDangerZoneSendToDesc: [
            "The member message above is sent directly to the selected member. Email and Slack are optional copies for supervisors or channels.",
            "El mensaje para miembro de arriba se envía directamente al miembro seleccionado. El correo electrónico y Slack son copias opcionales para supervisores o canales.",
            "Die Nachricht oben wird direkt an das ausgewählte Mitglied gesendet. E-Mail und Slack sind optionale Kopien für Vorgesetzte oder Channels.",
        ],
        AlertBatteryLow: [
            "Battery low",
            "Batería baja",
            "Batterie niedrig",
        ],
        AlertBatteryLowDesc: [
            "Low-battery alerts notify the member directly when their battery is at or below 20% and the device is not charging.",
            "Las alertas de batería baja notifican al miembro directamente cuando su batería está al 20% o menos y el dispositivo no se está cargando.",
            "Alarme bei niedrigem Batteriestand benachrichtigen das Mitglied direkt, wenn der Batteriestand 20% oder weniger beträgt und das Gerät nicht geladen wird.",
        ],
        AlertBatteryLowMessage: [
            "Member message",
            "Mensaje para miembro",
            "Nachricht an Mitglied",
        ],
        AlertBatteryLowMessagePlaceholder: [
            "{title}: {member}, your device battery is low ({battery}%). Please charge your device. Time: {time}",
            "{title}: {member}, la batería de tu dispositivo está baja ({battery}%). Carga tu dispositivo. Hora: {time}",
            "{title}: {member}, der Batteriestand deines Geräts ist niedrig ({battery}%). Bitte lade dein Gerät. Zeit: {time}",
        ],
        AlertBatteryLowMessageCaption: [
            "Leave empty to use the default message. This alert fires at 20% or less while not charging. Supported placeholders: {title}, {member}, {battery}, {time}, {company}.",
            "Deja vacío para usar el mensaje predeterminado. Esta alerta se activa al 20% o menos mientras no se está cargando. Marcadores admitidos: {title}, {member}, {battery}, {time}, {company}.",
            "Leer lassen, um die Standardnachricht zu verwenden. Dieser Alarm wird bei 20% oder weniger ausgelöst, solange nicht geladen wird. Unterstützte Platzhalter: {title}, {member}, {battery}, {time}, {company}.",
        ],
        AlertBatteryLowSendToDesc: [
            "The member message above is sent directly to the selected member. Slack is an optional copy for the team.",
            "El mensaje para miembro de arriba se envía directamente al miembro seleccionado. Slack es una copia opcional para el equipo.",
            "Die Nachricht oben wird direkt an das ausgewählte Mitglied gesendet. Slack ist eine optionale Kopie für das Team.",
        ],
        AlertLeavesZone: ["Leaves zone", "Sale de zona", "Austritt aus Zone"],
        AlertLoggedIn: ["Logged in", "Sesión iniciada", "Angemeldet"],
        AlertLoggedOut: ["Logged out", "Sesión cerrada", "Abgemeldet"],
        AlertLongIdleTime: ["Exceeds stationary time", "Excede el tiempo parado", "Langes Stillstehen (stationär)"],
        AlertConditions: ["Conditions", "Condiciones", "Bedingungen"],
        AlertAnd: ["AND", "Y", "UND"],
        AlertNewConfig: ["New configuration", "Nueva configuración", "Neue Konfiguration"],
        AlertNoConnectionToDevice: [
            "No connection to device",
            "Sin conexión al dispositivo",
            "Keine Verbindung zum Gerät",
        ],
        AlertScheduleDaysOfWeek: [
            "Schedule days of the week",
            "Selecciona días de la semana",
            "Wochentage auswählen",
        ],
        AlertSendTo: ["Send alert to", "Enviar alerta a", "Alarm senden an"],
        AlertWeekdays: ["weekdays", "días de la semana", "Wochentage"],
        AlertWithin: ["within", "dentro de", "binnen"],
        Alerts: ["Alerts", "Alertas", "Alarme"],
        AlertsDesc: [
            "Here you can create and edit alert configurations",
            "Aquí puedes crear y editar configuraciones de alertas",
            "Du kannst Alarm-Konfigurationen hier erstellen und bearbeiten",
        ],
        RecentAlerts: ['Recent alerts', 'Alertas recientes', 'Letzte Alarme'],
        ConfigureAlerts: ['Configure alerts', 'Configurar alertas', 'Alarme konfigurieren'],
        StartOfWorkingHours: [
            "Start of working hours",
            "Inicio del horario de trabajo",
            "Beginn der Arbeitszeit",
        ],
        EndOfWorkingHours: [
            "End of working hours",
            "Fin del horario de trabajo",
            "Ende der Arbeitszeit",
        ],
        ClockInSwitch: [
            "Clocked in / Switch activated",
            "Hora de entrada / interruptor activo",
            "Eingestempelt / Schalter aktiviert",
        ],
        ClockOutService: [
            "Clocked out / Not in service",
            "Hora de salida / interruptor inactivo",
            "Ausgestempelt / nicht im Dienst",
        ],
        CheckInAtX: [
            "Check-in at {0}",
            "Check-in en {0}",
            "Check-in in {0}",
        ],
        CheckOutAtX: [
            "Check-out at {0}",
            "Check-out de {0}",
            "Check-out aus {0}",
        ],
        ManualCheckInAtX: [
            'Manual check-in at {0}',
            'Check-in manual en {0}',
            'Manueller Check-in in {0}',
        ],
        ManualCheckOutAtX: [
            'Manual check-out at {0}',
            'Check-out manual de {0}',
            'Manueller Check-out aus {0}',
        ],
        ArrivedAtJobX: [
            "Arrived at job {0}",
            "Llegó a la tarea {0}",
            "Am Auftrag {0} angekommen",
        ],
        LeftJobX: [
            "Left job {0}",
            "Salió de la tarea {0}",
            "Auftrag {0} verlassen",
        ],
        CompletedMarkedJobX: [
            "Marked job as completed: {0}",
            "Tarea marcada como completada: {0}",
            "Auftrag als erledigt markiert: {0}",
        ],
        IssueMarkedJobX: [
            "Marked job as issue: {0}",
            "Tarea marcada como problema: {0}",
            "Auftrag als Problem markiert: {0}",
        ],
    },
    Reports: {
        JobReport: ["Jobs", "Tareas", "Aufträge"],
        DayRouteReport: ["Day route", "Ruta del día", "Tagesroute"],
        PlacesReport: ["Export places", "Exportar lugares", "Orte exportieren"],
        AlertsReport: ["Alerts", "Alertas", "Alarmbericht"],
        CheckinsReport: ["Check-ins", "Check-ins", "Check-ins"],
        VisitsCount: ["{0} visits", "{0} visitas", "{0} Besuche"],
        OneVisit: ["1 visit", "1 visita", "1 Besuch"],
        VisitorsCount: ["{0} people", "{0} personas", "{0} Personen"],
        PlacesCount: ["{0} places", "{0} lugares", "{0} Orte"],
        AverageStay: ["average stay", "estancia media", "im Schnitt"],
        Left: ["Left", "Salida", "Gegangen"],
        Now: ["now", "ahora", "jetzt"],
        DeletedMember: ["Deleted member", "Miembro eliminado", "Gelöschtes Mitglied"],
        DeletedPlace: ["Deleted place", "Lugar eliminado", "Gelöschter Ort"],
        NoVisitsInPeriod: ["No visits in this period", "Sin visitas en este período", "Keine Besuche in diesem Zeitraum"],
        MembersReport: ["Export members", "Exportar miembros", "Mitglieder exportieren"],
        MileageReport: ["Mileage report", "Informe de kilometraje", "Kilometerbericht"],
        PlaceOnSiteReport: ["Place on-site times", "Tiempos en lugares", "Zeit an Orten"],
        MemberOnSiteReport: ["On-site times of your team", "Tiempos en lugares de tu equipo", "Vor-Ort-Zeiten deines Teams"],
        NewReport: ['New report', 'Nuevo informe', 'Neuer Bericht'],
        JobReportDesc: [
            "A detailed report that exports all data related to jobs, including information entered by the worker such as job start and end times, location, and any notes or comments. It can be used to track job progress and performance.",
            "Un informe detallado que exporta todos los datos relacionados con las tareas, incluida la información ingresada por el trabajador, como la hora de inicio y fin de las tareas, la ubicación y cualquier nota o comentario. Se puede usar para hacer seguimiento del progreso y el rendimiento de las tareas.",
            "Ein detaillierter Bericht, der alle auftragsbezogenen Daten exportiert, einschließlich der vom Mitarbeiter eingegebenen Informationen wie Start- und Endzeiten des Auftrags, Standort sowie etwaige Notizen oder Kommentare. Er kann verwendet werden, um den Auftragsfortschritt und die Leistung zu verfolgen.",
        ],
        DayRouteReportDesc: [
            "This report shows a list of jobs that a worker completed on a specific day, including the location and time of each job. This report can be useful for analyzing worker productivity and efficiency, as well as for optimizing future routes to reduce travel time and fuel consumption.",
            "Este informe muestra una lista de tareas que un trabajador completó en un día específico, la ubicación y la hora de cada tarea. Este informe puede ser útil para analizar la productividad y la eficiencia de los trabajadores, así como para optimizar las rutas futuras para reducir el tiempo de viaje y el consumo de combustible.",
            "Dieser Bericht zeigt eine Liste der Aufträge, die ein Mitarbeiter an einem bestimmten Tag abgeschlossen hat, einschließlich des Standorts und der Zeit jedes Auftrags. Dieser Bericht kann nützlich sein, um die Produktivität und Effizienz der Mitarbeiter zu analysieren sowie zukünftige Routen zu optimieren, um Fahrtzeit und Kraftstoffverbrauch zu reduzieren.",
        ],
        PlacesReportDesc: [
            "This report contains all data related to your places in the system. This includes information such as the name, location, as well as any additional details or notes associated with the place.",
            "Este informe contiene todos los datos relacionados con tus lugares en el sistema. Esto incluye información como el nombre, la ubicación, así como cualquier detalle adicional o notas asociadas con el lugar.",
            "Dieser Bericht enthält alle Daten zu deinen Orten im System. Dazu gehören Name, Standort sowie alle zusätzlichen Details oder Notizen, die du zum Ort hinterlegt hast.",
        ],
        AlertsReportDesc: [
            "This report shows a detailed list of all the alerts that have been triggered, including information such as the type of alert, the location, and the time it was triggered. It can be used to track and troubleshoot any issues that may have occurred.",
            "Este informe muestra una lista detallada de todas las alertas que se han activado, incluida información como el tipo de alerta, la ubicación y la hora en que se activó. Se puede usar para detectar y solucionar los problemas que hayan ocurrido.",
            "Dieser Bericht zeigt eine detaillierte Liste aller ausgelösten Alarme, einschließlich Informationen wie Art des Alarms, Standort und Auslösezeitpunkt. Er kann verwendet werden, um aufgetretene Probleme zu verfolgen und zu beheben.",
        ],
        CheckinsReportDesc: [
            "This report shows a list of all check-ins and check-outs of your team at places in your system. It can be used to track worker attendance.",
            "Este informe muestra una lista de todos los check-ins y check-outs de tu equipo en los lugares de tu sistema. Se puede usar para hacer seguimiento de la asistencia de los trabajadores.",
            "Dieser Bericht listet alle Check-ins und Check-outs deines Teams an deinen Orten auf. So kannst du die Anwesenheit der Mitarbeiter nachverfolgen.",
        ],
        MembersReportDesc: [
            "This report contains all data related to the members in the system, including information such as the name, role, and contact information.",
            "Este informe contiene todos los datos relacionados con los miembros del sistema, incluida la información como el nombre, el rol y la información de contacto.",
            "Dieser Bericht enthält alle Daten zu den Mitgliedern im System, einschließlich Informationen wie Name, Rolle und Kontaktdaten.",
        ],
        MileageReportDesc: [
            "This report provides detailed information on the mileage traveled by workers, including the start and end location, distance traveled, and duration of the trip. It can be used to track worker productivity and optimize routes for future jobs.",
            "Este informe proporciona información detallada sobre el kilometraje recorrido por los trabajadores, incluida la ubicación de inicio y finalización, la distancia recorrida y la duración del viaje. Se puede utilizar para hacer seguimiento de la productividad de los trabajadores y optimizar las rutas para futuras tareas.",
            "Dieser Bericht liefert detaillierte Informationen über die von Mitarbeitern zurückgelegten Kilometer, einschließlich Start- und Endposition, zurückgelegte Strecke und Dauer der Fahrt. Er kann verwendet werden, um die Produktivität der Mitarbeiter zu verfolgen und Routen für zukünftige Aufträge zu optimieren.",
        ],
        PlaceOnSiteReportDesc: [
            "This report provides detailed information on the amount of time a worker has spent at a specific place, including the start and end time, and total duration of the visit. This report can be used to track worker productivity and efficiency.",
            "Este informe proporciona información detallada sobre la cantidad de tiempo que un trabajador ha pasado en un lugar específico, incluido el tiempo de inicio y finalización, y la duración total de la visita. Este informe se puede utilizar para hacer seguimiento de la productividad y la eficiencia de los trabajadores.",
            "Dieser Bericht enthält detaillierte Informationen über die Zeit, die ein Mitarbeiter an einem bestimmten Ort verbracht hat, einschließlich Start- und Endzeit sowie Gesamtdauer des Besuchs. Dieser Bericht kann verwendet werden, um die Produktivität und Effizienz der Mitarbeiter zu verfolgen.",
        ],
        MemberOnSiteReportDesc: [
            "This report provides detailed information on the amount of time a worker has spent at a specific place, including the start and end time, and total duration of the visit. This report can be used to track worker productivity and efficiency.",
            "Este informe proporciona información detallada sobre la cantidad de tiempo que un trabajador ha pasado en un lugar específico, incluido el tiempo de inicio y finalización, y la duración total de la visita. Este informe se puede utilizar para hacer seguimiento de la productividad y la eficiencia de los trabajadores.",
            "Dieser Bericht liefert detaillierte Informationen über die Zeit, die ein Mitarbeiter an einem bestimmten Ort verbracht hat, einschließlich Start- und Endzeit sowie Gesamtdauer des Besuchs. Dieser Bericht kann verwendet werden, um die Produktivität und Effizienz der Mitarbeiter zu verfolgen.",
        ],
        EnterNameForThisReport: ["Enter name for this recurring report", "Ingresa un nombre para este informe recurrente", "Name für diesen wiederkehrenden Bericht eingeben"],
        TimesheetReport: ['Timesheet', 'Hoja de horas', 'Zeiterfassung'],
        TimesheetReportDesc: [
            "Your team can clock in and out with the Hellotracks mobile app by turning the Active switch on/off. Here you can find a summary of your team's clock-in and clock-out times.",
            'Tu equipo puede registrar la entrada y la salida con la app móvil de Hellotracks activando o desactivando el interruptor Activo. Aquí encontrarás un resumen de las horas de entrada y salida de tu equipo.',
            'Dein Team kann sich in der Hellotracks-App ein- und ausstempeln, indem es den Aktiv-Schalter ein- oder ausschaltet. Hier findest du eine Zusammenfassung der Ein- und Ausstempelzeiten deines Teams.',
        ],
        RecurringReports: ["Recurring reports", "Informes recurrentes", "Wiederkehrende Berichte"],
        RecentReports: ["Recent reports", "Informes recientes", "Aktuelle Berichte"],
        ReportQueued: ["Report queued", "Informe en cola", "Bericht eingereiht"],
        ReportProcessing: ["Creating report", "Creando informe", "Bericht wird erstellt"],
        ReportFailed: ["Report failed", "Informe fallido", "Bericht fehlgeschlagen"],
        SelectTimeFrame: ["Select time frame", "Seleccionar periodo", "Zeitrahmen auswählen"],
        SelectDayToCreate: ["Select day to create", "Seleccionar día para crear", "Tag zum Erstellen auswählen"],
        SelectDayToCreateFirstReport: [
            "Select day to create first report (the day of report creation is not included)",
            "Seleccionar día para crear el primer informe (el día de creación del informe no está incluido)",
            "Wähle den Tag, um den ersten Bericht zu erstellen (der Tag der Berichtserstellung ist nicht enthalten)",
        ],
        NotifyPeopleOnCreation: [
            "Notify people on creation",
            "Notificar a las personas en la creación",
            "Personen bei Erstellung benachrichtigen",
        ],
        ExportFormSubmissions: ["Export form submissions", "Exportar envíos de formularios", "Formular-Einsendungen exportieren"],
        ExportFormSubmissionsDesc: [
            "You can export form submissions here. This report contains all data filled out by your staff in the field. Select a form below to start.",
            "Aquí puedes exportar los envíos de formularios. Este informe contiene todos los datos completados por tu personal en el campo. Selecciona un formulario a continuación para empezar.",
            "Du kannst hier Formular-Einsendungen exportieren. Dieser Bericht enthält alle Daten, die von deinem Personal vor Ort ausgefüllt wurden. Wähle unten ein Formular aus, um zu beginnen.",
        ],
        GpxReport: ["Trips as GPX file", "Viajes como archivo GPX", "Fahrten als GPX-Datei"],
        GpxReportDesc: [
            "After the download, unzip the file. You can analyze your trip with tools such as gpsvisualizer.com",
            "Después de descargar, descomprime el archivo. Puedes analizar tu viaje con herramientas como gpsvisualizer.com.",
            "Nach dem Download die Zip-Datei entpacken. Du kannst deine Fahrt mit Werkzeugen wie gpsvisualizer.com analysieren.",
        ],
        StopsReport: [
            "Stops",
            "Paradas",
            "Stopps",
        ],
        StopsReportDesc: [
            "This report provides detailed information on the stops made by workers at places or other locations, including the duration of idling time spent without moving. This data can offer valuable insights into worker behavior and be helpful for client billing, as well as assist in optimizing productivity and efficiency.",
            "Este informe proporciona información detallada sobre las paradas realizadas por los trabajadores en lugares u otras ubicaciones, incluida la duración del tiempo de inactividad sin movimiento. Estos datos pueden ofrecer información valiosa sobre el comportamiento de los trabajadores, ser útiles para la facturación a los clientes y ayudar a optimizar la productividad y eficiencia.",
            "Dieser Bericht bietet detaillierte Informationen zu den Stopps deiner Mitarbeiter an Orten oder anderswo, einschließlich der Dauer der Leerlaufzeit ohne Bewegung. Diese Daten können wertvolle Einblicke in das Verhalten von Mitarbeitern liefern, hilfreich für die Kundenabrechnung sein und bei der Optimierung von Produktivität und Effizienz unterstützen.",
        ],
        ActivitiesReport: [
            "Activities report",
            "Informe de actividades",
            "Aktivitätenbericht"
        ],
        ActivitiesReportDesc: [
            "The activities report provides a detailed record of all the events and actions that have occurred within your organization. It includes a list of activities per member, providing details on when they occurred and who performed them.",
            "El informe de actividades proporciona un registro detallado de todos los eventos y acciones que han ocurrido dentro de tu organización. Incluye una lista de actividades por miembro, detallando cuándo ocurrieron y quién las realizó.",
            "Der Aktivitätenbericht liefert eine detaillierte Übersicht über alle Ereignisse und Aktionen, die innerhalb deiner Organisation stattgefunden haben. Er enthält eine Liste der Aktivitäten pro Mitglied mit Zeitpunkt und ausführender Person."
        ],
        TimelineReport: [
            "Timeline report",
            "Informe de línea de tiempo",
            "Timeline-Bericht"
        ],
        TimelineReportDesc: [
            "The timeline report shows a chronological overview of all the actions and events that have occurred within your organization, visualizing progress and activity over time.",
            "El informe de línea de tiempo muestra una visión general cronológica de todas las acciones y eventos que han ocurrido dentro de tu organización, visualizando el progreso y la actividad a lo largo del tiempo.",
            "Der Timeline-Bericht zeigt einen chronologischen Überblick über alle Aktionen und Ereignisse, die innerhalb deiner Organisation stattgefunden haben, und visualisiert Fortschritte und Aktivitäten im Laufe der Zeit."
        ],
        Worksheet: [
            "Worksheet",
            "Hoja de trabajo",
            "Arbeitsblatt",
        ],
        TimeAllocationReport: [
            "Time allocation report",
            "Informe de asignación de tiempo",
            "Bericht zur Zeitaufteilung",
        ],
        TimeAllocationReportDesc: [
            "A detailed analysis of a team member’s time across three key areas: active working hours (from timesheet entries), time at specific places with check-in counts, and travel time between places. Perfect for your performance reviews, project planning, and understanding work patterns.",
            "Un análisis detallado del tiempo de un miembro del equipo en tres áreas clave: horas de trabajo activas (a partir de entradas de hoja de horas), tiempo en lugares específicos con conteo de check-ins y tiempo de viaje entre lugares. Perfecto para tus evaluaciones de desempeño, la planificación de proyectos y entender patrones de trabajo.",
            "Eine detaillierte Analyse der Zeit eines Teammitglieds in drei Kernbereichen: aktive Arbeitsstunden (aus Zeiterfassungseinträgen), Zeit an bestimmten Orten mit Anzahl der Check-ins und Fahrtzeit zwischen Orten. Perfekt für deine Leistungsbeurteilungen, Projektplanung und zum Verständnis von Arbeitsmustern."
        ],
        WorksheetDesc: [
            "The worksheet report offers an analysis of travel times, on-site times at stops, pauses, logins, and other related activities. It is a tool for tracking, understanding, and optimizing operational efficiency.",
            "El informe de hoja de trabajo ofrece un análisis de los tiempos de viaje, tiempos en el sitio en las paradas, pausas, inicios de sesión y otras actividades relacionadas. Es una herramienta para medir, entender y optimizar la eficiencia operacional.",
            "Der Arbeitsblattbericht bietet eine Analyse der Fahrtzeiten, Zeiten vor Ort an Stopps, Pausen, Anmeldungen und anderer verwandter Aktivitäten. Er ist ein Werkzeug zum Verfolgen, Verstehen und Optimieren der Betriebseffizienz."
        ],
        StatisticsReport: [
            "Statistics report",
            "Informe de estadísticas",
            "Statistikbericht"
        ],

        StatisticsReportDesc: [
            "The statistics report provides a comprehensive summary of key metrics and data points within your organization. It includes insights on performance, productivity, and other important indicators, helping you make informed decisions.",
            "El informe de estadísticas proporciona un resumen completo de las métricas clave y puntos de datos dentro de tu organización. Incluye información sobre el rendimiento, la productividad y otros indicadores importantes, ayudándote a tomar decisiones informadas.",
            "Der Statistikbericht liefert eine umfassende Zusammenfassung wichtiger Kennzahlen und Datenpunkte innerhalb deiner Organisation. Er enthält Einblicke in Leistung, Produktivität und andere wichtige Indikatoren und unterstützt dich bei fundierten Entscheidungen."
        ],
        CreatedOn: ["Created {0}", "Creado el {0}", "Erstellt am {0}"],
        CreatedByOn: ["Created by {0} on {1}", "Creado por {0} el {1}", "Erstellt von {0} am {1}"],
        ResetColumns: ["Reset to default", "Restablecer", "Zurücksetzen"],
        Columns: [
            "Columns",
            "Columnas",
            "Spalten",
        ],
        DailyReport: [
            "Daily report",
            "Informe diario",
            "Täglicher Bericht",
        ],
        WeeklyReport: [
            "Weekly report",
            "Informe semanal",
            "Wöchentlicher Bericht",
        ],
        EveryTwoWeeksReport: [
            "Report every two weeks",
            "Informe cada dos semanas ",
            "Zweiwöchentlicher Bericht",
        ],
        AddSheetForVisitedPlaces: [
            "Sheet for visited places",
            "Hoja con lugares visitados",
            "Liste mit besuchten Orten",
        ],

        // --- subject groups for the catalogue ---
        GroupJobs: ["Jobs & routes", "Tareas y rutas", "Aufträge & Routen"],
        GroupTime: ["Time & attendance", "Tiempo y asistencia", "Zeit & Anwesenheit"],
        GroupDriving: ["Driving & location", "Manejo y ubicación", "Fahrten & Standort"],
        GroupPlaces: ["Places & on-site", "Lugares y visitas", "Orte & Besuche"],
        GroupPeople: ["People & forms", "Personas y formularios", "Personen & Formulare"],

        // --- one-line card summaries (the long *Desc texts stay for the run panel) ---
        JobReportShort: [
            "Every job with times, location and worker input.",
            "Cada tarea con horarios, ubicación y datos del trabajador.",
            "Jeder Auftrag mit Zeiten, Standort und Eingaben der Mitarbeiter.",
        ],
        DayRouteReportShort: [
            "What one worker completed on a day, in order.",
            "Lo que un trabajador completó en un día, en orden.",
            "Was ein Mitarbeiter an einem Tag erledigt hat, der Reihe nach.",
        ],
        PlacesReportShort: [
            "Your full place list with addresses and details.",
            "Tu lista completa de lugares con direcciones y detalles.",
            "Deine komplette Ortsliste mit Adressen und Details.",
        ],
        AlertsReportShort: [
            "Every triggered alert with type, place and time.",
            "Cada alerta activada con tipo, lugar y hora.",
            "Jeder ausgelöste Alarm mit Typ, Ort und Zeitpunkt.",
        ],
        CheckinsReportShort: [
            "Check-ins and check-outs at your places.",
            "Check-ins y check-outs en tus lugares.",
            "Ein- und Auschecken an deinen Orten.",
        ],
        MembersReportShort: [
            "Your full team list with roles and contact details.",
            "Tu lista completa de miembros con roles y contacto.",
            "Deine komplette Mitgliederliste mit Rollen und Kontaktdaten.",
        ],
        MileageReportShort: [
            "Distance driven per trip, for expenses and tax.",
            "Distancia por viaje, para gastos e impuestos.",
            "Gefahrene Strecke pro Fahrt, für Spesen und Steuer.",
        ],
        PlaceOnSiteReportShort: [
            "Time spent at each place — grouped by place.",
            "Tiempo en cada lugar — agrupado por lugar.",
            "Zeit an jedem Ort — nach Ort gruppiert.",
        ],
        MemberOnSiteReportShort: [
            "Time spent at places — grouped by team member.",
            "Tiempo en lugares — agrupado por miembro.",
            "Zeit an Orten — nach Mitarbeiter gruppiert.",
        ],
        TimesheetReportShort: [
            "Clock-in and clock-out hours, ready for payroll.",
            "Horas de entrada y salida, listas para nómina.",
            "Ein- und Ausstempelzeiten, fertig für die Lohnabrechnung.",
        ],
        GpxReportShort: [
            "Raw trip traces as GPX files for other tools.",
            "Trazas de viajes en archivos GPX para otras herramientas.",
            "Rohe Fahrtaufzeichnungen als GPX-Dateien für andere Tools.",
        ],
        StopsReportShort: [
            "Every stop with location and how long it lasted.",
            "Cada parada con ubicación y duración.",
            "Jeder Stopp mit Standort und Dauer.",
        ],
        ActivitiesReportShort: [
            "An audit trail of what changed, and who changed it.",
            "Registro de qué cambió y quién lo cambió.",
            "Ein Protokoll darüber, was sich geändert hat und wer es geändert hat.",
        ],
        TimelineReportShort: [
            "A minute-by-minute view of a worker's day.",
            "Vista minuto a minuto del día de un trabajador.",
            "Eine minutengenaue Ansicht des Arbeitstags.",
        ],
        WorksheetShort: [
            "Travel time versus time on site, per worker.",
            "Tiempo de viaje frente a tiempo en el sitio, por trabajador.",
            "Fahrzeit im Vergleich zur Zeit vor Ort, pro Mitarbeiter.",
        ],
        TimeAllocationReportShort: [
            "Where a team member's hours actually went.",
            "En qué se fueron realmente las horas del miembro.",
            "Wohin die Stunden eines Mitarbeiters tatsächlich geflossen sind.",
        ],
        StatisticsReportShort: [
            "Headline numbers summarized across the period.",
            "Cifras principales resumidas del período.",
            "Kennzahlen, zusammengefasst über den Zeitraum.",
        ],
        ExportFormSubmissionsShort: [
            "Answers from one form, as rows you can filter.",
            "Respuestas de un formulario, como filas filtrables.",
            "Antworten eines Formulars als filterbare Zeilen.",
        ],

        // --- workspace ---
        InProgress: ["In progress", "En curso", "In Arbeit"],
        Scheduled: ["Scheduled", "Programados", "Geplant"],
        RecentFiles: ["Recent files", "Archivos recientes", "Aktuelle Dateien"],
        AllReports: ["All reports", "Todos los informes", "Alle Berichte"],
        XSelected: ["{0} selected", "{0} seleccionadas", "{0} ausgewählt"],
        RepeatOnSchedule: ["Repeat on a schedule", "Repetir según programación", "Regelmäßig wiederholen"],
        PauseSchedule: ["Pause", "Pausar", "Pausieren"],
        ResumeSchedule: ["Resume", "Reanudar", "Fortsetzen"],
        XMembers: ["{0} members", "{0} miembros", "{0} Mitglieder"],
        XPlaces: ["{0} places", "{0} lugares", "{0} Orte"],
        SearchReports: [
            "Search reports",
            "Buscar informes",
            "Berichte suchen",
        ],
        NoReportsMatch: ["No report matches \"{0}\"", "Ningún informe coincide con \"{0}\"", "Kein Bericht passt zu \"{0}\""],
        ShowAllFiles: ["Show all files", "Ver todos los archivos", "Alle Dateien anzeigen"],
        HideAllFiles: ["Hide file list", "Ocultar lista de archivos", "Dateiliste ausblenden"],
        ShowSchedules: ["Show", "Ver", "Anzeigen"],
        HideSchedules: ["Hide", "Ocultar", "Ausblenden"],
        NothingScheduledYet: [
            "Nothing scheduled yet. Any report can be set to run on a schedule.",
            "Nada programado todavía. Cualquier informe puede ejecutarse de forma programada.",
            "Noch nichts geplant. Jeder Bericht kann automatisch wiederholt werden.",
        ],
        NoFilesYet: [
            "No reports generated yet.",
            "Aún no se ha generado ningún informe.",
            "Noch keine Berichte erstellt.",
        ],

        // --- run history / re-run ---
        Run: ["Run", "Ejecutar", "Erstellen"],
        FormTemplate: ["Form", "Formulario", "Formular"],
        OpenReport: ["Open", "Abrir", "Öffnen"],
        RunAgain: ["Run again", "Ejecutar de nuevo", "Erneut erstellen"],
        Schedule: ["Schedule", "Programar", "Planen"],
        LastRun: ["Last run {0}", "Última ejecución {0}", "Zuletzt erstellt {0}"],
        ScheduledCadence: ["Scheduled {0}", "Programado {0}", "Geplant: {0}"],

        // --- constraints shown up front ---
        MaxRange: ["Max {0} days", "Máx. {0} días", "Max. {0} Tage"],
        NoDateRange: ["Current data", "Datos actuales", "Aktuelle Daten"],
        MembersOnly: ["By member", "Por miembro", "Nach Mitglied"],
        PlacesOnly: ["By place", "Por lugar", "Nach Ort"],
        MembersOrPlaces: ["By member or place", "Por miembro o lugar", "Nach Mitglied oder Ort"],
        WholeCompany: ["Whole company", "Toda la empresa", "Ganzes Unternehmen"],
    },
    JobReport: {
        Number: ["#", "#", "#"],
        RouteInfo: ["Route", "Ruta", "Route"],
        StatusTs: ["Status timestamp", "Marca de tiempo del estado", "Zeitstempel des Status"],
        StatusResponse: ["Status response", "Respuesta del estado", "Statusantwort"],
        ScheduledWindow: ["Scheduled window", "Ventana programada", "Geplantes Zeitfenster"],
        Attachments: ["Attachments", "Adjuntos", "Anhänge"],
        CustomFields: ["Custom fields", "Campos personalizados", "Benutzerdefinierte Felder"],
        FormFields: ["Form fields", "Campos del formulario", "Formularfelder"],
        PublicUrl: ["Public URL", "URL pública", "Öffentliche URL"],
    },
    Dashboard: {
        Mileage: ["Mileage", "Kilometraje", "Kilometer"],
        SpeedDiagram: ["Speed diagram", "Diagrama de velocidad", "Geschwindigkeitsdiagramm"]
    },
    Errors: {
        FileNotAccepted: ["File not accepted", "Archivo no aceptado", "Datei nicht akzeptiert"],
        IncorrectVerificationCode: ["The code is incorrect", "El código es incorrecto", "Der Code ist falsch"],
    },
    Places: {
        PlacesDescriptionTitle: [
            "What are places?",
            "¿Qué son los lugares?",
            "Was sind Orte?",
        ],
        PlacesDescription: [
            "Places are specific saved locations with a defined radius, such as customer sites, warehouses, or offices. They enable automatic check-ins and check-outs as team members enter or leave these predefined areas, facilitating accurate location-based tracking and reporting.",
            "Los lugares son ubicaciones específicas guardadas con un radio definido, como sitios de clientes, almacenes u oficinas. Permiten check-ins y check-outs automáticos cuando los miembros del equipo entran o salen de estas áreas predefinidas, facilitando un seguimiento e informes precisos basados en ubicación.",
            "Orte sind gespeicherte Standorte mit einem festgelegten Radius, etwa Kundenstandorte, Lager oder Büros. Sie ermöglichen automatische Ein- und Auscheckvorgänge, wenn Teammitglieder diese vordefinierten Bereiche betreten oder verlassen, und erleichtern eine präzise standortbasierte Erfassung und Berichterstattung.",
        ],
        ZonesDescriptionTitle: [
            "What are zones?",
            "¿Qué son las zonas?",
            "Was sind Zonen?",
        ],
        ZonesDescription: [
            "Zones are polygonal regions that can cover larger, irregular areas, such as delivery territories or service areas. They allow automatic triggering of location-based events when team members enter or leave these defined regions, and integrate seamlessly with jobs, forms, and alerts.",
            "Las zonas son regiones poligonales que pueden cubrir áreas más grandes e irregulares, como territorios de entrega o áreas de servicio. Permiten la activación automática de eventos basados en la ubicación cuando los miembros del equipo entran o salen de estas regiones definidas, y se integran perfectamente con tareas, formularios y alertas.",
            "Zonen sind polygonale Regionen, die größere, unregelmäßige Flächen abdecken können, wie etwa Liefergebiete oder Servicebereiche. Sie ermöglichen die automatische Auslösung standortbasierter Ereignisse, wenn Teammitglieder diese definierten Regionen betreten oder verlassen, und arbeiten nahtlos mit Aufträgen, Formularen und Alarmen zusammen.",
        ],
        ImportPlaces: [
            'Import places',
            'Importar lugares',
            'Orte importieren',
        ],
        ImportPlacesInfo: [
            '<p>You can download these <strong>templates</strong>:<ul><li><a href="{0}" target="_blank" download>CSV template</a>, or</li><li><a href="{1}" download>Excel template</a>, or</li><li><a href="{2}" target="_blank" download>KML template</a> (e.g. used in Google Earth/Maps).</li><li><strong>GeoJSON</strong>: you can simply export your current places as GeoJSON to see an example.</li></ul><small><br><strong>If you choose to import from Excel or CSV:</strong><ul><li>Do not rename header fields</li><li>You may remove columns if they don\'t apply</li><li>You may also leave cells empty if they don\'t apply</li><li>If you use the CSV format, make sure the file encoding is in UTF-8</li></ul></small>',
            '<p>Puedes descargar una <strong>plantilla de ejemplo</strong> aqu&iacute;:<ul><li><a href="{0}" target="_blank" download>plantilla de CSV</a>, o</li><li><a href="{1}" target="_blank" download>plantilla de Excel</a>, o</li><li><a href="{2}" download>plantilla de KML</a> (p. ej., Google Earth/Maps).</li><li><strong>GeoJSON</strong>: para ver un ejemplo, puedes exportar tus lugares actuales como GeoJSON.</li></ul><small><br><strong>Si eliges importar desde Excel o CSV:</strong><ul><li>No modifiques encabezados</li><li>Puedes quitar columnas</li><li>Deja campos vac&iacute;os si no aplican</li><li>Asegúrate de que la codificación del CSV sea UTF-8</li></ul></small>',
            '<p>Du kannst diese <strong>Vorlagen</strong> herunterladen:<ul><li><a href="{0}" target="_blank" download>CSV-Vorlage</a>, oder</li><li><a href="{1}" download>Excel-Vorlage</a>, oder</li><li><a href="{2}" target="_blank" download>KML-Vorlage</a> (z.B. in Google Earth/Maps).</li><li><strong>GeoJSON</strong>: exportiere deine eigenen Orte im GeoJSON-Format, um sie als Vorlage zu verwenden.</li></ul><small><br><strong>Wenn du aus Excel oder CSV importieren willst:</strong><ul><li>Die Felder der Kopfzeile nicht &auml;ndern</li><li>Spalten entfernen ist erlaubt</li><li>Du kannst Felder leer lassen</li><li>Wenn du das CSV-Format verwendest, achte darauf, dass die Datei UTF-8-kodiert ist.</li></ul></small>',
        ],
        ImportPlacesTitle: [
            'Import places from Excel, CSV, GeoJSON or KML file',
            'Importar lugares desde un archivo CSV, Excel, KML o GeoJSON',
            'Orte aus Excel-, CSV-, KML- oder GeoJSON-Datei importieren',
        ],
        NewPlace: [
            'New place',
            'Nuevo lugar',
            'Neuer Ort',
        ],
        SelectPlace: [
            "Select place",
            "Selecciona un lugar",
            "Ort auswählen",
        ],
        SelectPlaces: [
            "Select places",
            "Seleccionar lugares",
            "Orte auswählen",
        ],
        InvalidRadiusDesc: [
            "Enter a number between {0} and {1}",
            "Ingresa un número entre {0} y {1}",
            "Gib eine Zahl zwischen {0} und {1} ein",
        ],
        DeletePlace: ['Delete place', 'Borrar lugar', 'Ort löschen'],
        DeleteXPlaces: [
            "Delete {0} places",
            "Borrar {0} lugares",
            "{0} Orte löschen",
        ],
        ConfirmDeletePlacesDesc: [
            "I'm aware that deleting places cannot be undone.",
            "Soy consciente de que eliminar los lugares no se puede deshacer.",
            "Ich bin mir bewusst, dass das Löschen von Orten nicht rückgängig gemacht werden kann."
        ],
        EnterName: [
            "Enter place name",
            "Ingresar nombre del lugar",
            "Ortsname eingeben",
        ],
        LoadingPlaces: [
            "Loading places… {0} loaded",
            "Cargando lugares… {0} cargados",
            "Orte werden geladen… {0} geladen",
        ],
        RefreshingPlaces: [
            "Refreshing places… {0} currently shown",
            "Actualizando lugares… {0} visibles actualmente",
            "Orte werden aktualisiert… {0} derzeit angezeigt",
        ],
        EditPlace: [
            "Edit place",
            "Editar lugar",
            "Ort bearbeiten",
        ],
        PlaceImageUpdate: [
            "Image is updating in background",
            "La imagen se está actualizando en segundo plano",
            "Bild wird im Hintergrund aktualisiert",
        ],
        ApplyPlacesToPastVisits: [
            "Apply places to past visits",
            "Aplicar lugares a visitas anteriores",
            "Orte auf vergangene Besuche anwenden",
        ],
        ApplyPlacesToPastVisitsConfirmTitle: [
            "Apply places to past visits?",
            "¿Aplicar lugares a visitas anteriores?",
            "Orte auf vergangene Besuche anwenden?",
        ],
        ApplyPlacesToPastVisitsConfirmDesc: [
            "We’ll check recent stop history for all members and label visits that fall inside existing place areas. Existing place labels will not be removed.",
            "Revisaremos el historial reciente de paradas de todos los miembros y etiquetaremos las visitas que estén dentro de lugares existentes. Las etiquetas de lugares existentes no se eliminarán.",
            "Wir prüfen die aktuelle Stopp-Historie aller Mitglieder und markieren Besuche, die innerhalb bestehender Orte liegen. Bestehende Ortsmarkierungen werden nicht entfernt.",
        ],
        ApplyPlaces: [
            "Apply places",
            "Aplicar lugares",
            "Orte anwenden",
        ],
        ApplyPlacesToPastVisitsStarted: [
            "Applying places to past visits in the background",
            "Aplicando lugares a visitas anteriores en segundo plano",
            "Orte werden im Hintergrund auf vergangene Besuche angewendet",
        ],
        UnknownPlace: [
            "Unknown place",
            "Lugar desconocido",
            "Unbekannter Ort"
        ],

        UnnamedPlace: [
            "Unnamed place",
            "Lugar sin nombre",
            "Unbenannter Ort"
        ],

        CoordinatesNotSet: [
            "Coordinates not set",
            "Coordenadas no establecidas",
            "Koordinaten nicht festgelegt"
        ],

        DuplicateNames: [
            "Duplicate names",
            "Nombres duplicados",
            "Doppelte Namen"
        ],
        DuplicateCoordinates: [
            "Duplicate coordinates",
            "Coordenadas duplicadas",
            "Doppelte Koordinaten"
        ],
        Attention: [
            "Attention",
            "Atención",
            "Zu prüfen",
        ],
        AllPlaces: [
            "All places",
            "Todos los lugares",
            "Alle Orte",
        ],
        AllTeams: [
            "All teams",
            "Todos los equipos",
            "Alle Teams",
        ],
        NeedsAttention: [
            "Needs attention",
            "Necesita atención",
            "Zu prüfen",
        ],
        RecentlyCreated: [
            "Recently created",
            "Creado recientemente",
            "Kürzlich erstellt",
        ],
    },
    Zones: {
        ImportZones: [
            'Import zones',
            'Importar zonas',
            'Zonen importieren',
        ],
        ImportZonesInfo: [
            'You can import zones from a KML file that contains polygons. Each polygon will be imported as a new zone.',
            'Puedes importar zonas desde un archivo KML con polígonos. Cada polígono se importará como una zona nueva.',
            'Zonen können mit einer KML-Datei importiert werden. Für jedes Polygon der KML-Datei wird eine neue Zone erstellt.',
        ],
        ImportZonesTitle: [
            'Import zones from KML file',
            'Importar zonas desde archivo KML',
            'Zonen mit KML-Datei importieren',
        ],
        NewZone: [
            "New zone",
            "Nueva zona",
            "Neue Zone",
        ],
        ZoneUpdated: [
            "Zone updated",
            "Zona actualizada",
            "Zone aktualisiert",
        ],
        PleaseEnterZoneName: [
            "Please enter the zone name before saving",
            "Ingresa el nombre de la zona antes de guardar",
            "Bitte gib den Zonennamen vor dem Speichern ein.",
        ],
        EnterNewZoneName: [
            "Enter new zone name",
            "Ingresa el nombre de la nueva zona",
            "Zonenname eingeben",
        ],
        DeleteXZones: [
            "Delete {0} zones",
            "Borrar {0} zonas",
            "{0} Zonen löschen",
        ],
        ConfirmDeleteZonesDesc: [
            "I'm aware that deleting zones cannot be undone.",
            "Soy consciente de que eliminar las zonas no se puede deshacer.",
            "Mir ist bewusst, dass das Löschen von Zonen nicht rückgängig gemacht werden kann.",
        ],
        EditXZones: [
            "Edit {0} zones",
            "Editar {0} zonas",
            "{0} Zonen bearbeiten",
        ],
    },
    Integrations: {
        WebhookJobCreated: ["Job created", "Tarea creada", "Auftrag erstellt"],
        WebhookJobUpdated: ["Job updated", "Tarea actualizada", "Auftrag geändert"],
        WebhookJobCompleted: ["Job completed", "Tarea completada", "Auftrag abgeschlossen"],
        WebhookJobArchived: ["Job archived", "Tarea archivada", "Auftrag archiviert"],
        WebhookJobDeleted: ["Job deleted", "Tarea eliminada", "Auftrag gelöscht"],
        WebhookJobChecked: ["Job check-in/out", "Check-in/check-out en una tarea", "Check-in/-out bei einem Auftrag"],
        WebhookPlaceChecked: ["Place check-in/out", "Check-in/check-out en un lugar", "Check-in/-out an einem Ort"],
        WebhookClockInOut: ["Clock in/out", "Registro de entrada/salida", "Ein-/Ausstempeln"],
        WebhookAlertTriggered: ["Alert triggered", "Alerta activada", "Alarm ausgelöst"],
        ShowWebhooks: ["Show webhooks", "Mostrar webhooks", "Webhooks anzeigen"],
        HideWebhooks: ["Hide webhooks", "Ocultar webhooks", "Webhooks ausblenden"],
        WebhookHeaders: ["Headers", "Encabezados", "Header"],
        ShowHeaders: ["Show headers", "Mostrar encabezados", "Header anzeigen"],
        HideHeaders: ["Hide headers", "Ocultar encabezados", "Header ausblenden"],
        WebhookHeaderName: ["Header name (e.g. Authorization)", "Nombre del encabezado (p. ej., Authorization)", "Header-Name (z. B. Authorization)"],
        WebhookHeaderValue: ["Header value", "Valor del encabezado", "Header-Wert"],
        WebhookInvalidUrl: ["Please enter a valid URL (e.g. https://example.com/webhook)", "Ingresa una URL válida (p. ej., https://example.com/webhook)", "Gib eine gültige URL ein (z. B. https://example.com/webhook)"],
        Integrations: [
            'API & Integrations',
            'API & Integraciones',
            'API & Integrationen',
        ],
        IntegrationsApiUseAdminRole: [
            "Your user has the Operator role. To get access to the API, create a dedicated API user with Administrator role.",
            "Tu usuario tiene el rol de Operador. Para obtener acceso a la API, crea un usuario de API dedicado con rol de Administrador.",
            "Dein Benutzer hat die Rolle des Disponenten. Um Zugang zur API zu erhalten, erstelle einen dedizierten API-Benutzer mit Administrator-Rolle."
        ],
        IntegrationsApiHtml: [
            'The most powerful and flexible integration is with our APIs.<p>You can find our API documentation here: <a href="https://api-docs.hellotracks.com" target="_blank">API-docs</a><br>',
            'La integración más poderosa y flexible es con nuestras API.<p>Puedes encontrar nuestra documentación de APIs aquí: <a href="https://api-docs.hellotracks.com" target="_blank">API-docs</a><br>',
            'Die leistungsstärkste und flexibelste Integration erfolgt mit unseren APIs.<p>Unsere API-Dokumentation findest du hier: <a href="https://api-docs.hellotracks.com" target="_blank">API-docs</a><br>',
        ],
        IntegrationsAskAdmin: [
            'Ask your administrator to enable this integration.',
            'Pídele a tu administrador que habilite esta integración.',
            'Bitte den Administrator, diese Integration zu aktivieren.',
        ],
        IntegrationsCli: [
            'CLI (ht-cli)',
            'CLI (ht-cli)',
            'CLI (ht-cli)',
        ],
        IntegrationsCliHtml: [
            'The official Hellotracks command-line interface for <strong>scripts</strong>, <strong>CI runners</strong>, and <strong>AI coding agents</strong>. Bulk-sync jobs, optimize routes, configure webhooks, and rotate API keys — straight from your shell.',
            'La interfaz de línea de comandos oficial de Hellotracks para <strong>scripts</strong>, <strong>CI</strong> y <strong>agentes de IA</strong>. Sincroniza tareas, optimiza rutas, configura webhooks y rota claves API — directamente desde tu shell.',
            'Die offizielle Hellotracks-Kommandozeile für <strong>Skripte</strong>, <strong>CI-Runner</strong> und <strong>KI-Coding-Agenten</strong>. Aufträge synchronisieren, Routen optimieren, Webhooks konfigurieren, API-Schlüssel rotieren — direkt aus dem Terminal.',
        ],
        IntegrationsCliFeatureBulk: [
            'Bulk-sync via CSV, NDJSON, YAML',
            'Sincronización masiva por CSV, NDJSON, YAML',
            'Massen-Sync per CSV, NDJSON, YAML',
        ],
        IntegrationsCliFeatureDryRun: [
            'Dry runs before imports',
            'Vista previa antes de importar',
            'Probelauf vor jedem Import',
        ],
        IntegrationsCliFeatureAgent: [
            'Agent skill for Codex & Claude Code',
            'Skill para agentes Codex y Claude Code',
            'Agent-Skill für Codex & Claude Code',
        ],
        IntegrationsCliExplore: [
            'Explore the CLI',
            'Explorar el CLI',
            'Zur CLI-Übersicht',
        ],
        IntegrationsCliInstall: [
            'Copy install command',
            'Copiar comando de instalación',
            'Installationsbefehl kopieren',
        ],
        IntegrationsCliInstallCopied: [
            'Copied',
            'Copiado',
            'Kopiert',
        ],
        IntegrationsCliLearnMore: [
            'Learn more about ht-cli',
            'Más información sobre ht-cli',
            'Mehr über ht-cli',
        ],
        IntegrationsDescHtml: [
            'Integrations can help you automate tasks like creating new jobs or updating existing ones to keep synchronized with other tools.<br>We offer a variety of options for a seamless integration:',
            'Las integraciones te ayudan a automatizar actividades, como crear tareas nuevas o actualizar las existentes, para mantenerte sincronizado con otras herramientas.<br>Ofrecemos una variedad de opciones para una integración perfecta:',
            'Mithilfe von Integrationen kannst du Aufgaben wie das Erstellen neuer Aufträge oder das Aktualisieren vorhandener Aufträge automatisieren, um mit anderen Tools synchron zu bleiben.<br>Wir bieten eine Vielzahl von Optionen für eine nahtlose Integration an:',
        ],
        IntegrationsEmailBody: [
            'You can add any field that matches the CSV or Excel template.',
            'Puedes agregar cualquier campo que coincida con la plantilla de CSV o Excel.',
            'Du kannst jedes Feld hinzufügen, das der CSV- oder Excel-Vorlage entspricht.',
        ],
        IntegrationsEmailHtml: [
            'You can send an email to <strong>job@mail.hellotracks.com</strong> which will automatically create a new job in Hellotracks.<br>The subject of the email will become the new title of the job, the content of the email will be attached to the newly created job.<br>You can even set all individual fields of the job: click <a href="mailto:job@mail.hellotracks.com?subject={0}&body={1}" target="_blank">here</a> to open an <strong>email template</strong>.<p>Note that the email must be sent from a verified email address or the verified address needs to be Cc-ed.<br>You can verify the email address in your profile settings.',
            'Puedes enviar un correo a <strong>job@mail.hellotracks.com</strong> que creará automáticamente una nueva tarea en Hellotracks.<br>El asunto del correo electrónico se convertirá en el nuevo título de la tarea, el contenido del correo electrónico se adjuntará a la tarea recién creada.<br>Incluso puedes configurar todos los campos de la tarea: haz clic <a href="mailto:job@mail.hellotracks.com?subject={0}&body={1}" target="_blank">aquí</a> para abrir <strong>una plantilla de correo</strong>.<p>Ten en cuenta que el correo electrónico debe ser enviado por una dirección de correo electrónico verificada o la dirección verificada debe estar incluida en Cc.<br>Puedes verificar la dirección de correo electrónico en la configuración de tu perfil.',
            'Du kannst eine E-Mail an <strong>job@mail.hellotracks.com</strong> senden. Dadurch wird automatisch ein neuer Auftrag in Hellotracks erstellt.<br>Der Betreff der E-Mail wird zum neuen Titel des Auftrags. Der Inhalt der E-Mail wird an den neu erstellten Auftrag angehängt.<br>Du kannst sogar alle einzelnen Felder des Auftrags festlegen: klicke <a href="mailto:job@mail.hellotracks.com?subject={0}&body={1}" target="_blank">hier</a>, um eine <strong>E-Mail-Vorlage</strong> zu öffnen.<p>Beachte, dass die E-Mail von einer verifizierten E-Mail-Adresse gesendet werden muss oder dass die verifizierte Adresse in Cc stehen muss.<br>Du kannst die E-Mail-Adresse in deinen Profileinstellungen verifizieren.',
        ],
        IntegrationsEmailSubject: [
            'This is a job created via email.',
            'Esta es una tarea creada a través de un mensaje de correo electrónico.',
            'Ein neuer Auftrag direkt aus einer E-Mail',
        ],
        IntegrationsEnableApi: [
            'Enable API for your company account',
            'Habilita la API para la cuenta de tu empresa',
            'API für das Unternehmenskonto aktivieren',
        ],
        IntegrationsExcelCsv: [
            'Excel and CSV templates',
            'Plantillas de Excel y CSV',
            'Excel- und CSV-Vorlagen',
        ],
        IntegrationsExcelCsvHtml: [
            'A simple yet powerful tool to import many jobs at once is to import jobs via sheets in Excel or CSV format.<br>Our templates allow a lot of flexibility, e.g.<ul><li>you can delete any column if it doesn\'t apply to your use case,</li><li>you can reorder all columns as you wish,</li><li>and you can add as many custom fields as you need.</li><p>Go to the Jobs view and click <strong>{0}</strong> to start using sheet templates.',
            'Una opción simple pero poderosa para importar muchas tareas a la vez es importar un archivo en formato Excel o CSV.<br>Nuestras plantillas ofrecen mucha flexibilidad, por ejemplo <ul><li>puedes eliminar cualquier columna si no aplica,</li><li> puedes reordenar todas las columnas como requieras,</li><li> y puedes agregar tantos campos personalizados como necesites.</li><p>Dirígete a la vista Tareas y haz clic en <strong>{0}</strong> para comenzar a usar las plantillas para Excel.',
            'Ein einfaches, aber leistungsstarkes Tool zum gleichzeitigen Importieren vieler Aufträge ist das Importieren von Aufträgen über Tabellen im Excel- oder CSV-Format.<br>Unsere Vorlagen bieten viel Flexibilität, z. B. <ul> <li> Du kannst jede Spalte löschen.</li><li>Du kannst alle Spalten nach Belieben neu anordnen.</li><li>Du kannst so viele benutzerdefinierte Felder hinzufügen, wie du brauchst.</li><p>Um loszulegen, klicke in der Ansicht Aufträge auf <strong>{0}</strong>.',
        ],
        IntegrationsGoogleCalendarHtml: [
            'Hellotracks lets you easily synchronize jobs to your team members\' Google Calendar.<br>New jobs will automatically appear in the Google Calendar and will update based on any new changes.<p>In order for this to work, each team member needs to connect their Google Calendar with Hellotracks.<br>This can be done easily by sending a link to team members who can accept the Google Calendar integration with just a single click.<br> You will find the button to start the Google Calendar integration in the team member\'s <strong>profile page</strong>:<ol><li>Open <strong>Manage</strong> › <strong>Members</strong> in the menu</li><li>Select a member</li><li>Click <strong>Profile &amp; settings</strong></li><li>Open <strong>General settings</strong></li><li>In the <strong>Integrations</strong> section, click <strong>Send link to connect with Google Calendar</strong></li></ol>',
            'Puedes conectar y sincronizar fácilmente las tareas en Hellotracks con la cuenta de Calendario de Google de los miembros de tu equipo.<br>Las nuevas tareas aparecerán automáticamente en el Calendario de Google y se actualizarán automáticamente.<p>Cada miembro debe conectar su Calendario de Google con Hellotracks de manera individual.<br>Simplemente envía un enlace para que los miembros puedan aceptar la integración con un solo clic.<br>Encontrarás el botón para iniciar la integración de Google Calendar en la <strong>página de perfil</strong> del miembro: <ol><li>Abre <strong>Administrar</strong> › <strong>Miembros</strong> en el menú</li><li>Selecciona un miembro</li><li>Haz clic en <strong>Perfil y configuración</strong></li><li>Abre <strong>Configuración general</strong></li><li>En la sección <strong>Integraciones</strong>, haz clic en <strong>Enviar enlace para conectar con Google Calendar</strong></li></ol>',
            'Aufträge können sehr einfach automatisiert mit Google Kalender synchronisiert werden.<br>Neue Aufträge erscheinen automatisch in Google Kalender und werden auch stetig aktualisiert.<p>Jedes Team-Mitglied muss eigens die Verbindung von Hellotracks zu Google Kalender einrichten.<br>Glücklicherweise kann sehr einfach ein Link geteilt werden, sodass Team-Mitglieder mit einem simplen Klick die Integration durchführen können.<br>Den Button, um die Google-Kalender-Integration zu starten, findest du auf der <strong>Profilseite</strong> des Team-Mitglieds:<ol><li>Öffne im Menü <strong>Verwalten</strong> › <strong>Mitglieder</strong></li><li>Wähle ein Mitglied aus</li><li>Klicke auf <strong>Profil &amp; Einstellungen</strong></li><li>Öffne <strong>Allgemeine Einstellungen</strong></li><li>Klicke im Abschnitt <strong>Integrationen</strong> auf <strong>Link senden, um mit Google Kalender zu verbinden</strong></li></ol>',
        ],
        IntegrationsSlackHtml: [
            'Create new jobs easily via shortcuts from within your Slack workspace.<br>E.g. type this into your Slack workspace:<p><code>/job New delivery at Lombard St.</code><p> A window opens where you can enter all relevant job data and assign the job directly to the right team member.<br>If you enter an address, Hellotracks will automatically geolocate it to the right location.',
            'Crea nuevas tareas fácilmente a través de los accesos directos de tu workspace en Slack.<br>P. ej., escribe esto en tu workspace en Slack:<p><code>/job Nueva entrega en Lombard St.</code><p> Se abrirá una ventana donde puedes ingresar todos los datos relevantes de la tarea y asignarla directamente a un miembro de tu equipo.<br>Si ingresas una dirección, Hellotracks la geolocalizará automáticamente.',
            'Erstelle neue Aufträge einfach über Shortcuts im Slack-Arbeitsbereich.<br>Z.B. gib dies im Slack-Arbeitsbereich ein:<p><code>/job Neuer Auftrag</code><p> Es öffnet sich ein Fenster, in dem du alle relevanten Daten eingeben und den Auftrag direkt dem richtigen Teammitglied zuweisen kannst.<br>Wenn du eine Adresse eingibst, wird diese von Hellotracks automatisch an der richtigen Stelle geolokalisiert.',
        ],
        IntegrationsOkta: [
            "<p>To configure your single sign-on (SSO) integration with Okta, Azure AD or other identity providers, please follow the detailed instructions provided in our help articles. These guides walk you through each step of the integration process. See <a target='_blank' href=\"https://help-docs.hellotracks.com/article/1028-how-to-integrate-with-okta\">How to Integrate with Okta</a> and <a target='_blank' href=\"https://help-docs.hellotracks.com/article/1029-how-to-integrate-with-microsoft-azure-active-directory-ad\">How to Integrate with Azure AD</a>.</p>",
            "<p>Para configurar tu integración de Single Sign On (SSO) con Okta, Azure AD u otros proveedores de identidad, sigue las instrucciones detalladas proporcionadas en nuestros artículos de ayuda. Estas guías te guiarán a través de cada paso del proceso de integración. Consulta <a target='_blank' href=\"https://help-docs.hellotracks.com/article/1028-how-to-integrate-with-okta\">Cómo integrar con Okta</a> y <a target='_blank' href=\"https://help-docs.hellotracks.com/article/1029-how-to-integrate-with-microsoft-azure-active-directory-ad\">Cómo integrar con Azure AD</a>.</p>",
            "<p>Um deine SSO-Integration (Single Sign-On) mit Okta, Azure AD oder anderen Identity-Providern zu konfigurieren, folge bitte den detaillierten Anweisungen in unseren Hilfeartikeln. Diese Anleitungen führen dich durch jeden Schritt des Integrationsprozesses. Siehe <a target='_blank' href=\"https://help-docs.hellotracks.com/article/1028-how-to-integrate-with-okta\">Integration mit Okta</a> und <a target='_blank' href=\"https://help-docs.hellotracks.com/article/1029-how-to-integrate-with-microsoft-azure-active-directory-ad\">Integration mit Azure AD</a>.</p>",
        ],
        IntegrationsHelpEmailBefore: [
            "Need help setting up an integration? Email",
            "¿Necesitas ayuda para configurar una integración? Escribe a",
            "Brauchst du Hilfe beim Einrichten einer Integration? Schreibe an",
        ],
        IntegrationsHelpEmailAfter: [
            "- we are happy to help.",
            "- con gusto te ayudamos.",
            "- wir helfen gerne.",
        ],
        NoCodeIntegrationsTitle: ["No-code integrations", "Integraciones sin código", "No-Code-Integrationen"],
        NoCodeIntegrationsDesc: [
            "Build workflows between Hellotracks and 6,000+ apps without writing a line of code. Create or copy an API key above, then connect your automation platform below.",
            "Crea flujos entre Hellotracks y más de 6,000 apps sin escribir código. Crea o copia una clave API arriba y luego conecta tu plataforma de automatización abajo.",
            "Erstelle Workflows zwischen Hellotracks und mehr als 6.000 Apps, ohne Code zu schreiben. Erstelle oder kopiere oben einen API-Key und verbinde dann unten deine Automatisierungsplattform.",
        ],
        NoCodeZapierDesc: [
            "Open the Zapier setup flow, paste your Hellotracks API key when prompted, and publish your first Zap.",
            "Abre el flujo de configuración de Zapier, pega tu clave API de Hellotracks cuando se solicite y publica tu primer Zap.",
            "Öffne die Zapier-Einrichtung, füge deinen Hellotracks-API-Key ein, wenn du dazu aufgefordert wirst, und veröffentliche deinen ersten Zap.",
        ],
        NoCodeTemplateWebFormTitle: ["Web form → Hellotracks job", "Formulario web → tarea de Hellotracks", "Webformular → Hellotracks-Auftrag"],
        NoCodeTemplateWebFormDesc: [
            "Turn submissions from Typeform, Google Forms, or any web form into dispatchable jobs.",
            "Convierte envíos de Typeform, Google Forms o cualquier formulario web en tareas asignables.",
            "Wandle Einsendungen aus Typeform, Google Forms oder beliebigen Webformularen in disponierbare Aufträge um.",
        ],
        NoCodeTemplateCrmTitle: ["CRM ticket, case, or deal → Hellotracks job", "Ticket, caso o negocio de CRM → tarea de Hellotracks", "CRM-Ticket, Case oder Deal → Hellotracks-Auftrag"],
        NoCodeTemplateCrmDesc: [
            "Auto-dispatch from any CRM. Works alongside HubSpot tickets, Salesforce cases, and more.",
            "Despacha automáticamente desde cualquier CRM. Funciona con tickets de HubSpot, casos de Salesforce y más.",
            "Disponiere automatisch aus jedem CRM. Funktioniert mit HubSpot-Tickets, Salesforce-Cases und mehr.",
        ],
        NoCodeTemplateCompletedTitle: ["Completed job → Slack, email, or CRM", "Tarea completada → Slack, correo o CRM", "Erledigter Auftrag → Slack, E-Mail oder CRM"],
        NoCodeTemplateCompletedDesc: [
            "Notify customers, update records, or alert your team the moment a job finishes.",
            "Notifica a clientes, actualiza registros o avisa a tu equipo en cuanto una tarea finaliza.",
            "Benachrichtige Kunden, aktualisiere Datensätze oder informiere dein Team, sobald ein Auftrag abgeschlossen ist.",
        ],
        NoCodeOpenPlatform: ["Open {0}", "Abrir {0}", "{0} öffnen"],
        NoCodeConnectWithZapier: ["Connect with Zapier", "Conectar con Zapier", "Mit Zapier verbinden"],
        NoCodeZapierTemplatesTitle: ["Zapier starter workflows", "Flujos iniciales de Zapier", "Zapier-Start-Workflows"],
        NoCodeZapierTemplatesDesc: [
            "Start from an approved template, then review and publish the Zap in Zapier.",
            "Comienza con una plantilla aprobada, luego revisa y publica el Zap en Zapier.",
            "Starte mit einer freigegebenen Vorlage, prüfe sie anschließend in Zapier und veröffentliche den Zap.",
        ],
        NoCodeUseZapierTemplate: ["Use template", "Usar plantilla", "Vorlage verwenden"],
        NoCodeZapierTemplateMondayTitle: [
            "Create jobs from monday.com items",
            "Crear tareas desde elementos de monday.com",
            "Aufträge aus monday.com-Elementen erstellen",
        ],
        NoCodeZapierTemplateMondayDesc: [
            "Turn a new monday.com board item into a dispatchable Hellotracks job.",
            "Convierte un nuevo elemento de un tablero de monday.com en una tarea asignable de Hellotracks.",
            "Wandle ein neues monday.com-Board-Element in einen disponierbaren Hellotracks-Auftrag um.",
        ],
        NoCodeZapierTemplateSheetsTitle: [
            "Update Google Sheets when jobs change",
            "Actualizar Google Sheets cuando cambian las tareas",
            "Google Sheets aktualisieren, wenn sich Aufträge ändern",
        ],
        NoCodeZapierTemplateSheetsDesc: [
            "Send updated Hellotracks job details to an existing Google Sheets row.",
            "Envía los detalles actualizados de una tarea de Hellotracks a una fila existente de Google Sheets.",
            "Sende aktualisierte Hellotracks-Auftragsdetails an eine bestehende Zeile in Google Sheets.",
        ],
        NoCodeZapierModalTitle: ["Connect Hellotracks with Zapier", "Conectar Hellotracks con Zapier", "Hellotracks mit Zapier verbinden"],
        NoCodeZapierModalDesc: [
            "Use the embedded Zapier setup flow to sign up or log in to Zapier, connect Hellotracks with the API key from this page, publish a Zap, and run it once.",
            "Usa el flujo integrado de Zapier para crear una cuenta o iniciar sesión, conectar Hellotracks con la clave API de esta página, publicar un Zap y ejecutarlo una vez.",
            "Nutze die eingebettete Zapier-Einrichtung, um ein Zapier-Konto zu erstellen oder dich anzumelden, Hellotracks mit dem API-Key von dieser Seite zu verbinden, einen Zap zu veröffentlichen und ihn einmal auszuführen.",
        ],
        NoCodePlatforms: ["Platforms", "Plataformas", "Plattformen"],
        NoCodeWorkflowTemplates: ["Workflow templates", "Plantillas de flujo", "Workflow-Vorlagen"],
        NoCodeWorkflowTemplatesDesc: [
            "Common patterns to recreate in your platform of choice.",
            "Patrones comunes para recrear en la plataforma que elijas.",
            "Häufige Muster, die du in der Plattform deiner Wahl nachbauen kannst.",
        ],
        NoCodeZapierStep1: [
            "Copy your API key from the API Keys section above",
            "Copia tu clave API de la sección Claves API de arriba",
            "Kopiere deinen API-Key aus dem Bereich API-Keys oben",
        ],
        NoCodeZapierStep2: [
            "Choose a template to open the embedded setup flow",
            "Elige una plantilla para abrir el flujo integrado",
            "Wähle eine Vorlage, um die eingebettete Einrichtung zu öffnen",
        ],
        NoCodeZapierStep3: [
            "Log in to Zapier, paste the key when asked, and publish",
            "Inicia sesión en Zapier, pega la clave cuando se solicite y publica",
            "Melde dich bei Zapier an, füge den Key ein und veröffentliche den Zap",
        ],
        NoCodeZapierOpenInZapier: ["Open in Zapier", "Abrir en Zapier", "In Zapier öffnen"],
        NoCodeZapierDone: ["Done", "Listo", "Fertig"],
        NoCodeZapierLive: ["Your Zap is live!", "¡Tu Zap está activo!", "Dein Zap ist aktiv!"],
        NoCodeZapierLiveDesc: [
            "Run it once in Zapier to complete setup.",
            "Ejecútalo una vez en Zapier para completar la configuración.",
            "Führe ihn einmal in Zapier aus, um die Einrichtung abzuschließen.",
        ],
        NoCodeZapierLoading: ["Loading Zapier…", "Cargando Zapier…", "Zapier wird geladen…"],
        ExternalLoading: ["Loading external integrations...", "Cargando integraciones externas...", "Externe Integrationen werden geladen..."],
        ExternalLoadError: ["Failed to load external integrations.", "No se pudieron cargar las integraciones externas.", "Externe Integrationen konnten nicht geladen werden."],
        ExternalStatusDisconnected: ["Disconnected", "Desconectado", "Getrennt"],
        ExternalStatusPausedReconnectRequired: ["Paused, reconnect required", "Pausado, requiere reconexión", "Pausiert, erneute Verbindung erforderlich"],
        ExternalSupportBefore: [
            "These CRM integrations are freshly rolled out and we are iterating quickly. If something does not connect, sync, or map the way you expected, email",
            "Estas integraciones de CRM se lanzaron recientemente y seguimos iterando rápido. Si algo no conecta, sincroniza o mapea como esperabas, escribe a",
            "Diese CRM-Integrationen sind neu eingeführt und wir entwickeln sie schnell weiter. Wenn etwas nicht wie erwartet verbindet, synchronisiert oder zuordnet, schreibe an",
        ],
        ExternalSupportAfter: ["and we will jump on it with you.", "y lo revisaremos contigo.", "und wir kümmern uns gemeinsam darum."],
        ExternalHubSpotTagline: ["Sync HubSpot tickets into Hellotracks jobs.", "Sincroniza tickets de HubSpot con tareas de Hellotracks.", "Synchronisiere HubSpot-Tickets in Hellotracks-Aufträge."],
        ExternalHubSpotDesc: [
            "Connect HubSpot tickets directly to Hellotracks jobs. Choose the ticket details that should become dispatch fields.",
            "Conecta tickets de HubSpot directamente con tareas de Hellotracks. Elige qué detalles del ticket deben convertirse en campos de despacho.",
            "Verbinde HubSpot-Tickets direkt mit Hellotracks-Aufträgen. Wähle aus, welche Ticketdetails zu Dispositionsfeldern werden sollen.",
        ],
        ExternalSalesforceTagline: ["Turn Salesforce cases into Hellotracks jobs.", "Convierte casos de Salesforce en tareas de Hellotracks.", "Wandle Salesforce-Cases in Hellotracks-Aufträge um."],
        ExternalSalesforceDesc: [
            "Connect Salesforce cases directly to Hellotracks jobs. Choose the case details that should become dispatch fields.",
            "Conecta casos de Salesforce directamente con tareas de Hellotracks. Elige qué detalles del caso deben convertirse en campos de despacho.",
            "Verbinde Salesforce-Cases direkt mit Hellotracks-Aufträgen. Wähle aus, welche Case-Details zu Dispositionsfeldern werden sollen.",
        ],
        ExternalMondayTagline: ["Pipe monday.com board items into Hellotracks jobs.", "Envía elementos de tableros de monday.com a tareas de Hellotracks.", "Leite monday.com-Board-Elemente in Hellotracks-Aufträge."],
        ExternalMondayDesc: [
            "Connect monday.com board items directly to Hellotracks jobs. Select the board and group this company should sync from.",
            "Conecta elementos de tableros de monday.com directamente con tareas de Hellotracks. Selecciona el tablero y grupo desde los que esta empresa debe sincronizar.",
            "Verbinde monday.com-Board-Elemente direkt mit Hellotracks-Aufträgen. Wähle das Board und die Gruppe aus, aus denen dieses Unternehmen synchronisieren soll.",
        ],
        ExternalConfigClientId: ["Client ID", "ID de cliente", "Client-ID"],
        ExternalConfigClientSecret: ["Client secret", "Secreto de cliente", "Client Secret"],
        ExternalConfigScopes: ["Scopes", "Scopes", "Scopes"],
        ExternalConfigLoginUrl: ["Login URL", "URL de inicio de sesión", "Anmelde-URL"],
        ExternalConfigWebhookSecret: ["Webhook secret", "Secreto de webhook", "Webhook-Secret"],
        ExternalConfigWebhookSecretHelp: [
            "Click Generate for a strong random value, or paste your own. Then use the same value in Salesforce: append it as token=<secret> for Outbound Messages, or send Authorization: Bearer <secret> for Apex callouts.",
            "Haz clic en Generar para crear un valor aleatorio fuerte o pega el tuyo. Luego usa el mismo valor en Salesforce: agrégalo como token=<secret> para Outbound Messages o envía Authorization: Bearer <secret> para callouts de Apex.",
            "Klicke auf Generieren für einen starken Zufallswert oder füge deinen eigenen ein. Verwende denselben Wert anschließend in Salesforce: hänge ihn für Outbound Messages als token=<secret> an oder sende Authorization: Bearer <secret> für Apex-Callouts.",
        ],
        ExternalConfigSigningSecret: ["Signing secret", "Secreto de firma", "Signing Secret"],
        ExternalConfigBoardId: ["Board ID", "ID de tablero", "Board-ID"],
        ExternalConfigGroupId: ["Group ID", "ID de grupo", "Gruppen-ID"],
        ExternalConfigSubdomain: ["Subdomain", "Subdominio", "Subdomain"],
        ExternalCoreGroupJobBasics: ["Job basics", "Datos básicos de la tarea", "Auftragsgrunddaten"],
        ExternalCoreGroupContact: ["Contact", "Contacto", "Kontakt"],
        ExternalCoreGroupAssignment: ["Assignment", "Asignación", "Zuweisung"],
        ExternalCoreGroupScheduling: ["Scheduling", "Programación", "Planung"],
        ExternalFieldJobTitle: ["Job title", "Título de la tarea", "Auftragstitel"],
        ExternalFieldJobTitleHelp: ["Mapped into the Hellotracks job title.", "Se mapea al título de la tarea en Hellotracks.", "Wird in den Hellotracks-Auftragstitel übernommen."],
        ExternalFieldNotes: ["Description / notes", "Descripción / notas", "Beschreibung / Notizen"],
        ExternalFieldAddress: ["Address / location", "Dirección / ubicación", "Adresse / Standort"],
        ExternalFieldContactName: ["Contact name", "Nombre de contacto", "Kontaktname"],
        ExternalFieldContactPhone: ["Contact phone", "Teléfono de contacto", "Kontakttelefon"],
        ExternalFieldContactEmail: ["Contact email", "Correo electrónico de contacto", "Kontakt-E-Mail"],
        ExternalFieldAssignee: ["Assignee", "Asignado", "Zugewiesen an"],
        ExternalFieldAssigneeHelp: [
            "Maps an external assignee email to a Hellotracks member when there is an exact match.",
            "Mapea el correo de un asignado externo a un miembro de Hellotracks cuando coincide exactamente.",
            "Ordnet die E-Mail einer extern zugewiesenen Person einem Hellotracks-Mitglied zu, wenn sie exakt übereinstimmt.",
        ],
        ExternalFieldPriority: ["Priority", "Prioridad", "Priorität"],
        ExternalFieldPriorityHelp: [
            "Supports low / normal / high-style values from the provider.",
            "Admite valores del proveedor del tipo baja / normal / alta.",
            "Unterstützt Werte des Anbieters wie niedrig / normal / hoch.",
        ],
        ExternalFieldJobDate: ["Job date", "Fecha de la tarea", "Auftragsdatum"],
        ExternalFieldJobDateHelp: ["Hellotracks job date in YYYY-MM-DD format.", "Fecha de la tarea en Hellotracks en formato YYYY-MM-DD.", "Hellotracks-Auftragsdatum im Format YYYY-MM-DD."],
        ExternalFieldTimeWindowStart: ["Time window start", "Inicio de ventana horaria", "Beginn des Zeitfensters"],
        ExternalFieldTimeWindowStartHelp: ["Earliest allowed or appointment start time in HH:mm format.", "Hora más temprana permitida o inicio de cita en formato HH:mm.", "Früheste erlaubte Zeit oder Terminbeginn im Format HH:mm."],
        ExternalFieldTimeWindowEnd: ["Time window end", "Fin de ventana horaria", "Ende des Zeitfensters"],
        ExternalFieldTimeWindowEndHelp: ["Latest allowed or appointment end time in HH:mm format.", "Hora más tardía permitida o fin de cita en formato HH:mm.", "Späteste erlaubte Zeit oder Terminende im Format HH:mm."],
        ExternalConnectionEnterDetails: ["Enter the {0} app details, then connect this company.", "Ingresa los detalles de la app {0} y luego conecta esta empresa.", "Gib die App-Details für {0} ein und verbinde anschließend dieses Unternehmen."],
        ExternalConnectionManagedMonday: ["{0} credentials are managed by Hellotracks. Choose the board this company should sync from, then connect.", "Las credenciales de {0} las gestiona Hellotracks. Elige el tablero desde el que esta empresa debe sincronizar y luego conecta.", "{0}-Zugangsdaten werden von Hellotracks verwaltet. Wähle das Board aus, aus dem dieses Unternehmen synchronisieren soll, und verbinde dann."],
        ExternalConnectionManaged: ["{0} credentials are managed by Hellotracks. Just click Connect to authorize this company.", "Las credenciales de {0} las gestiona Hellotracks. Haz clic en Conectar para autorizar esta empresa.", "{0}-Zugangsdaten werden von Hellotracks verwaltet. Klicke einfach auf Verbinden, um dieses Unternehmen zu autorisieren."],
        ExternalProviderFieldPlaceholder: ["{0} field key", "Clave de campo de {0}", "{0}-Feldschlüssel"],
        ExternalSaveConfigError: ["Failed to save {0} configuration.", "No se pudo guardar la configuración de {0}.", "{0}-Konfiguration konnte nicht gespeichert werden."],
        ExternalSaveMappingsError: ["Failed to save {0} mappings.", "No se pudieron guardar los mapeos de {0}.", "{0}-Zuordnungen konnten nicht gespeichert werden."],
        ExternalMappingUnknownField: ["This field is not on the selected monday.com board.", "Este campo no está en el tablero seleccionado de monday.com.", "Dieses Feld befindet sich nicht auf dem ausgewählten monday.com-Board."],
        ExternalMappingUnknownFields: ["Some mappings are not on the selected monday.com board: {0}", "Algunos mapeos no están en el tablero seleccionado de monday.com: {0}", "Einige Zuordnungen befinden sich nicht auf dem ausgewählten monday.com-Board: {0}"],
        ExternalMappingUseSuggestedField: ["Use {0}", "Usar {0}", "{0} verwenden"],
        ExternalStartConnectionError: ["Failed to start {0} connection.", "No se pudo iniciar la conexión de {0}.", "{0}-Verbindung konnte nicht gestartet werden."],
        ExternalDisconnectError: ["Failed to disconnect {0}.", "No se pudo desconectar {0}.", "{0} konnte nicht getrennt werden."],
        ExternalReconcileError: ["Failed to reconcile {0}.", "No se pudo reconciliar {0}.", "{0} konnte nicht abgeglichen werden."],
        ExternalExpandIntegrationAria: ["Expand {0} integration", "Expandir integración {0}", "{0}-Integration erweitern"],
        ExternalCollapseIntegrationAria: ["Collapse {0} integration", "Contraer integración {0}", "{0}-Integration einklappen"],
        ExternalLastWebhookValue: ["Last webhook: {0}", "Último webhook: {0}", "Letzter Webhook: {0}"],
        ExternalConflictingProvider: ["{0} is already active for this company. Disconnect it before connecting {1}.", "{0} ya está activo para esta empresa. Desconéctalo antes de conectar {1}.", "{0} ist für dieses Unternehmen bereits aktiv. Trenne es, bevor du {1} verbindest."],
        ExternalHealth: ["Health", "Estado", "Status"],
        ExternalAskAdminManage: ["Ask your administrator to manage this integration.", "Pide a tu administrador que gestione esta integración.", "Bitte deinen Administrator, diese Integration zu verwalten."],
        ExternalWebhookUrl: ["Webhook URL", "URL de webhook", "Webhook-URL"],
        ExternalCallbackUrl: ["Callback URL", "URL de callback", "Callback-URL"],
        ExternalUnavailable: ["Unavailable", "No disponible", "Nicht verfügbar"],
        ExternalLastReconcile: ["Last reconcile", "Última reconciliación", "Letzter Abgleich"],
        ExternalLastWebhook: ["Last webhook", "Último webhook", "Letzter Webhook"],
        ExternalLinkedJobs: ["Linked jobs", "Tareas vinculadas", "Verknüpfte Aufträge"],
        ExternalLinkedJobsSummary: ["{0} total, {1} open, {2} closed, {3} deleted", "{0} total, {1} abiertas, {2} cerradas, {3} eliminadas", "{0} gesamt, {1} offen, {2} geschlossen, {3} gelöscht"],
        ExternalReconnectRequiredDesc: ["Reconnect required before sync can resume.", "Se requiere reconexión antes de reanudar la sincronización.", "Eine erneute Verbindung ist erforderlich, bevor die Synchronisierung fortgesetzt werden kann."],
        ExternalAtAGlance: ["At a glance", "Resumen", "Auf einen Blick"],
        ExternalConnectedAt: ["Connected at", "Conectado el", "Verbunden am"],
        ExternalReconnectRequired: ["Reconnect required", "Reconexión requerida", "Erneute Verbindung erforderlich"],
        ExternalConnection: ["Connection", "Conexión", "Verbindung"],
        ExternalCredentialSet: ["SET", "CONFIGURADO", "GESETZT"],
        ExternalGenerate: ["Generate", "Generar", "Generieren"],
        ExternalCopySecretNow: ["Copy this secret now - click Save settings below to apply.", "Copia este secreto ahora; haz clic en Guardar configuración abajo para aplicarlo.", "Kopiere dieses Secret jetzt - klicke unten auf Einstellungen speichern, um es anzuwenden."],
        ExternalStoredOnServer: ["Stored on server. Enter a new value only to replace it.", "Guardado en el servidor. Ingresa un nuevo valor solo para reemplazarlo.", "Auf dem Server gespeichert. Gib nur einen neuen Wert ein, wenn du ihn ersetzen möchtest."],
        ExternalConnect: ["Connect", "Conectar", "Verbinden"],
        ExternalReconnect: ["Reconnect", "Reconectar", "Erneut verbinden"],
        ExternalDisconnect: ["Disconnect", "Desconectar", "Trennen"],
        ExternalSaveSettings: ["Save settings", "Guardar configuración", "Einstellungen speichern"],
        ExternalFieldMapping: ["Field mapping", "Mapeo de campos", "Feldzuordnung"],
        ExternalFieldMappingDesc: ["Choose which fields should fill each Hellotracks job field.", "Elige qué campos deben completar cada campo de tarea de Hellotracks.", "Wähle aus, welche Felder die einzelnen Hellotracks-Auftragsfelder füllen sollen."],
        ExternalConnectFirstForFields: ["Connect first to choose fields from this integration.", "Conecta primero para elegir campos de esta integración.", "Verbinde zuerst, um Felder aus dieser Integration auszuwählen."],
        ExternalFieldListUnavailable: ["Field list unavailable. You can enter {0} field keys manually.", "La lista de campos no está disponible. Puedes ingresar las claves de campo de {0} manualmente.", "Feldliste nicht verfügbar. Du kannst {0}-Feldschlüssel manuell eingeben."],
        ExternalHubSpotRealtimeMappingNote: [
            "For real-time date, time window, and address updates, use the Hellotracks HubSpot ticket fields. Other mapped fields still sync during reconcile.",
            "Para actualizaciones en tiempo real de fecha, ventana horaria y dirección, usa los campos de ticket de Hellotracks en HubSpot. Otros campos mapeados siguen sincronizándose durante la reconciliación.",
            "Für Echtzeit-Updates von Datum, Zeitfenster und Adresse verwende die Hellotracks-HubSpot-Ticketfelder. Andere zugeordnete Felder werden weiterhin beim Abgleich synchronisiert.",
        ],
        ExternalMappingPreview: ["{0} ← {1}", "{0} ← {1}", "{0} ← {1}"],
        ExternalJobCustomFields: ["Job custom fields", "Campos personalizados de tarea", "Benutzerdefinierte Auftragsfelder"],
        ExternalSavesAs: ["Saves as {0}", "Se guarda como {0}", "Wird als {0} gespeichert"],
        ExternalSaveMappings: ["Save mappings", "Guardar mapeos", "Zuordnungen speichern"],
        ExternalRunReconcile: ["Run reconcile", "Ejecutar reconciliación", "Abgleich ausführen"],
        ExternalRefreshStatus: ["Refresh status", "Actualizar estado", "Status aktualisieren"],
        ExternalSalesforceWebhookTitle: ["Salesforce inbound webhook", "Webhook entrante de Salesforce", "Eingehender Salesforce-Webhook"],
        ExternalSalesforceWebhookDesc: [
            "After saving your webhook secret above, point Salesforce at Hellotracks using one of the methods below. The secret you set must match the token or Authorization header Salesforce sends.",
            "Después de guardar el secreto de webhook arriba, apunta Salesforce a Hellotracks con uno de los métodos siguientes. El secreto configurado debe coincidir con el token o encabezado Authorization que envía Salesforce.",
            "Nachdem du dein Webhook-Secret oben gespeichert hast, leite Salesforce mit einer der folgenden Methoden an Hellotracks weiter. Das gesetzte Secret muss mit dem Token oder Authorization-Header übereinstimmen, den Salesforce sendet.",
        ],
        ExternalSalesforceWebhookNeedsUrl: [
            "Save your Salesforce credentials and webhook secret above to generate the inbound endpoint.",
            "Guarda tus credenciales de Salesforce y el secreto de webhook arriba para generar el endpoint entrante.",
            "Speichere oben deine Salesforce-Zugangsdaten und das Webhook-Secret, um den eingehenden Endpunkt zu erzeugen.",
        ],
        ExternalSalesforceOutboundMessage: ["Salesforce Outbound Message", "Outbound Message de Salesforce", "Salesforce Outbound Message"],
        ExternalSalesforceOutboundMessageDesc: [
            "In Salesforce, configure an Outbound Message to POST to this URL. Include the Case ID field on the message.",
            "En Salesforce, configura un Outbound Message que haga POST a esta URL. Incluye el campo Case ID en el mensaje.",
            "Konfiguriere in Salesforce eine Outbound Message, die per POST an diese URL sendet. Füge das Feld Case ID in die Nachricht ein.",
        ],
        ExternalSalesforceApexCallout: ["Apex or custom JSON callout", "Callout Apex o JSON personalizado", "Apex- oder benutzerdefinierter JSON-Callout"],
        ExternalSalesforcePostJsonBodies: ["POST one of these JSON bodies to the endpoint:", "Envía con POST uno de estos cuerpos JSON al endpoint:", "Sende einen dieser JSON-Bodies per POST an den Endpunkt:"],
        ExternalSalesforceAuthorizationHeader: ["Plus the Authorization header:", "Además del encabezado Authorization:", "Zusätzlich den Authorization-Header:"],
    },
    Slack: {
        Slack: [
            'Slack',
            'Slack',
            'Slack',
        ],
        SlackDisconnect: [
            'Disconnect Slack',
            'Desconectar Slack',
            'Von Slack trennen',
        ],
        SlackChannelId: [
            'Slack channel ID',
            'ID del canal de Slack',
            'Slack-Channel-ID',
        ],
        SlackChannelIdDesc: [
            'Paste the channel ID, for example C1234567890. Invite the Hellotracks app to the channel first.',
            'Pega el ID del canal, por ejemplo C1234567890. Invita primero la app de Hellotracks al canal.',
            'Füge die Channel-ID ein, zum Beispiel C1234567890. Lade zuerst die Hellotracks-App in den Channel ein.',
        ],
        SlackConnectFirst: [
            'Connect Slack in API & Integrations before sending alerts to Slack.',
            'Conecta Slack en API e Integraciones antes de enviar alertas a Slack.',
            'Verbinde Slack unter API & Integrationen, bevor du Alarme an Slack sendest.',
        ],
    },
    GoogleCalendar: {
        GoogleCalendar: [
            'Google Calendar',
            'Google Calendar',
            'Google Kalender',
        ],
        GoogleCalendarConnected: [
            'Connected',
            'Conectado',
            'Verbunden',
        ],
        GoogleCalendarDesc: [
            'Once Google Calendar is connected, all Hellotracks jobs sync with it automatically.',
            'Al conectar Google Calendar, todas las tareas de Hellotracks se sincronizan automáticamente con él.',
            'Mit einer Verbindung zum Google Kalender werden alle Aufträge in Hellotracks automatisch mit dem Kalender synchronisiert.',
        ],
        GoogleCalendarDisconnect: [
            'Disconnect Google Calendar',
            'Desconectar Google Calendar',
            'Von Google Kalender trennen',
        ],
        GoogleCalendarDisconnectQuestion: [
            'Disconnect Google Calendar? Jobs will no longer sync between Hellotracks and this member\'s Google Calendar.',
            '¿Desconectar Google Calendar? Las tareas de este miembro ya no se sincronizarán entre Hellotracks y Google Calendar.',
            'Google Kalender wirklich trennen? Aufträge werden dann nicht mehr zwischen Hellotracks und dem Google Kalender dieses Mitglieds synchronisiert.',
        ],
        GoogleCalendarSendLink: [
            'Send link to connect with Google Calendar',
            'Enviar enlace para conectar con Google Calendar',
            'Link senden, um mit Google Kalender zu verbinden',
        ],
        GoogleCalendarXNeedsVerified: [
            '{0} needs to have a verified email or phone to connect with Google Calendar.',
            '{0} necesita tener un correo electrónico o teléfono verificado para conectarse con Google Calendar.',
            '{0} braucht eine verifizierte E-Mail oder Telefonnummer, um sich mit Google Kalender zu verbinden.',
        ],
    },
    Forms: {
        FormsDesc: [
            '<ul><li>You can create and manage forms here.</li><li>Forms can be linked to jobs or places.</li><li>Your team can fill out and submit forms in the mobile app.</li><li>Submissions will appear here.</li>',
            '<ul><li>Puedes crear y administrar formularios aquí.</li><li>Los formularios pueden estar ligados a tareas o lugares.</li><li>Tu equipo puede completar y enviar formularios desde la aplicación móvil.</li><li>Los resultados aparecerán aquí.</li>',
            '<ul><li>Hier kannst du Formulare erstellen und verwalten.</li><li>Formulare können mit Aufträgen oder Orten verknüpft werden.</li><li>Dein Team kann Formulare in der mobilen App ausfüllen und einsenden.</li><li>Einsendungen werden hier angezeigt.</li>'
        ],
        SubmittedBy: [
            "Submitted by",
            "Enviado por",
            "Eingereicht von",
        ],
        Forms: ['Forms', 'Formularios', 'Formulare'],
        FormFields: ['Form fields', 'Campos del formulario', 'Formularfelder'],
        FormsAndDataInputDesc: ['Retrieve data from your team in the field', 'Recopila datos de tu equipo en campo', 'Daten von deinem Team vor Ort abrufen'],
        FormsCheckbox: ['Checkbox', 'Casilla de verificación', 'Checkbox'],
        FormsDecimal: ['Decimal', 'Decimal', 'Dezimal'],
        FormsDropdown: ['Dropdown', 'Menú desplegable', 'Dropdown'],
        FormsImage: ['Image', 'Imagen', 'Bild'],
        FormsLabel: ['Label', 'Etiqueta', 'Label'],
        FormsLinkedForm: ['Linked form', 'Formulario vinculado', 'Verknüpftes Formular'],
        FormsLinkedForms: ['Linked forms', 'Formularios vinculados', 'Verknüpfte Formulare'],
        FormsNumber: ['Number', 'Número', 'Zahl'],
        FormsParagraph: ['Paragraph', 'Párrafo', 'Absatz'],
        FormsRadio: ['Multiple choice', 'Opción múltiple', 'Mehrfachauswahl'],
        FormsSection: ['Section', 'Sección', 'Abschnitt'],
        FormsText: ['Text', 'Texto', 'Text'],
        FormsUntitledForm: ['Untitled form', 'Formulario sin título', 'Unbenanntes Formular'],
        FormsDeleteForm: [
            "Delete this form?",
            "¿Eliminar este formulario?",
            "Dieses Formular wirklich löschen?",
        ],
        FormSubmissionSavedLocally: [
            "Your changes will be saved locally unless you cancel the submission.",
            "Tus cambios se guardarán localmente a menos que canceles el envío.",
            "Deine Änderungen werden lokal gespeichert, es sei denn, du brichst die Einreichung ab.",
        ],
        FormSubmissionSucceed: [
            "Your submission has been sent successfully.",
            "Tu envío se realizó con éxito.",
            "Einreichung wurde erfolgreich gesendet.",
        ],
        BackToForms: [
            "Back to forms",
            "Regresar a formularios",
            "Zurück zu den Formularen",
        ],
        NewFormSubmission: [
            "New submission",
            "Nuevo envío",
            "Neue Einreichung",
        ],
        SelectForm: [
            "Select form",
            "Selecciona un formulario",
            "Formular auswählen",
        ],
        AreYouSureEditForm: [
            "Are you sure you want to edit your form?",
            "¿Estás seguro de que quieres editar tu formulario?",
            "Bist du sicher, dass du dein Formular bearbeiten willst?"
        ],
        EditFormWarning: [
            "Warning: you might lose response data. Before continuing, export your responses.",
            "Advertencia: podrías perder datos de respuestas. Antes de continuar, exporta tus respuestas.",
            "Warnung: Du könntest Antwortdaten verlieren. Exportiere deine Antworten, bevor du fortfährst."
        ],
        FormEditorSelectField: [
            "Add or select a field to edit",
            "Agregar o seleccionar un campo para editar",
            "Feld zum Bearbeiten auswählen oder hinzufügen"
        ],
        FormEditorFormProperties: [
            "Form properties",
            "Propiedades del formulario",
            "Formulareigenschaften"
        ],
        FormEditorTitle: [
            "Title",
            "Título",
            "Titel"
        ],
        FormEditorFormTitle: [
            "Form title",
            "Título del formulario",
            "Formulartitel"
        ],
        FormEditorDescription: [
            "Description",
            "Descripción",
            "Beschreibung"
        ],
        FormEditorFormDescription: [
            "Form description (optional)",
            "Descripción del formulario (opcional)",
            "Formularbeschreibung (optional)"
        ],
        FormEditorFieldProperties: [
            "Field properties",
            "Propiedades del campo",
            "Feldeigenschaften"
        ],
        FormEditorLabel: [
            "Label",
            "Etiqueta",
            "Label"
        ],
        FormEditorFieldName: [
            "Field name",
            "Nombre del campo",
            "Feldname"
        ],
        FormEditorType: [
            "Type",
            "Tipo",
            "Typ"
        ],
        FormEditorRequiredField: [
            "Required field",
            "Campo obligatorio",
            "Pflichtfeld"
        ],
        FormEditorOptions: [
            "Options",
            "Opciones",
            "Optionen"
        ],
        FormEditorAddOption: [
            "Add option...",
            "Agregar opción...",
            "Option hinzufügen..."
        ],
        FormEditorInsertFieldBelow: [
            "Insert field below",
            "Insertar campo debajo",
            "Feld darunter einfügen"
        ],
        FormEditorAddFieldAtTop: [
            "Add field at top",
            "Agregar campo arriba",
            "Feld oben hinzufügen"
        ],
        FormEditorAddFieldAtBottom: [
            "Add field at bottom",
            "Agregar campo abajo",
            "Feld unten hinzufügen"
        ],
        FormEditorDeleteField: [
            "Delete field",
            "Eliminar campo",
            "Feld löschen"
        ],
        FormEditorFollowUp: [
            "Follow-up",
            "Pregunta de seguimiento",
            "Folgefrage"
        ],
        FormEditorFollowUpCount: [
            "{0} follow-ups",
            "{0} preguntas de seguimiento",
            "{0} Folgefragen"
        ],
        FormEditorFollowUpFor: [
            "Follow-up for “{0}”",
            "Seguimiento para “{0}”",
            "Folgefrage für „{0}“"
        ],
        FormEditorIfAnswer: [
            "If “{0}”",
            "Si responde “{0}”",
            "Wenn „{0}“"
        ],
        FormEditorRemoveFollowUpsTitle: [
            "Delete the follow-up questions?",
            "¿Eliminar las preguntas de seguimiento?",
            "Folgefragen löschen?"
        ],
        FormEditorRemoveFollowUpsType: [
            "Only Multiple choice and Dropdown questions can have follow-ups. Changing the type deletes them.",
            "Solo las preguntas de opción múltiple y de menú desplegable pueden tener preguntas de seguimiento. Si cambias el tipo, se eliminan.",
            "Nur Mehrfachauswahl- und Dropdown-Fragen können Folgefragen haben. Wenn du den Typ änderst, werden sie gelöscht."
        ],
        FormEditorRemoveOptionFollowUps: [
            "This answer has follow-up questions. Delete them too?",
            "Esta respuesta tiene preguntas de seguimiento. ¿Eliminarlas también?",
            "Zu dieser Antwort gibt es Folgefragen. Auch löschen?"
        ],
        FormEditorDuplicateName: [
            "Another question has the same name. Exports match answers by name, so give each question its own.",
            "Otra pregunta tiene el mismo nombre. Las exportaciones asocian las respuestas por nombre, así que usa uno distinto para cada pregunta.",
            "Eine andere Frage heißt genauso. Exporte ordnen Antworten über den Namen zu, also gib jeder Frage einen eigenen."
        ],
        FormEditorAnswerAtLeastOne: [
            "Answer at least one",
            "Responder al menos una",
            "Mindestens eine beantworten"
        ],
        FormEditorAnswerAtLeastOneHint: [
            "At least one question in this section must be answered before the form can be sent.",
            "Hay que responder al menos una pregunta de esta sección antes de enviar el formulario.",
            "Mindestens eine Frage in diesem Abschnitt muss beantwortet sein, bevor das Formular gesendet werden kann."
        ],
        WorkerWebFormsIntro: [
            "Fill in your company's forms here. Your jobs and tracking stay in the app.",
            "Aquí completas los formularios de tu empresa. Tus tareas y el seguimiento siguen en la app.",
            "Hier füllst du die Formulare deiner Firma aus. Aufträge und Ortung bleiben in der App."
        ],
        FormSectionAnswerAtLeastOne: [
            "Answer at least one question in this section",
            "Responde al menos una pregunta de esta sección",
            "Beantworte mindestens eine Frage in diesem Abschnitt"
        ],
        FormEditorPreview: [
            "Preview",
            "Vista previa",
            "Vorschau"
        ],
        FormEditorEdit: [
            "Edit",
            "Editar",
            "Bearbeiten"
        ],
        FormEditorUnsaved: [
            "Unsaved",
            "Sin guardar",
            "Nicht gespeichert"
        ],
        FormEditorSelectPlaceholder: [
            "Select...",
            "Seleccionar...",
            "Auswählen..."
        ],
        FormEditorAddField: [
            "Add field",
            "Agregar campo",
            "Feld hinzufügen"
        ],
        FormListNew: [
            "New",
            "Nuevo",
            "Neu"
        ],
        FormListUpdated: [
            "Updated",
            "Actualizado",
            "Aktualisiert"
        ]
    },
    Login: {
        UserUnknown: ['This username does not exist.', 'Este nombre de usuario no existe.', 'Dieser Nutzername existiert nicht.'],
        IncorrectPassword: ['Incorrect password', 'Contraseña incorrecta', 'Passwort ist nicht richtig'],
        InvalidUsernameOrPassword: ["Invalid username or password", "Nombre de usuario o contraseña no válidos", "Nutzername oder Passwort ungültig"],
        NoPermissionEnterWeb: ['Field workers log in to the Hellotracks app. The web dashboard is for operators and admins.', 'Los trabajadores de campo inician sesión en la app de Hellotracks. El panel web es para operadores y administradores.', 'Mitarbeiter im Außendienst melden sich in der Hellotracks-App an. Das Web-Dashboard ist für Disponenten und Admins.'],
        GetTheApp: ['Get the app', 'Descargar la app', 'App herunterladen'],
        SignInDidNotWork: ['That login didn’t work.', 'No se pudo iniciar la sesión.', 'Die Anmeldung hat nicht geklappt.'],
        Throttling: ['Too many attempts. Please wait a minute and retry.', 'Demasiados intentos. Por favor, espera un minuto y vuelve a intentarlo.', 'Zu viele Versuche. Bitte warte eine Minute und versuche es erneut.'],
        Busy: ['Our servers are currently busy. Please hang on.', 'Nuestros servidores están ocupados en este momento. Por favor, espera.', 'Unsere Server sind momentan beschäftigt. Bitte warte kurz.'],
        SomethingWentWrong: ['Something went wrong. Please try again.', 'Algo salió mal. Por favor, vuelve a intentarlo.', 'Etwas ist schiefgelaufen. Bitte versuch es erneut.'],
        NoConnection: ['Can\'t reach Hellotracks. Check your internet connection and try again.', 'No se puede conectar con Hellotracks. Revisa tu conexión a internet e inténtalo de nuevo.', 'Hellotracks ist nicht erreichbar. Prüfe deine Internetverbindung und versuche es erneut.'],
        TwoFactorAuthentication: ['Two-factor authentication (2FA)', 'Autenticación de dos factores (2FA)', 'Zwei-Faktor-Authentisierung (2FA)'],
        TwoFactorAuthenticationEnabled: ['Two-factor authentication (2FA) is now enabled', 'Autenticación de dos factores (2FA) activada', 'Zwei-Faktor-Authentisierung (2FA) ist nun aktiviert'],
        TwoFactorAuthenticationDisabled: ['Two-factor authentication (2FA) is now disabled', 'Autenticación de dos factores (2FA) desactivada', 'Zwei-Faktor-Authentisierung (2FA) ist nun deaktiviert'],
        AuthenticatorAppSetupPrompt: ['Set up an authenticator app to replace SMS or email codes for your web login.', 'Configura una aplicación autenticadora para reemplazar los códigos por SMS o correo electrónico en tu inicio de sesión web.', 'Richte eine Authenticator-App ein, um SMS- oder E-Mail-Codes für deine Web-Anmeldung zu ersetzen.'],
        AuthenticatorAppRequiresPasswordLogin: ['Set a password first if you want to use an authenticator app with this account.', 'Primero establece una contraseña si quieres usar una aplicación autenticadora con esta cuenta.', 'Lege zuerst ein Passwort fest, wenn du mit diesem Konto eine Authenticator-App verwenden möchtest.'],
        AuthenticatorAppEnabledDesc: ['Authenticator app protection is active for your account.', 'La protección con aplicación autenticadora está activa para tu cuenta.', 'Der Schutz per Authenticator-App ist für dein Konto aktiv.'],
        AuthenticatorAppEnabledForUser: ['Authenticator app protection is active for this user.', 'La protección con aplicación autenticadora está activa para este usuario.', 'Der Schutz per Authenticator-App ist für diesen Nutzer aktiv.'],
        LegacyTwoFactorEnabledDesc: ['Two-factor authentication is currently enabled through email or SMS for your account.', 'La autenticación de dos factores está habilitada actualmente mediante correo electrónico o SMS para tu cuenta.', 'Die Zwei-Faktor-Authentisierung ist für dein Konto derzeit per E-Mail oder SMS aktiviert.'],
        LegacyTwoFactorEnabledForUser: ['Two-factor authentication is currently enabled through email or SMS for this user.', 'La autenticación de dos factores está habilitada actualmente mediante correo electrónico o SMS para este usuario.', 'Die Zwei-Faktor-Authentisierung ist für diesen Nutzer derzeit per E-Mail oder SMS aktiviert.'],
        SetUpAuthenticatorApp: ['Set up authenticator app', 'Configurar aplicación autenticadora', 'Authenticator-App einrichten'],
        DisableTwoFactor: ['Disable two-factor authentication', 'Desactivar la autenticación de dos factores', 'Zwei-Faktor-Authentisierung deaktivieren'],
        DisableAuthenticatorApp: ['Disable authenticator app', 'Desactivar aplicación autenticadora', 'Authenticator-App deaktivieren'],
        RegenerateBackupCodes: ['Regenerate backup codes', 'Regenerar códigos de respaldo', 'Backup-Codes neu erstellen'],
        BackupCodesRegenerated: ['Backup codes regenerated', 'Códigos de respaldo regenerados', 'Backup-Codes neu erstellt'],
        ResetAuthenticatorForUser: ['Reset authenticator for user', 'Restablecer autenticador para el usuario', 'Authenticator für Nutzer zurücksetzen'],
        ResetAuthenticatorForUserDesc: ['This will disable two-factor authentication for this user. They will need to set it up again if they want to continue using an authenticator app.', 'Esto desactivará la autenticación de dos factores para este usuario. Tendrá que configurarla de nuevo si quiere seguir usando una aplicación autenticadora.', 'Dadurch wird die Zwei-Faktor-Authentisierung für diesen Nutzer deaktiviert. Er muss sie erneut einrichten, wenn er weiter eine Authenticator-App verwenden möchte.'],
        AuthenticatorAppSetupDesc: ['Scan this QR code with Google Authenticator, 1Password, Authy, or another compatible app, then enter the first 6-digit code to finish setup.', 'Escanea este código QR con Google Authenticator, 1Password, Authy u otra aplicación compatible, y luego ingresa el primer código de 6 dígitos para finalizar la configuración.', 'Scanne diesen QR-Code mit Google Authenticator, 1Password, Authy oder einer anderen kompatiblen App und gib dann den ersten 6-stelligen Code ein, um die Einrichtung abzuschließen.'],
        ManualSetupKey: ['Manual setup key', 'Clave de configuración manual', 'Manueller Einrichtungsschlüssel'],
        AuthenticatorAppSupported: ['Google Authenticator, 1Password, Authy, and other compatible apps are supported.', 'Se admiten Google Authenticator, 1Password, Authy y otras aplicaciones compatibles.', 'Google Authenticator, 1Password, Authy und andere kompatible Apps werden unterstützt.'],
        EnterAuthenticatorCode: ['Enter the 6-digit code from your authenticator app.', 'Ingresa el código de 6 dígitos de tu aplicación autenticadora.', 'Gib den 6-stelligen Code aus deiner Authenticator-App ein.'],
        ResendCode: ['Send a new code', 'Enviar un código nuevo', 'Neuen Code senden'],
        NewCodeSent: ['We sent you a new code.', 'Te enviamos un código nuevo.', 'Wir haben dir einen neuen Code gesendet.'],
        EnterBackupCode: ['Enter a backup code', 'Ingresa un código de respaldo', 'Backup-Code eingeben'],
        UseBackupCodeInstead: ['Use a backup code instead', 'Usar un código de respaldo', 'Stattdessen Backup-Code verwenden'],
        UseAuthenticatorCodeInstead: ['Use authenticator code instead', 'Usar código autenticador', 'Stattdessen Authenticator-Code verwenden'],
        BackupCodes: ['Backup codes', 'Códigos de respaldo', 'Backup-Codes'],
        BackupCodesShownOnce: ['These backup codes are shown only once. Store them somewhere safe before closing this dialog.', 'Estos códigos de respaldo se muestran solo una vez. Guárdalos en un lugar seguro antes de cerrar este diálogo.', 'Diese Backup-Codes werden nur einmal angezeigt. Bewahre sie an einem sicheren Ort auf, bevor du diesen Dialog schließt.'],
        PrintBackupCodes: ['Print backup codes', 'Imprimir códigos de respaldo', 'Backup-Codes drucken'],
        AuthenticatorAppEnabled: ['Authenticator app enabled', 'Aplicación autenticadora activada', 'Authenticator-App aktiviert'],
        GoogleSignInRequiresPasswordForTwoFactor: ['Accounts with two-factor authentication currently need to log in with password and code.', 'Las cuentas con autenticación de dos factores deben iniciar sesión actualmente con contraseña y código.', 'Konten mit Zwei-Faktor-Authentisierung müssen sich derzeit mit Passwort und Code anmelden.'],
        ForgotPasswordLinkToX: ['A link to recover your password has been sent to {0}', 'Un enlace para recuperar tu contraseña se ha enviado a {0}', 'Ein Link zur Wiederherstellung des Passworts wurde an {0} gesendet'],
        ForgotPasswordTryAgain: ['Please enter a valid username or email and try again', 'Ingresa un nombre de usuario o correo válido e inténtalo de nuevo', 'Bitte gültigen Nutzernamen oder gültige E-Mail eingeben und erneut versuchen'],
        UserDoesNotExist: [
            "User does not exist",
            "El usuario no existe",
            "Nutzer existiert nicht"
        ],
        UserNotSetUpForSSO: [
            "User not set up for SSO",
            "Usuario no configurado para SSO",
            "Nutzer nicht für SSO eingerichtet"
        ],
        CreateFreeAccount: ["Create free account", "Crear cuenta gratis", "Kostenloses Konto erstellen"],
    },
    Timeline: {
        ShowFullDayRoute: [
            "Show full day route on map",
            "Mostrar ruta de día completo en el mapa",
            "Tagesroute anzeigen",
        ],
        ZoomToTrack: [
            "Zoom to trip on hover",
            "Acercar al viaje al pasar el mouse",
            "Bei Mouseover zur Fahrt zoomen",
        ],
        AllEvents: ["All events", "Todos los eventos", "Alle Ereignisse"],
        OnlyTracks: ["Only trips", "Solo viajes", "Nur Fahrten"],
        ShowAllXEvents: ["Show all {0} events", "Ver todos los {0} eventos", "Alle {0} Ereignisse anzeigen"],
    },
    Spreadsheet: {
        AddAdvancedField: [
            'Add field',
            'Agregar campo',
            'Feld hinzufügen',
        ],
        AddCustomFieldColumn: [
            'Add custom field column',
            'Agregar columna de campo personalizado',
            'Benutzerdefinierte Spalte hinzufügen',
        ],
        AddRow: [
            'Add row',
            'Agregar fila',
            'Zeile hinzufügen',
        ],
        ChooseCustomFieldName: [
            'Choose custom field name',
            'Elige un nombre de campo personalizado',
            'Feldnamen wählen',
        ],
        CustomFieldName: [
            'Custom field name',
            'Nombre de campo personalizado',
            'Feldname',
        ],
    },
    Messages: {
        Inbox: ["Inbox", "Bandeja de entrada", "Posteingang"],
        SearchConversations: ["Search conversations", "Buscar conversaciones", "Gespräche durchsuchen"],
        AllMessages: ["All messages", "Todos los mensajes", "Alle Nachrichten"],
        Unread: ["Unread", "Sin leer", "Ungelesen"],
        NoMessagesYet: ["No messages yet", "Aún no hay mensajes", "Noch keine Nachrichten"],
        NoResults: ["No conversations found", "No se encontraron conversaciones", "Keine Gespräche gefunden"],
        SearchHint: ["Try another name or recent message.", "Prueba con otro nombre o mensaje reciente.", "Versuche einen anderen Namen oder Nachrichtentext."],
        CaughtUp: ["You’re all caught up", "Estás al día", "Alles gelesen"],
        NewMessagesHere: ["New messages will appear here.", "Los mensajes nuevos aparecerán aquí.", "Neue Nachrichten erscheinen hier."],
        StartConversation: ["Start a conversation", "Iniciar una conversación", "Gespräch beginnen"],
        OpenFile: ["Open", "Abrir", "Öffnen"],
        ShareFile: ["Share", "Compartir", "Teilen"],
        LinkCopied: ["Link copied", "Enlace copiado", "Link kopiert"],
        ChooseRecipientsHint: ["Choose someone from your team to get started.", "Elige a alguien de tu equipo para empezar.", "Wähle jemanden aus deinem Team aus."],
        ChooseConversation: ["Choose a conversation", "Elige una conversación", "Wähle ein Gespräch"],
        ChooseConversationHint: ["Catch up with your team or start a new conversation.", "Ponte al día con tu equipo o inicia una conversación.", "Tausche dich mit deinem Team aus oder beginne ein neues Gespräch."],
        Conversation: ["Conversation", "Conversación", "Gespräch"],
        BackToInbox: ["Back to inbox", "Volver a la bandeja de entrada", "Zurück zum Posteingang"],
        DirectMessage: ["Direct message", "Mensaje directo", "Direktnachricht"],
        Profile: ["Profile", "Perfil", "Profil"],
        RecipientCount: ["New message · {0} recipients", "Nuevo mensaje · {0} destinatarios", "Neue Nachricht · {0} Empfänger"],
        SeparateMessages: ["Each person receives a separate direct message.", "Cada persona recibe un mensaje directo separado.", "Jede Person erhält eine eigene Direktnachricht."],
        SayHello: ["Send a message to start the conversation.", "Envía un mensaje para iniciar la conversación.", "Sende eine Nachricht, um das Gespräch zu beginnen."],
        MessagePlaceholder: ["Message {0}…", "Mensaje a {0}…", "Nachricht an {0}…"],
        ComposerHint: ["Enter to send · Shift + Enter for a new line", "Enter para enviar · Mayús + Enter para una nueva línea", "Enter zum Senden · Umschalt + Enter für eine neue Zeile"],
        LoadFailed: ["Couldn’t load messages.", "No se pudieron cargar los mensajes.", "Nachrichten konnten nicht geladen werden."],
        Retry: ["Retry", "Reintentar", "Erneut versuchen"],
        Sending: ["Sending…", "Enviando…", "Wird gesendet…"],
        SendFailed: ["Send not confirmed for: {0}. Your draft is saved. Check before retrying to avoid duplicates.", "Envío sin confirmar para: {0}. Tu borrador está guardado. Comprueba antes de reintentar para evitar duplicados.", "Versand nicht bestätigt für: {0}. Dein Entwurf ist gespeichert. Prüfe vor einem erneuten Versuch, um doppelte Nachrichten zu vermeiden."],
        Offline: ["You’re offline. You can keep writing; reconnect to send.", "Sin conexión. Puedes seguir escribiendo; reconéctate para enviar.", "Du bist offline. Du kannst weiterschreiben und nach dem Verbinden senden."],
        RemoveLocation: ["Remove attached location", "Quitar ubicación adjunta", "Angehängten Standort entfernen"],
        SharedLocation: ["Shared location", "Ubicación compartida", "Geteilter Standort"],
        OpenOnMap: ["Open on map", "Abrir en el mapa", "Auf der Karte öffnen"],
        AttachedLocation: ["Attached location", "Ubicación adjunta", "Angehängter Standort"],
        UnreadCount: ["{0} unread", "{0} sin leer", "{0} ungelesen"],
        SentToCount: ["Message sent to {0} people", "Mensaje enviado a {0} personas", "Nachricht an {0} Personen gesendet"],
        Read: ["Read", "Leído", "Gelesen"],
        Sent: ["Sent", "Enviado", "Gesendet"],
        UnknownMember: ["Team member", "Miembro del equipo", "Teammitglied"],
        YouPreview: ["You: {0}", "Tú: {0}", "Du: {0}"],
        NewMessagesBelow: ["New messages", "Mensajes nuevos", "Neue Nachrichten"],
        TypeMessageHere: [
            "Type message here",
            "Escribe un mensaje aquí",
            "Nachricht hier eingeben",
        ],
        EnterMessage: [
            'Enter message',
            'Escribir un mensaje',
            'Nachricht eingeben',
        ],
        NewMessage: [
            "New message",
            "Nuevo mensaje",
            "Neue Nachricht",
        ],
        MessageFromX: [
            "Message from {0}",
            "Mensaje de {0}",
            "Nachricht von {0}"
        ],
        DeleteMessage: [
            "Delete message",
            "Borrar mensaje",
            "Nachricht löschen",
        ],
    },
    Reporting: {
        YourReports: ["Your reports", "Tus informes", "Deine Berichte"],
        Recurring: ["Recurring", "Recurrentes", "Wiederkehrend"],
        Recent: ["Recent", "Recientes", "Verlauf"],
        Archived: ["Archived", "Archivados", "Archiviert"],
        StartNew: ["Start a new report", "Crea un informe nuevo", "Neuen Bericht starten"],
        StartNewHint: ["Each card shows the first page with example data. Open one to see it with yours.", "Cada tarjeta muestra la primera página con datos de ejemplo. Ábrela para verla con los tuyos.", "Jede Karte zeigt die erste Seite mit Beispieldaten. Öffne sie, um sie mit deinen Daten zu sehen."],
        NewReport: ["New report", "Nuevo informe", "Neuer Bericht"],
        ClassicBandTitle: ["Classic reports and data exports", "Informes clásicos y exportaciones", "Klassische Berichte und Datenexporte"],
        ClassicBand: ["The reports you know are still here. Your classic schedules keep running exactly as before until you move them.", "Los informes que conoces siguen aquí. Tus programaciones clásicas siguen igual hasta que las cambies.", "Die Berichte, die du kennst, sind weiter da. Deine klassischen Zeitpläne laufen genau wie bisher, bis du sie umstellst."],
        ShowClassic: ["Show classic reports", "Ver informes clásicos", "Klassische Berichte zeigen"],
        Search: ["Search reports, schedules and files", "Busca informes, programaciones y archivos", "Berichte, Zeitpläne und Dateien suchen"],
        ColName: ["Name", "Nombre", "Name"],
        ColReport: ["Report", "Informe", "Bericht"],
        ColRuns: ["Runs", "Se ejecuta", "Läuft"],
        ColSendsTo: ["Sends to", "Se envía a", "Geht an"],
        ColLastSent: ["Last sent", "Último envío", "Zuletzt gesendet"],
        ColSize: ["Size", "Tamaño", "Größe"],
        ColMade: ["Made", "Creado", "Erstellt"],
        ColMadeBy: ["Made by", "Hecho por", "Erstellt von"],
        MadeBySchedule: ["Schedule · {0}", "Programación · {0}", "Zeitplan · {0}"],
        DownloadShort: ["Download", "Descargar", "Herunterladen"],
        BothUntil: ["Both versions until {0}", "Ambas versiones hasta el {0}", "Beide Versionen bis {0}"],
        Classic: ["Classic", "Clásico", "Klassisch"],
        All: ["All", "Todos", "Alle"],
        Edit: ["Edit", "Editar", "Bearbeiten"],
        TryNewVersion: ["Try new version", "Probar la nueva versión", "Neue Version testen"],
        OpenInClassic: ["Open in classic", "Abrir en clásico", "Klassisch öffnen"],
        Retry: ["Retry", "Reintentar", "Erneut versuchen"],
        Resume: ["Resume", "Reanudar", "Fortsetzen"],
        DeleteReport: ["Delete", "Eliminar", "Löschen"],
        BetaInvite: ["New: Reports with a live preview, a sheet per person and your choice of view.", "Nuevo: informes con vista previa en vivo, una hoja por persona y la vista que elijas.", "Neu: Berichte mit Live-Vorschau, einem Blatt pro Person und der Ansicht deiner Wahl."],
        BetaTry: ["Try the new Reports (beta)", "Probar los nuevos informes (beta)", "Neue Berichte testen (Beta)"],
        BetaOn: ["You're trying the new Reports (beta). Your classic reports and schedules keep running.", "Estás probando los nuevos informes (beta). Tus informes y programaciones clásicos siguen funcionando.", "Du testest die neuen Berichte (Beta). Deine klassischen Berichte und Zeitpläne laufen weiter."],
        BetaBack: ["Back to classic Reports", "Volver a los informes clásicos", "Zurück zu den klassischen Berichten"],
        ReallyDeleteReport: ["Delete this report and its schedule?", "¿Eliminar este informe y su programación?", "Diesen Bericht und seinen Zeitplan löschen?"],
        MoreActions: ["More", "Más", "Mehr"],
        Pause: ["Pause", "Pausar", "Pausieren"],
        Paused: ["Paused", "En pausa", "Pausiert"],
        Failed: ["Failed", "Falló", "Fehlgeschlagen"],
        ByHand: ["By hand", "A mano", "Von Hand"],
        Never: ["Never", "Nunca", "Nie"],
        PeopleCount: ["{0} people", "{0} personas", "{0} Personen"],
        OutsideCount: ["{0} outside", "{0} externos", "{0} extern"],
        You: ["You", "Tú", "Du"],
        ClassicDaily: ["Daily · yesterday", "Diario · ayer", "Täglich · gestern"],
        ClassicWeekly: ["Weekly · last 7 days", "Semanal · últimos 7 días", "Wöchentlich · letzte 7 Tage"],
        ClassicTwoWeeks: ["Every two weeks", "Cada dos semanas", "Alle zwei Wochen"],
        EmptyYourReports: ["Nothing saved yet. Open a report below, then schedule it.", "Aún no hay nada guardado. Abre un informe abajo y prográmalo.", "Noch nichts gespeichert. Öffne unten einen Bericht und plane ihn."],
        EmptyRecent: ["No files in the last 30 days.", "No hay archivos de los últimos 30 días.", "Keine Dateien aus den letzten 30 Tagen."],
        EmptyArchived: ["Nothing archived. Paused reports land here.", "Nada archivado. Los informes en pausa aparecen aquí.", "Nichts archiviert. Pausierte Berichte landen hier."],
        Who: ["Who", "Quién", "Wer"],
        LoadingPreview: ["Making your preview…", "Preparando tu vista previa…", "Erstelle deine Vorschau…"],
        LoadingTeamWeek: ["Counting your team's hours…", "Contando las horas de tu equipo…", "Zähle die Stunden deines Teams…"],
        LoadingJobs: ["Going through your jobs…", "Revisando tus tareas…", "Gehe deine Aufträge durch…"],
        LoadingPlaceVisits: ["Checking your places…", "Revisando tus lugares…", "Prüfe deine Orte…"],
        LoadingTimesheet: ["Adding up the hours…", "Sumando las horas…", "Rechne die Stunden zusammen…"],
        LoadingMileage: ["Adding up the trips…", "Sumando los viajes…", "Rechne die Fahrten zusammen…"],
        LoadingAlerts: ["Reading the alerts…", "Leyendo las alertas…", "Lese die Alarme…"],
        LoadingFormAnswers: ["Reading the answers…", "Leyendo las respuestas…", "Lese die Antworten…"],
        LoadingVisit: ["Pulling up the visit…", "Buscando la visita…", "Hole den Besuch…"],
        Form: ["Form", "Formulario", "Formular"],
        NoForms: [
            "No forms yet. Once you make one and your team fills it in, its answers show here.",
            "Aún no hay formularios. Cuando crees uno y tu equipo lo llene, sus respuestas aparecen aquí.",
            "Noch keine Formulare. Sobald du eins erstellst und dein Team es ausfüllt, erscheinen die Antworten hier.",
        ],
        Places: ["Places", "Lugares", "Orte"],
        ByField: ["By field", "Por campo", "Nach Feld"],
        FieldName: ["Field, e.g. Type", "Campo, p. ej. Tipo", "Feld, z. B. Typ"],
        FieldValue: ["Value, e.g. Hospital", "Valor, p. ej. Hospital", "Wert, z. B. Klinik"],
        When: ["When", "Cuándo", "Wann"],
        View: ["View", "Vista", "Ansicht"],
        Format: ["Format", "Formato", "Format"],
        Everyone: ["Everyone", "Todos", "Alle"],
        Teams: ["Teams", "Equipos", "Teams"],
        People: ["People", "Personas", "Personen"],
        TeamFollows: ["New people in these teams are included automatically.", "Las personas nuevas de estos equipos se incluyen solas.", "Neue Personen in diesen Teams sind automatisch dabei."],
        PickTeams: ["Pick teams", "Elige equipos", "Teams wählen"],
        PickPeople: ["Pick people", "Elige personas", "Personen wählen"],
        Yesterday: ["Yesterday", "Ayer", "Gestern"],
        ThisWeek: ["This week", "Esta semana", "Diese Woche"],
        LastWeek: ["Last week", "La semana pasada", "Letzte Woche"],
        ThisMonth: ["This month", "Este mes", "Dieser Monat"],
        LastMonth: ["Last month", "El mes pasado", "Letzter Monat"],
        PickDates: ["Pick dates", "Elegir fechas", "Daten wählen"],
        Columns: ["Columns", "Columnas", "Spalten"],
        ColumnsAll: ["All {0} columns", "Las {0} columnas", "Alle {0} Spalten"],
        ColumnsSome: ["{0} of {1} columns", "{0} de {1} columnas", "{0} von {1} Spalten"],
        ColumnsChange: ["Change", "Cambiar", "Ändern"],
        ColumnsTitle: ["Columns in Excel and CSV", "Columnas en Excel y CSV", "Spalten in Excel und CSV"],
        ColumnsSub: [
            "Pick them, drag them into order, rename them for your own systems. The PDF keeps its own layout.",
            "Elígelas, arrástralas para ordenarlas y cámbiales el nombre para tus sistemas. El PDF mantiene su diseño.",
            "Wähle sie aus, zieh sie in die richtige Reihenfolge und benenne sie für deine Systeme um. Das PDF behält sein eigenes Layout.",
        ],
        ColumnsEvery: ["Every column", "Todas las columnas", "Alle Spalten"],
        ColumnsStandard: ["Standard", "Estándar", "Standard"],
        ColumnsSearch: ["Find a column", "Buscar una columna", "Spalte suchen"],
        ColumnsRename: ["Rename", "Cambiar nombre", "Umbenennen"],
        ColumnsRenamed: ["In the file: {0}", "En el archivo: {0}", "In der Datei: {0}"],
        ColumnsSaveSet: ["Save as a set for the company", "Guardar como conjunto de la empresa", "Als Vorlage für die Firma speichern"],
        ColumnsSetName: ["Name, e.g. Payroll", "Nombre, p. ej. Nómina", "Name, z. B. Lohnabrechnung"],
        ColumnsSetSaved: ["Saved. Everyone in the company can pick it.", "Guardado. Todos en la empresa pueden elegirlo.", "Gespeichert. Alle in der Firma können sie auswählen."],
        ColumnsRemoveSet: ["Remove the set {0}", "Quitar el conjunto {0}", "Vorlage {0} entfernen"],
        ColumnsSave: ["Save", "Guardar", "Speichern"],
        ColumnsDone: ["Done", "Listo", "Fertig"],
        ColumnsNone: ["Pick at least one column.", "Elige al menos una columna.", "Wähle mindestens eine Spalte."],
        ColumnsLoading: ["The columns show once the preview is in.", "Las columnas aparecen cuando carga la vista previa.", "Die Spalten erscheinen, sobald die Vorschau da ist."],
        RangeFrom: ["From", "Desde", "Von"],
        RangeUntil: ["To", "Hasta", "Bis"],
        TooManyDays: ["Up to {0} days at a time.", "Hasta {0} días a la vez.", "Höchstens {0} Tage auf einmal."],
        Compare: ["Compare with the period before", "Comparar con el periodo anterior", "Mit dem Zeitraum davor vergleichen"],
        ExcelHint: ["Excel has a Summary sheet with these numbers, then every row.", "El Excel trae una hoja de resumen con estas cifras y luego todas las filas.", "Excel hat ein Übersichtsblatt mit diesen Zahlen, danach alle Zeilen."],
        CsvHint: ["One table for importing into other tools. The summary is in Excel and PDF.", "Una tabla para importar en otras herramientas. El resumen está en el Excel y el PDF.", "Eine Tabelle zum Importieren in andere Programme. Die Übersicht steht im Excel und im PDF."],
        LivePreview: ["Live preview · your data", "Vista previa en vivo · tus datos", "Live-Vorschau · deine Daten"],
        Updating: ["Updating…", "Actualizando…", "Wird aktualisiert…"],
        NoPreview: ["Couldn't make the preview: {0}", "No se pudo crear la vista previa: {0}", "Die Vorschau konnte nicht erstellt werden: {0}"],
        Download: ["Download {0}", "Descargar {0}", "{0} herunterladen"],
        Making: ["Making the file…", "Creando el archivo…", "Datei wird erstellt…"],
        FileReady: ["Your file is ready.", "Tu archivo está listo.", "Deine Datei ist fertig."],
        FileFailed: ["The file couldn't be made: {0}", "No se pudo crear el archivo: {0}", "Die Datei konnte nicht erstellt werden: {0}"],
        Schedule: ["Schedule", "Programar", "Planen"],
        EditSchedule: ["Edit schedule", "Editar programación", "Zeitplan bearbeiten"],
        ScheduleTitle: ["Schedule {0}", "Programar {0}", "{0} planen"],
        ScheduleSub: ["Sends itself. You can pause or change it any time.", "Se envía solo. Puedes pausarlo o cambiarlo cuando quieras.", "Wird automatisch verschickt. Du kannst es jederzeit pausieren oder ändern."],
        Name: ["Name", "Nombre", "Name"],
        HowOften: ["How often", "Frecuencia", "Wie oft"],
        EveryDay: ["Every day", "Cada día", "Jeden Tag"],
        EveryWeek: ["Every week", "Cada semana", "Jede Woche"],
        EveryMonth: ["Every month", "Cada mes", "Jeden Monat"],
        OnWeekdays: ["On", "Los días", "An"],
        OnWeekday: ["On", "El", "Am"],
        OnMonthDay: ["On day", "El día", "Am Tag"],
        At: ["at", "a las", "um"],
        CoversDay: ["Covers the day before each run.", "Cubre el día anterior a cada envío.", "Umfasst jeweils den Vortag."],
        CoversWeek: ["Covers the previous Monday to Sunday.", "Cubre de lunes a domingo de la semana anterior.", "Umfasst Montag bis Sonntag der Vorwoche."],
        CoversMonth: ["Covers the previous month.", "Cubre el mes anterior.", "Umfasst den Vormonat."],
        SendTo: ["Send to", "Enviar a", "Senden an"],
        AddRecipient: ["Add a person or an email address", "Añade una persona o un correo", "Person oder E-Mail-Adresse hinzufügen"],
        OutsideHint: ["People outside your company get the email only, never a login.", "Las personas de fuera de tu empresa solo reciben el correo, nunca un acceso.", "Personen außerhalb deiner Firma bekommen nur die E-Mail, nie einen Zugang."],
        HowArrives: ["How it arrives", "Cómo llega", "Wie es ankommt"],
        DeliveryAttach: ["Email with the files attached", "Correo con los archivos adjuntos", "E-Mail mit den Dateien im Anhang"],
        DeliveryAttachHint: ["The summary is in the email too, so most people never need to open the file.", "El resumen va en el correo, así que casi nadie necesita abrir el archivo.", "Die Übersicht steht auch in der E-Mail, die meisten müssen die Datei gar nicht öffnen."],
        DeliveryLink: ["Email with a link", "Correo con un enlace", "E-Mail mit Link"],
        DeliveryInbox: ["Hellotracks Inbox only", "Solo la bandeja de Hellotracks", "Nur im Hellotracks-Posteingang"],
        AlsoExcel: ["Also attach the Excel file", "Adjuntar también el Excel", "Auch die Excel-Datei anhängen"],
        SaveSchedule: ["Save schedule", "Guardar programación", "Zeitplan speichern"],
        NeedsRecipient: ["Add at least one recipient.", "Añade al menos un destinatario.", "Füge mindestens einen Empfänger hinzu."],
        SavedOk: ["Saved.", "Guardado.", "Gespeichert."],
        SendNow: ["Send now", "Enviar ahora", "Jetzt senden"],
        Sent: ["On its way.", "En camino.", "Ist unterwegs."],
        Delete: ["Delete", "Eliminar", "Löschen"],
        DeleteConfirm: ["Delete \"{0}\"? It stops sending.", "¿Eliminar \"{0}\"? Deja de enviarse.", "\"{0}\" löschen? Es wird nicht mehr verschickt."],
        Back: ["Back to reports", "Volver a informes", "Zurück zu den Berichten"],
        SendsToday: ["What it sends today", "Lo que envía hoy", "Was heute verschickt wird"],
        InboxLink: ["Inbox link", "Enlace en la bandeja", "Link im Posteingang"],
        NewVersionTitle: ["The new version: {0}", "La nueva versión: {0}", "Die neue Version: {0}"],
        NewVersionSub: ["A one-page summary on top. The Excel file keeps its sheets and columns.", "Un resumen de una página arriba. El Excel mantiene sus hojas y columnas.", "Oben eine Übersicht auf einer Seite. Die Excel-Datei behält ihre Blätter und Spalten."],
        StaysSame: ["If you switch, this stays the same", "Si cambias, esto se mantiene", "Wenn du umstellst, bleibt das gleich"],
        SameDay: ["Same days and the same period.", "Los mismos días y el mismo periodo.", "Dieselben Tage und derselbe Zeitraum."],
        SameRecipients: ["Same recipients.", "Los mismos destinatarios.", "Dieselben Empfänger."],
        SamePeople: ["Same people.", "Las mismas personas.", "Dieselben Personen."],
        SameExcel: ["The Excel file keeps its sheets and columns, so anything that imports it keeps working.", "El Excel mantiene sus hojas y columnas, así que todo lo que lo importa sigue funcionando.", "Die Excel-Datei behält Blätter und Spalten, alles was sie importiert, funktioniert weiter."],
        OnTop: ["What you get on top", "Lo que ganas además", "Was du zusätzlich bekommst"],
        OnTopPdf: ["A one-page PDF with the answer, the key numbers and what changed.", "Un PDF de una página con la respuesta, las cifras clave y lo que cambió.", "Ein einseitiges PDF mit der Antwort, den wichtigsten Zahlen und was sich geändert hat."],
        OnTopEmail: ["An email with the files attached, instead of a link in the Inbox.", "Un correo con los archivos adjuntos, en lugar de un enlace en la bandeja.", "Eine E-Mail mit den Dateien im Anhang statt eines Links im Posteingang."],
        OnTopTime: ["Sent at 7:00 in the morning instead of right after midnight.", "Se envía a las 7:00 en lugar de justo después de medianoche.", "Kommt um 7:00 Uhr statt kurz nach Mitternacht."],
        SwitchNow: ["Switch this schedule", "Cambiar esta programación", "Diesen Zeitplan umstellen"],
        SendBoth: ["Send both for 2 weeks, then decide", "Enviar ambos 2 semanas y luego decidir", "2 Wochen beides schicken, dann entscheiden"],
        KeepClassic: ["Keep classic", "Mantener el clásico", "Klassisch behalten"],
        CantSwitch: ["There is no new version of this report yet.", "Aún no hay una versión nueva de este informe.", "Für diesen Bericht gibt es noch keine neue Version."],
        CantMove: [
            "This schedule can't move to the new version. Make a new report from the list instead.",
            "Esta programación no se puede pasar a la versión nueva. Crea un informe nuevo desde la lista.",
            "Dieser Zeitplan lässt sich nicht auf die neue Version umstellen. Erstelle stattdessen einen neuen Bericht aus der Liste.",
        ],
        Switched: ["Switched. The classic schedule is paused, not deleted.", "Cambiado. La programación clásica queda en pausa, no eliminada.", "Umgestellt. Der klassische Zeitplan ist pausiert, nicht gelöscht."],
        BothStarted: ["Both are sent for the next 2 weeks.", "Se enviarán ambos durante las próximas 2 semanas.", "In den nächsten 2 Wochen kommt beides."],
        NewVersionPreview: ["Preview with your data", "Vista previa con tus datos", "Vorschau mit deinen Daten"],
    },
    Stats: {
        Statistics: ["Statistics", "Estadísticas", "Statistik"],

        // ---- Statistics v2: metrics (labels + help) ----
        MetricClockedPerDay: ["Median clocked / day", "Mediana registrada / día", "Median gestempelt / Tag"],
        MetricClockedPerDayHelp: ["Median clocked time per clocked day. Half of the days were shorter, half longer.", "Mediana del tiempo registrado por día registrado. La mitad de los días fueron más cortos, la otra mitad más largos.", "Median der gestempelten Zeit pro Stempeltag. Die Hälfte der Tage war kürzer, die andere länger."],
        MetricTotalClockedHelp: ["All clocked time in the period.", "Todo el tiempo registrado en el período.", "Gesamte gestempelte Zeit im Zeitraum."],
        MetricScheduledWorked: ["Scheduled hours worked", "Horas programadas trabajadas", "Geleistete Sollstunden"],
        MetricScheduledWorkedHelp: ["Clocked time as a share of the working hours set for the members.", "Tiempo registrado como parte de las horas laborales configuradas para los miembros.", "Gestempelte Zeit im Verhältnis zu den eingestellten Arbeitszeiten der Mitglieder."],
        MetricImplausibleDays: ["Implausible days", "Días implausibles", "Unplausible Tage"],
        MetricImplausibleDaysHelp: ["Days with more than 16 hours clocked. Almost always a missing clock-out.", "Días con más de 16 horas registradas. Casi siempre falta una salida.", "Tage mit mehr als 16 gestempelten Stunden. Fast immer fehlt ein Ausstempeln."],
        MetricTimesheetEntriesHelp: ["Timesheet entries with a clock-in or clock-out.", "Entradas de hoja de horas con entrada o salida.", "Stempeleinträge mit Ein- oder Ausstempeln."],
        MetricJobsDone: ["Done", "Completadas", "Erledigt"],
        MetricJobsDoneHelp: ["Jobs completed successfully, out of all assigned jobs in the period.", "Tareas completadas con éxito, de todas las tareas asignadas en el período.", "Erfolgreich erledigte Aufträge von allen zugewiesenen Aufträgen im Zeitraum."],
        MetricJobIssues: ["Issues", "Incidencias", "Probleme"],
        MetricJobIssuesHelp: ["Jobs reported as an issue.", "Tareas reportadas con incidencia.", "Aufträge, die als Problem gemeldet wurden."],
        MetricLateArrivals: ["Late arrivals", "Llegadas tarde", "Verspätungen"],
        MetricLateArrivalsHelp: ["Jobs with a time window where the member arrived more than 10 minutes late.", "Tareas con ventana horaria en las que el miembro llegó más de 10 minutos tarde.", "Aufträge mit Zeitfenster, bei denen das Mitglied mehr als 10 Minuten zu spät kam."],
        MetricOnTimeRate: ["On-time rate", "Puntualidad", "Pünktlichkeit"],
        MetricOnTimeRateHelp: ["Share of jobs with a time window that were reached on time.", "Porcentaje de tareas con ventana horaria atendidas a tiempo.", "Anteil der Aufträge mit Zeitfenster, die pünktlich erreicht wurden."],
        MetricMedianTimeAtJobs: ["Median time at job", "Mediana de tiempo en tarea", "Mediane Zeit beim Auftrag"],
        MetricTimeAtJobsHelp: ["Median time spent at a job site. Half of the visits were shorter.", "Mediana del tiempo en el lugar de la tarea. La mitad de las visitas fueron más cortas.", "Median der Zeit am Einsatzort. Die Hälfte der Besuche war kürzer."],
        MetricTotalTimeAtJobsHelp: ["All time spent at job sites.", "Todo el tiempo en lugares de tareas.", "Gesamte Zeit an Einsatzorten."],
        MetricMedianTimeBetweenJobs: ["Median time between jobs", "Mediana de tiempo entre tareas", "Mediane Zeit zwischen Aufträgen"],
        MetricTimeBetweenJobsHelp: ["Median gap between leaving one job and arriving at the next, same day.", "Mediana del tiempo entre salir de una tarea y llegar a la siguiente, el mismo día.", "Median der Zeit zwischen dem Verlassen eines Auftrags und der Ankunft beim nächsten am selben Tag."],
        MetricEngagementHelp: ["Share of assigned jobs the member interacted with.", "Porcentaje de tareas asignadas con las que el miembro interactuó.", "Anteil der zugewiesenen Aufträge, mit denen das Mitglied gearbeitet hat."],
        MetricJobsNoForm: ["Done without form", "Completadas sin formulario", "Erledigt ohne Formular"],
        MetricJobsNoFormHelp: ["Completed jobs that expect a form but have none.", "Tareas completadas que requieren un formulario pero no lo tienen.", "Erledigte Aufträge, die ein Formular erfordern, aber keines haben."],
        MetricJobPerformanceByDayHelp: ["Done, issues and scheduled jobs per day.", "Completadas, incidencias y programadas por día.", "Erledigt, Probleme und geplant pro Tag."],
        MetricJobsByTypeHelp: ["Jobs in the period by job type.", "Tareas del período por tipo.", "Aufträge im Zeitraum nach Typ."],
        MetricJobsByTeamHelp: ["Jobs in the period by team.", "Tareas del período por equipo.", "Aufträge im Zeitraum nach Team."],
        MetricTotalDistanceHelp: ["All distance traveled in the period.", "Toda la distancia recorrida en el período.", "Gesamte zurückgelegte Strecke im Zeitraum."],
        MetricTotalStopsHelp: ["All stops in the period.", "Todas las paradas del período.", "Alle Stopps im Zeitraum."],
        MetricTotalTravelTimeHelp: ["All time on the move.", "Todo el tiempo en movimiento.", "Gesamte Zeit in Bewegung."],
        MetricTotalPauseHelp: ["All stationary time that is not a job or place.", "Todo el tiempo detenido que no es una tarea ni un lugar.", "Gesamte Standzeit, die kein Auftrag und kein Ort ist."],
        MetricDayAllocation: ["Where the day goes", "En qué se va el día", "Wohin der Tag geht"],
        MetricDayAllocationHelp: ["Time at jobs, at places, traveling and paused per day across the team.", "Tiempo en tareas, en lugares, en viaje y en pausa por día en el equipo.", "Zeit bei Aufträgen, an Orten, unterwegs und in Pause pro Tag im Team."],
        MetricAvgSpeedHelp: ["Average speed over all trips.", "Velocidad promedio de todos los viajes.", "Durchschnittsgeschwindigkeit über alle Fahrten."],
        MetricMaxSpeedHelp: ["Highest speed recorded.", "Velocidad máxima registrada.", "Höchste gemessene Geschwindigkeit."],
        MetricTracks: ["Trips", "Viajes", "Fahrten"],
        MetricTracksHelp: ["Recorded trips in the period.", "Viajes registrados en el período.", "Aufgezeichnete Fahrten im Zeitraum."],
        MetricTrackingGaps: ["Tracking gaps", "Huecos de seguimiento", "Tracking-Lücken"],
        MetricTrackingGapsHelp: ["Gaps of more than 2 hours without location while clocked in.", "Huecos de más de 2 horas sin ubicación durante la jornada.", "Lücken von mehr als 2 Stunden ohne Standort während der Stempelzeit."],
        MetricDaysJobsNoLocation: ["Job days without location", "Días con tareas sin ubicación", "Auftragstage ohne Standort"],
        MetricDaysJobsNoLocationHelp: ["Days with assigned jobs but no recorded trips.", "Días con tareas asignadas pero sin viajes registrados.", "Tage mit zugewiesenen Aufträgen, aber ohne aufgezeichnete Fahrten."],
        MetricPlaceVisits: ["Place visits", "Visitas a lugares", "Ortsbesuche"],
        MetricPlaceVisitsHelp: ["Stops at a saved place.", "Paradas en un lugar guardado.", "Stopps an einem gespeicherten Ort."],
        MetricMedianTimeAtPlaces: ["Median time at place", "Mediana de tiempo en lugares", "Mediane Zeit an Orten"],
        MetricTimeAtPlacesHelp: ["Median time per place visit. Half of the visits were shorter.", "Mediana del tiempo por visita a un lugar. La mitad de las visitas fueron más cortas.", "Median der Zeit pro Ortsbesuch. Die Hälfte der Besuche war kürzer."],
        MetricTripLength: ["Median trip", "Mediana de viaje", "Median Fahrt"],
        MetricTripLengthHelp: ["Median duration of a recorded trip.", "Mediana de la duración de un viaje registrado.", "Median der Dauer einer aufgezeichneten Fahrt."],
        MetricPauseLength: ["Median stop", "Mediana de parada", "Median Stopp"],
        MetricPauseLengthHelp: ["Median duration of a stop that is not a job or a place.", "Mediana de la duración de una parada que no es una tarea ni un lugar.", "Median der Dauer eines Stopps, der kein Auftrag und kein Ort ist."],
        MetricPlaceCoverage: ["Places visited", "Lugares visitados", "Besuchte Orte"],
        MetricPlaceCoverageHelp: ["Share of your active places with at least one visit in the period.", "Porcentaje de tus lugares activos con al menos una visita en el período.", "Anteil deiner aktiven Orte mit mindestens einem Besuch im Zeitraum."],
        MetricSilentPlaces: ["Silent places", "Lugares sin visitas", "Stille Orte"],
        MetricSilentPlacesHelp: ["Active places nobody has visited for longer than the silent-place threshold (14 days unless changed in the company settings).", "Lugares activos que nadie ha visitado durante más tiempo que el umbral de lugar sin visitas (14 días salvo que lo cambies en la configuración de la empresa).", "Aktive Orte, die länger als die Schwelle für stille Orte niemand besucht hat (14 Tage, sofern du es in den Firmeneinstellungen nicht änderst)."],
        MetricVisitsPerPlace: ["Visits per place", "Visitas por lugar", "Besuche pro Ort"],
        MetricVisitsPerPlaceHelp: ["Median number of visits per visited place.", "Mediana de visitas por lugar visitado.", "Median der Besuche pro besuchtem Ort."],
        MetricTopPlaces: ["Most visited places", "Lugares más visitados", "Meistbesuchte Orte"],
        MetricTopPlacesHelp: ["The eight places with the most visits in the period.", "Los ocho lugares con más visitas en el período.", "Die acht Orte mit den meisten Besuchen im Zeitraum."],
        MetricClockedAtPlaces: ["Clocked time at places", "Tiempo registrado en lugares", "Stempelzeit an Orten"],
        MetricClockedAtPlacesHelp: ["Time at the chosen places while clocked in, as a share of all clocked time.", "Tiempo en los lugares elegidos durante el tiempo registrado, como porcentaje de todo el tiempo registrado.", "Zeit an den gewählten Orten während der Stempelzeit, als Anteil an der gesamten Stempelzeit."],
        AtAllPlaces: ["at all {0} places", "en los {0} lugares", "an allen {0} Orten"],
        AtSomePlaces: ["at {0} of {1} places", "en {0} de {1} lugares", "an {0} von {1} Orten"],
        AllPlacesCount: ["All {0} places", "Los {0} lugares", "Alle {0} Orte"],
        SomePlacesCount: ["{0} of {1} places", "{0} de {1} lugares", "{0} von {1} Orten"],
        MetricTotalTimeAtPlacesHelp: ["All time spent at places.", "Todo el tiempo en lugares.", "Gesamte Zeit an Orten."],
        MetricCheckins: ["Check-ins", "Check-ins", "Check-ins"],
        MetricCheckinsHelp: ["Check-ins at places in the period.", "Check-ins en lugares en el período.", "Check-ins an Orten im Zeitraum."],
        MetricVisitsNoCheckin: ["Visits without check-in", "Visitas sin check-in", "Besuche ohne Check-in"],
        MetricVisitsNoCheckinHelp: ["Place visits detected from location with no check-in.", "Visitas a lugares detectadas por ubicación sin check-in.", "Per Standort erkannte Ortsbesuche ohne Check-in."],
        MetricCheckinRate: ["Check-in rate", "Tasa de check-in", "Check-in-Quote"],
        MetricCheckinRateHelp: ["Share of place visits with a check-in.", "Porcentaje de visitas a lugares con check-in.", "Anteil der Ortsbesuche mit Check-in."],
        MetricFormsSubmitted: ["Forms submitted", "Formularios enviados", "Formulare gesendet"],
        MetricFormsSubmittedHelp: ["Form submissions in the period.", "Formularios enviados en el período.", "Gesendete Formulare im Zeitraum."],
        MetricFormsPerDay: ["Forms / active day", "Formularios / día activo", "Formulare / aktiver Tag"],
        MetricFormsPerDayHelp: ["Form submissions per active day.", "Formularios enviados por día activo.", "Gesendete Formulare pro aktivem Tag."],
        MetricDeviceIssues: ["Devices needing setup", "Dispositivos por configurar", "Geräte mit Einrichtungsbedarf"],
        MetricDeviceIssuesHelp: ["Members whose phone cannot record location in the background.", "Miembros cuyo teléfono no puede registrar la ubicación en segundo plano.", "Mitglieder, deren Telefon den Standort nicht im Hintergrund aufzeichnen kann."],
        // ---- Statistics v2: formatting ----
        OfTotal: ["of {0}", "de {0}", "von {0}"],
        CountOfTotal: ["{0} of {1}", "{0} de {1}", "{0} von {1}"],
        DistAvg: ["avg {0}", "prom. {0}", "Ø {0}"],
        DistP90: ["P90 {0}", "P90 {0}", "P90 {0}"],
        OpenRecords: ["Open records ↗", "Abrir registros ↗", "Einträge öffnen ↗"],
        OpenRecordsFor: ["Open records for {0}", "Abrir registros de {0}", "Einträge für {0} öffnen"],
        SetUp: ["Set up →", "Configurar →", "Einrichten →"],
        Locked: ["Not in use yet", "Aún sin uso", "Noch nicht in Verwendung"],
        DeltaNoChange: ["no change", "sin cambios", "keine Änderung"],
        DeltaSuffix: ["vs previous", "vs anterior", "vs. vorher"],
        DeltaVsPreviousDay: ["vs previous day", "vs día anterior", "vs. Vortag"],
        DeltaVsPreviousDays: ["vs previous {0} days", "vs {0} días anteriores", "vs. vorherige {0} Tage"],
        Points: ["pts", "pts", "Pkt."],
        NeedsAttention: ["Needs attention", "Requiere atención", "Braucht Aufmerksamkeit"],
        MoveLeft: ["Move left", "Mover a la izquierda", "Nach links"],
        MoveRight: ["Move right", "Mover a la derecha", "Nach rechts"],
        AddCard: ["Add a card", "Agregar tarjeta", "Karte hinzufügen"],
        Customize: ["Customize", "Personalizar", "Anpassen"],
        // ---- Statistics v2: categories ----
        CategoryTime: ["Time", "Tiempo", "Zeit"],
        CategoryJobs: ["Jobs", "Tareas", "Aufträge"],
        CategoryMovement: ["Movement", "Movimiento", "Bewegung"],
        CategoryPlaces: ["Places", "Lugares", "Orte"],
        CategoryForms: ["Forms", "Formularios", "Formulare"],
        CategoryPeople: ["People", "Personas", "Personen"],
        CategoryTimeHint: ["Timesheet · working hours", "Hoja de horas · horario laboral", "Stempeluhr · Arbeitszeiten"],
        CategoryPlacesHint: ["Visits and check-ins", "Visitas y check-ins", "Besuche und Check-ins"],
        CategoryMovementHint: ["Trips, stops, site and travel time", "Viajes, paradas, tiempo en sitio y de viaje", "Fahrten, Stopps, Vor-Ort- und Fahrzeit"],
        ByDay: ["By day", "Por día", "Nach Tag"],
        ByMember: ["By member", "Por miembro", "Nach Mitglied"],
        ByTeam: ["By team", "Por equipo", "Nach Team"],
        AllocationTravel: ["Travel", "Viaje", "Fahrt"],
        AllocationPause: ["Pause", "Pausa", "Pause"],
        AllocationJobs: ["At jobs", "En tareas", "Bei Aufträgen"],
        AllocationPlaces: ["At places", "En lugares", "An Orten"],
        AllocationElsewhere: ["Elsewhere", "En otro sitio", "Anderswo"],
        AllocationNoLocation: ["No location", "Sin ubicación", "Kein Standort"],
        AllocationNotAtPlaces: ["Not at places", "Fuera de los lugares", "Nicht an Orten"],
        AllocationClocked: ["Clocked", "Registrado", "Gestempelt"],
        ByWeek: ["By week", "Por semana", "Nach Woche"],
        ByMonth: ["By month", "Por mes", "Nach Monat"],
        CsvByDay: ["CSV by day", "CSV por día", "CSV nach Tag"],
        CsvByWeek: ["CSV by week", "CSV por semana", "CSV nach Woche"],
        CsvByMonth: ["CSV by month", "CSV por mes", "CSV nach Monat"],
        CsvDay: ["Day", "Día", "Tag"],
        CsvWeekOf: ["Week of", "Semana del", "Woche ab"],
        CsvMonth: ["Month", "Mes", "Monat"],
        // ---- Statistics v2: header ----
        PeriodToday: ["Today", "Hoy", "Heute"],
        PeriodThisWeek: ["This week", "Esta semana", "Diese Woche"],
        PeriodThisMonth: ["This month", "Este mes", "Dieser Monat"],
        PeriodLast30: ["30 days", "30 días", "30 Tage"],
        CompareWith: ["Compare with", "Comparar con", "Vergleiche mit"],
        CompareYesterday: ["yesterday", "ayer", "gestern"],
        AllTeams: ["All teams", "Todos los equipos", "Alle Teams"],
        AllMembers: ["All members", "Todos los miembros", "Alle Mitglieder"],
        ExportMembersCsv: ["Export members as CSV", "Exportar miembros como CSV", "Mitglieder als CSV exportieren"],
        ScheduleWeeklyReport: ["Schedule a recurring report", "Programar un informe recurrente", "Wiederkehrenden Bericht planen"],
        WeeklyDigestEmail: ["Email \"Needs attention\" every Monday", "Enviar \"Requiere atención\" por correo cada lunes", "\"Braucht Aufmerksamkeit\" jeden Montag per E-Mail"],
        WeeklyDigestEmailHelp: ["Goes to the company account and all admins.", "Se envía a la cuenta de la empresa y a todos los administradores.", "Geht an das Firmenkonto und alle Admins."],
        // ---- Statistics v2: templates ----
        TemplateFieldService: ["Field service", "Servicio de campo", "Außendienst"],
        TemplateHomeCare: ["Home care", "Cuidado a domicilio", "Pflege zu Hause"],
        TemplateSecurity: ["Security", "Seguridad", "Sicherheit"],
        TemplateSales: ["Sales", "Ventas", "Vertrieb"],
        TemplateDelivery: ["Delivery", "Entregas", "Lieferung"],
        TemplateCleaning: ["Cleaning", "Limpieza", "Reinigung"],
        TemplateAttendance: ["Attendance only", "Solo asistencia", "Nur Anwesenheit"],
        // ---- Statistics v2: attention panel ----
        AttentionMoreNames: ["{0} +{1}", "{0} +{1}", "{0} +{1}"],
        AttentionMoreDays: ["{0} and {1} more", "{0} y {1} más", "{0} und {1} weitere"],
        AttentionPeopleOf: ["{0} of {1} people", "{0} de {1} personas", "{0} von {1} Personen"],
        AttentionPeopleCount: ["{0} people", "{0} personas", "{0} Personen"],
        AttentionOccurrences: ["{0} times", "{0} veces", "{0} Mal"],
        AttentionAffectedDays: ["Affected days", "Días afectados", "Betroffene Tage"],
        AttentionLikelyCause: ["Likely cause", "Causa probable", "Wahrscheinliche Ursache"],
        AttentionHiddenRules: ["{0} hidden · show", "{0} ocultos · mostrar", "{0} ausgeblendet · anzeigen"],
        AttentionAllClear: ["Nothing needs attention", "Nada requiere atención", "Nichts braucht Aufmerksamkeit"],
        AttentionAllClearHint: ["No missing data or unusual values in this period.", "Sin datos faltantes ni valores inusuales en este período.", "Keine fehlenden Daten oder ungewöhnlichen Werte in diesem Zeitraum."],
        AttentionAllClearMuted: ["Nothing to show. Some rules are hidden.", "Nada que mostrar. Algunas reglas están ocultas.", "Nichts anzuzeigen. Einige Regeln sind ausgeblendet."],
        AttentionBaselineBuilding: ["Comparisons with each person's usual values appear after a few days of history.", "Las comparaciones con los valores habituales de cada persona aparecen tras unos días de historial.", "Vergleiche mit den üblichen Werten jeder Person erscheinen nach ein paar Tagen Verlauf."],
        AttentionCauseIosWhileInUse: ["The iPhone allows location \"While Using\" only. Hellotracks can't record trips in the background until it is set to \"Always\".", "El iPhone permite la ubicación solo \"Al usar la app\". Hellotracks no puede registrar viajes en segundo plano hasta que esté en \"Siempre\".", "Das iPhone erlaubt den Standort nur \"Beim Verwenden\". Hellotracks kann keine Fahrten im Hintergrund aufzeichnen, bis \"Immer\" eingestellt ist."],
        AttentionCauseBackgroundOff: ["Background location is off on the phone. Trips are only recorded while the app is open.", "La ubicación en segundo plano está desactivada en el teléfono. Los viajes solo se registran con la app abierta.", "Der Hintergrund-Standort ist auf dem Telefon aus. Fahrten werden nur bei geöffneter App aufgezeichnet."],
        AttentionMissingClockOut: ["{0} has {1} missing clock-out(s)", "{0} tiene {1} salida(s) sin registrar", "Bei {0} fehlt {1}-mal das Ausstempeln"],
        AttentionMissingClockOutReason: ["On {0}. Clocked time for those days is unreliable.", "El {0}. El tiempo registrado de esos días no es confiable.", "Am {0}. Die gestempelte Zeit dieser Tage ist unzuverlässig."],
        AttentionImplausibleDay: ["{0} has a clocked day of {1}", "{0} tiene un día registrado de {1}", "{0} hat einen Stempeltag von {1}"],
        AttentionImplausibleDayReason: ["On {0}. Almost certainly a missing clock-out.", "El {0}. Casi seguro falta una salida.", "Am {0}. Fast sicher fehlt ein Ausstempeln."],
        AttentionJobsNoLocation: ["{0} had jobs scheduled on {1} but no location was recorded", "{0} tenía tareas el {1} pero no se registró ubicación", "{0} hatte am {1} Aufträge, aber es wurde kein Standort aufgezeichnet"],
        AttentionJobsNoLocationReason: ["The app may have been closed or location turned off on those days.", "La app pudo estar cerrada o la ubicación desactivada esos días.", "Die App war an diesen Tagen vielleicht geschlossen oder der Standort aus."],
        AttentionShiftNoClockIn: ["{0} had a scheduled shift on {1} but did not clock in", "{0} tenía turno el {1} pero no registró la entrada", "{0} hatte am {1} eine geplante Schicht, hat aber nicht eingestempelt"],
        AttentionShiftNoClockInReason: ["No trips were recorded on those days either.", "Tampoco se registraron viajes esos días.", "An diesen Tagen wurden auch keine Fahrten aufgezeichnet."],
        AttentionJobNoForm: ["{0} completed {1} job(s) without the required form", "{0} completó {1} tarea(s) sin el formulario requerido", "{0} hat {1} Auftrag/Aufträge ohne das erforderliche Formular erledigt"],
        AttentionJobNoFormReason: ["The job expects a form on completion.", "La tarea requiere un formulario al completarse.", "Der Auftrag erfordert beim Abschluss ein Formular."],
        AttentionVisitNoCheckin: ["{0} visited {1} place(s) without checking in", "{0} visitó {1} lugar(es) sin hacer check-in", "{0} hat {1} Ort(e) ohne Check-in besucht"],
        AttentionVisitNoCheckinReason: ["Detected from location on {0}.", "Detectado por ubicación el {0}.", "Per Standort erkannt am {0}."],
        AttentionTrackingGap: ["{0} had {1} tracking gap(s) longer than 2 hours while clocked in", "{0} tuvo {1} hueco(s) de seguimiento de más de 2 horas durante la jornada", "{0} hatte {1} Tracking-Lücke(n) von über 2 Stunden während der Stempelzeit"],
        AttentionTrackingGapReason: ["On {0}. The phone may have been off or the app closed.", "El {0}. El teléfono pudo estar apagado o la app cerrada.", "Am {0}. Das Telefon war vielleicht aus oder die App geschlossen."],
        AttentionJobIssues: ["{0} reported {1} job(s) with issues", "{0} reportó {1} tarea(s) con incidencias", "{0} hat {1} Auftrag/Aufträge mit Problemen gemeldet"],
        AttentionJobIssuesReason: ["Open the jobs to see what went wrong.", "Abre las tareas para ver qué pasó.", "Öffne die Aufträge, um zu sehen, was schiefging."],
        AttentionLateArrivals: ["{0} arrived late to {1}% of jobs with a time window ({2} jobs)", "{0} llegó tarde al {1}% de las tareas con ventana horaria ({2} tareas)", "{0} kam bei {1}% der Aufträge mit Zeitfenster zu spät ({2} Aufträge)"],
        AttentionLateArrivalsReason: ["More than 10 minutes after the time window started.", "Más de 10 minutos después del inicio de la ventana horaria.", "Mehr als 10 Minuten nach Beginn des Zeitfensters."],
        AttentionLowSiteTime: ["{0}'s site time dropped to {1} per day, down from the usual {2}", "El tiempo en sitio de {0} bajó a {1} por día, frente a los {2} habituales", "Die Vor-Ort-Zeit von {0} fiel auf {1} pro Tag, sonst {2}"],
        AttentionHighPause: ["{0}'s pause time is {1} per day, usually {2}", "El tiempo de pausa de {0} es {1} por día, normalmente {2}", "Die Pausenzeit von {0} liegt bei {1} pro Tag, sonst {2}"],
        AttentionHighTravel: ["{0}'s travel time is {1} per day, usually {2}", "El tiempo de viaje de {0} es {1} por día, normalmente {2}", "Die Fahrzeit von {0} liegt bei {1} pro Tag, sonst {2}"],
        AttentionHighDistance: ["{0} drove {1} per day, usually {2}", "{0} condujo {1} por día, normalmente {2}", "{0} fuhr {1} pro Tag, sonst {2}"],
        AttentionBaselineOwn: ["Compared with this person's previous four weeks. Worth a conversation, not a conclusion.", "Comparado con las cuatro semanas anteriores de esta persona. Vale una conversación, no una conclusión.", "Verglichen mit den letzten vier Wochen dieser Person. Ein Anlass für ein Gespräch, kein Urteil."],
        AttentionBaselineTeam: ["Compared with the team's median this period.", "Comparado con la mediana del equipo en este período.", "Verglichen mit dem Median des Teams in diesem Zeitraum."],
        AttentionLowActivity: ["{0} was active on {1} of {2} working days", "{0} estuvo activo {1} de {2} días laborables", "{0} war an {1} von {2} Arbeitstagen aktiv"],
        AttentionLowActivityReason: ["Fine for part-timers. Hide this rule for them if so.", "Normal para tiempo parcial. Oculta esta regla para ellos si es el caso.", "Bei Teilzeit normal. Blende die Regel dann für diese Person aus."],
        AttentionDevicePermission: ["{0}'s phone can't record trips in the background", "El teléfono de {0} no puede registrar viajes en segundo plano", "Das Telefon von {0} kann keine Fahrten im Hintergrund aufzeichnen"],
        AttentionGroupMissingClockOut: ["{0} people have missing clock-outs ({1} in total)", "{0} personas tienen salidas sin registrar ({1} en total)", "{0} Personen haben fehlende Ausstempelungen ({1} insgesamt)"],
        AttentionGroupMissingClockOutReason: ["Clocked time for those days is unreliable until fixed.", "El tiempo registrado de esos días no es confiable hasta corregirlo.", "Die gestempelte Zeit dieser Tage ist unzuverlässig, bis es korrigiert ist."],
        AttentionGroupImplausibleDay: ["{0} people have clocked days longer than 16 hours", "{0} personas tienen días registrados de más de 16 horas", "{0} Personen haben Stempeltage über 16 Stunden"],
        AttentionGroupImplausibleDayReason: ["Almost certainly missing clock-outs. Their averages are unreliable until fixed.", "Casi seguro faltan salidas. Sus promedios no son confiables hasta corregirlo.", "Fast sicher fehlende Ausstempelungen. Die Durchschnitte sind bis zur Korrektur unzuverlässig."],
        AttentionGroupJobsNoLocation: ["{0} people had jobs scheduled on days without any location", "{0} personas tenían tareas en días sin ubicación", "{0} Personen hatten Aufträge an Tagen ohne Standort"],
        AttentionGroupShiftNoClockIn: ["{0} people had scheduled shifts without a clock-in", "{0} personas tenían turnos sin registrar la entrada", "{0} Personen hatten geplante Schichten ohne Einstempeln"],
        AttentionGroupJobNoForm: ["{1} people completed {0} jobs without the required form", "{1} personas completaron {0} tareas sin el formulario requerido", "{1} Personen haben {0} Aufträge ohne das erforderliche Formular erledigt"],
        AttentionGroupVisitNoCheckin: ["{0} place visits had no check-in ({1} people)", "{0} visitas a lugares sin check-in ({1} personas)", "{0} Ortsbesuche ohne Check-in ({1} Personen)"],
        AttentionGroupVisitNoCheckinReason: ["Detected from location.", "Detectado por ubicación.", "Per Standort erkannt."],
        AttentionGroupTrackingGap: ["{0} people had tracking gaps while clocked in ({1} gaps)", "{0} personas tuvieron huecos de seguimiento durante la jornada ({1} huecos)", "{0} Personen hatten Tracking-Lücken während der Stempelzeit ({1} Lücken)"],
        AttentionGroupTrackingGapReason: ["Gaps longer than 2 hours without any location.", "Huecos de más de 2 horas sin ubicación.", "Lücken von über 2 Stunden ohne Standort."],
        AttentionGroupJobIssues: ["{0} jobs with issues reported by {1} people", "{0} tareas con incidencias reportadas por {1} personas", "{0} Aufträge mit Problemen, gemeldet von {1} Personen"],
        AttentionGroupLateArrivals: ["{0} people arrived late to more than 5% of their jobs", "{0} personas llegaron tarde a más del 5% de sus tareas", "{0} Personen kamen bei mehr als 5% ihrer Aufträge zu spät"],
        AttentionGroupLowSiteTime: ["{0} people spent far less time on site than usual", "{0} personas pasaron mucho menos tiempo en sitio de lo habitual", "{0} Personen waren deutlich kürzer vor Ort als sonst"],
        AttentionGroupHighPause: ["{0} people paused far more than usual", "{0} personas pausaron mucho más de lo habitual", "{0} Personen hatten deutlich mehr Pause als sonst"],
        AttentionGroupHighTravel: ["{0} people traveled far more than usual", "{0} personas viajaron mucho más de lo habitual", "{0} Personen fuhren deutlich länger als sonst"],
        AttentionGroupHighDistance: ["{0} people drove far more than usual", "{0} personas condujeron mucho más de lo habitual", "{0} Personen fuhren deutlich weiter als sonst"],
        AttentionGroupLowActivity: ["{0} people were active on fewer than half of the working days", "{0} personas estuvieron activas menos de la mitad de los días laborables", "{0} Personen waren an weniger als der Hälfte der Arbeitstage aktiv"],
        AttentionGroupDevicePermission: ["{0} phones can't record trips in the background", "{0} teléfonos no pueden registrar viajes en segundo plano", "{0} Telefone können keine Fahrten im Hintergrund aufzeichnen"],
        AttentionGroupDevicePermissionReason: ["Location permission is limited. Trips are probably missing.", "El permiso de ubicación es limitado. Probablemente faltan viajes.", "Die Standortberechtigung ist eingeschränkt. Fahrten fehlen wahrscheinlich."],
        AttentionSilentPlace: ["{0} has had no visit for {1} days", "{0} lleva {1} días sin visitas", "{0} hatte seit {1} Tagen keinen Besuch"],
        AttentionSilentPlaceNever: ["{0} has never been visited", "{0} nunca ha sido visitado", "{0} wurde noch nie besucht"],
        AttentionSilentPlaceReason: ["No member stopped there. Check whether the place is still in use.", "Ningún miembro se detuvo allí. Comprueba si el lugar sigue en uso.", "Kein Mitglied hat dort gehalten. Prüfe, ob der Ort noch genutzt wird."],
        AttentionGroupSilentPlace: ["{0} places without a visit for {1}+ days", "{0} lugares sin visitas desde hace {1}+ días", "{0} Orte seit {1}+ Tagen ohne Besuch"],
        AttentionPlaceCount: ["{0} places", "{0} lugares", "{0} Orte"],
        AttentionNeverVisited: ["never visited", "nunca visitado", "nie besucht"],
        AttentionDaysWithoutVisit: ["{0} days", "{0} días", "{0} Tage"],
        ActionOpenPlace: ["Open place", "Abrir lugar", "Ort öffnen"],
        ActionShowPlaceOnMap: ["Show on map", "Ver en el mapa", "Auf Karte zeigen"],
        ActionShow: ["Show", "Ver", "Anzeigen"],
        ActionOpenTimesheet: ["Open timesheet", "Abrir hoja de horas", "Stempeluhr öffnen"],
        ActionShowJobs: ["Show jobs", "Ver tareas", "Aufträge anzeigen"],
        ActionOpenDay: ["Open {0}", "Abrir {0}", "{0} öffnen"],
        ActionShowLocation: ["Show location history", "Ver historial de ubicación", "Standortverlauf anzeigen"],
        ActionSendReminder: ["Send setup reminder", "Enviar recordatorio de configuración", "Einrichtungs-Erinnerung senden"],
        ActionOpenMember: ["Open member", "Abrir miembro", "Mitglied öffnen"],
        ActionHideFor: ["Hide for {0}", "Ocultar para {0}", "Für {0} ausblenden"],
        ActionHideRule: ["Hide this rule", "Ocultar esta regla", "Diese Regel ausblenden"],
        AttentionReminderMessage: ["Please check your Hellotracks app settings: location must be allowed \"Always\" and background location switched on so your trips are recorded.", "Revisa la configuración de la app Hellotracks: la ubicación debe estar en \"Siempre\" y la ubicación en segundo plano activada para registrar tus viajes.", "Bitte prüfe deine Hellotracks-App-Einstellungen: Standort muss auf \"Immer\" stehen und der Hintergrund-Standort eingeschaltet sein, damit deine Fahrten aufgezeichnet werden."],
        AttentionReminderSent: ["Reminder sent to the member's app.", "Recordatorio enviado a la app del miembro.", "Erinnerung an die App des Mitglieds gesendet."],
        AttentionReminderSentShort: ["Reminder sent", "Recordatorio enviado", "Erinnerung gesendet"],

        // ---- Statistics v2: People table, column picker, customize drawer ----
        // ------------------------------------------------------------ table
        Attention: ["Attention", "Atención", "Aufmerksamkeit"],
        ActiveOnly: ["Active only", "Solo activos", "Nur aktive"],
        IncludeInactive: ["Include inactive", "Incluir inactivos", "Inaktive einbeziehen"],
        GroupByTeam: ["Group by team", "Agrupar por equipo", "Nach Team gruppieren"],
        NoTeam: ["No team", "Sin equipo", "Kein Team"],
        TeamTotal: ["Team total", "Total del equipo", "Team gesamt"],
        ShowAllN: ["Show all {0}", "Mostrar los {0}", "Alle {0} anzeigen"],
        ShowingRows: ["{0} of {1}", "{0} de {1}", "{0} von {1}"],
        SparkTrailing: ["Last {0} days", "Últimos {0} días", "Letzte {0} Tage"],
        TodaySoFar: ["Today so far", "Hoy hasta ahora", "Heute bisher"],
        ExpandTile: ["Show details", "Ver detalles", "Details anzeigen"],
        CollapseTile: ["Hide details", "Ocultar detalles", "Details ausblenden"],
        ExportCsv: ["Export CSV", "Exportar CSV", "CSV exportieren"],
        SortBy: ["Sort by {0}", "Ordenar por {0}", "Nach {0} sortieren"],
        OpenMember: ["Open {0}", "Abrir {0}", "{0} öffnen"],
        AttentionCount: ["{0} to look at", "{0} por revisar", "{0} zum Anschauen"],
        // ---------------------------------------------------------- places
        PlaceHeader: ["Place", "Lugar", "Ort"],
        Visits: ["Visits", "Visitas", "Besuche"],
        Visitors: ["Visitors", "Visitantes", "Besucher"],
        MedianOnSite: ["Median on site", "Mediana en sitio", "Median vor Ort"],
        TotalOnSite: ["Total on site", "Total en sitio", "Gesamt vor Ort"],
        LastVisit: ["Last visit", "Última visita", "Letzter Besuch"],
        FewVisitsTag: ["n < 5", "n < 5", "n < 5"],
        FewVisitsHint: ["Fewer than 5 visits: listed, not ranked", "Menos de 5 visitas: se muestra, no se clasifica", "Weniger als 5 Besuche: gelistet, nicht gerankt"],
        SilentForDays: ["No visit for {0} days", "Sin visitas desde hace {0} días", "Seit {0} Tagen kein Besuch"],
        SilentNever: ["No visit in 90 days", "Sin visitas en 90 días", "Kein Besuch in 90 Tagen"],
        PlacesBaselineBuilding: ["Past days are still being prepared. Numbers fill in within a few minutes.", "Los días anteriores aún se están preparando. Los números se completan en unos minutos.", "Vergangene Tage werden noch aufbereitet. Die Zahlen füllen sich in wenigen Minuten."],
        SilentListEmpty: ["Every active place had a recent visit.", "Todos los lugares activos tuvieron una visita reciente.", "Jeder aktive Ort hatte kürzlich einen Besuch."],
        SearchPlaces: ["Search places", "Buscar lugares", "Orte suchen"],
        ExportPlacesCsv: ["Export places as CSV", "Exportar lugares como CSV", "Orte als CSV exportieren"],
        ExportFormsCsv: ["Export forms as CSV", "Exportar formularios como CSV", "Formulare als CSV exportieren"],
        ShowVisits: ["Show visits on the map", "Ver visitas en el mapa", "Besuche auf der Karte zeigen"],
        OpenPlace: ["Open {0}", "Abrir {0}", "{0} öffnen"],
        NoPlaceVisits: ["No place visits in this period.", "Sin visitas a lugares en este período.", "Keine Ortsbesuche in diesem Zeitraum."],
        UnknownPlace: ["Unknown place", "Lugar desconocido", "Unbekannter Ort"],
        // ----------------------------------------------------------- forms
        FormHeader: ["Form", "Formulario", "Formular"],
        Submissions: ["Submissions", "Envíos", "Einsendungen"],
        Submitters: ["Submitted by", "Enviado por", "Eingesendet von"],
        LastSubmission: ["Last submission", "Último envío", "Letzte Einsendung"],
        SearchForms: ["Search forms", "Buscar formularios", "Formulare suchen"],
        OpenForm: ["Open {0}", "Abrir {0}", "{0} öffnen"],
        NoFormSubmissions: ["No form submissions in this period.", "Sin envíos de formularios en este período.", "Keine Formular-Einsendungen in diesem Zeitraum."],
        UnknownForm: ["Deleted form", "Formulario eliminado", "Gelöschtes Formular"],
        // ---------------------------------------------------------- visits
        MetricVisitLength: ["Visit length", "Duración de la visita", "Besuchsdauer"],
        MetricVisitLengthHelp: ["Time from check-in to check-out, per job. A manual check-in in the app takes priority over GPS.", "Tiempo entre el check-in y el check-out de cada tarea. Un check-in manual en la app tiene prioridad sobre el GPS.", "Zeit vom Check-in bis zum Check-out pro Auftrag. Ein manueller Check-in in der App hat Vorrang vor GPS."],
        VisitMiddleHalf: ["Middle half {0} – {1}", "Mitad central {0} – {1}", "Mittlere Hälfte {0} – {1}"],
        VisitCount: ["{0} visits", "{0} visitas", "{0} Besuche"],
        VisitMedian: ["Median", "Mediana", "Median"],
        VisitMiddle: ["Middle half", "Mitad central", "Mittlere Hälfte"],
        VisitUnder: ["Under {0}", "Menos de {0}", "Unter {0}"],
        VisitOver: ["Over {0}", "Más de {0}", "Über {0}"],
        VisitUnderHint: ["Drive-bys and accidental manual check-ins. In the bars, not in the median.", "Pasadas de largo y check-ins por error. Están en las barras, no en la mediana.", "Vorbeifahrten und versehentliche Check-ins. In den Balken, nicht im Median."],
        VisitOverHint: ["Most likely a forgotten check-out. In the bars, not in the median.", "Seguramente un check-out olvidado. Está en las barras, no en la mediana.", "Meist ein vergessener Check-out. In den Balken, nicht im Median."],
        VisitOpen: ["No check-out yet", "Sin check-out aún", "Noch kein Check-out"],
        VisitSource: ["{0} manual · {1} GPS", "{0} manuales · {1} por GPS", "{0} manuell · {1} per GPS"],
        VisitCountedBy: ["Counted by", "Registrado por", "Erfasst per"],
        VisitAllTypes: ["All types", "Todos los tipos", "Alle Typen"],
        VisitJobType: ["Job type", "Tipo de tarea", "Auftragstyp"],
        VisitByType: ["By job type", "Por tipo de tarea", "Nach Auftragstyp"],
        VisitByPlace: ["By place", "Por lugar", "Nach Ort"],
        VisitRange: ["{0} – {1}", "{0} – {1}", "{0} – {1}"],
        VisitRangeOpen: ["{0} and more", "{0} o más", "{0} und mehr"],
        VisitBarTip: ["{0} visits · {1}", "{0} visitas · {1}", "{0} Besuche · {1}"],
        VisitBarOpen: ["Click to see these jobs", "Haz clic para ver estas tareas", "Klicke, um diese Aufträge zu sehen"],
        VisitFilterLabel: ["Visits {0}", "Visitas {0}", "Besuche {0}"],
        VisitFilterCapped: ["Visits {0} (newest {1} of {2})", "Visitas {0} (las {1} más recientes de {2})", "Besuche {0} (neueste {1} von {2})"],
        VisitAxis: ["Time from check-in to check-out", "Tiempo entre check-in y check-out", "Zeit vom Check-in bis zum Check-out"],
        VisitPrevLegend: ["Outline: previous period", "Contorno: período anterior", "Umriss: vorheriger Zeitraum"],
        VisitFewer: ["{0} more with fewer than 5 visits", "{0} más con menos de 5 visitas", "{0} weitere mit weniger als 5 Besuchen"],
        VisitPartial: ["Earlier days are still being counted. This updates by itself.", "Aún se están contando los días anteriores. Se actualiza solo.", "Frühere Tage werden noch gezählt. Das aktualisiert sich von selbst."],
        VisitEmpty: ["No job with a check-in and a check-out in this period.", "Ninguna tarea con check-in y check-out en este período.", "Kein Auftrag mit Check-in und Check-out in diesem Zeitraum."],
        VisitNoType: ["No type", "Sin tipo", "Ohne Typ"],
        VisitNoPlace: ["No place", "Sin lugar", "Ohne Ort"],
        VisitRowOpen: ["Open {0}'s jobs", "Abrir las tareas de {0}", "Aufträge von {0} öffnen"],
        // --------------------------------------------------------- columns
        Columns: ["Columns", "Columnas", "Spalten"],
        ShownColumns: ["Shown · drag to reorder", "Mostradas · arrastra para ordenar", "Angezeigt · zum Sortieren ziehen"],
        MoreColumns: ["More columns", "Más columnas", "Weitere Spalten"],
        NotOnYourPlan: ["Not on your plan", "No incluido en tu plan", "Nicht in deinem Plan"],
        NotInUse: ["Not in use", "Sin uso", "Nicht in Verwendung"],
        // ----------------------------------------------------------- views
        ViewLabel: ["View: {0}", "Vista: {0}", "Ansicht: {0}"],
        DefaultView: ["Default", "Predeterminada", "Standard"],
        SaveCurrentAsView: ["Save current as view…", "Guardar como vista…", "Aktuelle als Ansicht speichern…"],
        ViewNamePlaceholder: ["View name", "Nombre de la vista", "Name der Ansicht"],
        // ---------------------------------------------------------- drawer
        AddACard: ["Add a card", "Agregar una tarjeta", "Karte hinzufügen"],
        SearchMetrics: ["Search metrics", "Buscar métricas", "Kennzahlen suchen"],
        StartFromTemplate: ["Start from a template", "Empezar desde una plantilla", "Mit einer Vorlage starten"],
        StartedFrom: [
            "Started from: {0}, based on how you use Hellotracks",
            "Punto de partida: {0}, según cómo usas Hellotracks",
            "Ausgangspunkt: {0}, basierend darauf, wie du Hellotracks nutzt",
        ],
        Add: ["Add", "Agregar", "Hinzufügen"],
        AlreadyOnBoard: ["Already on your board", "Ya está en tu tablero", "Bereits auf deinem Board"],
        NotInUseYet: ["Not in use yet", "Aún sin uso", "Noch nicht in Verwendung"],
        AvailableOnDispatch: ["Available on the Dispatch plan", "Disponible en el plan Dispatch", "Verfügbar im Dispatch-Plan"],
        HintTimesheet: ["Start clocking in from the app", "Empieza a registrar la entrada desde la app", "Fang an, dich in der App einzustempeln"],
        HintJobs: ["Create your first job", "Crea tu primera tarea", "Erstelle deinen ersten Auftrag"],
        HintPlaces: ["Add places", "Agrega lugares", "Orte hinzufügen"],
        HintCheckins: ["Enable check-ins", "Activa los check-ins", "Check-ins aktivieren"],
        HintForms: ["Create a form", "Crea un formulario", "Erstelle ein Formular"],
        HintWorkinghours: ["Set working hours for members", "Define horarios de trabajo para los miembros", "Lege Arbeitszeiten für Mitglieder fest"],
        HintTeams: ["Create teams", "Crea equipos", "Teams erstellen"],
        HintTracks: ["Location tracking is off", "El seguimiento de ubicación está desactivado", "Standort-Tracking ist aus"],
        ResetToTemplate: ["Reset to template", "Restablecer plantilla", "Auf Vorlage zurücksetzen"],
        UseAsCompanyDefault: ["Use as company default", "Usar como predeterminado de la empresa", "Als Firmenstandard verwenden"],
        CompanyDefaultSaved: ["Saved as company default", "Guardado como predeterminado de la empresa", "Als Firmenstandard gespeichert"],
        PerformanceStats: ["Performance", "Rendimiento", "Leistung"],
        TimeStats: ["Time", "Tiempo", "Zeit"],
        DistributionStats: ["Breakdowns", "Desgloses", "Aufschlüsselungen"],
        ActiveMembers: ["Active members", "Miembros activos", "Aktive Mitglieder"],
        ActiveMembersHelp: [
            "Members with at least one active day in the selected range.",
            "Miembros con al menos un día activo en el rango seleccionado.",
            "Mitglieder mit mindestens einem aktiven Tag im gewählten Zeitraum.",
        ],
        ActiveDays: ["Active days", "Días activos", "Aktive Tage"],
        ActiveDaysHelp: [
            "A day counts when the member has clocked time, distance, stops, jobs, site time, travel time, pause time, or trips.",
            "Un día cuenta si el miembro tiene tiempo registrado, distancia, paradas, tareas, tiempo en sitio, viaje, pausa o viajes.",
            "Ein Tag zählt, wenn das Mitglied gestempelte Zeit, Strecke, Stopps, Aufträge, Vor-Ort-Zeit, Reisezeit, Pausenzeit oder Fahrten hat.",
        ],
        ClockedDays: ["Clocked days", "Días registrados", "Stempeltage"],
        ClockedDaysHelp: [
            "Days with at least one clock-in or clock-out entry.",
            "Días con al menos un registro de entrada o salida.",
            "Tage mit mindestens einem Einstempeln oder Ausstempeln.",
        ],
        AvgClockIn: ["Avg clock-in", "Entrada prom.", "Durchschn. Einstempeln"],
        AvgClockInSummaryHelp: [
            "Average first clock-in time across all clocked member-days.",
            "Promedio de la primera entrada en todos los días registrados de miembros.",
            "Durchschnittliche erste Einstempelzeit über alle Stempeltage der Mitglieder.",
        ],
        AvgClockOut: ["Avg clock-out", "Salida prom.", "Durchschn. Ausstempeln"],
        AvgClockOutSummaryHelp: [
            "Average last clock-out time across all clocked member-days.",
            "Promedio de la última salida en todos los días registrados de miembros.",
            "Durchschnittliche letzte Ausstempelzeit über alle Stempeltage der Mitglieder.",
        ],
        TotalClockedTime: ["Total clocked time", "Tiempo registrado total", "Gesamte Stempelzeit"],
        TimesheetEntries: ["Entries", "Entradas", "Einträge"],
        TotalStops: ["Stops", "Paradas", "Stopps"],
        AvgDistancePerActiveDayHelp: [
            "Total team distance divided by all active member-days.",
            "Distancia total del equipo dividida por todos los días activos de miembros.",
            "Gesamte Teamstrecke geteilt durch alle aktiven Mitgliedstage.",
        ],
        AvgStopsPerActiveDayHelp: [
            "Merged job, place, and stationary stops divided by all active member-days. Shows 0 until the new data is available.",
            "Paradas fusionadas de tareas, lugares y estacionarias divididas por todos los días activos. Muestra 0 hasta que los nuevos datos estén disponibles.",
            "Zusammengeführte Auftrags-, Orts- und Standstopps geteilt durch alle aktiven Mitgliedstage. Zeigt 0, bis die neuen Daten verfügbar sind.",
        ],
        AvgSiteTimePerActiveDayHelp: [
            "Job onsite time plus place onsite time, divided by all active member-days.",
            "Tiempo en tareas más tiempo en lugares, dividido por todos los días activos de miembros.",
            "Zeit bei Aufträgen plus Zeit an Orten, geteilt durch alle aktiven Mitgliedstage.",
        ],
        AvgTravelTimePerActiveDayHelp: [
            "Total travel time from trips, divided by all active member-days.",
            "Tiempo total de viaje de los viajes, dividido por todos los días activos de miembros.",
            "Gesamte Reisezeit aus Fahrten, geteilt durch alle aktiven Mitgliedstage.",
        ],
        AvgPauseTimePerActiveDayHelp: [
            "Total pause or stationary time, divided by all active member-days.",
            "Tiempo total de pausa o estacionario, dividido por todos los días activos de miembros.",
            "Gesamte Pausen- oder Standzeit, geteilt durch alle aktiven Mitgliedstage.",
        ],
        JobCompletionRateHelp: [
            "Completed jobs divided by completed, canceled, and failed jobs.",
            "Tareas completadas divididas por tareas completadas, canceladas y fallidas.",
            "Erledigte Aufträge geteilt durch erledigte, stornierte und fehlgeschlagene Aufträge.",
        ],
        DistancePerDay: ["Distance / day", "Distancia / día", "Strecke / Tag"],
        StopsPerDay: ["Stops / day", "Paradas / día", "Stopps / Tag"],
        SiteTimePerDay: ["Site time / day", "Tiempo en sitio / día", "Vor-Ort-Zeit / Tag"],
        TravelTimePerDay: ["Travel time / day", "Viaje / día", "Reisezeit / Tag"],
        PauseTimePerDay: ["Pause / day", "Pausa / día", "Pause / Tag"],
        JobsHelp: [
            "Total jobs assigned to this member in the selected range.",
            "Total de tareas asignadas a este miembro en el rango seleccionado.",
            "Alle diesem Mitglied im gewählten Zeitraum zugewiesenen Aufträge.",
        ],
        MissingClockOuts: ["Missing outs", "Salidas faltantes", "Fehlende Ausst."],
        MissingClockOutsHelp: [
            "Clock-ins in the selected range that do not have a matching clock-out.",
            "Entradas en el rango seleccionado que no tienen una salida correspondiente.",
            "Einstempelungen im gewählten Zeitraum ohne passende Ausstempelung.",
        ],
        CompletionRate: ["Done %", "% hecho", "Erledigt %"],
        TotalMembers: ['Members', 'Miembros', 'Mitglieder'],
        TotalAssignedJobs: ['Total assigned jobs', 'Total de tareas asignadas', 'Insgesamt zugewiesene Aufträge'],
        MaxSpeed: ["Max speed", "Velocidad máxima", "Max. Geschw."],
        AvgSpeed: ["Avg speed", "Velocidad promedio", "Durchschn. Geschw."],
        OnTime: ["On time", "A tiempo", "Pünktlich"],
        Delays: ["Delays", "Retrasos", "Verzögerungen"],
        Engagement: ["Engagement", "Compromiso", "Engagement"],
        Table: ["Table", "Tabla", "Tabelle"],
        AccumulatedTimeBetweenJobs: [
            "Total time between jobs",
            "Tiempo acumulado entre tareas",
            "Summierte Zeit zw. Aufträgen",
        ],
        AvgTimeBetweenJobs: [
            "Average time between jobs",
            "Tiempo promedio entre tareas",
            "Durchschn. Zeit zw. Aufträgen",
        ],
        AvgTimeAtJobSites: [
            "Average time at job sites",
            "Tiempo promedio en lugares de tarea",
            "Durchschnittliche Zeit an Aufträgen",
        ],
        TimeAtJob: ["Time at jobs", "Tiempo en tareas", "Zeit bei Aufträgen"],
        TimeAtPlace: ["Time at places", "Tiempo en lugares", "Zeit an Orten"],
        TravelTime: ["Travel time", "Tiempo de viaje", "Reisezeit"],
        Pause: ["Pause", "Pausa", "Pause"],
        TravelAndPauseTime: [
            "Travel and pause time",
            "Tiempo de viaje y pausa",
            "Reise- und Pausenzeit"
        ],
        AccumulatedOnsiteTimeByDate: [
            "Total onsite time by date",
            "Tiempo acumulado en el sitio por fecha",
            "Summierte Vor-Ort-Zeit nach Datum"
        ],
        JobPerformanceByDate: [
            "Job performance by date",
            "Rendimiento de tarea por fecha",
            "Auftragsperformance nach Datum"
        ],
        TotalJobOnsite: ["Total job onsite", "Total en tareas", "Summ. bei Auftrag"],
        AvgJobOnsite: ["Avg job onsite", "Promedio en tareas", "Durchschn. bei Auftrag"],
        TotalPlaceOnsite: ["Total place onsite", "Total en lugares", "Zeit an Orten gesamt"],
        AvgPlaceOnsite: ["Avg place onsite", "Promedio en lugares", "Ø Zeit an Orten"],
        TotalPause: ["Total pause", "Total de pausa", "Gesamte Pause"],
        AvgPause: ["Avg pause", "Pausa promedio", "Durchschn. Pause"],
        AvgTravelTime: ["Avg travel time", "Promedio de viaje", "Durchschn. Reisezeit"],
        TotalTravelTime: ["Total travel time", "Tiempo total de viaje", "Gesamte Reisezeit"],
        SuccessRate: ["Success rate", "Tasa de éxito", "Erfolgsrate"],
        IssueRate: ["Issue rate", "Tasa de problemas", "Problemrate"],
        TotalTimeAtJobs: ["Total time at jobs", "Tiempo total en las tareas", "Gesamtzeit aller Aufträge"],
        TotalDistanceTravelled: ["Total distance driven", "Distancia total recorrida", "Gesamtfahrstrecke"],
        JobTypes: ["Job types", "Tipos de tarea", "Auftragstypen"],
        JobTeams: ["Job teams", "Equipos por tarea", "Teams für Aufträge"],
    },
    Onboard: {
        ScheduleDemo: [
            "Schedule a demo",
            "Programar una demo",
            "Demo vereinbaren",
        ]
    },
    Signup: {
        Title: [
            "Sign up for Hellotracks",
            "Regístrate en Hellotracks",
            "Bei Hellotracks registrieren",
        ],
        ClientsDescription: [
            "Trusted by thousands of teams worldwide",
            "Miles de equipos en todo el mundo confían en Hellotracks",
            "Tausende Teams weltweit vertrauen Hellotracks",
        ],
        HaveAccount: [
            "Already have an account?",
            "¿Ya tienes una cuenta?",
            "Hast du bereits ein Konto?",
        ],
        SignIn: [
            "Log in",
            "Inicia sesión",
            "Anmelden",
        ],
        Continue: [
            "Continue",
            "Continuar",
            "Weiter",
        ],
        Description: [
            "How should we greet you?",
            "¿Cómo deberíamos saludarte?",
            "Wie sollen wir dich begrüßen?",
        ],
        EmailPlaceholder: [
            "This will be your login",
            "Este será tu inicio de sesión",
            "Damit meldest du dich an",
        ],
        Back: [
            "Back",
            "Atrás",
            "Zurück",
        ],
        CreateAccount: [
            "Create account",
            "Crear cuenta",
            "Konto erstellen",
        ],
        EstimatedUsersTitle: [
            "Estimated number of users in Hellotracks",
            "Número estimado de usuarios en Hellotracks",
            "Geschätzte Anzahl von Nutzern in Hellotracks",
        ],
        IndustryTitle: [
            "Please select your industry",
            "Por favor, selecciona tu industria",
            "Bitte wähle deine Branche",
        ],
        IndustryRepairMaintenance: [
            "Repair & maintenance",
            "Reparación y mantenimiento",
            "Reparatur und Instandhaltung",
        ],
        IndustryMobilityAndTransportation: [
            "Mobility and transportation",
            "Movilidad y transporte",
            "Mobilität und Transport",
        ],
        IndustryPublicSector: [
            "Public sector",
            "Sector público",
            "Öffentlicher Sektor",
        ],
        IndustryLogisticsDistribution: [
            "Logistics & distribution",
            "Logística y distribución",
            "Logistik & Vertrieb",
        ],
        Other: [
            "Other...",
            "Otra...",
            "Andere...",
        ],
        RoleTitle: [
            "What best describes your role?",
            "¿Qué opción describe mejor tus funciones?",
            "Was beschreibt deine Rolle am besten?",
        ],
        RoleOperationsmanagerDirector: [
            "Operations manager/director",
            "Gerente de operaciones",
            "Betriebsleiter/Direktor",
        ],
        RoleFieldStaffManagerDispatcher: [
            "Field staff manager/dispatcher",
            "Gerente del personal de campo",
            "Außendienstleiter/Disponent",
        ],
        RoleDeveloperItConsultant: [
            "Developer / IT consultant",
            "Consultor(a) de IT o desarrollador(a)",
            "Entwickler/IT-Berater",
        ],
        RoleHr: [
            "HR",
            "Recursos humanos",
            "HR",
        ],
        RoleEntrepreneurOwner: [
            "Entrepreneur / owner",
            "Emprendedor(a) o dueño(a)",
            "Unternehmer",
        ],
        FindusTitle: [
            "How did you find us?",
            "¿Cómo nos encontraste?",
            "Wie hast du uns gefunden?",
        ],
        FindusGoogleSearch: [
            "Google Search",
            "Búsqueda en Google",
            "Google-Suche",
        ],
        FindusFacebook: [
            "Facebook",
            "Facebook",
            "Facebook",
        ],
        FindusLinkedin: [
            "LinkedIn",
            "LinkedIn",
            "LinkedIn",
        ],
        FindusSoftwareMarketPlace: [
            "Software marketplace",
            "Marketplace de software",
            "Software-Marktplatz",
        ],
        FindusReferral: [
            "Referral",
            "Recomendación",
            "Empfehlung",
        ],
        GoalTitle: [
            "What is the #1 goal you would like to achieve?",
            "¿Cuál es el objetivo #1 que te gustaría lograr?",
            "Was ist dein wichtigstes Ziel?",
        ],
        TeamSizeQuestion: ["How many people are in the field?", "¿Cuántas personas trabajan en campo?", "Wie viele Personen sind im Außendienst?"],
        Optional: ["optional", "opcional", "optional"],
        TailorTitle: ["Help us tailor Hellotracks", "Ayúdanos a adaptar Hellotracks", "Hilf uns, Hellotracks anzupassen"],
        TailorDesc: ["Two quick questions, about 10 seconds.", "Dos preguntas rápidas, unos 10 segundos.", "Zwei kurze Fragen, etwa 10 Sekunden."],
        NotNow: ["Not now", "Ahora no", "Nicht jetzt"],
        ThanksForAnswers: ["Thanks, that helps!", "¡Gracias, eso ayuda!", "Danke, das hilft!"],
        GoalLiveLocation: [
            "Access real-time location of my field staff.",
            "Acceder a la ubicación en tiempo real de mi personal en campo.",
            "Zugriff auf den Echtzeit-Standort meiner Außendienstmitarbeiter.",
        ],
        GoalCheckins: [
            "Automatically register arrivals, departures and total onsite time.",
            "Registrar automáticamente las llegadas, salidas y el tiempo total en el sitio.",
            "Automatisches Registrieren von Ankünften, Abfahrten und der Gesamtaufenthaltszeit.",
        ],
        GoalLocationHistory: [
            "Access to mileage, location history, total distance and stops.",
            "Acceder al kilometraje, historial de ubicaciones, distancia total y paradas.",
            "Zugriff auf Kilometer, Standortverlauf, Gesamtdistanz und Stopps.",
        ],
        GoalDispatch: [
            "Optimize job dispatch and assignment.",
            "Optimizar la asignación y el despacho de tareas.",
            "Optimierung der Auftragszuweisung/-verteilung.",
        ],
        GoalData: [
            "Accurately retrieve service-related data.",
            "Obtener datos precisos del servicio.",
            "Abrufen von dienstbezogenen Daten.",
        ],
        EmailAlreadyUsed: [
            "This email address is already being used",
            "Este correo ya está registrado.",
            "Diese E-Mail-Adresse wird bereits verwendet",
        ],
        SomethingWentWrong: [
            "Something went wrong, please try again.",
            "Algo salió mal. Por favor, vuelve a intentarlo.",
            "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
        ],
        PasswordStrongPassword: [
            "Your password is strong ✅",
            "Tu contraseña es fuerte ✅",
            "Dein Passwort ist stark ✅"
        ],
        PasswordNoWhitespace: [
            "Cannot contain spaces",
            "No debe contener espacios",
            "Darf keine Leerzeichen enthalten"
        ],
        Password8Chars: [
            "At least 8 characters",
            "Al menos 8 caracteres",
            "Mindestens 8 Zeichen"
        ],
        PasswordLowerCase: [
            "Include lowercase letters or use a longer password",
            "Debe contener caracteres en minúscula o usar una contraseña más larga",
            "Kleinbuchstaben verwenden oder ein längeres Passwort wählen"
        ],
        PasswordUpperCase: [
            "Include uppercase letters or use a longer password",
            "Debe contener caracteres en mayúscula o usar una contraseña más larga",
            "Großbuchstaben verwenden oder ein längeres Passwort wählen"
        ],
        PasswordNumber: [
            "Include a number or use a longer password",
            "Debe contener un número o usar una contraseña más larga",
            "Eine Zahl verwenden oder ein längeres Passwort wählen"
        ],
        FormTitle: [
            "Start your free 30-day trial",
            "Inicia tu prueba gratuita de 30 días",
            "Starte deine kostenlose 30-Tage-Testversion",
        ],
        NoCardNeeded: [
            "No credit card needed.",
            "Sin tarjeta de crédito.",
            "Keine Kreditkarte nötig.",
        ],
        YourName: ["Your name", "Tu nombre", "Dein Name"],
        WorkEmail: ["Work email", "Correo electrónico de trabajo", "Geschäftliche E-Mail"],
        Rule8Chars: ["8+ characters", "8+ caracteres", "8+ Zeichen"],
        RuleCase: ["Upper and lower case", "Mayúsculas y minúsculas", "Groß- und Kleinbuchstaben"],
        RuleNumber: ["A number", "Un número", "Eine Zahl"],
        RuleOr12: [
            "or 12+ characters of any kind",
            "o 12+ caracteres de cualquier tipo",
            "oder 12+ beliebige Zeichen",
        ],
        ResetPassword: ["Reset password", "Restablecer contraseña", "Passwort zurücksetzen"],
        TermsContinue: [
            "By continuing you agree to the {0} and {1}.",
            "Al continuar aceptas los {0} y la {1}.",
            "Wenn du fortfährst, stimmst du den {0} und der {1} zu.",
        ],
        TermsOfService: ["Terms of Service", "Términos de servicio", "Nutzungsbedingungen"],
        PrivacyPolicy: ["Privacy Policy", "Política de privacidad", "Datenschutzerklärung"],
        PanelLive: [
            "See your whole team live on one map",
            "Ve a todo tu equipo en vivo en un solo mapa",
            "Sieh dein ganzes Team live auf einer Karte",
        ],
        PanelJobs: [
            "Dispatch jobs and get proof of every visit",
            "Asigna tareas y obtén una prueba de cada visita",
            "Disponiere Aufträge und erhalte einen Nachweis für jeden Besuch",
        ],
        PanelReports: [
            "Timesheets and mileage without paperwork",
            "Hojas de horas y kilometraje sin papeleo",
            "Stundenzettel und Kilometer ohne Papierkram",
        ],
        PanelQuote: [
            "“Hellotracks has been very easy to implement and it’s helped us to better manage our field staff, improve asset recovery and improve overall field operations through real-time visibility.”",
            "“Hellotracks fue muy fácil de implementar y nos ha ayudado a gestionar mejor a nuestro personal de campo, recuperar más activos y mejorar toda la operación en campo gracias a la visibilidad en tiempo real.”",
            "„Hellotracks war sehr einfach einzuführen und hilft uns, unser Außendienstteam besser zu steuern, mehr Assets zurückzuholen und den gesamten Außendienst durch Echtzeit-Sichtbarkeit zu verbessern.“",
        ],
        WatchIntro: ["Watch the 3-minute intro", "Mira la intro de 3 minutos", "3-Minuten-Intro ansehen"],
        ContinueWithGoogle: [
            "Continue with Google",
            "Continuar con Google",
            "Weiter mit Google",
        ],
        BackToDesktop: [
            "Back to the desktop app",
            "Volver a la app de escritorio",
            "Zurück zur Desktop-App",
        ],
        DesktopDesc: [
            "Click to continue with Google. You'll then be redirected to the desktop app.",
            "Haz clic para continuar con Google, después serás redirigido a la aplicación de escritorio.",
            "Klicke, um mit Google fortzufahren, du wirst anschließend zur Desktop-App weitergeleitet.",
        ],
        BackToWebsite: [
            "Back to website",
            "Volver al sitio web",
            "Zurück zur Website",
        ],
    },
    LateJobs: {
        ArrivingOne: ["1 job arriving late", "1 tarea llegará tarde", "1 Auftrag kommt zu spät"],
        ArrivingX: ["{0} jobs arriving late", "{0} tareas llegarán tarde", "{0} Aufträge kommen zu spät"],
        MissedOne: ["1 window missed", "1 ventana horaria perdida", "1 Zeitfenster verpasst"],
        MissedX: ["{0} windows missed", "{0} ventanas horarias perdidas", "{0} Zeitfenster verpasst"],
        ShowOnDispatch: [
            "Show them on Dispatch, filtered to Late",
            "Mostrarlas en Despacho, filtradas por Con retraso",
            "Auf der Disposition zeigen, gefiltert nach Verspätet",
        ],
    },
    CoDispatch: {
        ShowPanel: ["Show Co-Dispatch beside the map", "Mostrar Co-Dispatch junto al mapa", "Co-Dispatch neben der Karte anzeigen"],
        Hide: ["Hide", "Ocultar", "Ausblenden"],
        LastCheckedX: ["Last checked {0}", "Última revisión {0}", "Zuletzt geprüft {0}"],
    },
    Audio: {
        StartRecordingAudioTranscript: [
            "Start recording audio transcript",
            "Comenzar a grabar la transcripción de audio",
            "Beginne mit der Aufzeichnung des Audio-Transkripts",
        ],
        StopRecording: [
            "Stop recording",
            "Detener la grabación",
            "Aufnahme beenden",
        ],
        GrantMicPermission: [
            "Please grant permission to use the mic",
            "Por favor, permite usar el micrófono",
            "Bitte erlaube die Benutzung des Mikrofons"
        ]
    },
    Timesheet: {
        NewEntry: [
            "New timesheet entry",
            "Nuevo registro de hoja de tiempo",
            "Neue Zeiteintragung"
        ],
    },
    Activities: {
        ActivityLog: [
            "Activity log",
            "Registro de actividad",
            "Aktivitätsprotokoll",
        ],
        ActivityLogDesc: [
            "What happened in the field, one day at a time",
            "Lo que pasó en el campo, día a día",
            "Was draußen passiert ist, Tag für Tag",
        ],
        Activity: [
            "Activity",
            "Actividad",
            "Aktivität"
        ],
        SearchActivity: [
            "Search people, places, jobs",
            "Buscar personas, lugares, tareas",
            "Personen, Orte, Aufträge suchen",
        ],
        Kind: ["Kind", "Tipo", "Art"],
        Person: ["Person", "Persona", "Person"],
        Team: ["Team", "Equipo", "Team"],
        Place: ["Place", "Lugar", "Ort"],
        NoTeam: ["No team", "Sin equipo", "Kein Team"],
        AlertX: ["Alert “{0}”", "Alerta «{0}»", "Alarm „{0}“"],
        XPeople: ["{0} people", "{0} personas", "{0} Personen"],
        WasAtX: ["was at {0}", "estuvo en {0}", "war bei {0}"],
        AtZoneEdgeX: ["was at the edge of zone {0}", "estuvo en el borde de la zona {0}", "war am Rand der Zone {0}"],
        XMin: ["{0} min", "{0} min", "{0} Min."],
        RoutineHidden: [
            "Routine updates hidden: {0}",
            "Novedades rutinarias ocultas: {0}",
            "Ausgeblendete Routine-Meldungen: {0}",
        ],
        RoutineHint: [
            "logins, tracking on, phone status",
            "inicios de sesión, seguimiento activado, estado del teléfono",
            "Anmeldungen, Tracking an, Handystatus",
        ],
        ShowRoutine: ["Show", "Mostrar", "Anzeigen"],
        HideRoutine: ["Hide routine updates", "Ocultar novedades rutinarias", "Routine-Meldungen ausblenden"],
        Loading: ["Loading the day…", "Cargando el día…", "Tag wird geladen…"],
        NoActivity: [
            "Nothing was logged on this day.",
            "No se registró nada este día.",
            "An diesem Tag wurde nichts protokolliert.",
        ],
        NothingMatches: [
            "Nothing matches. Try another kind or clear the search.",
            "Nada coincide. Prueba otro tipo o borra la búsqueda.",
            "Nichts passt. Probier eine andere Art oder leere die Suche.",
        ],
        LoadFailed: ["This day couldn't be loaded.", "No se pudo cargar este día.", "Dieser Tag konnte nicht geladen werden."],
        TryAgain: ["Try again", "Volver a intentar", "Nochmal versuchen"],
        BackToActivity: ["Back to the activity", "Volver a la actividad", "Zurück zur Aktivität"],
        OpenPerson: ["Open {0}", "Abrir {0}", "{0} öffnen"],
        XNew: ["{0} new", "{0} nuevas", "{0} neue"],
        BeforeAndAfter: ["Before and after · {0}", "Antes y después · {0}", "Davor und danach · {0}"],
        People: ["People", "Personas", "Personen"],
        ShowOnMap: ["Show on map", "Ver en el mapa", "Auf der Karte zeigen"],
        OpenJob: ["Open job", "Abrir tarea", "Auftrag öffnen"],
        OpenPlace: ["Open place", "Abrir lugar", "Ort öffnen"],
        MessageX: ["Message {0}", "Escribir a {0}", "{0} schreiben"],
        NoPosition: [
            "No position with this activity",
            "Esta actividad no tiene posición",
            "Zu dieser Aktivität gibt es keine Position",
        ],
        PhonePosition: ["Where the phone was", "Dónde estaba el teléfono", "Wo das Handy war"],
        AtThePlace: ["At the place", "En el lugar", "Am Ort"],
        RuleX: ["Rule: {0}", "Regla: {0}", "Regel: {0}"],
        OpenActivityLog: ["Open activity log", "Abrir registro de actividad", "Aktivitätsprotokoll öffnen"],
        ActivityHere: ["All activity here", "Toda la actividad aquí", "Alle Aktivitäten hier"],
        Export: ["Export", "Exportar", "Exportieren"],
        Latitude: ["Latitude", "Latitud", "Breitengrad"],
        Longitude: ["Longitude", "Longitud", "Längengrad"],
        PhoneTrackingOff: ["turned tracking off", "desactivó el seguimiento", "hat das Tracking ausgeschaltet"],
        PhoneTrackingOn: ["turned tracking on", "activó el seguimiento", "hat das Tracking eingeschaltet"],
        PhoneLocationOff: ["turned the phone's location off", "desactivó la ubicación del teléfono", "hat den Standort am Handy ausgeschaltet"],
        PhoneLocationOn: ["turned the phone's location on", "activó la ubicación del teléfono", "hat den Standort am Handy eingeschaltet"],
        PhoneLoggedIn: ["logged in", "inició sesión", "hat sich angemeldet"],
        PhoneLoggedOut: ["logged out", "cerró sesión", "hat sich abgemeldet"],
        PhoneBatterySaverOn: ["turned battery saver on", "activó el ahorro de batería", "hat den Energiesparmodus eingeschaltet"],
        PhoneBatterySaverOff: ["turned battery saver off", "desactivó el ahorro de batería", "hat den Energiesparmodus ausgeschaltet"],
        PhoneBatterySaverNote: ["tracks may be rough", "el recorrido puede salir impreciso", "Strecken können ungenau werden"],
        PhoneStatusX: ["set the status “{0}”", "puso el estado «{0}»", "hat den Status „{0}“ gesetzt"],
        PhoneAppStopped: ["App stopped on the phone", "La app se cerró en el teléfono", "App auf dem Handy beendet"],
        PhoneAppBack: ["App running again", "La app vuelve a funcionar", "App läuft wieder"],
        PhoneBatteryLow: ["Battery low", "Batería baja", "Akku fast leer"],
        PhoneBatteryOk: ["Battery okay again", "La batería vuelve a estar bien", "Akku wieder in Ordnung"],
        PhoneRebooted: ["Phone restarted", "El teléfono se reinició", "Handy neu gestartet"],
        PhoneLocatingOff: ["Location service didn't start", "El servicio de ubicación no arrancó", "Ortungsdienst nicht gestartet"],
        PhoneLocatingBack: ["Location service running again", "El servicio de ubicación vuelve a funcionar", "Ortungsdienst läuft wieder"],
    },
    LiveNotifications: {
        Notifications: ["Notifications", "Notificaciones", "Benachrichtigungen"],
        NeedsALook: ["Needs a look", "Para revisar", "Zu prüfen"],
        Activity: ["Activity", "Actividad", "Aktivität"],
        Empty: [
            "Alerts and updates from your team show up here.",
            "Aquí aparecen las alertas y novedades de tu equipo.",
            "Hier erscheinen Alarme und Neuigkeiten aus deinem Team.",
        ],
        Settings: ["Notification settings", "Configuración de notificaciones", "Benachrichtigungen einstellen"],
        SettingsSaved: [
            "Saved in this browser. Everything stays in the activity log.",
            "Se guarda en este navegador. Todo sigue en el registro de actividad.",
            "Gilt für diesen Browser. Im Aktivitätsprotokoll bleibt alles erhalten.",
        ],
        SettingsSnoozed: [
            "Pop-ups are snoozed, so for now everything except alerts goes to the bell.",
            "Los avisos están en silencio, así que por ahora todo menos las alertas va a la campana.",
            "Einblendungen sind pausiert, darum landet gerade alles außer Alarmen in der Glocke.",
        ],
        Back: ["Back", "Volver", "Zurück"],
        LanePopup: ["Pop up", "Aviso", "Einblenden"],
        LaneBell: ["Bell", "Campana", "Glocke"],
        LaneOff: ["Off", "Apagado", "Aus"],
        KindAlert: ["Alerts", "Alertas", "Alarme"],
        KindAlertHelp: ["From your alert rules", "De tus reglas de alerta", "Aus deinen Alarmregeln"],
        KindTrackingOff: [
            "Tracking or location turned off",
            "Seguimiento o ubicación desactivados",
            "Tracking oder Standort ausgeschaltet",
        ],
        KindTrackingOffHelp: [
            "Pops up only while the person still has jobs today",
            "Solo avisa si la persona aún tiene tareas hoy",
            "Wird nur eingeblendet, wenn die Person heute noch Aufträge hat",
        ],
        KindJob: ["Job status, check-ins and trips to jobs", "Estado, check-ins y viajes a las tareas", "Auftragsstatus, Check-ins und Fahrten zu Aufträgen"],
        KindPlaceVisit: ["Check-ins at places", "Check-ins en lugares", "Check-ins an Orten"],
        KindOther: ["Other updates", "Otras novedades", "Weitere Neuigkeiten"],
        KindOtherHelp: [
            "Low battery, accepted invitations",
            "Batería baja, invitaciones aceptadas",
            "Akku fast leer, angenommene Einladungen",
        ],
        KindRoutine: [
            "Drives, ETA updates, logins and phone status",
            "Trayectos, actualizaciones de ETA, inicios de sesión y estado del teléfono",
            "Fahrten, ETA-Updates, Anmeldungen und Handystatus",
        ],
        InLastMinutes: ["in the last {0} min", "en los últimos {0} min", "in den letzten {0} Min."],
        NamesAndOthers: ["{0} and {1} more", "{0} y {1} más", "{0} und {1} weitere"],
        CheckIns: ["Check-ins {0}", "Check-ins {0}", "Check-ins {0}"],
        CheckOuts: ["Check-outs {0}", "Check-outs {0}", "Check-outs {0}"],
        BellOnly: ["Show these in the bell only", "Mostrar solo en la campana", "Nur noch in der Glocke zeigen"],
        MovedToBell: [
            "From now on, “{0}” only goes to the bell.",
            "A partir de ahora, «{0}» solo va a la campana.",
            "Ab jetzt landet „{0}“ nur noch in der Glocke.",
        ],
        SinceOpened: [
            "Since you opened the web dashboard",
            "Desde que abriste el panel web",
            "Seit du das Web-Dashboard geöffnet hast",
        ],
        MinutesAgo: ["{0} min ago", "hace {0} min", "vor {0} Min."],
        ShowAll: ["Show all {0}", "Mostrar los {0}", "Alle {0} anzeigen"],
        ShowLess: ["Show less", "Mostrar menos", "Weniger anzeigen"],
    },
    PlacesList: {
        ScopeNew: ['New this week', 'Nuevos esta semana', 'Neu diese Woche'],
        AddedAgo: ['added {0}', 'agregado {0}', 'hinzugefügt {0}'],
        Title: ['Places', 'Lugares', 'Orte'],
        ZonesTitle: ['Zones', 'Zonas', 'Zonen'],
        ScopeAll: ['All', 'Todos', 'Alle'],
        ScopeToday: ['Visited today', 'Visitados hoy', 'Heute besucht'],
        ScopeAttention: ['Needs attention', 'Requieren atención', 'Braucht Aufmerksamkeit'],
        ScopeSilent: ['No visit in 30 days', 'Sin visitas en 30 días', '30 Tage kein Besuch'],
        ScopeUnvisited: ['No visit in 90 days', 'Sin visitas en 90 días', '90 Tage kein Besuch'],
        SearchPlaceholder: ['Search name, address or custom field', 'Busca nombre, dirección o campo propio', 'Name, Adresse oder eigenes Feld suchen'],
        ColName: ['Name', 'Nombre', 'Name'],
        ColStatus: ['Status', 'Estado', 'Status'],
        ColVisits: ['Visits 30 d', 'Visitas 30 d', 'Besuche 30 T.'],
        ColTeams: ['Visible to', 'Visible para', 'Sichtbar für'],
        HereOne: ['{0} here', '{0} aquí', '{0} ist hier'],
        HereMany: ['{0} people here', '{0} personas aquí', '{0} Leute hier'],
        VisitedToday: ['Visited today', 'Visitado hoy', 'Heute besucht'],
        VisitedTodayVisits: ['{0} visits', '{0} visitas', '{0} Besuche'],
        LastVisit: ['Last visit', 'Última visita', 'Letzter Besuch'],
        NoVisitSince: ['No visit since {0}', 'Sin visitas desde {0}', 'Kein Besuch seit {0}'],
        NoVisit90: ['No visit in 90 days', 'Sin visitas en 90 días', 'Seit 90 Tagen kein Besuch'],
        CauseNoLocation: ['No location', 'Sin ubicación', 'Kein Standort'],
        CauseSameName: ['Same name nearby', 'Mismo nombre cerca', 'Gleicher Name in der Nähe'],
        CauseSameSpot: ['Same spot, other name', 'Mismo punto, otro nombre', 'Gleiche Stelle, anderer Name'],
        CauseTwinAt: ['{0}, {1}', '{0}, {1}', '{0}, {1}'],
        CauseNameRepeated: ['Name used more than once', 'Nombre repetido', 'Name mehrfach vergeben'],
        CauseNameRepeatedDetail: ['{0} places', '{0} lugares', '{0} Orte'],
        CauseInvisible: ['Workers can’t see it', 'Los trabajadores no lo ven', 'Mitarbeiter sehen ihn nicht'],
        CauseInvisibleDetail: ['no team', 'sin equipo', 'kein Team'],
        CauseRadius: ['Radius won’t check in', 'El radio no registra llegadas', 'Radius löst keinen Check-in aus'],
        HintNoLocation: [
            'The place has no position, so nobody can check in and jobs there have no pin.',
            'El lugar no tiene posición, así que nadie puede registrar su llegada y las tareas allí no tienen marcador.',
            'Der Ort hat keine Position, deshalb kann niemand einchecken und Aufträge dort haben keinen Pin.',
        ],
        HintSameName: [
            'Same or similar name within {0}. Visits and jobs are split between the two, so neither looks right in Statistics.',
            'Nombre igual o parecido a menos de {0}. Las visitas y tareas se reparten entre los dos, así que ninguno cuadra en Estadísticas.',
            'Gleicher oder ähnlicher Name innerhalb von {0}. Besuche und Aufträge verteilen sich auf beide, deshalb stimmt keiner in der Statistik.',
        ],
        HintSameSpot: [
            'Different names at the very same position, often one place entered twice. If they really are two places, like two shops in one building, leave them.',
            'Nombres distintos exactamente en la misma posición, muchas veces el mismo lugar creado dos veces. Si de verdad son dos lugares, como dos tiendas en el mismo edificio, déjalos así.',
            'Verschiedene Namen an genau derselben Position, oft derselbe Ort doppelt angelegt. Wenn es wirklich zwei Orte sind, etwa zwei Läden im selben Gebäude, lass sie so.',
        ],
        HintNameRepeated: [
            'Places in different spots share this name, so in lists, pickers and reports nobody can tell which one is meant. Add the street or area to the name.',
            'Lugares en sitios distintos comparten este nombre, así que en listas, selectores e informes nadie sabe cuál es cuál. Agrega la calle o la zona al nombre.',
            'Orte an verschiedenen Stellen haben denselben Namen, deshalb weiß in Listen, Auswahlfeldern und Berichten niemand, welcher gemeint ist. Ergänze die Straße oder das Viertel im Namen.',
        ],
        HintInvisible: [
            'Workers only see their team’s places, and these have no team. On the phone they don’t exist.',
            'Los trabajadores solo ven los lugares de su equipo, y estos no tienen equipo. En el teléfono no existen.',
            'Mitarbeiter sehen nur die Orte ihres Teams, und diese haben kein Team. In der App gibt es sie nicht.',
        ],
        HintRadius: [
            'A radius of 0 never checks in on the server, and over {0} never checks in at all.',
            'Un radio de 0 nunca registra llegadas en el servidor, y más de {0} nunca registra nada.',
            'Ein Radius von 0 löst auf dem Server nie einen Check-in aus, über {0} nie.',
        ],
        FindByAddress: ['Find {0} by address', 'Buscar {0} por dirección', '{0} über die Adresse finden'],
        AddToTeam: ['Add to team…', 'Agregar a equipo…', 'Einem Team zuordnen…'],
        SetRadius100: ['Set to {0}', 'Poner {0}', 'Auf {0} setzen'],
        ShowMore: ['Show {0} more', 'Mostrar {0} más', '{0} weitere anzeigen'],
        Select: ['Select {0}', 'Seleccionar {0}', '{0} auswählen'],
        Done: ['Done', 'Hecho', 'Erledigt'],
        ShowOnMap: ['Show on map', 'Mostrar en el mapa', 'Auf der Karte zeigen'],
        ToFix: ['{0} to fix', '{0} por arreglar', '{0} zu beheben'],
        FixShowBoth: ['Show both', 'Ver los dos', 'Beide zeigen'],
        AddZoneAlert: ['Add an alert for this zone…', 'Agregar una alerta para esta zona…', 'Alarm für diese Zone anlegen…'],
        ZoneAlertTitle: ['Arrives at {0}', 'Llegada a {0}', 'Ankunft in {0}'],
        OnlyTheseX: ['These {0} places', 'Estos {0} lugares', 'Diese {0} Orte'],
        FixRename: ['Rename', 'Renombrar', 'Umbenennen'],
        FixPickTeams: ['Pick teams', 'Elegir equipos', 'Teams wählen'],
        FixSetLocation: ['Set location', 'Definir ubicación', 'Standort festlegen'],
        FixChangeRadius: ['Change radius', 'Cambiar radio', 'Radius ändern'],
        Export: ['Export', 'Exportar', 'Exportieren'],
        CountPlaces: ['{0} places', '{0} lugares', '{0} Orte'],
        CountToday: ['{0} visited today', '{0} visitados hoy', '{0} heute besucht'],
        CountHere: ['{0} with someone there now', '{0} con alguien ahora', '{0} gerade mit jemandem vor Ort'],
        MapShowing: ['Map shows {0} of {1}', 'El mapa muestra {0} de {1}', 'Karte zeigt {0} von {1}'],
        Nothing: ['No places match.', 'Ningún lugar coincide.', 'Kein Ort passt.'],
        LoadingList: ['Loading places…', 'Cargando lugares…', 'Orte werden geladen…'],
        LoadingZones: ['Loading zones…', 'Cargando zonas…', 'Zonen werden geladen…'],
        AttentionNone: ['Every place can check in and workers can see it.', 'Todos los lugares registran llegadas y los trabajadores los ven.', 'Jeder Ort funktioniert für Check-ins und ist für Mitarbeiter sichtbar.'],
        VisitsTitle: ['Visits · last 30 days', 'Visitas · últimos 30 días', 'Besuche · letzte 30 Tage'],
        StatVisits: ['visits', 'visitas', 'Besuche'],
        StatPeople: ['people', 'personas', 'Leute'],
        StatMedian: ['median stay', 'estancia mediana', 'mittlere Dauer'],
        StatDays: ['days with a visit', 'días con visita', 'Tage mit Besuch'],
        DayVisits: ['{0} visits', '{0} visitas', '{0} Besuche'],
        DayOneVisit: ['1 visit', '1 visita', '1 Besuch'],
        DayNoVisits: ['No visits', 'Sin visitas', 'Keine Besuche'],
        DayOnSite: ['{0} on site', '{0} en el sitio', '{0} vor Ort'],
        WhoCame: ['Who came', 'Quién vino', 'Wer da war'],
        NoVisitsYet: ['No visits in the last 30 days.', 'Sin visitas en los últimos 30 días.', 'In den letzten 30 Tagen keine Besuche.'],
        VisitsLoading: ['Loading visits…', 'Cargando visitas…', 'Besuche werden geladen…'],
        Radius: ['Radius', 'Radio', 'Radius'],
        VisibleTo: ['Visible to', 'Visible para', 'Sichtbar für'],
        EveryWorker: ['Every worker', 'Todos los trabajadores', 'Alle Mitarbeiter'],
        EveryWorkerSeesAll: ['Every worker sees every place. This is a company setting.', 'Todos los trabajadores ven todos los lugares. Es una configuración de la empresa.', 'Alle Mitarbeiter sehen alle Orte. Das ist eine Firmeneinstellung.'],
        NoWorker: ['No worker (no team)', 'Ningún trabajador (sin equipo)', 'Kein Mitarbeiter (kein Team)'],
        Forms: ['Forms', 'Formularios', 'Formulare'],
        Contact: ['Contact', 'Contacto', 'Kontakt'],
        CustomFields: ['Custom fields', 'Campos propios', 'Eigene Felder'],
        AllCheckins: ['All check-ins', 'Todos los check-ins', 'Alle Check-ins'],
        UseForNewPlaces: ['Use for new places', 'Usar en lugares nuevos', 'Für neue Orte verwenden'],
        VoizReports: ['Voiz reports', 'Informes Voiz', 'Voiz-Berichte'],
        Delete: ['Delete…', 'Eliminar…', 'Löschen…'],
        ZonesSearch: ['Search zones', 'Buscar zonas', 'Zonen suchen'],
        ColAssigned: ['Assigned', 'Asignada a', 'Zugewiesen'],
        ColUsedBy: ['Used by', 'Usada por', 'Genutzt von'],
        ColArea: ['Area', 'Área', 'Fläche'],
        NotAssigned: ['Not assigned', 'Sin asignar', 'Nicht zugewiesen'],
        UsedAlerts: ['{0} alerts', '{0} alertas', '{0} Alarme'],
        UsedAlertOne: ['1 alert', '1 alerta', '1 Alarm'],
        UsedDispatch: ['dispatch', 'despacho', 'Disposition'],
        UsedRestricts: ['restricts tracking', 'limita el seguimiento', 'begrenzt das Tracking'],
        NotUsed: ['Not used', 'Sin uso', 'Nicht genutzt'],
        Corners: ['{0} corners', '{0} vértices', '{0} Ecken'],
        ZonesScopeUnused: ['Not used', 'Sin uso', 'Nicht genutzt'],
        ZonesScopeRestricts: ['Restricts tracking', 'Limitan el seguimiento', 'Begrenzen das Tracking'],
        Shape: ['Shape', 'Forma', 'Form'],
        Color: ['Color', 'Color', 'Farbe'],
        Rename: ['Rename', 'Renombrar', 'Umbenennen'],
        Save: ['Save', 'Guardar', 'Speichern'],
        AssignedHint: [
            'Assigned people come first when auto-dispatch picks someone for a job in this zone. Unless workers see all zones, only assigned people see it on the phone.',
            'Las personas asignadas van primero cuando el despacho automático elige a alguien para una tarea en esta zona. Salvo que los trabajadores vean todas las zonas, solo las personas asignadas la ven en el teléfono.',
            'Zugewiesene Leute kommen zuerst dran, wenn die automatische Disposition jemanden für einen Auftrag in dieser Zone auswählt. Wenn Mitarbeiter nicht alle Zonen sehen, sehen nur Zugewiesene sie in der App.',
        ],
        AssignedHintLocation: [
            'Unless workers see all zones, only assigned people see it on the phone.',
            'Salvo que los trabajadores vean todas las zonas, solo las personas asignadas la ven en el teléfono.',
            'Wenn Mitarbeiter nicht alle Zonen sehen, sehen nur Zugewiesene sie in der App.',
        ],
        UsedByAlert: ['Alert “{0}”', 'Alerta «{0}»', 'Alarm „{0}“'],
        UsedByDispatch: ['Dispatch ranks assigned people first', 'El despacho prioriza a las personas asignadas', 'Disposition bevorzugt Zugewiesene'],
        UsedByRestricts: ['Tracking only inside company zones', 'Seguimiento solo dentro de las zonas de la empresa', 'Tracking nur innerhalb der Firmenzonen'],
        NothingUsesZone: ['No alert or setting uses this zone.', 'Ninguna alerta ni configuración usa esta zona.', 'Kein Alarm und keine Einstellung nutzt diese Zone.'],
        DeleteZoneTitle: ['Delete {0}', 'Eliminar {0}', '{0} löschen'],
        DeleteZoneUsed: [
            'This zone is used by {0}. Those stop working for this zone.',
            'Esta zona la usa: {0}. Dejarán de funcionar para esta zona.',
            'Diese Zone wird genutzt von: {0}. Das funktioniert für diese Zone dann nicht mehr.',
        ],
        DeleteZoneConfirm: ['Delete zone', 'Eliminar zona', 'Zone löschen'],
        NoZones: ['No zones yet. Draw one to use it in alerts and dispatch.', 'Todavía no hay zonas. Dibuja una para usarla en alertas y despacho.', 'Noch keine Zonen. Zeichne eine, um sie für Alarme und Disposition zu nutzen.'],
        AreaKm2: ['{0} km²', '{0} km²', '{0} km²'],
        AreaHa: ['{0} ha', '{0} ha', '{0} ha'],
        AreaMi2: ['{0} mi²', '{0} mi²', '{0} mi²'],
        AreaAcres: ['{0} acres', '{0} acres', '{0} acres'],
    },
    Roster: {
        ScopeAll: ['All', 'Todos', 'Alle'],
        ScopeAttention: ['Needs attention', 'Requieren atención', 'Braucht Aufmerksamkeit'],
        ScopeInvited: ['Invited', 'Invitados', 'Eingeladen'],
        ScopeInactive: ['Inactive 30 days', 'Inactivos 30 días', '30 Tage inaktiv'],
        ScopeStaff: ['Admins & operators', 'Admins y operadores', 'Admins & Disponenten'],
        SearchPlaceholder: ['Search name, email, team or skill', 'Busca nombre, correo, equipo o habilidad', 'Name, E-Mail, Team oder Skill suchen'],
        GroupNone: ['No grouping', 'Sin agrupar', 'Nicht gruppieren'],
        GroupTeam: ['Group by team', 'Agrupar por equipo', 'Nach Team gruppieren'],
        GroupRole: ['Group by role', 'Agrupar por rol', 'Nach Rolle gruppieren'],
        ColName: ['Name', 'Nombre', 'Name'],
        ColStatus: ['Status', 'Estado', 'Status'],
        ColRole: ['Role', 'Rol', 'Rolle'],
        ColTeams: ['Teams', 'Equipos', 'Teams'],
        ColLastSignal: ['Last signal', 'Última señal', 'Letztes Signal'],
        ColApp: ['App', 'App', 'App'],
        NoTeam: ['No team', 'Sin equipo', 'Kein Team'],
        Now: ['now', 'ahora', 'jetzt'],
        Never: ['never', 'nunca', 'nie'],
        Ago: ['{0} ago', 'hace {0}', 'vor {0}'],
        UnitMinutes: ['{0} min', '{0} min', '{0} Min.'],
        UnitHours: ['{0} h', '{0} h', '{0} Std.'],
        UnitDays: ['{0} d', '{0} d', '{0} Tg.'],
        UnitMonths: ['{0} mo', '{0} meses', '{0} Mon.'],
        StatusLocationOff: ['Location off', 'Ubicación desactivada', 'Standort aus'],
        StatusIosWhileUsing: ['iPhone set to “While using”', 'iPhone en «Cuando se use la app»', 'iPhone auf „Beim Verwenden der App“'],
        StatusBatterySaver: ['Battery saver on', 'Ahorro de batería activado', 'Energiesparmodus an'],
        StatusAppOutdated: ['App out of date', 'App desactualizada', 'App veraltet'],
        StatusAtJob: ['At job #{0}', 'En la tarea #{0}', 'Bei Auftrag #{0}'],
        StatusAt: ['At {0}', 'En {0}', 'Bei {0}'],
        StatusLastSeen: ['Last seen {0}', 'Visto {0}', 'Zuletzt aktiv {0}'],
        StatusInactive: ['No login for {0}', 'Sin conectarse desde hace {0}', 'Seit {0} nicht angemeldet'],
        StatusNoPhone: ['No phone connected', 'Sin teléfono conectado', 'Kein Handy verbunden'],
        CountMembers: ['{0} members', '{0} miembros', '{0} Mitglieder'],
        CountOnDuty: ['{0} on duty', '{0} en servicio', '{0} im Dienst'],
        CountOnTheWay: ['{0} on the way', '{0} en camino', '{0} unterwegs'],
        EmptyScope: ['Nobody here right now.', 'Nadie por aquí ahora mismo.', 'Gerade ist hier niemand.'],
        EmptySearch: ['Nobody matches “{0}”.', 'Nadie coincide con «{0}».', 'Niemand passt zu „{0}“.'],
        Open: ['Open', 'Abrir', 'Öffnen'],
        SelectAll: ['Select all', 'Seleccionar todos', 'Alle auswählen'],
        AppUpdateAvailable: ['A newer app version is available', 'Hay una versión más nueva de la app', 'Es gibt eine neuere App-Version'],
        PhoneSetup: ['Phone setup', 'Configuración del teléfono', 'Handy-Einrichtung'],
        SetupApp: ['App', 'App', 'App'],
        SetupLocationAccess: ['Location access', 'Acceso a la ubicación', 'Standortzugriff'],
        SetupBackground: ['Background location', 'Ubicación en segundo plano', 'Standort im Hintergrund'],
        SetupLocationServices: ['Location services', 'Servicios de ubicación', 'Ortungsdienste'],
        SetupBatterySaver: ['Battery saver', 'Ahorro de batería', 'Energiesparmodus'],
        SetupTracking: ['Tracking', 'Seguimiento', 'Tracking'],
        SetupLastSignal: ['Last signal', 'Última señal', 'Letztes Signal'],
        ValueOn: ['On', 'Activado', 'An'],
        ValueOff: ['Off', 'Desactivado', 'Aus'],
        ValueAlways: ['Always', 'Siempre', 'Immer'],
        ValueWhileUsing: ['While using', 'Cuando se use la app', 'Beim Verwenden'],
        ValueAllowed: ['Allowed', 'Permitido', 'Erlaubt'],
        ValueNotAllowed: ['Not allowed', 'No permitido', 'Nicht erlaubt'],
        HintBackground: [
            'Trips and check-ins stop while the app is closed. Location has to be set to “Allow all the time” in the phone’s settings.',
            'Los viajes y check-ins se detienen cuando la app está cerrada. La ubicación tiene que estar en «Permitir todo el tiempo» en la configuración del teléfono.',
            'Fahrten und Check-ins stoppen, sobald die App geschlossen ist. Der Standort muss in den Handy-Einstellungen auf „Immer zulassen“ stehen.',
        ],
        HintWhileUsing: [
            'iOS stops tracking in the background, so trips go missing even though the app looks fine. Location has to be set to “Always”.',
            'iOS deja de registrar en segundo plano, así que faltan viajes aunque la app parezca estar bien. La ubicación tiene que estar en «Siempre».',
            'iOS stoppt das Tracking im Hintergrund, deshalb fehlen Fahrten, obwohl die App normal aussieht. Der Standort muss auf „Immer“ stehen.',
        ],
        HintLocationOff: [
            'The phone’s location services are off, so no positions arrive.',
            'Los servicios de ubicación del teléfono están apagados, así que no llegan posiciones.',
            'Die Ortungsdienste am Handy sind aus, deshalb kommen keine Positionen an.',
        ],
        HintTrackingOff: [
            'Tracking is switched off in the app during working hours.',
            'El seguimiento está apagado en la app durante el horario de trabajo.',
            'Das Tracking ist in der App während der Arbeitszeit aus.',
        ],
        HintBatterySaver: [
            'The battery saver can pause tracking and delay positions.',
            'El ahorro de batería puede pausar el seguimiento y retrasar las posiciones.',
            'Der Energiesparmodus kann das Tracking pausieren und Positionen verzögern.',
        ],
        HintAppOutdated: [
            'Updating takes a minute in the app store and brings the latest fixes.',
            'Actualizar lleva un minuto en la tienda de apps y trae las últimas correcciones.',
            'Das Update dauert im App Store eine Minute und bringt die neuesten Korrekturen.',
        ],
        HintInvited: [
            'Hasn’t joined yet, and already counts as a paid seat.',
            'Todavía no se ha unido y ya cuenta como licencia pagada.',
            'Noch nicht beigetreten und zählt schon als bezahlte Lizenz.',
        ],
        HintInactive: [
            'Probably no longer with you. Removing them frees a seat.',
            'Probablemente ya no forma parte del equipo. Al quitarlo se libera una licencia.',
            'Wahrscheinlich nicht mehr bei euch. Wenn du die Person entfernst, wird eine Lizenz frei.',
        ],
        NoPhoneYet: ['No phone has logged in yet.', 'Todavía no se ha conectado ningún teléfono.', 'Noch hat sich kein Handy angemeldet.'],
        InvitedAgo: ['Invited {0}', 'Invitado {0}', 'Eingeladen {0}'],
        LastReminder: ['last reminder {0}', 'último recordatorio {0}', 'letzte Erinnerung {0}'],
        ResendInvite: ['Resend invite', 'Reenviar invitación', 'Einladung erneut senden'],
        InviteSent: ['Invite sent', 'Invitación enviada', 'Einladung gesendet'],
        Primary: ['Primary', 'Principal', 'Hauptteam'],
        AddTeam: ['Add', 'Agregar', 'Hinzufügen'],
        MakePrimary: ['Make primary team', 'Hacer equipo principal', 'Zum Hauptteam machen'],
        RemoveFromTeam: ['Remove from {0}', 'Quitar de {0}', 'Aus {0} entfernen'],
        PrimaryHint: [
            'Working hours and start location come from the primary team.',
            'El horario y la ubicación de inicio vienen del equipo principal.',
            'Arbeitszeiten und Startpunkt kommen vom Hauptteam.',
        ],
        Role: ['Role', 'Rol', 'Rolle'],
        WorkingHours: ['Working hours', 'Horario', 'Arbeitszeiten'],
        HoursFromTeam: ['From {0}', 'Del equipo {0}', 'Vom Team {0}'],
        HoursAllDay: ['all day', 'todo el día', 'ganztags'],
        HoursOwn: ['Own hours', 'Horario propio', 'Eigene Zeiten'],
        HoursDefault: ['Company default', 'Predeterminado de la empresa', 'Standard der Firma'],
        LunchBreak: ['Lunch break', 'Pausa de almuerzo', 'Mittagspause'],
        LunchNone: ['None', 'Ninguna', 'Keine'],
        LunchFromTeamXY: ['{0}, from {1}', '{0}, del equipo {1}', '{0}, vom Team {1}'],
        LunchX: ['Lunch {0}', 'Almuerzo {0}', 'Mittagspause {0}'],
        LunchSameAsTeamXY: ['Same as {0} ({1})', 'Igual que {0} ({1})', 'Wie {0} ({1})'],
        LunchOwn: ['Own lunch break', 'Pausa de almuerzo propia', 'Eigene Mittagspause'],
        LunchTimes: ['Lunch time', 'Hora del almuerzo', 'Mittagszeit'],
        LunchInvalid: ['Up to 3 hours, ending after it starts', 'Hasta 3 horas, y que termine después de empezar', 'Höchstens 3 Stunden, Ende nach dem Beginn'],
        LunchNoBreak: ['No lunch break', 'Sin pausa de almuerzo', 'Keine Mittagspause'],
        LunchHint: [
            "Every working day. Routes keep this time free and move the stops after it. Tracking and timesheets don't change.",
            'Cada día laborable. Las rutas dejan este tiempo libre y mueven las paradas que siguen. El seguimiento y la hoja de horas no cambian.',
            'An jedem Arbeitstag. Routen halten diese Zeit frei und verschieben die Stopps danach. Tracking und Zeiterfassung ändern sich nicht.',
        ],
        Change: ['Change', 'Cambiar', 'Ändern'],
        Skills: ['Skills', 'Habilidades', 'Skills'],
        MemberSince: ['Member since', 'Miembro desde', 'Mitglied seit'],
        Color: ['Color', 'Color', 'Farbe'],
        ProfileAndSettings: ['Profile & settings', 'Perfil y configuración', 'Profil & Einstellungen'],
        Remove: ['Remove…', 'Quitar…', 'Entfernen…'],
        RemoveOne: ['Remove {0}', 'Quitar a {0}', '{0} entfernen'],
        RemoveMany: ['Remove {0} members', 'Quitar {0} miembros', '{0} Mitglieder entfernen'],
        CannotRemoveSelf: ['You can’t remove yourself here.', 'No puedes quitarte a ti mismo aquí.', 'Du kannst dich hier nicht selbst entfernen.'],
        SendFixSteps: ['Send fix steps', 'Enviar pasos', 'Anleitung senden'],
        TeamsButton: ['Teams…', 'Equipos…', 'Teams…'],
        InvitePeople: ['Invite people', 'Invitar personas', 'Leute einladen'],
        InviteMenuInviteHint: ['Paste names and emails, pick role and team', 'Pega nombres y correos, elige rol y equipo', 'Namen und E-Mails einfügen, Rolle und Team wählen'],
        InviteMenuAddOne: ['Add one person', 'Agregar una persona', 'Eine Person anlegen'],
        InviteMenuAddOneHint: ['With a username and password, no email', 'Con nombre de usuario y contraseña, sin correo', 'Mit Nutzername und Passwort, ohne E-Mail'],
        InviteMenuImport: ['Import a file', 'Importar un archivo', 'Datei importieren'],
        InviteMenuImportHint: ['CSV or Excel, up to 200 people', 'CSV o Excel, hasta 200 personas', 'CSV oder Excel, bis zu 200 Personen'],
        SkillAnyChip: ['Skill: any', 'Habilidad: cualquiera', 'Skill: alle'],
        SkillChip: ['Skill: {0}', 'Habilidad: {0}', 'Skill: {0}'],
        AnySkill: ['Any skill', 'Cualquier habilidad', 'Alle Skills'],
        ManageSkills: ['Manage skills…', 'Gestionar habilidades…', 'Skills verwalten…'],
        GroupLabel: ['Group: {0}', 'Agrupación: {0}', 'Gruppierung: {0}'],
        GroupShortNone: ['none', 'ninguna', 'keine'],
        GroupShortTeam: ['team', 'equipo', 'Team'],
        GroupShortRole: ['role', 'rol', 'Rolle'],
        InvitePasteLabel: [
            'Paste names and emails, one person per line',
            'Pega nombres y correos, una persona por línea',
            'Namen und E-Mails einfügen, eine Person pro Zeile',
        ],
        InvitePastePlaceholder: [
            'Marta Nowak, marta@example.com\nBen Carter\tben@example.com',
            'Marta Nowak, marta@example.com\nBen Carter\tben@example.com',
            'Marta Nowak, marta@example.com\nBen Carter\tben@example.com',
        ],
        InviteRole: ['Role', 'Rol', 'Rolle'],
        InviteTeam: ['Team', 'Equipo', 'Team'],
        InviteNoTeam: ['No team', 'Sin equipo', 'Kein Team'],
        InviteSend: ['Send {0} invites', 'Enviar {0} invitaciones', '{0} Einladungen senden'],
        InviteSendOne: ['Send invite', 'Enviar invitación', 'Einladung senden'],
        InviteSendNone: ['Send invites', 'Enviar invitaciones', 'Einladungen senden'],
        InviteProblemNoEmail: ['Needs an email', 'Falta un correo', 'Braucht eine E-Mail'],
        InviteProblemBadEmail: ['Email looks incomplete', 'El correo parece incompleto', 'E-Mail sieht unvollständig aus'],
        InviteProblemDuplicate: ['Listed twice', 'Aparece dos veces', 'Doppelt in der Liste'],
        InviteProblemExists: ['Already a member', 'Ya es miembro', 'Schon Mitglied'],
        InviteHow: [
            'Each person gets an email with a link to join. Workers can also join with the invite code.',
            'Cada persona recibe un correo con un enlace para unirse. Los trabajadores también pueden unirse con el código de invitación.',
            'Jede Person bekommt eine E-Mail mit einem Link zum Beitreten. Mitarbeiter können auch mit dem Einladungscode beitreten.',
        ],
        InviteDone: ['{0} invited', '{0} invitados', '{0} eingeladen'],
        InviteRowFailed: ['Couldn’t invite', 'No se pudo invitar', 'Einladung fehlgeschlagen'],
        InviteFailed: ['{0} couldn’t be invited', 'No se pudo invitar a {0}', '{0} konnten nicht eingeladen werden'],
        InvitePending: ['Waiting to join', 'Pendientes de unirse', 'Noch nicht beigetreten'],
        InviteOrAddOne: ['Add one person with a username instead', 'Agregar una persona con nombre de usuario', 'Stattdessen eine Person mit Nutzernamen anlegen'],
        InviteCodeTitle: ['Or share the invite code', 'O comparte el código de invitación', 'Oder teile den Einladungscode'],
        TeamColName: ['Team', 'Equipo', 'Team'],
        TeamColMembers: ['Members', 'Miembros', 'Mitglieder'],
        TeamColHours: ['Working hours', 'Horario', 'Arbeitszeiten'],
        TeamColRoute: ['Start location', 'Ubicación de inicio', 'Startpunkt'],
        TeamRouteSet: ['Set', 'Definido', 'Festgelegt'],
        TeamRouteCompany: ['Company address', 'Dirección de la empresa', 'Firmenadresse'],
        NoTeamRow: ['People without a team', 'Personas sin equipo', 'Leute ohne Team'],
        SearchTeamsOrPeople: ['Search teams or people', 'Busca equipos o personas', 'Teams oder Leute suchen'],
        NoTeamMatch: ['No team or person matches “{0}”.', 'Ningún equipo ni persona coincide con «{0}».', 'Kein Team und keine Person passt zu „{0}“.'],
        ShowThem: ['Show them', 'Verlos', 'Anzeigen'],
        ShowMembers: ['Show members', 'Ver miembros', 'Mitglieder anzeigen'],
        AddPeople: ['Add people…', 'Agregar personas…', 'Leute hinzufügen…'],
        HoursFromOtherTeam: ['Working hours from {0}', 'Horario de {0}', 'Arbeitszeiten von {0}'],
        AddX: ['Add {0}', 'Agregar {0}', '{0} hinzufügen'],
        RemoveFromThisTeam: ['Remove from team', 'Quitar del equipo', 'Aus dem Team entfernen'],
        EveryoneInTeam: ['Everyone is already in this team.', 'Todos ya están en este equipo.', 'Alle sind schon in diesem Team.'],
        SearchPeople: ['Search people', 'Buscar personas', 'Leute suchen'],
        NobodyInTeam: ['Nobody in this team yet.', 'Todavía no hay nadie en este equipo.', 'Noch niemand in diesem Team.'],
        TeamName: ['Name', 'Nombre', 'Name'],
        Rename: ['Rename', 'Renombrar', 'Umbenennen'],
        Save: ['Save', 'Guardar', 'Speichern'],
        EditHours: ['Edit', 'Editar', 'Bearbeiten'],
        EditRoute: ['Set start location', 'Definir ubicación de inicio', 'Startpunkt festlegen'],
        DeleteTeam: ['Delete team…', 'Eliminar equipo…', 'Team löschen…'],
        DeleteTeamTitle: ['Delete {0}', 'Eliminar {0}', '{0} löschen'],
        DeleteTeamBody: [
            'Members, places, zones, alerts and open jobs of this team move to the team you pick, or lose the team. Archived jobs keep it.',
            'Los miembros, lugares, zonas, alertas y tareas abiertas de este equipo pasan al equipo que elijas o se quedan sin equipo. Las tareas archivadas lo conservan.',
            'Mitglieder, Orte, Zonen, Alarme und offene Aufträge dieses Teams wechseln in das Team, das du auswählst, oder verlieren das Team. Archivierte Aufträge behalten es.',
        ],
        MoveThemTo: ['Move them to', 'Pasarlos a', 'Verschieben nach'],
        DeleteTeamConfirm: ['Delete team', 'Eliminar equipo', 'Team löschen'],
        TeamDeleted: [
            'Team deleted. Moved {0} members, {1} places, {2} zones and {3} jobs.',
            'Equipo eliminado. Se movieron {0} miembros, {1} lugares, {2} zonas y {3} tareas.',
            'Team gelöscht. {0} Mitglieder, {1} Orte, {2} Zonen und {3} Aufträge verschoben.',
        ],
        TeamDeleteFailed: ['The team couldn’t be deleted. Try again.', 'No se pudo eliminar el equipo. Inténtalo de nuevo.', 'Das Team konnte nicht gelöscht werden. Versuch es noch mal.'],
        TeamsFull: ['All 99 team slots are in use.', 'Los 99 equipos posibles están en uso.', 'Alle 99 Team-Plätze sind belegt.'],
        NoTeams: ['No teams yet. Teams group people for dispatch, working hours and a start location.', 'Todavía no hay equipos. Los equipos agrupan personas para despacho, horario y ubicación de inicio.', 'Noch keine Teams. Teams bündeln Leute für Disposition, Arbeitszeiten und Startpunkt.'],
        NoTeamsLocation: ['No teams yet. Teams group people for working hours and the places they see.', 'Todavía no hay equipos. Los equipos agrupan personas para el horario y los lugares que ven.', 'Noch keine Teams. Teams bündeln Leute für Arbeitszeiten und die Orte, die sie sehen.'],
        TeamsLegend: ['✓ everyone · – some of them', '✓ todos · – algunos', '✓ alle · – einige'],
        TeamsApply: ['Apply', 'Aplicar', 'Übernehmen'],
        TeamsUpdated: ['Teams updated for {0}', 'Equipos actualizados para {0}', 'Teams für {0} aktualisiert'],
        XPeople: ['{0} people', '{0} personas', '{0} Personen'],
        PrimaryTeam: ['Primary team', 'Equipo principal', 'Hauptteam'],
        PrimaryTeamHint: ['Only for people in that team.', 'Solo para quienes están en ese equipo.', 'Nur für Leute in diesem Team.'],
        MoreResend: ['Resend invite to {0}', 'Reenviar invitación a {0}', 'Einladung erneut an {0} senden'],
        MoreFix: ['Send fix steps to {0}', 'Enviar pasos a {0}', 'Anleitung an {0} senden'],
        MoreDomain: ['Change email domain of {0}…', 'Cambiar dominio de correo de {0}…', 'E-Mail-Domain von {0} ändern…'],
        MoreRemove: ['Remove {0}…', 'Quitar {0}…', '{0} entfernen…'],
        InvitesSent: ['{0} invites sent', '{0} invitaciones enviadas', '{0} Einladungen gesendet'],
        FixStepsSent: ['Fix steps sent to {0}', 'Pasos enviados a {0}', 'Anleitung an {0} gesendet'],
        Removed: ['{0} removed', '{0} quitados', '{0} entfernt'],
        Sent: ['Sent', 'Enviado', 'Gesendet'],
        AttentionSendFix: ['Send fix steps to {0}', 'Enviar pasos a {0}', 'Anleitung an {0} senden'],
        AttentionRemind: ['Remind {0} to update', 'Recordar a {0} que actualicen', '{0} ans Update erinnern'],
        AttentionResend: ['Resend {0} invites', 'Reenviar {0} invitaciones', '{0} Einladungen erneut senden'],
        AttentionSelect: ['Select {0}', 'Seleccionar {0}', '{0} auswählen'],
        AttentionSent: ['Sent to {0}', 'Enviado a {0}', 'An {0} gesendet'],
        AttentionNone: [
            'Nothing needs attention. Every phone is set up.',
            'Nada requiere atención. Todos los teléfonos están bien configurados.',
            'Alles in Ordnung. Jedes Handy ist richtig eingerichtet.',
        ],
        AttentionStaleInvites: ['Invited, not joined after 7 days', 'Invitados sin unirse tras 7 días', 'Eingeladen, nach 7 Tagen nicht beigetreten'],
        AttentionInactive: ['No login for 30 days', 'Sin conectarse en 30 días', 'Seit 30 Tagen nicht angemeldet'],
        AttentionMessageHint: [
            'Goes out as a chat message in the person’s language.',
            'Se envía como mensaje de chat en el idioma de la persona.',
            'Geht als Chat-Nachricht in der Sprache der Person raus.',
        ],
        FixBackground: [
            'Hi {0}, your phone only shares your location while the Hellotracks app is open, so trips and check-ins get lost.\nTo fix it, open your phone’s Settings, then Apps, Hellotracks, Permissions, Location, and choose “Allow all the time”.\nThanks!',
            'Hola {0}, tu teléfono solo comparte tu ubicación mientras la app Hellotracks está abierta, así que se pierden viajes y check-ins.\nPara arreglarlo, abre la Configuración del teléfono, luego Aplicaciones, Hellotracks, Permisos, Ubicación, y elige «Permitir todo el tiempo».\n¡Gracias!',
            'Hallo {0}, dein Handy teilt deinen Standort nur, solange die Hellotracks-App offen ist. Dadurch gehen Fahrten und Check-ins verloren.\nSo behebst du das: Öffne die Einstellungen, dann Apps, Hellotracks, Berechtigungen, Standort, und wähle „Immer zulassen“.\nDanke!',
        ],
        FixWhileUsing: [
            'Hi {0}, your iPhone only shares your location while Hellotracks is open, so trips go missing.\nTo fix it, open Settings, then Hellotracks, Location, and choose “Always”. Please also turn on “Precise Location”.\nThanks!',
            'Hola {0}, tu iPhone solo comparte tu ubicación mientras Hellotracks está abierta, así que faltan viajes.\nPara arreglarlo, abre Configuración, luego Hellotracks, Ubicación, y elige «Siempre». Activa también «Ubicación exacta».\n¡Gracias!',
            'Hallo {0}, dein iPhone teilt deinen Standort nur, solange Hellotracks offen ist. Dadurch fehlen Fahrten.\nSo behebst du das: Öffne Einstellungen, dann Hellotracks, Standort, und wähle „Immer“. Schalte bitte auch „Genauer Standort“ ein.\nDanke!',
        ],
        FixLocationOff: [
            'Hi {0}, location is switched off on your phone, so Hellotracks can’t record your trips.\nPlease turn on Location in your phone’s quick settings, or on an iPhone in Settings, Privacy & Security, Location Services.\nThanks!',
            'Hola {0}, la ubicación está desactivada en tu teléfono, así que Hellotracks no puede registrar tus viajes.\nActiva la Ubicación en la configuración rápida del teléfono, o en un iPhone en Configuración, Privacidad y seguridad, Localización.\n¡Gracias!',
            'Hallo {0}, der Standort ist an deinem Handy ausgeschaltet, deshalb kann Hellotracks deine Fahrten nicht aufzeichnen.\nBitte schalte den Standort in den Schnelleinstellungen ein, am iPhone unter Einstellungen, Datenschutz & Sicherheit, Ortungsdienste.\nDanke!',
        ],
        FixTrackingOff: [
            'Hi {0}, tracking is switched off in your Hellotracks app during working hours.\nPlease open the app and switch tracking on.\nThanks!',
            'Hola {0}, el seguimiento está apagado en tu app Hellotracks durante el horario de trabajo.\nAbre la app y activa el seguimiento, por favor.\n¡Gracias!',
            'Hallo {0}, das Tracking ist in deiner Hellotracks-App während der Arbeitszeit ausgeschaltet.\nBitte öffne die App und schalte das Tracking ein.\nDanke!',
        ],
        FixBatterySaver: [
            'Hi {0}, the battery saver on your phone can pause Hellotracks and delay your positions.\nIf you can, turn it off during work or leave Hellotracks out of it.\nThanks!',
            'Hola {0}, el ahorro de batería de tu teléfono puede pausar Hellotracks y retrasar tus posiciones.\nSi puedes, desactívalo durante el trabajo o deja fuera a Hellotracks.\n¡Gracias!',
            'Hallo {0}, der Energiesparmodus an deinem Handy kann Hellotracks pausieren und deine Positionen verzögern.\nWenn möglich, schalte ihn während der Arbeit aus oder nimm Hellotracks davon aus.\nDanke!',
        ],
        FixAppOutdated: [
            'Hi {0}, there’s a newer version of the Hellotracks app with fixes for tracking.\nPlease update it in the App Store or on Google Play.\nThanks!',
            'Hola {0}, hay una versión más nueva de la app Hellotracks con mejoras para el seguimiento.\nActualízala en App Store o Google Play, por favor.\n¡Gracias!',
            'Hallo {0}, es gibt eine neuere Version der Hellotracks-App mit Verbesserungen fürs Tracking.\nBitte aktualisiere sie im App Store oder bei Google Play.\nDanke!',
        ],
        DomainSwitch: ['Change email domain', 'Cambiar dominio de correo', 'E-Mail-Domain ändern'],
        DomainSwitchFrom: ['From', 'De', 'Von'],
        DomainSwitchTo: ['To', 'A', 'Zu'],
        DomainSwitchToPlaceholder: ['newdomain.com', 'nuevodominio.com', 'neuedomain.de'],
        DomainSwitchHow: [
            'Usernames and email addresses on the old domain move to the new one. Everyone keeps their history, and the old username still works for signing in.',
            'Los nombres de usuario y correos del dominio anterior pasan al nuevo. Todos conservan su historial y el nombre de usuario anterior sigue sirviendo para iniciar sesión.',
            'Nutzernamen und E-Mail-Adressen der alten Domain ziehen auf die neue um. Der Verlauf bleibt erhalten, und mit dem alten Nutzernamen kann man sich weiterhin anmelden.',
        ],
        DomainSwitchInvalid: ['Enter a domain like example.com.', 'Escribe un dominio como ejemplo.com.', 'Gib eine Domain wie beispiel.de ein.'],
        DomainSwitchSame: ['That’s the domain they’re on now.', 'Ese es el dominio que ya tienen.', 'Das ist die Domain, die sie schon haben.'],
        DomainSwitchNobody: ['Nobody is on @{0}.', 'Nadie está en @{0}.', 'Niemand ist auf @{0}.'],
        DomainSwitchWas: ['was {0}', 'antes {0}', 'bisher {0}'],
        DomainSwitchEmailToo: ['email {0}', 'correo {0}', 'E-Mail {0}'],
        DomainSwitchTakenBy: ['Already used by {0}', 'Ya lo usa {0}', 'Schon vergeben an {0}'],
        DomainSwitchRun: ['Change {0} people', 'Cambiar {0} personas', '{0} Personen ändern'],
        DomainSwitchRunOne: ['Change 1 person', 'Cambiar 1 persona', '1 Person ändern'],
        DomainSwitchRunNone: ['Change people', 'Cambiar personas', 'Personen ändern'],
        DomainSwitchProgress: ['Changing {0} of {1}…', 'Cambiando {0} de {1}…', 'Ändere {0} von {1}…'],
        DomainSwitchChanged: ['Changed', 'Cambiado', 'Geändert'],
        DomainSwitchRowFailed: ['Couldn’t change', 'No se pudo cambiar', 'Nicht geändert'],
        DomainSwitchEmailFailed: ['Username changed, email not', 'Usuario cambiado, correo no', 'Nutzername geändert, E-Mail nicht'],
        DomainSwitchDone: ['{0} changed', '{0} cambiados', '{0} geändert'],
        DomainSwitchFailed: ['{0} not changed', '{0} sin cambiar', '{0} nicht geändert'],
        DomainSwitchListTitle: ['Change usernames', 'Cambiar nombres de usuario', 'Nutzernamen ändern'],
        DomainSwitchUseList: ['Paste a list of old and new usernames instead', 'Pegar una lista de nombres anteriores y nuevos', 'Stattdessen eine Liste alter und neuer Nutzernamen einfügen'],
        DomainSwitchUseDomain: ['Move everyone to a new domain instead', 'Pasar a todos a un dominio nuevo', 'Stattdessen alle auf eine neue Domain umziehen'],
        DomainSwitchListPlaceholder: [
            'jsmith@example.com    john.smith@example.com\nadoe@example.com    anna.doe@example.com',
            'jperez@ejemplo.com    juan.perez@ejemplo.com\namora@ejemplo.com    ana.mora@ejemplo.com',
            'mmueller@beispiel.de    max.mueller@beispiel.de\naschmidt@beispiel.de    anna.schmidt@beispiel.de',
        ],
        DomainSwitchListHow: [
            'The old username first, then the new one. A pasted table works as is. Everyone keeps their history, and the old username still works for signing in.',
            'Primero el nombre de usuario anterior, luego el nuevo. Puedes pegar una tabla tal cual. Todos conservan su historial y el nombre anterior sigue sirviendo para iniciar sesión.',
            'Zuerst der alte Nutzername, dann der neue. Eine eingefügte Tabelle geht so, wie sie ist. Der Verlauf bleibt erhalten, und mit dem alten Nutzernamen kann man sich weiterhin anmelden.',
        ],
        DomainSwitchNotFound: ['Not found', 'No encontrado', 'Nicht gefunden'],
        DomainSwitchMissing: ['No new username', 'Falta el nuevo usuario', 'Neuer Nutzername fehlt'],
        DomainSwitchNoChange: ['Already this username', 'Ya tiene este usuario', 'Hat diesen Nutzernamen schon'],
    },
    SelectionBar: {
        ClearSelection: ['Clear selection', 'Quitar selección', 'Auswahl aufheben'],
        Deselect: ['Deselect', 'Quitar de la selección', 'Abwählen'],
        AndXMore: ['and {0} more', 'y {0} más', 'und {0} weitere'],
        XDays: ['{0} days', '{0} días', '{0} Tage'],
        XTemplates: ['{0} templates', '{0} plantillas', '{0} Vorlagen'],
        XArchivedJobs: ['{0} archived jobs', '{0} tareas archivadas', '{0} archivierte Aufträge'],
        MoveTo: ['Move to…', 'Mover a…', 'Verschieben…'],
        EditFields: ['Edit fields', 'Editar campos', 'Felder bearbeiten'],
        MoreActions: ['More actions', 'Más acciones', 'Weitere Aktionen'],
        SelectWholeRoute: ['Select the whole route', 'Seleccionar toda la ruta', 'Ganze Route auswählen'],
        ShowOnMap: ['Show on map', 'Mostrar en el mapa', 'Auf der Karte zeigen'],
        MixedTemplates: [
            'Jobs and templates can’t be edited together',
            'Las tareas y las plantillas no se pueden editar juntas',
            'Aufträge und Vorlagen lassen sich nicht zusammen bearbeiten',
        ],
        KeepOnlyJobs: ['Keep only the jobs', 'Quedarme solo con las tareas', 'Nur die Aufträge behalten'],
        MixedArchived: [
            'Archived and active jobs can’t be edited together',
            'Las tareas archivadas y las activas no se pueden editar juntas',
            'Archivierte und aktive Aufträge lassen sich nicht zusammen bearbeiten',
        ],
        KeepOnlyActive: ['Keep only the active jobs', 'Quedarme solo con las activas', 'Nur die aktiven Aufträge behalten'],
        OneInSequence: [
            '1 of them belongs to a recurring route',
            '1 de ellas pertenece a una ruta recurrente',
            '1 davon gehört zu einer wiederkehrenden Route',
        ],
        XInSequence: [
            '{0} of them belong to a recurring route',
            '{0} de ellas pertenecen a una ruta recurrente',
            '{0} davon gehören zu einer wiederkehrenden Route',
        ],
        DeselectThem: ['Deselect them', 'Quitarlas', 'Abwählen'],
        AssignTo: ['Assign to', 'Asignar a', 'Zuweisen an'],
        TheirDay: ['Their day', 'Su día', 'Ihr Tag'],
        SearchPeople: ['Search people', 'Buscar personas', 'Personen suchen'],
        KeepAssignee: ['Keep who has them', 'Mantener a quien las tiene', 'Zuweisung behalten'],
        XPeople: ['{0} people', '{0} personas', '{0} Personen'],
        NoOne: ['No one yet', 'Nadie todavía', 'Noch niemand'],
        OneJobThatDay: ['1 job', '1 tarea', '1 Auftrag'],
        XJobsThatDay: ['{0} jobs', '{0} tareas', '{0} Aufträge'],
        FreeThatDay: ['Free', 'Libre', 'Frei'],
        NoMatches: ['No one matches', 'Nadie coincide', 'Niemand gefunden'],
        Day: ['Day', 'Día', 'Tag'],
        KeepDay: ['Keep day', 'Mantener día', 'Tag behalten'],
        Today: ['Today', 'Hoy', 'Heute'],
        Tomorrow: ['Tomorrow', 'Mañana', 'Morgen'],
        PickDate: ['Pick a date…', 'Elegir fecha…', 'Datum wählen…'],
        PickPersonOrDay: [
            'Pick a person, a day, or both.',
            'Elige una persona, un día o ambos.',
            'Wähle eine Person, einen Tag oder beides.',
        ],
        MoveOneJob: ['Move job', 'Mover tarea', 'Auftrag verschieben'],
        MoveXJobs: ['Move {0} jobs', 'Mover {0} tareas', '{0} Aufträge verschieben'],
        RescheduleOneJob: ['Reschedule job', 'Reprogramar tarea', 'Auftrag umplanen'],
        RescheduleXJobs: ['Reschedule {0} jobs', 'Reprogramar {0} tareas', '{0} Aufträge umplanen'],
        UnassignOneJob: ['Unassign job', 'Desasignar tarea', 'Zuweisung aufheben'],
        UnassignXJobs: ['Unassign {0} jobs', 'Desasignar {0} tareas', 'Zuweisung von {0} Aufträgen aufheben'],
        MovedOne: ['Moved 1 job to {0}', '1 tarea movida a {0}', '1 Auftrag verschoben: {0}'],
        MovedX: ['Moved {0} jobs to {1}', '{0} tareas movidas a {1}', '{0} Aufträge verschoben: {1}'],
        UnassignedOne: ['Unassigned 1 job', '1 tarea desasignada', 'Zuweisung von 1 Auftrag aufgehoben'],
        UnassignedX: ['Unassigned {0} jobs', '{0} tareas desasignadas', 'Zuweisung von {0} Aufträgen aufgehoben'],
        UpdatedOne: ['Updated 1 job', '1 tarea actualizada', '1 Auftrag aktualisiert'],
        UpdatedX: ['Updated {0} jobs', '{0} tareas actualizadas', '{0} Aufträge aktualisiert'],
        ArchivedOne: ['Archived 1 job', '1 tarea archivada', '1 Auftrag archiviert'],
        ArchivedX: ['Archived {0} jobs', '{0} tareas archivadas', '{0} Aufträge archiviert'],
        RestoredOne: ['Restored 1 job', '1 tarea restablecida', '1 Auftrag wiederhergestellt'],
        RestoredX: ['Restored {0} jobs', '{0} tareas restablecidas', '{0} Aufträge wiederhergestellt'],
        DeletedOne: ['Deleted 1 job', '1 tarea eliminada', '1 Auftrag gelöscht'],
        DeletedX: ['Deleted {0} jobs', '{0} tareas eliminadas', '{0} Aufträge gelöscht'],
        Undo: ['Undo', 'Deshacer', 'Rückgängig'],
        MovedBack: ['Moved back', 'Devueltas a su sitio', 'Zurückgesetzt'],
        ArchiveOneJob: ['Archive job', 'Archivar tarea', 'Auftrag archivieren'],
        ArchiveXJobs: ['Archive {0} jobs', 'Archivar {0} tareas', '{0} Aufträge archivieren'],
        DeleteOneJob: ['Delete job', 'Eliminar tarea', 'Auftrag löschen'],
        DeleteXJobs: ['Delete {0} jobs', 'Eliminar {0} tareas', '{0} Aufträge löschen'],
        EditOneJob: ['Edit 1 job', 'Editar 1 tarea', '1 Auftrag bearbeiten'],
        EditXJobs: ['Edit {0} jobs', 'Editar {0} tareas', '{0} Aufträge bearbeiten'],
        OnlyChangesSaved: [
            'Only the fields you change are saved.',
            'Solo se guardan los campos que cambies.',
            'Gespeichert wird nur, was du änderst.',
        ],
        Field: ['Field', 'Campo', 'Feld'],
        Now: ['Now', 'Ahora', 'Jetzt'],
        ChangeTo: ['Change to', 'Cambiar a', 'Ändern in'],
        GroupDispatch: ['Dispatch', 'Despacho', 'Disposition'],
        GroupOnSite: ['On site', 'En el sitio', 'Vor Ort'],
        GroupTagsLinks: ['Labels and links', 'Etiquetas y enlaces', 'Labels und Verknüpfungen'],
        GroupCleanUp: ['Clean up', 'Limpieza', 'Aufräumen'],
        KeepAsIs: ['Keep as is', 'Sin cambios', 'Unverändert'],
        Varies: ['Varies', 'Varía', 'Unterschiedlich'],
        RequiredSkills: ['Required skills', 'Habilidades requeridas', 'Benötigte Skills'],
        SkillsAreAdded: ['Added to each job', 'Se agregan a cada tarea', 'Werden jedem Auftrag hinzugefügt'],
        LabelsAdd: ['Add', 'Agregar', 'Hinzufügen'],
        LabelsReplace: ['Replace', 'Reemplazar', 'Ersetzen'],
        LinkedItems: ['Linked items', 'Elementos vinculados', 'Verknüpfungen'],
        Choose: ['Choose…', 'Elegir…', 'Auswählen…'],
        XLinked: ['{0} linked', '{0} vinculados', '{0} verknüpft'],
        RemoveCustomFields: ['Remove custom fields', 'Quitar campos personalizados', 'Eigene Felder entfernen'],
        OneChange: ['1 change', '1 cambio', '1 Änderung'],
        XChanges: ['{0} changes', '{0} cambios', '{0} Änderungen'],
        NoChanges: ['No changes yet', 'Aún sin cambios', 'Noch keine Änderungen'],
        ApplyToOneJob: ['Apply', 'Aplicar', 'Übernehmen'],
        ApplyToXJobs: ['Apply to {0} jobs', 'Aplicar a {0} tareas', 'Auf {0} Aufträge anwenden'],
        OneSelected: ['1 selected', '1 seleccionado', '1 ausgewählt'],
        XSelected: ['{0} selected', '{0} seleccionados', '{0} ausgewählt'],
        NoneSelected: ['None selected', 'Nada seleccionado', 'Nichts ausgewählt'],
        XPlaces: ['{0} places', '{0} lugares', '{0} Orte'],
        OnePlace: ['1 place', '1 lugar', '1 Ort'],
        XZones: ['{0} zones', '{0} zonas', '{0} Zonen'],
        OneZone: ['1 zone', '1 zona', '1 Zone'],
        GeocodeX: ['Geocode {0}', 'Geocodificar {0}', '{0} geokodieren'],
        OneMember: ['1 member', '1 miembro', '1 Mitglied'],
        XMembers: ['{0} members', '{0} miembros', '{0} Mitglieder'],
        OneTrack: ['1 track', '1 recorrido', '1 Strecke'],
        XTracks: ['{0} tracks', '{0} recorridos', '{0} Strecken'],
        EditOnePlace: ['Edit 1 place', 'Editar 1 lugar', '1 Ort bearbeiten'],
        EditXPlaces: ['Edit {0} places', 'Editar {0} lugares', '{0} Orte bearbeiten'],
        EditOneZone: ['Edit 1 zone', 'Editar 1 zona', '1 Zone bearbeiten'],
        EditXZones: ['Edit {0} zones', 'Editar {0} zonas', '{0} Zonen bearbeiten'],
        EditOneMember: ['Edit 1 member', 'Editar 1 miembro', '1 Mitglied bearbeiten'],
        EditXMembers: ['Edit {0} members', 'Editar {0} miembros', '{0} Mitglieder bearbeiten'],
        ApplyToXPlaces: ['Apply to {0} places', 'Aplicar a {0} lugares', 'Auf {0} Orte anwenden'],
        ApplyToXZones: ['Apply to {0} zones', 'Aplicar a {0} zonas', 'Auf {0} Zonen anwenden'],
        ApplyToXMembers: ['Apply to {0} members', 'Aplicar a {0} miembros', 'Auf {0} Mitglieder anwenden'],
        UpdatedOnePlace: ['Updated 1 place', '1 lugar actualizado', '1 Ort aktualisiert'],
        UpdatedXPlaces: ['Updated {0} places', '{0} lugares actualizados', '{0} Orte aktualisiert'],
        DeletedOnePlace: ['Deleted 1 place', '1 lugar eliminado', '1 Ort gelöscht'],
        DeletedXPlaces: ['Deleted {0} places', '{0} lugares eliminados', '{0} Orte gelöscht'],
        UpdatedOneZone: ['Updated 1 zone', '1 zona actualizada', '1 Zone aktualisiert'],
        UpdatedXZones: ['Updated {0} zones', '{0} zonas actualizadas', '{0} Zonen aktualisiert'],
        DeletedOneZone: ['Deleted 1 zone', '1 zona eliminada', '1 Zone gelöscht'],
        DeletedXZones: ['Deleted {0} zones', '{0} zonas eliminadas', '{0} Zonen gelöscht'],
        UpdatedOneMember: ['Updated 1 member', '1 miembro actualizado', '1 Mitglied aktualisiert'],
        UpdatedXMembers: ['Updated {0} members', '{0} miembros actualizados', '{0} Mitglieder aktualisiert'],
        DeletedOneTrack: ['Deleted 1 track', '1 recorrido eliminado', '1 Strecke gelöscht'],
        DeletedXTracks: ['Deleted {0} tracks', '{0} recorridos eliminados', '{0} Strecken gelöscht'],
        DeleteOnePlace: ['Delete place', 'Eliminar lugar', 'Ort löschen'],
        DeleteXPlaces: ['Delete {0} places', 'Eliminar {0} lugares', '{0} Orte löschen'],
        DeleteOneZone: ['Delete zone', 'Eliminar zona', 'Zone löschen'],
        DeleteXZones: ['Delete {0} zones', 'Eliminar {0} zonas', '{0} Zonen löschen'],
        DeleteOneTrack: ['Delete track', 'Eliminar recorrido', 'Strecke löschen'],
        DeleteXTracks: ['Delete {0} tracks', 'Eliminar {0} recorridos', '{0} Strecken löschen'],
        ExportCsv: ['Export', 'Exportar', 'Exportieren'],
        Gpx: ['GPX', 'GPX', 'GPX'],
        Radius: ['Radius', 'Radio', 'Radius'],
        Teams: ['Teams', 'Equipos', 'Teams'],
        Members: ['Members', 'Miembros', 'Mitglieder'],
        Color: ['Color', 'Color', 'Farbe'],
        RemoveAll: ['Remove all', 'Quitar todos', 'Alle entfernen'],
        AddSkills: ['Add skills', 'Agregar habilidades', 'Skills hinzufügen'],
        RemoveSkills: ['Remove skills', 'Quitar habilidades', 'Skills entfernen'],
        ProfileImage: ['Profile image', 'Imagen de perfil', 'Profilbild'],
        UseInitials: ['Replace with initials', 'Cambiar por iniciales', 'Durch Initialen ersetzen'],
        GroupPlace: ['Place', 'Lugar', 'Ort'],
        GroupContact: ['Contact', 'Contacto', 'Kontakt'],
        GroupZone: ['Zone', 'Zona', 'Zone'],
        GroupProfile: ['Profile', 'Perfil', 'Profil'],
        GroupAssignment: ['Assignment', 'Asignación', 'Zuweisung'],
        GroupSkills: ['Skills', 'Habilidades', 'Skills'],
        GroupLinks: ['Links', 'Enlaces', 'Verknüpfungen'],
    },
    Clustering: {
        Clustering: [
            "Clustering",
            "Agrupamiento",
            "Clustering"
        ],
        Info: [
            "You can group unassigned jobs and assign them to your team. Our clustering algorithm takes distance and zones into account.",
            "Puedes agrupar tareas no asignadas y asignarlas a tu equipo. Nuestro algoritmo de agrupación tiene en cuenta la distancia y las zonas.",
            "Du kannst unzugewiesene Aufträge gruppieren und sie deinem Team zuweisen. Unser Clustering-Algorithmus berücksichtigt Entfernung und Zonen.",
        ],
        ClusteringXSelectedJobs: [
            "Clustering {0} selected jobs",
            "Agrupando {0} tareas seleccionadas",
            "Clustering von {0} ausgewählten Aufträgen",
        ],
        SelectUpToXJobsForClustering: [
            "Select up to {0} unassigned jobs for clustering",
            "Selecciona hasta {0} tareas no asignadas para el agrupamiento",
            "Wähle bis zu {0} nicht zugewiesene Aufträge zum Clustering aus",
        ],
        CreatingXClusters: [
            "Creating {0} clusters",
            "Creando {0} grupos",
            "{0} Cluster werden erstellt",
        ],
        XClusters: [
            "{0} clusters",
            "{0} grupos",
            "{0} Cluster",
        ],
        OneCluster: [
            "1 cluster",
            "1 grupo",
            "1 Cluster",
        ],
    },
    EmptyLoops: {
        HistoryTitle: ["Every drive and stop, recorded", "Cada trayecto y cada parada, registrados", "Jede Fahrt und jeder Stopp, aufgezeichnet"],
        HistoryText: [
            "Once the app is active on a phone, each day shows up here: where they drove, where they stopped and for how long.",
            "En cuanto la app esté activa en un teléfono, cada día aparece aquí: por dónde condujo, dónde paró y cuánto tiempo.",
            "Sobald die App auf einem Handy aktiv ist, erscheint hier jeder Tag: wo gefahren wurde, wo angehalten und wie lange.",
        ],
        HistoryWaiting: [
            "Trips show up after the first drive with the app active.",
            "Los viajes aparecen tras el primer trayecto con la app activa.",
            "Fahrten erscheinen nach der ersten Fahrt mit aktiver App.",
        ],
        PlacesTitle: ["Know when someone is there", "Sabe cuándo hay alguien allí", "Wissen, wann jemand vor Ort ist"],
        PlacesText: [
            "Add the places you work at. When someone arrives, they're checked in and their time on site counts, without a tap.",
            "Agrega los lugares donde trabaja tu equipo. Cuando alguien llega, se registra su llegada y cuenta su tiempo en el sitio, sin tocar nada.",
            "Leg die Orte an, an denen ihr arbeitet. Kommt jemand an, wird er eingecheckt und die Zeit vor Ort läuft mit, ganz ohne Tippen.",
        ],
        AddFirstPlace: ["Add a place", "Agregar un lugar", "Ort anlegen"],
        CreateFirstForm: ["Create your first form", "Crea tu primer formulario", "Erstelle dein erstes Formular"],
        CreateFirstJob: ["Create your first job", "Crea tu primera tarea", "Leg deinen ersten Auftrag an"],
        ReportsTitle: ["Reports that come to you", "Informes que te llegan solos", "Berichte, die von selbst kommen"],
        ReportsText: [
            "Hours, trips and visits as a file you can pass on. Schedule one once and it arrives every week.",
            "Horas, viajes y visitas en un archivo que puedes pasar. Prográmalo una vez y llega cada semana.",
            "Stunden, Fahrten und Besuche als Datei zum Weitergeben. Einmal planen, und sie kommt jede Woche.",
        ],
        EveryMonday: ["Send me this every Monday", "Envíamelo cada lunes", "Schick mir das jeden Montag"],
        EveryMondayNote: [
            "A timesheet of the {0} people on your team today, as an Excel file. Change it any time under Scheduled.",
            "Un timesheet de las {0} personas de tu equipo hoy, en Excel. Cámbialo cuando quieras en Programados.",
            "Ein Timesheet der {0} Personen in deinem Team heute, als Excel-Datei. Ändern kannst du es jederzeit unter Geplant.",
        ],
        ReportsNeedTeam: [
            "Reports fill once your team is on the map.",
            "Los informes se llenan cuando tu equipo esté en el mapa.",
            "Berichte füllen sich, sobald dein Team auf der Karte ist.",
        ],
    },
    FirstPhone: {
        OwnPhone: ["Track my own phone too", "Registrar también mi teléfono", "Auch mein eigenes Handy tracken"],
        OwnPhoneHint: [
            "Scan this with your phone, install the app and log in as {0}.",
            "Escanéalo con tu teléfono, instala la app e inicia sesión como {0}.",
            "Scann das mit deinem Handy, installier die App und melde dich als {0} an.",
        ],
        StepJoined: ["Joined", "Se unió", "Beigetreten"],
        StepSignedIn: ["Logged in", "Sesión iniciada", "Angemeldet"],
        StepOnMap: ["On the map", "En el mapa", "Auf der Karte"],
        XIsOnMap: ["{0} is on the map", "{0} está en el mapa", "{0} ist auf der Karte"],
        YouAreOnMap: ["You're on the map", "Estás en el mapa", "Du bist auf der Karte"],
        InviteOthers: [
            "Invite the others the same way. They show up here as they join.",
            "Invita a los demás igual. Aparecen aquí en cuanto se unen.",
            "Lade die anderen genauso ein. Sie erscheinen hier, sobald sie beitreten.",
        ],
        WhatTheySee: ["What they see on their phone", "Lo que ven en su teléfono", "Was sie auf dem Handy sehen"],
        InviteHint: [
            "Send your team this code. They install Hellotracks and tap {0} on the first screen, not “Get started”.",
            "Envía este código a tu equipo. Instalan Hellotracks y en la primera pantalla tocan {0}, no «Empezar».",
            "Schick deinem Team diesen Code. Sie installieren Hellotracks und tippen auf dem ersten Bildschirm auf {0}, nicht auf „Loslegen“.",
        ],
        HaveInvite: ["I have an invite code", "Tengo un código de invitación", "Ich habe einen Einladungscode"],
        CopyInvite: ["Copy invite", "Copiar invitación", "Einladung kopieren"],
    },
    Setup: {
        Menu: ["Setup", "Configuración", "Einrichtung"],
        StepOf: ["Step {0} of {1}", "Paso {0} de {1}", "Schritt {0} von {1}"],
        StepDone: ["Step {0} of {1} done", "Paso {0} de {1} listo", "Schritt {0} von {1} erledigt"],
        Change: ["Change", "Cambiar", "Ändern"],
        Skip: ["Skip", "Omitir", "Überspringen"],
        Skipped: ["Skipped", "Omitido", "Übersprungen"],
        DoItNow: ["Do it now", "Hacerlo ahora", "Jetzt erledigen"],
        AllSteps: ["All steps", "Todos los pasos", "Alle Schritte"],
        HideSteps: ["Hide steps", "Ocultar pasos", "Schritte ausblenden"],
        Now: ["Now", "Ahora", "Jetzt"],
        SkippedEarlier: ["skipped earlier", "omitido antes", "vorhin übersprungen"],
        NotForUs: ["Not for us", "No es para nosotros", "Brauchen wir nicht"],
        Minimize: ["Minimize", "Minimizar", "Minimieren"],
        FirstStopTitle: ["Send {0} a first stop", "Envía a {0} una primera parada", "Schick {0} einen ersten Stopp"],
        FirstStopAnyone: ["Send a first stop", "Envía una primera parada", "Schick einen ersten Stopp"],
        FirstStopWhy: ["Pick an address and a time. The stop lands on their phone with a sound.", "Elige una dirección y una hora. La parada llega a su teléfono con un sonido.", "Wähl Adresse und Uhrzeit. Der Stopp landet mit einem Ton auf dem Handy."],
        JobBackTitle: ["{0} finishes it on the phone", "{0} la termina en el teléfono", "{0} erledigt es auf dem Handy"],
        JobBackAnyone: ["The job comes back done", "La tarea vuelve lista", "Der Auftrag kommt erledigt zurück"],
        JobBackWhy: ["Nothing to do here: on the way, arrived and done show up on the map as they happen.", "Aquí no hay nada que hacer: en camino, llegada y lista aparecen en el mapa en cuanto pasan.", "Hier gibt's nichts zu tun: Unterwegs, angekommen und erledigt erscheinen auf der Karte, sobald es passiert."],
        JobBackWait: ["Waiting for {0} to finish {1}", "Esperando a que {0} termine {1}", "Warten, bis {0} {1} erledigt"],
        JobBackWaitAnyone: ["Waiting for the first job to come back done", "Esperando a que la primera tarea vuelva lista", "Warten, bis der erste Auftrag erledigt zurückkommt"],
        JobBackDone: ["{0} came back done.", "{0} volvió lista.", "{0} kam erledigt zurück."],
        JobBackSelfTitle: ["Complete the job on your phone", "Completa la tarea en tu teléfono", "Erledige den Auftrag auf deinem Handy"],
        AppStepJobs: ["Open the Hellotracks app and tap {0}", "Abre la app de Hellotracks y toca {0}", "Öffne die Hellotracks-App und tippe auf {0}"],
        AppStepOpen: ["Open “{0}”", "Abre «{0}»", "Öffne „{0}“"],
        AppStepOpenAny: ["Open the job", "Abre la tarea", "Öffne den Auftrag"],
        AppStepDone: ["Tap {0}", "Toca {0}", "Tippe auf {0}"],
        // the labels as the phone app shows them: the Jobs tab and the job's Done button
        AppJobsTab: ["Jobs", "Tareas", "Aufträge"],
        AppDoneButton: ["Done", "Listo", "Fertig"],
        JobBackSelfWait: ["Waiting for you to finish {0}", "Esperando a que termines {0}", "Warten, bis du {0} erledigst"],
        JobBackSelfWaitAny: ["Waiting for you to mark it done", "Esperando a que la marques como hecha", "Warten, bis du ihn als erledigt markierst"],
        FirstVisitTitle: ["The first visit is counted at {0}", "Se cuenta la primera visita en {0}", "Der erste Besuch bei {0} wird gezählt"],
        FirstVisitAnyone: ["The first visit is counted", "Se cuenta la primera visita", "Der erste Besuch wird gezählt"],
        FirstVisitWhy: ["Nothing to do here: when someone arrives, they're checked in, with the time on site.", "Aquí no hay nada que hacer: cuando alguien llega, se registra solo, con el tiempo en el lugar.", "Hier gibt's nichts zu tun: Wer ankommt, wird automatisch eingecheckt, mit der Zeit vor Ort."],
        FirstVisitWait: ["Waiting for the first arrival at {0}", "Esperando la primera llegada a {0}", "Warten auf die erste Ankunft bei {0}"],
        FirstVisitWaitAnyone: ["Waiting for the first arrival", "Esperando la primera llegada", "Warten auf die erste Ankunft"],
        DayWait: ["Waiting for the first day of trips", "Esperando el primer día de viajes", "Warten auf den ersten Tag mit Fahrten"],
        SetupVideo: ["Setting up Hellotracks", "Configurar Hellotracks", "Hellotracks einrichten"],
        VideoLength: ["Video · {0}", "Video · {0}", "Video · {0}"],
        WatchVideo: ["Watch the setup video", "Ver el video de configuración", "Einrichtungsvideo ansehen"],
        NextUp: ["Next: {0}", "Siguiente: {0}", "Als Nächstes: {0}"],
        MoreQuestions: ["Two quick questions", "Dos preguntas rápidas", "Zwei kurze Fragen"],
        AllSetTitle: ["{0} is set up", "{0} está listo", "{0} ist eingerichtet"],
        AllSetNoName: ["You're set up", "Todo está listo", "Alles ist eingerichtet"],
        StepsDoneOf: ["{0} of {1} steps done", "{0} de {1} pasos listos", "{0} von {1} Schritten erledigt"],
        SkippedWait: ["The skipped steps wait here. Do them whenever you're ready.", "Los pasos omitidos esperan aquí. Hazlos cuando quieras.", "Die übersprungenen Schritte warten hier. Erledige sie, wann immer du so weit bist."],
        AllSetText: [
            "The steps are done. Teams like yours use these next: {0}.",
            "Los pasos están listos. Equipos como el tuyo usan esto después: {0}.",
            "Die Schritte sind erledigt. Teams wie eures nutzen als Nächstes: {0}.",
        ],
        WorkQuestion: ["What does your team do?", "¿A qué se dedica tu equipo?", "Was macht dein Team?"],
        WorkHint: [
            "Pick one, and the next steps fit your work.",
            "Elige uno y los siguientes pasos se ajustan a tu trabajo.",
            "Wähl eins, dann passen die nächsten Schritte zu eurer Arbeit.",
        ],
        Workrepair: ["Repair", "Reparación", "Reparatur"],
        WorkrepairEx: ["Plumbing, heating, electrical", "Plomería, calefacción, electricidad", "Sanitär, Heizung, Elektro"],
        Workcleaning: ["Cleaning", "Limpieza", "Reinigung"],
        WorkcleaningEx: ["Offices, buildings, crews", "Oficinas, edificios, cuadrillas", "Büros, Gebäude, Teams"],
        Workcare: ["Home care", "Cuidado en casa", "Pflege"],
        WorkcareEx: ["Home care, nursing, therapy", "Cuidadores, enfermería, terapia", "Pflege, Krankenpflege, Therapie"],
        Worksecurity: ["Security", "Seguridad", "Sicherheit"],
        WorksecurityEx: ["Guards, patrols, alarm response", "Guardias, rondas, respuesta a alarmas", "Wachdienst, Streifen, Alarmverfolgung"],
        Workdelivery: ["Delivery", "Entregas", "Lieferdienst"],
        WorkdeliveryEx: ["Couriers, drivers, pickups", "Mensajeros, choferes, recolecciones", "Kuriere, Fahrer, Abholungen"],
        Worksales: ["Field sales", "Ventas en campo", "Außendienst"],
        WorksalesEx: ["Reps, merchandisers, inspectors", "Vendedores, promotores, inspectores", "Vertrieb, Merchandiser, Prüfer"],
        Workother: ["Other", "Otro", "Anderes"],
        WorkotherEx: ["See the team, trips and hours", "Ver al equipo, sus viajes y horas", "Team, Fahrten und Stunden sehen"],
        Nextrepair: ["the week planner and Co-Dispatch", "el planificador semanal y Co-Dispatch", "der Wochenplaner und Co-Dispatch"],
        Nextcleaning: ["Statistics for time on site", "Estadísticas de tiempo en sitio", "Statistiken zur Zeit vor Ort"],
        Nextcare: ["forms with photos and visit reports", "formularios con fotos e informes de visitas", "Formulare mit Fotos und Besuchsberichte"],
        Nextsecurity: ["alerts for early leaves and zones", "alertas de salidas tempranas y zonas", "Alarme bei frühem Verlassen und Zonen"],
        Nextdelivery: ["the week planner and arrival emails", "el planificador semanal y los correos de llegada", "der Wochenplaner und Ankunfts-E-Mails"],
        Nextsales: ["Statistics for visits per person", "Estadísticas de visitas por persona", "Statistiken zu Besuchen pro Person"],
        Nextother: ["alerts and reports", "alertas e informes", "Alarme und Berichte"],
        InviteDoneSelf: ["Your phone is on the map.", "Tu teléfono está en el mapa.", "Dein Handy ist auf der Karte."],
        InviteDone: ["{0} is on the map.", "{0} está en el mapa.", "{0} ist auf der Karte."],
        JobTitle: ["Send {0} a first job", "Envía a {0} una primera tarea", "Schick {0} einen ersten Auftrag"],
        JobTitleAnyone: ["Send a first job", "Envía una primera tarea", "Schick einen ersten Auftrag"],
        JobTitleSelf: ["Send a first job to yourself", "Envíate una primera tarea", "Schick dir selbst einen ersten Auftrag"],
        JobWhy: [
            "Pick an address, a time and a person. The job lands on their phone with a sound.",
            "Elige una dirección, una hora y una persona. La tarea llega a su teléfono con un sonido.",
            "Wähl Adresse, Uhrzeit und Person. Der Auftrag landet mit einem Ton auf dem Handy.",
        ],
        OwnPhoneJob: ["Send one to my own phone", "Enviar una a mi teléfono", "Einen an mein Handy schicken"],
        OwnPhoneJobSent: ["Sent to your phone. Open the app to try it.", "Enviada a tu teléfono. Abre la app para probarla.", "An dein Handy geschickt. Öffne die App und probier ihn aus."],
        JobDone: ["{0} is on a phone.", "{0} ya está en un teléfono.", "{0} ist auf einem Handy."],
        JobDoneSelf: ["{0} is on your phone.", "{0} ya está en tu teléfono.", "{0} ist auf deinem Handy."],
        ProofTitle: ["Get proof back from the job", "Recibe pruebas de cada tarea", "Hol dir Nachweise vom Auftrag"],
        ProofWhy: [
            "Add the {0} form. It's filled in on site, with photos, and lands on the job.",
            "Agrega el formulario {0}. Se llena en el lugar, con fotos, y queda en la tarea.",
            "Füg das Formular {0} hinzu. Es wird vor Ort ausgefüllt, mit Fotos, und landet am Auftrag.",
        ],
        FormButton: ["Add {0}", "Agregar {0}", "{0} hinzufügen"],
        FormAddedShort: ["{0} added", "{0} agregado", "{0} hinzugefügt"],
        FormAdded: [
            "{0} added. New jobs come with it.",
            "{0} agregado. Las tareas nuevas lo incluyen.",
            "{0} hinzugefügt. Neue Aufträge haben es dabei.",
        ],
        FormAddedPlaces: [
            "{0} added. It's in the app, and new places come with it.",
            "{0} agregado. Está en la app y los lugares nuevos lo incluyen.",
            "{0} hinzugefügt. Es ist in der App, und neue Orte haben es dabei.",
        ],
        ProofDone: ["{0} came back done, with proof.", "{0} volvió lista, con pruebas.", "{0} kam erledigt zurück, mit Nachweis."],
        EtaTitle: ["Let customers see you coming", "Que tus clientes te vean llegar", "Lass Kunden sehen, wann ihr kommt"],
        EtaWhy: [
            "When someone taps On the way, the customer gets an email with the arrival time and a live map.",
            "Cuando alguien toca En camino, el cliente recibe un correo con la hora de llegada y un mapa en vivo.",
            "Wenn jemand auf Unterwegs tippt, bekommt der Kunde eine E-Mail mit der Ankunftszeit und einer Live-Karte.",
        ],
        EtaButton: ["Turn on arrival emails", "Activar correos de llegada", "Ankunfts-E-Mails einschalten"],
        EtaDone: ["Arrival emails are on.", "Los correos de llegada están activados.", "Ankunfts-E-Mails sind an."],
        SitesTitle: ["Add your first site", "Agrega tu primer sitio", "Leg dein erstes Objekt an"],
        SitesWhy: ["Type the building's address. It becomes a place on the map, and visits there are counted on their own.", "Escribe la dirección del edificio. Se convierte en un lugar en el mapa y las visitas allí se cuentan solas.", "Gib die Adresse des Gebäudes ein. Es wird ein Ort auf der Karte, und Besuche dort werden automatisch gezählt."],
        ClientsTitle: ["Add your first client's home", "Agrega la casa de tu primer cliente", "Leg das Zuhause deines ersten Klienten an"],
        ClientsWhy: ["Type the address. It becomes a place on the map, and visits there are counted on their own.", "Escribe la dirección. Se convierte en un lugar en el mapa y las visitas allí se cuentan solas.", "Gib die Adresse ein. Sie wird ein Ort auf der Karte, und Besuche dort werden automatisch gezählt."],
        CustomersTitle: ["Add your first customer", "Agrega tu primer cliente", "Leg deinen ersten Kunden an"],
        CustomersWhy: ["Type the customer's address. It becomes a place on the map, and visits there are counted on their own.", "Escribe la dirección del cliente. Se convierte en un lugar en el mapa y las visitas allí se cuentan solas.", "Gib die Adresse des Kunden ein. Sie wird ein Ort auf der Karte, und Besuche dort werden automatisch gezählt."],
        GuardSitesTitle: ["Add the first site you guard", "Agrega el primer sitio que vigilas", "Leg das erste Objekt an, das ihr bewacht"],
        GuardSitesWhy: ["Type the site's address. Every round there is counted on its own, with the time on site.", "Escribe la dirección del sitio. Cada ronda allí se cuenta sola, con el tiempo en el lugar.", "Gib die Adresse des Objekts ein. Jede Runde dort wird automatisch gezählt, mit der Zeit vor Ort."],
        ImportButton: ["Import a spreadsheet", "Importar una hoja de cálculo", "Tabelle importieren"],
        AddOne: ["Add one", "Agregar uno", "Einzeln anlegen"],
        ZoneButton: ["Draw a zone", "Dibujar una zona", "Zone zeichnen"],
        PlacesDone: ["{0} places are on the map.", "{0} lugares están en el mapa.", "{0} Orte sind auf der Karte."],
        PlaceDone: ["{0} is on the map.", "{0} está en el mapa.", "{0} ist auf der Karte."],
        TimeOnSiteTitle: ["See time on site, counted for you", "Mira el tiempo en cada sitio, contado solo", "Seht die Zeit vor Ort, automatisch gezählt"],
        TimeOnSiteWhy: [
            "When someone arrives at a site, they're checked in. No buttons, no paper.",
            "Cuando alguien llega a un sitio, queda registrado. Sin botones ni papel.",
            "Wer an einem Objekt ankommt, wird eingecheckt. Ohne Knöpfe, ohne Papier.",
        ],
        VisitsTitle: ["Arrivals counted on their own", "Llegadas contadas solas", "Ankünfte zählen sich von selbst"],
        VisitsWhy: [
            "Every stop at a customer is recorded with the time spent.",
            "Cada parada con un cliente queda registrada con el tiempo que duró.",
            "Jeder Halt bei einem Kunden wird mit der Dauer aufgezeichnet.",
        ],
        PopupsButton: ["Show arrivals as they happen", "Mostrar las llegadas al momento", "Ankünfte sofort anzeigen"],
        PopupsOn: ["You'll see each arrival here as it happens.", "Verás cada llegada aquí en el momento.", "Du siehst hier jede Ankunft, sobald sie passiert."],
        VisitNoteTitle: ["Every visit, on record", "Cada visita, registrada", "Jeder Besuch, festgehalten"],
        VisitNoteWhy: [
            "Arrival and departure are recorded at the client's door. The {0} form adds what was done.",
            "La llegada y la salida quedan registradas en la puerta del cliente. El formulario {0} agrega lo que se hizo.",
            "Ankunft und Abfahrt werden an der Tür aufgezeichnet. Das Formular {0} hält fest, was gemacht wurde.",
        ],
        VisitReportTitle: ["Visits counted on their own", "Visitas contadas solas", "Besuche zählen sich von selbst"],
        VisitReportWhy: [
            "Every stop at a customer is recorded with the time spent. The {0} form adds notes.",
            "Cada parada con un cliente queda registrada con el tiempo que duró. El formulario {0} agrega notas.",
            "Jeder Halt bei einem Kunden wird mit der Dauer aufgezeichnet. Das Formular {0} ergänzt Notizen.",
        ],
        CheckinDone: ["The first check-in happened on its own.", "El primer check-in se registró solo.", "Der erste Check-in kam von selbst."],
        CheckinDoneAt: ["Checked in at {0}, on its own.", "Check-in en {0}, registrado solo.", "Bei {0} eingecheckt, von selbst."],
        AlertsTitle: ["Know when a round starts", "Entérate cuando empieza una ronda", "Wisst, wann eine Runde beginnt"],
        AlertsWhy: [
            "Get an email when someone arrives at a site. Pick the sites and who gets it.",
            "Recibe un correo cuando alguien llega a un sitio. Elige los sitios y quién lo recibe.",
            "Bekomm eine E-Mail, wenn jemand an einem Objekt ankommt. Wähl die Objekte und wer sie bekommt.",
        ],
        AlertsButton: ["Set up arrival alerts", "Configurar alertas de llegada", "Ankunftsalarme einrichten"],
        AlertsName: ["Arrivals", "Llegadas", "Ankünfte"],
        AlertsDone: ["Arrival alerts are on.", "Las alertas de llegada están activadas.", "Ankunftsalarme sind an."],
        WeeklyTimesheetTitle: ["Get the timesheet every Monday", "Recibe las horas cada lunes", "Bekomm jeden Montag die Stundenliste"],
        WeeklyTimesheetWhy: [
            "Hours per person as a spreadsheet in your inbox.",
            "Las horas de cada persona en una hoja de cálculo en tu correo.",
            "Die Stunden pro Person als Tabelle in deinem Postfach.",
        ],
        WeeklyVisitsTitle: ["Visits report every Monday", "Informe de visitas cada lunes", "Jeden Montag der Besuchsbericht"],
        WeeklyVisitsWhy: [
            "Time at each place, ready for billing.",
            "El tiempo en cada lugar, listo para facturar.",
            "Die Zeit an jedem Ort, fertig für die Abrechnung.",
        ],
        WeeklySiteVisitsTitle: ["Site visits every Monday", "Visitas a sitios cada lunes", "Jeden Montag die Objektbesuche"],
        WeeklySiteVisitsWhy: [
            "Every visit to each site with its times, as a spreadsheet.",
            "Cada visita a cada sitio con sus horas, en una hoja de cálculo.",
            "Jeder Besuch an jedem Objekt mit Zeiten, als Tabelle.",
        ],
        WeeklyMileageTitle: ["Mileage every Monday", "Kilometraje cada lunes", "Jeden Montag die Kilometer"],
        WeeklyMileageWhy: [
            "Kilometers per person, ready for expenses.",
            "Kilómetros por persona, listos para gastos.",
            "Kilometer pro Person, fertig für die Spesen.",
        ],
        WeeklyNeedsPlaces: ["Add a place first, so the report has something to count.", "Primero agrega un lugar, así el informe tiene algo que contar.", "Leg zuerst einen Ort an, damit der Bericht etwas zu zählen hat."],
        WeeklyDone: ["It arrives every Monday.", "Llega cada lunes.", "Er kommt jeden Montag."],
        StopsTitle: ["Import today's stops", "Importa las paradas de hoy", "Importier die Stopps von heute"],
        StopsWhy: [
            "Upload a spreadsheet. Each stop becomes a job with an address.",
            "Sube una hoja de cálculo. Cada parada se vuelve una tarea con dirección.",
            "Lad eine Tabelle hoch. Jeder Stopp wird ein Auftrag mit Adresse.",
        ],
        StopsDone: ["The stops are in.", "Las paradas ya están.", "Die Stopps sind drin."],
        RouteTitle: ["Plan a route", "Planifica una ruta", "Plan eine Route"],
        RouteWhy: [
            "Give someone two or more stops on a day. They get them in order on the phone.",
            "Dale a alguien dos o más paradas en un día. Las recibe en orden en el teléfono.",
            "Gib jemandem zwei oder mehr Stopps an einem Tag. Das Handy zeigt sie der Reihe nach.",
        ],
        RouteButton: ["Open Dispatch", "Abrir Despacho", "Disposition öffnen"],
        RouteDone: ["A route is planned.", "Hay una ruta planificada.", "Eine Route ist geplant."],
        PodTitle: ["Proof of delivery", "Prueba de entrega", "Liefernachweis"],
        PodWhy: [
            "Add the {0} form: a photo and the recipient's name at every stop.",
            "Agrega el formulario {0}: una foto y el nombre de quien recibe en cada parada.",
            "Füg das Formular {0} hinzu: ein Foto und der Name des Empfängers bei jedem Stopp.",
        ],
        TeamTitle: ["Get the whole team on the map", "Pon a todo el equipo en el mapa", "Bring das ganze Team auf die Karte"],
        TeamWhy: [
            "Share the same link with everyone. Each person shows up as they join.",
            "Comparte el mismo enlace con todos. Cada persona aparece al unirse.",
            "Teil denselben Link mit allen. Jede Person erscheint, sobald sie beitritt.",
        ],
        TeamDone: ["{0} people are on the map.", "{0} personas están en el mapa.", "{0} Personen sind auf der Karte."],
        DayTitle: ["Look back at a day", "Revisa un día", "Schau dir einen Tag an"],
        DayWhy: [
            "Every drive and stop is recorded. Open any day in Location History.",
            "Cada viaje y parada queda registrado. Abre cualquier día en el historial.",
            "Jede Fahrt und jeder Stopp wird aufgezeichnet. Öffne jeden Tag im Standortverlauf.",
        ],
        DayButton: ["Open Location History", "Abrir el historial", "Standortverlauf öffnen"],
        DayDone: ["The first day of trips is recorded.", "El primer día de viajes está registrado.", "Der erste Tag mit Fahrten ist aufgezeichnet."],
        FormserviceReport: ["Service report", "Reporte de servicio", "Servicebericht"],
        FormsiteChecklist: ["Site checklist", "Lista del sitio", "Objekt-Checkliste"],
        FormvisitNote: ["Visit note", "Nota de visita", "Besuchsnotiz"],
        FormpatrolCheck: ["Patrol check", "Control de ronda", "Kontrollgang"],
        FormproofOfDelivery: ["Proof of delivery", "Prueba de entrega", "Liefernachweis"],
        FormvisitReport: ["Visit report", "Reporte de visita", "Besuchsbericht"],
        FieldWorkDone: ["Work done", "Trabajo realizado", "Erledigte Arbeiten"],
        FieldPartsUsed: ["Parts used", "Piezas usadas", "Verwendetes Material"],
        FieldPhotoBefore: ["Photo before", "Foto antes", "Foto vorher"],
        FieldPhotoAfter: ["Photo after", "Foto después", "Foto nachher"],
        FieldAreasDone: ["Areas done", "Áreas listas", "Erledigte Bereiche"],
        FieldPhoto: ["Photo", "Foto", "Foto"],
        FieldIssue: ["Anything to report?", "¿Algo que reportar?", "Etwas zu melden?"],
        FieldTasksDone: ["Tasks done", "Tareas realizadas", "Erledigte Aufgaben"],
        FieldNotes: ["Notes", "Notas", "Notizen"],
        FieldAllClear: ["All clear", "Todo en orden", "Alles in Ordnung"],
        FieldIncident: ["Incident", "Incidente", "Vorfall"],
        FieldRecipient: ["Recipient's name", "Nombre de quien recibe", "Name des Empfängers"],
        FieldContact: ["Contact", "Contacto", "Ansprechpartner"],
        FieldOutcome: ["Outcome", "Resultado", "Ergebnis"],
        FieldNextStep: ["Next step", "Siguiente paso", "Nächster Schritt"],
        SampleSites: ["24 sites", "24 sitios", "24 Objekte"],
        SampleClients: ["38 clients", "38 clientes", "38 Klienten"],
        SampleCustomers: ["120 customers", "120 clientes", "120 Kunden"],
        SampleStops: ["9 stops", "9 paradas", "9 Stopps"],
        SampleZone: ["Zone added", "Zona agregada", "Zone angelegt"],
        SampleCheckedIn: ["Checked in · {0}", "Check-in · {0}", "Eingecheckt · {0}"],
        SampleArrived: ["{0} arrived at {1}", "{0} llegó a {1}", "{0} ist bei {1} angekommen"],
        SampleAlert: ["{0} · Alert", "{0} · Alerta", "{0} · Alarm"],
        SampleOnMap: ["{0} on the map", "{0} en el mapa", "{0} auf der Karte"],
        SampleRoute: ["{0} stops · {1} km", "{0} paradas · {1} km", "{0} Stopps · {1} km"],
        SampleParcel: ["Parcel for {0}", "Paquete para {0}", "Paket für {0}"],
        SampleOwnJob: ["Try it: tap On the way, then Done", "Pruébala: toca En camino y luego Listo", "Probier's aus: tipp auf Unterwegs, dann Erledigt"],
    },
    HelpFilms: {
        Roles: ["Worker, operator and administrator", "Trabajador, operador y administrador", "Mitarbeiter, Disponent und Administrator"],
        Jobs: ["How to create a job", "Cómo crear una tarea", "Einen Auftrag anlegen"],
        Settings: ["Company settings and permissions", "Configuración de la empresa y permisos", "Unternehmenseinstellungen und Berechtigungen"],
        Gps: ["Common GPS and tracking issues", "Problemas de GPS y seguimiento", "GPS- und Tracking-Probleme"],
        Invites: ["Create, share and delete an invite code", "Crear, compartir y eliminar un código de invitación", "Einladungscodes erstellen, teilen und löschen"],
        Integrations: ["APIs and integrations", "APIs e integraciones", "APIs & Integrationen"],
        ThisPage: ["Watch how this page works", "Mira cómo funciona esta página", "So funktioniert diese Seite"],
        CreateJobs: ["3 ways to create jobs", "3 formas de crear tareas", "3 Wege, Aufträge anzulegen"],
        Importing: ["Watch how importing works", "Mira cómo funciona la importación", "So funktioniert der Import"],
        RolesExplained: ["Roles explained", "Los roles, explicados", "Die Rollen erklärt"],
        InviteCodes: ["How invite codes work", "Cómo funcionan los códigos de invitación", "So funktionieren Einladungscodes"],
        TracksOff: ["Why tracks can look off", "Por qué un recorrido puede verse raro", "Warum Spuren seltsam aussehen können"],
        HowIntegrations: ["Watch how integrations work", "Mira cómo funcionan las integraciones", "So funktionieren Integrationen"],
        Videos: ["Videos", "Videos", "Videos"],
        ShortVideos: ["{0} short videos", "{0} videos cortos", "{0} kurze Videos"],
        Watched: ["Watched", "Visto", "Angesehen"],
        Chapters: ["Chapters", "Capítulos", "Kapitel"],
        KeepPlaying: ["Keep playing while I work", "Seguir viendo mientras trabajo", "Weiterschauen, während ich arbeite"],
        BackToWindow: ["Back to the full window", "Volver a la ventana completa", "Zurück ins große Fenster"],
        OpenHelpCenter: ["Open the help center", "Abrir el centro de ayuda", "Hilfe-Center öffnen"],
        Language: ["Language", "Idioma", "Sprache"],
        PlayVideo: ["Play the video: {0}", "Reproducir el video: {0}", "Video abspielen: {0}"],
    },
    Trial: {
        DaysLeft: ["Your trial · {0} days left", "Tu prueba · quedan {0} días", "Deine Testphase · noch {0} Tage"],
        AskTitle: ["Pick your plan now, pay from {0}", "Elige tu plan ahora y paga desde el {0}", "Wähl jetzt deinen Tarif, zahlen erst ab {0}"],
        AskText: ["Your trial runs until {0} either way. With a card on file, nothing changes for your team when it ends.", "Tu prueba sigue hasta el {0} de todos modos. Con una tarjeta guardada, nada cambia para tu equipo cuando termine.", "Deine Testphase läuft so oder so bis {0}. Mit hinterlegter Karte ändert sich für dein Team nichts, wenn sie endet."],
        NoChargeUntil: ["Nothing is charged before {0}. Cancel before then and you pay nothing.", "No se cobra nada antes del {0}. Si cancelas antes, no pagas nada.", "Vor dem {0} wird nichts abgebucht. Kündigst du vorher, zahlst du nichts."],
        ChargedToday: ["{0} a month from today. Cancel any time.", "{0} al mes desde hoy. Cancela cuando quieras.", "{0} im Monat ab heute. Jederzeit kündbar."],
        RemindTomorrow: ["Remind me tomorrow", "Recuérdamelo mañana", "Morgen erinnern"],
        BannerStake: ["Without a card, the dashboard pauses then.", "Sin tarjeta, el panel se pausa ese día.", "Ohne Karte pausiert das Dashboard dann."],
        ChipDaysLeft: ["Trial · {0} days left", "Prueba · quedan {0} días", "Testphase · noch {0} Tage"],
        ChipLastDay: ["Trial · last day", "Prueba · último día", "Testphase · letzter Tag"],
        ChipFreeUntil: ["Free until {0}", "Gratis hasta el {0}", "Gratis bis {0}"],
        ChipFits: ["{0} fits your team", "{0} encaja con tu equipo", "{0} passt zu deinem Team"],
        ChipPick: ["Choose your plan any time", "Elige tu plan cuando quieras", "Wähl deinen Tarif, wann du willst"],
        ChipChosen: ["{0} starts {1}", "{0} empieza el {1}", "{0} startet am {1}"],
        ChipCardSaved: ["Card saved. Nothing is charged before then.", "Tarjeta guardada. No se cobra nada antes.", "Karte hinterlegt. Vorher wird nichts abgebucht."],
        SavedTrial: ["Card saved. {0} starts {1}; nothing is charged before.", "Tarjeta guardada. {0} empieza el {1}; antes no se cobra nada.", "Karte hinterlegt. {0} startet am {1}, vorher wird nichts abgebucht."],
        SavedEnded: ["Thank you! {0} is on.", "¡Gracias! {0} está activo.", "Danke! {0} ist aktiv."],
        TeamTimes: ["{0} people × {1}", "{0} personas × {1}", "{0} Personen × {1}"],
        MonthTotal: ["{0} a month", "{0} al mes", "{0} im Monat"],
        ChooseX: ["Choose {0}", "Elegir {0}", "{0} wählen"],
        EndsOn: ["Your trial ends {0}.", "Tu prueba termina el {0}.", "Deine Testphase endet am {0}."],
        ChoosePlan: ["Choose your plan", "Elige tu plan", "Wähle deinen Tarif"],
        EndedTitle: ["Your trial has ended. Everything is saved.", "Tu prueba terminó. Todo está guardado.", "Deine Testphase ist vorbei. Alles ist gespeichert."],
        EndedText: ["Your team, places and history stay exactly as they are. Pick a plan and carry on.", "Tu equipo, tus lugares y el historial siguen tal como están. Elige un plan y continúa.", "Dein Team, deine Orte und der Verlauf bleiben genau so. Wähl einen Tarif und mach weiter."],
        InYourTrial: ["In your trial", "En tu prueba", "In deiner Testphase"],
        StatOnMapOf: ["of {0} on the map", "de {0} en el mapa", "von {0} auf der Karte"],
        StatTrips: ["trips", "viajes", "Fahrten"],
        StatVisits: ["visits", "visitas", "Besuche"],
        StatJobs: ["jobs sent", "tareas enviadas", "Aufträge"],
        Question: ["Do you tell your team what to do each day?", "¿Le dices a tu equipo qué hacer cada día?", "Sagst du deinem Team jeden Tag, was zu tun ist?"],
        Forlocation: ["No, they know their round.", "No, conocen su ruta.", "Nein, sie kennen ihre Runde."],
        Fordispatch: ["Yes: addresses, tasks, times.", "Sí: direcciones, tareas, horarios.", "Ja: Adressen, Aufgaben, Zeiten."],
        Whatlocation: ["Places: where your team goes. The phone records arrivals, time on site and trips on its own.", "Lugares: a dónde va tu equipo. El celular registra solo las llegadas, el tiempo en el sitio y los viajes.", "Orte: wohin dein Team fährt. Das Handy zeichnet Ankunft, Zeit vor Ort und Fahrten von selbst auf."],
        Whatdispatch: ["Jobs: what, where, who and when. Sent to the phone, back with status, photos, signature and forms.", "Tareas: qué, dónde, quién y cuándo. Llegan al celular y vuelven con estado, fotos, firma y formularios.", "Aufträge: was, wo, wer und wann. Aufs Handy geschickt, zurück mit Status, Fotos, Unterschrift und Formularen."],
        Gotlocation: ["Live map and history; Places and visits; Timesheets and mileage; Reports by email", "Mapa en vivo e historial; Lugares y visitas; Horas y kilometraje; Informes por correo", "Live-Karte und Verlauf; Orte und Besuche; Arbeitszeiten und Kilometer; Berichte per E-Mail"],
        Gotdispatch: ["Everything in Location; Jobs and routes; Photos, signatures and forms; Customers see you coming", "Todo lo de Location; Tareas y rutas; Fotos, firmas y formularios; Tus clientes te ven llegar", "Alles aus Location; Aufträge und Routen; Fotos, Unterschriften und Formulare; Kunden sehen dich kommen"],
        FitsUse: ["Fits what you used", "Encaja con lo que usaste", "Passt zu deiner Nutzung"],
        PerPerson: ["per person a month", "por persona al mes", "pro Person im Monat"],
        BilledYearly: ["per person a month, billed yearly", "por persona al mes, facturado anualmente", "pro Person im Monat, jährlich abgerechnet"],
        Monthly: ["Monthly", "Mensual", "Monatlich"],
        YearlySave: ["Yearly · save {0} a person", "Anual · ahorra {0} por persona", "Jährlich · spare {0} pro Person"],
        CardNumber: ["Card number", "Número de tarjeta", "Kartennummer"],
        CardExpiry: ["MM / YY", "MM / AA", "MM / JJ"],
        StartX: ["Start {0}", "Empezar con {0}", "Mit {0} starten"],
        TalkToUs: ["Not sure? Talk to us, 15 minutes", "¿No estás seguro? Habla con nosotros, 15 minutos", "Unsicher? Sprich mit uns, 15 Minuten"],
    },
    Upsell: {
        Kicker: ["With Dispatch", "Con Dispatch", "Mit Dispatch"],
        DispatchTitle: ["Give every stop a time and a person.", "Cada parada con su hora y su persona.", "Jeder Stopp bekommt eine Zeit und eine Person."],
        DispatchText: [
            "Drop a job on someone's day. The route draws itself and their phone gets it.",
            "Arrastra una tarea al día de alguien. La ruta se dibuja sola y su teléfono la recibe.",
            "Zieh einen Auftrag in den Tag von jemandem. Die Route zeichnet sich von selbst, und sein Handy bekommt ihn.",
        ],
        PlannerTitle: ["Plan next week by dragging.", "Planifica la próxima semana arrastrando.", "Plane die nächste Woche per Ziehen."],
        PlannerText: [
            "See everyone's week side by side. Move a job to another day or person and the hours follow.",
            "Ve la semana de todos, lado a lado. Mueve una tarea a otro día o a otra persona y las horas se ajustan.",
            "Sieh die Woche von allen nebeneinander. Schieb einen Auftrag auf einen anderen Tag oder zu jemand anderem, und die Stunden passen sich an.",
        ],
        CoDispatchTitle: ["Co-Dispatch sorts the day. You say yes.", "Co-Dispatch ordena el día. Tú dices que sí.", "Co-Dispatch sortiert den Tag. Du sagst Ja."],
        CoDispatchText: [
            "It finds the closer person and the shorter order, and tells you why.",
            "Encuentra a la persona más cercana y el orden más corto, y te dice por qué.",
            "Es findet die Person, die näher dran ist, und die kürzere Reihenfolge, und sagt dir, warum.",
        ],
        JobsTitle: ["Your customer knows when you'll arrive.", "Tu cliente sabe cuándo llegas.", "Deine Kunden wissen, wann ihr kommt."],
        JobsText: [
            "When the worker heads out, the customer can get an email with a live map and the arrival time.",
            "Cuando el técnico sale, el cliente puede recibir un correo con un mapa en vivo y la hora de llegada.",
            "Sobald dein Mitarbeiter losfährt, kann der Kunde eine E-Mail mit Live-Karte und Ankunftszeit bekommen.",
        ],
        FormsTitle: ["The checklist gets done on site.", "La lista se completa en el sitio.", "Die Checkliste wird vor Ort erledigt."],
        FormsText: [
            "Checklist, signature, Done. The office sees what happened the moment it's tapped.",
            "Lista, firma y Hecho. En la oficina ves al momento lo que pasó.",
            "Checkliste, Unterschrift, Erledigt. Im Büro siehst du sofort, was passiert ist.",
        ],
        PhotosTitle: ["Proof from every job.", "Pruebas de cada tarea.", "Ein Nachweis für jeden Auftrag."],
        PhotosText: [
            "Photos land on the job with the time and the place, while the worker is still there.",
            "Las fotos llegan a la tarea con la hora y el lugar, mientras el técnico sigue allí.",
            "Fotos landen mit Zeit und Ort am Auftrag, während dein Mitarbeiter noch vor Ort ist.",
        ],
        SampleData: ["Sample data. Click to pause.", "Datos de ejemplo. Haz clic para pausar.", "Beispieldaten. Klick zum Pausieren."],
        AskAdmin: [
            "Only an admin can change the plan. Ask yours about Dispatch.",
            "Solo un administrador puede cambiar el plan. Pregúntale al tuyo por Dispatch.",
            "Nur ein Admin kann den Plan ändern. Frag deinen Admin nach Dispatch.",
        ],
        WatchFilm: ["Watch the film", "Ver el video", "Film ansehen"],
        Pause: ["Pause", "Pausar", "Pausieren"],
        Play: ["Play", "Reproducir", "Abspielen"],
    },
    Plan: {
        YourPlan: ["Your plan", "Tu plan", "Dein Plan"],
        SelectPlan: ["Select plan", "Seleccionar plan", "Wähle einen Plan aus"],
        YourCurrentPlanIsX: ["Your current plan is {0}", "Tu plan actual es {0}", "Dein aktueller Plan ist {0}"],
        LegacyPlanDescription: [
            "This is our standard Classic Plan. You have the option to continue with this plan until March 31, 2024. Alternatively, you can explore our other plans, such as those offering annual discounts, available for selection today. If you require further details or have any questions, please don't hesitate to ask.",
            "Este es nuestro plan Clásico estándar. Puedes continuar con este plan hasta el 31 de marzo de 2024. Alternativamente, puedes explorar nuestros otros planes, como aquellos que ofrecen descuentos anuales, disponibles para seleccionar hoy. Si necesitas más detalles o tienes alguna pregunta, no dudes en preguntar.",
            "Dies ist unser Standard Classic Plan. Du kannst diesen Plan bis zum 31. März 2024 beibehalten. Alternativ kannst du unsere anderen Pläne erkunden, wie zum Beispiel diejenigen, die jährliche Rabatte bieten, die heute zur Auswahl stehen. Wenn du weitere Details benötigst oder Fragen hast, zögere bitte nicht zu fragen.",
        ],
        SeeAllFeatures: ["See all features", "Ver todas las características", "Sieh dir alle Funktionen an"],
        SelectCurrency: ["Select currency", "Seleccionar moneda", "Währung auswählen"],
        Monthly: ["Monthly", "Mensual", "Monatlich"],
        Yearly: ["Annual", "Anual", "Jährlich"],
        Aprox: ["approx.", "aprox.", "ca."],
        SwitchPlanPrompt: [
            "Do you wish to switch to this new plan?",
            "¿Deseas cambiar a este nuevo plan?",
            "Möchtest du zu diesem neuen Plan wechseln?",
        ],
        PlanChangeBlockedOverdue: [
            "You have an overdue invoice we couldn't charge. Please update your payment method first — then you can switch plans.",
            "Tienes una factura vencida que no pudimos cobrar. Actualiza primero tu método de pago y luego podrás cambiar de plan.",
            "Du hast eine überfällige Rechnung, die wir nicht abbuchen konnten. Aktualisiere zuerst deine Zahlungsmethode — danach kannst du den Plan wechseln.",
        ],
        ChoosePlanInBilling: [
            "Choose your plan in Billing",
            "Elige tu plan en Facturación",
            "Wähle deinen Plan unter Zahlungsdaten",
        ],
        ClickHereToLearnMore: [
            "Click here to learn more",
            "Haz clic aquí para saber más",
            "Klicke hier, um mehr zu erfahren",
        ]
    },
    LocationFeatures: {
        RealTimeLocation: ["Real-time location", "Ubicación en tiempo real", "Echtzeit-Standort"],
        UnlimitedLocationHistory: [
            "Unlimited location history (route recording)",
            "Historial de ubicación ilimitado (registro de ruta)",
            "Unbegrenzter Standortverlauf (Routenaufzeichnung)"
        ],
        Geofencing: [
            "Geofencing - auto check-ins/outs",
            "Geocercas - check-ins/check-outs automáticos",
            "Geofencing - Automatische Check-ins/-outs"
        ],
        OnsiteTimeRecording: [
            "Onsite time recording at POI / client location",
            "Registro de tiempo en el lugar en POI / ubicación del cliente",
            "Zeiterfassung vor Ort bei POI / Kundenstandort"
        ],
        Zones: [
            "Zones (highlight areas, alerting)",
            "Zonas (resaltar áreas, alertas)",
            "Zonen (Hervorhebung von Bereichen, Alarmierung)"
        ],
        TimeTracker: [
            "Time tracker (recording work hours)",
            "Control de horas (registro de horas de trabajo)",
            "Zeiterfassung (Aufzeichnung der Arbeitsstunden)"
        ],
        Alerts: [
            "Alerts for idling, outside geofence and more",
            "Alertas por inactividad, fuera de geocerca y más",
            "Alarme bei Leerlauf, außerhalb des Geofence und mehr"
        ],
        Reports: [
            "Reports for mileage and onsite times",
            "Informes de kilometraje y tiempos en el lugar",
            "Berichte über Kilometer und Vor-Ort-Zeiten"
        ]
    },
    DispatchFeatures: {
        HellotracksLocation: [
            "All features from Hellotracks Location",
            "Todas las características de Hellotracks Location",
            "Alle Funktionen von Hellotracks Location",
        ],
        JobScheduling: [
            "Job scheduling",
            "Programación de tareas",
            "Auftragsplanung",
        ],
        AutoDispatch: [
            "Auto-Dispatch",
            "Despacho automático",
            "Auto-Dispatch",
        ],
        RouteOptimization: [
            "Route optimization (mileage and time saving)",
            "Optimización de ruta (ahorro de kilometraje y tiempo)",
            "Routenoptimierung (Kilometer- und Zeiteinsparung)",
        ],
        OnsiteTimeRecordingJobs: [
            "Onsite time recording at jobs / services",
            "Registro de tiempo en el lugar en tareas / servicios",
            "Zeiterfassung vor Ort bei Aufträgen / Dienstleistungen",
        ],
        ClientNotifications: [
            "Client notifications",
            "Notificaciones al cliente",
            "Kundenbenachrichtigungen",
        ],
        SignatureCapture: [
            "Signature capture",
            "Captura de firma",
            "Unterschriftserfassung",
        ],
        ImageUploads: [
            "Image uploads",
            "Subidas de imágenes",
            "Bild-Uploads",
        ],
        Forms: [
            "Forms (basic + advanced)",
            "Formularios (básicos + avanzados)",
            "Formulare (einfach + erweitert)",
        ],
        ReportsJobPerformance: [
            "All reports including job performance",
            "Todos los informes incluido el rendimiento de tareas",
            "Alle Berichte einschließlich Auftragsperformance",
        ],
        RecurringReports: [
            "Automated recurring reports",
            "Informes recurrentes automatizados",
            "Automatisierte wiederkehrende Berichte",
        ],
        Integrations: [
            "Integrations with Slack and Google Calendar",
            "Integraciones con Slack y Google Calendar",
            "Integrationen mit Slack und Google Kalender",
        ],
        APIAccess: [
            "API access",
            "Acceso a la API",
            "API-Zugriff",
        ],
        TwoFactorAuthentication: [
            "Two-factor authentication",
            "Autenticación de dos factores",
            "Zwei-Faktor-Authentifizierung",
        ],
    },
    DeviceDiagnostics: {
        DeviceDiagnostics: [
            "Device diagnostics",
            "Diagnóstico del dispositivo",
            "Gerätediagnostik"
        ],
        Description: [
            "The device diagnostics provides a visual representation of key device activities, such as location changes, app states, connectivity, and server communication, to aid in diagnostics and troubleshooting.",
            "El diagnóstico del dispositivo proporciona una representación visual de las actividades clave del dispositivo, como cambios de ubicación, estados de la aplicación, conectividad y comunicación con el servidor, para ayudar en el diagnóstico y la resolución de problemas.",
            "Die Gerätediagnostik bietet eine visuelle Darstellung wichtiger Geräteaktivitäten, wie Standortänderungen, App-Status, Konnektivität und Serverkommunikation, um bei der Diagnose und Fehlerbehebung zu helfen.",
        ],
        Trigger: [
            "Trigger new device diagnostics",
            "Activar nuevo diagnóstico del dispositivo",
            "Neue Gerätediagnostik auslösen",
        ],
        DeviceDiagnosticsRequest: [
            "Device diagnostics request",
            "Solicitud de diagnóstico del dispositivo",
            "Anfrage zur Gerätediagnostik"
        ],
        Requested: [
            "Request sent",
            "Solicitud enviada",
            "Anfrage gesendet"
        ],
        UnavailableNotLoggedIn: [
            "User is not logged into a mobile device.",
            "El usuario no ha iniciado sesión en un dispositivo móvil.",
            "Benutzer ist nicht auf einem mobilen Gerät angemeldet."
        ],
        UnavailableNeedsUpdate: [
            "User needs to update mobile device.",
            "El usuario necesita actualizar el dispositivo móvil.",
            "Benutzer muss das mobile Gerät aktualisieren."
        ],
        DeviceDiagnosticsUploaded: [
            "Device diagnostics uploaded:",
            "Diagnósticos del dispositivo subidos:",
            "Gerätediagnostik hochgeladen:"
        ],
        StartStopTrackingEvents: [
            "Start/stop tracking events",
            "Eventos de inicio/parada del seguimiento",
            "Start-/Stopp-Ereignisse des Trackings"
        ],
        TrackingEventsTooltip: [
            "Tracks start and stop events of location updates",
            "Registra eventos de inicio y detención de actualizaciones de ubicación",
            "Erfasst Start- und Stopp-Ereignisse von Standortaktualisierungen"
        ],
        WakeUpsRunningEvents: [
            "Wake-ups and running events",
            "Despertares y eventos en ejecución",
            "Aufwachen und laufende Ereignisse"
        ],
        WakeUpsRunningEventsTooltip: [
            "Displays wake-up triggers and running events. Blue for location updates running. Green for geofence exits.",
            "Muestra disparadores de despertar y eventos en ejecución. Azul para actualizaciones de ubicación en ejecución. Verde para salidas de geovalla.",
            "Zeigt Weckauslöser und laufende Ereignisse an. Blau für laufende Standortaktualisierungen. Grün für das Verlassen eines Geofence."
        ],
        AppStateEvents: [
            "App state events",
            "Eventos de estado de la app",
            "App-Zustandsereignisse"
        ],
        AppStateEventsTooltip: [
            "Shows different states of the app. Blue for app launched events. Green for app active state. Orange for app background state. Red for app terminated.",
            "Muestra los diferentes estados de la aplicación. Azul para eventos de aplicación lanzada. Verde para estado activo de la aplicación. Naranja para estado en segundo plano de la aplicación. Rojo para aplicación terminada.",
            "Zeigt verschiedene Zustände der App an. Blau für gestartete App-Ereignisse. Grün für den aktiven Zustand der App. Orange für den Hintergrundzustand der App. Rot für beendete App."
        ],
        BackgroundTickEvents: [
            "Background tick events",
            "Eventos de marcado en segundo plano",
            "Hintergrund-Tick-Ereignisse"
        ],
        BackgroundTickEventsTooltip: [
            "Indicates background tick occurrences. Green for periodic foreground ticks. Black/white for periodic background ticks.",
            "Indica ocurrencias de marcado en segundo plano. Verde para marcas periódicas en primer plano. Blanco/negro para marcas periódicas en segundo plano.",
            "Zeigt Vorkommnisse von Hintergrund-Ticks an. Grün für periodische Vordergrund-Ticks. Schwarz/Weiß für periodische Hintergrund-Ticks."
        ],
        LocationUploadEvents: [
            "Location upload events",
            "Eventos de carga de ubicación",
            "Standort-Upload-Ereignisse"
        ],
        LocationUploadEventsTooltip: [
            "Logs events of location data uploads. Purple for uploads via API. Black/white for uploads via WebSocket.",
            "Registra eventos de cargas de datos de ubicación. Púrpura para cargas a través de API. Blanco/negro para cargas a través de WebSocket.",
            "Protokolliert Ereignisse von Standortdaten-Uploads. Lila für Uploads über API. Schwarz/Weiß für Uploads über WebSocket."
        ],
        ConnectivityEvents: [
            "Connectivity events",
            "Eventos de conectividad",
            "Konnektivitätsereignisse"
        ],
        ConnectivityEventsTooltip: [
            "Monitors connectivity changes. Green for when the device is online. Gray for when the device goes offline.",
            "Monitorea los cambios de conectividad. Verde cuando el dispositivo está en línea. Gris cuando el dispositivo está desconectado.",
            "Überwacht Konnektivitätsänderungen. Grün, wenn das Gerät online ist. Grau, wenn das Gerät offline geht."
        ],
        WebsocketConnectivity: [
            "WebSocket events (connectivity)",
            "Eventos de WebSocket (conectividad)",
            "WebSocket-Ereignisse (Konnektivität)"
        ],
        WebsocketConnectivityTooltip: [
            "WebSocket connectivity status. Blue when connected. Orange when disconnected. Green upon successful connection attempt.",
            "Estado de la conectividad de WebSocket. Azul cuando está conectado. Naranja cuando está desconectado. Verde al intentar conectar con éxito.",
            "WebSocket-Konnektivitätsstatus. Blau bei Verbindung. Orange bei Trennung. Grün bei erfolgreichem Verbindungsversuch."
        ],
        WebsocketSendEvents: [
            "WebSocket send events",
            "Eventos de envío de WebSocket",
            "WebSocket-Sendevorgänge"
        ],
        WebsocketSendEventsTooltip: [
            "Tracks WebSocket send events. Purple for successful sends. Gray for send errors.",
            "Registra eventos de envío de WebSocket. Morado para envíos exitosos. Gris para errores de envío.",
            "Verfolgt WebSocket-Sendevorgänge. Lila für erfolgreiche Sendungen. Grau für Sendefehler."
        ],
        WebsocketReceiveEvents: [
            "WebSocket receive events",
            "Eventos de recepción de WebSocket",
            "WebSocket-Empfangsvorgänge"
        ],
        WebsocketReceiveEventsTooltip: [
            "Monitors received messages over WebSocket. Black/white indicates messages received.",
            "Monitorea los mensajes recibidos a través de WebSocket. El negro/blanco indica los mensajes recibidos.",
            "Überwacht empfangene Nachrichten über WebSocket. Schwarz/Weiß zeigt empfangene Nachrichten an."
        ],
        CheckInEvents: [
            "Check-in events",
            "Eventos de check-in",
            "Check-in-Ereignisse"
        ],
        CheckInEventsTooltip: [
            "Registered check-in and check-out events. Blue for place check-ins. Black/white for place check-outs. Purple for job check-ins. Gray for job check-outs.",
            "Eventos de check-in y check-out registrados. Azul para check-ins en lugares. Negro/blanco para check-outs en lugares. Morado para check-ins de tareas. Gris para check-outs de tareas.",
            "Registrierte Check-in- und Check-out-Ereignisse. Blau für Orts-Check-ins. Schwarz/Weiß für Orts-Check-outs. Lila für Auftrags-Check-ins. Grau für Auftrags-Check-outs."
        ],
    },
    Reorder: {
        RouteReorderOrderNumber: [
            "Reorder all jobs by order #",
            "Reordena todas las tareas por el número de orden",
            "Alle Aufträge nach Auftragsnummer neu ordnen"
        ],
        RouteReorderPriority: [
            "Reorder all jobs by priority",
            "Reordena todas las tareas por prioridad",
            "Alle Aufträge nach Priorität ordnen"
        ],
        ConfirmationReorder: [
            "This will re-sort all jobs in this route. Are you sure?",
            "Esto reordenará todas las tareas de esta ruta. ¿Estás seguro?",
            "Dadurch werden alle Aufträge dieser Route neu sortiert. Bist du sicher?"
        ],
        ReorderingState: [
            "Reordering",
            "Reordenando",
            "Neuordnung"
        ],
        ReorderAction: [
            "Reorder",
            "Reordenar",
            "Neu ordnen"
        ],
    },
    Sso: {
        ConfigurationHiddenDesc: [
            "Your configuration is securely stored and remains hidden for safety reasons.",
            "Tu configuración se almacena de forma segura y permanece oculta por razones de seguridad.",
            "Deine Konfiguration wird sicher gespeichert und aus Sicherheitsgründen verborgen."
        ],
        ChangeSsoConfiguration: [
            "Change SSO configuration",
            "Cambiar la configuración de SSO",
            "SSO-Konfiguration ändern"
        ],
        SetupSsoConfiguration: [
            "Set up SSO configuration",
            "Configurar SSO",
            "SSO-Konfiguration einrichten"
        ],
        EnterTenantID: [
            "Enter tenant ID",
            "Ingresar ID de tenant",
            "Tenant-ID eingeben",
        ],
        EnterClientID: [
            "Enter client ID",
            "Ingresar ID de cliente",
            "Client-ID eingeben"
        ],
        EnterClientSecret: [
            "Client secret (remains hidden for safety reasons)",
            "Secreto de cliente (permanece oculto por razones de seguridad)",
            "Client Secret (aus Sicherheitsgründen verborgen)"
        ],
        EnterRedirectUrl: [
            "Enter redirect URL",
            "Ingresar URL de redirección",
            "Redirect-URL eingeben"
        ],
        Notes: ['Notes', 'Notas', 'Notizen'],
        NotesContent: [
            "After a successful SSO login of a user that does not yet exist in Hellotracks, the user will automatically be created and the worker role will be assigned. To get into the SSO login page of your identity provider, you can either use an existing username in Hellotracks or set {0} as the username to get forwarded to the SSO login page of your identity provider.",
            "Después de un inicio de sesión SSO exitoso de un usuario que aún no existe en Hellotracks, el usuario será creado automáticamente y se le asignará el rol de trabajador. Para entrar en la página de inicio de sesión SSO de tu proveedor de identidad, puedes usar un nombre de usuario existente en Hellotracks o establecer {0} como el nombre de usuario para ser redirigido a la página de inicio de sesión SSO de tu proveedor de identidad.",
            "Nach einer erfolgreichen SSO-Anmeldung eines Benutzers, der in Hellotracks noch nicht existiert, wird der Benutzer automatisch erstellt und erhält die Rolle Mitarbeiter. Um auf die SSO-Anmeldeseite deines Identitätsanbieters zu gelangen, kannst du entweder einen vorhandenen Nutzernamen in Hellotracks verwenden oder {0} als Nutzernamen eingeben, um zur SSO-Anmeldeseite deines Identitätsanbieters weitergeleitet zu werden."
        ],
        LinkToLoginPage: [
            "Link to SSO login page",
            "Enlace a la página de inicio de sesión SSO",
            "Link zur SSO-Anmeldeseite",
        ],
        SelectIdentityProvider: [
            "Select identity provider",
            "Selecciona el proveedor de identidad",
            "Identitätsanbieter auswählen"
        ]
    },
    Approval: {
        Approval: [
            "Approval",
            "Aprobación",
            "Genehmigung"
        ],
        Notified: [
            "Notified",
            "Notificado",
            "Benachrichtigt"
        ],
        Pending: [
            "Pending",
            "Pendiente",
            "Ausstehend"
        ],
        Approved: [
            "Approved",
            "Aprobado",
            "Genehmigt"
        ],
        Disapproved: [
            "Rejected",
            "Rechazado",
            "Abgelehnt"
        ],
        Approve: [
            "Approve",
            "Aprobar",
            "Genehmigen"
        ],
        Disapprove: [
            "Reject",
            "Rechazar",
            "Ablehnen"
        ],
        ApprovedBy: [
            "Approved by",
            "Aprobado por",
            "Genehmigt von"
        ],
        Source: ["Source", "Origen", "Quelle"],
        SourceGps: ["GPS", "GPS", "GPS"],
        SourceManual: ["Manual", "Manual", "Manuell"],
        SourceEdited: ["Edited", "Editada", "Bearbeitet"],
        Recorded: ["Recorded", "Registrado", "Aufgezeichnet"],
        Entered: ["Entered", "Ingresado", "Eingegeben"],
        Routed: ["Routed", "Calculado", "Berechnet"],
        RecordedOn: ["Recorded {0}", "Registrado el {0}", "Aufgezeichnet am {0}"],
        EnteredOnBy: ["Entered {0} by {1}", "Ingresado el {0} por {1}", "Eingegeben am {0} von {1}"],
        EditedOnBy: ["Edited {0} by {1}", "Editado el {0} por {1}", "Bearbeitet am {0} von {1}"],
        RejectTrip: ["Reject trip", "Rechazar viaje", "Fahrt ablehnen"],
        RejectTripDesc: [
            "The worker sees this trip as rejected. You can add a note.",
            "El trabajador verá este viaje como rechazado. Puedes agregar una nota.",
            "Der Mitarbeiter sieht diese Fahrt als abgelehnt. Du kannst eine Notiz hinzufügen.",
        ],
        RejectionNote: ["Note for the worker", "Nota para el trabajador", "Notiz für den Mitarbeiter"],
        RejectionNoteOptional: ["Optional", "Opcional", "Optional"],
        RejectedNote: ["Rejection note", "Motivo del rechazo", "Ablehnungsgrund"],
        PendingReview: ["Pending review", "Pendiente de revisión", "Wird geprüft"],
        AllMembers: ["all members", "todos los miembros", "alle Mitglieder"],
        EnteredBy: ["Entered by", "Ingresado por", "Eingegeben von"],
        RecordedDistance: ["Recorded distance", "Distancia registrada", "Aufgezeichnete Distanz"],
    },
    TrackEditor: {
        NewTrip: ["Manual trip entry", "Registro manual de viaje", "Fahrt manuell erfassen"],
        EditTrip: ["Edit trip", "Editar viaje", "Fahrt bearbeiten"],
        AddTrip: ["Add manual trip", "Agregar viaje manual", "Fahrt manuell hinzufügen"],
        SaveTrip: ["Save trip", "Guardar viaje", "Fahrt speichern"],
        SaveChanges: ["Save changes", "Guardar cambios", "Änderungen speichern"],
        StartAddress: ["Start", "Inicio", "Start"],
        EndAddress: ["End", "Fin", "Ziel"],
        PickOnMapHint: [
            "Click on the map or search by address or place.",
            "Haz clic en el mapa o busca por dirección o lugar.",
            "Klicke auf die Karte oder suche nach Adresse oder Ort.",
        ],
        Date: ["Date", "Fecha", "Datum"],
        StartTime: ["Start time", "Hora de inicio", "Startzeit"],
        EndTime: ["End time", "Hora de fin", "Endzeit"],
        NextDay: ["+1 day", "+1 día", "+1 Tag"],
        TripRouteInfo: ["Route: {0} · {1}", "Ruta: {0} · {1}", "Route: {0} · {1}"],
        NoRouteFound: [
            "No route found, straight-line distance will be used",
            "No se encontró ninguna ruta, se usará la distancia en línea recta",
            "Keine Route gefunden, die Luftlinie wird als Distanz verwendet",
        ],
        DistanceFromRoute: [
            "{0} · {1}, from the route",
            "{0} · {1}, según la ruta",
            "{0} · {1}, aus der Route",
        ],
        ChooseMember: ["Choose a member", "Elige un miembro", "Wähle ein Mitglied"],
        ChooseStartAndEnd: ["Choose a start and an end", "Elige un inicio y un fin", "Wähle Start und Ziel"],
        EndMustBeAfterStart: ["The end must be after the start", "El fin debe ser después del inicio", "Das Ende muss nach dem Start liegen"],
        TripTooLong: ["A trip cannot be longer than 24 hours", "Un viaje no puede durar más de 24 horas", "Eine Fahrt kann nicht länger als 24 Stunden dauern"],
        TripInFuture: ["A trip cannot end in the future", "Un viaje no puede terminar en el futuro", "Eine Fahrt kann nicht in der Zukunft enden"],
        TripSaved: ["Trip saved", "Viaje guardado", "Fahrt gespeichert"],
        RecordedValue: ["Recorded: {0}", "Registrado: {0}", "Aufgezeichnet: {0}"],
    },
    Trips: {
        OnTheWayToX: [
            "On the way to {0}",
            "En camino a {0}",
            "Auf dem Weg nach {0}"
        ],
        Started: [
            "Started",
            "Comenzó",
            "Gestartet"
        ],
        OriginalETA: [
            "Original ETA",
            "ETA original",
            "Ursprüngliche ETA"
        ],
        CurrentETA: [
            "Current ETA",
            "ETA actual",
            "Aktuelle ETA"
        ],
        EtaNotificationSetToDefault: [
            "Set to default",
            "Valores predeterminados",
            "Auf Standard setzen",
        ],
        EtaNotificationCaption: [
            "Use {eta}, {company}, {driver}, {title}, {etaPageUrl} to customize",
            "Usa {eta}, {company}, {driver}, {title}, {etaPageUrl} para personalizar",
            "Verwende {eta}, {company}, {driver}, {title}, {etaPageUrl}, um anzupassen",
        ],
        EtaNotificationTextDefault: [
            "This is an automated notification to inform you that the estimated time of arrival (ETA) for {title} is {eta}.\n\nLive arrival page: {etaPageUrl}",
            "Esta es una notificación automática para informarle que la hora estimada de llegada (ETA) para {title} es {eta}.\n\nPágina de llegada en vivo: {etaPageUrl}",
            "Dies ist eine automatische Benachrichtigung, um Sie darüber zu informieren, dass die voraussichtliche Ankunftszeit (ETA) für {title} {eta} ist.\n\nLive-Ankunftsseite: {etaPageUrl}",
        ],
        EtaNotificationEtaPageLine: [
            "Live arrival page: {etaPageUrl}",
            "Página de llegada en vivo: {etaPageUrl}",
            "Live-Ankunftsseite: {etaPageUrl}",
        ],
        EtaNotificationSubjectDefault: [
            "ETA {eta} - {company}",
            "ETA {eta} - {company}",
            "ETA {eta} - {company}",
        ],
        EtaNotification: [
            "ETA email notifications",
            "Notificaciones de ETA por correo",
            "ETA-E-Mail-Benachrichtigungen",
        ],
        EtaNotificationDesc: [
            "After a worker selects “On the way” to start a trip to a job in the Hellotracks mobile app, an email is automatically sent to the job’s contact, providing the estimated arrival time.",
            "Después de que un trabajador selecciona “En camino” para comenzar un viaje a una tarea en la aplicación móvil Hellotracks, se envía automáticamente un correo electrónico al contacto de la tarea, proporcionando la hora estimada de llegada.",
            "Nachdem ein Mitarbeiter in der Hellotracks-App „Unterwegs“ auswählt, um eine Fahrt zu einem Auftrag zu starten, wird automatisch eine E-Mail an den Kontakt des Auftrags gesendet, die die voraussichtliche Ankunftszeit angibt.",
        ],
        EtaNotificationSend: [
            "Send ETA notification to the job's contact email address",
            "Enviar notificación de ETA a la dirección de correo electrónico del contacto de la tarea",
            "Sende ETA-Benachrichtigung an die E-Mail-Adresse des Auftragskontakts",
        ],
        EtaNotificationXMinBeforeArrival: [
            "{0} min before arrival",
            "{0} min antes de la llegada",
            "{0} min vor der Ankunft",
        ],
        EtaNotificationSubject: [
            "ETA notification subject",
            "Asunto de la notificación de ETA",
            "Betreff der ETA-Benachrichtigung",
        ],
        EtaNotificationBody: [
            "ETA notification body",
            "Cuerpo de la notificación de ETA",
            "Text der ETA-Benachrichtigung",
        ],
        EtaNotificationIncludeImage: [
            "Include image with current position and remaining route",
            "Incluir imagen con la posición actual y la ruta restante",
            "Bild mit der aktuellen Position und der verbleibenden Route einfügen",
        ],
        EtaNotificationIncludeEtaPage: [
            "Include ETA page link",
            "Incluir enlace a la página ETA",
            "Link zur ETA-Seite einfügen",
        ],
        EtaNotificationIncludeEtaPageCaption: [
            "Adds a live arrival page link to the ETA email. If no page exists yet, Hellotracks creates one automatically.",
            "Agrega al correo de ETA un enlace a una página de llegada en vivo. Si aún no existe una página, Hellotracks la crea automáticamente.",
            "Fügt der ETA-E-Mail einen Link zur Live-Ankunftsseite hinzu. Falls noch keine Seite existiert, erstellt Hellotracks sie automatisch.",
        ],
        EtaPageDefaults: [
            "ETA page defaults",
            "Valores predeterminados de la página ETA",
            "ETA-Seiten-Standards",
        ],
        EtaPageDefaultsDesc: [
            "These settings apply when a new ETA page is created. Existing pages keep their own visibility.",
            "Esta configuración se aplica cuando se crea una nueva página ETA. Las páginas existentes conservan su visibilidad.",
            "Diese Einstellungen gelten, wenn eine neue ETA-Seite erstellt wird. Bestehende Seiten behalten ihre Sichtbarkeit.",
        ],
        EtaPageDefaultShowWorkerName: [
            "Show worker name",
            "Mostrar nombre del trabajador",
            "Mitarbeiternamen anzeigen",
        ],
        EtaPageDefaultShowWorkerNameCaption: [
            "New ETA pages can show who is assigned. You can still change this per job.",
            "Las nuevas páginas ETA pueden mostrar quién está asignado. Puedes cambiarlo por tarea.",
            "Neue ETA-Seiten können anzeigen, wer zugewiesen ist. Du kannst dies pro Auftrag ändern.",
        ],
        EtaPageDefaultShowMap: [
            "Show live map",
            "Mostrar mapa en vivo",
            "Live-Karte anzeigen",
        ],
        EtaPageDefaultShowMapCaption: [
            "New ETA pages can show location only while the worker is on the way to the job. You can still change this per job.",
            "Las nuevas páginas ETA pueden mostrar la ubicación solo mientras el trabajador está en camino a la tarea. Puedes cambiarlo por tarea.",
            "Neue ETA-Seiten können den Standort nur anzeigen, während der Mitarbeiter zum Auftrag unterwegs ist. Du kannst dies pro Auftrag ändern.",
        ],
    },
    ImproveQualityDialog: {
        ChecklistTitle: [
            "Checklist to improve GPS quality",
            "Lista de verificación para mejorar la calidad del GPS",
            "Checkliste zur Verbesserung der GPS-Qualität"
        ],
        CloseButton: [
            "Close",
            "Cerrar",
            "Schließen"
        ],
        SuspendedLast: [
            "Last suspension:",
            "Última suspensión:",
            "Zuletzt angehalten:"
        ],
        SuspendedRecovered: [
            "Recovered:",
            "Recuperado:",
            "Wiederhergestellt:"
        ],
        CheckAppUpdate: [
            "Check if the mobile app is up to date.",
            "Verifica si la aplicación móvil está actualizada.",
            "Überprüfe, ob die mobile App auf dem neuesten Stand ist."
        ],
        AppUpToDate: [
            "App version is up to date.",
            "La versión de la aplicación está actualizada.",
            "Die App-Version ist aktuell."
        ],
        AppUpdateAvailable: [
            "There is an update available. Installed version: {0}, latest version: {1}.",
            "Hay una actualización disponible. Versión instalada: {0}, última versión: {1}.",
            "Es ist ein Update verfügbar. Installierte Version: {0}, neueste Version: {1}."
        ],
        CheckLocationPermissions: [
            "Ensure location permissions are granted and set to high precision.",
            "Asegúrate de que los permisos de ubicación estén concedidos y configurados en alta precisión.",
            "Stelle sicher, dass Standortberechtigungen erteilt und auf hohe Präzision eingestellt sind."
        ],
        LocationPermissionsGranted: [
            "Location permissions are granted and location services are enabled.",
            "Los permisos de ubicación están concedidos y los servicios de ubicación están habilitados.",
            "Standortberechtigungen sind erteilt und Standortdienste sind aktiviert."
        ],
        LocationPermissionsNotGranted: [
            "Location permissions or services are not enabled. Please enable them in the device settings.",
            "Los permisos o servicios de ubicación no están habilitados. Habilítalos en la configuración del dispositivo.",
            "Standortberechtigungen oder -dienste sind nicht aktiviert. Bitte in den Geräteeinstellungen aktivieren."
        ],
        CheckBackgroundLocation: [
            "Allow location access in the background.",
            "Permite el acceso a la ubicación en segundo plano.",
            "Erlaube den Standortzugriff im Hintergrund."
        ],
        DisableBatterySaveMode: [
            "Disable battery save mode within Hellotracks.",
            "Desactiva el modo de ahorro de batería en Hellotracks.",
            "Deaktiviere den Energiesparmodus in Hellotracks."
        ],
        BatterySaveModeDisabled: [
            "Battery save mode is disabled.",
            "El modo de ahorro de batería está desactivado.",
            "Der Energiesparmodus ist deaktiviert."
        ],
        BatterySaveModeEnabled: [
            "Battery save mode is enabled. Please disable it to ensure proper tracking.",
            "El modo de ahorro de batería está activado. Desactívalo para garantizar un seguimiento adecuado.",
            "Der Energiesparmodus ist aktiviert. Bitte deaktiviere ihn, um ein korrektes Tracking zu gewährleisten."
        ],
        TrackingSwitchOn: [
            "Confirm that the tracking switch is on.",
            "Confirma que el interruptor de seguimiento está activado.",
            "Bestätige, dass der Tracking-Schalter eingeschaltet ist."
        ],
        TrackingSwitchIsOff: [
            "Tracking switch is off. Please enable it in the Hellotracks app.",
            "El interruptor de seguimiento está desactivado. Actívalo en la aplicación Hellotracks.",
            "Der Tracking-Schalter ist ausgeschaltet. Bitte in der Hellotracks-App aktivieren."
        ],
        AppNotSuspended: [
            "Ensure the app is not suspended.",
            "Asegúrate de que la aplicación no esté suspendida.",
            "Stelle sicher, dass die App nicht angehalten wurde."
        ],
        AppRunsInBackground: [
            "The app appears to run normally in the background. Avoid swiping it out from the app switcher.",
            "La aplicación parece funcionar normalmente en segundo plano. Evita deslizarla fuera del conmutador de aplicaciones.",
            "Die App scheint im Hintergrund normal zu laufen. Vermeide es, sie aus dem App-Umschalter zu wischen."
        ],
        AppSuspended: [
            "The app is suspended. Avoid swiping it out from the app switcher.",
            "La aplicación está suspendida. Evita deslizarla fuera del conmutador de aplicaciones.",
            "Die App ist angehalten. Vermeide es, sie aus dem App-Umschalter zu wischen."
        ],
        DisableBatteryOptimization: [
            "Ensure the app is not restricted by Android's battery optimization.",
            "Asegúrate de que la aplicación no esté restringida por la optimización de batería de Android.",
            "Stelle sicher, dass die App nicht durch die Batterieoptimierung von Android eingeschränkt wird."
        ],
        BatteryOptimizationNotRestricting: [
            "Battery optimization is not restricting the app.",
            "La optimización de batería no está restringiendo la aplicación.",
            "Die Batterieoptimierung schränkt die App nicht ein."
        ],
        BatteryOptimizationRestricting: [
            "Battery optimization is restricting the app. Turn it off via: Settings → Battery → Battery Optimization.",
            "La optimización de batería está restringiendo la aplicación. Desactívala en: Configuración → Batería → Optimización de batería.",
            "Die Batterieoptimierung schränkt die App ein. Deaktiviere sie unter: Einstellungen → Batterie → Batterieoptimierung."
        ],
        CheckBatteryLevel: [
            "Ensure the battery level is higher than 20%.",
            "Asegúrate de que el nivel de batería sea superior al 20%.",
            "Stelle sicher, dass der Batteriestand über 20 % liegt."
        ],
        BatteryLevelSufficient: [
            "Current battery level is sufficient: {level}%.",
            "El nivel de batería actual es suficiente: {level}%.",
            "Der aktuelle Batteriestand ist ausreichend: {level}%."
        ],
        BatteryLevelLow: [
            "Current battery level is low: {level}%. Please charge your device.",
            "El nivel de batería actual es bajo: {level}%. Carga tu dispositivo.",
            "Der aktuelle Batteriestand ist niedrig: {level}%. Bitte lade dein Gerät auf."
        ],
        DeviceCommunication: [
            "Device communication",
            "Comunicación del dispositivo",
            "Gerätekommunikation"
        ],
        DeviceCommunicating: [
            "Device is communicating with our servers - last sync: {0} ago",
            "El dispositivo está comunicándose con nuestros servidores - última sincronización: hace {0}",
            "Das Gerät kommuniziert mit unseren Servern - letzte Synchronisierung: vor {0}"
        ],
        SyncOutdated: [
            "Sync outdated - last sync: {0} ago",
            "Sincronización desactualizada - última sincronización: hace {0}",
            "Synchronisierung veraltet - letzte Synchronisierung: vor {0}"
        ],
        DeviceNotCommunicating: [
            "Device is not communicating with our servers. The Hellotracks mobile app should be opened to reestablish a connection.",
            "El dispositivo no se está comunicando con nuestros servidores. Se debe abrir la app móvil de Hellotracks para restablecer la conexión.",
            "Das Gerät kommuniziert nicht mit unseren Servern. Die Hellotracks-App sollte geöffnet werden, um die Verbindung wiederherzustellen."
        ],
        NoUpToDateInfo: [
            "No up-to-date information available",
            "No hay información actualizada disponible",
            "Keine aktuellen Informationen verfügbar"
        ],
        TrackingOn: [
            "Tracking switch / In service is ON",
            "Interruptor de seguimiento / En servicio está ACTIVADO",
            "Tracking-Schalter / Im Einsatz ist AN"
        ],
        UserNotLoggedIn: [
            "User is not logged into the Hellotracks mobile app",
            "El usuario no ha iniciado sesión en la app móvil de Hellotracks",
            "Der Nutzer ist nicht in der Hellotracks-App angemeldet"
        ],
        TrackingOff: [
            "Tracking switch / In service is OFF",
            "Interruptor de seguimiento / En servicio está DESACTIVADO",
            "Tracking-Schalter / Im Einsatz ist AUS"
        ],
        RecentLocation: [
            "Recent location",
            "Ubicación reciente",
            "Letzter Standort"
        ],
        LastLocationReceived: [
            "Last location received: {0} ago",
            "Última ubicación recibida: hace {0}",
            "Letzter Standort empfangen: vor {0}"
        ],
        NoLocationData: [
            "No location data available",
            "No hay datos de ubicación disponibles",
            "Keine Standortdaten verfügbar"
        ],
        LocationOutdated: [
            "Location outdated: {0} ago",
            "Ubicación desactualizada: hace {0}",
            "Standort veraltet: vor {0}"
        ],
    },
    LocationRowQuality: {
        PoorTag: [
            "Poor",
            "Mala",
            "Schlecht"
        ],
        GoodTag: [
            "Good",
            "Buena",
            "Gut"
        ],
        OkTag: [
            "OK",
            "Regular",
            "OK"
        ],
        PoorQualityTooltip: [
            "Large parts of this trip were not recorded. The route on the map may be incomplete.",
            "Gran parte de este viaje no se registró. El recorrido en el mapa puede estar incompleto.",
            "Große Teile dieser Fahrt wurden nicht aufgezeichnet. Die Route auf der Karte kann unvollständig sein."
        ],
        GoodQualityTooltip: [
            "Location updates covered the whole trip. This does not measure how precise each position was.",
            "Las actualizaciones de ubicación cubrieron todo el viaje. Esto no mide la precisión de cada posición.",
            "Standortupdates decken die ganze Fahrt ab. Die Genauigkeit der einzelnen Positionen wird dabei nicht bewertet."
        ],
        OkQualityTooltip: [
            "A few short stretches of this trip were not recorded.",
            "Algunos tramos cortos de este viaje no se registraron.",
            "Einige kurze Abschnitte dieser Fahrt wurden nicht aufgezeichnet."
        ],
        UnknownTag: ["Unknown", "Desconocida", "Unbekannt"],
        UnknownQualityTooltip: [
            "There is not enough data to assess this trip.",
            "No hay datos suficientes para evaluar este viaje.",
            "Es gibt nicht genügend Daten, um diese Fahrt zu bewerten."
        ],
        PointSummary: [
            "{0} location updates, one every {1}s on average",
            "{0} actualizaciones de ubicación, una cada {1}s de media",
            "{0} Standortupdates, durchschnittlich alle {1}s"
        ],
        LargestTravelGap: [
            "Largest unrecorded stretch: about {0} m in {1}s",
            "Mayor tramo sin registrar: unos {0} m en {1}s",
            "Längster nicht aufgezeichneter Abschnitt: etwa {0} m in {1}s"
        ],
        NoTravelGaps: [
            "No unrecorded stretches.",
            "Ningún tramo sin registrar.",
            "Keine nicht aufgezeichneten Abschnitte."
        ],
        GapDistance: [
            "Unrecorded distance: about {0} m ({1}% of the trip)",
            "Distancia sin registrar: unos {0} m ({1}% del viaje)",
            "Nicht aufgezeichnete Distanz: etwa {0} m ({1}% der Fahrt)"
        ],
        LongestSilence: [
            "Longest time without any update: {0} min",
            "Mayor tiempo sin ninguna actualización: {0} min",
            "Längste Zeit ohne Update: {0} min"
        ],
        ImproveQualityButton: [
            "Improve GPS quality",
            "Mejorar calidad del GPS",
            "GPS-Qualität verbessern"
        ]
    },
    EmailVerification: {
        Title: ["Email verification", "Verificación del correo", "E-Mail-Bestätigung"],
        EnterCodeTitle: [
            "Enter the 6-digit code we sent to {0}",
            "Ingresa el código de 6 dígitos que enviamos a {0}",
            "Gib den 6-stelligen Code ein, den wir an {0} gesendet haben",
        ],
        EnterCodeHint: [
            "You can also click the link in that email. If you don't see it, check your spam folder.",
            "También puedes hacer clic en el enlace de ese correo. Si no lo ves, revisa tu carpeta de spam.",
            "Du kannst auch den Link in dieser E-Mail anklicken. Falls du sie nicht findest, prüfe deinen Spam-Ordner.",
        ],
        WrongCode: [
            "That code is not correct. Please try again.",
            "Ese código no es correcto. Inténtalo de nuevo.",
            "Dieser Code ist nicht korrekt. Bitte versuche es erneut.",
        ],
        CodeExpired: [
            "This code no longer works. Send a new one.",
            "Este código ya no funciona. Envía uno nuevo.",
            "Dieser Code funktioniert nicht mehr. Sende einen neuen.",
        ],
        ResendIn: [
            "Send a new code in {0}s",
            "Enviar un código nuevo en {0}s",
            "Neuen Code senden in {0}s",
        ],
        ResendCode: ["Send a new code", "Enviar un código nuevo", "Neuen Code senden"],
        EmailVerificationIssue: [
            "If you're unable to verify your email, you can log out and sign up again using a different email address.",
            "Si no puedes verificar tu correo electrónico, puedes cerrar sesión y registrarte de nuevo usando una dirección de correo electrónico diferente.",
            "Falls du deine E-Mail nicht verifizieren kannst, kannst du dich abmelden und dich mit einer anderen E-Mail-Adresse erneut registrieren."
        ],
        CantVerify: [
            "Can't verify",
            "No puedo verificar",
            "Verifizierung nicht möglich",
        ]
    },
    Skills: {
        Skills: ["Skills", "Habilidades", "Skills"],
        NothingToRemove: ["The selected members have no skills yet.", "Los miembros seleccionados aún no tienen habilidades.", "Die ausgewählten Mitglieder haben noch keine Skills."],
        OnePerson: ["one person", "una persona", "eine Person"],
        OverviewEmpty: [
            "No skills yet. Add skills on a member's profile or as a job's required skills, and they show up here.",
            "Aún no hay habilidades. Agrega habilidades en el perfil de un miembro o como requisito de una tarea y aparecerán aquí.",
            "Noch keine Skills. Trage Skills im Profil eines Mitglieds oder als Anforderung eines Auftrags ein, dann erscheinen sie hier.",
        ],
        WindowIntro: [
            "Skills say who can do which job. When a job requires a skill, only people who have it are suggested as assignee, and route optimization and Co-Dispatch plan the job for nobody else. Other spellings, synonyms and translations of a skill count as that skill.",
            "Las habilidades indican quién puede hacer qué tarea. Cuando una tarea requiere una habilidad, solo se sugieren como asignado las personas que la tienen, y la optimización de rutas y Co-Dispatch no planifican la tarea para nadie más. Otras escrituras, sinónimos y traducciones de una habilidad cuentan como esa habilidad.",
            "Skills sagen, wer welchen Auftrag erledigen kann. Erfordert ein Auftrag einen Skill, werden nur Personen mit diesem Skill als Zuständige vorgeschlagen, und Routenoptimierung und Co-Dispatch planen den Auftrag für niemand anderen ein. Andere Schreibweisen, Synonyme und Übersetzungen eines Skills zählen als dieser Skill.",
        ],
        NewSkill: ["New skill", "Nueva habilidad", "Neuer Skill"],
        NewSkillName: ["Name of the skill", "Nombre de la habilidad", "Name des Skills"],
        ManageSkills: ["Manage skills", "Gestionar habilidades", "Skills verwalten"],
        ManageX: ["Manage {0}", "Gestionar {0}", "{0} verwalten"],
        SearchSkills: ["Search skills", "Buscar habilidades", "Skills suchen"],
        NeedsAttention: ["Needs attention", "Requiere atención", "Braucht Aufmerksamkeit"],
        AllSkills: ["All skills", "Todas las habilidades", "Alle Skills"],
        NoSkillFound: ["No skill found", "No se encontró ninguna habilidad", "Kein Skill gefunden"],
        AddNewSkillX: ["Add \"{0}\"", "Agregar \"{0}\"", "\"{0}\" hinzufügen"],
        MembersAndJobsHint: [
            "members · open jobs, next {0} days",
            "miembros · tareas abiertas, próximos {0} días",
            "Mitglieder · offene Aufträge, nächste {0} Tage",
        ],
        OpenJobsInNextDays: ["{0} open jobs in the next {1} days", "{0} tareas abiertas en los próximos {1} días", "{0} offene Aufträge in den nächsten {1} Tagen"],
        NoOpenJobsInNextDays: ["no open jobs in the next {0} days", "sin tareas abiertas en los próximos {0} días", "keine offenen Aufträge in den nächsten {0} Tagen"],
        NobodyHasIt: ["nobody has it", "nadie la tiene", "niemand hat ihn"],
        HasThisSkill: ["Has this skill", "Tienen esta habilidad", "Haben diesen Skill"],
        NobodyYet: ["Nobody has this skill yet.", "Nadie tiene esta habilidad todavía.", "Noch niemand hat diesen Skill."],
        RemoveFromAll: ["Remove from all", "Quitar de todos", "Von allen entfernen"],
        RemoveFromAllConfirm: [
            "Take \"{0}\" away from all {1} members? Templates and open jobs that require it keep it.",
            "¿Quitar \"{0}\" a los {1} miembros? Las plantillas y las tareas abiertas que la requieren la conservan.",
            "\"{0}\" allen {1} Mitgliedern wegnehmen? Vorlagen und offene Aufträge, die ihn erfordern, behalten ihn.",
        ],
        AddMembers: ["Add members", "Agregar miembros", "Mitglieder hinzufügen"],
        AddMembersToX: ["Add members to {0}", "Agregar miembros a {0}", "Mitglieder zu {0} hinzufügen"],
        ShowAllX: ["Show all {0}", "Mostrar los {0}", "Alle {0} anzeigen"],
        ProbablyHasIt: ["Probably has it, not confirmed", "Probablemente la tienen, sin confirmar", "Haben ihn wahrscheinlich, nicht bestätigt"],
        XCompletedJobs: ["{0} completed jobs", "{0} tareas completadas", "{0} erledigte Aufträge"],
        SameWord: ["Other spellings", "Otras escrituras", "Andere Schreibweisen"],
        AlsoSpelled: [
            "Also in use as \"{0}\". Both count as one skill; merge to keep one word.",
            "También en uso como \"{0}\". Ambas cuentan como una sola habilidad; fusiona para conservar una palabra.",
            "Auch als \"{0}\" in Gebrauch. Beide zählen als ein Skill; führe zusammen, damit es nur ein Wort gibt.",
        ],
        MergeInto: ["Merge into {0}", "Fusionar en {0}", "Mit {0} zusammenführen"],
        MergeConfirm: [
            "Members, templates and open jobs that use \"{0}\" change to \"{1}\". Finished jobs keep their word.",
            "Los miembros, plantillas y tareas abiertas que usan \"{0}\" pasan a \"{1}\". Las tareas terminadas conservan su palabra.",
            "Mitglieder, Vorlagen und offene Aufträge mit \"{0}\" wechseln zu \"{1}\". Erledigte Aufträge behalten ihr Wort.",
        ],
        RenameHint: [
            "The new name applies to members, templates and open jobs. An existing name merges the two.",
            "El nuevo nombre se aplica a miembros, plantillas y tareas abiertas. Un nombre existente fusiona ambas.",
            "Der neue Name gilt für Mitglieder, Vorlagen und offene Aufträge. Ein vorhandener Name führt beide zusammen.",
        ],
        DeleteConfirm: [
            "Remove \"{0}\" from all members, templates and open jobs?",
            "¿Quitar \"{0}\" de todos los miembros, plantillas y tareas abiertas?",
            "\"{0}\" bei allen Mitgliedern, Vorlagen und offenen Aufträgen entfernen?",
        ],
        Unused: [
            "No member has this skill and no open job requires it.",
            "Ningún miembro tiene esta habilidad y ninguna tarea abierta la requiere.",
            "Kein Mitglied hat diesen Skill und kein offener Auftrag erfordert ihn.",
        ],
        NewSkillHint: [
            "A new skill. Add the first member who has it, and it is saved. Jobs can then require it.",
            "Una habilidad nueva. Agrega al primer miembro que la tiene y quedará guardada. Después las tareas pueden requerirla.",
            "Ein neuer Skill. Füge das erste Mitglied hinzu, das ihn hat, dann ist er gespeichert. Danach können Aufträge ihn erfordern.",
        ],
        OneMember: ["{0} member", "{0} miembro", "{0} Mitglied"],
        XMembers: ["{0} members", "{0} miembros", "{0} Mitglieder"],
        OneJob: ["{0} job", "{0} tarea", "{0} Auftrag"],
        XJobs: ["{0} jobs", "{0} tareas", "{0} Aufträge"],
        LooksLikeExisting: [
            "\"{0}\" looks like your existing skill \"{1}\".",
            "\"{0}\" se parece a tu habilidad existente \"{1}\".",
            "\"{0}\" sieht aus wie dein vorhandener Skill \"{1}\".",
        ],
        UseExisting: ["Use {0}", "Usar {0}", "{0} verwenden"],
        ProposedFromJobsAndExpertise: [
            "Suggested from jobs completed in the last 6 months and from the expertise text.",
            "Sugerido a partir de las tareas completadas en los últimos 6 meses y del texto de experiencia.",
            "Vorgeschlagen anhand der erledigten Aufträge der letzten 6 Monate und der Fachkenntnisse im Profil.",
        ],
        FromExpertise: ["expertise", "experiencia", "Fachkenntnisse"],
        ExpertiseMentionsIt: ["expertise mentions it", "lo menciona su experiencia", "in den Fachkenntnissen erwähnt"],
        WhyKeep: ["Why keep {0}?", "¿Por qué mantener a {0}?", "Warum {0} behalten?"],
        MemberHasSkill: ["{0} has {1}", "{0} tiene {1}", "{0} hat {1}"],
        JobDoesNotNeed: ["Job does not need {0}", "La tarea no necesita {0}", "Auftrag braucht {0} nicht"],
        RejectedBy: ["{0} rejected this job.", "{0} rechazó esta tarea.", "{0} hat diesen Auftrag abgelehnt."],
        NeedsSkillMemberLacks: ["Needs a skill {0} lacks", "Necesita una habilidad que {0} no tiene", "Braucht einen Skill, den {0} nicht hat"],
        SkillsThisJobNeeds: ["Skills this job needs", "Habilidades que necesita esta tarea", "Skills, die dieser Auftrag braucht"],
        KeptBefore: [
            "You kept {0} on {1} other jobs that require {2}.",
            "Mantuviste a {0} en otras {1} tareas que requieren {2}.",
            "Du hast {0} bei {1} anderen Aufträgen behalten, die {2} erfordern.",
        ],
        OtherReason: ["Other reason", "Otro motivo", "Anderer Grund"],
        NobodyHoldsThese: ["Nobody holds these skills yet.", "Nadie tiene estas habilidades todavía.", "Noch niemand hat diese Skills."],
        OnePersonHoldsThese: ["1 person holds these skills.", "1 persona tiene estas habilidades.", "1 Person hat diese Skills."],
        XPeopleHoldThese: ["{0} people hold these skills.", "{0} personas tienen estas habilidades.", "{0} Personen haben diese Skills."],
        TemplateJobsInherit: [
            "New jobs from this template will require them.",
            "Las nuevas tareas de esta plantilla las requerirán.",
            "Neue Aufträge aus dieser Vorlage erfordern sie.",
        ],
        AddToOneOpenJob: [
            "Add to 1 open job from this template",
            "Agregar a 1 tarea abierta de esta plantilla",
            "Zu 1 offenen Auftrag aus dieser Vorlage hinzufügen",
        ],
        AddToXOpenJobs: [
            "Add to {0} open jobs from this template",
            "Agregar a {0} tareas abiertas de esta plantilla",
            "Zu {0} offenen Aufträgen aus dieser Vorlage hinzufügen",
        ],
        AddRequiredSkills: ["Add required skills", "Agregar habilidades requeridas", "Erforderliche Skills hinzufügen"],
        NobodyHasYet: ["Nobody has this skill yet", "Nadie tiene esta habilidad todavía", "Noch niemand hat diesen Skill"],
    },
    MatchAi: {
        Suggestions: ["Suggestions", "Sugerencias", "Vorschläge"],
        ReassignTo: ["Reassign to {0}", "Reasignar a {0}", "An {0} zuweisen"],
        Keep: ["Keep {0}", "Mantener a {0}", "{0} behalten"],
        AddSkillsHint: [
            "Add skills to your members' profiles to get better suggestions.",
            "Agrega habilidades en el perfil de tus miembros para obtener mejores sugerencias.",
            "Trage Skills im Profil deiner Mitglieder ein, um bessere Vorschläge zu erhalten."
        ],
        SkillsRequiredButNoneSet: [
            "This job requires skills, but no member has any yet. Add them in the members' profiles.",
            "Esta tarea requiere habilidades, pero ningún miembro tiene ninguna. Agrégalas en el perfil de los miembros.",
            "Dieser Auftrag erfordert Skills, aber noch kein Mitglied hat welche. Trage sie im Profil der Mitglieder ein."
        ],
        OnePersonFits: ["1 person fits this job", "1 persona encaja con esta tarea", "1 Person passt zu diesem Auftrag"],
        Best: ["Best", "Mejor", "Beste Wahl"],
        Why: ["Why", "Por qué", "Warum"],
        EveryoneElse: ["Everyone else", "Todos los demás", "Alle anderen"],
        BestAssignee: ["Best assignee", "Mejor asignado", "Beste Zuweisung"],
        BestBy: ["by working hours, skills, distance", "por horario, habilidades, distancia", "nach Arbeitszeit, Skills, Entfernung"],
        HowWeRank: ["How suggestions are ranked", "Cómo se ordenan las sugerencias", "So werden Vorschläge sortiert"],
        HowWeRankIntro: [
            "Members are compared in this order. A later point only decides between members who are equal on the ones before it.",
            "Los miembros se comparan en este orden. Un punto posterior solo decide entre miembros que están igualados en los anteriores.",
            "Mitglieder werden in dieser Reihenfolge verglichen. Ein späterer Punkt entscheidet nur zwischen Mitgliedern, die bei den vorherigen gleichauf sind."
        ],
        RankWorking: ["Works on the day of the job", "Trabaja el día de la tarea", "Arbeitet am Tag des Auftrags"],
        RankSkills: ["Has the required skills and equipment", "Tiene las habilidades y el equipo requeridos", "Hat die erforderlichen Skills und die Ausrüstung"],
        RankJobText: ["Skills fit what the job describes", "Sus habilidades encajan con lo que describe la tarea", "Skills passen zu dem, was der Auftrag beschreibt"],
        RankTeam: ["Belongs to the job's team", "Pertenece al equipo de la tarea", "Gehört zum Team des Auftrags"],
        RankTravel: ["Shortest drive to the job (jobs of today only)", "Trayecto más corto hasta la tarea (solo tareas de hoy)", "Kürzeste Fahrt zum Auftrag (nur Aufträge von heute)"],
        RankNearby: ["Already has jobs nearby that day", "Ya tiene tareas cerca ese día", "Hat an dem Tag schon Aufträge in der Nähe"],
        RankPlace: ["Has done jobs at this place before", "Ya ha hecho tareas en este lugar", "Hat an diesem Ort schon Aufträge erledigt"],
        RankWorkload: ["Fewest jobs that day", "Menos tareas ese día", "Wenigste Aufträge an dem Tag"],
        XPeopleFit: ["{0} people fit this job", "{0} personas encajan con esta tarea", "{0} Personen passen zu diesem Auftrag"],
    },
    Affiliate: {
        Title: ["Affiliate", "Afiliado", "Affiliate"],
        Dashboard: ["Affiliate dashboard", "Panel de afiliado", "Affiliate-Dashboard"],
        Desc: ["Referral dashboard", "Panel de referidos", "Empfehlungs-Dashboard"],
        CopyReferralLink: ["Copy referral link", "Copiar enlace de referido", "Empfehlungslink kopieren"],
        ReferralLink: ["Referral link", "Enlace de referido", "Empfehlungslink"],
        AffiliateCode: ["Affiliate code", "Código de afiliado", "Affiliate-Code"],
        Commission: ["Commission", "Comisión", "Provision"],
        CommissionFirstInvoice: ["{0}% first invoice", "{0}% primera factura", "{0}% erste Rechnung"],
        Signups: ["Signups", "Registros", "Registrierungen"],
        Trials: ["Trials", "Pruebas", "Testversionen"],
        PaidCustomers: ["Paid customers", "Clientes de pago", "Zahlende Kunden"],
        EarnedCommission: ["Earned commission", "Comisión ganada", "Verdiente Provision"],
        PaidCommission: ["Paid commission", "Comisión pagada", "Ausgezahlte Provision"],
        ReferredCustomers: ["Referred customers", "Clientes referidos", "Empfohlene Kunden"],
        CommissionLedger: ["Commission ledger", "Libro de comisiones", "Provisionsübersicht"],
        Customer: ["Customer", "Cliente", "Kunde"],
        State: ["State", "Estado", "Status"],
        Status: ["Status", "Estado", "Status"],
        Invoice: ["Invoice", "Factura", "Rechnung"],
        Created: ["Created", "Creado", "Erstellt"],
        Paid: ["Paid", "Pagado", "Bezahlt"],
        Earned: ["Earned", "Ganado", "Verdient"],
        EditCode: ["Edit code", "Editar código", "Code bearbeiten"],
        SaveCode: ["Save", "Guardar", "Speichern"],
        NoReferralsYet: ["No referrals yet", "Sin referidos aún", "Noch keine Empfehlungen"],
        NoReferralsYetDesc: ["Share your referral link to start tracking affiliate signups.", "Comparte tu enlace de referido para empezar a seguir los registros.", "Teile deinen Empfehlungslink, um Registrierungen zu verfolgen."],
        NoCommissionsYet: ["No commissions earned yet", "Sin comisiones aún", "Noch keine Provisionen"],
        NoCommissionsYetDesc: ["A commission is created once a referred company reaches its first paid invoice.", "Se crea una comisión cuando una empresa referida alcanza su primera factura pagada.", "Eine Provision wird erstellt, sobald ein empfohlenes Unternehmen seine erste bezahlte Rechnung erreicht."],
        NotEnabled: ["Affiliate access is not enabled", "El acceso de afiliado no está habilitado", "Affiliate-Zugang ist nicht aktiviert"],
        NotEnabledDesc: ["Enroll from Settings to get your personal referral link and affiliate dashboard.", "Inscríbete desde Configuración para obtener tu enlace de referido personal y tu panel de afiliado.", "Aktiviere das Affiliate-Programm in den Einstellungen, um deinen Empfehlungslink und dein Affiliate-Dashboard zu erhalten."],
        GoToSettings: ["Go to Settings", "Ir a Configuración", "Zu Einstellungen"],
        ReferralLinkCopied: ["Referral link copied", "Enlace de referido copiado", "Empfehlungslink kopiert"],
        CodeUpdated: ["Affiliate code updated", "Código de afiliado actualizado", "Affiliate-Code aktualisiert"],
        CodeUpdateFailed: ["Could not update affiliate code", "No se pudo actualizar el código de afiliado", "Affiliate-Code konnte nicht aktualisiert werden"],
        CodeHint: ["Lowercase letters, numbers, and hyphens only.", "Solo letras minúsculas, números y guiones.", "Nur Kleinbuchstaben, Zahlen und Bindestriche."],
        ReferredBy: ["Referred by", "Referido por", "Empfohlen von"],
        Generating: ["Generating...", "Generando...", "Wird generiert..."],
        NoCode: ["no-code", "sin-código", "kein-Code"],
    },
    Replays: {
        // library header + counts
        Title: ["Replays", "Repeticiones", "Replays"],
        CountOne: ["{0} replay", "{0} repetición", "{0} Replay"],
        CountMany: ["{0} replays", "{0} repeticiones", "{0} Replays"],
        CountFiltered: ["{0} of {1} replays", "{0} de {1} repeticiones", "{0} von {1} Replays"],
        NewReplay: ["+ New replay", "+ Nueva repetición", "+ Neues Replay"],
        MorningReplaysButton: ["Morning replays · {0}", "Repeticiones matinales · {0}", "Morgen-Replays · {0}"],
        All: ["all", "todos", "alle"],
        // filters
        AllMembers: ["All members", "Todos los miembros", "Alle Mitglieder"],
        SearchPlaceholder: ["Search replays", "Buscar repeticiones", "Replays suchen"],
        Rendering: ["Rendering", "Renderizando", "Rendering"],
        Failed: ["Failed", "Fallidas", "Fehlgeschlagen"],
        GroupBy: ["Group by", "Agrupar por", "Gruppieren nach"],
        GroupActivityDay: ["Activity day", "Día de actividad", "Aktivitätstag"],
        GroupCreated: ["Created", "Creación", "Erstellt"],
        ClearFilters: ["Clear filters", "Borrar filtros", "Filter zurücksetzen"],
        // recency sections
        Today: ["Today", "Hoy", "Heute"],
        Yesterday: ["Yesterday", "Ayer", "Gestern"],
        ThisWeek: ["This week", "Esta semana", "Diese Woche"],
        Earlier: ["Earlier", "Anterior", "Früher"],
        // empty states
        EmptyTitle: ["No replays yet", "Aún no hay repeticiones", "Noch keine Replays"],
        EmptyFilteredTitle: ["No replays match your filters", "Ninguna repetición coincide con los filtros", "Keine Replays entsprechen deinen Filtern"],
        EmptyBody: [
            "Save a replay from Location History, or enable nightly morning replays in your company settings.",
            "Guarda una repetición desde el Historial de ubicaciones, o activa las repeticiones matinales en la configuración de tu empresa.",
            "Speichere ein Replay im Standortverlauf oder aktiviere nächtliche Morgen-Replays in deinen Unternehmenseinstellungen.",
        ],
        EmptyFilteredBody: [
            "Clear the search or filters to see all replays.",
            "Borra la búsqueda o los filtros para ver todas las repeticiones.",
            "Setze die Suche oder Filter zurück, um alle Replays zu sehen.",
        ],
        // status tags
        TagReady: ["Ready", "Lista", "Fertig"],
        TagInstant: ["Instant", "Instantánea", "Sofort"],
        TagFailed: ["Failed", "Fallida", "Fehler"],
        TagRendering: ["Rendering", "Renderizando", "Rendering"],
        TagQueued: ["Queued", "En cola", "In Warteschlange"],
        // card thumbnail states
        RenderingProgress: ["Rendering… {0}%", "Renderizando… {0}%", "Rendering… {0}%"],
        RenderingEllipsis: ["Rendering…", "Renderizando…", "Rendering…"],
        RenderFailed: ["Render failed", "Renderizado fallido", "Rendering fehlgeschlagen"],
        RetryRender: ["Retry render", "Reintentar", "Erneut versuchen"],
        // card actions
        ClickToRename: ["Click to rename", "Haz clic para renombrar", "Zum Umbenennen klicken"],
        DownloadVideo: ["Download video", "Descargar video", "Video herunterladen"],
        DownloadNotReady: ["Download not available yet", "Descarga aún no disponible", "Download noch nicht verfügbar"],
        CopyShareLink: ["Copy share link", "Copiar enlace", "Freigabelink kopieren"],
        CreateShareLink: ["Create share link", "Crear enlace para compartir", "Freigabelink erstellen"],
        PlayIn3D: ["Play in 3D", "Reproducir en 3D", "In 3D abspielen"],
        RenderVideo: ["Render video", "Renderizar video", "Video rendern"],
        Rename: ["Rename", "Renombrar", "Umbenennen"],
        Delete: ["Delete", "Eliminar", "Löschen"],
        MoreActions: ["More actions", "Más acciones", "Weitere Aktionen"],
        Share: ["Share", "Compartir", "Teilen"],
        RevokeLink: ["Revoke link", "Revocar enlace", "Link widerrufen"],
        AutoRecap: ["Auto recap", "Resumen automático", "Auto-Rückblick"],
        CreatedBy: ["Created by {0}", "Creado por {0}", "Erstellt von {0}"],
        ReplayVideo: ["Replay video", "Video de repetición", "Replay-Video"],
        // meta units
        DistanceKm: ["{0} km", "{0} km", "{0} km"],
        DistanceMi: ["{0} mi", "{0} mi", "{0} mi"],
        StopOne: ["{0} stop", "{0} parada", "{0} Stopp"],
        StopMany: ["{0} stops", "{0} paradas", "{0} Stopps"],
        DurationMin: ["{0} min", "{0} min", "{0} Min."],
        DurationHour: ["{0}h {1}m", "{0}h {1}m", "{0}h {1}m"],
        // delete confirm
        DeleteTitle: ["Delete replay", "Eliminar repetición", "Replay löschen"],
        DeleteVideoWarning: ["The video file will be removed permanently.", "El archivo de video se eliminará permanentemente.", "Die Videodatei wird dauerhaft entfernt."],
        DeleteNoUndo: ["This cannot be undone.", "Esto no se puede deshacer.", "Das kann nicht rückgängig gemacht werden."],
        DeleteDescription: ["Delete \"{0}\"? {1}", "¿Eliminar \"{0}\"? {1}", "\"{0}\" löschen? {1}"],
        Cancel: ["Cancel", "Cancelar", "Abbrechen"],
        ThisReplay: ["this replay", "esta repetición", "dieses Replay"],
        // toasts
        ToastRenameFailed: ["Could not rename this replay", "No se pudo renombrar esta repetición", "Replay konnte nicht umbenannt werden"],
        ToastShareCopied: ["Share link copied — anyone with the link can watch", "Enlace copiado — cualquiera con el enlace puede verlo", "Freigabelink kopiert — jeder mit dem Link kann zusehen"],
        ToastShareFailed: ["Could not create a share link", "No se pudo crear el enlace", "Freigabelink konnte nicht erstellt werden"],
        ToastShareRevoked: ["Share link revoked", "Enlace revocado", "Freigabelink widerrufen"],
        ToastDeleted: ["Replay deleted", "Repetición eliminada", "Replay gelöscht"],
        ToastDeleteFailed: ["Could not delete this replay", "No se pudo eliminar esta repetición", "Replay konnte nicht gelöscht werden"],
        ToastDownloadNotReady: ["Download is not available for this video yet", "La descarga aún no está disponible para este video", "Der Download für dieses Video ist noch nicht verfügbar"],
        ToastDownloadFailed: ["Could not start the video download", "No se pudo iniciar la descarga", "Der Video-Download konnte nicht gestartet werden"],
        ToastRenderRequeued: ["Render re-queued", "Renderizado en cola de nuevo", "Rendering erneut eingereiht"],
        ToastRetryFailed: ["Could not retry — no track data for this replay", "No se pudo reintentar — sin datos de recorrido", "Erneuter Versuch fehlgeschlagen — keine Streckendaten"],
        ToastVideoQueued: ["Video render queued", "Renderizado de video en cola", "Video-Rendering eingereiht"],
        ToastVideoQueueFailed: ["Could not queue the video render", "No se pudo poner en cola el renderizado", "Video-Rendering konnte nicht eingereiht werden"],
        // morning-replays banner (library)
        BannerTitle: ["Your team's day, ready by morning", "El día de tu equipo, listo por la mañana", "Der Tag deines Teams, fertig am Morgen"],
        FreeDuringBeta: ["Beta", "Beta", "Beta"],
        BannerBody: [
            "Every evening we turn each worker's day into a short cinematic replay — for your morning review, and for workers to see their own.",
            "Cada tarde convertimos el día de cada trabajador en una breve repetición cinematográfica — para tu revisión matinal y para que cada trabajador vea la suya.",
            "Jeden Abend machen wir aus dem Tag jedes Mitarbeiters ein kurzes filmisches Replay — für deinen morgendlichen Überblick und damit Mitarbeiter ihren eigenen sehen.",
        ],
        SetUpMorning: ["Set up morning replays", "Configurar repeticiones matinales", "Morgen-Replays einrichten"],
        // new-replay dialog
        NewReplayTitle: ["New replay", "Nueva repetición", "Neues Replay"],
        SelectMember: ["Select member", "Seleccionar miembro", "Mitglied auswählen"],
        PacingShort: ["Short · quick share (~1 min)", "Corta · para compartir (~1 min)", "Kurz · schnell teilen (~1 Min.)"],
        PacingStandard: ["Standard (~1-2 min)", "Estándar (~1-2 min)", "Standard (~1-2 Min.)"],
        PacingExtended: ["Extended · detailed review (~3-4 min)", "Extendida · revisión detallada (~3-4 min)", "Ausführlich · detaillierter Rückblick (~3-4 Min.)"],
        AlsoRenderVideo: ["Also render as video (takes a few minutes)", "También renderizar como video (tarda unos minutos)", "Auch als Video rendern (dauert einige Minuten)"],
        SaveReplay: ["Save replay", "Guardar repetición", "Replay speichern"],
        SaveAndRender: ["Save + render video", "Guardar + renderizar video", "Speichern + Video rendern"],
        HintSelectMember: ["Select a member to see which days have recorded movement.", "Selecciona un miembro para ver qué días tienen movimiento registrado.", "Wähle ein Mitglied, um zu sehen, an welchen Tagen Bewegung aufgezeichnet wurde."],
        HintChecking: ["Checking recorded days…", "Comprobando días registrados…", "Aufgezeichnete Tage werden geprüft…"],
        HintPickDay: ["Pick a day to replay.", "Elige un día para reproducir.", "Wähle einen Tag zum Abspielen."],
        HintReady: ["Track data available — ready to save.", "Datos de recorrido disponibles — listo para guardar.", "Streckendaten verfügbar — bereit zum Speichern."],
        HintNoData: ["No recorded movement on this day. Pick a highlighted day instead.", "Sin movimiento registrado este día. Elige un día resaltado.", "Keine Bewegung an diesem Tag. Wähle stattdessen einen hervorgehobenen Tag."],
        ToastExistingRendering: ["This day is already in the library — rendering its video now", "Este día ya está en la biblioteca — renderizando su video ahora", "Dieser Tag ist bereits in der Bibliothek — das Video wird jetzt gerendert"],
        ToastExisting: ["A replay for this day already exists — showing it in the library", "Ya existe una repetición de este día — mostrándola en la biblioteca", "Für diesen Tag existiert bereits ein Replay — es wird in der Bibliothek angezeigt"],
        ToastSavedRendering: ["Replay saved — video render queued", "Repetición guardada — renderizado en cola", "Replay gespeichert — Video-Rendering eingereiht"],
        ToastSaved: ["Replay saved", "Repetición guardada", "Replay gespeichert"],
        ToastSaveFailed: ["Could not save this replay — no track data for the selected day", "No se pudo guardar — sin datos de recorrido para el día seleccionado", "Replay konnte nicht gespeichert werden — keine Streckendaten für den gewählten Tag"],
        // theater controls
        SaveToReplays: ["Save to Replays", "Guardar en Repeticiones", "In Replays speichern"],
        Saving: ["Saving…", "Guardando…", "Wird gespeichert…"],
        Saved: ["✓ Saved — see Replays", "✓ Guardada — ver Repeticiones", "✓ Gespeichert — zu Replays"],
        SaveFailedRetry: ["Failed — retry?", "Falló — ¿reintentar?", "Fehler — erneut?"],
        QueuingVideo: ["Queuing…", "Poniendo en cola…", "Wird eingereiht…"],
        VideoQueuedCheck: ["✓ Video queued", "✓ Video en cola", "✓ Video eingereiht"],
        ExportVideo: ["Export video", "Exportar video", "Video exportieren"],
        RecordingLabel: ["● Recording…", "● Grabando…", "● Aufnahme…"],
        Play: ["Play", "Reproducir", "Abspielen"],
        Pause: ["Pause", "Pausar", "Pause"],
        PlayHint: ["Play (Space)", "Reproducir (Espacio)", "Abspielen (Leertaste)"],
        PauseHint: ["Pause (Space)", "Pausar (Espacio)", "Pause (Leertaste)"],
        SeekHint: [
            "Seek — ← → to nudge, ↑ ↓ to jump, Home/End for start/end",
            "Buscar — ← → ajustar, ↑ ↓ saltar, Inicio/Fin para principio/final",
            "Springen — ← → feinjustieren, ↑ ↓ springen, Pos1/Ende für Anfang/Ende",
        ],
        Close: ["Close", "Cerrar", "Schließen"],
        LoadingDay: ["Loading day…", "Cargando el día…", "Tag wird geladen…"],
        LoadFailed: ["Could not load the day's tracks.", "No se pudieron cargar los recorridos del día.", "Die Strecken des Tages konnten nicht geladen werden."],
        NoTrackDay: ["No track recorded on this day.", "No se registró ningún recorrido este día.", "An diesem Tag wurde keine Strecke aufgezeichnet."],
        // morning-replays dialog
        MorningTitle: ["Morning replays", "Repeticiones matinales", "Morgen-Replays"],
        MorningLead: [
            "Every workday becomes a short cinematic video, ready in the morning — for operators to review the day in minutes, and for each worker to see their own.",
            "Cada jornada se convierte en un breve video cinematográfico, listo por la mañana — para que los operadores revisen el día en minutos y cada trabajador vea el suyo.",
            "Jeder Arbeitstag wird zu einem kurzen filmischen Video, fertig am Morgen — damit Disponenten den Tag in Minuten überblicken und jeder Mitarbeiter seinen eigenen sieht.",
        ],
        MembersLabel: ["Members", "Miembros", "Mitglieder"],
        MembersCaptionEmpty: ["Leave empty to include everyone with tracking. Tip: start with one team.", "Déjalo vacío para incluir a todos con seguimiento. Consejo: empieza con un equipo.", "Leer lassen, um alle mit Tracking einzuschließen. Tipp: Beginne mit einem Team."],
        MembersCaptionOne: ["{0} member will get a replay every workday.", "{0} miembro recibirá una repetición cada jornada.", "{0} Mitglied erhält an jedem Arbeitstag ein Replay."],
        MembersCaptionMany: ["{0} members will get a replay every workday.", "{0} miembros recibirán una repetición cada jornada.", "{0} Mitglieder erhalten an jedem Arbeitstag ein Replay."],
        RenderAtLabel: ["Render at (company local time)", "Renderizar a las (hora local de la empresa)", "Rendern um (lokale Unternehmenszeit)"],
        HourPrevDaySuffix: [" (renders the previous day)", " (renderiza el día anterior)", " (rendert den Vortag)"],
        PushToMember: ["Send each worker their own replay as a notification", "Enviar a cada trabajador su propia repetición como notificación", "Jedem Mitarbeiter sein eigenes Replay als Benachrichtigung senden"],
        DigestLabel: ["Morning digest email", "Correo de resumen matinal", "Morgen-Zusammenfassung per E-Mail"],
        DigestCaption: ["One summary email with all of yesterday's replays — press Enter after each address.", "Un correo resumen con todas las repeticiones de ayer — presiona Enter tras cada dirección.", "Eine Zusammenfassungs-E-Mail mit allen Replays von gestern — drücke nach jeder Adresse Enter."],
        TurnOff: ["Turn off", "Desactivar", "Ausschalten"],
        SaveChanges: ["Save changes", "Guardar cambios", "Änderungen speichern"],
        EnableMorning: ["Enable morning replays", "Activar repeticiones matinales", "Morgen-Replays aktivieren"],
        ToastMorningSaveFailed: ["Could not save — please try again", "No se pudo guardar — inténtalo de nuevo", "Konnte nicht speichern — bitte erneut versuchen"],
        ToastMorningOff: ["Morning replays turned off", "Repeticiones matinales desactivadas", "Morgen-Replays ausgeschaltet"],
        ToastMorningBackfillOne: [
            "Morning replays on — rendering yesterday for {0} member now. Videos will appear in the library within minutes.",
            "Repeticiones matinales activadas — renderizando ayer para {0} miembro. Los videos aparecerán en la biblioteca en minutos.",
            "Morgen-Replays aktiv — gestern wird für {0} Mitglied gerendert. Die Videos erscheinen in wenigen Minuten in der Bibliothek.",
        ],
        ToastMorningBackfillMany: [
            "Morning replays on — rendering yesterday for {0} members now. Videos will appear in the library within minutes.",
            "Repeticiones matinales activadas — renderizando ayer para {0} miembros. Los videos aparecerán en la biblioteca en minutos.",
            "Morgen-Replays aktiv — gestern wird für {0} Mitglieder gerendert. Die Videos erscheinen in wenigen Minuten in der Bibliothek.",
        ],
        ToastMorningSettingsSaved: ["Morning replays settings saved", "Configuración de repeticiones matinales guardada", "Einstellungen für Morgen-Replays gespeichert"],
        // scope labels (replayScope)
        DayReplay: ["Day replay", "Repetición del día", "Tages-Replay"],
        TripReplay: ["Trip replay", "Repetición del viaje", "Fahrt-Replay"],
        StopReplay: ["Stop replay", "Repetición de la parada", "Stopp-Replay"],
        SelectionReplay: ["Selection replay", "Repetición de la selección", "Auswahl-Replay"],
        Play3D: ["▶ 3D replay", "▶ Repetición 3D", "▶ 3D-Replay"],
        ReplayTrip: ["▶ Replay trip", "▶ Reproducir viaje", "▶ Fahrt abspielen"],
        ReplayStop: ["▶ Replay stop", "▶ Reproducir parada", "▶ Stopp abspielen"],
        ReplaySelection: ["▶ Replay selection", "▶ Reproducir selección", "▶ Auswahl abspielen"],
        SaveDayVideo: ["Save day video", "Guardar video del día", "Tagesvideo speichern"],
        SaveTripVideo: ["Save trip video", "Guardar video del viaje", "Fahrtvideo speichern"],
        SaveStopVideo: ["Save stop video", "Guardar video de la parada", "Stopp-Video speichern"],
        SaveSelectionVideo: ["Save selection video", "Guardar video de la selección", "Auswahl-Video speichern"],
        SaveVideo: ["Save video", "Guardar video", "Video speichern"],
    },
    Planner: {
        // header
        Title: ["Week planner", "Planificador semanal", "Wochenplaner"],
        Tab: ["Planner", "Planificador", "Planer"],
        JumpToWeek: ["Jump to a week", "Ir a una semana", "Zu einer Woche springen"],
        DragHint: [
            "Drag jobs between days and members",
            "Arrastra tareas entre días y miembros",
            "Ziehe Aufträge zwischen Tagen und Mitgliedern",
        ],
        FilterMembers: ["Filter members", "Filtrar miembros", "Mitglieder filtern"],
        MembersCount: ["Members · {0}", "Miembros · {0}", "Mitglieder · {0}"],
        MembersCountAuto: ["Members · {0} (auto)", "Miembros · {0} (auto)", "Mitglieder · {0} (auto)"],
        Today: ["Today", "Hoy", "Heute"],
        ClosePlanner: ["Close planner", "Cerrar planificador", "Wochenplaner schließen"],
        // day and row headers
        JobCountOne: ["{0} job", "{0} tarea", "{0} Auftrag"],
        JobCountMany: ["{0} jobs", "{0} tareas", "{0} Aufträge"],
        OpenCount: ["{0} open", "{0} sin asignar", "{0} offen"],
        Unassigned: ["Unassigned", "Sin asignar", "Nicht zugewiesen"],
        AllJobsAssigned: ["All jobs assigned", "Todas las tareas asignadas", "Alle Aufträge zugewiesen"],
        ToAssignOne: ["{0} job to assign", "{0} tarea por asignar", "{0} Auftrag zuzuweisen"],
        ToAssignMany: ["{0} jobs to assign", "{0} tareas por asignar", "{0} Aufträge zuzuweisen"],
        NoJobsThisWeek: ["No jobs this week", "Sin tareas esta semana", "Keine Aufträge diese Woche"],
        RowSummaryOne: ["{0} job · {1}", "{0} tarea · {1}", "{0} Auftrag · {1}"],
        RowSummaryMany: ["{0} jobs · {1}", "{0} tareas · {1}", "{0} Aufträge · {1}"],
        // capacity meter
        OnSite: ["On-site: {0}", "En sitio: {0}", "Vor Ort: {0}"],
        Travel: ["Travel: {0}", "Trayecto: {0}", "Fahrt: {0}"],
        Calculating: ["calculating…", "calculando…", "wird berechnet…"],
        LoadOfCapacity: ["{0} of {1}", "{0} de {1}", "{0} von {1}"],
        OverCapacity: ["over capacity", "capacidad superada", "Kapazität überschritten"],
        Off: ["Off", "Libre", "Frei"],
        OffDay: ["{0} · off day", "{0} · día libre", "{0} · freier Tag"],
        // members picker
        SearchMembers: ["Search members", "Buscar miembros", "Mitglieder suchen"],
        AllTeams: ["All teams", "Todos los equipos", "Alle Teams"],
        OnTheBoard: ["On the board · {0}", "En el tablero · {0}", "Auf dem Board · {0}"],
        ResetToAuto: ["Reset to auto", "Restablecer a automático", "Auf automatisch zurücksetzen"],
        NobodyOnBoardAdd: [
            "Nobody on the board yet — add someone below.",
            "Nadie en el tablero todavía — agrega a alguien abajo.",
            "Noch niemand auf dem Board — füge unten jemanden hinzu.",
        ],
        RemoveFromBoard: ["Remove from board", "Quitar del tablero", "Vom Board entfernen"],
        UnassignedLane: ["Unassigned lane", "Fila sin asignar", "Spur „Nicht zugewiesen“"],
        Show: ["Show", "Mostrar", "Anzeigen"],
        Hide: ["Hide", "Ocultar", "Ausblenden"],
        AddMembers: ["Add members", "Agregar miembros", "Mitglieder hinzufügen"],
        AddAll: ["Add all", "Agregar todos", "Alle hinzufügen"],
        AddAllShown: ["Add all shown", "Agregar los mostrados", "Alle angezeigten hinzufügen"],
        NoMembersMatch: ["No members match.", "Ningún miembro coincide.", "Keine Mitglieder gefunden."],
        EveryoneOnBoard: ["Everyone's on the board.", "Todos están en el tablero.", "Alle sind auf dem Board."],
        MoreRefineSearch: [
            "+{0} more — refine your search",
            "+{0} más — refina tu búsqueda",
            "+{0} weitere — verfeinere deine Suche",
        ],
        NobodyOnBoardPick: [
            "Nobody on the board yet — pick who you want to plan for.",
            "Nadie en el tablero todavía — elige para quién quieres planificar.",
            "Noch niemand auf dem Board — wähle aus, für wen du planen möchtest.",
        ],
        PickMembers: ["Pick members", "Elegir miembros", "Mitglieder auswählen"],
        NoMembersMatchSearch: [
            "No members on the board match “{0}”.",
            "Ningún miembro del tablero coincide con «{0}».",
            "Keine Mitglieder auf dem Board passen zu „{0}“.",
        ],
        // plan week
        PlanWeek: ["Plan week", "Planificar semana", "Woche planen"],
        Cancel: ["Cancel", "Cancelar", "Abbrechen"],
        // plan scope popover
        PlanScope: ["What will be planned", "Qué se va a planificar", "Was geplant wird"],
        DayInPast: [
            "Days in the past can't be planned",
            "Los días pasados no se pueden planificar",
            "Vergangene Tage können nicht geplant werden",
        ],
        ScopeMembers: ["Members on the board", "Miembros del tablero", "Mitglieder auf dem Board"],
        ScopeMembersOne: ["{0} member", "{0} miembro", "{0} Mitglied"],
        ScopeMembersMany: ["{0} members", "{0} miembros", "{0} Mitglieder"],
        ScopeIncludeUnassigned: [
            "Include unassigned jobs",
            "Incluir tareas sin asignar",
            "Nicht zugewiesene Aufträge einbeziehen",
        ],
        ScopeRecurring: [
            "Recurring visits not yet scheduled",
            "Visitas recurrentes aún no programadas",
            "Wiederkehrende Besuche, noch nicht geplant",
        ],
        ScopeNotCounted: ["{0} · not counted", "{0} · no se cuentan", "{0} · nicht mitgezählt"],
        ScopeNothingSelected: [
            "Pick at least one day and one member.",
            "Elige al menos un día y un miembro.",
            "Wähle mindestens einen Tag und ein Mitglied.",
        ],
        ScopeSummaryOne: ["Plans {0} job.", "Planifica {0} tarea.", "Plant {0} Auftrag."],
        ScopeSummaryMany: ["Plans {0} jobs.", "Planifica {0} tareas.", "Plant {0} Aufträge."],
        ScopeFreeze: [
            "The next {0} min stay as they are.",
            "Los próximos {0} min se mantienen igual.",
            "Die nächsten {0} Min. bleiben unverändert.",
        ],
        ProposedPlan: ["Proposed plan", "Plan propuesto", "Vorgeschlagener Plan"],
        EveryJobFits: [
            "Every job already fits its day — no cross-day moves needed.",
            "Cada tarea ya cabe en su día — no hacen falta cambios de día.",
            "Jeder Auftrag passt bereits in seinen Tag — keine Verschiebungen nötig.",
        ],
        MovesOne: [
            "{0} job moves to a better day",
            "{0} tarea se mueve a un día mejor",
            "{0} Auftrag wird auf einen besseren Tag verschoben",
        ],
        MovesMany: [
            "{0} jobs move to a better day",
            "{0} tareas se mueven a un día mejor",
            "{0} Aufträge werden auf einen besseren Tag verschoben",
        ],
        NeedReview: ["{0} need review", "{0} requieren revisión", "{0} zu prüfen"],
        ProposedMovesTitle: [
            "Proposed moves — click to show on the board",
            "Cambios propuestos — haz clic para verlos en el tablero",
            "Vorgeschlagene Verschiebungen — klicke, um sie auf dem Board zu zeigen",
        ],
        NeedsReviewTitle: [
            "Needs review — no day this week had room",
            "Requiere revisión — ningún día de esta semana tenía espacio",
            "Zu prüfen — kein Tag dieser Woche hatte Platz",
        ],
        DidntFitAnyDay: [
            "Didn't fit any day this week",
            "No cupo en ningún día de esta semana",
            "Passte in keinen Tag dieser Woche",
        ],
        MoreCount: ["+{0} more", "+{0} más", "+{0} weitere"],
        Job: ["Job", "Tarea", "Auftrag"],
        Dismiss: ["Dismiss", "Descartar", "Verwerfen"],
        Discard: ["Discard", "Descartar", "Verwerfen"],
        ApplyPlan: ["Apply plan", "Aplicar plan", "Plan anwenden"],
        // proposed move chip
        ProposedMoveCurrently: [
            "Proposed move — currently {0} {1}",
            "Cambio propuesto — actualmente {0} {1}",
            "Vorgeschlagene Verschiebung — aktuell {0} {1}",
        ],
        FromDay: ["from {0}", "desde {0}", "von {0}"],
        // recurring ghost chip
        RecurringVisit: ["Recurring visit", "Visita recurrente", "Wiederkehrender Besuch"],
        Recurring: ["Recurring", "Recurrente", "Wiederkehrend"],
        RecurringStopsOne: [
            "Recurring · {0} stop · ~{1}",
            "Recurrente · {0} parada · ~{1}",
            "Wiederkehrend · {0} Stopp · ~{1}",
        ],
        RecurringStopsMany: [
            "Recurring · {0} stops · ~{1}",
            "Recurrente · {0} paradas · ~{1}",
            "Wiederkehrend · {0} Stopps · ~{1}",
        ],
        ClickToSchedule: ["Click to schedule", "Haz clic para programar", "Zum Planen klicken"],
        // job chip
        TimeWindow: ["Window {0}", "Ventana {0}", "Zeitfenster {0}"],
        // toasts
        CouldntBuildPlan: [
            "Couldn't build a week plan",
            "No se pudo crear el plan semanal",
            "Wochenplan konnte nicht erstellt werden",
        ],
        NoMovesNeeded: [
            "Every job already fits its day — no cross-day moves needed",
            "Cada tarea ya cabe en su día — no hacen falta cambios de día",
            "Jeder Auftrag passt bereits in seinen Tag — keine Verschiebungen nötig",
        ],
        CouldntApplyPlan: [
            "Couldn't apply the plan",
            "No se pudo aplicar el plan",
            "Plan konnte nicht angewendet werden",
        ],
        AppliedOne: [
            "Applied — {0} job moved to a better day",
            "Aplicado — {0} tarea movida a un día mejor",
            "Angewendet — {0} Auftrag auf einen besseren Tag verschoben",
        ],
        AppliedMany: [
            "Applied — {0} jobs moved to a better day",
            "Aplicado — {0} tareas movidas a un día mejor",
            "Angewendet — {0} Aufträge auf einen besseren Tag verschoben",
        ],
        CouldntSchedule: [
            "Couldn't schedule this occurrence",
            "No se pudo programar esta visita",
            "Dieser Termin konnte nicht geplant werden",
        ],
        RecurringScheduled: [
            "Recurring visit scheduled",
            "Visita recurrente programada",
            "Wiederkehrender Besuch geplant",
        ],
        AlreadyScheduled: ["Already scheduled", "Ya programado", "Bereits geplant"],
    },
    Filters: {
        Filter: ["Filter", "Filtro", "Filter"],
        AddFilter: ["Add a filter", "Agregar un filtro", "Filter hinzufügen"],
        Clear: ["Clear", "Borrar", "Zurücksetzen"],
        XOfY: ["{0} of {1}", "{0} de {1}", "{0} von {1}"],
        Only: ["Only", "Solo", "Nur"],
        XPicked: ["{0} picked", "{0} elegidos", "{0} ausgewählt"],
        Search: ["Search", "Buscar", "Suchen"],
        NoValues: ["Nothing to pick yet", "Todavía no hay nada que elegir", "Noch nichts zur Auswahl"],
        NoValuesMatch: ["Nothing matches “{0}”", "Nada coincide con «{0}»", "Nichts passt zu „{0}“"],
        RemoveFilter: ["Remove the {0} filter", "Quitar el filtro {0}", "Filter {0} entfernen"],
        XHiddenByFilters: ["{0} hidden by filters", "{0} ocultos por los filtros", "{0} durch Filter ausgeblendet"],
        OneHiddenByFilters: ["1 hidden by filters", "1 oculto por los filtros", "1 durch Filter ausgeblendet"],
        ShowAll: ["Show all", "Mostrar todos", "Alle zeigen"],
        ClearFilters: ["Clear filters", "Borrar filtros", "Filter zurücksetzen"],
        NoPeopleMatch: ["No one matches these filters.", "Nadie coincide con estos filtros.", "Niemand passt zu diesen Filtern."],
        SearchPeople: ["Search people", "Buscar personas", "Leute suchen"],
        StatusMoving: ["On the way", "En camino", "Unterwegs"],
        StatusAtJob: ["At a job", "En una tarea", "Bei einem Auftrag"],
        StatusAtPlace: ["At a place", "En un lugar", "An einem Ort"],
        StatusStationary: ["Stationary", "Parado", "Steht"],
        StatusNotReporting: ["Not reporting", "Sin señal", "Kein Signal"],
        StatusOffDuty: ["Off duty", "Fuera de servicio", "Nicht im Dienst"],
        StatusHint: ["What they are doing right now", "Lo que están haciendo ahora", "Was sie gerade machen"],
        ActiveHint: ["Tracking on and a location in the last 18 hours", "Seguimiento activado y una ubicación en las últimas 18 horas", "Tracking an und ein Standort in den letzten 18 Stunden"],
        InServiceHint: ["Logged in, tracking on and not off duty", "Con sesión iniciada, seguimiento activado y no fuera de servicio", "Angemeldet, Tracking an und nicht außer Dienst"],
        HasJobsHint: ["Have jobs today", "Tienen tareas hoy", "Haben heute Aufträge"],
        TeamHint: ["In any of the picked teams", "En alguno de los equipos elegidos", "In einem der gewählten Teams"],
        NoTeam: ["No team", "Sin equipo", "Ohne Team"],
        Skill: ["Skill", "Habilidad", "Skill"],
        SkillHint: ["Has any of the picked skills", "Tiene alguna de las habilidades elegidas", "Hat einen der gewählten Skills"],
        RoleHint: ["Worker, operator or administrator", "Trabajador, operador o administrador", "Mitarbeiter, Disponent oder Admin"],
        Jobs: ["Jobs", "Tareas", "Aufträge"],
        JobsHas: ["Has jobs", "Con tareas", "Hat Aufträge"],
        JobsNone: ["No jobs", "Sin tareas", "Keine Aufträge"],
        JobsHint: ["Has jobs on the day shown, or none", "Tiene tareas el día mostrado, o ninguna", "Hat am gezeigten Tag Aufträge oder keine"],
        Working: ["Working hours", "Horario", "Arbeitszeit"],
        WorkingNow: ["Working now", "Trabajando ahora", "Gerade im Dienst"],
        WorkingOff: ["Off shift", "Fuera de horario", "Außerhalb der Dienstzeit"],
        WorkingHint: ["Inside their working hours right now", "Dentro de su horario ahora mismo", "Gerade in ihrer Arbeitszeit"],
        Attention: ["Needs attention", "Requiere atención", "Braucht Aufmerksamkeit"],
        AttentionHint: ["Phone issues: battery, permissions, old app", "Problemas del teléfono: batería, permisos, app antigua", "Handy-Probleme: Akku, Berechtigungen, alte App"],
        BatteryLow: ["Battery low", "Batería baja", "Akku schwach"],
        AppUpdate: ["Old app version", "Versión antigua de la app", "Alte App-Version"],
        JobStatusHint: ["Where the job stands", "En qué estado está la tarea", "Wo der Auftrag steht"],
        Late: ["Late", "Con retraso", "Verspätet"],
        LateHint: ["Missed its time window, or arriving after it", "Fuera de su ventana horaria o llegando tarde", "Zeitfenster verpasst oder kommt zu spät an"],
        LateMissed: ["Window missed", "Franja perdida", "Zeitfenster verpasst"],
        LateAtRisk: ["Arriving late", "Llegará tarde", "Kommt zu spät"],
        PriorityHint: ["High, normal or low", "Alta, normal o baja", "Hoch, normal oder niedrig"],
        Label: ["Label", "Etiqueta", "Label"],
        LabelHint: ["Has any of the picked labels", "Tiene alguna de las etiquetas elegidas", "Hat eines der gewählten Labels"],
        Assignee: ["Assignee", "Asignada a", "Zugewiesen an"],
        AssigneeHint: ["Assigned to any of the picked people", "Asignada a alguna de las personas elegidas", "Einer der gewählten Personen zugewiesen"],
        JobTeamHint: ["The team the job belongs to", "El equipo de la tarea", "Das Team des Auftrags"],
        Proof: ["Proof", "Comprobante", "Nachweis"],
        ProofHint: ["Form, signature or photo on the job", "Formulario, firma o foto en la tarea", "Formular, Unterschrift oder Foto am Auftrag"],
        ProofForm: ["Form filled in", "Formulario completado", "Formular ausgefüllt"],
        ProofNoForm: ["No form", "Sin formulario", "Kein Formular"],
        ProofSignature: ["Signed", "Firmada", "Unterschrieben"],
        ProofNoSignature: ["Not signed", "Sin firma", "Nicht unterschrieben"],
        ProofPhoto: ["Has photos", "Con fotos", "Mit Fotos"],
        ProofNoPhoto: ["No photos", "Sin fotos", "Ohne Fotos"],
        SearchJobs: ["Search jobs", "Buscar tareas", "Aufträge suchen"],
        NoJobsMatch: ["No jobs match these filters.", "Ninguna tarea coincide con estos filtros.", "Kein Auftrag passt zu diesen Filtern."],
        Date: ["Date", "Fecha", "Datum"],
        DateToday: ["Today", "Hoy", "Heute"],
        DateNone: ["No date", "Sin fecha", "Ohne Datum"],
        DateUpdated: ["Changed in the last hour", "Cambiadas en la última hora", "In der letzten Stunde geändert"],
        DateHint: ["Today, no date, or changed in the last hour", "Hoy, sin fecha o cambiadas en la última hora", "Heute, ohne Datum oder in der letzten Stunde geändert"],
        Archived: ["Archived", "Archivadas", "Archiviert"],
        ArchivedHint: ["Show the archived jobs instead of the active ones", "Mostrar las tareas archivadas en lugar de las activas", "Archivierte statt aktive Aufträge zeigen"],
        FilterByColumn: ["Filter by {0}", "Filtrar por {0}", "Nach {0} filtern"],
        Views: ["Views", "Vistas", "Ansichten"],
        ViewX: ["View: {0}", "Vista: {0}", "Ansicht: {0}"],
        ViewXChanged: ["View: {0} · changed", "Vista: {0} · cambiada", "Ansicht: {0} · geändert"],
        BackToView: ["Back to “{0}”", "Volver a «{0}»", "Zurück zu „{0}“"],
        NoView: ["No view, filters off", "Sin vista, sin filtros", "Keine Ansicht, keine Filter"],
        MyViews: ["My views", "Mis vistas", "Meine Ansichten"],
        SaveAsView: ["Save as new view…", "Guardar como vista nueva…", "Als neue Ansicht speichern…"],
        UpdateView: ["Update “{0}”", "Actualizar «{0}»", "„{0}“ aktualisieren"],
        ViewName: ["Name of the view", "Nombre de la vista", "Name der Ansicht"],
        Save: ["Save", "Guardar", "Speichern"],
        DeleteView: ["Delete the view {0}", "Eliminar la vista {0}", "Ansicht {0} löschen"],
        ViewChanged: ["Changed since you opened it", "Cambiada desde que la abriste", "Geändert, seit du sie geöffnet hast"],
    },
    JobSheet: {
        WhatHappened: ["What happened", "Qué pasó", "Was passiert ist"],
        Plan: ["Plan", "Plan", "Plan"],
        Details: ["Details", "Detalles", "Details"],
        History: ["History", "Historial", "Verlauf"],
        When: ["When", "Cuándo", "Wann"],
        Who: ["Who", "Quién", "Wer"],
        Where: ["Where", "Dónde", "Wo"],
        Type: ["Type", "Tipo", "Art"],
        XOfY: ["{0} of {1}", "{0} de {1}", "{0} von {1}"],
        Previous: ["Previous job", "Tarea anterior", "Vorheriger Auftrag"],
        Next: ["Next job", "Siguiente tarea", "Nächster Auftrag"],
        Accepted: ["Accepted", "Aceptada", "Angenommen"],
        TurnedDown: ["Turned down", "Rechazada", "Abgelehnt"],
        OnTheWay: ["On the way", "En camino", "Unterwegs"],
        CheckedIn: ["Checked in", "Check-in", "Eingecheckt"],
        CheckedOut: ["Checked out", "Check-out", "Ausgecheckt"],
        Gps: ["GPS", "GPS", "GPS"],
        Manual: ["manual", "manual", "manuell"],
        FromJobX: ["{0} from the job", "a {0} de la tarea", "{0} vom Auftrag"],
        AtTheJob: ["at the job", "en la tarea", "am Auftrag"],
        FormSent: ["Form sent", "Formulario enviado", "Formular gesendet"],
        DoneAt: ["Done at {0}", "Hecha a las {0}", "Erledigt um {0}"],
        IssueAt: ["Issue at {0}", "Problema a las {0}", "Problem um {0}"],
        OnSiteSince: ["On site since {0}", "En el sitio desde las {0}", "Vor Ort seit {0}"],
        OnSiteFor: ["{0} on site", "{0} en el sitio", "{0} vor Ort"],
        PastWindow: ["{0} after the window", "{0} después de la ventana", "{0} nach dem Zeitfenster"],
        CarriesOver: ["carries over if unfinished", "pasa a mañana si queda sin hacer", "geht auf morgen über, wenn unerledigt"],
        StopX: ["stop {0}", "parada {0}", "Stopp {0}"],
        SignedBy: ["Signed by {0}", "Firmado por {0}", "Unterschrieben von {0}"],
        Signed: ["Signed", "Firmado", "Unterschrieben"],
        FormsSent: ["Forms sent", "Formularios enviados", "Gesendete Formulare"],
        NoteFrom: ["Note from {0}", "Nota de {0}", "Notiz von {0}"],
        NotesFor: ["Notes for {0}", "Notas para {0}", "Notizen für {0}"],
        NotesForWorker: ["Notes for the worker", "Notas para el trabajador", "Notizen für den Mitarbeiter"],
        Items: ["Items", "Artículos", "Artikel"],
        PickUpDropOff: ["pick up {0} · drop off {1}", "recoger {0} · entregar {1}", "abholen {0} · abgeben {1}"],
        Skills: ["Skills", "Habilidades", "Skills"],
        LinkedReports: ["Linked reports", "Informes vinculados", "Verknüpfte Berichte"],
        MoreX: ["{0} more", "{0} más", "{0} weitere"],
        LinkedNotDropoff: ["Not marked as a drop-off", "No está marcada como entrega", "Nicht als Abgabe markiert"],
        LinkedNotPickup: ["Not marked as a pick-up", "No está marcada como recogida", "Nicht als Abholung markiert"],
        MarkIt: ["Mark it", "Marcarla", "Markieren"],
        LinkedOtherDay: ["On a different day", "En otro día", "An einem anderen Tag"],
        LinkedOtherPerson: ["Assigned to someone else", "Asignada a otra persona", "Jemand anderem zugewiesen"],
        VoizDesc: ["Voice-based reports that field workers fill out by speaking. Create and manage report templates at {0}, then link them here with the report code.", "Informes por voz que los trabajadores completan hablando. Crea y gestiona las plantillas en {0} y vincúlalas aquí con el código del informe.", "Sprachberichte, die Mitarbeiter im Außendienst per Sprache ausfüllen. Vorlagen erstellst und verwaltest du auf {0} und verknüpfst sie hier mit dem Berichtscode."],
        VoizCodeHint: ["Enter the 6-character code or paste a voiz.report link", "Ingresa el código de 6 caracteres o pega un enlace de voiz.report", "Gib den 6-stelligen Code ein oder füge einen voiz.report-Link ein"],
        VoizChecking: ["Checking the code…", "Comprobando el código…", "Code wird geprüft…"],
        VoizNotFound: ["No Voiz template found for this code.", "No hay ninguna plantilla de Voiz con este código.", "Für diesen Code gibt es keine Voiz-Vorlage."],
        VoizDuplicate: ["This Voiz code is already linked.", "Este código de Voiz ya está vinculado.", "Dieser Voiz-Code ist schon verknüpft."],
        VoizUnavailable: ["Couldn't check the code. Try again.", "No se pudo comprobar el código. Inténtalo de nuevo.", "Der Code ließ sich nicht prüfen. Versuch es noch mal."],
        AddReport: ["Add report", "Agregar informe", "Bericht hinzufügen"],
        CompletionEmail: ["Completion email", "Correo al terminar", "Abschluss-E-Mail"],
        EditJob: ["Edit job", "Editar tarea", "Auftrag bearbeiten"],
        Back: ["Back", "Volver", "Zurück"],
        ShowOnMap: ["Show on map", "Ver en el mapa", "Auf der Karte zeigen"],
        CreatedOn: ["Created {0}", "Creada el {0}", "Erstellt am {0}"],
        ByX: ["by {0}", "por {0}", "von {0}"],
        LastChange: ["last change {0}", "último cambio {0}", "zuletzt geändert {0}"],
        Template: ["Template", "Plantilla", "Vorlage"],
        TemplateNote: ["Changes apply to new jobs made from it", "Los cambios se aplican a las tareas nuevas que salgan de ella", "Änderungen gelten für neue Aufträge daraus"],
        RecurringRoute: ["Part of a recurring route", "Parte de una ruta recurrente", "Teil einer wiederkehrenden Route"],
        RecurringRouteNote: ["Changes apply to the route", "Los cambios se aplican a la ruta", "Änderungen gelten für die Route"],
        Archived: ["Archived", "Archivada", "Archiviert"],
        Deleted: ["This job was deleted.", "Esta tarea se eliminó.", "Dieser Auftrag wurde gelöscht."],
        LoadingJob: ["Loading the job…", "Cargando la tarea…", "Auftrag wird geladen…"],
        NextStop: ["next job", "siguiente tarea", "nächster Auftrag"],
        Reassign: ["Reassign", "Reasignar", "Neu zuweisen"],
        ChangeDay: ["Change day", "Cambiar día", "Tag ändern"],
        Status: ["Status", "Estado", "Status"],
        Message: ["Message", "Mensaje", "Nachricht"],
        MessageX: ["Message {0}", "Escribir a {0}", "Nachricht an {0}"],
        AllFields: ["All fields", "Todos los campos", "Alle Felder"],
        Today: ["Today", "Hoy", "Heute"],
        Tomorrow: ["Tomorrow", "Mañana", "Morgen"],
        PickADay: ["Pick a day", "Elegir un día", "Tag wählen"],
        MovedTo: ["Moved to {0}", "Movida al {0}", "Verschoben auf {0}"],
        GivenTo: ["Given to {0}", "Asignada a {0}", "{0} zugewiesen"],
        NowUnassigned: ["Now unassigned", "Ahora sin asignar", "Jetzt nicht zugewiesen"],
        StatusSetTo: ["Status set to {0}", "Estado cambiado a {0}", "Status auf {0} gesetzt"],
        SetStatusQuestion: ["Set the status to {0}? This can't be undone.", "¿Cambiar el estado a {0}? No se puede deshacer.", "Status auf {0} setzen? Das lässt sich nicht rückgängig machen."],
        Set: ["Set", "Cambiar", "Setzen"],
        FieldSaved: ["{0} saved", "{0} guardado", "{0} gespeichert"],
        Undo: ["Undo", "Deshacer", "Rückgängig"],
        ChangedBack: ["Changed back", "Cambio deshecho", "Zurückgesetzt"],
        CouldNotSave: ["Couldn't save. Nothing was changed.", "No se pudo guardar. No se cambió nada.", "Konnte nicht speichern. Es wurde nichts geändert."],
        EnterSaves: ["Enter saves · Esc cancels", "Enter guarda · Esc cancela", "Enter speichert · Esc bricht ab"],
        ClickAwaySaves: ["Saves when you click away · Esc cancels", "Se guarda al hacer clic fuera · Esc cancela", "Speichert beim Wegklicken · Esc bricht ab"],
        AddComment: ["Add a comment", "Agregar un comentario", "Kommentar hinzufügen"],
        Add: ["Add", "Agregar", "Hinzufügen"],
        Title: ["Title", "Título", "Titel"],
        Day: ["Day", "Día", "Tag"],
        From: ["From", "Desde", "Von"],
        To: ["To", "Hasta", "Bis"],
        PickUp: ["Pick up", "Recoger", "Abholen"],
        DropOff: ["Drop off", "Entregar", "Abgeben"],
        Name: ["Name", "Nombre", "Name"],
        Email: ["Email", "Correo", "E-Mail"],
        Phone: ["Phone", "Teléfono", "Telefon"],
        Team: ["Team", "Equipo", "Team"],
        SearchWhere: ["Search a place or address", "Busca un lugar o una dirección", "Ort oder Adresse suchen"],
        KeepWhere: ["Keep it", "Dejarlo así", "So lassen"],
        MoreInForm: ["More in the job form", "Más en el formulario de la tarea", "Mehr im Auftragsformular"],
        AttachmentsAndLinks: ["Attachments and links", "Adjuntos y vínculos", "Anhänge und Verknüpfungen"],
        LinkedJob: ["Linked job", "Tarea vinculada", "Verknüpfter Auftrag"],
        FormForJob: ["Form for this job", "Formulario de esta tarea", "Formular für diesen Auftrag"],
        CorrectAnswers: ["Correct the answers", "Corregir las respuestas", "Antworten korrigieren"],
        MoreActions: ["More", "Más", "Mehr"],
        Duplicate: ["Duplicate", "Duplicar", "Duplizieren"],
        SamePerson: ["Same person", "Misma persona", "Gleiche Person"],
        SameDay: ["Same day", "Mismo día", "Gleicher Tag"],
        SaveAsTemplate: ["Save as template", "Guardar como plantilla", "Als Vorlage speichern"],
        Print: ["Print", "Imprimir", "Drucken"],
        CopyId: ["Copy ID", "Copiar ID", "ID kopieren"],
        IdCopied: ["ID copied", "ID copiada", "ID kopiert"],
        HintTitle: ["Jobs now open on the side", "Las tareas ahora se abren al lado", "Aufträge öffnen jetzt an der Seite"],
        HintBody: ["Your map stays in view. When space is tight, the menu and people list fold away until you close the job.", "Tu mapa sigue a la vista. Si falta espacio, el menú y la lista de personas se pliegan hasta que cierras la tarea.", "Deine Karte bleibt sichtbar. Wenn der Platz knapp ist, klappen Menü und Personenliste ein, bis du den Auftrag schließt."],
        HintTop: ["Assign, change day, status", "Asignar, cambiar día, estado", "Zuweisen, Tag ändern, Status"],
        HintTopWhere: ["at the top", "arriba", "oben"],
        HintBottom: ["Duplicate, print, delete", "Duplicar, imprimir, borrar", "Duplizieren, Drucken, Löschen"],
        HintBottomNoDelete: ["Duplicate, template, print", "Duplicar, plantilla, imprimir", "Duplizieren, Vorlage, Drucken"],
        HintBottomWhere: ["at the bottom", "abajo", "unten"],
        HintMore: ["Message, copy ID, archive", "Mensaje, copiar ID, archivar", "Nachricht, ID kopieren, Archivieren"],
        HintMoreWhere: ["in ⋯", "en ⋯", "unter ⋯"],
        Duplicated: ["Duplicated", "Duplicada", "Dupliziert"],
        SavedAsTemplate: ["Saved as a template", "Guardada como plantilla", "Als Vorlage gespeichert"],
        HistoryCreated: ["Created", "Creada", "Erstellt"],
        HistoryAssigned: ["Assigned to {0}", "Asignada a {0}", "{0} zugewiesen"],
        HistoryUnassigned: ["Unassigned", "Sin asignar", "Zuweisung entfernt"],
        HistoryMoved: ["Moved to {0}", "Movida al {0}", "Verschoben auf {0}"],
        HistoryStatus: ["Status: {0}", "Estado: {0}", "Status: {0}"],
        HistoryLastChange: ["Last change", "Último cambio", "Letzte Änderung"],
        PanelFailed: ["This part couldn't load. Go back and try again.", "Esta parte no se pudo cargar. Vuelve e inténtalo de nuevo.", "Dieser Teil konnte nicht geladen werden. Geh zurück und versuch es noch einmal."],
        Draft: ["Draft", "Borrador", "Entwurf"],
        DraftNote: ["New job · nothing is saved until Create job", "Tarea nueva · no se guarda nada hasta Crear tarea", "Neuer Auftrag · gespeichert wird erst mit Auftrag erstellen"],
        StopDraftNote: ["Stop of the new recurring route · saved with the route", "Parada de la nueva ruta recurrente · se guarda con la ruta", "Stopp der neuen wiederkehrenden Route · wird mit der Route gespeichert"],
        DraftLandsOn: ["New job for {0} · {1} · nothing is saved until Create job", "Tarea nueva para el {0} · {1} · no se guarda nada hasta Crear tarea", "Neuer Auftrag für {0} · {1} · gespeichert wird erst mit Auftrag erstellen"],
        NewJobLandsHere: ["New job · lands here", "Tarea nueva · va aquí", "Neuer Auftrag · landet hier"],
        NewJobLandsAsStop: ["New job · lands as stop {0}", "Tarea nueva · será la parada {0}", "Neuer Auftrag · wird Stopp {0}"],
        NRoutes: ["{0} routes", "{0} rutas", "{0} Routen"],
        FormRow: ["Form", "Formulario", "Formular"],
        FormStandard: ["Standard form", "Formulario estándar", "Standardformular"],
        FormOwn: ["Individual form", "Formulario individual", "Individuelles Formular"],
        FormChoiceHint: ["The worker fills it in when finishing the job, along with photos and a signature. The standard form is shared by every job that uses it.", "Se completa al terminar la tarea, junto con fotos y firma. El formulario estándar lo comparten todas las tareas que lo usan.", "Wird beim Abschließen des Auftrags ausgefüllt, zusammen mit Fotos und Unterschrift. Das Standardformular gilt für alle Aufträge, die es nutzen."],
        FormStandardHint: ["Default form for every job. Select Individual form to change it for this job only.", "El formulario predeterminado de todas las tareas. Elige Formulario individual para cambiarlo solo en esta tarea.", "Das Standardformular für jeden Auftrag. Wähl Individuelles Formular, um es nur für diesen Auftrag zu ändern."],
        FormWorkerSees: ["What the worker sees and answers when finishing the job. Required questions must be answered first.", "Lo que el trabajador ve y contesta al terminar la tarea. Las preguntas obligatorias se contestan antes.", "Das sieht und beantwortet der Mitarbeiter beim Abschließen des Auftrags. Pflichtfragen müssen vorher beantwortet sein."],
        Customer: ["Customer", "Cliente", "Kunde"],
        NotSharedYet: ["No ETA page yet", "Aún sin página ETA", "Noch keine ETA-Seite"],
        EtaPageExplainerXY: ["{0} sees when {1} arrives and can say they're ready, add access notes or ask for another time.", "{0} ve cuándo llega {1} y puede avisar que está listo, agregar notas de acceso o pedir otro horario.", "{0} sieht, wann {1} ankommt, und kann Bescheid geben, dass alles bereit ist, Zugangshinweise ergänzen oder einen anderen Termin anfragen."],
        EtaPageExplainer: ["Your customer sees when the worker arrives and can say they're ready, add access notes or ask for another time.", "Tu cliente ve cuándo llega el trabajador y puede avisar que está listo, agregar notas de acceso o pedir otro horario.", "Dein Kunde sieht, wann der Mitarbeiter ankommt, und kann Bescheid geben, dass alles bereit ist, Zugangshinweise ergänzen oder einen anderen Termin anfragen."],
        NotOpenedYet: ["Not opened yet", "Aún sin abrir", "Noch nicht geöffnet"],
        EtaLink: ["ETA page", "Página ETA", "ETA-Seite"],
        FilesAndLinks: ["Files and links", "Archivos y enlaces", "Dateien und Links"],
        OnePicture: ["1 picture", "1 foto", "1 Bild"],
        PicturesX: ["{0} pictures", "{0} fotos", "{0} Bilder"],
        OneFile: ["1 file", "1 archivo", "1 Datei"],
        FilesX: ["{0} files", "{0} archivos", "{0} Dateien"],
        NewLabel: ["New label", "Etiqueta nueva", "Neues Label"],
        LabelName: ["Label name", "Nombre de la etiqueta", "Name des Labels"],
        EditLabels: ["Edit labels", "Editar etiquetas", "Labels bearbeiten"],
        EditLabelsHint: ["Changes here are for picking labels on any job; jobs keep the labels they already have.", "Los cambios aquí son para elegir etiquetas en cualquier tarea; las tareas conservan las etiquetas que ya tienen.", "Änderungen hier gelten für die Auswahl bei allen Aufträgen; Aufträge behalten ihre bisherigen Labels."],
        FormOwnHint: ["Only for this job. {0} fills it in when finishing, along with photos and a signature.", "Solo para esta tarea. {0} lo completa al terminar, junto con fotos y firma.", "Nur für diesen Auftrag. {0} füllt es beim Abschließen aus, zusammen mit Fotos und Unterschrift."],
        FormOwnHintNobody: ["Only for this job. It's filled in when finishing the job, along with photos and a signature.", "Solo para esta tarea. Se completa al terminar la tarea, junto con fotos y firma.", "Nur für diesen Auftrag. Wird beim Abschließen des Auftrags ausgefüllt, zusammen mit Fotos und Unterschrift."],
        NoQuestions: ["No questions yet", "Todavía no hay preguntas", "Noch keine Fragen"],
        YourAnswer: ["Your answer", "Tu respuesta", "Deine Antwort"],
        SignHere: ["Sign here", "Firma aquí", "Hier unterschreiben"],
        TimeWindow: ["Time window", "Ventana horaria", "Zeitfenster"],
        TimeOnSite: ["Time on site", "Tiempo en el sitio", "Zeit vor Ort"],
        Arrive: ["arrive", "llegada", "Ankunft"],
        AnyTime: ["any time", "a cualquier hora", "jederzeit"],
        MinOfWork: ["min of work", "min de trabajo", "Min. Arbeit"],
        NotSet: ["not set", "sin definir", "nicht festgelegt"],
        WindowHint: ["When the job site can be visited. {0} sees it, and routing plans the arrival inside it.", "Cuándo se puede visitar el sitio. {0} lo ve y la ruta planifica la llegada dentro de este horario.", "Wann der Einsatzort besucht werden kann. {0} sieht es, und die Route plant die Ankunft in diesem Zeitfenster."],
        WindowHintNobody: ["When the job site can be visited. The worker sees it, and routing plans the arrival inside it.", "Cuándo se puede visitar el sitio. El trabajador lo ve y la ruta planifica la llegada dentro de este horario.", "Wann der Einsatzort besucht werden kann. Der Mitarbeiter sieht es, und die Route plant die Ankunft in diesem Zeitfenster."],
        OnSiteHint: ["How long the work takes once there. Routing counts it in between the drives.", "Cuánto dura el trabajo una vez allí. La ruta lo cuenta entre los trayectos.", "Wie lange die Arbeit vor Ort dauert. Die Route rechnet sie zwischen den Fahrten ein."],
        WhoHint: ["Who does the job. It shows up in their mobile app.", "Quién hace la tarea. Le aparece en su app móvil.", "Wer den Auftrag erledigt. Er erscheint dann in der Handy-App."],
        TemplateWhoHint: ["Who new jobs made from it go to. When making one, you can still pick someone else.", "A quién van las tareas nuevas que salgan de ella. Al crear una, aún puedes elegir a otra persona.", "Wer neue Aufträge daraus bekommt. Beim Anlegen kannst du noch jemand anderen wählen."],
        TeamHint: ["Which team the job belongs to. Operators and filters can show just their team's jobs.", "A qué equipo pertenece la tarea. Los operadores y los filtros pueden mostrar solo las tareas de su equipo.", "Zu welchem Team der Auftrag gehört. Disponenten und Filter können nur die Aufträge ihres Teams zeigen."],
        WhereHint: ["Where the work is: a saved place or any address.", "Dónde es el trabajo: un lugar guardado o cualquier dirección.", "Wo die Arbeit ist: ein gespeicherter Ort oder eine beliebige Adresse."],
        PinWithoutAddress: ["A pin on the map, no address", "Un pin en el mapa, sin dirección", "Eine Markierung auf der Karte, keine Adresse"],
        LookUpAddress: ["Look up the address", "Buscar la dirección", "Adresse suchen"],
        LookingUpAddress: ["Looking up…", "Buscando…", "Suche…"],
        NoAddressFound: ["No address found here", "No se encontró una dirección aquí", "Hier wurde keine Adresse gefunden"],
        TypeHint: ["The kind of work, such as Install or Service.", "El tipo de trabajo, como Instalación o Servicio.", "Die Art der Arbeit, etwa Installation oder Wartung."],
        BackToBoard: ["Back to what you had open; the job stays open", "Volver a lo que tenías abierto; la tarea sigue abierta", "Zurück zu dem, was du offen hattest; der Auftrag bleibt offen"],
        TemplateDraftNote: ["New template · nothing is saved until Save template", "Plantilla nueva · no se guarda nada hasta Guardar plantilla", "Neue Vorlage · gespeichert wird erst mit Vorlage speichern"],
        JobCreated: ["Job created", "Tarea creada", "Auftrag erstellt"],
        DiscardDraft: ["Discard this new job?", "¿Descartar esta tarea nueva?", "Diesen neuen Auftrag verwerfen?"],
        Discard: ["Discard", "Descartar", "Verwerfen"],
        Done: ["Done", "Listo", "Fertig"],
        Open: ["Open", "Abrir", "Öffnen"],
        UseForNewJobs: ["Use for new jobs", "Usar en tareas nuevas", "Für neue Aufträge nutzen"],
        PickOnMap: ["Pick on the map", "Elegir en el mapa", "Auf der Karte wählen"],
        OpenBig: ["Open as a window", "Abrir como ventana", "Als Fenster öffnen"],
        BesideTheMap: ["Beside the map", "Junto al mapa", "Neben der Karte"],
        OpensBigNow: ["From now on, jobs open as a window", "A partir de ahora, las tareas se abren como ventana", "Ab jetzt öffnen Aufträge als Fenster"],
        OpensBesideNow: ["From now on, jobs open beside the map", "A partir de ahora, las tareas se abren junto al mapa", "Ab jetzt öffnen Aufträge neben der Karte"],
        BesideNote: ["Jobs can now also open beside the map, so the map stays in view.", "Ahora las tareas también se pueden abrir junto al mapa, así el mapa sigue a la vista.", "Aufträge lassen sich jetzt auch neben der Karte öffnen, so bleibt die Karte im Blick."],
        TryIt: ["Try it", "Probar", "Ausprobieren"],
    },
    ImportFlow: {
        Title: ["Import jobs", "Importar tareas", "Aufträge importieren"],
        StepFile: ["File", "Archivo", "Datei"],
        StepColumns: ["Columns", "Columnas", "Spalten"],
        StepCheck: ["Check", "Revisión", "Prüfen"],
        StepDone: ["Done", "Listo", "Fertig"],
        DropTitle: ["Drop a CSV or Excel file", "Suelta un archivo CSV o Excel", "CSV- oder Excel-Datei hier ablegen"],
        ChooseFile: ["Choose a file", "Elegir un archivo", "Datei auswählen"],
        PasteHint: ["or paste rows copied from Excel or Google Sheets ({0})", "o pega filas copiadas de Excel o Google Sheets ({0})", "oder füge Zeilen aus Excel oder Google Sheets ein ({0})"],
        Reading: ["Reading the file…", "Leyendo el archivo…", "Datei wird gelesen…"],
        ReadFailed: ["This file couldn't be read. Save it as CSV or Excel and try again.", "No se pudo leer el archivo. Guárdalo como CSV o Excel y vuelve a intentarlo.", "Die Datei konnte nicht gelesen werden. Speichere sie als CSV oder Excel und versuch es noch einmal."],
        EmptyFile: ["This file has no rows to import.", "Este archivo no tiene filas para importar.", "Die Datei enthält keine Zeilen zum Importieren."],
        WhichSheet: ["This workbook has {0} sheets. Which one?", "Este libro tiene {0} hojas. ¿Cuál?", "Diese Arbeitsmappe hat {0} Blätter. Welches?"],
        SavedLayouts: ["Saved layouts", "Formatos guardados", "Gespeicherte Layouts"],
        LayoutColumnsX: ["{0} columns", "{0} columnas", "{0} Spalten"],
        LayoutUsedX: ["used {0} times", "usado {0} veces", "{0}× verwendet"],
        LayoutLastX: ["last {0}", "última vez {0}", "zuletzt {0}"],
        LayoutByX: ["by {0}", "por {0}", "von {0}"],
        Remove: ["Remove", "Quitar", "Entfernen"],
        LayoutHint: ["A file with the same columns as a saved layout goes straight to the check.", "Un archivo con las mismas columnas que un formato guardado pasa directo a la revisión.", "Eine Datei mit denselben Spalten wie ein gespeichertes Layout geht direkt zur Prüfung."],
        NewFile: ["New file?", "¿Archivo nuevo?", "Neue Datei?"],
        StartFromTemplate: ["Start from a template:", "Empieza con una plantilla:", "Starte mit einer Vorlage:"],
        FieldsHint: ["A file can hold title, place, address, assignee, team, date, time window, time on site, order number, priority, type, contact, notes, skills, forms, zones and your own custom fields.", "Un archivo puede tener título, lugar, dirección, persona asignada, equipo, fecha, ventana horaria, tiempo en el sitio, número de pedido, prioridad, tipo, contacto, notas, habilidades, formularios, zonas y tus propios campos personalizados.", "Eine Datei kann Titel, Ort, Adresse, Zuweisung, Team, Datum, Zeitfenster, Zeit vor Ort, Auftragsnummer, Priorität, Typ, Kontakt, Notizen, Skills, Formulare, Zonen und eigene Felder enthalten."],
        InYourFile: ["In your file", "En tu archivo", "In deiner Datei"],
        Samples: ["Samples", "Ejemplos", "Beispiele"],
        Becomes: ["Becomes", "Se importa como", "Wird zu"],
        CustomField: ["Custom field", "Campo personalizado", "Eigenes Feld"],
        LeaveOut: ["Leave out", "No importar", "Nicht importieren"],
        SuggestionsX: ["{0} suggestions below. Today these columns would become custom fields.", "{0} sugerencias abajo. Hoy estas columnas se importarían como campos personalizados.", "{0} Vorschläge unten. Heute würden diese Spalten als eigene Felder importiert."],
        SuggestionOne: ["1 suggestion below. Today this column would become a custom field.", "1 sugerencia abajo. Hoy esta columna se importaría como campo personalizado.", "1 Vorschlag unten. Heute würde diese Spalte als eigenes Feld importiert."],
        AcceptAll: ["Accept all", "Aceptar todo", "Alle übernehmen"],
        Accept: ["Accept", "Aceptar", "Übernehmen"],
        UseX: ["Use as {0}", "Usar como {0}", "Als {0}"],
        SuggestedX: ["Suggested: {0}", "Sugerencia: {0}", "Vorschlag: {0}"],
        ConflictX: ["This name would be read as {0}. Rename the column in the file or leave it out.", "Este nombre se leería como {0}. Cambia el nombre de la columna en el archivo o no la importes.", "Dieser Name würde als {0} gelesen. Benenne die Spalte in der Datei um oder importiere sie nicht."],
        SaveAsLayout: ["Save as layout", "Guardar como formato", "Als Layout speichern"],
        LayoutName: ["Layout name", "Nombre del formato", "Name des Layouts"],
        CheckXRows: ["Check {0} rows", "Revisar {0} filas", "{0} Zeilen prüfen"],
        CheckOneRow: ["Check 1 row", "Revisar 1 fila", "1 Zeile prüfen"],
        UsingLayoutX: ["Layout: {0}", "Formato: {0}", "Layout: {0}"],
        UsingYourLayoutX: ["Using your layout “{0}”", "Usando tu formato «{0}»", "Dein Layout „{0}“ wird verwendet"],
        DontUseLayout: ["Don't use it", "No usarlo", "Nicht verwenden"],
        UsingYourLayout: ["Using your layout", "Usando tu formato", "Verwendet wird dein Layout"],
        NoLayout: ["None, the file's own columns", "Ninguno, las columnas del archivo", "Keins, die Spalten der Datei"],
        SameAsLayoutX: ["Same as “{0}”, nothing new to save", "Igual que «{0}», no hay nada nuevo que guardar", "Gleich wie „{0}“, nichts Neues zu speichern"],
        UpdateLayoutX: ["Update “{0}” with these columns", "Actualizar «{0}» con estas columnas", "„{0}“ mit diesen Spalten aktualisieren"],
        SaveAsNewLayout: ["Save as a new layout", "Guardar como formato nuevo", "Als neues Layout speichern"],
        SaveAsNewInstead: ["Save as a new layout instead", "Mejor guardar como formato nuevo", "Lieber als neues Layout speichern"],
        UpdateInsteadX: ["Update “{0}” instead", "Mejor actualizar «{0}»", "Lieber „{0}“ aktualisieren"],
        ChangeColumns: ["Change columns", "Cambiar columnas", "Spalten ändern"],
        Checking: ["Checking the file…", "Revisando el archivo…", "Datei wird geprüft…"],
        JobsX: ["{0} jobs", "{0} tareas", "{0} Aufträge"],
        JobOne: ["1 job", "1 tarea", "1 Auftrag"],
        NewX: ["{0} new", "{0} nuevas", "{0} neu"],
        UpdatesX: ["{0} update existing orders", "{0} actualizan pedidos existentes", "{0} aktualisieren bestehende Aufträge"],
        UpdateOne: ["1 updates an existing order", "1 actualiza un pedido existente", "1 aktualisiert einen bestehenden Auftrag"],
        NoDayX: ["{0} without a date", "{0} sin fecha", "{0} ohne Datum"],
        Person: ["Person", "Persona", "Person"],
        Total: ["Total", "Total", "Gesamt"],
        MoreDaysX: ["+{0} more days", "+{0} días más", "+{0} weitere Tage"],
        RowsX: ["{0} rows", "{0} filas", "{0} Zeilen"],
        RowOne: ["1 row", "1 fila", "1 Zeile"],
        RowX: ["Row {0}", "Fila {0}", "Zeile {0}"],
        AssigneeNotFoundX: ["\"{0}\" isn't a member", "\"{0}\" no es miembro del equipo", "\"{0}\" ist kein Mitglied"],
        NowUnassigned: ["these jobs would be unassigned", "estas tareas quedarían sin asignar", "diese Aufträge wären nicht zugewiesen"],
        AssigneeMeansX: ["\"{0}\" in the file is", "\"{0}\" en el archivo es", "\"{0}\" in der Datei ist"],
        PickPerson: ["Pick a person", "Elige una persona", "Person wählen"],
        LeaveUnassigned: ["Leave unassigned", "Dejar sin asignar", "Nicht zuweisen"],
        Unassigned: ["Unassigned", "Sin asignar", "Nicht zugewiesen"],
        Continue: ["Continue", "Continuar", "Weiter"],
        Cancel: ["Cancel", "Cancelar", "Abbrechen"],
        Back: ["Back", "Atrás", "Zurück"],
        Close: ["Done", "Listo", "Fertig"],
        RememberForLayout: ["Remember for this layout", "Recordar para este formato", "Für dieses Layout merken"],
        ExistingX: ["{0} orders already exist", "{0} pedidos ya existen", "{0} Aufträge gibt es schon"],
        ExistingOne: ["1 order already exists", "1 pedido ya existe", "1 Auftrag gibt es schon"],
        ExistingFilled: ["Update only filled cells", "Actualizar solo las celdas con datos", "Nur ausgefüllte Zellen übernehmen"],
        ExistingFilledHint: ["Their other fields stay as they are.", "El resto de sus campos no cambia.", "Ihre anderen Felder bleiben, wie sie sind."],
        ExistingReplace: ["Replace the whole job", "Reemplazar la tarea entera", "Ganzen Auftrag ersetzen"],
        ExistingReplaceHint: ["Fields the file leaves empty are cleared, as before.", "Los campos vacíos en el archivo se borran, como hasta ahora.", "Felder, die in der Datei leer sind, werden geleert, wie bisher."],
        ExistingSkip: ["Leave them out", "No importarlos", "Nicht importieren"],
        ExistingSkipHint: ["Only the new jobs are imported.", "Solo se importan las tareas nuevas.", "Nur die neuen Aufträge werden importiert."],
        DottedDatesX: ["{0} dates like \"{1}\" can't be read", "{0} fechas como \"{1}\" no se pueden leer", "{0} Daten wie \"{1}\" können nicht gelesen werden"],
        ReadDayMonth: ["Read as day.month.year", "Leer como día.mes.año", "Als Tag.Monat.Jahr lesen"],
        ReadMonthDay: ["Read as month.day.year", "Leer como mes.día.año", "Als Monat.Tag.Jahr lesen"],
        WithoutDate: ["Import them without a date", "Importarlas sin fecha", "Ohne Datum importieren"],
        DottedReadX: ["{0} dates like \"{1}\" are read as", "{0} fechas como \"{1}\" se leen como", "{0} Daten wie \"{1}\" werden gelesen als"],
        DatesUnreadableX: ["{0} dates can't be read", "{0} fechas no se pueden leer", "{0} Daten können nicht gelesen werden"],
        DatesUnreadableHint: ["These jobs get no date.", "Estas tareas quedan sin fecha.", "Diese Aufträge bekommen kein Datum."],
        WindowsUnreadableX: ["{0} time windows can't be read", "{0} ventanas horarias no se pueden leer", "{0} Zeitfenster können nicht gelesen werden"],
        WindowsUnreadableHint: ["These jobs get the whole day.", "Estas tareas quedan para todo el día.", "Diese Aufträge gelten für den ganzen Tag."],
        TeamNotFoundX: ["Team \"{0}\" doesn't exist", "El equipo \"{0}\" no existe", "Das Team \"{0}\" gibt es nicht"],
        TeamNotFoundHint: ["These jobs get no team.", "Estas tareas quedan sin equipo.", "Diese Aufträge bekommen kein Team."],
        TypeNotFoundX: ["Type \"{0}\" doesn't exist", "El tipo \"{0}\" no existe", "Den Typ \"{0}\" gibt es nicht"],
        TypeNotFoundHint: ["These jobs get the standard type.", "Estas tareas quedan con el tipo estándar.", "Diese Aufträge bekommen den Standardtyp."],
        OrderTextX: ["{0} order numbers contain letters", "{0} números de pedido contienen letras", "{0} Auftragsnummern enthalten Buchstaben"],
        OrderTextHint: ["Letters are dropped, so A12 and B12 both become order 12.", "Las letras se descartan, así que A12 y B12 pasan a ser el pedido 12.", "Buchstaben fallen weg, A12 und B12 werden also beide zu Auftrag 12."],
        OrderRepeatedX: ["{0} order numbers appear more than once", "{0} números de pedido aparecen más de una vez", "{0} Auftragsnummern kommen mehrfach vor"],
        OrderRepeatedHint: ["A later row updates the job of the earlier one.", "Una fila posterior actualiza la tarea de la anterior.", "Eine spätere Zeile aktualisiert den Auftrag der früheren."],
        PlaceNotFoundX: ["\"{0}\" isn't one of your places", "\"{0}\" no es uno de tus lugares", "\"{0}\" ist keiner deiner Orte"],
        PlaceNotFoundHint: ["Jobs with an address use the address instead.", "Las tareas con dirección usan esa dirección.", "Aufträge mit Adresse verwenden stattdessen die Adresse."],
        PlacesNotFoundX: ["{0} places in the file aren't among yours", "{0} lugares del archivo no están entre los tuyos", "{0} Orte aus der Datei gibt es bei dir nicht"],
        FailedX: ["{0} rows can't be imported", "{0} filas no se pueden importar", "{0} Zeilen können nicht importiert werden"],
        CustomFieldsX: ["Custom fields: {0}", "Campos personalizados: {0}", "Eigene Felder: {0}"],
        ShowRows: ["Show rows", "Ver filas", "Zeilen anzeigen"],
        ViewFile: ["View file", "Ver archivo", "Datei ansehen"],
        HideFile: ["Hide file", "Ocultar archivo", "Datei ausblenden"],
        FileLegend: ["Rows with a dot need a look.", "Las filas con un punto necesitan revisión.", "Zeilen mit Punkt solltest du prüfen."],
        GridHint: ["Arrows move · type or Enter to change · Shift + arrows select · {0} Enter fills the selection · ⌫ clears · {0} Z undoes · right-click a row to leave it out", "Las flechas mueven · escribe o presiona Enter para cambiar · Mayús + flechas seleccionan · {0} Enter llena la selección · ⌫ borra · {0} Z deshace · clic derecho en una fila para omitirla", "Pfeiltasten bewegen · tippen oder Enter zum Ändern · Umschalt + Pfeile markieren · {0} Enter füllt die Markierung · ⌫ leert · {0} Z macht rückgängig · Rechtsklick auf eine Zeile lässt sie weg"],
        LeaveOutRowX: ["Leave out row {0}", "Omitir la fila {0}", "Zeile {0} weglassen"],
        LeaveOutRowsX: ["Leave out {0} rows", "Omitir {0} filas", "{0} Zeilen weglassen"],
        PutBackRowX: ["Put row {0} back", "Volver a incluir la fila {0}", "Zeile {0} wieder aufnehmen"],
        PutBackRowsX: ["Put {0} rows back", "Volver a incluir {0} filas", "{0} Zeilen wieder aufnehmen"],
        CellCorrectedOne: ["1 cell corrected", "1 celda corregida", "1 Zelle korrigiert"],
        CellsCorrectedX: ["{0} cells corrected", "{0} celdas corregidas", "{0} Zellen korrigiert"],
        RowLeftOutOne: ["1 row left out", "1 fila omitida", "1 Zeile weggelassen"],
        RowsLeftOutX: ["{0} rows left out", "{0} filas omitidas", "{0} Zeilen weggelassen"],
        DownloadCorrected: ["Download corrected file", "Descargar archivo corregido", "Korrigierte Datei herunterladen"],
        CorrectedFileSuffix: ["corrected", "corregido", "korrigiert"],
        Fixed: ["fixed", "corregido", "behoben"],
        FixedX: ["{0} fixed", "{0} corregidas", "{0} behoben"],
        LookingUpX: ["Looking up {0} addresses…", "Buscando {0} direcciones…", "{0} Adressen werden gesucht…"],
        LookingUpOne: ["Looking up 1 address…", "Buscando 1 dirección…", "1 Adresse wird gesucht…"],
        AddressesNotFoundHint: ["These jobs get no location until the address is fixed.", "Estas tareas quedan sin ubicación hasta que se corrija la dirección.", "Diese Aufträge bekommen keinen Standort, bis die Adresse stimmt."],
        NoLocationX: ["{0} rows have no address and none of your places", "{0} filas no tienen dirección ni ninguno de tus lugares", "{0} Zeilen haben keine Adresse und keinen deiner Orte"],
        NoLocationOne: ["1 row has no address and none of your places", "1 fila no tiene dirección ni ninguno de tus lugares", "1 Zeile hat keine Adresse und keinen deiner Orte"],
        NoLocationHint: ["These jobs are created without a location.", "Estas tareas se crean sin ubicación.", "Diese Aufträge werden ohne Standort angelegt."],
        NoLocationColumns: ["The file has no address or place column. Jobs get no location unless their title is one of your places.", "El archivo no tiene columna de dirección ni de lugar. Las tareas quedan sin ubicación salvo que su título sea uno de tus lugares.", "Die Datei hat keine Adress- oder Ortsspalte. Aufträge bekommen keinen Standort, außer ihr Titel ist einer deiner Orte."],
        AddressesAfterImportX: ["{0} addresses are looked up after the import.", "Las {0} direcciones se buscan después de importar.", "Die {0} Adressen werden nach dem Import gesucht."],
        HideRows: ["Hide rows", "Ocultar filas", "Zeilen ausblenden"],
        AllGood: ["Nothing needs a look.", "No hay nada que revisar.", "Alles in Ordnung."],
        NothingSavedYet: ["Nothing is saved until you import.", "No se guarda nada hasta que importes.", "Gespeichert wird erst, wenn du importierst."],
        CheckFailed: ["The file couldn't be checked.", "No se pudo revisar el archivo.", "Die Datei konnte nicht geprüft werden."],
        ImportWithoutCheck: ["Import without checking", "Importar sin revisar", "Ohne Prüfung importieren"],
        TryAgain: ["Try again", "Volver a intentar", "Noch einmal versuchen"],
        ImportXJobs: ["Import {0} jobs", "Importar {0} tareas", "{0} Aufträge importieren"],
        ImportOneJob: ["Import 1 job", "Importar 1 tarea", "1 Auftrag importieren"],
        Importing: ["Importing…", "Importando…", "Wird importiert…"],
        ImportingXofY: ["Importing {0} of {1}…", "Importando {0} de {1}…", "{0} von {1} werden importiert…"],
        KeepsRunning: ["The import keeps running if you close this window.", "La importación sigue si cierras esta ventana.", "Der Import läuft weiter, wenn du das Fenster schließt."],
        ImportFailed: ["The import didn't go through.", "La importación no se realizó.", "Der Import hat nicht geklappt."],
        UpdatedX: ["{0} updated", "{0} actualizadas", "{0} aktualisiert"],
        NotImportedX: ["{0} rows weren't imported", "{0} filas no se importaron", "{0} Zeilen wurden nicht importiert"],
        FromFileX: ["from {0}", "de {0}", "aus {0}"],
        JobsImportedX: ["{0} jobs imported", "{0} tareas importadas", "{0} Aufträge importiert"],
        JobImportedOne: ["1 job imported", "1 tarea importada", "1 Auftrag importiert"],
        JobsUpdatedX: ["{0} jobs updated", "{0} tareas actualizadas", "{0} Aufträge aktualisiert"],
        JobUpdatedOne: ["1 job updated", "1 tarea actualizada", "1 Auftrag aktualisiert"],
        PeopleX: ["{0} people", "{0} personas", "{0} Personen"],
        PersonOne: ["1 person", "1 persona", "1 Person"],
        UnassignedX: ["{0} unassigned", "{0} sin asignar", "{0} nicht zugewiesen"],
        DaysX: ["{0} days", "{0} días", "{0} Tage"],
        ColumnDay: ["Day", "Día", "Tag"],
        ColumnJobs: ["Jobs", "Tareas", "Aufträge"],
        ColumnPerPerson: ["Per person", "Por persona", "Pro Person"],
        MorePeopleX: ["+{0} more", "+{0} más", "+{0} weitere"],
        ShowAllDaysX: ["Show all {0} days", "Ver los {0} días", "Alle {0} Tage anzeigen"],
        ShowFewerDays: ["Show fewer days", "Ver menos días", "Weniger Tage anzeigen"],
        NoLocationImportedX: ["The jobs are imported, just not on the map.", "Las tareas se importaron, pero no aparecen en el mapa.", "Die Aufträge sind importiert, nur nicht auf der Karte."],
        NoLocationImportedOne: ["The job is imported, just not on the map.", "La tarea se importó, pero no aparece en el mapa.", "Der Auftrag ist importiert, nur nicht auf der Karte."],
        FixOneByOne: ["Fix one by one", "Corregir una por una", "Einzeln korrigieren"],
        TypeAddressHint: ["Type an address and press Enter. It's looked up and saved to the job.", "Escribe una dirección y presiona Enter. Se busca y se guarda en la tarea.", "Gib eine Adresse ein und drück Enter. Sie wird gesucht und im Auftrag gespeichert."],
        TypedNotFoundOne: ["1 address wasn't found. Try writing it another way.", "No se encontró 1 dirección. Intenta escribirla de otra forma.", "1 Adresse wurde nicht gefunden. Versuch eine andere Schreibweise."],
        TypedNotFoundX: ["{0} addresses weren't found. Try writing them another way.", "No se encontraron {0} direcciones. Intenta escribirlas de otra forma.", "{0} Adressen wurden nicht gefunden. Versuch eine andere Schreibweise."],
        NoDate: ["No date", "Sin fecha", "Ohne Datum"],
        LocatingX: ["Locating {0} addresses…", "Ubicando {0} direcciones…", "{0} Adressen werden gesucht…"],
        Locating: ["Locating the addresses…", "Ubicando las direcciones…", "Adressen werden gesucht…"],
        AddressesFound: ["All addresses were found.", "Se encontraron todas las direcciones.", "Alle Adressen wurden gefunden."],
        AddressesNotFoundX: ["{0} addresses couldn't be found", "No se encontraron {0} direcciones", "{0} Adressen wurden nicht gefunden"],
        AddressNotFoundOne: ["1 address couldn't be found", "No se encontró 1 dirección", "1 Adresse wurde nicht gefunden"],
        NoAddress: ["no address", "sin dirección", "keine Adresse"],
        AddressesSkipped: ["Too many addresses to locate at once, so these jobs have no location yet.", "Demasiadas direcciones para ubicar a la vez, así que estas tareas aún no tienen ubicación.", "Zu viele Adressen auf einmal, deshalb haben diese Aufträge noch keinen Standort."],
        Fix: ["Fix", "Corregir", "Korrigieren"],
        UndoImport: ["Undo import", "Deshacer importación", "Import rückgängig machen"],
        UndoTitleX: ["Delete the {0} new jobs?", "¿Eliminar las {0} tareas nuevas?", "Die {0} neuen Aufträge löschen?"],
        UndoTitleOne: ["Delete the new job?", "¿Eliminar la tarea nueva?", "Den neuen Auftrag löschen?"],
        UndoText: ["They also disappear from the workers' phones. Jobs this import updated keep their new values.", "También desaparecen de los teléfonos del equipo. Las tareas que esta importación actualizó conservan sus valores nuevos.", "Sie verschwinden auch von den Handys deines Teams. Aufträge, die dieser Import aktualisiert hat, behalten ihre neuen Werte."],
        UndoConfirmX: ["Delete {0} jobs", "Eliminar {0} tareas", "{0} Aufträge löschen"],
        UndoneX: ["Import undone: {0} new jobs deleted.", "Importación deshecha: se eliminaron {0} tareas nuevas.", "Import rückgängig gemacht: {0} neue Aufträge gelöscht."],
        DropToImport: ["Drop the file to import jobs", "Suelta el archivo para importar tareas", "Datei ablegen, um Aufträge zu importieren"],
        FieldTitle: ["Title", "Título", "Titel"],
        FieldPlaceName: ["Place name", "Nombre del lugar", "Ortsname"],
        FieldAddress: ["Address", "Dirección", "Adresse"],
        FieldCity: ["City", "Ciudad", "Stadt"],
        FieldState: ["State or region", "Estado o provincia", "Bundesland oder Region"],
        FieldCountry: ["Country", "País", "Land"],
        FieldLatitude: ["Latitude", "Latitud", "Breitengrad"],
        FieldLongitude: ["Longitude", "Longitud", "Längengrad"],
        FieldAssignee: ["Assignee", "Persona asignada", "Zugewiesen an"],
        FieldTeam: ["Team", "Equipo", "Team"],
        FieldDate: ["Date", "Fecha", "Datum"],
        FieldWindow: ["Time window", "Ventana horaria", "Zeitfenster"],
        FieldOnSite: ["Time on site (minutes)", "Tiempo en el sitio (minutos)", "Zeit vor Ort (Minuten)"],
        FieldOrder: ["Order number", "Número de pedido", "Auftragsnummer"],
        FieldPriority: ["Priority", "Prioridad", "Priorität"],
        FieldType: ["Type", "Tipo", "Typ"],
        FieldNotes: ["Notes", "Notas", "Notizen"],
        FieldContactName: ["Contact name", "Nombre de contacto", "Ansprechpartner"],
        FieldContactPhone: ["Contact phone", "Teléfono de contacto", "Telefon"],
        FieldContactEmail: ["Contact email", "Correo de contacto", "E-Mail"],
        FieldSkills: ["Required skills", "Habilidades requeridas", "Erforderliche Skills"],
        FieldTemplate: ["Job template", "Plantilla de tarea", "Auftragsvorlage"],
        FieldAutoAssign: ["Assign automatically", "Asignar automáticamente", "Automatisch zuweisen"],
        FieldCarryOver: ["Carry over", "Pasar al día siguiente", "Auf den nächsten Tag übertragen"],
        FieldPickup: ["Items to pick up", "Artículos para recoger", "Abzuholende Artikel"],
        FieldDropoff: ["Items to drop off", "Artículos para entregar", "Abzuliefernde Artikel"],
        FieldAttachments: ["Attachments", "Adjuntos", "Anhänge"],
        FieldForms: ["Forms", "Formularios", "Formulare"],
        FieldZones: ["Zones", "Zonas", "Zonen"],
        FieldEmailDone: ["Email when done", "Correo al terminar", "E-Mail bei Erledigung"],
        FieldEmailIssue: ["Email on an issue", "Correo si hay un problema", "E-Mail bei Problemen"],
        FieldStopNumber: ["Stop number", "Número de parada", "Stoppnummer"],
        FieldCustomerId: ["Customer ID", "ID de cliente", "Kundennummer"],
        FieldYear: ["Year", "Año", "Jahr"],
        FieldMonth: ["Month", "Mes", "Monat"],
        FieldDay: ["Day", "Día", "Tag"],
        FieldName: ["Name", "Nombre", "Name"],
        FieldTicketId: ["Ticket ID", "ID de ticket", "Ticketnummer"],
    },
    Photos: {
        Range: ["Range", "Periodo", "Zeitraum"],
        Day: ["Day", "Día", "Tag"],
        Week: ["7 days", "7 días", "7 Tage"],
        WeekTitle: ["The picked day and the six days before", "El día elegido y los seis anteriores", "Der gewählte Tag und die sechs Tage davor"],
        NoPlace: ["No place", "Sin lugar", "Kein Ort"],
        OnePhoto: ["1 photo", "1 foto", "1 Foto"],
        XPhotos: ["{0} photos", "{0} fotos", "{0} Fotos"],
        OneFromForm: ["1 from a form", "1 de un formulario", "1 aus einem Formular"],
        FromForms: ["{0} from forms", "{0} de formularios", "{0} aus Formularen"],
        FormTag: ["Form", "Formulario", "Formular"],
        XSelected: ["{0} selected", "{0} seleccionadas", "{0} ausgewählt"],
        DownloadZip: ["Download ZIP", "Descargar ZIP", "ZIP herunterladen"],
        SelectAll: ["Select all photos", "Seleccionar todas las fotos", "Alle Fotos auswählen"],
        SelectVisit: ["Select this visit's photos", "Seleccionar las fotos de esta visita", "Fotos dieses Besuchs auswählen"],
        SelectPhoto: ["Select photo", "Seleccionar foto", "Foto auswählen"],
        ClearSelection: ["Clear selection", "Quitar selección", "Auswahl aufheben"],
        LoadingDays: ["Loading {0} more days…", "Cargando {0} días más…", "{0} weitere Tage werden geladen…"],
        DaysFailed: ["{0} days couldn't load.", "No se pudieron cargar {0} días.", "{0} Tage konnten nicht geladen werden."],
        ShowMore: ["Show more visits", "Mostrar más visitas", "Mehr Besuche zeigen"],
        NoPhotosAt: ["No photos at {0} on these days.", "No hay fotos en {0} en estos días.", "An diesen Tagen gibt es keine Fotos von {0}."],
        OpenPlace: ["Open place", "Abrir lugar", "Ort öffnen"],
        AtPlace: ["At the place", "En el lugar", "Am Ort"],
        AtJob: ["At the job", "En la tarea", "Am Auftragsort"],
        FromPlace: ["{0} from the place", "A {0} del lugar", "{0} vom Ort entfernt"],
        FromJob: ["{0} from the job", "A {0} de la tarea", "{0} vom Auftragsort entfernt"],
        From: ["From", "Origen", "Herkunft"],
        JobPhoto: ["Job photo", "Foto de la tarea", "Auftragsfoto"],
        Sent: ["Sent {0}", "Enviado {0}", "Gesendet {0}"],
        OfVisit: ["{0} of {1} in this visit", "{0} de {1} en esta visita", "{0} von {1} bei diesem Besuch"],
        Previous: ["Previous photo", "Foto anterior", "Vorheriges Foto"],
        Next: ["Next photo", "Foto siguiente", "Nächstes Foto"],
        Map: ["Map", "Mapa", "Karte"],
    },
};

type TranslationsType = typeof TRANSLATIONS;

export type SingleLanguageTranslations = {
    [K in keyof TranslationsType]: {
        [P in keyof TranslationsType[K]]: string;
    };
};

const TRANSLATION_ENTRIES = Object.entries(TRANSLATIONS) as [keyof TranslationsType, typeof TRANSLATIONS[keyof TranslationsType]][];

const getTranslations = (index: number): SingleLanguageTranslations => {
    const entries = TRANSLATION_ENTRIES.map(([key, fields]) => {
        const FIELD_ENTRIES = Object.entries(fields);
        const values = FIELD_ENTRIES.map(([key2, value]) => [key2, value[index]]);
        return [key, Object.fromEntries(values)];
    });
    return Object.fromEntries(entries);
};

export const strings = {
    en: getTranslations(EN_TRANSLATION),
    es: getTranslations(ES_TRANSLATION),
    de: getTranslations(DE_TRANSLATION),
};
